
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirea85a"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirea85a"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("buXuT", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $85f0a5fae07767e2$export$ffb0004e005737fa, (v) => $85f0a5fae07767e2$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $85f0a5fae07767e2$export$34b9dba7ce09269b, (v) => $85f0a5fae07767e2$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $85f0a5fae07767e2$export$25062201e9e25d76, (v) => $85f0a5fae07767e2$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $85f0a5fae07767e2$export$ffb0004e005737fa;
var $85f0a5fae07767e2$export$34b9dba7ce09269b;
var $85f0a5fae07767e2$export$25062201e9e25d76;
"use strict";
var $85f0a5fae07767e2$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $85f0a5fae07767e2$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
function $85f0a5fae07767e2$var$jsxProd(type, config, maybeKey) {
    var key = null;
    void 0 !== maybeKey && (key = "" + maybeKey);
    void 0 !== config.key && (key = "" + config.key);
    if ("key" in config) {
        maybeKey = {};
        for(var propName in config)"key" !== propName && (maybeKey[propName] = config[propName]);
    } else maybeKey = config;
    config = maybeKey.ref;
    return {
        $$typeof: $85f0a5fae07767e2$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== config ? config : null,
        props: maybeKey
    };
}
$85f0a5fae07767e2$export$ffb0004e005737fa = $85f0a5fae07767e2$var$REACT_FRAGMENT_TYPE;
$85f0a5fae07767e2$export$34b9dba7ce09269b = $85f0a5fae07767e2$var$jsxProd;
$85f0a5fae07767e2$export$25062201e9e25d76 = $85f0a5fae07767e2$var$jsxProd;

});

parcelRegister("at1B7", function(module, exports) {

$parcel$export(module.exports, "Activity", () => $79edda0f1410e433$export$9c16c1426311996d, (v) => $79edda0f1410e433$export$9c16c1426311996d = v);
$parcel$export(module.exports, "Children", () => $79edda0f1410e433$export$dca3b0875bd9a954, (v) => $79edda0f1410e433$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $79edda0f1410e433$export$16fa2f45be04daa8, (v) => $79edda0f1410e433$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $79edda0f1410e433$export$ffb0004e005737fa, (v) => $79edda0f1410e433$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $79edda0f1410e433$export$e2c29f18771995cb, (v) => $79edda0f1410e433$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $79edda0f1410e433$export$221d75b3f55bb0bd, (v) => $79edda0f1410e433$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $79edda0f1410e433$export$5f8d39834fd61797, (v) => $79edda0f1410e433$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $79edda0f1410e433$export$74bf444e3cd11ea5, (v) => $79edda0f1410e433$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "ViewTransition", () => $79edda0f1410e433$export$8cdaa4703948c5e9, (v) => $79edda0f1410e433$export$8cdaa4703948c5e9 = v);
$parcel$export(module.exports, "__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", () => $79edda0f1410e433$export$1ced07cd6b1985ce, (v) => $79edda0f1410e433$export$1ced07cd6b1985ce = v);
$parcel$export(module.exports, "__COMPILER_RUNTIME", () => $79edda0f1410e433$export$abd8e32b826d7ea7, (v) => $79edda0f1410e433$export$abd8e32b826d7ea7 = v);
$parcel$export(module.exports, "addTransitionType", () => $79edda0f1410e433$export$87c99536b1b8cdd8, (v) => $79edda0f1410e433$export$87c99536b1b8cdd8 = v);
$parcel$export(module.exports, "cache", () => $79edda0f1410e433$export$69a3209f1a06c04d, (v) => $79edda0f1410e433$export$69a3209f1a06c04d = v);
$parcel$export(module.exports, "cacheSignal", () => $79edda0f1410e433$export$8c538325882c7eec, (v) => $79edda0f1410e433$export$8c538325882c7eec = v);
$parcel$export(module.exports, "cloneElement", () => $79edda0f1410e433$export$e530037191fcd5d7, (v) => $79edda0f1410e433$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $79edda0f1410e433$export$fd42f52fd3ae1109, (v) => $79edda0f1410e433$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $79edda0f1410e433$export$c8a8987d4410bf2d, (v) => $79edda0f1410e433$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createRef", () => $79edda0f1410e433$export$7d1e3a5e95ceca43, (v) => $79edda0f1410e433$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $79edda0f1410e433$export$257a8862b851cb5b, (v) => $79edda0f1410e433$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $79edda0f1410e433$export$a8257692ac88316c, (v) => $79edda0f1410e433$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $79edda0f1410e433$export$488013bae63b21da, (v) => $79edda0f1410e433$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $79edda0f1410e433$export$7c73462e0d25e514, (v) => $79edda0f1410e433$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $79edda0f1410e433$export$7568632d0d33d16d, (v) => $79edda0f1410e433$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_useCacheRefresh", () => $79edda0f1410e433$export$f93f40ac0ca7e3a8, (v) => $79edda0f1410e433$export$f93f40ac0ca7e3a8 = v);
$parcel$export(module.exports, "use", () => $79edda0f1410e433$export$1f96ae73734a86cc, (v) => $79edda0f1410e433$export$1f96ae73734a86cc = v);
$parcel$export(module.exports, "useActionState", () => $79edda0f1410e433$export$9a47ced3238df325, (v) => $79edda0f1410e433$export$9a47ced3238df325 = v);
$parcel$export(module.exports, "useCallback", () => $79edda0f1410e433$export$35808ee640e87ca7, (v) => $79edda0f1410e433$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $79edda0f1410e433$export$fae74005e78b1a27, (v) => $79edda0f1410e433$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $79edda0f1410e433$export$dc8fbce3eb94dc1e, (v) => $79edda0f1410e433$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $79edda0f1410e433$export$6a7bc4e911dc01cf, (v) => $79edda0f1410e433$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $79edda0f1410e433$export$6d9c69b0de29b591, (v) => $79edda0f1410e433$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useEffectEvent", () => $79edda0f1410e433$export$7f54fc3180508a52, (v) => $79edda0f1410e433$export$7f54fc3180508a52 = v);
$parcel$export(module.exports, "useId", () => $79edda0f1410e433$export$f680877a34711e37, (v) => $79edda0f1410e433$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $79edda0f1410e433$export$d5a552a76deda3c2, (v) => $79edda0f1410e433$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $79edda0f1410e433$export$aaabe4eda9ed9969, (v) => $79edda0f1410e433$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $79edda0f1410e433$export$e5c5a5f917a5871c, (v) => $79edda0f1410e433$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $79edda0f1410e433$export$1538c33de8887b59, (v) => $79edda0f1410e433$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useOptimistic", () => $79edda0f1410e433$export$fca7f784ae7a249a, (v) => $79edda0f1410e433$export$fca7f784ae7a249a = v);
$parcel$export(module.exports, "useReducer", () => $79edda0f1410e433$export$13e3392192263954, (v) => $79edda0f1410e433$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $79edda0f1410e433$export$b8f5890fc79d6aca, (v) => $79edda0f1410e433$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $79edda0f1410e433$export$60241385465d0a34, (v) => $79edda0f1410e433$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $79edda0f1410e433$export$306c0aa65ff9ec16, (v) => $79edda0f1410e433$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $79edda0f1410e433$export$7b286972b8d8ccbf, (v) => $79edda0f1410e433$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $79edda0f1410e433$export$83d89fbfd8236492, (v) => $79edda0f1410e433$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $79edda0f1410e433$export$9c16c1426311996d;
var $79edda0f1410e433$export$dca3b0875bd9a954;
var $79edda0f1410e433$export$16fa2f45be04daa8;
var $79edda0f1410e433$export$ffb0004e005737fa;
var $79edda0f1410e433$export$e2c29f18771995cb;
var $79edda0f1410e433$export$221d75b3f55bb0bd;
var $79edda0f1410e433$export$5f8d39834fd61797;
var $79edda0f1410e433$export$74bf444e3cd11ea5;
var $79edda0f1410e433$export$8cdaa4703948c5e9;
var $79edda0f1410e433$export$1ced07cd6b1985ce;
var $79edda0f1410e433$export$abd8e32b826d7ea7;
var $79edda0f1410e433$export$87c99536b1b8cdd8;
var $79edda0f1410e433$export$69a3209f1a06c04d;
var $79edda0f1410e433$export$8c538325882c7eec;
var $79edda0f1410e433$export$e530037191fcd5d7;
var $79edda0f1410e433$export$fd42f52fd3ae1109;
var $79edda0f1410e433$export$c8a8987d4410bf2d;
var $79edda0f1410e433$export$7d1e3a5e95ceca43;
var $79edda0f1410e433$export$257a8862b851cb5b;
var $79edda0f1410e433$export$a8257692ac88316c;
var $79edda0f1410e433$export$488013bae63b21da;
var $79edda0f1410e433$export$7c73462e0d25e514;
var $79edda0f1410e433$export$7568632d0d33d16d;
var $79edda0f1410e433$export$f93f40ac0ca7e3a8;
var $79edda0f1410e433$export$1f96ae73734a86cc;
var $79edda0f1410e433$export$9a47ced3238df325;
var $79edda0f1410e433$export$35808ee640e87ca7;
var $79edda0f1410e433$export$fae74005e78b1a27;
var $79edda0f1410e433$export$dc8fbce3eb94dc1e;
var $79edda0f1410e433$export$6a7bc4e911dc01cf;
var $79edda0f1410e433$export$6d9c69b0de29b591;
var $79edda0f1410e433$export$7f54fc3180508a52;
var $79edda0f1410e433$export$f680877a34711e37;
var $79edda0f1410e433$export$d5a552a76deda3c2;
var $79edda0f1410e433$export$aaabe4eda9ed9969;
var $79edda0f1410e433$export$e5c5a5f917a5871c;
var $79edda0f1410e433$export$1538c33de8887b59;
var $79edda0f1410e433$export$fca7f784ae7a249a;
var $79edda0f1410e433$export$13e3392192263954;
var $79edda0f1410e433$export$b8f5890fc79d6aca;
var $79edda0f1410e433$export$60241385465d0a34;
var $79edda0f1410e433$export$306c0aa65ff9ec16;
var $79edda0f1410e433$export$7b286972b8d8ccbf;
var $79edda0f1410e433$export$83d89fbfd8236492;
"use strict";
var $79edda0f1410e433$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $79edda0f1410e433$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $79edda0f1410e433$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $79edda0f1410e433$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $79edda0f1410e433$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $79edda0f1410e433$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $79edda0f1410e433$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $79edda0f1410e433$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $79edda0f1410e433$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $79edda0f1410e433$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $79edda0f1410e433$var$REACT_LAZY_TYPE = Symbol.for("react.lazy"), $79edda0f1410e433$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity"), $79edda0f1410e433$var$REACT_VIEW_TRANSITION_TYPE = Symbol.for("react.view_transition"), $79edda0f1410e433$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $79edda0f1410e433$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $79edda0f1410e433$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$79edda0f1410e433$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $79edda0f1410e433$var$ReactNoopUpdateQueue = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $79edda0f1410e433$var$assign = Object.assign, $79edda0f1410e433$var$emptyObject = {};
function $79edda0f1410e433$var$Component(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $79edda0f1410e433$var$emptyObject;
    this.updater = updater || $79edda0f1410e433$var$ReactNoopUpdateQueue;
}
$79edda0f1410e433$var$Component.prototype.isReactComponent = {};
$79edda0f1410e433$var$Component.prototype.setState = function(partialState, callback) {
    if ("object" !== typeof partialState && "function" !== typeof partialState && null != partialState) throw Error("takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, partialState, callback, "setState");
};
$79edda0f1410e433$var$Component.prototype.forceUpdate = function(callback) {
    this.updater.enqueueForceUpdate(this, callback, "forceUpdate");
};
function $79edda0f1410e433$var$ComponentDummy() {}
$79edda0f1410e433$var$ComponentDummy.prototype = $79edda0f1410e433$var$Component.prototype;
function $79edda0f1410e433$var$PureComponent(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $79edda0f1410e433$var$emptyObject;
    this.updater = updater || $79edda0f1410e433$var$ReactNoopUpdateQueue;
}
var $79edda0f1410e433$var$pureComponentPrototype = $79edda0f1410e433$var$PureComponent.prototype = new $79edda0f1410e433$var$ComponentDummy();
$79edda0f1410e433$var$pureComponentPrototype.constructor = $79edda0f1410e433$var$PureComponent;
$79edda0f1410e433$var$assign($79edda0f1410e433$var$pureComponentPrototype, $79edda0f1410e433$var$Component.prototype);
$79edda0f1410e433$var$pureComponentPrototype.isPureReactComponent = !0;
var $79edda0f1410e433$var$isArrayImpl = Array.isArray;
function $79edda0f1410e433$var$noop() {}
var $79edda0f1410e433$var$ReactSharedInternals = {
    H: null,
    A: null,
    T: null,
    S: null
}, $79edda0f1410e433$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $79edda0f1410e433$var$ReactElement(type, key, props) {
    var refProp = props.ref;
    return {
        $$typeof: $79edda0f1410e433$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== refProp ? refProp : null,
        props: props
    };
}
function $79edda0f1410e433$var$cloneAndReplaceKey(oldElement, newKey) {
    return $79edda0f1410e433$var$ReactElement(oldElement.type, newKey, oldElement.props);
}
function $79edda0f1410e433$var$isValidElement(object) {
    return "object" === typeof object && null !== object && object.$$typeof === $79edda0f1410e433$var$REACT_ELEMENT_TYPE;
}
function $79edda0f1410e433$var$escape(key) {
    var escaperLookup = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + key.replace(/[=:]/g, function(match) {
        return escaperLookup[match];
    });
}
var $79edda0f1410e433$var$userProvidedKeyEscapeRegex = /\/+/g;
function $79edda0f1410e433$var$getElementKey(element, index) {
    return "object" === typeof element && null !== element && null != element.key ? $79edda0f1410e433$var$escape("" + element.key) : index.toString(36);
}
function $79edda0f1410e433$var$resolveThenable(thenable) {
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenable.reason;
        default:
            switch("string" === typeof thenable.status ? thenable.then($79edda0f1410e433$var$noop, $79edda0f1410e433$var$noop) : (thenable.status = "pending", thenable.then(function(fulfilledValue) {
                "pending" === thenable.status && (thenable.status = "fulfilled", thenable.value = fulfilledValue);
            }, function(error) {
                "pending" === thenable.status && (thenable.status = "rejected", thenable.reason = error);
            })), thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenable.reason;
            }
    }
    throw thenable;
}
function $79edda0f1410e433$var$mapIntoArray(children, array, escapedPrefix, nameSoFar, callback) {
    var type = typeof children;
    if ("undefined" === type || "boolean" === type) children = null;
    var invokeCallback = !1;
    if (null === children) invokeCallback = !0;
    else switch(type){
        case "bigint":
        case "string":
        case "number":
            invokeCallback = !0;
            break;
        case "object":
            switch(children.$$typeof){
                case $79edda0f1410e433$var$REACT_ELEMENT_TYPE:
                case $79edda0f1410e433$var$REACT_PORTAL_TYPE:
                    invokeCallback = !0;
                    break;
                case $79edda0f1410e433$var$REACT_LAZY_TYPE:
                    return invokeCallback = children._init, $79edda0f1410e433$var$mapIntoArray(invokeCallback(children._payload), array, escapedPrefix, nameSoFar, callback);
            }
    }
    if (invokeCallback) return callback = callback(children), invokeCallback = "" === nameSoFar ? "." + $79edda0f1410e433$var$getElementKey(children, 0) : nameSoFar, $79edda0f1410e433$var$isArrayImpl(callback) ? (escapedPrefix = "", null != invokeCallback && (escapedPrefix = invokeCallback.replace($79edda0f1410e433$var$userProvidedKeyEscapeRegex, "$&/") + "/"), $79edda0f1410e433$var$mapIntoArray(callback, array, escapedPrefix, "", function(c) {
        return c;
    })) : null != callback && ($79edda0f1410e433$var$isValidElement(callback) && (callback = $79edda0f1410e433$var$cloneAndReplaceKey(callback, escapedPrefix + (null == callback.key || children && children.key === callback.key ? "" : ("" + callback.key).replace($79edda0f1410e433$var$userProvidedKeyEscapeRegex, "$&/") + "/") + invokeCallback)), array.push(callback)), 1;
    invokeCallback = 0;
    var nextNamePrefix = "" === nameSoFar ? "." : nameSoFar + ":";
    if ($79edda0f1410e433$var$isArrayImpl(children)) for(var i = 0; i < children.length; i++)nameSoFar = children[i], type = nextNamePrefix + $79edda0f1410e433$var$getElementKey(nameSoFar, i), invokeCallback += $79edda0f1410e433$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if (i = $79edda0f1410e433$var$getIteratorFn(children), "function" === typeof i) for(children = i.call(children), i = 0; !(nameSoFar = children.next()).done;)nameSoFar = nameSoFar.value, type = nextNamePrefix + $79edda0f1410e433$var$getElementKey(nameSoFar, i++), invokeCallback += $79edda0f1410e433$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if ("object" === type) {
        if ("function" === typeof children.then) return $79edda0f1410e433$var$mapIntoArray($79edda0f1410e433$var$resolveThenable(children), array, escapedPrefix, nameSoFar, callback);
        array = String(children);
        throw Error("Objects are not valid as a React child (found: " + ("[object Object]" === array ? "object with keys {" + Object.keys(children).join(", ") + "}" : array) + "). If you meant to render a collection of children, use an array instead.");
    }
    return invokeCallback;
}
function $79edda0f1410e433$var$mapChildren(children, func, context) {
    if (null == children) return children;
    var result = [], count = 0;
    $79edda0f1410e433$var$mapIntoArray(children, result, "", "", function(child) {
        return func.call(context, child, count++);
    });
    return result;
}
function $79edda0f1410e433$var$lazyInitializer(payload) {
    if (-1 === payload._status) {
        var ctor = payload._result, thenable = ctor();
        thenable.then(function(moduleObject) {
            if (0 === payload._status || -1 === payload._status) payload._status = 1, payload._result = moduleObject, void 0 === thenable.status && (thenable.status = "fulfilled", thenable.value = moduleObject);
        }, function(error) {
            if (0 === payload._status || -1 === payload._status) payload._status = 2, payload._result = error, void 0 === thenable.status && (thenable.status = "rejected", thenable.reason = error);
        });
        -1 === payload._status && (payload._status = 0, payload._result = thenable);
    }
    if (1 === payload._status) return payload._result.default;
    throw payload._result;
}
var $79edda0f1410e433$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
};
function $79edda0f1410e433$var$startTransition(scope) {
    var prevTransition = $79edda0f1410e433$var$ReactSharedInternals.T, currentTransition = {};
    currentTransition.types = null !== prevTransition ? prevTransition.types : null;
    $79edda0f1410e433$var$ReactSharedInternals.T = currentTransition;
    try {
        var returnValue = scope(), onStartTransitionFinish = $79edda0f1410e433$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && returnValue.then($79edda0f1410e433$var$noop, $79edda0f1410e433$var$reportGlobalError);
    } catch (error) {
        $79edda0f1410e433$var$reportGlobalError(error);
    } finally{
        null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $79edda0f1410e433$var$ReactSharedInternals.T = prevTransition;
    }
}
function $79edda0f1410e433$var$addTransitionType(type) {
    var transition = $79edda0f1410e433$var$ReactSharedInternals.T;
    if (null !== transition) {
        var transitionTypes = transition.types;
        null === transitionTypes ? transition.types = [
            type
        ] : -1 === transitionTypes.indexOf(type) && transitionTypes.push(type);
    } else $79edda0f1410e433$var$startTransition($79edda0f1410e433$var$addTransitionType.bind(null, type));
}
var $79edda0f1410e433$var$Children = {
    map: $79edda0f1410e433$var$mapChildren,
    forEach: function(children, forEachFunc, forEachContext) {
        $79edda0f1410e433$var$mapChildren(children, function() {
            forEachFunc.apply(this, arguments);
        }, forEachContext);
    },
    count: function(children) {
        var n = 0;
        $79edda0f1410e433$var$mapChildren(children, function() {
            n++;
        });
        return n;
    },
    toArray: function(children) {
        return $79edda0f1410e433$var$mapChildren(children, function(child) {
            return child;
        }) || [];
    },
    only: function(children) {
        if (!$79edda0f1410e433$var$isValidElement(children)) throw Error("React.Children.only expected to receive a single React element child.");
        return children;
    }
};
$79edda0f1410e433$export$9c16c1426311996d = $79edda0f1410e433$var$REACT_ACTIVITY_TYPE;
$79edda0f1410e433$export$dca3b0875bd9a954 = $79edda0f1410e433$var$Children;
$79edda0f1410e433$export$16fa2f45be04daa8 = $79edda0f1410e433$var$Component;
$79edda0f1410e433$export$ffb0004e005737fa = $79edda0f1410e433$var$REACT_FRAGMENT_TYPE;
$79edda0f1410e433$export$e2c29f18771995cb = $79edda0f1410e433$var$REACT_PROFILER_TYPE;
$79edda0f1410e433$export$221d75b3f55bb0bd = $79edda0f1410e433$var$PureComponent;
$79edda0f1410e433$export$5f8d39834fd61797 = $79edda0f1410e433$var$REACT_STRICT_MODE_TYPE;
$79edda0f1410e433$export$74bf444e3cd11ea5 = $79edda0f1410e433$var$REACT_SUSPENSE_TYPE;
$79edda0f1410e433$export$8cdaa4703948c5e9 = $79edda0f1410e433$var$REACT_VIEW_TRANSITION_TYPE;
$79edda0f1410e433$export$1ced07cd6b1985ce = $79edda0f1410e433$var$ReactSharedInternals;
$79edda0f1410e433$export$abd8e32b826d7ea7 = {
    __proto__: null,
    c: function(size) {
        return $79edda0f1410e433$var$ReactSharedInternals.H.useMemoCache(size);
    }
};
$79edda0f1410e433$export$87c99536b1b8cdd8 = $79edda0f1410e433$var$addTransitionType;
$79edda0f1410e433$export$69a3209f1a06c04d = function(fn) {
    return function() {
        return fn.apply(null, arguments);
    };
};
$79edda0f1410e433$export$8c538325882c7eec = function() {
    return null;
};
$79edda0f1410e433$export$e530037191fcd5d7 = function(element, config, children) {
    if (null === element || void 0 === element) throw Error("The argument must be a React element, but you passed " + element + ".");
    var props = $79edda0f1410e433$var$assign({}, element.props), key = element.key;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)!$79edda0f1410e433$var$hasOwnProperty.call(config, propName) || "key" === propName || "__self" === propName || "__source" === propName || "ref" === propName && void 0 === config.ref || (props[propName] = config[propName]);
    var propName = arguments.length - 2;
    if (1 === propName) props.children = children;
    else if (1 < propName) {
        for(var childArray = Array(propName), i = 0; i < propName; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    return $79edda0f1410e433$var$ReactElement(element.type, key, props);
};
$79edda0f1410e433$export$fd42f52fd3ae1109 = function(defaultValue) {
    defaultValue = {
        $$typeof: $79edda0f1410e433$var$REACT_CONTEXT_TYPE,
        _currentValue: defaultValue,
        _currentValue2: defaultValue,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    defaultValue.Provider = defaultValue;
    defaultValue.Consumer = {
        $$typeof: $79edda0f1410e433$var$REACT_CONSUMER_TYPE,
        _context: defaultValue
    };
    return defaultValue;
};
$79edda0f1410e433$export$c8a8987d4410bf2d = function(type, config, children) {
    var propName, props = {}, key = null;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)$79edda0f1410e433$var$hasOwnProperty.call(config, propName) && "key" !== propName && "__self" !== propName && "__source" !== propName && (props[propName] = config[propName]);
    var childrenLength = arguments.length - 2;
    if (1 === childrenLength) props.children = children;
    else if (1 < childrenLength) {
        for(var childArray = Array(childrenLength), i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    if (type && type.defaultProps) for(propName in childrenLength = type.defaultProps, childrenLength)void 0 === props[propName] && (props[propName] = childrenLength[propName]);
    return $79edda0f1410e433$var$ReactElement(type, key, props);
};
$79edda0f1410e433$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$79edda0f1410e433$export$257a8862b851cb5b = function(render) {
    return {
        $$typeof: $79edda0f1410e433$var$REACT_FORWARD_REF_TYPE,
        render: render
    };
};
$79edda0f1410e433$export$a8257692ac88316c = $79edda0f1410e433$var$isValidElement;
$79edda0f1410e433$export$488013bae63b21da = function(ctor) {
    return {
        $$typeof: $79edda0f1410e433$var$REACT_LAZY_TYPE,
        _payload: {
            _status: -1,
            _result: ctor
        },
        _init: $79edda0f1410e433$var$lazyInitializer
    };
};
$79edda0f1410e433$export$7c73462e0d25e514 = function(type, compare) {
    return {
        $$typeof: $79edda0f1410e433$var$REACT_MEMO_TYPE,
        type: type,
        compare: void 0 === compare ? null : compare
    };
};
$79edda0f1410e433$export$7568632d0d33d16d = $79edda0f1410e433$var$startTransition;
$79edda0f1410e433$export$f93f40ac0ca7e3a8 = function() {
    return $79edda0f1410e433$var$ReactSharedInternals.H.useCacheRefresh();
};
$79edda0f1410e433$export$1f96ae73734a86cc = function(usable) {
    return $79edda0f1410e433$var$ReactSharedInternals.H.use(usable);
};
$79edda0f1410e433$export$9a47ced3238df325 = function(action, initialState, permalink) {
    return $79edda0f1410e433$var$ReactSharedInternals.H.useActionState(action, initialState, permalink);
};
$79edda0f1410e433$export$35808ee640e87ca7 = function(callback, deps) {
    return $79edda0f1410e433$var$ReactSharedInternals.H.useCallback(callback, deps);
};
$79edda0f1410e433$export$fae74005e78b1a27 = function(Context) {
    return $79edda0f1410e433$var$ReactSharedInternals.H.useContext(Context);
};
$79edda0f1410e433$export$dc8fbce3eb94dc1e = function() {};
$79edda0f1410e433$export$6a7bc4e911dc01cf = function(value, initialValue) {
    return $79edda0f1410e433$var$ReactSharedInternals.H.useDeferredValue(value, initialValue);
};
$79edda0f1410e433$export$6d9c69b0de29b591 = function(create, deps) {
    return $79edda0f1410e433$var$ReactSharedInternals.H.useEffect(create, deps);
};
$79edda0f1410e433$export$7f54fc3180508a52 = function(callback) {
    return $79edda0f1410e433$var$ReactSharedInternals.H.useEffectEvent(callback);
};
$79edda0f1410e433$export$f680877a34711e37 = function() {
    return $79edda0f1410e433$var$ReactSharedInternals.H.useId();
};
$79edda0f1410e433$export$d5a552a76deda3c2 = function(ref, create, deps) {
    return $79edda0f1410e433$var$ReactSharedInternals.H.useImperativeHandle(ref, create, deps);
};
$79edda0f1410e433$export$aaabe4eda9ed9969 = function(create, deps) {
    return $79edda0f1410e433$var$ReactSharedInternals.H.useInsertionEffect(create, deps);
};
$79edda0f1410e433$export$e5c5a5f917a5871c = function(create, deps) {
    return $79edda0f1410e433$var$ReactSharedInternals.H.useLayoutEffect(create, deps);
};
$79edda0f1410e433$export$1538c33de8887b59 = function(create, deps) {
    return $79edda0f1410e433$var$ReactSharedInternals.H.useMemo(create, deps);
};
$79edda0f1410e433$export$fca7f784ae7a249a = function(passthrough, reducer) {
    return $79edda0f1410e433$var$ReactSharedInternals.H.useOptimistic(passthrough, reducer);
};
$79edda0f1410e433$export$13e3392192263954 = function(reducer, initialArg, init) {
    return $79edda0f1410e433$var$ReactSharedInternals.H.useReducer(reducer, initialArg, init);
};
$79edda0f1410e433$export$b8f5890fc79d6aca = function(initialValue) {
    return $79edda0f1410e433$var$ReactSharedInternals.H.useRef(initialValue);
};
$79edda0f1410e433$export$60241385465d0a34 = function(initialState) {
    return $79edda0f1410e433$var$ReactSharedInternals.H.useState(initialState);
};
$79edda0f1410e433$export$306c0aa65ff9ec16 = function(subscribe, getSnapshot, getServerSnapshot) {
    return $79edda0f1410e433$var$ReactSharedInternals.H.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
};
$79edda0f1410e433$export$7b286972b8d8ccbf = function() {
    return $79edda0f1410e433$var$ReactSharedInternals.H.useTransition();
};
$79edda0f1410e433$export$83d89fbfd8236492 = "19.3.1";

});

parcelRegister("2Cd0r", function(module, exports) {

$parcel$export(module.exports, "createRoot", () => $1e79381dc3a64a75$export$882461b6382ed46c, (v) => $1e79381dc3a64a75$export$882461b6382ed46c = v);
$parcel$export(module.exports, "hydrateRoot", () => $1e79381dc3a64a75$export$757ceba2d55c277e, (v) => $1e79381dc3a64a75$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "version", () => $1e79381dc3a64a75$export$83d89fbfd8236492, (v) => $1e79381dc3a64a75$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom-client.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $1e79381dc3a64a75$export$882461b6382ed46c;
var $1e79381dc3a64a75$export$757ceba2d55c277e;
var $1e79381dc3a64a75$export$83d89fbfd8236492;
"use strict";

var $3T9qK = parcelRequire("3T9qK");

var $bFZzf = parcelRequire("bFZzf");

var $5g5IQ = parcelRequire("5g5IQ");
function $1e79381dc3a64a75$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $1e79381dc3a64a75$var$isValidContainer(node) {
    return !(!node || 1 !== node.nodeType && 9 !== node.nodeType && 11 !== node.nodeType);
}
function $1e79381dc3a64a75$var$getNearestMountedFiber(fiber) {
    for(var node = fiber, nextNode = node; nextNode && !nextNode.alternate;)node = nextNode, 0 !== (node.flags & 4098) && (fiber = node.return), nextNode = node.return;
    for(; node.return;)node = node.return;
    return 3 === node.tag ? fiber : null;
}
function $1e79381dc3a64a75$var$getSuspenseInstanceFromFiber(fiber) {
    if (13 === fiber.tag) {
        var suspenseState = fiber.memoizedState;
        null === suspenseState && (fiber = fiber.alternate, null !== fiber && (suspenseState = fiber.memoizedState));
        if (null !== suspenseState) return suspenseState.dehydrated;
    }
    return null;
}
function $1e79381dc3a64a75$var$getActivityInstanceFromFiber(fiber) {
    if (31 === fiber.tag) {
        var activityState = fiber.memoizedState;
        null === activityState && (fiber = fiber.alternate, null !== fiber && (activityState = fiber.memoizedState));
        if (null !== activityState) return activityState.dehydrated;
    }
    return null;
}
function $1e79381dc3a64a75$var$assertIsMounted(fiber) {
    if ($1e79381dc3a64a75$var$getNearestMountedFiber(fiber) !== fiber) throw Error($1e79381dc3a64a75$var$formatProdErrorMessage(188));
}
function $1e79381dc3a64a75$var$findCurrentFiberUsingSlowPath(fiber) {
    var alternate = fiber.alternate;
    if (!alternate) {
        alternate = $1e79381dc3a64a75$var$getNearestMountedFiber(fiber);
        if (null === alternate) throw Error($1e79381dc3a64a75$var$formatProdErrorMessage(188));
        return alternate !== fiber ? null : fiber;
    }
    for(var a = fiber, b = alternate;;){
        var parentA = a.return;
        if (null === parentA) break;
        var parentB = parentA.alternate;
        if (null === parentB) {
            b = parentA.return;
            if (null !== b) {
                a = b;
                continue;
            }
            break;
        }
        if (parentA.child === parentB.child) {
            for(parentB = parentA.child; parentB;){
                if (parentB === a) return $1e79381dc3a64a75$var$assertIsMounted(parentA), fiber;
                if (parentB === b) return $1e79381dc3a64a75$var$assertIsMounted(parentA), alternate;
                parentB = parentB.sibling;
            }
            throw Error($1e79381dc3a64a75$var$formatProdErrorMessage(188));
        }
        if (a.return !== b.return) a = parentA, b = parentB;
        else {
            for(var didFindChild = !1, child$0 = parentA.child; child$0;){
                if (child$0 === a) {
                    didFindChild = !0;
                    a = parentA;
                    b = parentB;
                    break;
                }
                if (child$0 === b) {
                    didFindChild = !0;
                    b = parentA;
                    a = parentB;
                    break;
                }
                child$0 = child$0.sibling;
            }
            if (!didFindChild) {
                for(child$0 = parentB.child; child$0;){
                    if (child$0 === a) {
                        didFindChild = !0;
                        a = parentB;
                        b = parentA;
                        break;
                    }
                    if (child$0 === b) {
                        didFindChild = !0;
                        b = parentB;
                        a = parentA;
                        break;
                    }
                    child$0 = child$0.sibling;
                }
                if (!didFindChild) throw Error($1e79381dc3a64a75$var$formatProdErrorMessage(189));
            }
        }
        if (a.alternate !== b) throw Error($1e79381dc3a64a75$var$formatProdErrorMessage(190));
    }
    if (3 !== a.tag) throw Error($1e79381dc3a64a75$var$formatProdErrorMessage(188));
    return a.stateNode.current === a ? fiber : alternate;
}
function $1e79381dc3a64a75$var$findCurrentHostFiberImpl(node) {
    var tag = node.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return node;
    for(node = node.child; null !== node;){
        tag = $1e79381dc3a64a75$var$findCurrentHostFiberImpl(node);
        if (null !== tag) return tag;
        node = node.sibling;
    }
    return null;
}
function $1e79381dc3a64a75$var$traverseVisibleInstancesAndTextInstances(child, searchWithinHosts, fn, a, b, c) {
    for(; null !== child;){
        if ((5 === child.tag || 27 === child.tag || 6 === child.tag) && fn(child, a, b, c) || (22 !== child.tag || null === child.memoizedState) && (searchWithinHosts || 5 !== child.tag && 27 !== child.tag) && $1e79381dc3a64a75$var$traverseVisibleInstancesAndTextInstances(child.child, searchWithinHosts, fn, a, b, c)) return !0;
        child = child.sibling;
    }
    return !1;
}
function $1e79381dc3a64a75$var$getFragmentParentInstanceOrContainerFiber(fiber) {
    for(fiber = fiber.return; null !== fiber;){
        if (3 === fiber.tag || 5 === fiber.tag || 27 === fiber.tag) return fiber;
        fiber = fiber.return;
    }
    return null;
}
function $1e79381dc3a64a75$var$fiberIsPortaledIntoHost(fiber) {
    var foundPortalParent = !1;
    for(fiber = fiber.return; null !== fiber;){
        4 === fiber.tag && (foundPortalParent = !0);
        if (3 === fiber.tag || 5 === fiber.tag || 27 === fiber.tag) break;
        fiber = fiber.return;
    }
    return foundPortalParent;
}
function $1e79381dc3a64a75$var$getFragmentInstanceOrTextInstanceSiblings(fiber) {
    var result = [
        null,
        null
    ], parentHostFiber = $1e79381dc3a64a75$var$getFragmentParentInstanceOrContainerFiber(fiber);
    if (null === parentHostFiber) return result;
    $1e79381dc3a64a75$var$findFragmentInstanceOrTextInstanceSiblings(result, fiber, parentHostFiber.child, {
        foundSelf: !1
    });
    return result;
}
function $1e79381dc3a64a75$var$findFragmentInstanceOrTextInstanceSiblings(result, self, child, state) {
    for(; null !== child;){
        if (child === self) state.foundSelf = !0;
        else if (5 === child.tag || 27 === child.tag || 6 === child.tag) {
            if (state.foundSelf) return result[1] = child, !0;
            result[0] = child;
        } else if ((22 !== child.tag || null === child.memoizedState) && $1e79381dc3a64a75$var$findFragmentInstanceOrTextInstanceSiblings(result, self, child.child, state)) return !0;
        child = child.sibling;
    }
    return !1;
}
function $1e79381dc3a64a75$var$getInstanceFromHostFiber(fiber) {
    switch(fiber.tag){
        case 5:
        case 27:
        case 6:
            return fiber.stateNode;
        case 3:
            return fiber.stateNode.containerInfo;
        default:
            throw Error($1e79381dc3a64a75$var$formatProdErrorMessage(559));
    }
}
var $1e79381dc3a64a75$var$searchTarget = null, $1e79381dc3a64a75$var$searchBoundary = null;
function $1e79381dc3a64a75$var$isFiberPrecedingCheck(child, target, boundary) {
    return child === boundary ? !0 : child === target ? ($1e79381dc3a64a75$var$searchTarget = child, !0) : !1;
}
function $1e79381dc3a64a75$var$isFiberFollowingCheck(child, target, boundary) {
    return child === boundary ? ($1e79381dc3a64a75$var$searchBoundary = child, !1) : child === target ? (null !== $1e79381dc3a64a75$var$searchBoundary && ($1e79381dc3a64a75$var$searchTarget = child), !0) : !1;
}
function $1e79381dc3a64a75$var$getParentForFragmentAncestors(inst) {
    if (null === inst) return null;
    do inst = null === inst ? null : inst.return;
    while (inst && 5 !== inst.tag && 27 !== inst.tag && 3 !== inst.tag);
    return inst ? inst : null;
}
function $1e79381dc3a64a75$var$getLowestCommonAncestor(instA, instB, getParent) {
    for(var depthA = 0, tempA = instA; tempA; tempA = getParent(tempA))depthA++;
    tempA = 0;
    for(var tempB = instB; tempB; tempB = getParent(tempB))tempA++;
    for(; 0 < depthA - tempA;)instA = getParent(instA), depthA--;
    for(; 0 < tempA - depthA;)instB = getParent(instB), tempA--;
    for(; depthA--;){
        if (instA === instB || null !== instB && instA === instB.alternate) return instA;
        instA = getParent(instA);
        instB = getParent(instB);
    }
    return null;
}
var $1e79381dc3a64a75$var$assign = Object.assign, $1e79381dc3a64a75$var$REACT_LEGACY_ELEMENT_TYPE = Symbol.for("react.element"), $1e79381dc3a64a75$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $1e79381dc3a64a75$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $1e79381dc3a64a75$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $1e79381dc3a64a75$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $1e79381dc3a64a75$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $1e79381dc3a64a75$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $1e79381dc3a64a75$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $1e79381dc3a64a75$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $1e79381dc3a64a75$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $1e79381dc3a64a75$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), $1e79381dc3a64a75$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $1e79381dc3a64a75$var$REACT_LAZY_TYPE = Symbol.for("react.lazy");
Symbol.for("react.scope");
var $1e79381dc3a64a75$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity"), $1e79381dc3a64a75$var$REACT_LEGACY_HIDDEN_TYPE = Symbol.for("react.legacy_hidden");
Symbol.for("react.tracing_marker");
var $1e79381dc3a64a75$var$REACT_MEMO_CACHE_SENTINEL = Symbol.for("react.memo_cache_sentinel"), $1e79381dc3a64a75$var$REACT_VIEW_TRANSITION_TYPE = Symbol.for("react.view_transition"), $1e79381dc3a64a75$var$REACT_RECOVERABLE_TYPE = Symbol.for("react.recoverable"), $1e79381dc3a64a75$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $1e79381dc3a64a75$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $1e79381dc3a64a75$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$1e79381dc3a64a75$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $1e79381dc3a64a75$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function $1e79381dc3a64a75$var$getComponentNameFromType(type) {
    if (null == type) return null;
    if ("function" === typeof type) return type.$$typeof === $1e79381dc3a64a75$var$REACT_CLIENT_REFERENCE ? null : type.displayName || type.name || null;
    if ("string" === typeof type) return type;
    switch(type){
        case $1e79381dc3a64a75$var$REACT_FRAGMENT_TYPE:
            return "Fragment";
        case $1e79381dc3a64a75$var$REACT_PROFILER_TYPE:
            return "Profiler";
        case $1e79381dc3a64a75$var$REACT_STRICT_MODE_TYPE:
            return "StrictMode";
        case $1e79381dc3a64a75$var$REACT_SUSPENSE_TYPE:
            return "Suspense";
        case $1e79381dc3a64a75$var$REACT_SUSPENSE_LIST_TYPE:
            return "SuspenseList";
        case $1e79381dc3a64a75$var$REACT_ACTIVITY_TYPE:
            return "Activity";
        case $1e79381dc3a64a75$var$REACT_VIEW_TRANSITION_TYPE:
            return "ViewTransition";
    }
    if ("object" === typeof type) switch(type.$$typeof){
        case $1e79381dc3a64a75$var$REACT_PORTAL_TYPE:
            return "Portal";
        case $1e79381dc3a64a75$var$REACT_CONTEXT_TYPE:
            return type.displayName || "Context";
        case $1e79381dc3a64a75$var$REACT_CONSUMER_TYPE:
            return (type._context.displayName || "Context") + ".Consumer";
        case $1e79381dc3a64a75$var$REACT_FORWARD_REF_TYPE:
            var innerType = type.render;
            type = type.displayName;
            type || (type = innerType.displayName || innerType.name || "", type = "" !== type ? "ForwardRef(" + type + ")" : "ForwardRef");
            return type;
        case $1e79381dc3a64a75$var$REACT_MEMO_TYPE:
            return innerType = type.displayName || null, null !== innerType ? innerType : $1e79381dc3a64a75$var$getComponentNameFromType(type.type) || "Memo";
        case $1e79381dc3a64a75$var$REACT_LAZY_TYPE:
            innerType = type._payload;
            type = type._init;
            try {
                return $1e79381dc3a64a75$var$getComponentNameFromType(type(innerType));
            } catch (x) {}
    }
    return null;
}
var $1e79381dc3a64a75$var$isArrayImpl = Array.isArray, $1e79381dc3a64a75$var$ReactSharedInternals = $bFZzf.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $1e79381dc3a64a75$var$ReactDOMSharedInternals = $5g5IQ.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $1e79381dc3a64a75$var$sharedNotPendingObject = {
    pending: !1,
    data: null,
    method: null,
    action: null
}, $1e79381dc3a64a75$var$valueStack = [], $1e79381dc3a64a75$var$index = -1;
function $1e79381dc3a64a75$var$createCursor(defaultValue) {
    return {
        current: defaultValue
    };
}
function $1e79381dc3a64a75$var$pop(cursor) {
    0 > $1e79381dc3a64a75$var$index || (cursor.current = $1e79381dc3a64a75$var$valueStack[$1e79381dc3a64a75$var$index], $1e79381dc3a64a75$var$valueStack[$1e79381dc3a64a75$var$index] = null, $1e79381dc3a64a75$var$index--);
}
function $1e79381dc3a64a75$var$push(cursor, value) {
    $1e79381dc3a64a75$var$index++;
    $1e79381dc3a64a75$var$valueStack[$1e79381dc3a64a75$var$index] = cursor.current;
    cursor.current = value;
}
var $1e79381dc3a64a75$var$contextStackCursor = $1e79381dc3a64a75$var$createCursor(null), $1e79381dc3a64a75$var$contextFiberStackCursor = $1e79381dc3a64a75$var$createCursor(null), $1e79381dc3a64a75$var$rootInstanceStackCursor = $1e79381dc3a64a75$var$createCursor(null), $1e79381dc3a64a75$var$hostTransitionProviderCursor = $1e79381dc3a64a75$var$createCursor(null);
function $1e79381dc3a64a75$var$pushHostContainer(fiber, nextRootInstance) {
    $1e79381dc3a64a75$var$push($1e79381dc3a64a75$var$rootInstanceStackCursor, nextRootInstance);
    $1e79381dc3a64a75$var$push($1e79381dc3a64a75$var$contextFiberStackCursor, fiber);
    $1e79381dc3a64a75$var$push($1e79381dc3a64a75$var$contextStackCursor, null);
    switch(nextRootInstance.nodeType){
        case 9:
        case 11:
            fiber = (fiber = nextRootInstance.documentElement) ? (fiber = fiber.namespaceURI) ? $1e79381dc3a64a75$var$getOwnHostContext(fiber) : 0 : 0;
            break;
        default:
            if (fiber = nextRootInstance.tagName, nextRootInstance = nextRootInstance.namespaceURI) nextRootInstance = $1e79381dc3a64a75$var$getOwnHostContext(nextRootInstance), fiber = $1e79381dc3a64a75$var$getChildHostContextProd(nextRootInstance, fiber);
            else switch(fiber){
                case "svg":
                    fiber = 1;
                    break;
                case "math":
                    fiber = 2;
                    break;
                default:
                    fiber = 0;
            }
    }
    $1e79381dc3a64a75$var$pop($1e79381dc3a64a75$var$contextStackCursor);
    $1e79381dc3a64a75$var$push($1e79381dc3a64a75$var$contextStackCursor, fiber);
}
function $1e79381dc3a64a75$var$popHostContainer() {
    $1e79381dc3a64a75$var$pop($1e79381dc3a64a75$var$contextStackCursor);
    $1e79381dc3a64a75$var$pop($1e79381dc3a64a75$var$contextFiberStackCursor);
    $1e79381dc3a64a75$var$pop($1e79381dc3a64a75$var$rootInstanceStackCursor);
}
function $1e79381dc3a64a75$var$pushHostContext(fiber) {
    var stateHook = fiber.memoizedState;
    null !== stateHook && ($1e79381dc3a64a75$var$HostTransitionContext._currentValue = stateHook.memoizedState, $1e79381dc3a64a75$var$push($1e79381dc3a64a75$var$hostTransitionProviderCursor, fiber));
    stateHook = $1e79381dc3a64a75$var$contextStackCursor.current;
    var JSCompiler_inline_result = $1e79381dc3a64a75$var$getChildHostContextProd(stateHook, fiber.type);
    stateHook !== JSCompiler_inline_result && ($1e79381dc3a64a75$var$push($1e79381dc3a64a75$var$contextFiberStackCursor, fiber), $1e79381dc3a64a75$var$push($1e79381dc3a64a75$var$contextStackCursor, JSCompiler_inline_result));
}
function $1e79381dc3a64a75$var$popHostContext(fiber) {
    $1e79381dc3a64a75$var$contextFiberStackCursor.current === fiber && ($1e79381dc3a64a75$var$pop($1e79381dc3a64a75$var$contextStackCursor), $1e79381dc3a64a75$var$pop($1e79381dc3a64a75$var$contextFiberStackCursor));
    $1e79381dc3a64a75$var$hostTransitionProviderCursor.current === fiber && ($1e79381dc3a64a75$var$pop($1e79381dc3a64a75$var$hostTransitionProviderCursor), $1e79381dc3a64a75$var$HostTransitionContext._currentValue = $1e79381dc3a64a75$var$sharedNotPendingObject);
}
var $1e79381dc3a64a75$var$prefix, $1e79381dc3a64a75$var$suffix;
function $1e79381dc3a64a75$var$describeBuiltInComponentFrame(name) {
    if (void 0 === $1e79381dc3a64a75$var$prefix) try {
        throw Error();
    } catch (x) {
        var match = x.stack.trim().match(/\n( *(at )?)/);
        $1e79381dc3a64a75$var$prefix = match && match[1] || "";
        $1e79381dc3a64a75$var$suffix = -1 < x.stack.indexOf("\n    at") ? " (<anonymous>)" : -1 < x.stack.indexOf("@") ? "@unknown:0:0" : "";
    }
    return "\n" + $1e79381dc3a64a75$var$prefix + name + $1e79381dc3a64a75$var$suffix;
}
var $1e79381dc3a64a75$var$reentry = !1;
function $1e79381dc3a64a75$var$describeNativeComponentFrame(fn, construct) {
    if (!fn || $1e79381dc3a64a75$var$reentry) return "";
    $1e79381dc3a64a75$var$reentry = !0;
    var previousPrepareStackTrace = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        var RunInRootFrame = {
            DetermineComponentFrameRoot: function() {
                try {
                    if (construct) {
                        var Fake = function() {
                            throw Error();
                        };
                        Object.defineProperty(Fake.prototype, "props", {
                            set: function() {
                                throw Error();
                            }
                        });
                        if ("object" === typeof Reflect && Reflect.construct) {
                            try {
                                Reflect.construct(Fake, []);
                            } catch (x) {
                                var control = x;
                            }
                            Reflect.construct(fn, [], Fake);
                        } else {
                            try {
                                Fake.call();
                            } catch (x$1) {
                                control = x$1;
                            }
                            Fake = !1;
                            try {
                                var prevProps = Object.getOwnPropertyDescriptor(fn.prototype, "props");
                                Object.defineProperty(fn.prototype, "props", {
                                    configurable: !0,
                                    set: function() {
                                        throw Error();
                                    }
                                });
                                Fake = !0;
                                new fn();
                            } finally{
                                Fake && (void 0 !== prevProps ? Object.defineProperty(fn.prototype, "props", prevProps) : delete fn.prototype.props);
                            }
                        }
                    } else {
                        try {
                            throw Error();
                        } catch (x$2) {
                            control = x$2;
                        }
                        (Fake = fn()) && "function" === typeof Fake.catch && Fake.catch(function() {});
                    }
                } catch (sample) {
                    if (sample && control && "string" === typeof sample.stack) return [
                        sample.stack,
                        control.stack
                    ];
                }
                return [
                    null,
                    null
                ];
            }
        };
        RunInRootFrame.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
        var namePropDescriptor = Object.getOwnPropertyDescriptor(RunInRootFrame.DetermineComponentFrameRoot, "name");
        namePropDescriptor && namePropDescriptor.configurable && Object.defineProperty(RunInRootFrame.DetermineComponentFrameRoot, "name", {
            value: "DetermineComponentFrameRoot"
        });
        var _RunInRootFrame$Deter = RunInRootFrame.DetermineComponentFrameRoot(), sampleStack = _RunInRootFrame$Deter[0], controlStack = _RunInRootFrame$Deter[1];
        if (sampleStack && controlStack) {
            var sampleLines = sampleStack.split("\n"), controlLines = controlStack.split("\n");
            for(namePropDescriptor = RunInRootFrame = 0; RunInRootFrame < sampleLines.length && !sampleLines[RunInRootFrame].includes("DetermineComponentFrameRoot");)RunInRootFrame++;
            for(; namePropDescriptor < controlLines.length && !controlLines[namePropDescriptor].includes("DetermineComponentFrameRoot");)namePropDescriptor++;
            if (RunInRootFrame === sampleLines.length || namePropDescriptor === controlLines.length) for(RunInRootFrame = sampleLines.length - 1, namePropDescriptor = controlLines.length - 1; 1 <= RunInRootFrame && 0 <= namePropDescriptor && sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor];)namePropDescriptor--;
            for(; 1 <= RunInRootFrame && 0 <= namePropDescriptor; RunInRootFrame--, namePropDescriptor--)if (sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                if (1 !== RunInRootFrame || 1 !== namePropDescriptor) {
                    do if (RunInRootFrame--, namePropDescriptor--, 0 > namePropDescriptor || sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                        var frame = "\n" + sampleLines[RunInRootFrame].replace(" at new ", " at ");
                        fn.displayName && frame.includes("<anonymous>") && (frame = frame.replace("<anonymous>", fn.displayName));
                        return frame;
                    }
                    while (1 <= RunInRootFrame && 0 <= namePropDescriptor);
                }
                break;
            }
        }
    } finally{
        $1e79381dc3a64a75$var$reentry = !1, Error.prepareStackTrace = previousPrepareStackTrace;
    }
    return (previousPrepareStackTrace = fn ? fn.displayName || fn.name : "") ? $1e79381dc3a64a75$var$describeBuiltInComponentFrame(previousPrepareStackTrace) : "";
}
function $1e79381dc3a64a75$var$describeFiber(fiber, childFiber) {
    switch(fiber.tag){
        case 26:
        case 27:
        case 5:
            return $1e79381dc3a64a75$var$describeBuiltInComponentFrame(fiber.type);
        case 16:
            return $1e79381dc3a64a75$var$describeBuiltInComponentFrame("Lazy");
        case 13:
            return fiber.child !== childFiber && null !== childFiber ? $1e79381dc3a64a75$var$describeBuiltInComponentFrame("Suspense Fallback") : $1e79381dc3a64a75$var$describeBuiltInComponentFrame("Suspense");
        case 19:
            return $1e79381dc3a64a75$var$describeBuiltInComponentFrame("SuspenseList");
        case 0:
        case 15:
            return $1e79381dc3a64a75$var$describeNativeComponentFrame(fiber.type, !1);
        case 11:
            return $1e79381dc3a64a75$var$describeNativeComponentFrame(fiber.type.render, !1);
        case 1:
            return $1e79381dc3a64a75$var$describeNativeComponentFrame(fiber.type, !0);
        case 31:
            return $1e79381dc3a64a75$var$describeBuiltInComponentFrame("Activity");
        case 30:
            return $1e79381dc3a64a75$var$describeBuiltInComponentFrame("ViewTransition");
        default:
            return "";
    }
}
function $1e79381dc3a64a75$var$getStackByFiberInDevAndProd(workInProgress) {
    try {
        var info = "", previous = null;
        do info += $1e79381dc3a64a75$var$describeFiber(workInProgress, previous), previous = workInProgress, workInProgress = workInProgress.return;
        while (workInProgress);
        return info;
    } catch (x) {
        return "\nError generating stack: " + x.message + "\n" + x.stack;
    }
}
var $1e79381dc3a64a75$var$hasOwnProperty = Object.prototype.hasOwnProperty, $1e79381dc3a64a75$var$scheduleCallback$3 = $3T9qK.unstable_scheduleCallback, $1e79381dc3a64a75$var$cancelCallback$1 = $3T9qK.unstable_cancelCallback, $1e79381dc3a64a75$var$shouldYield = $3T9qK.unstable_shouldYield, $1e79381dc3a64a75$var$requestPaint = $3T9qK.unstable_requestPaint, $1e79381dc3a64a75$var$now = $3T9qK.unstable_now, $1e79381dc3a64a75$var$getCurrentPriorityLevel = $3T9qK.unstable_getCurrentPriorityLevel, $1e79381dc3a64a75$var$ImmediatePriority = $3T9qK.unstable_ImmediatePriority, $1e79381dc3a64a75$var$UserBlockingPriority = $3T9qK.unstable_UserBlockingPriority, $1e79381dc3a64a75$var$NormalPriority$1 = $3T9qK.unstable_NormalPriority, $1e79381dc3a64a75$var$LowPriority = $3T9qK.unstable_LowPriority, $1e79381dc3a64a75$var$IdlePriority = $3T9qK.unstable_IdlePriority, $1e79381dc3a64a75$var$log$1 = $3T9qK.log, $1e79381dc3a64a75$var$unstable_setDisableYieldValue = $3T9qK.unstable_setDisableYieldValue, $1e79381dc3a64a75$var$rendererID = null, $1e79381dc3a64a75$var$injectedHook = null;
function $1e79381dc3a64a75$var$setIsStrictModeForDevtools(newIsStrictMode) {
    "function" === typeof $1e79381dc3a64a75$var$log$1 && $1e79381dc3a64a75$var$unstable_setDisableYieldValue(newIsStrictMode);
    if ($1e79381dc3a64a75$var$injectedHook && "function" === typeof $1e79381dc3a64a75$var$injectedHook.setStrictMode) try {
        $1e79381dc3a64a75$var$injectedHook.setStrictMode($1e79381dc3a64a75$var$rendererID, newIsStrictMode);
    } catch (err) {}
}
var $1e79381dc3a64a75$var$clz32 = Math.clz32 ? Math.clz32 : $1e79381dc3a64a75$var$clz32Fallback, $1e79381dc3a64a75$var$log = Math.log, $1e79381dc3a64a75$var$LN2 = Math.LN2;
function $1e79381dc3a64a75$var$clz32Fallback(x) {
    x >>>= 0;
    return 0 === x ? 32 : 31 - ($1e79381dc3a64a75$var$log(x) / $1e79381dc3a64a75$var$LN2 | 0) | 0;
}
var $1e79381dc3a64a75$var$nextTransitionUpdateLane = 256, $1e79381dc3a64a75$var$nextTransitionDeferredLane = 262144, $1e79381dc3a64a75$var$nextRetryLane = 4194304;
function $1e79381dc3a64a75$var$getHighestPriorityLanes(lanes) {
    var pendingSyncLanes = lanes & 42;
    if (0 !== pendingSyncLanes) return pendingSyncLanes;
    switch(lanes & -lanes){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
            return 64;
        case 128:
            return 128;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
            return lanes & -lanes;
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return lanes & 3932160;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return lanes & 62914560;
        case 67108864:
            return 67108864;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 0;
        default:
            return lanes;
    }
}
function $1e79381dc3a64a75$var$getNextLanes(root, wipLanes, rootHasPendingCommit) {
    var pendingLanes = root.pendingLanes;
    if (0 === pendingLanes) return 0;
    var nextLanes = 0, suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes;
    root = root.warmLanes;
    var nonIdlePendingLanes = pendingLanes & 134217727;
    0 !== nonIdlePendingLanes ? (pendingLanes = nonIdlePendingLanes & ~suspendedLanes, 0 !== pendingLanes ? nextLanes = $1e79381dc3a64a75$var$getHighestPriorityLanes(pendingLanes) : (pingedLanes &= nonIdlePendingLanes, 0 !== pingedLanes ? nextLanes = $1e79381dc3a64a75$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = nonIdlePendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $1e79381dc3a64a75$var$getHighestPriorityLanes(rootHasPendingCommit))))) : (nonIdlePendingLanes = pendingLanes & ~suspendedLanes, 0 !== nonIdlePendingLanes ? nextLanes = $1e79381dc3a64a75$var$getHighestPriorityLanes(nonIdlePendingLanes) : 0 !== pingedLanes ? nextLanes = $1e79381dc3a64a75$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = pendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $1e79381dc3a64a75$var$getHighestPriorityLanes(rootHasPendingCommit))));
    return 0 === nextLanes ? 0 : 0 !== wipLanes && wipLanes !== nextLanes && 0 === (wipLanes & suspendedLanes) && (suspendedLanes = nextLanes & -nextLanes, rootHasPendingCommit = wipLanes & -wipLanes, suspendedLanes >= rootHasPendingCommit || 32 === suspendedLanes && 0 !== (rootHasPendingCommit & 4194048)) ? wipLanes : nextLanes;
}
function $1e79381dc3a64a75$var$checkIfRootIsPrerendering(root, renderLanes) {
    return 0 === (root.pendingLanes & ~(root.suspendedLanes & ~root.pingedLanes) & renderLanes);
}
function $1e79381dc3a64a75$var$getEntangledLanes(root, renderLanes) {
    0 !== (renderLanes & 8) && (renderLanes |= renderLanes & 32);
    var allEntangledLanes = root.entangledLanes;
    if (0 !== allEntangledLanes) for(root = root.entanglements, allEntangledLanes &= renderLanes; 0 < allEntangledLanes;){
        var index$4 = 31 - $1e79381dc3a64a75$var$clz32(allEntangledLanes), lane = 1 << index$4;
        renderLanes |= root[index$4];
        allEntangledLanes &= ~lane;
    }
    return renderLanes;
}
function $1e79381dc3a64a75$var$computeExpirationTime(lane, currentTime) {
    switch(lane){
        case 1:
        case 2:
        case 4:
        case 8:
        case 64:
            return currentTime + 250;
        case 16:
        case 32:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return currentTime + 5e3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return -1;
        case 67108864:
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $1e79381dc3a64a75$var$claimNextRetryLane() {
    var lane = $1e79381dc3a64a75$var$nextRetryLane;
    $1e79381dc3a64a75$var$nextRetryLane <<= 1;
    0 === ($1e79381dc3a64a75$var$nextRetryLane & 62914560) && ($1e79381dc3a64a75$var$nextRetryLane = 4194304);
    return lane;
}
function $1e79381dc3a64a75$var$createLaneMap(initial) {
    for(var laneMap = [], i = 0; 31 > i; i++)laneMap.push(initial);
    return laneMap;
}
function $1e79381dc3a64a75$var$markRootUpdated$1(root, updateLane) {
    root.pendingLanes |= updateLane;
    268435456 !== updateLane && (root.suspendedLanes = 0, root.pingedLanes = 0, root.warmLanes = 0);
}
function $1e79381dc3a64a75$var$markRootFinished(root, finishedLanes, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes) {
    var previouslyPendingLanes = root.pendingLanes;
    root.pendingLanes = remainingLanes;
    root.suspendedLanes = 0;
    root.pingedLanes = 0;
    root.warmLanes = 0;
    root.expiredLanes &= remainingLanes;
    root.entangledLanes &= remainingLanes;
    root.errorRecoveryDisabledLanes &= remainingLanes;
    root.shellSuspendCounter = 0;
    var entanglements = root.entanglements, expirationTimes = root.expirationTimes, hiddenUpdates = root.hiddenUpdates;
    for(remainingLanes = previouslyPendingLanes & ~remainingLanes; 0 < remainingLanes;){
        var index$7 = 31 - $1e79381dc3a64a75$var$clz32(remainingLanes), lane = 1 << index$7;
        entanglements[index$7] = 0;
        expirationTimes[index$7] = -1;
        var hiddenUpdatesForLane = hiddenUpdates[index$7];
        if (null !== hiddenUpdatesForLane) for(hiddenUpdates[index$7] = null, index$7 = 0; index$7 < hiddenUpdatesForLane.length; index$7++){
            var update = hiddenUpdatesForLane[index$7];
            null !== update && (update.lane &= -536870913);
        }
        remainingLanes &= ~lane;
    }
    0 !== spawnedLane && $1e79381dc3a64a75$var$markSpawnedDeferredLane(root, spawnedLane, 0);
    0 !== suspendedRetryLanes && 0 === updatedLanes && 0 !== root.tag && (root.suspendedLanes |= suspendedRetryLanes & ~(previouslyPendingLanes & ~finishedLanes));
}
function $1e79381dc3a64a75$var$markSpawnedDeferredLane(root, spawnedLane, entangledLanes) {
    root.pendingLanes |= spawnedLane;
    root.suspendedLanes &= ~spawnedLane;
    var spawnedLaneIndex = 31 - $1e79381dc3a64a75$var$clz32(spawnedLane);
    root.entangledLanes |= spawnedLane;
    root.entanglements[spawnedLaneIndex] = root.entanglements[spawnedLaneIndex] | 1073741824 | entangledLanes & 261930;
}
function $1e79381dc3a64a75$var$markRootEntangled(root, entangledLanes) {
    var rootEntangledLanes = root.entangledLanes |= entangledLanes;
    for(root = root.entanglements; rootEntangledLanes;){
        var index$8 = 31 - $1e79381dc3a64a75$var$clz32(rootEntangledLanes), lane = 1 << index$8;
        lane & entangledLanes | root[index$8] & entangledLanes && (root[index$8] |= entangledLanes);
        rootEntangledLanes &= ~lane;
    }
}
function $1e79381dc3a64a75$var$getBumpedLaneForHydration(root, renderLanes) {
    var renderLane = renderLanes & -renderLanes;
    renderLane = 0 !== (renderLane & 42) ? 1 : $1e79381dc3a64a75$var$getBumpedLaneForHydrationByLane(renderLane);
    return 0 !== (renderLane & (root.suspendedLanes | renderLanes)) ? 0 : renderLane;
}
function $1e79381dc3a64a75$var$getBumpedLaneForHydrationByLane(lane) {
    switch(lane){
        case 2:
            lane = 1;
            break;
        case 8:
            lane = 4;
            break;
        case 32:
            lane = 16;
            break;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            lane = 128;
            break;
        case 268435456:
            lane = 134217728;
            break;
        default:
            lane = 0;
    }
    return lane;
}
function $1e79381dc3a64a75$var$lanesToEventPriority(lanes) {
    lanes &= -lanes;
    return 2 < lanes ? 8 < lanes ? 0 !== (lanes & 134217727) ? 32 : 268435456 : 8 : 2;
}
function $1e79381dc3a64a75$var$resolveUpdatePriority() {
    var updatePriority = $1e79381dc3a64a75$var$ReactDOMSharedInternals.p;
    if (0 !== updatePriority) return updatePriority;
    updatePriority = window.event;
    return void 0 === updatePriority ? 32 : $1e79381dc3a64a75$var$getEventPriority(updatePriority.type);
}
function $1e79381dc3a64a75$var$runWithPriority(priority, fn) {
    var previousPriority = $1e79381dc3a64a75$var$ReactDOMSharedInternals.p;
    try {
        return $1e79381dc3a64a75$var$ReactDOMSharedInternals.p = priority, fn();
    } finally{
        $1e79381dc3a64a75$var$ReactDOMSharedInternals.p = previousPriority;
    }
}
var $1e79381dc3a64a75$var$randomKey = Math.random().toString(36).slice(2), $1e79381dc3a64a75$var$internalInstanceKey = "__reactFiber$" + $1e79381dc3a64a75$var$randomKey, $1e79381dc3a64a75$var$internalPropsKey = "__reactProps$" + $1e79381dc3a64a75$var$randomKey, $1e79381dc3a64a75$var$internalContainerInstanceKey = "__reactContainer$" + $1e79381dc3a64a75$var$randomKey, $1e79381dc3a64a75$var$internalEventHandlersKey = "__reactEvents$" + $1e79381dc3a64a75$var$randomKey, $1e79381dc3a64a75$var$internalEventHandlerListenersKey = "__reactListeners$" + $1e79381dc3a64a75$var$randomKey, $1e79381dc3a64a75$var$internalEventHandlesSetKey = "__reactHandles$" + $1e79381dc3a64a75$var$randomKey, $1e79381dc3a64a75$var$internalRootNodeResourcesKey = "__reactResources$" + $1e79381dc3a64a75$var$randomKey, $1e79381dc3a64a75$var$internalHoistableMarker = "__reactMarker$" + $1e79381dc3a64a75$var$randomKey, $1e79381dc3a64a75$var$internalLoadPendingKey = "__reactLoad$" + $1e79381dc3a64a75$var$randomKey;
function $1e79381dc3a64a75$var$detachDeletedInstance(node) {
    delete node[$1e79381dc3a64a75$var$internalInstanceKey];
    delete node[$1e79381dc3a64a75$var$internalPropsKey];
    delete node[$1e79381dc3a64a75$var$internalEventHandlerListenersKey];
    delete node[$1e79381dc3a64a75$var$internalEventHandlesSetKey];
}
function $1e79381dc3a64a75$var$getClosestInstanceFromNode(targetNode) {
    var targetInst;
    if (targetInst = targetNode[$1e79381dc3a64a75$var$internalInstanceKey]) return targetInst;
    for(var parentNode = targetNode.parentNode; parentNode;){
        if (targetInst = parentNode[$1e79381dc3a64a75$var$internalContainerInstanceKey] || parentNode[$1e79381dc3a64a75$var$internalInstanceKey]) {
            parentNode = targetInst.alternate;
            if (null !== targetInst.child || null !== parentNode && null !== parentNode.child) for(targetNode = $1e79381dc3a64a75$var$getParentHydrationBoundary(targetNode); null !== targetNode;){
                if (parentNode = targetNode[$1e79381dc3a64a75$var$internalInstanceKey]) return parentNode;
                targetNode = $1e79381dc3a64a75$var$getParentHydrationBoundary(targetNode);
            }
            return targetInst;
        }
        targetNode = parentNode;
        parentNode = targetNode.parentNode;
    }
    return null;
}
function $1e79381dc3a64a75$var$getInstanceFromNode(node) {
    if (node = node[$1e79381dc3a64a75$var$internalInstanceKey] || node[$1e79381dc3a64a75$var$internalContainerInstanceKey]) {
        var tag = node.tag;
        if (5 === tag || 6 === tag || 13 === tag || 31 === tag || 26 === tag || 27 === tag || 3 === tag) return node;
    }
    return null;
}
function $1e79381dc3a64a75$var$getNodeFromInstance(inst) {
    var tag = inst.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return inst.stateNode;
    throw Error($1e79381dc3a64a75$var$formatProdErrorMessage(33));
}
function $1e79381dc3a64a75$var$getResourcesFromRoot(root) {
    var resources = root[$1e79381dc3a64a75$var$internalRootNodeResourcesKey];
    resources || (resources = root[$1e79381dc3a64a75$var$internalRootNodeResourcesKey] = {
        hoistableStyles: new Map(),
        hoistableScripts: new Map()
    });
    return resources;
}
function $1e79381dc3a64a75$var$markNodeAsHoistable(node) {
    node[$1e79381dc3a64a75$var$internalHoistableMarker] = !0;
}
function $1e79381dc3a64a75$var$clearPendingLoadOnNode(node) {
    node[$1e79381dc3a64a75$var$internalLoadPendingKey] = void 0;
}
var $1e79381dc3a64a75$var$allNativeEvents = new Set(), $1e79381dc3a64a75$var$registrationNameDependencies = {};
function $1e79381dc3a64a75$var$registerTwoPhaseEvent(registrationName, dependencies) {
    $1e79381dc3a64a75$var$registerDirectEvent(registrationName, dependencies);
    $1e79381dc3a64a75$var$registerDirectEvent(registrationName + "Capture", dependencies);
}
function $1e79381dc3a64a75$var$registerDirectEvent(registrationName, dependencies) {
    $1e79381dc3a64a75$var$registrationNameDependencies[registrationName] = dependencies;
    for(registrationName = 0; registrationName < dependencies.length; registrationName++)$1e79381dc3a64a75$var$allNativeEvents.add(dependencies[registrationName]);
}
var $1e79381dc3a64a75$var$VALID_ATTRIBUTE_NAME_REGEX = RegExp("^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), $1e79381dc3a64a75$var$illegalAttributeNameCache = {}, $1e79381dc3a64a75$var$validatedAttributeNameCache = {};
function $1e79381dc3a64a75$var$isAttributeNameSafe(attributeName) {
    if ($1e79381dc3a64a75$var$hasOwnProperty.call($1e79381dc3a64a75$var$validatedAttributeNameCache, attributeName)) return !0;
    if ($1e79381dc3a64a75$var$hasOwnProperty.call($1e79381dc3a64a75$var$illegalAttributeNameCache, attributeName)) return !1;
    if ($1e79381dc3a64a75$var$VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) return $1e79381dc3a64a75$var$validatedAttributeNameCache[attributeName] = !0;
    $1e79381dc3a64a75$var$illegalAttributeNameCache[attributeName] = !0;
    return !1;
}
var $1e79381dc3a64a75$var$viewTransitionMutationContext = !1;
function $1e79381dc3a64a75$var$pushMutationContext() {
    var prev = $1e79381dc3a64a75$var$viewTransitionMutationContext;
    $1e79381dc3a64a75$var$viewTransitionMutationContext = !1;
    return prev;
}
function $1e79381dc3a64a75$var$setValueForAttribute(node, name, value) {
    if ($1e79381dc3a64a75$var$isAttributeNameSafe(name)) {
        if (null === value) node.removeAttribute(name);
        else {
            switch(typeof value){
                case "undefined":
                case "function":
                case "symbol":
                    node.removeAttribute(name);
                    return;
                case "boolean":
                    var prefix$10 = name.toLowerCase().slice(0, 5);
                    if ("data-" !== prefix$10 && "aria-" !== prefix$10) {
                        node.removeAttribute(name);
                        return;
                    }
            }
            node.setAttribute(name, value);
        }
    }
}
function $1e79381dc3a64a75$var$setValueForKnownAttribute(node, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttribute(name, value);
    }
}
function $1e79381dc3a64a75$var$setValueForNamespacedAttribute(node, namespace, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttributeNS(namespace, name, value);
    }
}
function $1e79381dc3a64a75$var$getToStringValue(value) {
    switch(typeof value){
        case "bigint":
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return value;
        case "object":
            return value;
        default:
            return "";
    }
}
function $1e79381dc3a64a75$var$isCheckable(elem) {
    var type = elem.type;
    return (elem = elem.nodeName) && "input" === elem.toLowerCase() && ("checkbox" === type || "radio" === type);
}
function $1e79381dc3a64a75$var$trackValueOnNode(node, valueField, currentValue) {
    var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);
    if (!node.hasOwnProperty(valueField) && "undefined" !== typeof descriptor && "function" === typeof descriptor.get && "function" === typeof descriptor.set) {
        var get = descriptor.get, set = descriptor.set;
        Object.defineProperty(node, valueField, {
            configurable: !0,
            get: function() {
                return get.call(this);
            },
            set: function(value) {
                currentValue = "" + value;
                set.call(this, value);
            }
        });
        Object.defineProperty(node, valueField, {
            enumerable: descriptor.enumerable
        });
        return {
            getValue: function() {
                return currentValue;
            },
            setValue: function(value) {
                currentValue = "" + value;
            },
            stopTracking: function() {
                node._valueTracker = null;
                delete node[valueField];
            }
        };
    }
}
function $1e79381dc3a64a75$var$track(node) {
    if (!node._valueTracker) {
        var valueField = $1e79381dc3a64a75$var$isCheckable(node) ? "checked" : "value";
        node._valueTracker = $1e79381dc3a64a75$var$trackValueOnNode(node, valueField, "" + node[valueField]);
    }
}
function $1e79381dc3a64a75$var$updateValueIfChanged(node) {
    if (!node) return !1;
    var tracker = node._valueTracker;
    if (!tracker) return !0;
    var lastValue = tracker.getValue();
    var value = "";
    node && (value = $1e79381dc3a64a75$var$isCheckable(node) ? node.checked ? "true" : "false" : node.value);
    node = value;
    return node !== lastValue ? (tracker.setValue(node), !0) : !1;
}
var $1e79381dc3a64a75$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex = /[\n"\\]/g;
function $1e79381dc3a64a75$var$escapeSelectorAttributeValueInsideDoubleQuotes(value) {
    return value.replace($1e79381dc3a64a75$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex, function(ch) {
        return "\\" + ch.charCodeAt(0).toString(16) + " ";
    });
}
function $1e79381dc3a64a75$var$updateInput(element, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name) {
    element.name = "";
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type ? element.type = type : element.removeAttribute("type");
    if (null != value) {
        if ("number" === type) {
            if (0 === value && "" === element.value || element.value != value) element.value = "" + $1e79381dc3a64a75$var$getToStringValue(value);
        } else element.value !== "" + $1e79381dc3a64a75$var$getToStringValue(value) && (element.value = "" + $1e79381dc3a64a75$var$getToStringValue(value));
    } else "submit" !== type && "reset" !== type || element.removeAttribute("value");
    null != value ? "number" === type && element.value == value ? $1e79381dc3a64a75$var$setDefaultValue(element, $1e79381dc3a64a75$var$getToStringValue(element.value)) : $1e79381dc3a64a75$var$setDefaultValue(element, $1e79381dc3a64a75$var$getToStringValue(value)) : null != defaultValue ? $1e79381dc3a64a75$var$setDefaultValue(element, $1e79381dc3a64a75$var$getToStringValue(defaultValue)) : null != lastDefaultValue && element.removeAttribute("value");
    null == checked && null != defaultChecked && (element.defaultChecked = !!defaultChecked);
    null != checked && (element.checked = checked && "function" !== typeof checked && "symbol" !== typeof checked);
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name ? element.name = "" + $1e79381dc3a64a75$var$getToStringValue(name) : element.removeAttribute("name");
}
function $1e79381dc3a64a75$var$initInput(element, value, defaultValue, checked, defaultChecked, type, name, isHydrating) {
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type && (element.type = type);
    if (null != value || null != defaultValue) {
        if (!("submit" !== type && "reset" !== type || void 0 !== value && null !== value)) {
            $1e79381dc3a64a75$var$track(element);
            return;
        }
        defaultValue = null != defaultValue ? "" + $1e79381dc3a64a75$var$getToStringValue(defaultValue) : "";
        value = null != value ? "" + $1e79381dc3a64a75$var$getToStringValue(value) : defaultValue;
        isHydrating || value === element.value || (element.value = value);
        element.defaultValue = value;
    }
    checked = null != checked ? checked : defaultChecked;
    checked = "function" !== typeof checked && "symbol" !== typeof checked && !!checked;
    element.checked = isHydrating ? element.checked : !!checked;
    element.defaultChecked = !!checked;
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name && (element.name = name);
    $1e79381dc3a64a75$var$track(element);
}
function $1e79381dc3a64a75$var$setDefaultValue(node, value) {
    node.defaultValue !== "" + value && (node.defaultValue = "" + value);
}
function $1e79381dc3a64a75$var$updateOptions(node, multiple, propValue, setDefaultSelected) {
    node = node.options;
    if (multiple) {
        multiple = {};
        for(var i = 0; i < propValue.length; i++)multiple["$" + propValue[i]] = !0;
        for(propValue = 0; propValue < node.length; propValue++)i = multiple.hasOwnProperty("$" + node[propValue].value), node[propValue].selected !== i && (node[propValue].selected = i), i && setDefaultSelected && (node[propValue].defaultSelected = !0);
    } else {
        propValue = "" + $1e79381dc3a64a75$var$getToStringValue(propValue);
        multiple = null;
        for(i = 0; i < node.length; i++){
            if (node[i].value === propValue) {
                node[i].selected = !0;
                setDefaultSelected && (node[i].defaultSelected = !0);
                return;
            }
            null !== multiple || node[i].disabled || (multiple = node[i]);
        }
        null !== multiple && (multiple.selected = !0);
    }
}
function $1e79381dc3a64a75$var$updateTextarea(element, value, defaultValue) {
    if (null != value && (value = "" + $1e79381dc3a64a75$var$getToStringValue(value), value !== element.value && (element.value = value), null == defaultValue)) {
        element.defaultValue !== value && (element.defaultValue = value);
        return;
    }
    element.defaultValue = null != defaultValue ? "" + $1e79381dc3a64a75$var$getToStringValue(defaultValue) : "";
}
function $1e79381dc3a64a75$var$initTextarea(element, value, defaultValue, children) {
    if (null == value) {
        if (null != children) {
            if (null != defaultValue) throw Error($1e79381dc3a64a75$var$formatProdErrorMessage(92));
            if ($1e79381dc3a64a75$var$isArrayImpl(children)) {
                if (1 < children.length) throw Error($1e79381dc3a64a75$var$formatProdErrorMessage(93));
                children = children[0];
            }
            defaultValue = children;
        }
        null == defaultValue && (defaultValue = "");
        value = defaultValue;
    }
    defaultValue = $1e79381dc3a64a75$var$getToStringValue(value);
    element.defaultValue = defaultValue;
    children = element.textContent;
    children === defaultValue && "" !== children && null !== children && (element.value = children);
    $1e79381dc3a64a75$var$track(element);
}
function $1e79381dc3a64a75$var$setTextContent(node, text) {
    if (text) {
        var firstChild = node.firstChild;
        if (firstChild && firstChild === node.lastChild && 3 === firstChild.nodeType) {
            firstChild.nodeValue = text;
            return;
        }
    }
    node.textContent = text;
}
var $1e79381dc3a64a75$var$unitlessNumbers = new Set("animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(" "));
function $1e79381dc3a64a75$var$setValueForStyle(style, styleName, value) {
    var isCustomProperty = 0 === styleName.indexOf("--");
    null == value || "boolean" === typeof value || "" === value ? isCustomProperty ? style.setProperty(styleName, "") : "float" === styleName ? style.cssFloat = "" : style[styleName] = "" : isCustomProperty ? style.setProperty(styleName, value) : "number" !== typeof value || 0 === value || $1e79381dc3a64a75$var$unitlessNumbers.has(styleName) ? "float" === styleName ? style.cssFloat = value : style[styleName] = ("" + value).trim() : style[styleName] = value + "px";
}
function $1e79381dc3a64a75$var$setValueForStyles(node, styles, prevStyles) {
    if (null != styles && "object" !== typeof styles) throw Error($1e79381dc3a64a75$var$formatProdErrorMessage(62));
    node = node.style;
    if (null != prevStyles) {
        for(var styleName in prevStyles)!prevStyles.hasOwnProperty(styleName) || null != styles && styles.hasOwnProperty(styleName) || (0 === styleName.indexOf("--") ? node.setProperty(styleName, "") : "float" === styleName ? node.cssFloat = "" : node[styleName] = "", $1e79381dc3a64a75$var$viewTransitionMutationContext = !0);
        for(var styleName$16 in styles)styleName = styles[styleName$16], styles.hasOwnProperty(styleName$16) && prevStyles[styleName$16] !== styleName && ($1e79381dc3a64a75$var$setValueForStyle(node, styleName$16, styleName), $1e79381dc3a64a75$var$viewTransitionMutationContext = !0);
    } else for(var styleName$17 in styles)styles.hasOwnProperty(styleName$17) && $1e79381dc3a64a75$var$setValueForStyle(node, styleName$17, styles[styleName$17]);
}
function $1e79381dc3a64a75$var$isCustomElement(tagName) {
    if (-1 === tagName.indexOf("-")) return !1;
    switch(tagName){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $1e79381dc3a64a75$var$aliases = new Map([
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ],
    [
        "crossOrigin",
        "crossorigin"
    ],
    [
        "accentHeight",
        "accent-height"
    ],
    [
        "alignmentBaseline",
        "alignment-baseline"
    ],
    [
        "arabicForm",
        "arabic-form"
    ],
    [
        "baselineShift",
        "baseline-shift"
    ],
    [
        "capHeight",
        "cap-height"
    ],
    [
        "clipPath",
        "clip-path"
    ],
    [
        "clipRule",
        "clip-rule"
    ],
    [
        "colorInterpolation",
        "color-interpolation"
    ],
    [
        "colorInterpolationFilters",
        "color-interpolation-filters"
    ],
    [
        "colorProfile",
        "color-profile"
    ],
    [
        "colorRendering",
        "color-rendering"
    ],
    [
        "dominantBaseline",
        "dominant-baseline"
    ],
    [
        "enableBackground",
        "enable-background"
    ],
    [
        "fillOpacity",
        "fill-opacity"
    ],
    [
        "fillRule",
        "fill-rule"
    ],
    [
        "floodColor",
        "flood-color"
    ],
    [
        "floodOpacity",
        "flood-opacity"
    ],
    [
        "fontFamily",
        "font-family"
    ],
    [
        "fontSize",
        "font-size"
    ],
    [
        "fontSizeAdjust",
        "font-size-adjust"
    ],
    [
        "fontStretch",
        "font-stretch"
    ],
    [
        "fontStyle",
        "font-style"
    ],
    [
        "fontVariant",
        "font-variant"
    ],
    [
        "fontWeight",
        "font-weight"
    ],
    [
        "glyphName",
        "glyph-name"
    ],
    [
        "glyphOrientationHorizontal",
        "glyph-orientation-horizontal"
    ],
    [
        "glyphOrientationVertical",
        "glyph-orientation-vertical"
    ],
    [
        "horizAdvX",
        "horiz-adv-x"
    ],
    [
        "horizOriginX",
        "horiz-origin-x"
    ],
    [
        "imageRendering",
        "image-rendering"
    ],
    [
        "letterSpacing",
        "letter-spacing"
    ],
    [
        "lightingColor",
        "lighting-color"
    ],
    [
        "markerEnd",
        "marker-end"
    ],
    [
        "markerMid",
        "marker-mid"
    ],
    [
        "markerStart",
        "marker-start"
    ],
    [
        "maskType",
        "mask-type"
    ],
    [
        "overlinePosition",
        "overline-position"
    ],
    [
        "overlineThickness",
        "overline-thickness"
    ],
    [
        "paintOrder",
        "paint-order"
    ],
    [
        "panose-1",
        "panose-1"
    ],
    [
        "pointerEvents",
        "pointer-events"
    ],
    [
        "renderingIntent",
        "rendering-intent"
    ],
    [
        "shapeRendering",
        "shape-rendering"
    ],
    [
        "stopColor",
        "stop-color"
    ],
    [
        "stopOpacity",
        "stop-opacity"
    ],
    [
        "strikethroughPosition",
        "strikethrough-position"
    ],
    [
        "strikethroughThickness",
        "strikethrough-thickness"
    ],
    [
        "strokeDasharray",
        "stroke-dasharray"
    ],
    [
        "strokeDashoffset",
        "stroke-dashoffset"
    ],
    [
        "strokeLinecap",
        "stroke-linecap"
    ],
    [
        "strokeLinejoin",
        "stroke-linejoin"
    ],
    [
        "strokeMiterlimit",
        "stroke-miterlimit"
    ],
    [
        "strokeOpacity",
        "stroke-opacity"
    ],
    [
        "strokeWidth",
        "stroke-width"
    ],
    [
        "textAnchor",
        "text-anchor"
    ],
    [
        "textDecoration",
        "text-decoration"
    ],
    [
        "textRendering",
        "text-rendering"
    ],
    [
        "transformOrigin",
        "transform-origin"
    ],
    [
        "underlinePosition",
        "underline-position"
    ],
    [
        "underlineThickness",
        "underline-thickness"
    ],
    [
        "unicodeBidi",
        "unicode-bidi"
    ],
    [
        "unicodeRange",
        "unicode-range"
    ],
    [
        "unitsPerEm",
        "units-per-em"
    ],
    [
        "vAlphabetic",
        "v-alphabetic"
    ],
    [
        "vHanging",
        "v-hanging"
    ],
    [
        "vIdeographic",
        "v-ideographic"
    ],
    [
        "vMathematical",
        "v-mathematical"
    ],
    [
        "vectorEffect",
        "vector-effect"
    ],
    [
        "vertAdvY",
        "vert-adv-y"
    ],
    [
        "vertOriginX",
        "vert-origin-x"
    ],
    [
        "vertOriginY",
        "vert-origin-y"
    ],
    [
        "wordSpacing",
        "word-spacing"
    ],
    [
        "writingMode",
        "writing-mode"
    ],
    [
        "xmlnsXlink",
        "xmlns:xlink"
    ],
    [
        "xHeight",
        "x-height"
    ]
]), $1e79381dc3a64a75$var$isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
function $1e79381dc3a64a75$var$sanitizeURL(url) {
    return $1e79381dc3a64a75$var$isJavaScriptProtocol.test("" + url) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : url;
}
function $1e79381dc3a64a75$var$noop$1() {}
var $1e79381dc3a64a75$var$currentReplayingEvent = null;
function $1e79381dc3a64a75$var$getEventTarget(nativeEvent) {
    nativeEvent = nativeEvent.target || nativeEvent.srcElement || window;
    nativeEvent.correspondingUseElement && (nativeEvent = nativeEvent.correspondingUseElement);
    return 3 === nativeEvent.nodeType ? nativeEvent.parentNode : nativeEvent;
}
var $1e79381dc3a64a75$var$restoreTarget = null, $1e79381dc3a64a75$var$restoreQueue = null;
function $1e79381dc3a64a75$var$restoreStateOfTarget(target) {
    var internalInstance = $1e79381dc3a64a75$var$getInstanceFromNode(target);
    if (internalInstance && (target = internalInstance.stateNode)) {
        var props = target[$1e79381dc3a64a75$var$internalPropsKey] || null;
        a: switch(target = internalInstance.stateNode, internalInstance.type){
            case "input":
                $1e79381dc3a64a75$var$updateInput(target, props.value, props.defaultValue, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name);
                internalInstance = props.name;
                if ("radio" === props.type && null != internalInstance) {
                    for(props = target; props.parentNode;)props = props.parentNode;
                    props = props.querySelectorAll('input[name="' + $1e79381dc3a64a75$var$escapeSelectorAttributeValueInsideDoubleQuotes("" + internalInstance) + '"][type="radio"]');
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++){
                        var otherNode = props[internalInstance];
                        if (otherNode !== target && otherNode.form === target.form) {
                            var otherProps = otherNode[$1e79381dc3a64a75$var$internalPropsKey] || null;
                            if (!otherProps) throw Error($1e79381dc3a64a75$var$formatProdErrorMessage(90));
                            $1e79381dc3a64a75$var$updateInput(otherNode, otherProps.value, otherProps.defaultValue, otherProps.defaultValue, otherProps.checked, otherProps.defaultChecked, otherProps.type, otherProps.name);
                        }
                    }
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++)otherNode = props[internalInstance], otherNode.form === target.form && $1e79381dc3a64a75$var$updateValueIfChanged(otherNode);
                }
                break a;
            case "textarea":
                $1e79381dc3a64a75$var$updateTextarea(target, props.value, props.defaultValue);
                break a;
            case "select":
                internalInstance = props.value, null != internalInstance && $1e79381dc3a64a75$var$updateOptions(target, !!props.multiple, internalInstance, !1);
        }
    }
}
var $1e79381dc3a64a75$var$isInsideEventHandler = !1;
function $1e79381dc3a64a75$var$batchedUpdates$1(fn, a, b) {
    if ($1e79381dc3a64a75$var$isInsideEventHandler) return fn(a, b);
    $1e79381dc3a64a75$var$isInsideEventHandler = !0;
    try {
        var JSCompiler_inline_result = fn(a);
        return JSCompiler_inline_result;
    } finally{
        if ($1e79381dc3a64a75$var$isInsideEventHandler = !1, null !== $1e79381dc3a64a75$var$restoreTarget || null !== $1e79381dc3a64a75$var$restoreQueue) {
            if ($1e79381dc3a64a75$var$flushSyncWork$1(), $1e79381dc3a64a75$var$restoreTarget && (a = $1e79381dc3a64a75$var$restoreTarget, fn = $1e79381dc3a64a75$var$restoreQueue, $1e79381dc3a64a75$var$restoreQueue = $1e79381dc3a64a75$var$restoreTarget = null, $1e79381dc3a64a75$var$restoreStateOfTarget(a), fn)) for(a = 0; a < fn.length; a++)$1e79381dc3a64a75$var$restoreStateOfTarget(fn[a]);
        }
    }
}
function $1e79381dc3a64a75$var$getListener(inst, registrationName) {
    var stateNode = inst.stateNode;
    if (null === stateNode) return null;
    var props = stateNode[$1e79381dc3a64a75$var$internalPropsKey] || null;
    if (null === props) return null;
    stateNode = props[registrationName];
    a: switch(registrationName){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (props = !props.disabled) || (inst = inst.type, props = !("button" === inst || "input" === inst || "select" === inst || "textarea" === inst));
            inst = !props;
            break a;
        default:
            inst = !1;
    }
    if (inst) return null;
    if (stateNode && "function" !== typeof stateNode) throw Error($1e79381dc3a64a75$var$formatProdErrorMessage(231, registrationName, typeof stateNode));
    return stateNode;
}
var $1e79381dc3a64a75$var$canUseDOM = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $1e79381dc3a64a75$var$passiveBrowserEventsSupported = !1;
if ($1e79381dc3a64a75$var$canUseDOM) try {
    var $1e79381dc3a64a75$var$options = {};
    Object.defineProperty($1e79381dc3a64a75$var$options, "passive", {
        get: function() {
            $1e79381dc3a64a75$var$passiveBrowserEventsSupported = !0;
        }
    });
    window.addEventListener("test", $1e79381dc3a64a75$var$options, $1e79381dc3a64a75$var$options);
    window.removeEventListener("test", $1e79381dc3a64a75$var$options, $1e79381dc3a64a75$var$options);
} catch (e) {
    $1e79381dc3a64a75$var$passiveBrowserEventsSupported = !1;
}
var $1e79381dc3a64a75$var$root = null, $1e79381dc3a64a75$var$startText = null, $1e79381dc3a64a75$var$fallbackText = null;
function $1e79381dc3a64a75$var$getData() {
    if ($1e79381dc3a64a75$var$fallbackText) return $1e79381dc3a64a75$var$fallbackText;
    var start, startValue = $1e79381dc3a64a75$var$startText, startLength = startValue.length, end, endValue = "value" in $1e79381dc3a64a75$var$root ? $1e79381dc3a64a75$var$root.value : $1e79381dc3a64a75$var$root.textContent, endLength = endValue.length;
    for(start = 0; start < startLength && startValue[start] === endValue[start]; start++);
    var minEnd = startLength - start;
    for(end = 1; end <= minEnd && startValue[startLength - end] === endValue[endLength - end]; end++);
    return $1e79381dc3a64a75$var$fallbackText = endValue.slice(start, 1 < end ? 1 - end : void 0);
}
function $1e79381dc3a64a75$var$getEventCharCode(nativeEvent) {
    var keyCode = nativeEvent.keyCode;
    "charCode" in nativeEvent ? (nativeEvent = nativeEvent.charCode, 0 === nativeEvent && 13 === keyCode && (nativeEvent = 13)) : nativeEvent = keyCode;
    10 === nativeEvent && (nativeEvent = 13);
    return 32 <= nativeEvent || 13 === nativeEvent ? nativeEvent : 0;
}
function $1e79381dc3a64a75$var$functionThatReturnsTrue() {
    return !0;
}
function $1e79381dc3a64a75$var$functionThatReturnsFalse() {
    return !1;
}
function $1e79381dc3a64a75$var$createSyntheticEvent(Interface) {
    function SyntheticBaseEvent(reactName, reactEventType, targetInst, nativeEvent, nativeEventTarget) {
        this._reactName = reactName;
        this._targetInst = targetInst;
        this.type = reactEventType;
        this.nativeEvent = nativeEvent;
        this.target = nativeEventTarget;
        this.currentTarget = null;
        for(var propName in Interface)Interface.hasOwnProperty(propName) && (reactName = Interface[propName], this[propName] = reactName ? reactName(nativeEvent) : nativeEvent[propName]);
        this.isDefaultPrevented = (null != nativeEvent.defaultPrevented ? nativeEvent.defaultPrevented : !1 === nativeEvent.returnValue) ? $1e79381dc3a64a75$var$functionThatReturnsTrue : $1e79381dc3a64a75$var$functionThatReturnsFalse;
        this.isPropagationStopped = $1e79381dc3a64a75$var$functionThatReturnsFalse;
        return this;
    }
    $1e79381dc3a64a75$var$assign(SyntheticBaseEvent.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var event = this.nativeEvent;
            event && (event.preventDefault ? event.preventDefault() : "unknown" !== typeof event.returnValue && (event.returnValue = !1), this.isDefaultPrevented = $1e79381dc3a64a75$var$functionThatReturnsTrue);
        },
        stopPropagation: function() {
            var event = this.nativeEvent;
            event && (event.stopPropagation ? event.stopPropagation() : "unknown" !== typeof event.cancelBubble && (event.cancelBubble = !0), this.isPropagationStopped = $1e79381dc3a64a75$var$functionThatReturnsTrue);
        },
        persist: function() {},
        isPersistent: $1e79381dc3a64a75$var$functionThatReturnsTrue
    });
    return SyntheticBaseEvent;
}
var $1e79381dc3a64a75$var$EventInterface = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(event) {
        return event.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $1e79381dc3a64a75$var$SyntheticEvent = $1e79381dc3a64a75$var$createSyntheticEvent($1e79381dc3a64a75$var$EventInterface), $1e79381dc3a64a75$var$UIEventInterface = $1e79381dc3a64a75$var$assign({}, $1e79381dc3a64a75$var$EventInterface, {
    view: 0,
    detail: 0
}), $1e79381dc3a64a75$var$SyntheticUIEvent = $1e79381dc3a64a75$var$createSyntheticEvent($1e79381dc3a64a75$var$UIEventInterface), $1e79381dc3a64a75$var$lastMovementX, $1e79381dc3a64a75$var$lastMovementY, $1e79381dc3a64a75$var$lastMouseEvent, $1e79381dc3a64a75$var$MouseEventInterface = $1e79381dc3a64a75$var$assign({}, $1e79381dc3a64a75$var$UIEventInterface, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $1e79381dc3a64a75$var$getEventModifierState,
    button: 0,
    buttons: 0,
    relatedTarget: function(event) {
        return void 0 === event.relatedTarget ? event.fromElement === event.srcElement ? event.toElement : event.fromElement : event.relatedTarget;
    },
    movementX: function(event) {
        if ("movementX" in event) return event.movementX;
        event !== $1e79381dc3a64a75$var$lastMouseEvent && ($1e79381dc3a64a75$var$lastMouseEvent && "mousemove" === event.type ? ($1e79381dc3a64a75$var$lastMovementX = event.screenX - $1e79381dc3a64a75$var$lastMouseEvent.screenX, $1e79381dc3a64a75$var$lastMovementY = event.screenY - $1e79381dc3a64a75$var$lastMouseEvent.screenY) : $1e79381dc3a64a75$var$lastMovementY = $1e79381dc3a64a75$var$lastMovementX = 0, $1e79381dc3a64a75$var$lastMouseEvent = event);
        return $1e79381dc3a64a75$var$lastMovementX;
    },
    movementY: function(event) {
        return "movementY" in event ? event.movementY : $1e79381dc3a64a75$var$lastMovementY;
    }
}), $1e79381dc3a64a75$var$SyntheticMouseEvent = $1e79381dc3a64a75$var$createSyntheticEvent($1e79381dc3a64a75$var$MouseEventInterface), $1e79381dc3a64a75$var$DragEventInterface = $1e79381dc3a64a75$var$assign({}, $1e79381dc3a64a75$var$MouseEventInterface, {
    dataTransfer: 0
}), $1e79381dc3a64a75$var$SyntheticDragEvent = $1e79381dc3a64a75$var$createSyntheticEvent($1e79381dc3a64a75$var$DragEventInterface), $1e79381dc3a64a75$var$FocusEventInterface = $1e79381dc3a64a75$var$assign({}, $1e79381dc3a64a75$var$UIEventInterface, {
    relatedTarget: 0
}), $1e79381dc3a64a75$var$SyntheticFocusEvent = $1e79381dc3a64a75$var$createSyntheticEvent($1e79381dc3a64a75$var$FocusEventInterface), $1e79381dc3a64a75$var$AnimationEventInterface = $1e79381dc3a64a75$var$assign({}, $1e79381dc3a64a75$var$EventInterface, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $1e79381dc3a64a75$var$SyntheticAnimationEvent = $1e79381dc3a64a75$var$createSyntheticEvent($1e79381dc3a64a75$var$AnimationEventInterface), $1e79381dc3a64a75$var$ClipboardEventInterface = $1e79381dc3a64a75$var$assign({}, $1e79381dc3a64a75$var$EventInterface, {
    clipboardData: function(event) {
        return "clipboardData" in event ? event.clipboardData : window.clipboardData;
    }
}), $1e79381dc3a64a75$var$SyntheticClipboardEvent = $1e79381dc3a64a75$var$createSyntheticEvent($1e79381dc3a64a75$var$ClipboardEventInterface), $1e79381dc3a64a75$var$CompositionEventInterface = $1e79381dc3a64a75$var$assign({}, $1e79381dc3a64a75$var$EventInterface, {
    data: 0
}), $1e79381dc3a64a75$var$SyntheticCompositionEvent = $1e79381dc3a64a75$var$createSyntheticEvent($1e79381dc3a64a75$var$CompositionEventInterface), $1e79381dc3a64a75$var$normalizeKey = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $1e79381dc3a64a75$var$translateToKey = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $1e79381dc3a64a75$var$modifierKeyToProp = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $1e79381dc3a64a75$var$modifierStateGetter(keyArg) {
    var nativeEvent = this.nativeEvent;
    return nativeEvent.getModifierState ? nativeEvent.getModifierState(keyArg) : (keyArg = $1e79381dc3a64a75$var$modifierKeyToProp[keyArg]) ? !!nativeEvent[keyArg] : !1;
}
function $1e79381dc3a64a75$var$getEventModifierState() {
    return $1e79381dc3a64a75$var$modifierStateGetter;
}
var $1e79381dc3a64a75$var$KeyboardEventInterface = $1e79381dc3a64a75$var$assign({}, $1e79381dc3a64a75$var$UIEventInterface, {
    key: function(nativeEvent) {
        if (nativeEvent.key) {
            var key = $1e79381dc3a64a75$var$normalizeKey[nativeEvent.key] || nativeEvent.key;
            if ("Unidentified" !== key) return key;
        }
        return "keypress" === nativeEvent.type ? (nativeEvent = $1e79381dc3a64a75$var$getEventCharCode(nativeEvent), 13 === nativeEvent ? "Enter" : String.fromCharCode(nativeEvent)) : "keydown" === nativeEvent.type || "keyup" === nativeEvent.type ? $1e79381dc3a64a75$var$translateToKey[nativeEvent.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $1e79381dc3a64a75$var$getEventModifierState,
    charCode: function(event) {
        return "keypress" === event.type ? $1e79381dc3a64a75$var$getEventCharCode(event) : 0;
    },
    keyCode: function(event) {
        return "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    },
    which: function(event) {
        return "keypress" === event.type ? $1e79381dc3a64a75$var$getEventCharCode(event) : "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    }
}), $1e79381dc3a64a75$var$SyntheticKeyboardEvent = $1e79381dc3a64a75$var$createSyntheticEvent($1e79381dc3a64a75$var$KeyboardEventInterface), $1e79381dc3a64a75$var$PointerEventInterface = $1e79381dc3a64a75$var$assign({}, $1e79381dc3a64a75$var$MouseEventInterface, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $1e79381dc3a64a75$var$SyntheticPointerEvent = $1e79381dc3a64a75$var$createSyntheticEvent($1e79381dc3a64a75$var$PointerEventInterface), $1e79381dc3a64a75$var$SubmitEventInterface = $1e79381dc3a64a75$var$assign({}, $1e79381dc3a64a75$var$EventInterface, {
    submitter: 0
}), $1e79381dc3a64a75$var$SyntheticSubmitEvent = $1e79381dc3a64a75$var$createSyntheticEvent($1e79381dc3a64a75$var$SubmitEventInterface), $1e79381dc3a64a75$var$TouchEventInterface = $1e79381dc3a64a75$var$assign({}, $1e79381dc3a64a75$var$UIEventInterface, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $1e79381dc3a64a75$var$getEventModifierState
}), $1e79381dc3a64a75$var$SyntheticTouchEvent = $1e79381dc3a64a75$var$createSyntheticEvent($1e79381dc3a64a75$var$TouchEventInterface), $1e79381dc3a64a75$var$TransitionEventInterface = $1e79381dc3a64a75$var$assign({}, $1e79381dc3a64a75$var$EventInterface, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $1e79381dc3a64a75$var$SyntheticTransitionEvent = $1e79381dc3a64a75$var$createSyntheticEvent($1e79381dc3a64a75$var$TransitionEventInterface), $1e79381dc3a64a75$var$WheelEventInterface = $1e79381dc3a64a75$var$assign({}, $1e79381dc3a64a75$var$MouseEventInterface, {
    deltaX: function(event) {
        return "deltaX" in event ? event.deltaX : "wheelDeltaX" in event ? -event.wheelDeltaX : 0;
    },
    deltaY: function(event) {
        return "deltaY" in event ? event.deltaY : "wheelDeltaY" in event ? -event.wheelDeltaY : "wheelDelta" in event ? -event.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $1e79381dc3a64a75$var$SyntheticWheelEvent = $1e79381dc3a64a75$var$createSyntheticEvent($1e79381dc3a64a75$var$WheelEventInterface), $1e79381dc3a64a75$var$ToggleEventInterface = $1e79381dc3a64a75$var$assign({}, $1e79381dc3a64a75$var$EventInterface, {
    newState: 0,
    oldState: 0,
    source: 0
}), $1e79381dc3a64a75$var$SyntheticToggleEvent = $1e79381dc3a64a75$var$createSyntheticEvent($1e79381dc3a64a75$var$ToggleEventInterface), $1e79381dc3a64a75$var$END_KEYCODES = [
    9,
    13,
    27,
    32
], $1e79381dc3a64a75$var$canUseCompositionEvent = $1e79381dc3a64a75$var$canUseDOM && "CompositionEvent" in window, $1e79381dc3a64a75$var$documentMode = null;
$1e79381dc3a64a75$var$canUseDOM && "documentMode" in document && ($1e79381dc3a64a75$var$documentMode = document.documentMode);
var $1e79381dc3a64a75$var$canUseTextInputEvent = $1e79381dc3a64a75$var$canUseDOM && "TextEvent" in window && !$1e79381dc3a64a75$var$documentMode, $1e79381dc3a64a75$var$useFallbackCompositionData = $1e79381dc3a64a75$var$canUseDOM && (!$1e79381dc3a64a75$var$canUseCompositionEvent || $1e79381dc3a64a75$var$documentMode && 8 < $1e79381dc3a64a75$var$documentMode && 11 >= $1e79381dc3a64a75$var$documentMode), $1e79381dc3a64a75$var$SPACEBAR_CHAR = String.fromCharCode(32), $1e79381dc3a64a75$var$hasSpaceKeypress = !1;
function $1e79381dc3a64a75$var$isFallbackCompositionEnd(domEventName, nativeEvent) {
    switch(domEventName){
        case "keyup":
            return -1 !== $1e79381dc3a64a75$var$END_KEYCODES.indexOf(nativeEvent.keyCode);
        case "keydown":
            return 229 !== nativeEvent.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $1e79381dc3a64a75$var$getDataFromCustomEvent(nativeEvent) {
    nativeEvent = nativeEvent.detail;
    return "object" === typeof nativeEvent && "data" in nativeEvent ? nativeEvent.data : null;
}
var $1e79381dc3a64a75$var$isComposing = !1;
function $1e79381dc3a64a75$var$getNativeBeforeInputChars(domEventName, nativeEvent) {
    switch(domEventName){
        case "compositionend":
            return $1e79381dc3a64a75$var$getDataFromCustomEvent(nativeEvent);
        case "keypress":
            if (32 !== nativeEvent.which) return null;
            $1e79381dc3a64a75$var$hasSpaceKeypress = !0;
            return $1e79381dc3a64a75$var$SPACEBAR_CHAR;
        case "textInput":
            return domEventName = nativeEvent.data, domEventName === $1e79381dc3a64a75$var$SPACEBAR_CHAR && $1e79381dc3a64a75$var$hasSpaceKeypress ? null : domEventName;
        default:
            return null;
    }
}
function $1e79381dc3a64a75$var$getFallbackBeforeInputChars(domEventName, nativeEvent) {
    if ($1e79381dc3a64a75$var$isComposing) return "compositionend" === domEventName || !$1e79381dc3a64a75$var$canUseCompositionEvent && $1e79381dc3a64a75$var$isFallbackCompositionEnd(domEventName, nativeEvent) ? (domEventName = $1e79381dc3a64a75$var$getData(), $1e79381dc3a64a75$var$fallbackText = $1e79381dc3a64a75$var$startText = $1e79381dc3a64a75$var$root = null, $1e79381dc3a64a75$var$isComposing = !1, domEventName) : null;
    switch(domEventName){
        case "paste":
            return null;
        case "keypress":
            if (!(nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) || nativeEvent.ctrlKey && nativeEvent.altKey) {
                if (nativeEvent.char && 1 < nativeEvent.char.length) return nativeEvent.char;
                if (nativeEvent.which) return String.fromCharCode(nativeEvent.which);
            }
            return null;
        case "compositionend":
            return $1e79381dc3a64a75$var$useFallbackCompositionData && "ko" !== nativeEvent.locale ? null : nativeEvent.data;
        default:
            return null;
    }
}
var $1e79381dc3a64a75$var$supportedInputTypes = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $1e79381dc3a64a75$var$isTextInputElement(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return "input" === nodeName ? !!$1e79381dc3a64a75$var$supportedInputTypes[elem.type] : "textarea" === nodeName ? !0 : !1;
}
function $1e79381dc3a64a75$var$createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, target) {
    $1e79381dc3a64a75$var$restoreTarget ? $1e79381dc3a64a75$var$restoreQueue ? $1e79381dc3a64a75$var$restoreQueue.push(target) : $1e79381dc3a64a75$var$restoreQueue = [
        target
    ] : $1e79381dc3a64a75$var$restoreTarget = target;
    inst = $1e79381dc3a64a75$var$accumulateTwoPhaseListeners(inst, "onChange");
    0 < inst.length && (nativeEvent = new $1e79381dc3a64a75$var$SyntheticEvent("onChange", "change", null, nativeEvent, target), dispatchQueue.push({
        event: nativeEvent,
        listeners: inst
    }));
}
var $1e79381dc3a64a75$var$activeElement$1 = null, $1e79381dc3a64a75$var$activeElementInst$1 = null;
function $1e79381dc3a64a75$var$runEventInBatch(dispatchQueue) {
    $1e79381dc3a64a75$var$processDispatchQueue(dispatchQueue, 0);
}
function $1e79381dc3a64a75$var$getInstIfValueChanged(targetInst) {
    var targetNode = $1e79381dc3a64a75$var$getNodeFromInstance(targetInst);
    if ($1e79381dc3a64a75$var$updateValueIfChanged(targetNode)) return targetInst;
}
function $1e79381dc3a64a75$var$getTargetInstForChangeEvent(domEventName, targetInst) {
    if ("change" === domEventName) return targetInst;
}
var $1e79381dc3a64a75$var$isInputEventSupported = !1;
if ($1e79381dc3a64a75$var$canUseDOM) {
    var $1e79381dc3a64a75$var$JSCompiler_inline_result$jscomp$318;
    if ($1e79381dc3a64a75$var$canUseDOM) {
        var $1e79381dc3a64a75$var$isSupported$jscomp$inline_474 = "oninput" in document;
        if (!$1e79381dc3a64a75$var$isSupported$jscomp$inline_474) {
            var $1e79381dc3a64a75$var$element$jscomp$inline_475 = document.createElement("div");
            $1e79381dc3a64a75$var$element$jscomp$inline_475.setAttribute("oninput", "return;");
            $1e79381dc3a64a75$var$isSupported$jscomp$inline_474 = "function" === typeof $1e79381dc3a64a75$var$element$jscomp$inline_475.oninput;
        }
        $1e79381dc3a64a75$var$JSCompiler_inline_result$jscomp$318 = $1e79381dc3a64a75$var$isSupported$jscomp$inline_474;
    } else $1e79381dc3a64a75$var$JSCompiler_inline_result$jscomp$318 = !1;
    $1e79381dc3a64a75$var$isInputEventSupported = $1e79381dc3a64a75$var$JSCompiler_inline_result$jscomp$318 && (!document.documentMode || 9 < document.documentMode);
}
function $1e79381dc3a64a75$var$stopWatchingForValueChange() {
    $1e79381dc3a64a75$var$activeElement$1 && ($1e79381dc3a64a75$var$activeElement$1.detachEvent("onpropertychange", $1e79381dc3a64a75$var$handlePropertyChange), $1e79381dc3a64a75$var$activeElementInst$1 = $1e79381dc3a64a75$var$activeElement$1 = null);
}
function $1e79381dc3a64a75$var$handlePropertyChange(nativeEvent) {
    if ("value" === nativeEvent.propertyName && $1e79381dc3a64a75$var$getInstIfValueChanged($1e79381dc3a64a75$var$activeElementInst$1)) {
        var dispatchQueue = [];
        $1e79381dc3a64a75$var$createAndAccumulateChangeEvent(dispatchQueue, $1e79381dc3a64a75$var$activeElementInst$1, nativeEvent, $1e79381dc3a64a75$var$getEventTarget(nativeEvent));
        $1e79381dc3a64a75$var$batchedUpdates$1($1e79381dc3a64a75$var$runEventInBatch, dispatchQueue);
    }
}
function $1e79381dc3a64a75$var$handleEventsForInputEventPolyfill(domEventName, target, targetInst) {
    "focusin" === domEventName ? ($1e79381dc3a64a75$var$stopWatchingForValueChange(), $1e79381dc3a64a75$var$activeElement$1 = target, $1e79381dc3a64a75$var$activeElementInst$1 = targetInst, $1e79381dc3a64a75$var$activeElement$1.attachEvent("onpropertychange", $1e79381dc3a64a75$var$handlePropertyChange)) : "focusout" === domEventName && $1e79381dc3a64a75$var$stopWatchingForValueChange();
}
function $1e79381dc3a64a75$var$getTargetInstForInputEventPolyfill(domEventName) {
    if ("selectionchange" === domEventName || "keyup" === domEventName || "keydown" === domEventName) return $1e79381dc3a64a75$var$getInstIfValueChanged($1e79381dc3a64a75$var$activeElementInst$1);
}
function $1e79381dc3a64a75$var$getTargetInstForClickEvent(domEventName, targetInst) {
    if ("click" === domEventName) return $1e79381dc3a64a75$var$getInstIfValueChanged(targetInst);
}
function $1e79381dc3a64a75$var$getTargetInstForInputOrChangeEvent(domEventName, targetInst) {
    if ("input" === domEventName || "change" === domEventName) return $1e79381dc3a64a75$var$getInstIfValueChanged(targetInst);
}
function $1e79381dc3a64a75$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $1e79381dc3a64a75$var$objectIs = "function" === typeof Object.is ? Object.is : $1e79381dc3a64a75$var$is;
function $1e79381dc3a64a75$var$shallowEqual(objA, objB) {
    if ($1e79381dc3a64a75$var$objectIs(objA, objB)) return !0;
    if ("object" !== typeof objA || null === objA || "object" !== typeof objB || null === objB) return !1;
    var keysA = Object.keys(objA), keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return !1;
    for(keysB = 0; keysB < keysA.length; keysB++){
        var currentKey = keysA[keysB];
        if (!$1e79381dc3a64a75$var$hasOwnProperty.call(objB, currentKey) || !$1e79381dc3a64a75$var$objectIs(objA[currentKey], objB[currentKey])) return !1;
    }
    return !0;
}
function $1e79381dc3a64a75$var$getActiveElement(doc) {
    doc = doc || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof doc) return null;
    try {
        return doc.activeElement || doc.body;
    } catch (e$20) {
        return doc.body;
    }
}
function $1e79381dc3a64a75$var$getLeafNode(node) {
    for(; node && node.firstChild;)node = node.firstChild;
    return node;
}
function $1e79381dc3a64a75$var$getNodeForCharacterOffset(root, offset) {
    var node = $1e79381dc3a64a75$var$getLeafNode(root);
    root = 0;
    for(var nodeEnd; node;){
        if (3 === node.nodeType) {
            nodeEnd = root + node.textContent.length;
            if (root <= offset && nodeEnd >= offset) return {
                node: node,
                offset: offset - root
            };
            root = nodeEnd;
        }
        a: {
            for(; node;){
                if (node.nextSibling) {
                    node = node.nextSibling;
                    break a;
                }
                node = node.parentNode;
            }
            node = void 0;
        }
        node = $1e79381dc3a64a75$var$getLeafNode(node);
    }
}
function $1e79381dc3a64a75$var$containsNode(outerNode, innerNode) {
    return outerNode && innerNode ? outerNode === innerNode ? !0 : outerNode && 3 === outerNode.nodeType ? !1 : innerNode && 3 === innerNode.nodeType ? $1e79381dc3a64a75$var$containsNode(outerNode, innerNode.parentNode) : "contains" in outerNode ? outerNode.contains(innerNode) : outerNode.compareDocumentPosition ? !!(outerNode.compareDocumentPosition(innerNode) & 16) : !1 : !1;
}
function $1e79381dc3a64a75$var$getActiveElementDeep(containerInfo) {
    containerInfo = null != containerInfo && null != containerInfo.ownerDocument && null != containerInfo.ownerDocument.defaultView ? containerInfo.ownerDocument.defaultView : window;
    for(var element = $1e79381dc3a64a75$var$getActiveElement(containerInfo.document); element instanceof containerInfo.HTMLIFrameElement;){
        try {
            var JSCompiler_inline_result = "string" === typeof element.contentWindow.location.href;
        } catch (err) {
            JSCompiler_inline_result = !1;
        }
        if (JSCompiler_inline_result) containerInfo = element.contentWindow;
        else break;
        element = $1e79381dc3a64a75$var$getActiveElement(containerInfo.document);
    }
    return element;
}
function $1e79381dc3a64a75$var$hasSelectionCapabilities(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return nodeName && ("input" === nodeName && ("text" === elem.type || "search" === elem.type || "tel" === elem.type || "url" === elem.type || "password" === elem.type) || "textarea" === nodeName || "true" === elem.contentEditable);
}
var $1e79381dc3a64a75$var$skipSelectionChangeEvent = $1e79381dc3a64a75$var$canUseDOM && "documentMode" in document && 11 >= document.documentMode, $1e79381dc3a64a75$var$activeElement = null, $1e79381dc3a64a75$var$activeElementInst = null, $1e79381dc3a64a75$var$lastSelection = null, $1e79381dc3a64a75$var$mouseDown = !1;
function $1e79381dc3a64a75$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget) {
    var doc = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget.document : 9 === nativeEventTarget.nodeType ? nativeEventTarget : nativeEventTarget.ownerDocument;
    $1e79381dc3a64a75$var$mouseDown || null == $1e79381dc3a64a75$var$activeElement || $1e79381dc3a64a75$var$activeElement !== $1e79381dc3a64a75$var$getActiveElement(doc) || (doc = $1e79381dc3a64a75$var$activeElement, "selectionStart" in doc && $1e79381dc3a64a75$var$hasSelectionCapabilities(doc) ? doc = {
        start: doc.selectionStart,
        end: doc.selectionEnd
    } : (doc = (doc.ownerDocument && doc.ownerDocument.defaultView || window).getSelection(), doc = {
        anchorNode: doc.anchorNode,
        anchorOffset: doc.anchorOffset,
        focusNode: doc.focusNode,
        focusOffset: doc.focusOffset
    }), $1e79381dc3a64a75$var$lastSelection && $1e79381dc3a64a75$var$shallowEqual($1e79381dc3a64a75$var$lastSelection, doc) || ($1e79381dc3a64a75$var$lastSelection = doc, doc = $1e79381dc3a64a75$var$accumulateTwoPhaseListeners($1e79381dc3a64a75$var$activeElementInst, "onSelect"), 0 < doc.length && (nativeEvent = new $1e79381dc3a64a75$var$SyntheticEvent("onSelect", "select", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
        event: nativeEvent,
        listeners: doc
    }), nativeEvent.target = $1e79381dc3a64a75$var$activeElement)));
}
function $1e79381dc3a64a75$var$makePrefixMap(styleProp, eventName) {
    var prefixes = {};
    prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
    prefixes["Webkit" + styleProp] = "webkit" + eventName;
    prefixes["Moz" + styleProp] = "moz" + eventName;
    return prefixes;
}
var $1e79381dc3a64a75$var$vendorPrefixes = {
    animationend: $1e79381dc3a64a75$var$makePrefixMap("Animation", "AnimationEnd"),
    animationiteration: $1e79381dc3a64a75$var$makePrefixMap("Animation", "AnimationIteration"),
    animationstart: $1e79381dc3a64a75$var$makePrefixMap("Animation", "AnimationStart"),
    transitionrun: $1e79381dc3a64a75$var$makePrefixMap("Transition", "TransitionRun"),
    transitionstart: $1e79381dc3a64a75$var$makePrefixMap("Transition", "TransitionStart"),
    transitioncancel: $1e79381dc3a64a75$var$makePrefixMap("Transition", "TransitionCancel"),
    transitionend: $1e79381dc3a64a75$var$makePrefixMap("Transition", "TransitionEnd")
}, $1e79381dc3a64a75$var$prefixedEventNames = {}, $1e79381dc3a64a75$var$style = {};
$1e79381dc3a64a75$var$canUseDOM && ($1e79381dc3a64a75$var$style = document.createElement("div").style, "AnimationEvent" in window || (delete $1e79381dc3a64a75$var$vendorPrefixes.animationend.animation, delete $1e79381dc3a64a75$var$vendorPrefixes.animationiteration.animation, delete $1e79381dc3a64a75$var$vendorPrefixes.animationstart.animation), "TransitionEvent" in window || delete $1e79381dc3a64a75$var$vendorPrefixes.transitionend.transition);
function $1e79381dc3a64a75$var$getVendorPrefixedEventName(eventName) {
    if ($1e79381dc3a64a75$var$prefixedEventNames[eventName]) return $1e79381dc3a64a75$var$prefixedEventNames[eventName];
    if (!$1e79381dc3a64a75$var$vendorPrefixes[eventName]) return eventName;
    var prefixMap = $1e79381dc3a64a75$var$vendorPrefixes[eventName], styleProp;
    for(styleProp in prefixMap)if (prefixMap.hasOwnProperty(styleProp) && styleProp in $1e79381dc3a64a75$var$style) return $1e79381dc3a64a75$var$prefixedEventNames[eventName] = prefixMap[styleProp];
    return eventName;
}
var $1e79381dc3a64a75$var$ANIMATION_END = $1e79381dc3a64a75$var$getVendorPrefixedEventName("animationend"), $1e79381dc3a64a75$var$ANIMATION_ITERATION = $1e79381dc3a64a75$var$getVendorPrefixedEventName("animationiteration"), $1e79381dc3a64a75$var$ANIMATION_START = $1e79381dc3a64a75$var$getVendorPrefixedEventName("animationstart"), $1e79381dc3a64a75$var$TRANSITION_RUN = $1e79381dc3a64a75$var$getVendorPrefixedEventName("transitionrun"), $1e79381dc3a64a75$var$TRANSITION_START = $1e79381dc3a64a75$var$getVendorPrefixedEventName("transitionstart"), $1e79381dc3a64a75$var$TRANSITION_CANCEL = $1e79381dc3a64a75$var$getVendorPrefixedEventName("transitioncancel"), $1e79381dc3a64a75$var$TRANSITION_END = $1e79381dc3a64a75$var$getVendorPrefixedEventName("transitionend"), $1e79381dc3a64a75$var$topLevelEventsToReactNames = new Map(), $1e79381dc3a64a75$var$simpleEventPluginEvents = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error fullscreenChange fullscreenError gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
$1e79381dc3a64a75$var$simpleEventPluginEvents.push("scrollEnd");
function $1e79381dc3a64a75$var$registerSimpleEvent(domEventName, reactName) {
    $1e79381dc3a64a75$var$topLevelEventsToReactNames.set(domEventName, reactName);
    $1e79381dc3a64a75$var$registerTwoPhaseEvent(reactName, [
        domEventName
    ]);
}
var $1e79381dc3a64a75$var$globalClientIdCounter$1 = 0;
function $1e79381dc3a64a75$var$getViewTransitionName(props, instance) {
    if (null != props.name && "auto" !== props.name) return props.name;
    if (null !== instance.autoName) return instance.autoName;
    props = $1e79381dc3a64a75$var$pendingEffectsRoot.identifierPrefix;
    var globalClientId = $1e79381dc3a64a75$var$globalClientIdCounter$1++;
    props = "_" + props + "t_" + globalClientId.toString(32) + "_";
    return instance.autoName = props;
}
function $1e79381dc3a64a75$var$getClassNameByType(classByType) {
    if (null == classByType || "string" === typeof classByType) return classByType;
    var className = null, activeTypes = $1e79381dc3a64a75$var$pendingTransitionTypes;
    if (null !== activeTypes) for(var i = 0; i < activeTypes.length; i++){
        var match = classByType[activeTypes[i]];
        if (null != match) {
            if ("none" === match) return "none";
            className = null == className ? match : className + (" " + match);
        }
    }
    return null == className ? classByType.default : className;
}
function $1e79381dc3a64a75$var$getViewTransitionClassName(defaultClass, eventClass) {
    defaultClass = $1e79381dc3a64a75$var$getClassNameByType(defaultClass);
    eventClass = $1e79381dc3a64a75$var$getClassNameByType(eventClass);
    return null == eventClass ? "auto" === defaultClass ? null : defaultClass : "auto" === eventClass ? null : eventClass;
}
var $1e79381dc3a64a75$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
}, $1e79381dc3a64a75$var$concurrentQueues = [], $1e79381dc3a64a75$var$concurrentQueuesIndex = 0, $1e79381dc3a64a75$var$concurrentlyUpdatedLanes = 0;
function $1e79381dc3a64a75$var$finishQueueingConcurrentUpdates() {
    for(var endIndex = $1e79381dc3a64a75$var$concurrentQueuesIndex, i = $1e79381dc3a64a75$var$concurrentlyUpdatedLanes = $1e79381dc3a64a75$var$concurrentQueuesIndex = 0; i < endIndex;){
        var fiber = $1e79381dc3a64a75$var$concurrentQueues[i];
        $1e79381dc3a64a75$var$concurrentQueues[i++] = null;
        var queue = $1e79381dc3a64a75$var$concurrentQueues[i];
        $1e79381dc3a64a75$var$concurrentQueues[i++] = null;
        var update = $1e79381dc3a64a75$var$concurrentQueues[i];
        $1e79381dc3a64a75$var$concurrentQueues[i++] = null;
        var lane = $1e79381dc3a64a75$var$concurrentQueues[i];
        $1e79381dc3a64a75$var$concurrentQueues[i++] = null;
        if (null !== queue && null !== update) {
            var pending = queue.pending;
            null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
            queue.pending = update;
        }
        0 !== lane && $1e79381dc3a64a75$var$markUpdateLaneFromFiberToRoot(fiber, update, lane);
    }
}
function $1e79381dc3a64a75$var$enqueueUpdate$1(fiber, queue, update, lane) {
    $1e79381dc3a64a75$var$concurrentQueues[$1e79381dc3a64a75$var$concurrentQueuesIndex++] = fiber;
    $1e79381dc3a64a75$var$concurrentQueues[$1e79381dc3a64a75$var$concurrentQueuesIndex++] = queue;
    $1e79381dc3a64a75$var$concurrentQueues[$1e79381dc3a64a75$var$concurrentQueuesIndex++] = update;
    $1e79381dc3a64a75$var$concurrentQueues[$1e79381dc3a64a75$var$concurrentQueuesIndex++] = lane;
    $1e79381dc3a64a75$var$concurrentlyUpdatedLanes |= lane;
    fiber.lanes |= lane;
    fiber = fiber.alternate;
    null !== fiber && (fiber.lanes |= lane);
}
function $1e79381dc3a64a75$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane) {
    $1e79381dc3a64a75$var$enqueueUpdate$1(fiber, queue, update, lane);
    return $1e79381dc3a64a75$var$getRootForUpdatedFiber(fiber);
}
function $1e79381dc3a64a75$var$enqueueConcurrentRenderForLane(fiber, lane) {
    $1e79381dc3a64a75$var$enqueueUpdate$1(fiber, null, null, lane);
    return $1e79381dc3a64a75$var$getRootForUpdatedFiber(fiber);
}
function $1e79381dc3a64a75$var$markUpdateLaneFromFiberToRoot(sourceFiber, update, lane) {
    sourceFiber.lanes |= lane;
    var alternate = sourceFiber.alternate;
    null !== alternate && (alternate.lanes |= lane);
    for(var isHidden = !1, parent = sourceFiber.return; null !== parent;)parent.childLanes |= lane, alternate = parent.alternate, null !== alternate && (alternate.childLanes |= lane), 22 === parent.tag && (sourceFiber = parent.stateNode, null === sourceFiber || sourceFiber._visibility & 1 || (isHidden = !0)), sourceFiber = parent, parent = parent.return;
    return 3 === sourceFiber.tag ? (parent = sourceFiber.stateNode, isHidden && null !== update && (isHidden = 31 - $1e79381dc3a64a75$var$clz32(lane), sourceFiber = parent.hiddenUpdates, alternate = sourceFiber[isHidden], null === alternate ? sourceFiber[isHidden] = [
        update
    ] : alternate.push(update), update.lane = lane | 536870912), parent) : null;
}
function $1e79381dc3a64a75$var$getRootForUpdatedFiber(sourceFiber) {
    if (50 < $1e79381dc3a64a75$var$nestedUpdateCount) throw $1e79381dc3a64a75$var$nestedUpdateCount = 0, $1e79381dc3a64a75$var$rootWithNestedUpdates = null, Error($1e79381dc3a64a75$var$formatProdErrorMessage(185));
    for(var parent = sourceFiber.return; null !== parent;)sourceFiber = parent, parent = sourceFiber.return;
    return 3 === sourceFiber.tag ? sourceFiber.stateNode : null;
}
var $1e79381dc3a64a75$var$emptyContextObject = {};
function $1e79381dc3a64a75$var$FiberNode(tag, pendingProps, key, mode) {
    this.tag = tag;
    this.key = key;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.refCleanup = this.ref = null;
    this.pendingProps = pendingProps;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = mode;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $1e79381dc3a64a75$var$createFiberImplClass(tag, pendingProps, key, mode) {
    return new $1e79381dc3a64a75$var$FiberNode(tag, pendingProps, key, mode);
}
function $1e79381dc3a64a75$var$shouldConstruct(Component) {
    Component = Component.prototype;
    return !(!Component || !Component.isReactComponent);
}
function $1e79381dc3a64a75$var$createWorkInProgress(current, pendingProps) {
    var workInProgress = current.alternate;
    null === workInProgress ? (workInProgress = $1e79381dc3a64a75$var$createFiberImplClass(current.tag, pendingProps, current.key, current.mode), workInProgress.elementType = current.elementType, workInProgress.type = current.type, workInProgress.stateNode = current.stateNode, workInProgress.alternate = current, current.alternate = workInProgress) : (workInProgress.pendingProps = pendingProps, workInProgress.type = current.type, workInProgress.flags = 0, workInProgress.subtreeFlags = 0, workInProgress.deletions = null);
    workInProgress.flags = current.flags & 1206910976;
    workInProgress.childLanes = current.childLanes;
    workInProgress.lanes = current.lanes;
    workInProgress.child = current.child;
    workInProgress.memoizedProps = current.memoizedProps;
    workInProgress.memoizedState = current.memoizedState;
    workInProgress.updateQueue = current.updateQueue;
    pendingProps = current.dependencies;
    workInProgress.dependencies = null === pendingProps ? null : {
        lanes: pendingProps.lanes,
        firstContext: pendingProps.firstContext
    };
    workInProgress.sibling = current.sibling;
    workInProgress.index = current.index;
    workInProgress.ref = current.ref;
    workInProgress.refCleanup = current.refCleanup;
    return workInProgress;
}
function $1e79381dc3a64a75$var$resetWorkInProgress(workInProgress, renderLanes) {
    workInProgress.flags &= 1206910978;
    var current = workInProgress.alternate;
    null === current ? (workInProgress.childLanes = 0, workInProgress.lanes = renderLanes, workInProgress.child = null, workInProgress.subtreeFlags = 0, workInProgress.memoizedProps = null, workInProgress.memoizedState = null, workInProgress.updateQueue = null, workInProgress.dependencies = null, workInProgress.stateNode = null) : (workInProgress.childLanes = current.childLanes, workInProgress.lanes = current.lanes, workInProgress.child = current.child, workInProgress.subtreeFlags = 0, workInProgress.deletions = null, workInProgress.memoizedProps = current.memoizedProps, workInProgress.memoizedState = current.memoizedState, workInProgress.updateQueue = current.updateQueue, workInProgress.type = current.type, renderLanes = current.dependencies, workInProgress.dependencies = null === renderLanes ? null : {
        lanes: renderLanes.lanes,
        firstContext: renderLanes.firstContext
    });
    return workInProgress;
}
function $1e79381dc3a64a75$var$createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes) {
    var fiberTag = 0;
    owner = type;
    if ("function" === typeof owner) $1e79381dc3a64a75$var$shouldConstruct(owner) && (fiberTag = 1);
    else if ("string" === typeof owner) fiberTag = $1e79381dc3a64a75$var$isHostHoistableType(type, pendingProps, $1e79381dc3a64a75$var$contextStackCursor.current) ? 26 : "html" === type || "head" === type || "body" === type ? 27 : 5;
    else a: switch(owner){
        case $1e79381dc3a64a75$var$REACT_ACTIVITY_TYPE:
            return type = $1e79381dc3a64a75$var$createFiberImplClass(31, pendingProps, key, mode), type.elementType = $1e79381dc3a64a75$var$REACT_ACTIVITY_TYPE, type.lanes = lanes, type;
        case $1e79381dc3a64a75$var$REACT_FRAGMENT_TYPE:
            return $1e79381dc3a64a75$var$createFiberFromFragment(pendingProps.children, mode, lanes, key);
        case $1e79381dc3a64a75$var$REACT_STRICT_MODE_TYPE:
            fiberTag = 8;
            mode |= 24;
            break;
        case $1e79381dc3a64a75$var$REACT_PROFILER_TYPE:
            return type = $1e79381dc3a64a75$var$createFiberImplClass(12, pendingProps, key, mode | 2), type.elementType = $1e79381dc3a64a75$var$REACT_PROFILER_TYPE, type.lanes = lanes, type;
        case $1e79381dc3a64a75$var$REACT_SUSPENSE_TYPE:
            return type = $1e79381dc3a64a75$var$createFiberImplClass(13, pendingProps, key, mode), type.elementType = $1e79381dc3a64a75$var$REACT_SUSPENSE_TYPE, type.lanes = lanes, type;
        case $1e79381dc3a64a75$var$REACT_SUSPENSE_LIST_TYPE:
            return type = $1e79381dc3a64a75$var$createFiberImplClass(19, pendingProps, key, mode), type.elementType = $1e79381dc3a64a75$var$REACT_SUSPENSE_LIST_TYPE, type.lanes = lanes, type;
        case $1e79381dc3a64a75$var$REACT_LEGACY_HIDDEN_TYPE:
        case $1e79381dc3a64a75$var$REACT_VIEW_TRANSITION_TYPE:
            return type = mode | 32, type = $1e79381dc3a64a75$var$createFiberImplClass(30, pendingProps, key, type), type.elementType = $1e79381dc3a64a75$var$REACT_VIEW_TRANSITION_TYPE, type.lanes = lanes, type.stateNode = {
                autoName: null,
                paired: null,
                clones: null,
                ref: null
            }, type;
        default:
            if ("object" === typeof owner && null !== owner) switch(owner.$$typeof){
                case $1e79381dc3a64a75$var$REACT_CONTEXT_TYPE:
                    fiberTag = 10;
                    break a;
                case $1e79381dc3a64a75$var$REACT_CONSUMER_TYPE:
                    fiberTag = 9;
                    break a;
                case $1e79381dc3a64a75$var$REACT_FORWARD_REF_TYPE:
                    fiberTag = 11;
                    break a;
                case $1e79381dc3a64a75$var$REACT_MEMO_TYPE:
                    fiberTag = 14;
                    break a;
                case $1e79381dc3a64a75$var$REACT_LAZY_TYPE:
                    fiberTag = 16;
                    owner = null;
                    break a;
            }
            fiberTag = 29;
            pendingProps = Error($1e79381dc3a64a75$var$formatProdErrorMessage(130, null === type ? "null" : typeof type, ""));
            owner = null;
    }
    key = $1e79381dc3a64a75$var$createFiberImplClass(fiberTag, pendingProps, key, mode);
    key.elementType = type;
    key.type = owner;
    key.lanes = lanes;
    return key;
}
function $1e79381dc3a64a75$var$createFiberFromFragment(elements, mode, lanes, key) {
    elements = $1e79381dc3a64a75$var$createFiberImplClass(7, elements, key, mode);
    elements.lanes = lanes;
    return elements;
}
function $1e79381dc3a64a75$var$createFiberFromText(content, mode, lanes) {
    content = $1e79381dc3a64a75$var$createFiberImplClass(6, content, null, mode);
    content.lanes = lanes;
    return content;
}
function $1e79381dc3a64a75$var$createFiberFromDehydratedFragment(dehydratedNode) {
    var fiber = $1e79381dc3a64a75$var$createFiberImplClass(18, null, null, 0);
    fiber.stateNode = dehydratedNode;
    return fiber;
}
function $1e79381dc3a64a75$var$createFiberFromPortal(portal, mode, lanes) {
    mode = $1e79381dc3a64a75$var$createFiberImplClass(4, null !== portal.children ? portal.children : [], portal.key, mode);
    mode.lanes = lanes;
    mode.stateNode = {
        containerInfo: portal.containerInfo,
        pendingChildren: null,
        implementation: portal.implementation
    };
    return mode;
}
var $1e79381dc3a64a75$var$CapturedStacks = new WeakMap();
function $1e79381dc3a64a75$var$createCapturedValueAtFiber(value, source) {
    if ("object" === typeof value && null !== value) {
        var existing = $1e79381dc3a64a75$var$CapturedStacks.get(value);
        if (void 0 !== existing) return existing;
        source = {
            value: value,
            source: source,
            stack: $1e79381dc3a64a75$var$getStackByFiberInDevAndProd(source)
        };
        $1e79381dc3a64a75$var$CapturedStacks.set(value, source);
        return source;
    }
    return {
        value: value,
        source: source,
        stack: $1e79381dc3a64a75$var$getStackByFiberInDevAndProd(source)
    };
}
var $1e79381dc3a64a75$var$forkStack = [], $1e79381dc3a64a75$var$forkStackIndex = 0, $1e79381dc3a64a75$var$treeForkProvider = null, $1e79381dc3a64a75$var$treeForkCount = 0, $1e79381dc3a64a75$var$idStack = [], $1e79381dc3a64a75$var$idStackIndex = 0, $1e79381dc3a64a75$var$treeContextProvider = null, $1e79381dc3a64a75$var$treeContextId = 1, $1e79381dc3a64a75$var$treeContextOverflow = "";
function $1e79381dc3a64a75$var$pushTreeFork(workInProgress, totalChildren) {
    $1e79381dc3a64a75$var$forkStack[$1e79381dc3a64a75$var$forkStackIndex++] = $1e79381dc3a64a75$var$treeForkCount;
    $1e79381dc3a64a75$var$forkStack[$1e79381dc3a64a75$var$forkStackIndex++] = $1e79381dc3a64a75$var$treeForkProvider;
    $1e79381dc3a64a75$var$treeForkProvider = workInProgress;
    $1e79381dc3a64a75$var$treeForkCount = totalChildren;
}
function $1e79381dc3a64a75$var$pushTreeId(workInProgress, totalChildren, index) {
    $1e79381dc3a64a75$var$idStack[$1e79381dc3a64a75$var$idStackIndex++] = $1e79381dc3a64a75$var$treeContextId;
    $1e79381dc3a64a75$var$idStack[$1e79381dc3a64a75$var$idStackIndex++] = $1e79381dc3a64a75$var$treeContextOverflow;
    $1e79381dc3a64a75$var$idStack[$1e79381dc3a64a75$var$idStackIndex++] = $1e79381dc3a64a75$var$treeContextProvider;
    $1e79381dc3a64a75$var$treeContextProvider = workInProgress;
    var baseIdWithLeadingBit = $1e79381dc3a64a75$var$treeContextId;
    workInProgress = $1e79381dc3a64a75$var$treeContextOverflow;
    var baseLength = 32 - $1e79381dc3a64a75$var$clz32(baseIdWithLeadingBit) - 1;
    baseIdWithLeadingBit &= ~(1 << baseLength);
    index += 1;
    var length = 32 - $1e79381dc3a64a75$var$clz32(totalChildren) + baseLength;
    if (30 < length) {
        var numberOfOverflowBits = baseLength - baseLength % 5;
        length = (baseIdWithLeadingBit & (1 << numberOfOverflowBits) - 1).toString(32);
        baseIdWithLeadingBit >>= numberOfOverflowBits;
        baseLength -= numberOfOverflowBits;
        $1e79381dc3a64a75$var$treeContextId = 1 << 32 - $1e79381dc3a64a75$var$clz32(totalChildren) + baseLength | index << baseLength | baseIdWithLeadingBit;
        $1e79381dc3a64a75$var$treeContextOverflow = length + workInProgress;
    } else $1e79381dc3a64a75$var$treeContextId = 1 << length | index << baseLength | baseIdWithLeadingBit, $1e79381dc3a64a75$var$treeContextOverflow = workInProgress;
}
function $1e79381dc3a64a75$var$pushMaterializedTreeId(workInProgress) {
    null !== workInProgress.return && ($1e79381dc3a64a75$var$pushTreeFork(workInProgress, 1), $1e79381dc3a64a75$var$pushTreeId(workInProgress, 1, 0));
}
function $1e79381dc3a64a75$var$popTreeContext(workInProgress) {
    for(; workInProgress === $1e79381dc3a64a75$var$treeForkProvider;)$1e79381dc3a64a75$var$treeForkProvider = $1e79381dc3a64a75$var$forkStack[--$1e79381dc3a64a75$var$forkStackIndex], $1e79381dc3a64a75$var$forkStack[$1e79381dc3a64a75$var$forkStackIndex] = null, $1e79381dc3a64a75$var$treeForkCount = $1e79381dc3a64a75$var$forkStack[--$1e79381dc3a64a75$var$forkStackIndex], $1e79381dc3a64a75$var$forkStack[$1e79381dc3a64a75$var$forkStackIndex] = null;
    for(; workInProgress === $1e79381dc3a64a75$var$treeContextProvider;)$1e79381dc3a64a75$var$treeContextProvider = $1e79381dc3a64a75$var$idStack[--$1e79381dc3a64a75$var$idStackIndex], $1e79381dc3a64a75$var$idStack[$1e79381dc3a64a75$var$idStackIndex] = null, $1e79381dc3a64a75$var$treeContextOverflow = $1e79381dc3a64a75$var$idStack[--$1e79381dc3a64a75$var$idStackIndex], $1e79381dc3a64a75$var$idStack[$1e79381dc3a64a75$var$idStackIndex] = null, $1e79381dc3a64a75$var$treeContextId = $1e79381dc3a64a75$var$idStack[--$1e79381dc3a64a75$var$idStackIndex], $1e79381dc3a64a75$var$idStack[$1e79381dc3a64a75$var$idStackIndex] = null;
}
function $1e79381dc3a64a75$var$restoreSuspendedTreeContext(workInProgress, suspendedContext) {
    $1e79381dc3a64a75$var$idStack[$1e79381dc3a64a75$var$idStackIndex++] = $1e79381dc3a64a75$var$treeContextId;
    $1e79381dc3a64a75$var$idStack[$1e79381dc3a64a75$var$idStackIndex++] = $1e79381dc3a64a75$var$treeContextOverflow;
    $1e79381dc3a64a75$var$idStack[$1e79381dc3a64a75$var$idStackIndex++] = $1e79381dc3a64a75$var$treeContextProvider;
    $1e79381dc3a64a75$var$treeContextId = suspendedContext.id;
    $1e79381dc3a64a75$var$treeContextOverflow = suspendedContext.overflow;
    $1e79381dc3a64a75$var$treeContextProvider = workInProgress;
}
var $1e79381dc3a64a75$var$hydrationParentFiber = null, $1e79381dc3a64a75$var$nextHydratableInstance = null, $1e79381dc3a64a75$var$isHydrating = !1, $1e79381dc3a64a75$var$hydrationErrors = null, $1e79381dc3a64a75$var$rootOrSingletonContext = !1, $1e79381dc3a64a75$var$HydrationMismatchException = Error($1e79381dc3a64a75$var$formatProdErrorMessage(519));
function $1e79381dc3a64a75$var$throwOnHydrationMismatch(fiber) {
    var error = Error($1e79381dc3a64a75$var$formatProdErrorMessage(418, 1 < arguments.length && void 0 !== arguments[1] && arguments[1] ? "text" : "HTML", ""));
    $1e79381dc3a64a75$var$queueHydrationError($1e79381dc3a64a75$var$createCapturedValueAtFiber(error, fiber));
    throw $1e79381dc3a64a75$var$HydrationMismatchException;
}
function $1e79381dc3a64a75$var$prepareToHydrateHostInstance(fiber) {
    var instance = fiber.stateNode, type = fiber.type, props = fiber.memoizedProps;
    instance[$1e79381dc3a64a75$var$internalInstanceKey] = fiber;
    instance[$1e79381dc3a64a75$var$internalPropsKey] = props;
    switch(type){
        case "dialog":
            $1e79381dc3a64a75$var$listenToNonDelegatedEvent("cancel", instance);
            $1e79381dc3a64a75$var$listenToNonDelegatedEvent("close", instance);
            break;
        case "iframe":
        case "object":
        case "embed":
            $1e79381dc3a64a75$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "video":
        case "audio":
            for(type = 0; type < $1e79381dc3a64a75$var$mediaEventTypes.length; type++)$1e79381dc3a64a75$var$listenToNonDelegatedEvent($1e79381dc3a64a75$var$mediaEventTypes[type], instance);
            break;
        case "source":
            $1e79381dc3a64a75$var$listenToNonDelegatedEvent("error", instance);
            break;
        case "img":
        case "image":
        case "link":
            $1e79381dc3a64a75$var$listenToNonDelegatedEvent("error", instance);
            $1e79381dc3a64a75$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "details":
            $1e79381dc3a64a75$var$listenToNonDelegatedEvent("toggle", instance);
            break;
        case "input":
            $1e79381dc3a64a75$var$listenToNonDelegatedEvent("invalid", instance);
            $1e79381dc3a64a75$var$initInput(instance, props.value, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name, !0);
            break;
        case "select":
            $1e79381dc3a64a75$var$listenToNonDelegatedEvent("invalid", instance);
            break;
        case "textarea":
            $1e79381dc3a64a75$var$listenToNonDelegatedEvent("invalid", instance), $1e79381dc3a64a75$var$initTextarea(instance, props.value, props.defaultValue, props.children);
    }
    type = props.children;
    "string" !== typeof type && "number" !== typeof type && "bigint" !== typeof type || instance.textContent === "" + type || !0 === props.suppressHydrationWarning || $1e79381dc3a64a75$var$checkForUnmatchedText(instance.textContent, type) ? (null != props.popover && ($1e79381dc3a64a75$var$listenToNonDelegatedEvent("beforetoggle", instance), $1e79381dc3a64a75$var$listenToNonDelegatedEvent("toggle", instance)), null != props.onScroll && $1e79381dc3a64a75$var$listenToNonDelegatedEvent("scroll", instance), null != props.onScrollEnd && $1e79381dc3a64a75$var$listenToNonDelegatedEvent("scrollend", instance), null != props.onClick && (instance.onclick = $1e79381dc3a64a75$var$noop$1), instance = !0) : instance = !1;
    instance || $1e79381dc3a64a75$var$throwOnHydrationMismatch(fiber, !0);
}
function $1e79381dc3a64a75$var$popToNextHostParent(fiber) {
    for($1e79381dc3a64a75$var$hydrationParentFiber = fiber.return; $1e79381dc3a64a75$var$hydrationParentFiber;)switch($1e79381dc3a64a75$var$hydrationParentFiber.tag){
        case 5:
        case 31:
        case 13:
            $1e79381dc3a64a75$var$rootOrSingletonContext = !1;
            return;
        case 27:
        case 3:
            $1e79381dc3a64a75$var$rootOrSingletonContext = !0;
            return;
        default:
            $1e79381dc3a64a75$var$hydrationParentFiber = $1e79381dc3a64a75$var$hydrationParentFiber.return;
    }
}
function $1e79381dc3a64a75$var$popHydrationState(fiber) {
    if (fiber !== $1e79381dc3a64a75$var$hydrationParentFiber) return !1;
    if (!$1e79381dc3a64a75$var$isHydrating) return $1e79381dc3a64a75$var$popToNextHostParent(fiber), $1e79381dc3a64a75$var$isHydrating = !0, !1;
    var tag = fiber.tag, JSCompiler_temp;
    if (JSCompiler_temp = 3 !== tag && 27 !== tag) {
        if (JSCompiler_temp = 5 === tag) JSCompiler_temp = fiber.type, JSCompiler_temp = !("form" !== JSCompiler_temp && "button" !== JSCompiler_temp) || $1e79381dc3a64a75$var$shouldSetTextContent(fiber.type, fiber.memoizedProps);
        JSCompiler_temp = !JSCompiler_temp;
    }
    JSCompiler_temp && $1e79381dc3a64a75$var$nextHydratableInstance && $1e79381dc3a64a75$var$throwOnHydrationMismatch(fiber);
    $1e79381dc3a64a75$var$popToNextHostParent(fiber);
    if (13 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($1e79381dc3a64a75$var$formatProdErrorMessage(317));
        $1e79381dc3a64a75$var$nextHydratableInstance = $1e79381dc3a64a75$var$getNextHydratableInstanceAfterHydrationBoundary(fiber);
    } else if (31 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($1e79381dc3a64a75$var$formatProdErrorMessage(317));
        $1e79381dc3a64a75$var$nextHydratableInstance = $1e79381dc3a64a75$var$getNextHydratableInstanceAfterHydrationBoundary(fiber);
    } else 27 === tag ? (tag = $1e79381dc3a64a75$var$nextHydratableInstance, $1e79381dc3a64a75$var$isSingletonScope(fiber.type) ? (fiber = $1e79381dc3a64a75$var$previousHydratableOnEnteringScopedSingleton, $1e79381dc3a64a75$var$previousHydratableOnEnteringScopedSingleton = null, $1e79381dc3a64a75$var$nextHydratableInstance = fiber) : $1e79381dc3a64a75$var$nextHydratableInstance = tag) : $1e79381dc3a64a75$var$nextHydratableInstance = $1e79381dc3a64a75$var$hydrationParentFiber ? $1e79381dc3a64a75$var$getNextHydratable(fiber.stateNode.nextSibling) : null;
    return !0;
}
function $1e79381dc3a64a75$var$resetHydrationState() {
    $1e79381dc3a64a75$var$nextHydratableInstance = $1e79381dc3a64a75$var$hydrationParentFiber = null;
    $1e79381dc3a64a75$var$isHydrating = !1;
}
function $1e79381dc3a64a75$var$upgradeHydrationErrorsToRecoverable() {
    var queuedErrors = $1e79381dc3a64a75$var$hydrationErrors;
    null !== queuedErrors && (null === $1e79381dc3a64a75$var$workInProgressRootRecoverableErrors ? $1e79381dc3a64a75$var$workInProgressRootRecoverableErrors = queuedErrors : $1e79381dc3a64a75$var$workInProgressRootRecoverableErrors.push.apply($1e79381dc3a64a75$var$workInProgressRootRecoverableErrors, queuedErrors), $1e79381dc3a64a75$var$hydrationErrors = null);
    return queuedErrors;
}
function $1e79381dc3a64a75$var$queueHydrationError(error) {
    null === $1e79381dc3a64a75$var$hydrationErrors ? $1e79381dc3a64a75$var$hydrationErrors = [
        error
    ] : $1e79381dc3a64a75$var$hydrationErrors.push(error);
}
var $1e79381dc3a64a75$var$valueCursor = $1e79381dc3a64a75$var$createCursor(null), $1e79381dc3a64a75$var$currentlyRenderingFiber$1 = null, $1e79381dc3a64a75$var$lastContextDependency = null;
function $1e79381dc3a64a75$var$pushProvider(providerFiber, context, nextValue) {
    $1e79381dc3a64a75$var$push($1e79381dc3a64a75$var$valueCursor, context._currentValue);
    context._currentValue = nextValue;
}
function $1e79381dc3a64a75$var$popProvider(context) {
    context._currentValue = $1e79381dc3a64a75$var$valueCursor.current;
    $1e79381dc3a64a75$var$pop($1e79381dc3a64a75$var$valueCursor);
}
function $1e79381dc3a64a75$var$scheduleContextWorkOnParentPath(parent, renderLanes, propagationRoot) {
    for(; null !== parent;){
        var alternate = parent.alternate;
        (parent.childLanes & renderLanes) !== renderLanes ? (parent.childLanes |= renderLanes, null !== alternate && (alternate.childLanes |= renderLanes)) : null !== alternate && (alternate.childLanes & renderLanes) !== renderLanes && (alternate.childLanes |= renderLanes);
        if (parent === propagationRoot) break;
        parent = parent.return;
    }
}
function $1e79381dc3a64a75$var$propagateContextChanges(workInProgress, contexts, renderLanes, forcePropagateEntireTree) {
    var fiber = workInProgress.child;
    null !== fiber && (fiber.return = workInProgress);
    for(; null !== fiber;){
        var list = fiber.dependencies;
        if (null !== list) {
            var nextFiber = fiber.child;
            list = list.firstContext;
            a: for(; null !== list;){
                var dependency = list;
                list = fiber;
                for(var i = 0; i < contexts.length; i++)if (dependency.context === contexts[i]) {
                    list.lanes |= renderLanes;
                    dependency = list.alternate;
                    null !== dependency && (dependency.lanes |= renderLanes);
                    $1e79381dc3a64a75$var$scheduleContextWorkOnParentPath(list.return, renderLanes, workInProgress);
                    forcePropagateEntireTree || (nextFiber = null);
                    break a;
                }
                list = dependency.next;
            }
        } else if (18 === fiber.tag) {
            nextFiber = fiber.return;
            if (null === nextFiber) throw Error($1e79381dc3a64a75$var$formatProdErrorMessage(341));
            nextFiber.lanes |= renderLanes;
            list = nextFiber.alternate;
            null !== list && (list.lanes |= renderLanes);
            $1e79381dc3a64a75$var$scheduleContextWorkOnParentPath(nextFiber, renderLanes, workInProgress);
            nextFiber = null;
        } else 13 === fiber.tag && null !== fiber.memoizedState && null === fiber.memoizedState.dehydrated ? (fiber.lanes |= renderLanes, nextFiber = fiber.alternate, null !== nextFiber && (nextFiber.lanes |= renderLanes), $1e79381dc3a64a75$var$scheduleContextWorkOnParentPath(fiber.return, renderLanes, workInProgress), nextFiber = fiber.child, nextFiber = null !== nextFiber ? nextFiber.sibling : null) : nextFiber = fiber.child;
        if (null !== nextFiber) nextFiber.return = fiber;
        else for(nextFiber = fiber; null !== nextFiber;){
            if (nextFiber === workInProgress) {
                nextFiber = null;
                break;
            }
            fiber = nextFiber.sibling;
            if (null !== fiber) {
                fiber.return = nextFiber.return;
                nextFiber = fiber;
                break;
            }
            nextFiber = nextFiber.return;
        }
        fiber = nextFiber;
    }
}
function $1e79381dc3a64a75$var$propagateParentContextChanges(current, workInProgress, renderLanes, forcePropagateEntireTree) {
    current = null;
    for(var parent = workInProgress, isInsidePropagationBailout = !1; null !== parent;){
        if (!isInsidePropagationBailout) {
            if (0 !== (parent.flags & 524288)) isInsidePropagationBailout = !0;
            else if (0 !== (parent.flags & 262144)) break;
        }
        if (10 === parent.tag) {
            var currentParent = parent.alternate;
            if (null === currentParent) throw Error($1e79381dc3a64a75$var$formatProdErrorMessage(387));
            currentParent = currentParent.memoizedProps;
            if (null !== currentParent) {
                var context = parent.type;
                $1e79381dc3a64a75$var$objectIs(parent.pendingProps.value, currentParent.value) || (null !== current ? current.push(context) : current = [
                    context
                ]);
            }
        } else if (parent === $1e79381dc3a64a75$var$hostTransitionProviderCursor.current) {
            currentParent = parent.alternate;
            if (null === currentParent) throw Error($1e79381dc3a64a75$var$formatProdErrorMessage(387));
            currentParent.memoizedState.memoizedState !== parent.memoizedState.memoizedState && (null !== current ? current.push($1e79381dc3a64a75$var$HostTransitionContext) : current = [
                $1e79381dc3a64a75$var$HostTransitionContext
            ]);
        }
        parent = parent.return;
    }
    null !== current && $1e79381dc3a64a75$var$propagateContextChanges(workInProgress, current, renderLanes, forcePropagateEntireTree);
    workInProgress.flags |= 262144;
    return null !== current;
}
function $1e79381dc3a64a75$var$checkIfContextChanged(currentDependencies) {
    for(currentDependencies = currentDependencies.firstContext; null !== currentDependencies;){
        if (!$1e79381dc3a64a75$var$objectIs(currentDependencies.context._currentValue, currentDependencies.memoizedValue)) return !0;
        currentDependencies = currentDependencies.next;
    }
    return !1;
}
function $1e79381dc3a64a75$var$prepareToReadContext(workInProgress) {
    $1e79381dc3a64a75$var$currentlyRenderingFiber$1 = workInProgress;
    $1e79381dc3a64a75$var$lastContextDependency = null;
    workInProgress = workInProgress.dependencies;
    null !== workInProgress && (workInProgress.firstContext = null);
}
function $1e79381dc3a64a75$var$readContext(context) {
    return $1e79381dc3a64a75$var$readContextForConsumer($1e79381dc3a64a75$var$currentlyRenderingFiber$1, context);
}
function $1e79381dc3a64a75$var$readContextDuringReconciliation(consumer, context) {
    null === $1e79381dc3a64a75$var$currentlyRenderingFiber$1 && $1e79381dc3a64a75$var$prepareToReadContext(consumer);
    return $1e79381dc3a64a75$var$readContextForConsumer(consumer, context);
}
function $1e79381dc3a64a75$var$readContextForConsumer(consumer, context) {
    var value = context._currentValue;
    context = {
        context: context,
        memoizedValue: value,
        next: null
    };
    if (null === $1e79381dc3a64a75$var$lastContextDependency) {
        if (null === consumer) throw Error($1e79381dc3a64a75$var$formatProdErrorMessage(308));
        $1e79381dc3a64a75$var$lastContextDependency = context;
        consumer.dependencies = {
            lanes: 0,
            firstContext: context
        };
        consumer.flags |= 524288;
    } else $1e79381dc3a64a75$var$lastContextDependency = $1e79381dc3a64a75$var$lastContextDependency.next = context;
    return value;
}
var $1e79381dc3a64a75$var$AbortControllerLocal = "undefined" !== typeof AbortController ? AbortController : function() {
    var listeners = [], signal = this.signal = {
        aborted: !1,
        addEventListener: function(type, listener) {
            listeners.push(listener);
        }
    };
    this.abort = function() {
        signal.aborted = !0;
        listeners.forEach(function(listener) {
            return listener();
        });
    };
}, $1e79381dc3a64a75$var$scheduleCallback$2 = $3T9qK.unstable_scheduleCallback, $1e79381dc3a64a75$var$NormalPriority = $3T9qK.unstable_NormalPriority, $1e79381dc3a64a75$var$CacheContext = {
    $$typeof: $1e79381dc3a64a75$var$REACT_CONTEXT_TYPE,
    Consumer: null,
    Provider: null,
    _currentValue: null,
    _currentValue2: null,
    _threadCount: 0
};
function $1e79381dc3a64a75$var$createCache() {
    return {
        controller: new $1e79381dc3a64a75$var$AbortControllerLocal(),
        data: new Map(),
        refCount: 0
    };
}
function $1e79381dc3a64a75$var$releaseCache(cache) {
    cache.refCount--;
    0 === cache.refCount && $1e79381dc3a64a75$var$scheduleCallback$2($1e79381dc3a64a75$var$NormalPriority, function() {
        cache.controller.abort();
    });
}
function $1e79381dc3a64a75$var$queueTransitionTypes(root, transitionTypes) {
    if (0 !== (root.pendingLanes & 4194048)) {
        var queued = root.transitionTypes;
        null === queued && (queued = root.transitionTypes = []);
        for(root = 0; root < transitionTypes.length; root++){
            var transitionType = transitionTypes[root];
            -1 === queued.indexOf(transitionType) && queued.push(transitionType);
        }
    }
}
var $1e79381dc3a64a75$var$entangledTransitionTypes = null;
function $1e79381dc3a64a75$var$claimQueuedTransitionTypes(root) {
    var claimed = root.transitionTypes;
    root.transitionTypes = null;
    return claimed;
}
var $1e79381dc3a64a75$var$currentEntangledListeners = null, $1e79381dc3a64a75$var$currentEntangledPendingCount = 0, $1e79381dc3a64a75$var$currentEntangledLane = 0, $1e79381dc3a64a75$var$currentEntangledActionThenable = null;
function $1e79381dc3a64a75$var$entangleAsyncAction(transition, thenable) {
    if (null === $1e79381dc3a64a75$var$currentEntangledListeners) {
        var entangledListeners = $1e79381dc3a64a75$var$currentEntangledListeners = [];
        $1e79381dc3a64a75$var$currentEntangledPendingCount = 0;
        $1e79381dc3a64a75$var$currentEntangledLane = $1e79381dc3a64a75$var$requestTransitionLane();
        $1e79381dc3a64a75$var$currentEntangledActionThenable = {
            status: "pending",
            value: void 0,
            then: function(resolve) {
                entangledListeners.push(resolve);
            }
        };
    }
    $1e79381dc3a64a75$var$currentEntangledPendingCount++;
    thenable.then($1e79381dc3a64a75$var$pingEngtangledActionScope, $1e79381dc3a64a75$var$pingEngtangledActionScope);
    return thenable;
}
function $1e79381dc3a64a75$var$pingEngtangledActionScope() {
    if (0 === --$1e79381dc3a64a75$var$currentEntangledPendingCount && ($1e79381dc3a64a75$var$entangledTransitionTypes = null, null !== $1e79381dc3a64a75$var$currentEntangledListeners)) {
        null !== $1e79381dc3a64a75$var$currentEntangledActionThenable && ($1e79381dc3a64a75$var$currentEntangledActionThenable.status = "fulfilled");
        var listeners = $1e79381dc3a64a75$var$currentEntangledListeners;
        $1e79381dc3a64a75$var$currentEntangledListeners = null;
        $1e79381dc3a64a75$var$currentEntangledLane = 0;
        $1e79381dc3a64a75$var$currentEntangledActionThenable = null;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])();
    }
}
function $1e79381dc3a64a75$var$chainThenableValue(thenable, result) {
    var listeners = [], thenableWithOverride = {
        status: "pending",
        value: null,
        reason: null,
        then: function(resolve) {
            listeners.push(resolve);
        }
    };
    thenable.then(function() {
        thenableWithOverride.status = "fulfilled";
        thenableWithOverride.value = result;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])(result);
    }, function(error) {
        thenableWithOverride.status = "rejected";
        thenableWithOverride.reason = error;
        for(error = 0; error < listeners.length; error++)(0, listeners[error])(void 0);
    });
    return thenableWithOverride;
}
var $1e79381dc3a64a75$var$prevOnStartTransitionFinish = $1e79381dc3a64a75$var$ReactSharedInternals.S;
$1e79381dc3a64a75$var$ReactSharedInternals.S = function(transition, returnValue) {
    $1e79381dc3a64a75$var$globalMostRecentTransitionTime = $1e79381dc3a64a75$var$now();
    "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && $1e79381dc3a64a75$var$entangleAsyncAction(transition, returnValue);
    if (null !== $1e79381dc3a64a75$var$entangledTransitionTypes) for(var root$28 = $1e79381dc3a64a75$var$firstScheduledRoot; null !== root$28;)$1e79381dc3a64a75$var$queueTransitionTypes(root$28, $1e79381dc3a64a75$var$entangledTransitionTypes), root$28 = root$28.next;
    root$28 = transition.types;
    if (null !== root$28) {
        for(var root$29 = $1e79381dc3a64a75$var$firstScheduledRoot; null !== root$29;)$1e79381dc3a64a75$var$queueTransitionTypes(root$29, root$28), root$29 = root$29.next;
        if (0 !== $1e79381dc3a64a75$var$currentEntangledLane) {
            root$29 = $1e79381dc3a64a75$var$entangledTransitionTypes;
            null === root$29 && (root$29 = $1e79381dc3a64a75$var$entangledTransitionTypes = []);
            for(var i = 0; i < root$28.length; i++){
                var transitionType = root$28[i];
                -1 === root$29.indexOf(transitionType) && root$29.push(transitionType);
            }
        }
    }
    null !== $1e79381dc3a64a75$var$prevOnStartTransitionFinish && $1e79381dc3a64a75$var$prevOnStartTransitionFinish(transition, returnValue);
};
var $1e79381dc3a64a75$var$resumedCache = $1e79381dc3a64a75$var$createCursor(null);
function $1e79381dc3a64a75$var$peekCacheFromPool() {
    var cacheResumedFromPreviousRender = $1e79381dc3a64a75$var$resumedCache.current;
    return null !== cacheResumedFromPreviousRender ? cacheResumedFromPreviousRender : $1e79381dc3a64a75$var$workInProgressRoot.pooledCache;
}
function $1e79381dc3a64a75$var$pushTransition(offscreenWorkInProgress, prevCachePool) {
    null === prevCachePool ? $1e79381dc3a64a75$var$push($1e79381dc3a64a75$var$resumedCache, $1e79381dc3a64a75$var$resumedCache.current) : $1e79381dc3a64a75$var$push($1e79381dc3a64a75$var$resumedCache, prevCachePool.pool);
}
function $1e79381dc3a64a75$var$getSuspendedCache() {
    var cacheFromPool = $1e79381dc3a64a75$var$peekCacheFromPool();
    return null === cacheFromPool ? null : {
        parent: $1e79381dc3a64a75$var$CacheContext._currentValue,
        pool: cacheFromPool
    };
}
var $1e79381dc3a64a75$var$SuspenseException = Error($1e79381dc3a64a75$var$formatProdErrorMessage(460)), $1e79381dc3a64a75$var$SuspenseyCommitException = Error($1e79381dc3a64a75$var$formatProdErrorMessage(474)), $1e79381dc3a64a75$var$SuspenseActionException = Error($1e79381dc3a64a75$var$formatProdErrorMessage(542)), $1e79381dc3a64a75$var$noopSuspenseyCommitThenable = {
    then: function() {}
};
function $1e79381dc3a64a75$var$isThenableResolved(thenable) {
    thenable = thenable.status;
    return "fulfilled" === thenable || "rejected" === thenable;
}
function $1e79381dc3a64a75$var$trackUsedThenable(thenableState, thenable, index) {
    index = thenableState[index];
    void 0 === index ? thenableState.push(thenable) : index !== thenable && (thenable.then($1e79381dc3a64a75$var$noop$1, $1e79381dc3a64a75$var$noop$1), thenable = index);
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            thenableState = thenable.reason;
            $1e79381dc3a64a75$var$checkIfUseWrappedInAsyncCatch(thenableState);
            if (void 0 === thenableState && !("reason" in thenable)) throw Error($1e79381dc3a64a75$var$formatProdErrorMessage(600));
            throw thenableState;
        default:
            if ("string" === typeof thenable.status) thenable.then($1e79381dc3a64a75$var$noop$1, $1e79381dc3a64a75$var$noop$1);
            else {
                thenableState = $1e79381dc3a64a75$var$workInProgressRoot;
                if (null !== thenableState && 100 < thenableState.shellSuspendCounter) throw Error($1e79381dc3a64a75$var$formatProdErrorMessage(482));
                thenableState = thenable;
                thenableState.status = "pending";
                thenableState.then(function(fulfilledValue) {
                    if ("pending" === thenable.status) {
                        var fulfilledThenable = thenable;
                        fulfilledThenable.status = "fulfilled";
                        fulfilledThenable.value = fulfilledValue;
                    }
                }, function(error) {
                    if ("pending" === thenable.status) {
                        var rejectedThenable = thenable;
                        rejectedThenable.status = "rejected";
                        rejectedThenable.reason = error;
                    }
                });
            }
            switch(thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenableState = thenable.reason, $1e79381dc3a64a75$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
            }
            $1e79381dc3a64a75$var$suspendedThenable = thenable;
            throw $1e79381dc3a64a75$var$SuspenseException;
    }
}
function $1e79381dc3a64a75$var$resolveLazy(lazyType) {
    try {
        var init = lazyType._init;
        return init(lazyType._payload);
    } catch (x) {
        if (null !== x && "object" === typeof x && "function" === typeof x.then) throw $1e79381dc3a64a75$var$suspendedThenable = x, $1e79381dc3a64a75$var$SuspenseException;
        throw x;
    }
}
var $1e79381dc3a64a75$var$suspendedThenable = null;
function $1e79381dc3a64a75$var$getSuspendedThenable() {
    if (null === $1e79381dc3a64a75$var$suspendedThenable) throw Error($1e79381dc3a64a75$var$formatProdErrorMessage(459));
    var thenable = $1e79381dc3a64a75$var$suspendedThenable;
    $1e79381dc3a64a75$var$suspendedThenable = null;
    return thenable;
}
function $1e79381dc3a64a75$var$checkIfUseWrappedInAsyncCatch(rejectedReason) {
    if (rejectedReason === $1e79381dc3a64a75$var$SuspenseException || rejectedReason === $1e79381dc3a64a75$var$SuspenseActionException) throw Error($1e79381dc3a64a75$var$formatProdErrorMessage(483));
}
var $1e79381dc3a64a75$var$thenableState$1 = null, $1e79381dc3a64a75$var$thenableIndexCounter$1 = 0;
function $1e79381dc3a64a75$var$unwrapThenable(thenable) {
    var index = $1e79381dc3a64a75$var$thenableIndexCounter$1;
    $1e79381dc3a64a75$var$thenableIndexCounter$1 += 1;
    null === $1e79381dc3a64a75$var$thenableState$1 && ($1e79381dc3a64a75$var$thenableState$1 = []);
    return $1e79381dc3a64a75$var$trackUsedThenable($1e79381dc3a64a75$var$thenableState$1, thenable, index);
}
function $1e79381dc3a64a75$var$coerceRef(workInProgress, element) {
    element = element.props.ref;
    workInProgress.ref = void 0 !== element ? element : null;
}
function $1e79381dc3a64a75$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild) {
    if (newChild.$$typeof === $1e79381dc3a64a75$var$REACT_LEGACY_ELEMENT_TYPE) throw Error($1e79381dc3a64a75$var$formatProdErrorMessage(525));
    returnFiber = Object.prototype.toString.call(newChild);
    throw Error($1e79381dc3a64a75$var$formatProdErrorMessage(31, "[object Object]" === returnFiber ? "object with keys {" + Object.keys(newChild).join(", ") + "}" : returnFiber));
}
function $1e79381dc3a64a75$var$createChildReconciler(shouldTrackSideEffects) {
    function deleteChild(returnFiber, childToDelete) {
        if (shouldTrackSideEffects) {
            var deletions = returnFiber.deletions;
            null === deletions ? (returnFiber.deletions = [
                childToDelete
            ], returnFiber.flags |= 16) : deletions.push(childToDelete);
        }
    }
    function deleteRemainingChildren(returnFiber, currentFirstChild) {
        if (!shouldTrackSideEffects) return null;
        for(; null !== currentFirstChild;)deleteChild(returnFiber, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return null;
    }
    function mapRemainingChildren(currentFirstChild) {
        for(var existingChildren = new Map(); null !== currentFirstChild;)null === currentFirstChild.key ? existingChildren.set(currentFirstChild.index, currentFirstChild) : existingChildren.set(currentFirstChild.key, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return existingChildren;
    }
    function useFiber(fiber, pendingProps) {
        fiber = $1e79381dc3a64a75$var$createWorkInProgress(fiber, pendingProps);
        fiber.index = 0;
        fiber.sibling = null;
        return fiber;
    }
    function placeChild(newFiber, lastPlacedIndex, newIndex) {
        newFiber.index = newIndex;
        if (!shouldTrackSideEffects) return newFiber.flags |= 1048576, lastPlacedIndex;
        newIndex = newFiber.alternate;
        if (null !== newIndex) return newIndex = newIndex.index, newIndex < lastPlacedIndex ? (newFiber.flags |= 2, lastPlacedIndex) : newIndex;
        newFiber.flags |= 134217730;
        return lastPlacedIndex;
    }
    function placeSingleChild(newFiber) {
        shouldTrackSideEffects && null === newFiber.alternate && (newFiber.flags |= 134217730);
        return newFiber;
    }
    function updateTextNode(returnFiber, current, textContent, lanes) {
        if (null === current || 6 !== current.tag) return current = $1e79381dc3a64a75$var$createFiberFromText(textContent, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, textContent);
        current.return = returnFiber;
        return current;
    }
    function updateElement(returnFiber, current, element, lanes) {
        var elementType = element.type;
        if (elementType === $1e79381dc3a64a75$var$REACT_FRAGMENT_TYPE) return returnFiber = updateFragment(returnFiber, current, element.props.children, lanes, element.key), $1e79381dc3a64a75$var$coerceRef(returnFiber, element), returnFiber;
        if (null !== current && (current.elementType === elementType || "object" === typeof elementType && null !== elementType && elementType.$$typeof === $1e79381dc3a64a75$var$REACT_LAZY_TYPE && $1e79381dc3a64a75$var$resolveLazy(elementType) === current.type)) return current = useFiber(current, element.props), $1e79381dc3a64a75$var$coerceRef(current, element), current.return = returnFiber, current;
        current = $1e79381dc3a64a75$var$createFiberFromTypeAndProps(element.type, element.key, element.props, null, returnFiber.mode, lanes);
        $1e79381dc3a64a75$var$coerceRef(current, element);
        current.return = returnFiber;
        return current;
    }
    function updatePortal(returnFiber, current, portal, lanes) {
        if (null === current || 4 !== current.tag || current.stateNode.containerInfo !== portal.containerInfo || current.stateNode.implementation !== portal.implementation) return current = $1e79381dc3a64a75$var$createFiberFromPortal(portal, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, portal.children || []);
        current.return = returnFiber;
        return current;
    }
    function updateFragment(returnFiber, current, fragment, lanes, key) {
        if (null === current || 7 !== current.tag) return current = $1e79381dc3a64a75$var$createFiberFromFragment(fragment, returnFiber.mode, lanes, key), current.return = returnFiber, current;
        current = useFiber(current, fragment);
        current.return = returnFiber;
        return current;
    }
    function createChild(returnFiber, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return newChild = $1e79381dc3a64a75$var$createFiberFromText("" + newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $1e79381dc3a64a75$var$REACT_ELEMENT_TYPE:
                    return lanes = $1e79381dc3a64a75$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $1e79381dc3a64a75$var$coerceRef(lanes, newChild), lanes.return = returnFiber, lanes;
                case $1e79381dc3a64a75$var$REACT_PORTAL_TYPE:
                    return newChild = $1e79381dc3a64a75$var$createFiberFromPortal(newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
                case $1e79381dc3a64a75$var$REACT_LAZY_TYPE:
                    return newChild = $1e79381dc3a64a75$var$resolveLazy(newChild), createChild(returnFiber, newChild, lanes);
            }
            if ($1e79381dc3a64a75$var$isArrayImpl(newChild) || $1e79381dc3a64a75$var$getIteratorFn(newChild)) return newChild = $1e79381dc3a64a75$var$createFiberFromFragment(newChild, returnFiber.mode, lanes, null), newChild.return = returnFiber, newChild;
            if ("function" === typeof newChild.then) return createChild(returnFiber, $1e79381dc3a64a75$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $1e79381dc3a64a75$var$REACT_CONTEXT_TYPE) return createChild(returnFiber, $1e79381dc3a64a75$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $1e79381dc3a64a75$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function updateSlot(returnFiber, oldFiber, newChild, lanes) {
        var key = null !== oldFiber ? oldFiber.key : null;
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return null !== key ? null : updateTextNode(returnFiber, oldFiber, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $1e79381dc3a64a75$var$REACT_ELEMENT_TYPE:
                    return newChild.key === key ? updateElement(returnFiber, oldFiber, newChild, lanes) : null;
                case $1e79381dc3a64a75$var$REACT_PORTAL_TYPE:
                    return newChild.key === key ? updatePortal(returnFiber, oldFiber, newChild, lanes) : null;
                case $1e79381dc3a64a75$var$REACT_LAZY_TYPE:
                    return newChild = $1e79381dc3a64a75$var$resolveLazy(newChild), updateSlot(returnFiber, oldFiber, newChild, lanes);
            }
            if ($1e79381dc3a64a75$var$isArrayImpl(newChild) || $1e79381dc3a64a75$var$getIteratorFn(newChild)) return null !== key ? null : updateFragment(returnFiber, oldFiber, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateSlot(returnFiber, oldFiber, $1e79381dc3a64a75$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $1e79381dc3a64a75$var$REACT_CONTEXT_TYPE) return updateSlot(returnFiber, oldFiber, $1e79381dc3a64a75$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $1e79381dc3a64a75$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return existingChildren = existingChildren.get(newIdx) || null, updateTextNode(returnFiber, existingChildren, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $1e79381dc3a64a75$var$REACT_ELEMENT_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updateElement(returnFiber, existingChildren, newChild, lanes);
                case $1e79381dc3a64a75$var$REACT_PORTAL_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updatePortal(returnFiber, existingChildren, newChild, lanes);
                case $1e79381dc3a64a75$var$REACT_LAZY_TYPE:
                    return newChild = $1e79381dc3a64a75$var$resolveLazy(newChild), updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes);
            }
            if ($1e79381dc3a64a75$var$isArrayImpl(newChild) || $1e79381dc3a64a75$var$getIteratorFn(newChild)) return existingChildren = existingChildren.get(newIdx) || null, updateFragment(returnFiber, existingChildren, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateFromMap(existingChildren, returnFiber, newIdx, $1e79381dc3a64a75$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $1e79381dc3a64a75$var$REACT_CONTEXT_TYPE) return updateFromMap(existingChildren, returnFiber, newIdx, $1e79381dc3a64a75$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $1e79381dc3a64a75$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function reconcileChildrenArray(returnFiber, currentFirstChild, newChildren, lanes) {
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null; null !== oldFiber && newIdx < newChildren.length; newIdx++){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, newChildren[newIdx], lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (newIdx === newChildren.length) return deleteRemainingChildren(returnFiber, oldFiber), $1e79381dc3a64a75$var$isHydrating && $1e79381dc3a64a75$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; newIdx < newChildren.length; newIdx++)oldFiber = createChild(returnFiber, newChildren[newIdx], lanes), null !== oldFiber && (currentFirstChild = placeChild(oldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = oldFiber : previousNewFiber.sibling = oldFiber, previousNewFiber = oldFiber);
            $1e79381dc3a64a75$var$isHydrating && $1e79381dc3a64a75$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); newIdx < newChildren.length; newIdx++)nextOldFiber = updateFromMap(oldFiber, returnFiber, newIdx, newChildren[newIdx], lanes), null !== nextOldFiber && (shouldTrackSideEffects && (newFiber = nextOldFiber.alternate, null !== newFiber && oldFiber.delete(null === newFiber.key ? newIdx : newFiber.key)), currentFirstChild = placeChild(nextOldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = nextOldFiber : previousNewFiber.sibling = nextOldFiber, previousNewFiber = nextOldFiber);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $1e79381dc3a64a75$var$isHydrating && $1e79381dc3a64a75$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildrenIterator(returnFiber, currentFirstChild, newChildren, lanes) {
        if (null == newChildren) throw Error($1e79381dc3a64a75$var$formatProdErrorMessage(151));
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null, step = newChildren.next(); null !== oldFiber && !step.done; newIdx++, step = newChildren.next()){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, step.value, lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (step.done) return deleteRemainingChildren(returnFiber, oldFiber), $1e79381dc3a64a75$var$isHydrating && $1e79381dc3a64a75$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; !step.done; newIdx++, step = newChildren.next())step = createChild(returnFiber, step.value, lanes), null !== step && (currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
            $1e79381dc3a64a75$var$isHydrating && $1e79381dc3a64a75$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); !step.done; newIdx++, step = newChildren.next())step = updateFromMap(oldFiber, returnFiber, newIdx, step.value, lanes), null !== step && (shouldTrackSideEffects && (nextOldFiber = step.alternate, null !== nextOldFiber && oldFiber.delete(null === nextOldFiber.key ? newIdx : nextOldFiber.key)), currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $1e79381dc3a64a75$var$isHydrating && $1e79381dc3a64a75$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes) {
        "object" === typeof newChild && null !== newChild && newChild.type === $1e79381dc3a64a75$var$REACT_FRAGMENT_TYPE && null === newChild.key && void 0 === newChild.props.ref && (newChild = newChild.props.children);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $1e79381dc3a64a75$var$REACT_ELEMENT_TYPE:
                    a: {
                        for(var key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                key = newChild.type;
                                if (key === $1e79381dc3a64a75$var$REACT_FRAGMENT_TYPE) {
                                    if (7 === currentFirstChild.tag) {
                                        deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                        lanes = useFiber(currentFirstChild, newChild.props.children);
                                        $1e79381dc3a64a75$var$coerceRef(lanes, newChild);
                                        lanes.return = returnFiber;
                                        returnFiber = lanes;
                                        break a;
                                    }
                                } else if (currentFirstChild.elementType === key || "object" === typeof key && null !== key && key.$$typeof === $1e79381dc3a64a75$var$REACT_LAZY_TYPE && $1e79381dc3a64a75$var$resolveLazy(key) === currentFirstChild.type) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.props);
                                    $1e79381dc3a64a75$var$coerceRef(lanes, newChild);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                }
                                deleteRemainingChildren(returnFiber, currentFirstChild);
                                break;
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        newChild.type === $1e79381dc3a64a75$var$REACT_FRAGMENT_TYPE ? (lanes = $1e79381dc3a64a75$var$createFiberFromFragment(newChild.props.children, returnFiber.mode, lanes, newChild.key), $1e79381dc3a64a75$var$coerceRef(lanes, newChild), lanes.return = returnFiber, returnFiber = lanes) : (lanes = $1e79381dc3a64a75$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $1e79381dc3a64a75$var$coerceRef(lanes, newChild), lanes.return = returnFiber, returnFiber = lanes);
                    }
                    return placeSingleChild(returnFiber);
                case $1e79381dc3a64a75$var$REACT_PORTAL_TYPE:
                    a: {
                        for(key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                if (4 === currentFirstChild.tag && currentFirstChild.stateNode.containerInfo === newChild.containerInfo && currentFirstChild.stateNode.implementation === newChild.implementation) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.children || []);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                } else {
                                    deleteRemainingChildren(returnFiber, currentFirstChild);
                                    break;
                                }
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        lanes = $1e79381dc3a64a75$var$createFiberFromPortal(newChild, returnFiber.mode, lanes);
                        lanes.return = returnFiber;
                        returnFiber = lanes;
                    }
                    return placeSingleChild(returnFiber);
                case $1e79381dc3a64a75$var$REACT_LAZY_TYPE:
                    return newChild = $1e79381dc3a64a75$var$resolveLazy(newChild), reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ($1e79381dc3a64a75$var$isArrayImpl(newChild)) return reconcileChildrenArray(returnFiber, currentFirstChild, newChild, lanes);
            if ($1e79381dc3a64a75$var$getIteratorFn(newChild)) {
                key = $1e79381dc3a64a75$var$getIteratorFn(newChild);
                if ("function" !== typeof key) throw Error($1e79381dc3a64a75$var$formatProdErrorMessage(150));
                newChild = key.call(newChild);
                return reconcileChildrenIterator(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ("function" === typeof newChild.then) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $1e79381dc3a64a75$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $1e79381dc3a64a75$var$REACT_CONTEXT_TYPE) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $1e79381dc3a64a75$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $1e79381dc3a64a75$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return "string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild ? (newChild = "" + newChild, null !== currentFirstChild && 6 === currentFirstChild.tag ? (deleteRemainingChildren(returnFiber, currentFirstChild.sibling), lanes = useFiber(currentFirstChild, newChild), lanes.return = returnFiber, returnFiber = lanes) : (deleteRemainingChildren(returnFiber, currentFirstChild), lanes = $1e79381dc3a64a75$var$createFiberFromText(newChild, returnFiber.mode, lanes), lanes.return = returnFiber, returnFiber = lanes), placeSingleChild(returnFiber)) : deleteRemainingChildren(returnFiber, currentFirstChild);
    }
    return function(returnFiber, currentFirstChild, newChild, lanes) {
        try {
            $1e79381dc3a64a75$var$thenableIndexCounter$1 = 0;
            var firstChildFiber = reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            $1e79381dc3a64a75$var$thenableState$1 = null;
            return firstChildFiber;
        } catch (x) {
            if (x === $1e79381dc3a64a75$var$SuspenseException || x === $1e79381dc3a64a75$var$SuspenseActionException) throw x;
            var fiber = $1e79381dc3a64a75$var$createFiberImplClass(29, x, null, returnFiber.mode);
            fiber.lanes = lanes;
            fiber.return = returnFiber;
            return fiber;
        } finally{}
    };
}
var $1e79381dc3a64a75$var$reconcileChildFibers = $1e79381dc3a64a75$var$createChildReconciler(!0), $1e79381dc3a64a75$var$mountChildFibers = $1e79381dc3a64a75$var$createChildReconciler(!1), $1e79381dc3a64a75$var$hasForceUpdate = !1;
function $1e79381dc3a64a75$var$initializeUpdateQueue(fiber) {
    fiber.updateQueue = {
        baseState: fiber.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            lanes: 0,
            hiddenCallbacks: null
        },
        callbacks: null
    };
}
function $1e79381dc3a64a75$var$cloneUpdateQueue(current, workInProgress) {
    current = current.updateQueue;
    workInProgress.updateQueue === current && (workInProgress.updateQueue = {
        baseState: current.baseState,
        firstBaseUpdate: current.firstBaseUpdate,
        lastBaseUpdate: current.lastBaseUpdate,
        shared: current.shared,
        callbacks: null
    });
}
function $1e79381dc3a64a75$var$createUpdate(lane) {
    return {
        lane: lane,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $1e79381dc3a64a75$var$enqueueUpdate(fiber, update, lane) {
    var updateQueue = fiber.updateQueue;
    if (null === updateQueue) return null;
    updateQueue = updateQueue.shared;
    if (0 !== ($1e79381dc3a64a75$var$executionContext & 2)) {
        var pending = updateQueue.pending;
        null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
        updateQueue.pending = update;
        update = $1e79381dc3a64a75$var$getRootForUpdatedFiber(fiber);
        $1e79381dc3a64a75$var$markUpdateLaneFromFiberToRoot(fiber, null, lane);
        return update;
    }
    $1e79381dc3a64a75$var$enqueueUpdate$1(fiber, updateQueue, update, lane);
    return $1e79381dc3a64a75$var$getRootForUpdatedFiber(fiber);
}
function $1e79381dc3a64a75$var$entangleTransitions(root, fiber, lane) {
    fiber = fiber.updateQueue;
    if (null !== fiber && (fiber = fiber.shared, 0 !== (lane & 4194048))) {
        var queueLanes = fiber.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        fiber.lanes = lane;
        $1e79381dc3a64a75$var$markRootEntangled(root, lane);
    }
}
function $1e79381dc3a64a75$var$enqueueCapturedUpdate(workInProgress, capturedUpdate) {
    var queue = workInProgress.updateQueue, current = workInProgress.alternate;
    if (null !== current && (current = current.updateQueue, queue === current)) {
        var newFirst = null, newLast = null;
        queue = queue.firstBaseUpdate;
        if (null !== queue) {
            do {
                var clone = {
                    lane: queue.lane,
                    tag: queue.tag,
                    payload: queue.payload,
                    callback: null,
                    next: null
                };
                null === newLast ? newFirst = newLast = clone : newLast = newLast.next = clone;
                queue = queue.next;
            }while (null !== queue);
            null === newLast ? newFirst = newLast = capturedUpdate : newLast = newLast.next = capturedUpdate;
        } else newFirst = newLast = capturedUpdate;
        queue = {
            baseState: current.baseState,
            firstBaseUpdate: newFirst,
            lastBaseUpdate: newLast,
            shared: current.shared,
            callbacks: current.callbacks
        };
        workInProgress.updateQueue = queue;
        return;
    }
    workInProgress = queue.lastBaseUpdate;
    null === workInProgress ? queue.firstBaseUpdate = capturedUpdate : workInProgress.next = capturedUpdate;
    queue.lastBaseUpdate = capturedUpdate;
}
var $1e79381dc3a64a75$var$didReadFromEntangledAsyncAction = !1;
function $1e79381dc3a64a75$var$suspendIfUpdateReadFromEntangledAsyncAction() {
    if ($1e79381dc3a64a75$var$didReadFromEntangledAsyncAction) {
        var entangledActionThenable = $1e79381dc3a64a75$var$currentEntangledActionThenable;
        if (null !== entangledActionThenable) throw entangledActionThenable;
    }
}
function $1e79381dc3a64a75$var$processUpdateQueue(workInProgress$jscomp$0, props, instance$jscomp$0, renderLanes) {
    $1e79381dc3a64a75$var$didReadFromEntangledAsyncAction = !1;
    var queue = workInProgress$jscomp$0.updateQueue;
    $1e79381dc3a64a75$var$hasForceUpdate = !1;
    var firstBaseUpdate = queue.firstBaseUpdate, lastBaseUpdate = queue.lastBaseUpdate, pendingQueue = queue.shared.pending;
    if (null !== pendingQueue) {
        queue.shared.pending = null;
        var lastPendingUpdate = pendingQueue, firstPendingUpdate = lastPendingUpdate.next;
        lastPendingUpdate.next = null;
        null === lastBaseUpdate ? firstBaseUpdate = firstPendingUpdate : lastBaseUpdate.next = firstPendingUpdate;
        lastBaseUpdate = lastPendingUpdate;
        var current = workInProgress$jscomp$0.alternate;
        null !== current && (current = current.updateQueue, pendingQueue = current.lastBaseUpdate, pendingQueue !== lastBaseUpdate && (null === pendingQueue ? current.firstBaseUpdate = firstPendingUpdate : pendingQueue.next = firstPendingUpdate, current.lastBaseUpdate = lastPendingUpdate));
    }
    if (null !== firstBaseUpdate) {
        var newState = queue.baseState;
        lastBaseUpdate = 0;
        current = firstPendingUpdate = lastPendingUpdate = null;
        pendingQueue = firstBaseUpdate;
        do {
            var updateLane = pendingQueue.lane & -536870913, isHiddenUpdate = updateLane !== pendingQueue.lane;
            if (isHiddenUpdate ? ($1e79381dc3a64a75$var$workInProgressRootRenderLanes & updateLane) === updateLane : (renderLanes & updateLane) === updateLane) {
                0 !== updateLane && updateLane === $1e79381dc3a64a75$var$currentEntangledLane && ($1e79381dc3a64a75$var$didReadFromEntangledAsyncAction = !0);
                null !== current && (current = current.next = {
                    lane: 0,
                    tag: pendingQueue.tag,
                    payload: pendingQueue.payload,
                    callback: null,
                    next: null
                });
                a: {
                    var workInProgress = workInProgress$jscomp$0, update = pendingQueue;
                    updateLane = props;
                    var instance = instance$jscomp$0;
                    switch(update.tag){
                        case 1:
                            workInProgress = update.payload;
                            if ("function" === typeof workInProgress) {
                                newState = workInProgress.call(instance, newState, updateLane);
                                break a;
                            }
                            newState = workInProgress;
                            break a;
                        case 3:
                            workInProgress.flags = workInProgress.flags & -65537 | 128;
                        case 0:
                            workInProgress = update.payload;
                            updateLane = "function" === typeof workInProgress ? workInProgress.call(instance, newState, updateLane) : workInProgress;
                            if (null === updateLane || void 0 === updateLane) break a;
                            newState = $1e79381dc3a64a75$var$assign({}, newState, updateLane);
                            break a;
                        case 2:
                            $1e79381dc3a64a75$var$hasForceUpdate = !0;
                    }
                }
                updateLane = pendingQueue.callback;
                null !== updateLane && (workInProgress$jscomp$0.flags |= 64, isHiddenUpdate && (workInProgress$jscomp$0.flags |= 8192), isHiddenUpdate = queue.callbacks, null === isHiddenUpdate ? queue.callbacks = [
                    updateLane
                ] : isHiddenUpdate.push(updateLane));
            } else isHiddenUpdate = {
                lane: updateLane,
                tag: pendingQueue.tag,
                payload: pendingQueue.payload,
                callback: pendingQueue.callback,
                next: null
            }, null === current ? (firstPendingUpdate = current = isHiddenUpdate, lastPendingUpdate = newState) : current = current.next = isHiddenUpdate, lastBaseUpdate |= updateLane;
            pendingQueue = pendingQueue.next;
            if (null === pendingQueue) {
                if (pendingQueue = queue.shared.pending, null === pendingQueue) break;
                else isHiddenUpdate = pendingQueue, pendingQueue = isHiddenUpdate.next, isHiddenUpdate.next = null, queue.lastBaseUpdate = isHiddenUpdate, queue.shared.pending = null;
            }
        }while (1);
        null === current && (lastPendingUpdate = newState);
        queue.baseState = lastPendingUpdate;
        queue.firstBaseUpdate = firstPendingUpdate;
        queue.lastBaseUpdate = current;
        null === firstBaseUpdate && (queue.shared.lanes = 0);
        $1e79381dc3a64a75$var$workInProgressRootSkippedLanes |= lastBaseUpdate;
        workInProgress$jscomp$0.lanes = lastBaseUpdate;
        workInProgress$jscomp$0.memoizedState = newState;
    }
}
function $1e79381dc3a64a75$var$callCallback(callback, context) {
    if ("function" !== typeof callback) throw Error($1e79381dc3a64a75$var$formatProdErrorMessage(191, callback));
    callback.call(context);
}
function $1e79381dc3a64a75$var$commitCallbacks(updateQueue, context) {
    var callbacks = updateQueue.callbacks;
    if (null !== callbacks) for(updateQueue.callbacks = null, updateQueue = 0; updateQueue < callbacks.length; updateQueue++)$1e79381dc3a64a75$var$callCallback(callbacks[updateQueue], context);
}
var $1e79381dc3a64a75$var$currentTreeHiddenStackCursor = $1e79381dc3a64a75$var$createCursor(null), $1e79381dc3a64a75$var$prevEntangledRenderLanesCursor = $1e79381dc3a64a75$var$createCursor(0);
function $1e79381dc3a64a75$var$pushHiddenContext(fiber, context) {
    fiber = $1e79381dc3a64a75$var$entangledRenderLanes;
    $1e79381dc3a64a75$var$push($1e79381dc3a64a75$var$prevEntangledRenderLanesCursor, fiber);
    $1e79381dc3a64a75$var$push($1e79381dc3a64a75$var$currentTreeHiddenStackCursor, context);
    $1e79381dc3a64a75$var$entangledRenderLanes = fiber | context.baseLanes;
}
function $1e79381dc3a64a75$var$reuseHiddenContextOnStack() {
    $1e79381dc3a64a75$var$push($1e79381dc3a64a75$var$prevEntangledRenderLanesCursor, $1e79381dc3a64a75$var$entangledRenderLanes);
    $1e79381dc3a64a75$var$push($1e79381dc3a64a75$var$currentTreeHiddenStackCursor, $1e79381dc3a64a75$var$currentTreeHiddenStackCursor.current);
}
function $1e79381dc3a64a75$var$popHiddenContext() {
    $1e79381dc3a64a75$var$entangledRenderLanes = $1e79381dc3a64a75$var$prevEntangledRenderLanesCursor.current;
    $1e79381dc3a64a75$var$pop($1e79381dc3a64a75$var$currentTreeHiddenStackCursor);
    $1e79381dc3a64a75$var$pop($1e79381dc3a64a75$var$prevEntangledRenderLanesCursor);
}
var $1e79381dc3a64a75$var$suspenseHandlerStackCursor = $1e79381dc3a64a75$var$createCursor(null), $1e79381dc3a64a75$var$shellBoundary = null;
function $1e79381dc3a64a75$var$pushPrimaryTreeSuspenseHandler(handler) {
    var current = handler.alternate;
    $1e79381dc3a64a75$var$push($1e79381dc3a64a75$var$suspenseStackCursor, $1e79381dc3a64a75$var$suspenseStackCursor.current & 1);
    $1e79381dc3a64a75$var$push($1e79381dc3a64a75$var$suspenseHandlerStackCursor, handler);
    null === $1e79381dc3a64a75$var$shellBoundary && (null === current || null !== $1e79381dc3a64a75$var$currentTreeHiddenStackCursor.current ? $1e79381dc3a64a75$var$shellBoundary = handler : null !== current.memoizedState && ($1e79381dc3a64a75$var$shellBoundary = handler));
}
function $1e79381dc3a64a75$var$pushDehydratedActivitySuspenseHandler(fiber) {
    $1e79381dc3a64a75$var$push($1e79381dc3a64a75$var$suspenseStackCursor, $1e79381dc3a64a75$var$suspenseStackCursor.current);
    $1e79381dc3a64a75$var$push($1e79381dc3a64a75$var$suspenseHandlerStackCursor, fiber);
    null === $1e79381dc3a64a75$var$shellBoundary && ($1e79381dc3a64a75$var$shellBoundary = fiber);
}
function $1e79381dc3a64a75$var$pushOffscreenSuspenseHandler(fiber) {
    22 === fiber.tag ? ($1e79381dc3a64a75$var$push($1e79381dc3a64a75$var$suspenseStackCursor, $1e79381dc3a64a75$var$suspenseStackCursor.current), $1e79381dc3a64a75$var$push($1e79381dc3a64a75$var$suspenseHandlerStackCursor, fiber), null === $1e79381dc3a64a75$var$shellBoundary && ($1e79381dc3a64a75$var$shellBoundary = fiber)) : $1e79381dc3a64a75$var$reuseSuspenseHandlerOnStack();
}
function $1e79381dc3a64a75$var$reuseSuspenseHandlerOnStack() {
    $1e79381dc3a64a75$var$push($1e79381dc3a64a75$var$suspenseStackCursor, $1e79381dc3a64a75$var$suspenseStackCursor.current);
    $1e79381dc3a64a75$var$push($1e79381dc3a64a75$var$suspenseHandlerStackCursor, $1e79381dc3a64a75$var$suspenseHandlerStackCursor.current);
}
function $1e79381dc3a64a75$var$popSuspenseHandler(fiber) {
    $1e79381dc3a64a75$var$pop($1e79381dc3a64a75$var$suspenseHandlerStackCursor);
    $1e79381dc3a64a75$var$shellBoundary === fiber && ($1e79381dc3a64a75$var$shellBoundary = null);
    $1e79381dc3a64a75$var$pop($1e79381dc3a64a75$var$suspenseStackCursor);
}
var $1e79381dc3a64a75$var$suspenseStackCursor = $1e79381dc3a64a75$var$createCursor(0);
function $1e79381dc3a64a75$var$pushSuspenseListContext(fiber, newContext) {
    $1e79381dc3a64a75$var$push($1e79381dc3a64a75$var$suspenseHandlerStackCursor, $1e79381dc3a64a75$var$suspenseHandlerStackCursor.current);
    $1e79381dc3a64a75$var$push($1e79381dc3a64a75$var$suspenseStackCursor, newContext);
}
function $1e79381dc3a64a75$var$popSuspenseListContext(fiber) {
    $1e79381dc3a64a75$var$pop($1e79381dc3a64a75$var$suspenseStackCursor);
    $1e79381dc3a64a75$var$pop($1e79381dc3a64a75$var$suspenseHandlerStackCursor);
    $1e79381dc3a64a75$var$shellBoundary === fiber && ($1e79381dc3a64a75$var$shellBoundary = null);
}
function $1e79381dc3a64a75$var$findFirstSuspended(row) {
    for(var node = row; null !== node;){
        if (13 === node.tag) {
            var state = node.memoizedState;
            if (null !== state && (state = state.dehydrated, null === state || $1e79381dc3a64a75$var$isSuspenseInstancePending(state) || $1e79381dc3a64a75$var$isSuspenseInstanceFallback(state))) return node;
        } else if (19 === node.tag && "independent" !== node.memoizedProps.revealOrder) {
            if (0 !== (node.flags & 128)) return node;
        } else if (null !== node.child) {
            node.child.return = node;
            node = node.child;
            continue;
        }
        if (node === row) break;
        for(; null === node.sibling;){
            if (null === node.return || node.return === row) return null;
            node = node.return;
        }
        node.sibling.return = node.return;
        node = node.sibling;
    }
    return null;
}
var $1e79381dc3a64a75$var$renderLanes = 0, $1e79381dc3a64a75$var$currentlyRenderingFiber = null, $1e79381dc3a64a75$var$currentHook = null, $1e79381dc3a64a75$var$workInProgressHook = null, $1e79381dc3a64a75$var$didScheduleRenderPhaseUpdate = !1, $1e79381dc3a64a75$var$didScheduleRenderPhaseUpdateDuringThisPass = !1, $1e79381dc3a64a75$var$shouldDoubleInvokeUserFnsInHooksDEV = !1, $1e79381dc3a64a75$var$localIdCounter = 0, $1e79381dc3a64a75$var$thenableIndexCounter = 0, $1e79381dc3a64a75$var$thenableState = null, $1e79381dc3a64a75$var$globalClientIdCounter = 0;
function $1e79381dc3a64a75$var$throwInvalidHookError() {
    throw Error($1e79381dc3a64a75$var$formatProdErrorMessage(321));
}
function $1e79381dc3a64a75$var$areHookInputsEqual(nextDeps, prevDeps) {
    if (null === prevDeps) return !1;
    for(var i = 0; i < prevDeps.length && i < nextDeps.length; i++)if (!$1e79381dc3a64a75$var$objectIs(nextDeps[i], prevDeps[i])) return !1;
    return !0;
}
function $1e79381dc3a64a75$var$renderWithHooks(current, workInProgress, Component, props, secondArg, nextRenderLanes) {
    $1e79381dc3a64a75$var$renderLanes = nextRenderLanes;
    $1e79381dc3a64a75$var$currentlyRenderingFiber = workInProgress;
    workInProgress.memoizedState = null;
    workInProgress.updateQueue = null;
    workInProgress.lanes = 0;
    $1e79381dc3a64a75$var$ReactSharedInternals.H = null === current || null === current.memoizedState ? $1e79381dc3a64a75$var$HooksDispatcherOnMount : $1e79381dc3a64a75$var$HooksDispatcherOnUpdate;
    $1e79381dc3a64a75$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    nextRenderLanes = Component(props, secondArg);
    $1e79381dc3a64a75$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    $1e79381dc3a64a75$var$didScheduleRenderPhaseUpdateDuringThisPass && (nextRenderLanes = $1e79381dc3a64a75$var$renderWithHooksAgain(workInProgress, Component, props, secondArg));
    $1e79381dc3a64a75$var$finishRenderingHooks(current);
    return nextRenderLanes;
}
function $1e79381dc3a64a75$var$finishRenderingHooks(current) {
    $1e79381dc3a64a75$var$ReactSharedInternals.H = $1e79381dc3a64a75$var$ContextOnlyDispatcher;
    var didRenderTooFewHooks = null !== $1e79381dc3a64a75$var$currentHook && null !== $1e79381dc3a64a75$var$currentHook.next;
    $1e79381dc3a64a75$var$renderLanes = 0;
    $1e79381dc3a64a75$var$workInProgressHook = $1e79381dc3a64a75$var$currentHook = $1e79381dc3a64a75$var$currentlyRenderingFiber = null;
    $1e79381dc3a64a75$var$didScheduleRenderPhaseUpdate = !1;
    $1e79381dc3a64a75$var$thenableIndexCounter = 0;
    $1e79381dc3a64a75$var$thenableState = null;
    if (didRenderTooFewHooks) throw Error($1e79381dc3a64a75$var$formatProdErrorMessage(300));
    null === current || $1e79381dc3a64a75$var$didReceiveUpdate || (current = current.dependencies, null !== current && $1e79381dc3a64a75$var$checkIfContextChanged(current) && ($1e79381dc3a64a75$var$didReceiveUpdate = !0));
}
function $1e79381dc3a64a75$var$renderWithHooksAgain(workInProgress, Component, props, secondArg) {
    $1e79381dc3a64a75$var$currentlyRenderingFiber = workInProgress;
    var numberOfReRenders = 0;
    do {
        $1e79381dc3a64a75$var$didScheduleRenderPhaseUpdateDuringThisPass && ($1e79381dc3a64a75$var$thenableState = null);
        $1e79381dc3a64a75$var$thenableIndexCounter = 0;
        $1e79381dc3a64a75$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
        if (25 <= numberOfReRenders) throw Error($1e79381dc3a64a75$var$formatProdErrorMessage(301));
        numberOfReRenders += 1;
        $1e79381dc3a64a75$var$workInProgressHook = $1e79381dc3a64a75$var$currentHook = null;
        if (null != workInProgress.updateQueue) {
            var children = workInProgress.updateQueue;
            children.lastEffect = null;
            children.events = null;
            children.stores = null;
            null != children.memoCache && (children.memoCache.index = 0);
        }
        $1e79381dc3a64a75$var$ReactSharedInternals.H = $1e79381dc3a64a75$var$HooksDispatcherOnRerender;
        children = Component(props, secondArg);
    }while ($1e79381dc3a64a75$var$didScheduleRenderPhaseUpdateDuringThisPass);
    return children;
}
function $1e79381dc3a64a75$var$TransitionAwareHostComponent() {
    var dispatcher = $1e79381dc3a64a75$var$ReactSharedInternals.H, maybeThenable = dispatcher.useState()[0];
    maybeThenable = "function" === typeof maybeThenable.then ? $1e79381dc3a64a75$var$useThenable(maybeThenable) : maybeThenable;
    dispatcher = dispatcher.useState()[0];
    (null !== $1e79381dc3a64a75$var$currentHook ? $1e79381dc3a64a75$var$currentHook.memoizedState : null) !== dispatcher && ($1e79381dc3a64a75$var$currentlyRenderingFiber.flags |= 1024);
    return maybeThenable;
}
function $1e79381dc3a64a75$var$checkDidRenderIdHook() {
    var didRenderIdHook = 0 !== $1e79381dc3a64a75$var$localIdCounter;
    $1e79381dc3a64a75$var$localIdCounter = 0;
    return didRenderIdHook;
}
function $1e79381dc3a64a75$var$bailoutHooks(current, workInProgress, lanes) {
    workInProgress.updateQueue = current.updateQueue;
    workInProgress.flags &= -2053;
    current.lanes &= ~lanes;
}
function $1e79381dc3a64a75$var$resetHooksOnUnwind(workInProgress) {
    if ($1e79381dc3a64a75$var$didScheduleRenderPhaseUpdate) {
        for(workInProgress = workInProgress.memoizedState; null !== workInProgress;){
            var queue = workInProgress.queue;
            null !== queue && (queue.pending = null);
            workInProgress = workInProgress.next;
        }
        $1e79381dc3a64a75$var$didScheduleRenderPhaseUpdate = !1;
    }
    $1e79381dc3a64a75$var$renderLanes = 0;
    $1e79381dc3a64a75$var$workInProgressHook = $1e79381dc3a64a75$var$currentHook = $1e79381dc3a64a75$var$currentlyRenderingFiber = null;
    $1e79381dc3a64a75$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
    $1e79381dc3a64a75$var$thenableIndexCounter = $1e79381dc3a64a75$var$localIdCounter = 0;
    $1e79381dc3a64a75$var$thenableState = null;
}
function $1e79381dc3a64a75$var$mountWorkInProgressHook() {
    var hook = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $1e79381dc3a64a75$var$workInProgressHook ? $1e79381dc3a64a75$var$currentlyRenderingFiber.memoizedState = $1e79381dc3a64a75$var$workInProgressHook = hook : $1e79381dc3a64a75$var$workInProgressHook = $1e79381dc3a64a75$var$workInProgressHook.next = hook;
    return $1e79381dc3a64a75$var$workInProgressHook;
}
function $1e79381dc3a64a75$var$updateWorkInProgressHook() {
    if (null === $1e79381dc3a64a75$var$currentHook) {
        var nextCurrentHook = $1e79381dc3a64a75$var$currentlyRenderingFiber.alternate;
        nextCurrentHook = null !== nextCurrentHook ? nextCurrentHook.memoizedState : null;
    } else nextCurrentHook = $1e79381dc3a64a75$var$currentHook.next;
    var nextWorkInProgressHook = null === $1e79381dc3a64a75$var$workInProgressHook ? $1e79381dc3a64a75$var$currentlyRenderingFiber.memoizedState : $1e79381dc3a64a75$var$workInProgressHook.next;
    if (null !== nextWorkInProgressHook) $1e79381dc3a64a75$var$workInProgressHook = nextWorkInProgressHook, $1e79381dc3a64a75$var$currentHook = nextCurrentHook;
    else {
        if (null === nextCurrentHook) {
            if (null === $1e79381dc3a64a75$var$currentlyRenderingFiber.alternate) throw Error($1e79381dc3a64a75$var$formatProdErrorMessage(467));
            throw Error($1e79381dc3a64a75$var$formatProdErrorMessage(310));
        }
        $1e79381dc3a64a75$var$currentHook = nextCurrentHook;
        nextCurrentHook = {
            memoizedState: $1e79381dc3a64a75$var$currentHook.memoizedState,
            baseState: $1e79381dc3a64a75$var$currentHook.baseState,
            baseQueue: $1e79381dc3a64a75$var$currentHook.baseQueue,
            queue: $1e79381dc3a64a75$var$currentHook.queue,
            next: null
        };
        null === $1e79381dc3a64a75$var$workInProgressHook ? $1e79381dc3a64a75$var$currentlyRenderingFiber.memoizedState = $1e79381dc3a64a75$var$workInProgressHook = nextCurrentHook : $1e79381dc3a64a75$var$workInProgressHook = $1e79381dc3a64a75$var$workInProgressHook.next = nextCurrentHook;
    }
    return $1e79381dc3a64a75$var$workInProgressHook;
}
function $1e79381dc3a64a75$var$createFunctionComponentUpdateQueue() {
    return {
        lastEffect: null,
        events: null,
        stores: null,
        memoCache: null
    };
}
function $1e79381dc3a64a75$var$useThenable(thenable) {
    var index = $1e79381dc3a64a75$var$thenableIndexCounter;
    $1e79381dc3a64a75$var$thenableIndexCounter += 1;
    null === $1e79381dc3a64a75$var$thenableState && ($1e79381dc3a64a75$var$thenableState = []);
    thenable = $1e79381dc3a64a75$var$trackUsedThenable($1e79381dc3a64a75$var$thenableState, thenable, index);
    index = $1e79381dc3a64a75$var$currentlyRenderingFiber;
    null === (null === $1e79381dc3a64a75$var$workInProgressHook ? index.memoizedState : $1e79381dc3a64a75$var$workInProgressHook.next) && (index = index.alternate, $1e79381dc3a64a75$var$ReactSharedInternals.H = null === index || null === index.memoizedState ? $1e79381dc3a64a75$var$HooksDispatcherOnMount : $1e79381dc3a64a75$var$HooksDispatcherOnUpdate);
    return thenable;
}
function $1e79381dc3a64a75$var$use(usable) {
    if (null !== usable && "object" === typeof usable) {
        if ("function" === typeof usable.then) return $1e79381dc3a64a75$var$useThenable(usable);
        if (usable.$$typeof === $1e79381dc3a64a75$var$REACT_RECOVERABLE_TYPE) return;
        if (usable.$$typeof === $1e79381dc3a64a75$var$REACT_CONTEXT_TYPE) return $1e79381dc3a64a75$var$readContext(usable);
    }
    throw Error($1e79381dc3a64a75$var$formatProdErrorMessage(438, String(usable)));
}
function $1e79381dc3a64a75$var$useMemoCache(size) {
    var memoCache = null, updateQueue = $1e79381dc3a64a75$var$currentlyRenderingFiber.updateQueue;
    null !== updateQueue && (memoCache = updateQueue.memoCache);
    if (null == memoCache) {
        var current = $1e79381dc3a64a75$var$currentlyRenderingFiber.alternate;
        null !== current && (current = current.updateQueue, null !== current && (current = current.memoCache, null != current && (memoCache = {
            data: current.data.map(function(array) {
                return array.slice();
            }),
            index: 0
        })));
    }
    null == memoCache && (memoCache = {
        data: [],
        index: 0
    });
    null === updateQueue && (updateQueue = $1e79381dc3a64a75$var$createFunctionComponentUpdateQueue(), $1e79381dc3a64a75$var$currentlyRenderingFiber.updateQueue = updateQueue);
    updateQueue.memoCache = memoCache;
    updateQueue = memoCache.data[memoCache.index];
    if (void 0 === updateQueue) for(updateQueue = memoCache.data[memoCache.index] = Array(size), current = 0; current < size; current++)updateQueue[current] = $1e79381dc3a64a75$var$REACT_MEMO_CACHE_SENTINEL;
    memoCache.index++;
    return updateQueue;
}
function $1e79381dc3a64a75$var$basicStateReducer(state, action) {
    return "function" === typeof action ? action(state) : action;
}
function $1e79381dc3a64a75$var$updateReducer(reducer) {
    var hook = $1e79381dc3a64a75$var$updateWorkInProgressHook();
    return $1e79381dc3a64a75$var$updateReducerImpl(hook, $1e79381dc3a64a75$var$currentHook, reducer);
}
function $1e79381dc3a64a75$var$updateReducerImpl(hook, current, reducer) {
    var queue = hook.queue;
    if (null === queue) throw Error($1e79381dc3a64a75$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var baseQueue = hook.baseQueue, pendingQueue = queue.pending;
    if (null !== pendingQueue) {
        if (null !== baseQueue) {
            var baseFirst = baseQueue.next;
            baseQueue.next = pendingQueue.next;
            pendingQueue.next = baseFirst;
        }
        current.baseQueue = baseQueue = pendingQueue;
        queue.pending = null;
    }
    pendingQueue = hook.baseState;
    if (null === baseQueue) hook.memoizedState = pendingQueue;
    else {
        current = baseQueue.next;
        var newBaseQueueFirst = baseFirst = null, newBaseQueueLast = null, update = current, didReadFromEntangledAsyncAction$64 = !1;
        do {
            var updateLane = update.lane & -536870913;
            if (updateLane !== update.lane ? ($1e79381dc3a64a75$var$workInProgressRootRenderLanes & updateLane) === updateLane : ($1e79381dc3a64a75$var$renderLanes & updateLane) === updateLane) {
                var revertLane = update.revertLane;
                if (0 === revertLane) null !== newBaseQueueLast && (newBaseQueueLast = newBaseQueueLast.next = {
                    lane: 0,
                    revertLane: 0,
                    gesture: null,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }), updateLane === $1e79381dc3a64a75$var$currentEntangledLane && (didReadFromEntangledAsyncAction$64 = !0);
                else if (($1e79381dc3a64a75$var$renderLanes & revertLane) === revertLane) {
                    update = update.next;
                    revertLane === $1e79381dc3a64a75$var$currentEntangledLane && (didReadFromEntangledAsyncAction$64 = !0);
                    continue;
                } else updateLane = {
                    lane: 0,
                    revertLane: update.revertLane,
                    gesture: null,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = updateLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = updateLane, $1e79381dc3a64a75$var$currentlyRenderingFiber.lanes |= revertLane, $1e79381dc3a64a75$var$workInProgressRootSkippedLanes |= revertLane;
                updateLane = update.action;
                $1e79381dc3a64a75$var$shouldDoubleInvokeUserFnsInHooksDEV && reducer(pendingQueue, updateLane);
                pendingQueue = update.hasEagerState ? update.eagerState : reducer(pendingQueue, updateLane);
            } else revertLane = {
                lane: updateLane,
                revertLane: update.revertLane,
                gesture: update.gesture,
                action: update.action,
                hasEagerState: update.hasEagerState,
                eagerState: update.eagerState,
                next: null
            }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = revertLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = revertLane, $1e79381dc3a64a75$var$currentlyRenderingFiber.lanes |= updateLane, $1e79381dc3a64a75$var$workInProgressRootSkippedLanes |= updateLane;
            update = update.next;
        }while (null !== update && update !== current);
        null === newBaseQueueLast ? baseFirst = pendingQueue : newBaseQueueLast.next = newBaseQueueFirst;
        if (!$1e79381dc3a64a75$var$objectIs(pendingQueue, hook.memoizedState) && ($1e79381dc3a64a75$var$didReceiveUpdate = !0, didReadFromEntangledAsyncAction$64 && (reducer = $1e79381dc3a64a75$var$currentEntangledActionThenable, null !== reducer))) throw reducer;
        hook.memoizedState = pendingQueue;
        hook.baseState = baseFirst;
        hook.baseQueue = newBaseQueueLast;
        queue.lastRenderedState = pendingQueue;
    }
    null === baseQueue && (queue.lanes = 0);
    return [
        hook.memoizedState,
        queue.dispatch
    ];
}
function $1e79381dc3a64a75$var$rerenderReducer(reducer) {
    var hook = $1e79381dc3a64a75$var$updateWorkInProgressHook(), queue = hook.queue;
    if (null === queue) throw Error($1e79381dc3a64a75$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var dispatch = queue.dispatch, lastRenderPhaseUpdate = queue.pending, newState = hook.memoizedState;
    if (null !== lastRenderPhaseUpdate) {
        queue.pending = null;
        var update = lastRenderPhaseUpdate = lastRenderPhaseUpdate.next;
        do newState = reducer(newState, update.action), update = update.next;
        while (update !== lastRenderPhaseUpdate);
        $1e79381dc3a64a75$var$objectIs(newState, hook.memoizedState) || ($1e79381dc3a64a75$var$didReceiveUpdate = !0);
        hook.memoizedState = newState;
        null === hook.baseQueue && (hook.baseState = newState);
        queue.lastRenderedState = newState;
    }
    return [
        newState,
        dispatch
    ];
}
function $1e79381dc3a64a75$var$updateSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
    var fiber = $1e79381dc3a64a75$var$currentlyRenderingFiber, hook = $1e79381dc3a64a75$var$updateWorkInProgressHook(), isHydrating$jscomp$0 = $1e79381dc3a64a75$var$isHydrating;
    if (isHydrating$jscomp$0) {
        if (void 0 === getServerSnapshot) throw Error($1e79381dc3a64a75$var$formatProdErrorMessage(407));
        getServerSnapshot = getServerSnapshot();
    } else getServerSnapshot = getSnapshot();
    var snapshotChanged = !$1e79381dc3a64a75$var$objectIs(($1e79381dc3a64a75$var$currentHook || hook).memoizedState, getServerSnapshot);
    snapshotChanged && (hook.memoizedState = getServerSnapshot, $1e79381dc3a64a75$var$didReceiveUpdate = !0);
    hook = hook.queue;
    $1e79381dc3a64a75$var$updateEffect($1e79381dc3a64a75$var$subscribeToStore.bind(null, fiber, hook, subscribe), [
        subscribe
    ]);
    subscribe = hook.getSnapshot !== getSnapshot || snapshotChanged || null !== $1e79381dc3a64a75$var$workInProgressHook && 0 !== ($1e79381dc3a64a75$var$workInProgressHook.memoizedState.tag & 1);
    $1e79381dc3a64a75$var$pushSimpleEffect(subscribe ? 9 : 8, {
        destroy: void 0
    }, $1e79381dc3a64a75$var$updateStoreInstance.bind(null, fiber, hook, getServerSnapshot, getSnapshot), null);
    if (subscribe) {
        fiber.flags |= 2048;
        if (null === $1e79381dc3a64a75$var$workInProgressRoot) throw Error($1e79381dc3a64a75$var$formatProdErrorMessage(349));
        isHydrating$jscomp$0 || 0 !== ($1e79381dc3a64a75$var$renderLanes & 127) || $1e79381dc3a64a75$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
    }
    return getServerSnapshot;
}
function $1e79381dc3a64a75$var$pushStoreConsistencyCheck(fiber, getSnapshot, renderedSnapshot) {
    fiber.flags |= 16384;
    fiber = {
        getSnapshot: getSnapshot,
        value: renderedSnapshot
    };
    getSnapshot = $1e79381dc3a64a75$var$currentlyRenderingFiber.updateQueue;
    null === getSnapshot ? (getSnapshot = $1e79381dc3a64a75$var$createFunctionComponentUpdateQueue(), $1e79381dc3a64a75$var$currentlyRenderingFiber.updateQueue = getSnapshot, getSnapshot.stores = [
        fiber
    ]) : (renderedSnapshot = getSnapshot.stores, null === renderedSnapshot ? getSnapshot.stores = [
        fiber
    ] : renderedSnapshot.push(fiber));
}
function $1e79381dc3a64a75$var$updateStoreInstance(fiber, inst, nextSnapshot, getSnapshot) {
    inst.value = nextSnapshot;
    inst.getSnapshot = getSnapshot;
    $1e79381dc3a64a75$var$checkIfSnapshotChanged(inst) && $1e79381dc3a64a75$var$forceStoreRerender(fiber);
}
function $1e79381dc3a64a75$var$subscribeToStore(fiber, inst, subscribe) {
    return subscribe(function() {
        $1e79381dc3a64a75$var$checkIfSnapshotChanged(inst) && $1e79381dc3a64a75$var$forceStoreRerender(fiber);
    });
}
function $1e79381dc3a64a75$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$1e79381dc3a64a75$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $1e79381dc3a64a75$var$forceStoreRerender(fiber) {
    var root = $1e79381dc3a64a75$var$enqueueConcurrentRenderForLane(fiber, 2);
    null !== root && $1e79381dc3a64a75$var$scheduleUpdateOnFiber(root, fiber, 2);
}
function $1e79381dc3a64a75$var$mountStateImpl(initialState) {
    var hook = $1e79381dc3a64a75$var$mountWorkInProgressHook();
    if ("function" === typeof initialState) {
        var initialStateInitializer = initialState;
        initialState = initialStateInitializer();
        if ($1e79381dc3a64a75$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $1e79381dc3a64a75$var$setIsStrictModeForDevtools(!0);
            try {
                initialStateInitializer();
            } finally{
                $1e79381dc3a64a75$var$setIsStrictModeForDevtools(!1);
            }
        }
    }
    hook.memoizedState = hook.baseState = initialState;
    hook.queue = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $1e79381dc3a64a75$var$basicStateReducer,
        lastRenderedState: initialState
    };
    return hook;
}
function $1e79381dc3a64a75$var$updateOptimisticImpl(hook, current, passthrough, reducer) {
    hook.baseState = passthrough;
    return $1e79381dc3a64a75$var$updateReducerImpl(hook, $1e79381dc3a64a75$var$currentHook, "function" === typeof reducer ? reducer : $1e79381dc3a64a75$var$basicStateReducer);
}
function $1e79381dc3a64a75$var$dispatchActionState(fiber, actionQueue, setPendingState, setState, payload) {
    if ($1e79381dc3a64a75$var$isRenderPhaseUpdate(fiber)) throw Error($1e79381dc3a64a75$var$formatProdErrorMessage(485));
    fiber = actionQueue.action;
    if (null !== fiber) {
        var actionNode = {
            payload: payload,
            action: fiber,
            next: null,
            isTransition: !0,
            status: "pending",
            value: null,
            reason: null,
            listeners: [],
            then: function(listener) {
                actionNode.listeners.push(listener);
            }
        };
        null !== $1e79381dc3a64a75$var$ReactSharedInternals.T ? setPendingState(!0) : actionNode.isTransition = !1;
        setState(actionNode);
        setPendingState = actionQueue.pending;
        null === setPendingState ? (actionNode.next = actionQueue.pending = actionNode, $1e79381dc3a64a75$var$runActionStateAction(actionQueue, actionNode)) : (actionNode.next = setPendingState.next, actionQueue.pending = setPendingState.next = actionNode);
    }
}
function $1e79381dc3a64a75$var$runActionStateAction(actionQueue, node) {
    var action = node.action, payload = node.payload, prevState = actionQueue.state;
    if (node.isTransition) {
        var prevTransition = $1e79381dc3a64a75$var$ReactSharedInternals.T, currentTransition = {};
        currentTransition.types = null !== prevTransition ? prevTransition.types : null;
        $1e79381dc3a64a75$var$ReactSharedInternals.T = currentTransition;
        try {
            var returnValue = action(prevState, payload), onStartTransitionFinish = $1e79381dc3a64a75$var$ReactSharedInternals.S;
            null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
            $1e79381dc3a64a75$var$handleActionReturnValue(actionQueue, node, returnValue);
        } catch (error) {
            $1e79381dc3a64a75$var$onActionError(actionQueue, node, error);
        } finally{
            null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $1e79381dc3a64a75$var$ReactSharedInternals.T = prevTransition;
        }
    } else try {
        prevTransition = action(prevState, payload), $1e79381dc3a64a75$var$handleActionReturnValue(actionQueue, node, prevTransition);
    } catch (error$70) {
        $1e79381dc3a64a75$var$onActionError(actionQueue, node, error$70);
    }
}
function $1e79381dc3a64a75$var$handleActionReturnValue(actionQueue, node, returnValue) {
    null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then ? returnValue.then(function(nextState) {
        $1e79381dc3a64a75$var$onActionSuccess(actionQueue, node, nextState);
    }, function(error) {
        return $1e79381dc3a64a75$var$onActionError(actionQueue, node, error);
    }) : $1e79381dc3a64a75$var$onActionSuccess(actionQueue, node, returnValue);
}
function $1e79381dc3a64a75$var$onActionSuccess(actionQueue, actionNode, nextState) {
    actionNode.status = "fulfilled";
    actionNode.value = nextState;
    $1e79381dc3a64a75$var$notifyActionListeners(actionNode);
    actionQueue.state = nextState;
    actionNode = actionQueue.pending;
    null !== actionNode && (nextState = actionNode.next, nextState === actionNode ? actionQueue.pending = null : (nextState = nextState.next, actionNode.next = nextState, $1e79381dc3a64a75$var$runActionStateAction(actionQueue, nextState)));
}
function $1e79381dc3a64a75$var$onActionError(actionQueue, actionNode, error) {
    var last = actionQueue.pending;
    actionQueue.pending = null;
    if (null !== last) {
        last = last.next;
        do actionNode.status = "rejected", actionNode.reason = error, $1e79381dc3a64a75$var$notifyActionListeners(actionNode), actionNode = actionNode.next;
        while (actionNode !== last);
    }
    actionQueue.action = null;
}
function $1e79381dc3a64a75$var$notifyActionListeners(actionNode) {
    actionNode = actionNode.listeners;
    for(var i = 0; i < actionNode.length; i++)(0, actionNode[i])();
}
function $1e79381dc3a64a75$var$actionStateReducer(oldState, newState) {
    return newState;
}
function $1e79381dc3a64a75$var$mountActionState(action, initialStateProp) {
    if ($1e79381dc3a64a75$var$isHydrating) {
        var ssrFormState = $1e79381dc3a64a75$var$workInProgressRoot.formState;
        if (null !== ssrFormState) {
            a: {
                var JSCompiler_inline_result = $1e79381dc3a64a75$var$currentlyRenderingFiber;
                if ($1e79381dc3a64a75$var$isHydrating) {
                    if ($1e79381dc3a64a75$var$nextHydratableInstance) {
                        b: {
                            var JSCompiler_inline_result$jscomp$0 = $1e79381dc3a64a75$var$nextHydratableInstance;
                            for(var inRootOrSingleton = $1e79381dc3a64a75$var$rootOrSingletonContext; 8 !== JSCompiler_inline_result$jscomp$0.nodeType;){
                                if (!inRootOrSingleton) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                                JSCompiler_inline_result$jscomp$0 = $1e79381dc3a64a75$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                                if (null === JSCompiler_inline_result$jscomp$0) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                            }
                            inRootOrSingleton = JSCompiler_inline_result$jscomp$0.data;
                            JSCompiler_inline_result$jscomp$0 = "F!" === inRootOrSingleton || "F" === inRootOrSingleton ? JSCompiler_inline_result$jscomp$0 : null;
                        }
                        if (JSCompiler_inline_result$jscomp$0) {
                            $1e79381dc3a64a75$var$nextHydratableInstance = $1e79381dc3a64a75$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                            JSCompiler_inline_result = "F!" === JSCompiler_inline_result$jscomp$0.data;
                            break a;
                        }
                    }
                    $1e79381dc3a64a75$var$throwOnHydrationMismatch(JSCompiler_inline_result);
                }
                JSCompiler_inline_result = !1;
            }
            JSCompiler_inline_result && (initialStateProp = ssrFormState[0]);
        }
    }
    ssrFormState = $1e79381dc3a64a75$var$mountWorkInProgressHook();
    ssrFormState.memoizedState = ssrFormState.baseState = initialStateProp;
    JSCompiler_inline_result = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $1e79381dc3a64a75$var$actionStateReducer,
        lastRenderedState: initialStateProp
    };
    ssrFormState.queue = JSCompiler_inline_result;
    ssrFormState = $1e79381dc3a64a75$var$dispatchSetState.bind(null, $1e79381dc3a64a75$var$currentlyRenderingFiber, JSCompiler_inline_result);
    JSCompiler_inline_result.dispatch = ssrFormState;
    JSCompiler_inline_result = $1e79381dc3a64a75$var$mountStateImpl(!1);
    inRootOrSingleton = $1e79381dc3a64a75$var$dispatchOptimisticSetState.bind(null, $1e79381dc3a64a75$var$currentlyRenderingFiber, !1, JSCompiler_inline_result.queue);
    JSCompiler_inline_result = $1e79381dc3a64a75$var$mountWorkInProgressHook();
    JSCompiler_inline_result$jscomp$0 = {
        state: initialStateProp,
        dispatch: null,
        action: action,
        pending: null
    };
    JSCompiler_inline_result.queue = JSCompiler_inline_result$jscomp$0;
    ssrFormState = $1e79381dc3a64a75$var$dispatchActionState.bind(null, $1e79381dc3a64a75$var$currentlyRenderingFiber, JSCompiler_inline_result$jscomp$0, inRootOrSingleton, ssrFormState);
    JSCompiler_inline_result$jscomp$0.dispatch = ssrFormState;
    JSCompiler_inline_result.memoizedState = action;
    return [
        initialStateProp,
        ssrFormState,
        !1
    ];
}
function $1e79381dc3a64a75$var$updateActionState(action) {
    var stateHook = $1e79381dc3a64a75$var$updateWorkInProgressHook();
    return $1e79381dc3a64a75$var$updateActionStateImpl(stateHook, $1e79381dc3a64a75$var$currentHook, action);
}
function $1e79381dc3a64a75$var$updateActionStateImpl(stateHook, currentStateHook, action) {
    currentStateHook = $1e79381dc3a64a75$var$updateReducerImpl(stateHook, currentStateHook, $1e79381dc3a64a75$var$actionStateReducer)[0];
    stateHook = $1e79381dc3a64a75$var$updateReducer($1e79381dc3a64a75$var$basicStateReducer)[0];
    if ("object" === typeof currentStateHook && null !== currentStateHook && "function" === typeof currentStateHook.then) try {
        var state = $1e79381dc3a64a75$var$useThenable(currentStateHook);
    } catch (x) {
        if (x === $1e79381dc3a64a75$var$SuspenseException) throw $1e79381dc3a64a75$var$SuspenseActionException;
        throw x;
    }
    else state = currentStateHook;
    currentStateHook = $1e79381dc3a64a75$var$updateWorkInProgressHook();
    var actionQueue = currentStateHook.queue, dispatch = actionQueue.dispatch;
    action !== currentStateHook.memoizedState && ($1e79381dc3a64a75$var$currentlyRenderingFiber.flags |= 2048, $1e79381dc3a64a75$var$pushSimpleEffect(9, {
        destroy: void 0
    }, $1e79381dc3a64a75$var$actionStateActionEffect.bind(null, actionQueue, action), null));
    return [
        state,
        dispatch,
        stateHook
    ];
}
function $1e79381dc3a64a75$var$actionStateActionEffect(actionQueue, action) {
    actionQueue.action = action;
}
function $1e79381dc3a64a75$var$rerenderActionState(action) {
    var stateHook = $1e79381dc3a64a75$var$updateWorkInProgressHook(), currentStateHook = $1e79381dc3a64a75$var$currentHook;
    if (null !== currentStateHook) return $1e79381dc3a64a75$var$updateActionStateImpl(stateHook, currentStateHook, action);
    $1e79381dc3a64a75$var$updateWorkInProgressHook();
    stateHook = stateHook.memoizedState;
    currentStateHook = $1e79381dc3a64a75$var$updateWorkInProgressHook();
    var dispatch = currentStateHook.queue.dispatch;
    currentStateHook.memoizedState = action;
    return [
        stateHook,
        dispatch,
        !1
    ];
}
function $1e79381dc3a64a75$var$pushSimpleEffect(tag, inst, create, deps) {
    tag = {
        tag: tag,
        create: create,
        deps: deps,
        inst: inst,
        next: null
    };
    inst = $1e79381dc3a64a75$var$currentlyRenderingFiber.updateQueue;
    null === inst && (inst = $1e79381dc3a64a75$var$createFunctionComponentUpdateQueue(), $1e79381dc3a64a75$var$currentlyRenderingFiber.updateQueue = inst);
    create = inst.lastEffect;
    null === create ? inst.lastEffect = tag.next = tag : (deps = create.next, create.next = tag, tag.next = deps, inst.lastEffect = tag);
    return tag;
}
function $1e79381dc3a64a75$var$updateRef() {
    return $1e79381dc3a64a75$var$updateWorkInProgressHook().memoizedState;
}
function $1e79381dc3a64a75$var$mountEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $1e79381dc3a64a75$var$mountWorkInProgressHook();
    $1e79381dc3a64a75$var$currentlyRenderingFiber.flags |= fiberFlags;
    hook.memoizedState = $1e79381dc3a64a75$var$pushSimpleEffect(1 | hookFlags, {
        destroy: void 0
    }, create, void 0 === deps ? null : deps);
}
function $1e79381dc3a64a75$var$updateEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $1e79381dc3a64a75$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var inst = hook.memoizedState.inst;
    null !== $1e79381dc3a64a75$var$currentHook && null !== deps && $1e79381dc3a64a75$var$areHookInputsEqual(deps, $1e79381dc3a64a75$var$currentHook.memoizedState.deps) ? hook.memoizedState = $1e79381dc3a64a75$var$pushSimpleEffect(hookFlags, inst, create, deps) : ($1e79381dc3a64a75$var$currentlyRenderingFiber.flags |= fiberFlags, hook.memoizedState = $1e79381dc3a64a75$var$pushSimpleEffect(1 | hookFlags, inst, create, deps));
}
function $1e79381dc3a64a75$var$mountEffect(create, deps) {
    $1e79381dc3a64a75$var$mountEffectImpl(8390656, 8, create, deps);
}
function $1e79381dc3a64a75$var$updateEffect(create, deps) {
    $1e79381dc3a64a75$var$updateEffectImpl(2048, 8, create, deps);
}
function $1e79381dc3a64a75$var$useEffectEventImpl(payload) {
    $1e79381dc3a64a75$var$currentlyRenderingFiber.flags |= 4;
    var componentUpdateQueue = $1e79381dc3a64a75$var$currentlyRenderingFiber.updateQueue;
    if (null === componentUpdateQueue) componentUpdateQueue = $1e79381dc3a64a75$var$createFunctionComponentUpdateQueue(), $1e79381dc3a64a75$var$currentlyRenderingFiber.updateQueue = componentUpdateQueue, componentUpdateQueue.events = [
        payload
    ];
    else {
        var events = componentUpdateQueue.events;
        null === events ? componentUpdateQueue.events = [
            payload
        ] : events.push(payload);
    }
}
function $1e79381dc3a64a75$var$updateEvent(callback) {
    var ref = $1e79381dc3a64a75$var$updateWorkInProgressHook().memoizedState;
    $1e79381dc3a64a75$var$useEffectEventImpl({
        ref: ref,
        nextImpl: callback
    });
    return function() {
        if (0 !== ($1e79381dc3a64a75$var$executionContext & 2)) throw Error($1e79381dc3a64a75$var$formatProdErrorMessage(440));
        return ref.impl.apply(void 0, arguments);
    };
}
function $1e79381dc3a64a75$var$updateInsertionEffect(create, deps) {
    return $1e79381dc3a64a75$var$updateEffectImpl(4, 2, create, deps);
}
function $1e79381dc3a64a75$var$updateLayoutEffect(create, deps) {
    return $1e79381dc3a64a75$var$updateEffectImpl(4, 4, create, deps);
}
function $1e79381dc3a64a75$var$imperativeHandleEffect(create, ref) {
    if ("function" === typeof ref) {
        create = create();
        var refCleanup = ref(create);
        return function() {
            "function" === typeof refCleanup ? refCleanup() : ref(null);
        };
    }
    if (null !== ref && void 0 !== ref) return create = create(), ref.current = create, function() {
        ref.current = null;
    };
}
function $1e79381dc3a64a75$var$updateImperativeHandle(ref, create, deps) {
    deps = null !== deps && void 0 !== deps ? deps.concat([
        ref
    ]) : null;
    $1e79381dc3a64a75$var$updateEffectImpl(4, 4, $1e79381dc3a64a75$var$imperativeHandleEffect.bind(null, create, ref), deps);
}
function $1e79381dc3a64a75$var$mountDebugValue() {}
function $1e79381dc3a64a75$var$updateCallback(callback, deps) {
    var hook = $1e79381dc3a64a75$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $1e79381dc3a64a75$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    hook.memoizedState = [
        callback,
        deps
    ];
    return callback;
}
function $1e79381dc3a64a75$var$updateMemo(nextCreate, deps) {
    var hook = $1e79381dc3a64a75$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $1e79381dc3a64a75$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    prevState = nextCreate();
    if ($1e79381dc3a64a75$var$shouldDoubleInvokeUserFnsInHooksDEV) {
        $1e79381dc3a64a75$var$setIsStrictModeForDevtools(!0);
        try {
            nextCreate();
        } finally{
            $1e79381dc3a64a75$var$setIsStrictModeForDevtools(!1);
        }
    }
    hook.memoizedState = [
        prevState,
        deps
    ];
    return prevState;
}
function $1e79381dc3a64a75$var$mountDeferredValueImpl(hook, value, initialValue) {
    if (void 0 === initialValue || 0 !== ($1e79381dc3a64a75$var$renderLanes & 1073741824) && 0 === ($1e79381dc3a64a75$var$workInProgressRootRenderLanes & 261930)) return hook.memoizedState = value;
    hook.memoizedState = initialValue;
    hook = $1e79381dc3a64a75$var$requestDeferredLane();
    $1e79381dc3a64a75$var$currentlyRenderingFiber.lanes |= hook;
    $1e79381dc3a64a75$var$workInProgressRootSkippedLanes |= hook;
    return initialValue;
}
function $1e79381dc3a64a75$var$updateDeferredValueImpl(hook, prevValue, value, initialValue) {
    if ($1e79381dc3a64a75$var$objectIs(value, prevValue)) return value;
    if (null !== $1e79381dc3a64a75$var$currentTreeHiddenStackCursor.current) return hook = $1e79381dc3a64a75$var$mountDeferredValueImpl(hook, value, initialValue), $1e79381dc3a64a75$var$objectIs(hook, prevValue) || ($1e79381dc3a64a75$var$didReceiveUpdate = !0), hook;
    if (0 === ($1e79381dc3a64a75$var$renderLanes & 106) || 0 !== ($1e79381dc3a64a75$var$renderLanes & 1073741824) && 0 === ($1e79381dc3a64a75$var$workInProgressRootRenderLanes & 261930)) return $1e79381dc3a64a75$var$didReceiveUpdate = !0, hook.memoizedState = value;
    hook = $1e79381dc3a64a75$var$requestDeferredLane();
    $1e79381dc3a64a75$var$currentlyRenderingFiber.lanes |= hook;
    $1e79381dc3a64a75$var$workInProgressRootSkippedLanes |= hook;
    return prevValue;
}
function $1e79381dc3a64a75$var$startTransition(fiber, queue, pendingState, finishedState, callback) {
    var previousPriority = $1e79381dc3a64a75$var$ReactDOMSharedInternals.p;
    $1e79381dc3a64a75$var$ReactDOMSharedInternals.p = 0 !== previousPriority && 8 > previousPriority ? previousPriority : 8;
    var prevTransition = $1e79381dc3a64a75$var$ReactSharedInternals.T, currentTransition = {};
    currentTransition.types = null !== prevTransition ? prevTransition.types : null;
    $1e79381dc3a64a75$var$ReactSharedInternals.T = currentTransition;
    $1e79381dc3a64a75$var$dispatchOptimisticSetState(fiber, !1, queue, pendingState);
    try {
        var returnValue = callback(), onStartTransitionFinish = $1e79381dc3a64a75$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        if (null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then) {
            var thenableForFinishedState = $1e79381dc3a64a75$var$chainThenableValue(returnValue, finishedState);
            $1e79381dc3a64a75$var$dispatchSetStateInternal(fiber, queue, thenableForFinishedState, $1e79381dc3a64a75$var$requestUpdateLane(fiber));
        } else $1e79381dc3a64a75$var$dispatchSetStateInternal(fiber, queue, finishedState, $1e79381dc3a64a75$var$requestUpdateLane(fiber));
    } catch (error) {
        $1e79381dc3a64a75$var$dispatchSetStateInternal(fiber, queue, {
            then: function() {},
            status: "rejected",
            reason: error
        }, $1e79381dc3a64a75$var$requestUpdateLane());
    } finally{
        $1e79381dc3a64a75$var$ReactDOMSharedInternals.p = previousPriority, null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $1e79381dc3a64a75$var$ReactSharedInternals.T = prevTransition;
    }
}
function $1e79381dc3a64a75$var$noop() {}
function $1e79381dc3a64a75$var$startHostTransition(formFiber, pendingState, action, formData) {
    if (5 !== formFiber.tag) throw Error($1e79381dc3a64a75$var$formatProdErrorMessage(476));
    var queue = $1e79381dc3a64a75$var$ensureFormComponentIsStateful(formFiber).queue;
    $1e79381dc3a64a75$var$startTransition(formFiber, queue, pendingState, $1e79381dc3a64a75$var$sharedNotPendingObject, null === action ? $1e79381dc3a64a75$var$noop : function() {
        $1e79381dc3a64a75$var$requestFormReset$1(formFiber);
        return action(formData);
    });
}
function $1e79381dc3a64a75$var$ensureFormComponentIsStateful(formFiber) {
    var existingStateHook = formFiber.memoizedState;
    if (null !== existingStateHook) return existingStateHook;
    existingStateHook = {
        memoizedState: $1e79381dc3a64a75$var$sharedNotPendingObject,
        baseState: $1e79381dc3a64a75$var$sharedNotPendingObject,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $1e79381dc3a64a75$var$basicStateReducer,
            lastRenderedState: $1e79381dc3a64a75$var$sharedNotPendingObject
        },
        next: null
    };
    var initialResetState = {};
    existingStateHook.next = {
        memoizedState: initialResetState,
        baseState: initialResetState,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $1e79381dc3a64a75$var$basicStateReducer,
            lastRenderedState: initialResetState
        },
        next: null
    };
    formFiber.memoizedState = existingStateHook;
    formFiber = formFiber.alternate;
    null !== formFiber && (formFiber.memoizedState = existingStateHook);
    return existingStateHook;
}
function $1e79381dc3a64a75$var$requestFormReset$1(formFiber) {
    var stateHook = $1e79381dc3a64a75$var$ensureFormComponentIsStateful(formFiber);
    null === stateHook.next && (stateHook = formFiber.alternate.memoizedState);
    $1e79381dc3a64a75$var$dispatchSetStateInternal(formFiber, stateHook.next.queue, {}, $1e79381dc3a64a75$var$requestUpdateLane());
}
function $1e79381dc3a64a75$var$useHostTransitionStatus() {
    return $1e79381dc3a64a75$var$readContext($1e79381dc3a64a75$var$HostTransitionContext);
}
function $1e79381dc3a64a75$var$updateId() {
    return $1e79381dc3a64a75$var$updateWorkInProgressHook().memoizedState;
}
function $1e79381dc3a64a75$var$updateRefresh() {
    return $1e79381dc3a64a75$var$updateWorkInProgressHook().memoizedState;
}
function $1e79381dc3a64a75$var$refreshCache(fiber) {
    for(var provider = fiber.return; null !== provider;){
        switch(provider.tag){
            case 24:
            case 3:
                var lane = $1e79381dc3a64a75$var$requestUpdateLane();
                fiber = $1e79381dc3a64a75$var$createUpdate(lane);
                var root$73 = $1e79381dc3a64a75$var$enqueueUpdate(provider, fiber, lane);
                null !== root$73 && ($1e79381dc3a64a75$var$scheduleUpdateOnFiber(root$73, provider, lane), $1e79381dc3a64a75$var$entangleTransitions(root$73, provider, lane));
                provider = {
                    cache: $1e79381dc3a64a75$var$createCache()
                };
                fiber.payload = provider;
                return;
        }
        provider = provider.return;
    }
}
function $1e79381dc3a64a75$var$dispatchReducerAction(fiber, queue, action) {
    var lane = $1e79381dc3a64a75$var$requestUpdateLane();
    action = {
        lane: lane,
        revertLane: 0,
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    $1e79381dc3a64a75$var$isRenderPhaseUpdate(fiber) ? $1e79381dc3a64a75$var$enqueueRenderPhaseUpdate(queue, action) : (action = $1e79381dc3a64a75$var$enqueueConcurrentHookUpdate(fiber, queue, action, lane), null !== action && ($1e79381dc3a64a75$var$scheduleUpdateOnFiber(action, fiber, lane), $1e79381dc3a64a75$var$entangleTransitionUpdate(action, queue, lane)));
}
function $1e79381dc3a64a75$var$dispatchSetState(fiber, queue, action) {
    var lane = $1e79381dc3a64a75$var$requestUpdateLane();
    $1e79381dc3a64a75$var$dispatchSetStateInternal(fiber, queue, action, lane);
}
function $1e79381dc3a64a75$var$dispatchSetStateInternal(fiber, queue, action, lane) {
    var update = {
        lane: lane,
        revertLane: 0,
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($1e79381dc3a64a75$var$isRenderPhaseUpdate(fiber)) $1e79381dc3a64a75$var$enqueueRenderPhaseUpdate(queue, update);
    else {
        var alternate = fiber.alternate;
        if (0 === fiber.lanes && (null === alternate || 0 === alternate.lanes) && (alternate = queue.lastRenderedReducer, null !== alternate)) try {
            var currentState = queue.lastRenderedState, eagerState = alternate(currentState, action);
            update.hasEagerState = !0;
            update.eagerState = eagerState;
            if ($1e79381dc3a64a75$var$objectIs(eagerState, currentState)) return $1e79381dc3a64a75$var$enqueueUpdate$1(fiber, queue, update, 0), null === $1e79381dc3a64a75$var$workInProgressRoot && $1e79381dc3a64a75$var$finishQueueingConcurrentUpdates(), !1;
        } catch (error) {} finally{}
        action = $1e79381dc3a64a75$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane);
        if (null !== action) return $1e79381dc3a64a75$var$scheduleUpdateOnFiber(action, fiber, lane), $1e79381dc3a64a75$var$entangleTransitionUpdate(action, queue, lane), !0;
    }
    return !1;
}
function $1e79381dc3a64a75$var$dispatchOptimisticSetState(fiber, throwIfDuringRender, queue, action) {
    action = {
        lane: 2,
        revertLane: $1e79381dc3a64a75$var$requestTransitionLane(),
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($1e79381dc3a64a75$var$isRenderPhaseUpdate(fiber)) {
        if (throwIfDuringRender) throw Error($1e79381dc3a64a75$var$formatProdErrorMessage(479));
    } else throwIfDuringRender = $1e79381dc3a64a75$var$enqueueConcurrentHookUpdate(fiber, queue, action, 2), null !== throwIfDuringRender && $1e79381dc3a64a75$var$scheduleUpdateOnFiber(throwIfDuringRender, fiber, 2);
}
function $1e79381dc3a64a75$var$isRenderPhaseUpdate(fiber) {
    var alternate = fiber.alternate;
    return fiber === $1e79381dc3a64a75$var$currentlyRenderingFiber || null !== alternate && alternate === $1e79381dc3a64a75$var$currentlyRenderingFiber;
}
function $1e79381dc3a64a75$var$enqueueRenderPhaseUpdate(queue, update) {
    $1e79381dc3a64a75$var$didScheduleRenderPhaseUpdateDuringThisPass = $1e79381dc3a64a75$var$didScheduleRenderPhaseUpdate = !0;
    var pending = queue.pending;
    null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
    queue.pending = update;
}
function $1e79381dc3a64a75$var$entangleTransitionUpdate(root, queue, lane) {
    if (0 !== (lane & 4194048)) {
        var queueLanes = queue.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        queue.lanes = lane;
        $1e79381dc3a64a75$var$markRootEntangled(root, lane);
    }
}
var $1e79381dc3a64a75$var$ContextOnlyDispatcher = {
    readContext: $1e79381dc3a64a75$var$readContext,
    use: $1e79381dc3a64a75$var$use,
    useCallback: $1e79381dc3a64a75$var$throwInvalidHookError,
    useContext: $1e79381dc3a64a75$var$throwInvalidHookError,
    useEffect: $1e79381dc3a64a75$var$throwInvalidHookError,
    useImperativeHandle: $1e79381dc3a64a75$var$throwInvalidHookError,
    useLayoutEffect: $1e79381dc3a64a75$var$throwInvalidHookError,
    useInsertionEffect: $1e79381dc3a64a75$var$throwInvalidHookError,
    useMemo: $1e79381dc3a64a75$var$throwInvalidHookError,
    useReducer: $1e79381dc3a64a75$var$throwInvalidHookError,
    useRef: $1e79381dc3a64a75$var$throwInvalidHookError,
    useState: $1e79381dc3a64a75$var$throwInvalidHookError,
    useDebugValue: $1e79381dc3a64a75$var$throwInvalidHookError,
    useDeferredValue: $1e79381dc3a64a75$var$throwInvalidHookError,
    useTransition: $1e79381dc3a64a75$var$throwInvalidHookError,
    useSyncExternalStore: $1e79381dc3a64a75$var$throwInvalidHookError,
    useId: $1e79381dc3a64a75$var$throwInvalidHookError,
    useHostTransitionStatus: $1e79381dc3a64a75$var$throwInvalidHookError,
    useFormState: $1e79381dc3a64a75$var$throwInvalidHookError,
    useActionState: $1e79381dc3a64a75$var$throwInvalidHookError,
    useOptimistic: $1e79381dc3a64a75$var$throwInvalidHookError,
    useMemoCache: $1e79381dc3a64a75$var$throwInvalidHookError,
    useCacheRefresh: $1e79381dc3a64a75$var$throwInvalidHookError,
    useEffectEvent: $1e79381dc3a64a75$var$throwInvalidHookError
}, $1e79381dc3a64a75$var$HooksDispatcherOnMount = {
    readContext: $1e79381dc3a64a75$var$readContext,
    use: $1e79381dc3a64a75$var$use,
    useCallback: function(callback, deps) {
        $1e79381dc3a64a75$var$mountWorkInProgressHook().memoizedState = [
            callback,
            void 0 === deps ? null : deps
        ];
        return callback;
    },
    useContext: $1e79381dc3a64a75$var$readContext,
    useEffect: $1e79381dc3a64a75$var$mountEffect,
    useImperativeHandle: function(ref, create, deps) {
        deps = null !== deps && void 0 !== deps ? deps.concat([
            ref
        ]) : null;
        $1e79381dc3a64a75$var$mountEffectImpl(4194308, 4, $1e79381dc3a64a75$var$imperativeHandleEffect.bind(null, create, ref), deps);
    },
    useLayoutEffect: function(create, deps) {
        return $1e79381dc3a64a75$var$mountEffectImpl(4194308, 4, create, deps);
    },
    useInsertionEffect: function(create, deps) {
        $1e79381dc3a64a75$var$mountEffectImpl(4, 2, create, deps);
    },
    useMemo: function(nextCreate, deps) {
        var hook = $1e79381dc3a64a75$var$mountWorkInProgressHook();
        deps = void 0 === deps ? null : deps;
        var nextValue = nextCreate();
        if ($1e79381dc3a64a75$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $1e79381dc3a64a75$var$setIsStrictModeForDevtools(!0);
            try {
                nextCreate();
            } finally{
                $1e79381dc3a64a75$var$setIsStrictModeForDevtools(!1);
            }
        }
        hook.memoizedState = [
            nextValue,
            deps
        ];
        return nextValue;
    },
    useReducer: function(reducer, initialArg, init) {
        var hook = $1e79381dc3a64a75$var$mountWorkInProgressHook();
        if (void 0 !== init) {
            var initialState = init(initialArg);
            if ($1e79381dc3a64a75$var$shouldDoubleInvokeUserFnsInHooksDEV) {
                $1e79381dc3a64a75$var$setIsStrictModeForDevtools(!0);
                try {
                    init(initialArg);
                } finally{
                    $1e79381dc3a64a75$var$setIsStrictModeForDevtools(!1);
                }
            }
        } else initialState = initialArg;
        hook.memoizedState = hook.baseState = initialState;
        reducer = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: reducer,
            lastRenderedState: initialState
        };
        hook.queue = reducer;
        reducer = reducer.dispatch = $1e79381dc3a64a75$var$dispatchReducerAction.bind(null, $1e79381dc3a64a75$var$currentlyRenderingFiber, reducer);
        return [
            hook.memoizedState,
            reducer
        ];
    },
    useRef: function(initialValue) {
        var hook = $1e79381dc3a64a75$var$mountWorkInProgressHook();
        initialValue = {
            current: initialValue
        };
        return hook.memoizedState = initialValue;
    },
    useState: function(initialState) {
        initialState = $1e79381dc3a64a75$var$mountStateImpl(initialState);
        var queue = initialState.queue, dispatch = $1e79381dc3a64a75$var$dispatchSetState.bind(null, $1e79381dc3a64a75$var$currentlyRenderingFiber, queue);
        queue.dispatch = dispatch;
        return [
            initialState.memoizedState,
            dispatch
        ];
    },
    useDebugValue: $1e79381dc3a64a75$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $1e79381dc3a64a75$var$mountWorkInProgressHook();
        return $1e79381dc3a64a75$var$mountDeferredValueImpl(hook, value, initialValue);
    },
    useTransition: function() {
        var stateHook = $1e79381dc3a64a75$var$mountStateImpl(!1);
        stateHook = $1e79381dc3a64a75$var$startTransition.bind(null, $1e79381dc3a64a75$var$currentlyRenderingFiber, stateHook.queue, !0, !1);
        $1e79381dc3a64a75$var$mountWorkInProgressHook().memoizedState = stateHook;
        return [
            !1,
            stateHook
        ];
    },
    useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
        var fiber = $1e79381dc3a64a75$var$currentlyRenderingFiber, hook = $1e79381dc3a64a75$var$mountWorkInProgressHook();
        if ($1e79381dc3a64a75$var$isHydrating) {
            if (void 0 === getServerSnapshot) throw Error($1e79381dc3a64a75$var$formatProdErrorMessage(407));
            getServerSnapshot = getServerSnapshot();
        } else {
            getServerSnapshot = getSnapshot();
            if (null === $1e79381dc3a64a75$var$workInProgressRoot) throw Error($1e79381dc3a64a75$var$formatProdErrorMessage(349));
            0 !== ($1e79381dc3a64a75$var$workInProgressRootRenderLanes & 127) || $1e79381dc3a64a75$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
        }
        hook.memoizedState = getServerSnapshot;
        var inst = {
            value: getServerSnapshot,
            getSnapshot: getSnapshot
        };
        hook.queue = inst;
        $1e79381dc3a64a75$var$mountEffect($1e79381dc3a64a75$var$subscribeToStore.bind(null, fiber, inst, subscribe), [
            subscribe
        ]);
        fiber.flags |= 2048;
        $1e79381dc3a64a75$var$pushSimpleEffect(9, {
            destroy: void 0
        }, $1e79381dc3a64a75$var$updateStoreInstance.bind(null, fiber, inst, getServerSnapshot, getSnapshot), null);
        return getServerSnapshot;
    },
    useId: function() {
        var hook = $1e79381dc3a64a75$var$mountWorkInProgressHook(), identifierPrefix = $1e79381dc3a64a75$var$workInProgressRoot.identifierPrefix;
        if ($1e79381dc3a64a75$var$isHydrating) {
            var JSCompiler_inline_result = $1e79381dc3a64a75$var$treeContextOverflow;
            var idWithLeadingBit = $1e79381dc3a64a75$var$treeContextId;
            JSCompiler_inline_result = (idWithLeadingBit & ~(1 << 32 - $1e79381dc3a64a75$var$clz32(idWithLeadingBit) - 1)).toString(32) + JSCompiler_inline_result;
            identifierPrefix = "_" + identifierPrefix + "R_" + JSCompiler_inline_result;
            JSCompiler_inline_result = $1e79381dc3a64a75$var$localIdCounter++;
            0 < JSCompiler_inline_result && (identifierPrefix += "H" + JSCompiler_inline_result.toString(32));
            identifierPrefix += "_";
        } else JSCompiler_inline_result = $1e79381dc3a64a75$var$globalClientIdCounter++, identifierPrefix = "_" + identifierPrefix + "r_" + JSCompiler_inline_result.toString(32) + "_";
        return hook.memoizedState = identifierPrefix;
    },
    useHostTransitionStatus: $1e79381dc3a64a75$var$useHostTransitionStatus,
    useFormState: $1e79381dc3a64a75$var$mountActionState,
    useActionState: $1e79381dc3a64a75$var$mountActionState,
    useOptimistic: function(passthrough) {
        var hook = $1e79381dc3a64a75$var$mountWorkInProgressHook();
        hook.memoizedState = hook.baseState = passthrough;
        var queue = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: null,
            lastRenderedState: null
        };
        hook.queue = queue;
        hook = $1e79381dc3a64a75$var$dispatchOptimisticSetState.bind(null, $1e79381dc3a64a75$var$currentlyRenderingFiber, !0, queue);
        queue.dispatch = hook;
        return [
            passthrough,
            hook
        ];
    },
    useMemoCache: $1e79381dc3a64a75$var$useMemoCache,
    useCacheRefresh: function() {
        return $1e79381dc3a64a75$var$mountWorkInProgressHook().memoizedState = $1e79381dc3a64a75$var$refreshCache.bind(null, $1e79381dc3a64a75$var$currentlyRenderingFiber);
    },
    useEffectEvent: function(callback) {
        var hook = $1e79381dc3a64a75$var$mountWorkInProgressHook(), ref = {
            impl: callback
        };
        hook.memoizedState = ref;
        return function() {
            if (0 !== ($1e79381dc3a64a75$var$executionContext & 2)) throw Error($1e79381dc3a64a75$var$formatProdErrorMessage(440));
            return ref.impl.apply(void 0, arguments);
        };
    }
}, $1e79381dc3a64a75$var$HooksDispatcherOnUpdate = {
    readContext: $1e79381dc3a64a75$var$readContext,
    use: $1e79381dc3a64a75$var$use,
    useCallback: $1e79381dc3a64a75$var$updateCallback,
    useContext: $1e79381dc3a64a75$var$readContext,
    useEffect: $1e79381dc3a64a75$var$updateEffect,
    useImperativeHandle: $1e79381dc3a64a75$var$updateImperativeHandle,
    useInsertionEffect: $1e79381dc3a64a75$var$updateInsertionEffect,
    useLayoutEffect: $1e79381dc3a64a75$var$updateLayoutEffect,
    useMemo: $1e79381dc3a64a75$var$updateMemo,
    useReducer: $1e79381dc3a64a75$var$updateReducer,
    useRef: $1e79381dc3a64a75$var$updateRef,
    useState: function() {
        return $1e79381dc3a64a75$var$updateReducer($1e79381dc3a64a75$var$basicStateReducer);
    },
    useDebugValue: $1e79381dc3a64a75$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $1e79381dc3a64a75$var$updateWorkInProgressHook();
        return $1e79381dc3a64a75$var$updateDeferredValueImpl(hook, $1e79381dc3a64a75$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $1e79381dc3a64a75$var$updateReducer($1e79381dc3a64a75$var$basicStateReducer)[0], start = $1e79381dc3a64a75$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $1e79381dc3a64a75$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $1e79381dc3a64a75$var$updateSyncExternalStore,
    useId: $1e79381dc3a64a75$var$updateId,
    useHostTransitionStatus: $1e79381dc3a64a75$var$useHostTransitionStatus,
    useFormState: $1e79381dc3a64a75$var$updateActionState,
    useActionState: $1e79381dc3a64a75$var$updateActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $1e79381dc3a64a75$var$updateWorkInProgressHook();
        return $1e79381dc3a64a75$var$updateOptimisticImpl(hook, $1e79381dc3a64a75$var$currentHook, passthrough, reducer);
    },
    useMemoCache: $1e79381dc3a64a75$var$useMemoCache,
    useCacheRefresh: $1e79381dc3a64a75$var$updateRefresh,
    useEffectEvent: $1e79381dc3a64a75$var$updateEvent
}, $1e79381dc3a64a75$var$HooksDispatcherOnRerender = {
    readContext: $1e79381dc3a64a75$var$readContext,
    use: $1e79381dc3a64a75$var$use,
    useCallback: $1e79381dc3a64a75$var$updateCallback,
    useContext: $1e79381dc3a64a75$var$readContext,
    useEffect: $1e79381dc3a64a75$var$updateEffect,
    useImperativeHandle: $1e79381dc3a64a75$var$updateImperativeHandle,
    useInsertionEffect: $1e79381dc3a64a75$var$updateInsertionEffect,
    useLayoutEffect: $1e79381dc3a64a75$var$updateLayoutEffect,
    useMemo: $1e79381dc3a64a75$var$updateMemo,
    useReducer: $1e79381dc3a64a75$var$rerenderReducer,
    useRef: $1e79381dc3a64a75$var$updateRef,
    useState: function() {
        return $1e79381dc3a64a75$var$rerenderReducer($1e79381dc3a64a75$var$basicStateReducer);
    },
    useDebugValue: $1e79381dc3a64a75$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $1e79381dc3a64a75$var$updateWorkInProgressHook();
        return null === $1e79381dc3a64a75$var$currentHook ? $1e79381dc3a64a75$var$mountDeferredValueImpl(hook, value, initialValue) : $1e79381dc3a64a75$var$updateDeferredValueImpl(hook, $1e79381dc3a64a75$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $1e79381dc3a64a75$var$rerenderReducer($1e79381dc3a64a75$var$basicStateReducer)[0], start = $1e79381dc3a64a75$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $1e79381dc3a64a75$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $1e79381dc3a64a75$var$updateSyncExternalStore,
    useId: $1e79381dc3a64a75$var$updateId,
    useHostTransitionStatus: $1e79381dc3a64a75$var$useHostTransitionStatus,
    useFormState: $1e79381dc3a64a75$var$rerenderActionState,
    useActionState: $1e79381dc3a64a75$var$rerenderActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $1e79381dc3a64a75$var$updateWorkInProgressHook();
        if (null !== $1e79381dc3a64a75$var$currentHook) return $1e79381dc3a64a75$var$updateOptimisticImpl(hook, $1e79381dc3a64a75$var$currentHook, passthrough, reducer);
        hook.baseState = passthrough;
        return [
            passthrough,
            hook.queue.dispatch
        ];
    },
    useMemoCache: $1e79381dc3a64a75$var$useMemoCache,
    useCacheRefresh: $1e79381dc3a64a75$var$updateRefresh,
    useEffectEvent: $1e79381dc3a64a75$var$updateEvent
};
function $1e79381dc3a64a75$var$applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, nextProps) {
    ctor = workInProgress.memoizedState;
    getDerivedStateFromProps = getDerivedStateFromProps(nextProps, ctor);
    getDerivedStateFromProps = null === getDerivedStateFromProps || void 0 === getDerivedStateFromProps ? ctor : $1e79381dc3a64a75$var$assign({}, ctor, getDerivedStateFromProps);
    workInProgress.memoizedState = getDerivedStateFromProps;
    0 === workInProgress.lanes && (workInProgress.updateQueue.baseState = getDerivedStateFromProps);
}
var $1e79381dc3a64a75$var$classComponentUpdater = {
    enqueueSetState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $1e79381dc3a64a75$var$requestUpdateLane(), update = $1e79381dc3a64a75$var$createUpdate(lane);
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $1e79381dc3a64a75$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($1e79381dc3a64a75$var$scheduleUpdateOnFiber(payload, inst, lane), $1e79381dc3a64a75$var$entangleTransitions(payload, inst, lane));
    },
    enqueueReplaceState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $1e79381dc3a64a75$var$requestUpdateLane(), update = $1e79381dc3a64a75$var$createUpdate(lane);
        update.tag = 1;
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $1e79381dc3a64a75$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($1e79381dc3a64a75$var$scheduleUpdateOnFiber(payload, inst, lane), $1e79381dc3a64a75$var$entangleTransitions(payload, inst, lane));
    },
    enqueueForceUpdate: function(inst, callback) {
        inst = inst._reactInternals;
        var lane = $1e79381dc3a64a75$var$requestUpdateLane(), update = $1e79381dc3a64a75$var$createUpdate(lane);
        update.tag = 2;
        void 0 !== callback && null !== callback && (update.callback = callback);
        callback = $1e79381dc3a64a75$var$enqueueUpdate(inst, update, lane);
        null !== callback && ($1e79381dc3a64a75$var$scheduleUpdateOnFiber(callback, inst, lane), $1e79381dc3a64a75$var$entangleTransitions(callback, inst, lane));
    }
};
function $1e79381dc3a64a75$var$checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) {
    workInProgress = workInProgress.stateNode;
    return "function" === typeof workInProgress.shouldComponentUpdate ? workInProgress.shouldComponentUpdate(newProps, newState, nextContext) : ctor.prototype && ctor.prototype.isPureReactComponent ? !$1e79381dc3a64a75$var$shallowEqual(oldProps, newProps) || !$1e79381dc3a64a75$var$shallowEqual(oldState, newState) : !0;
}
function $1e79381dc3a64a75$var$callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext) {
    workInProgress = instance.state;
    "function" === typeof instance.componentWillReceiveProps && instance.componentWillReceiveProps(newProps, nextContext);
    "function" === typeof instance.UNSAFE_componentWillReceiveProps && instance.UNSAFE_componentWillReceiveProps(newProps, nextContext);
    instance.state !== workInProgress && $1e79381dc3a64a75$var$classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
}
function $1e79381dc3a64a75$var$resolveClassComponentProps(Component, baseProps) {
    var newProps = baseProps;
    if ("ref" in baseProps) {
        newProps = {};
        for(var propName in baseProps)"ref" !== propName && (newProps[propName] = baseProps[propName]);
    }
    if (Component = Component.defaultProps) {
        newProps === baseProps && (newProps = $1e79381dc3a64a75$var$assign({}, newProps));
        for(var propName$77 in Component)void 0 === newProps[propName$77] && (newProps[propName$77] = Component[propName$77]);
    }
    return newProps;
}
function $1e79381dc3a64a75$var$defaultOnUncaughtError(error) {
    $1e79381dc3a64a75$var$reportGlobalError(error);
}
function $1e79381dc3a64a75$var$defaultOnCaughtError(error) {
    console.error(error);
}
function $1e79381dc3a64a75$var$defaultOnRecoverableError(error) {
    $1e79381dc3a64a75$var$reportGlobalError(error);
}
function $1e79381dc3a64a75$var$logUncaughtError(root, errorInfo) {
    try {
        var onUncaughtError = root.onUncaughtError;
        onUncaughtError(errorInfo.value, {
            componentStack: errorInfo.stack
        });
    } catch (e$78) {
        setTimeout(function() {
            throw e$78;
        });
    }
}
function $1e79381dc3a64a75$var$logCaughtError(root, boundary, errorInfo) {
    try {
        var onCaughtError = root.onCaughtError;
        onCaughtError(errorInfo.value, {
            componentStack: errorInfo.stack,
            errorBoundary: 1 === boundary.tag ? boundary.stateNode : null
        });
    } catch (e$79) {
        setTimeout(function() {
            throw e$79;
        });
    }
}
function $1e79381dc3a64a75$var$createRootErrorUpdate(root, errorInfo, lane) {
    lane = $1e79381dc3a64a75$var$createUpdate(lane);
    lane.tag = 3;
    lane.payload = {
        element: null
    };
    lane.callback = function() {
        $1e79381dc3a64a75$var$logUncaughtError(root, errorInfo);
    };
    return lane;
}
function $1e79381dc3a64a75$var$createClassErrorUpdate(lane) {
    lane = $1e79381dc3a64a75$var$createUpdate(lane);
    lane.tag = 3;
    return lane;
}
function $1e79381dc3a64a75$var$initializeClassErrorUpdate(update, root, fiber, errorInfo) {
    var getDerivedStateFromError = fiber.type.getDerivedStateFromError;
    if ("function" === typeof getDerivedStateFromError) {
        var error = errorInfo.value;
        update.payload = function() {
            return getDerivedStateFromError(error);
        };
        update.callback = function() {
            $1e79381dc3a64a75$var$logCaughtError(root, fiber, errorInfo);
        };
    }
    var inst = fiber.stateNode;
    null !== inst && "function" === typeof inst.componentDidCatch && (update.callback = function() {
        $1e79381dc3a64a75$var$logCaughtError(root, fiber, errorInfo);
        "function" !== typeof getDerivedStateFromError && (null === $1e79381dc3a64a75$var$legacyErrorBoundariesThatAlreadyFailed ? $1e79381dc3a64a75$var$legacyErrorBoundariesThatAlreadyFailed = new Set([
            this
        ]) : $1e79381dc3a64a75$var$legacyErrorBoundariesThatAlreadyFailed.add(this));
        var stack = errorInfo.stack;
        this.componentDidCatch(errorInfo.value, {
            componentStack: null !== stack ? stack : ""
        });
    });
}
function $1e79381dc3a64a75$var$throwException(root, returnFiber, sourceFiber, value, rootRenderLanes) {
    sourceFiber.flags |= 32768;
    if (null !== value && "object" === typeof value && "function" === typeof value.then) {
        returnFiber = sourceFiber.alternate;
        null !== returnFiber && $1e79381dc3a64a75$var$propagateParentContextChanges(returnFiber, sourceFiber, rootRenderLanes, !0);
        sourceFiber = $1e79381dc3a64a75$var$suspenseHandlerStackCursor.current;
        if (null !== sourceFiber) {
            switch(sourceFiber.tag){
                case 31:
                case 13:
                case 19:
                    return null === $1e79381dc3a64a75$var$shellBoundary ? $1e79381dc3a64a75$var$renderDidSuspendDelayIfPossible() : null === sourceFiber.alternate && 0 === $1e79381dc3a64a75$var$workInProgressRootExitStatus && ($1e79381dc3a64a75$var$workInProgressRootExitStatus = 3), sourceFiber.flags &= -257, sourceFiber.flags |= 65536, sourceFiber.lanes = rootRenderLanes, value === $1e79381dc3a64a75$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? sourceFiber.updateQueue = new Set([
                        value
                    ]) : returnFiber.add(value), $1e79381dc3a64a75$var$attachPingListener(root, value, rootRenderLanes)), !1;
                case 22:
                    return sourceFiber.flags |= 65536, value === $1e79381dc3a64a75$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? (returnFiber = {
                        transitions: null,
                        markerInstances: null,
                        retryQueue: new Set([
                            value
                        ])
                    }, sourceFiber.updateQueue = returnFiber) : (sourceFiber = returnFiber.retryQueue, null === sourceFiber ? returnFiber.retryQueue = new Set([
                        value
                    ]) : sourceFiber.add(value)), $1e79381dc3a64a75$var$attachPingListener(root, value, rootRenderLanes)), !1;
            }
            throw Error($1e79381dc3a64a75$var$formatProdErrorMessage(435, sourceFiber.tag));
        }
        $1e79381dc3a64a75$var$attachPingListener(root, value, rootRenderLanes);
        $1e79381dc3a64a75$var$renderDidSuspendDelayIfPossible();
        return !1;
    }
    if ($1e79381dc3a64a75$var$isHydrating) return returnFiber = $1e79381dc3a64a75$var$suspenseHandlerStackCursor.current, null !== returnFiber ? (0 === (returnFiber.flags & 65536) && (returnFiber.flags |= 256), returnFiber.flags |= 65536, returnFiber.lanes = rootRenderLanes, value !== $1e79381dc3a64a75$var$HydrationMismatchException && (root = Error($1e79381dc3a64a75$var$formatProdErrorMessage(422), {
        cause: value
    }), $1e79381dc3a64a75$var$queueHydrationError($1e79381dc3a64a75$var$createCapturedValueAtFiber(root, sourceFiber)))) : (value !== $1e79381dc3a64a75$var$HydrationMismatchException && (returnFiber = Error($1e79381dc3a64a75$var$formatProdErrorMessage(423), {
        cause: value
    }), $1e79381dc3a64a75$var$queueHydrationError($1e79381dc3a64a75$var$createCapturedValueAtFiber(returnFiber, sourceFiber))), root = root.current.alternate, root.flags |= 65536, rootRenderLanes &= -rootRenderLanes, root.lanes |= rootRenderLanes, value = $1e79381dc3a64a75$var$createCapturedValueAtFiber(value, sourceFiber), rootRenderLanes = $1e79381dc3a64a75$var$createRootErrorUpdate(root.stateNode, value, rootRenderLanes), $1e79381dc3a64a75$var$enqueueCapturedUpdate(root, rootRenderLanes), 4 !== $1e79381dc3a64a75$var$workInProgressRootExitStatus && ($1e79381dc3a64a75$var$workInProgressRootExitStatus = 2)), !1;
    var wrapperError = Error($1e79381dc3a64a75$var$formatProdErrorMessage(520), {
        cause: value
    });
    wrapperError = $1e79381dc3a64a75$var$createCapturedValueAtFiber(wrapperError, sourceFiber);
    null === $1e79381dc3a64a75$var$workInProgressRootConcurrentErrors ? $1e79381dc3a64a75$var$workInProgressRootConcurrentErrors = [
        wrapperError
    ] : $1e79381dc3a64a75$var$workInProgressRootConcurrentErrors.push(wrapperError);
    4 !== $1e79381dc3a64a75$var$workInProgressRootExitStatus && ($1e79381dc3a64a75$var$workInProgressRootExitStatus = 2);
    if (null === returnFiber) return !0;
    value = $1e79381dc3a64a75$var$createCapturedValueAtFiber(value, sourceFiber);
    sourceFiber = returnFiber;
    do {
        switch(sourceFiber.tag){
            case 3:
                return sourceFiber.flags |= 65536, root = rootRenderLanes & -rootRenderLanes, sourceFiber.lanes |= root, root = $1e79381dc3a64a75$var$createRootErrorUpdate(sourceFiber.stateNode, value, root), $1e79381dc3a64a75$var$enqueueCapturedUpdate(sourceFiber, root), !1;
            case 1:
                returnFiber = sourceFiber.type;
                wrapperError = sourceFiber.stateNode;
                if (0 === (sourceFiber.flags & 128) && ("function" === typeof returnFiber.getDerivedStateFromError || null !== wrapperError && "function" === typeof wrapperError.componentDidCatch && (null === $1e79381dc3a64a75$var$legacyErrorBoundariesThatAlreadyFailed || !$1e79381dc3a64a75$var$legacyErrorBoundariesThatAlreadyFailed.has(wrapperError)))) return sourceFiber.flags |= 65536, rootRenderLanes &= -rootRenderLanes, sourceFiber.lanes |= rootRenderLanes, rootRenderLanes = $1e79381dc3a64a75$var$createClassErrorUpdate(rootRenderLanes), $1e79381dc3a64a75$var$initializeClassErrorUpdate(rootRenderLanes, root, sourceFiber, value), $1e79381dc3a64a75$var$enqueueCapturedUpdate(sourceFiber, rootRenderLanes), !1;
                break;
            case 22:
                if (null !== sourceFiber.memoizedState) return sourceFiber.flags |= 65536, !1;
        }
        sourceFiber = sourceFiber.return;
    }while (null !== sourceFiber);
    return !1;
}
var $1e79381dc3a64a75$var$SelectiveHydrationException = Error($1e79381dc3a64a75$var$formatProdErrorMessage(461)), $1e79381dc3a64a75$var$didReceiveUpdate = !1;
function $1e79381dc3a64a75$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes) {
    workInProgress.child = null === current ? $1e79381dc3a64a75$var$mountChildFibers(workInProgress, null, nextChildren, renderLanes) : $1e79381dc3a64a75$var$reconcileChildFibers(workInProgress, current.child, nextChildren, renderLanes);
}
function $1e79381dc3a64a75$var$updateForwardRef(current, workInProgress, Component, nextProps, renderLanes) {
    Component = Component.render;
    var ref = workInProgress.ref;
    if ("ref" in nextProps) {
        var propsWithoutRef = {};
        for(var key in nextProps)"ref" !== key && (propsWithoutRef[key] = nextProps[key]);
    } else propsWithoutRef = nextProps;
    $1e79381dc3a64a75$var$prepareToReadContext(workInProgress);
    nextProps = $1e79381dc3a64a75$var$renderWithHooks(current, workInProgress, Component, propsWithoutRef, ref, renderLanes);
    key = $1e79381dc3a64a75$var$checkDidRenderIdHook();
    if (null !== current && !$1e79381dc3a64a75$var$didReceiveUpdate) return $1e79381dc3a64a75$var$bailoutHooks(current, workInProgress, renderLanes), $1e79381dc3a64a75$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $1e79381dc3a64a75$var$isHydrating && key && $1e79381dc3a64a75$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $1e79381dc3a64a75$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $1e79381dc3a64a75$var$updateMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null === current) {
        var type = Component.type;
        if ("function" === typeof type && !$1e79381dc3a64a75$var$shouldConstruct(type) && void 0 === type.defaultProps && null === Component.compare) return workInProgress.tag = 15, workInProgress.type = type, $1e79381dc3a64a75$var$updateSimpleMemoComponent(current, workInProgress, type, nextProps, renderLanes);
        current = $1e79381dc3a64a75$var$createFiberFromTypeAndProps(Component.type, null, nextProps, workInProgress, workInProgress.mode, renderLanes);
        current.ref = workInProgress.ref;
        current.return = workInProgress;
        return workInProgress.child = current;
    }
    type = current.child;
    if (!$1e79381dc3a64a75$var$checkScheduledUpdateOrContext(current, renderLanes)) {
        var prevProps = type.memoizedProps;
        Component = Component.compare;
        Component = null !== Component ? Component : $1e79381dc3a64a75$var$shallowEqual;
        if (Component(prevProps, nextProps) && current.ref === workInProgress.ref) return $1e79381dc3a64a75$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    }
    workInProgress.flags |= 1;
    current = $1e79381dc3a64a75$var$createWorkInProgress(type, nextProps);
    current.ref = workInProgress.ref;
    current.return = workInProgress;
    return workInProgress.child = current;
}
function $1e79381dc3a64a75$var$updateSimpleMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null !== current) {
        var prevProps = current.memoizedProps;
        if ($1e79381dc3a64a75$var$shallowEqual(prevProps, nextProps) && current.ref === workInProgress.ref) {
            if ($1e79381dc3a64a75$var$didReceiveUpdate = !1, workInProgress.pendingProps = nextProps = prevProps, $1e79381dc3a64a75$var$checkScheduledUpdateOrContext(current, renderLanes)) 0 !== (current.flags & 131072) && ($1e79381dc3a64a75$var$didReceiveUpdate = !0);
            else return workInProgress.lanes = current.lanes, $1e79381dc3a64a75$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
    }
    return $1e79381dc3a64a75$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes);
}
function $1e79381dc3a64a75$var$updateOffscreenComponent(current, workInProgress, renderLanes, nextProps) {
    var nextChildren = nextProps.children, prevState = null !== current ? current.memoizedState : null;
    null === current && null === workInProgress.stateNode && (workInProgress.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    });
    if ("hidden" === nextProps.mode) {
        if (0 !== (workInProgress.flags & 128)) {
            prevState = null !== prevState ? prevState.baseLanes | renderLanes : renderLanes;
            if (null !== current) {
                nextProps = workInProgress.child = current.child;
                for(nextChildren = 0; null !== nextProps;)nextChildren = nextChildren | nextProps.lanes | nextProps.childLanes, nextProps = nextProps.sibling;
                nextProps = nextChildren & ~prevState;
            } else nextProps = 0, workInProgress.child = null;
            return $1e79381dc3a64a75$var$deferHiddenOffscreenComponent(current, workInProgress, prevState, renderLanes, nextProps);
        }
        if (0 !== (renderLanes & 536870912)) workInProgress.memoizedState = {
            baseLanes: 0,
            cachePool: null
        }, null !== current && $1e79381dc3a64a75$var$pushTransition(workInProgress, null !== prevState ? prevState.cachePool : null), null !== prevState ? $1e79381dc3a64a75$var$pushHiddenContext(workInProgress, prevState) : $1e79381dc3a64a75$var$reuseHiddenContextOnStack(), $1e79381dc3a64a75$var$pushOffscreenSuspenseHandler(workInProgress);
        else return nextProps = workInProgress.lanes = 536870912, $1e79381dc3a64a75$var$deferHiddenOffscreenComponent(current, workInProgress, null !== prevState ? prevState.baseLanes | renderLanes : renderLanes, renderLanes, nextProps);
    } else null !== prevState ? ($1e79381dc3a64a75$var$pushTransition(workInProgress, prevState.cachePool), $1e79381dc3a64a75$var$pushHiddenContext(workInProgress, prevState), $1e79381dc3a64a75$var$reuseSuspenseHandlerOnStack(), workInProgress.memoizedState = null) : (null !== current && $1e79381dc3a64a75$var$pushTransition(workInProgress, null), $1e79381dc3a64a75$var$reuseHiddenContextOnStack(), $1e79381dc3a64a75$var$reuseSuspenseHandlerOnStack());
    $1e79381dc3a64a75$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
function $1e79381dc3a64a75$var$bailoutOffscreenComponent(current, workInProgress) {
    null !== current && 22 === current.tag || null !== workInProgress.stateNode || (workInProgress.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    });
    return workInProgress.sibling;
}
function $1e79381dc3a64a75$var$deferHiddenOffscreenComponent(current, workInProgress, nextBaseLanes, renderLanes, remainingChildLanes) {
    var JSCompiler_inline_result = $1e79381dc3a64a75$var$peekCacheFromPool();
    JSCompiler_inline_result = null === JSCompiler_inline_result ? null : {
        parent: $1e79381dc3a64a75$var$CacheContext._currentValue,
        pool: JSCompiler_inline_result
    };
    workInProgress.memoizedState = {
        baseLanes: nextBaseLanes,
        cachePool: JSCompiler_inline_result
    };
    null !== current && $1e79381dc3a64a75$var$pushTransition(workInProgress, null);
    $1e79381dc3a64a75$var$reuseHiddenContextOnStack();
    $1e79381dc3a64a75$var$pushOffscreenSuspenseHandler(workInProgress);
    null !== current && $1e79381dc3a64a75$var$propagateParentContextChanges(current, workInProgress, renderLanes, !0);
    workInProgress.childLanes = remainingChildLanes;
    return null;
}
function $1e79381dc3a64a75$var$mountActivityChildren(workInProgress, nextProps) {
    nextProps = $1e79381dc3a64a75$var$mountWorkInProgressOffscreenFiber({
        mode: nextProps.mode,
        children: nextProps.children
    }, workInProgress.mode);
    nextProps.ref = workInProgress.ref;
    workInProgress.child = nextProps;
    nextProps.return = workInProgress;
    return nextProps;
}
function $1e79381dc3a64a75$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $1e79381dc3a64a75$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $1e79381dc3a64a75$var$mountActivityChildren(workInProgress, workInProgress.pendingProps);
    current.flags |= 2;
    $1e79381dc3a64a75$var$popSuspenseHandler(workInProgress);
    workInProgress.memoizedState = null;
    return current;
}
function $1e79381dc3a64a75$var$updateActivityComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, didSuspend = 0 !== (workInProgress.flags & 128);
    workInProgress.flags &= -129;
    if (null === current) {
        if ($1e79381dc3a64a75$var$isHydrating) {
            if ("hidden" === nextProps.mode) return current = $1e79381dc3a64a75$var$mountActivityChildren(workInProgress, nextProps), workInProgress.lanes = 536870912, current.memoizedState = {
                baseLanes: 0,
                cachePool: null
            }, $1e79381dc3a64a75$var$bailoutOffscreenComponent(null, current);
            $1e79381dc3a64a75$var$pushDehydratedActivitySuspenseHandler(workInProgress);
            (current = $1e79381dc3a64a75$var$nextHydratableInstance) ? (current = $1e79381dc3a64a75$var$canHydrateHydrationBoundary(current, $1e79381dc3a64a75$var$rootOrSingletonContext), current = null !== current && "&" === current.data ? current : null, null !== current && (workInProgress.memoizedState = {
                dehydrated: current,
                treeContext: null !== $1e79381dc3a64a75$var$treeContextProvider ? {
                    id: $1e79381dc3a64a75$var$treeContextId,
                    overflow: $1e79381dc3a64a75$var$treeContextOverflow
                } : null,
                retryLane: 536870912,
                hydrationErrors: null
            }, renderLanes = $1e79381dc3a64a75$var$createFiberFromDehydratedFragment(current), renderLanes.return = workInProgress, workInProgress.child = renderLanes, $1e79381dc3a64a75$var$hydrationParentFiber = workInProgress, $1e79381dc3a64a75$var$nextHydratableInstance = null)) : current = null;
            if (null === current) throw $1e79381dc3a64a75$var$throwOnHydrationMismatch(workInProgress);
            workInProgress.lanes = 536870912;
            return null;
        }
        return $1e79381dc3a64a75$var$mountActivityChildren(workInProgress, nextProps);
    }
    var prevState = current.memoizedState;
    if (null !== prevState) {
        var dehydrated = prevState.dehydrated;
        $1e79381dc3a64a75$var$pushDehydratedActivitySuspenseHandler(workInProgress);
        if (didSuspend) {
            if (workInProgress.flags & 256) workInProgress.flags &= -257, workInProgress = $1e79381dc3a64a75$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
            else if (null !== workInProgress.memoizedState) workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null;
            else throw Error($1e79381dc3a64a75$var$formatProdErrorMessage(558));
        } else if ($1e79381dc3a64a75$var$didReceiveUpdate || $1e79381dc3a64a75$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), didSuspend = 0 !== (renderLanes & current.childLanes), $1e79381dc3a64a75$var$didReceiveUpdate || didSuspend) {
            if (null === $1e79381dc3a64a75$var$currentTreeHiddenStackCursor.current) {
                nextProps = $1e79381dc3a64a75$var$workInProgressRoot;
                if (null !== nextProps && (dehydrated = $1e79381dc3a64a75$var$getBumpedLaneForHydration(nextProps, renderLanes), 0 !== dehydrated && dehydrated !== prevState.retryLane)) throw prevState.retryLane = dehydrated, $1e79381dc3a64a75$var$enqueueConcurrentRenderForLane(current, dehydrated), $1e79381dc3a64a75$var$scheduleUpdateOnFiber(nextProps, current, dehydrated), $1e79381dc3a64a75$var$SelectiveHydrationException;
                $1e79381dc3a64a75$var$renderDidSuspendDelayIfPossible();
            }
            workInProgress = $1e79381dc3a64a75$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else current = prevState.treeContext, $1e79381dc3a64a75$var$nextHydratableInstance = $1e79381dc3a64a75$var$getNextHydratable(dehydrated.nextSibling), $1e79381dc3a64a75$var$hydrationParentFiber = workInProgress, $1e79381dc3a64a75$var$isHydrating = !0, $1e79381dc3a64a75$var$hydrationErrors = null, $1e79381dc3a64a75$var$rootOrSingletonContext = !1, null !== current && $1e79381dc3a64a75$var$restoreSuspendedTreeContext(workInProgress, current), workInProgress = $1e79381dc3a64a75$var$mountActivityChildren(workInProgress, nextProps), workInProgress.flags |= 134221824;
        return workInProgress;
    }
    current = $1e79381dc3a64a75$var$createWorkInProgress(current.child, {
        mode: nextProps.mode,
        children: nextProps.children
    });
    current.ref = workInProgress.ref;
    workInProgress.child = current;
    current.return = workInProgress;
    return current;
}
function $1e79381dc3a64a75$var$markRef(current, workInProgress) {
    var ref = workInProgress.ref;
    if (null === ref) null !== current && null !== current.ref && (workInProgress.flags |= 4194816);
    else {
        if ("function" !== typeof ref && "object" !== typeof ref) throw Error($1e79381dc3a64a75$var$formatProdErrorMessage(284));
        if (null === current || current.ref !== ref) workInProgress.flags |= 4194816;
    }
}
function $1e79381dc3a64a75$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $1e79381dc3a64a75$var$prepareToReadContext(workInProgress);
    Component = $1e79381dc3a64a75$var$renderWithHooks(current, workInProgress, Component, nextProps, void 0, renderLanes);
    nextProps = $1e79381dc3a64a75$var$checkDidRenderIdHook();
    if (null !== current && !$1e79381dc3a64a75$var$didReceiveUpdate) return $1e79381dc3a64a75$var$bailoutHooks(current, workInProgress, renderLanes), $1e79381dc3a64a75$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $1e79381dc3a64a75$var$isHydrating && nextProps && $1e79381dc3a64a75$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $1e79381dc3a64a75$var$reconcileChildren(current, workInProgress, Component, renderLanes);
    return workInProgress.child;
}
function $1e79381dc3a64a75$var$replayFunctionComponent(current, workInProgress, nextProps, Component, secondArg, renderLanes) {
    $1e79381dc3a64a75$var$prepareToReadContext(workInProgress);
    workInProgress.updateQueue = null;
    nextProps = $1e79381dc3a64a75$var$renderWithHooksAgain(workInProgress, Component, nextProps, secondArg);
    $1e79381dc3a64a75$var$finishRenderingHooks(current);
    Component = $1e79381dc3a64a75$var$checkDidRenderIdHook();
    if (null !== current && !$1e79381dc3a64a75$var$didReceiveUpdate) return $1e79381dc3a64a75$var$bailoutHooks(current, workInProgress, renderLanes), $1e79381dc3a64a75$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $1e79381dc3a64a75$var$isHydrating && Component && $1e79381dc3a64a75$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $1e79381dc3a64a75$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $1e79381dc3a64a75$var$updateClassComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $1e79381dc3a64a75$var$prepareToReadContext(workInProgress);
    if (null === workInProgress.stateNode) {
        var context = $1e79381dc3a64a75$var$emptyContextObject, contextType = Component.contextType;
        "object" === typeof contextType && null !== contextType && (context = $1e79381dc3a64a75$var$readContext(contextType));
        context = new Component(nextProps, context);
        workInProgress.memoizedState = null !== context.state && void 0 !== context.state ? context.state : null;
        context.updater = $1e79381dc3a64a75$var$classComponentUpdater;
        workInProgress.stateNode = context;
        context._reactInternals = workInProgress;
        context = workInProgress.stateNode;
        context.props = nextProps;
        context.state = workInProgress.memoizedState;
        context.refs = {};
        $1e79381dc3a64a75$var$initializeUpdateQueue(workInProgress);
        contextType = Component.contextType;
        context.context = "object" === typeof contextType && null !== contextType ? $1e79381dc3a64a75$var$readContext(contextType) : $1e79381dc3a64a75$var$emptyContextObject;
        context.state = workInProgress.memoizedState;
        contextType = Component.getDerivedStateFromProps;
        "function" === typeof contextType && ($1e79381dc3a64a75$var$applyDerivedStateFromProps(workInProgress, Component, contextType, nextProps), context.state = workInProgress.memoizedState);
        "function" === typeof Component.getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || (contextType = context.state, "function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount(), contextType !== context.state && $1e79381dc3a64a75$var$classComponentUpdater.enqueueReplaceState(context, context.state, null), $1e79381dc3a64a75$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes), $1e79381dc3a64a75$var$suspendIfUpdateReadFromEntangledAsyncAction(), context.state = workInProgress.memoizedState);
        "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308);
        nextProps = !0;
    } else if (null === current) {
        context = workInProgress.stateNode;
        var unresolvedOldProps = workInProgress.memoizedProps, oldProps = $1e79381dc3a64a75$var$resolveClassComponentProps(Component, unresolvedOldProps);
        context.props = oldProps;
        var oldContext = context.context, contextType$jscomp$0 = Component.contextType;
        contextType = $1e79381dc3a64a75$var$emptyContextObject;
        "object" === typeof contextType$jscomp$0 && null !== contextType$jscomp$0 && (contextType = $1e79381dc3a64a75$var$readContext(contextType$jscomp$0));
        var getDerivedStateFromProps = Component.getDerivedStateFromProps;
        contextType$jscomp$0 = "function" === typeof getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate;
        unresolvedOldProps = workInProgress.pendingProps !== unresolvedOldProps;
        contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (unresolvedOldProps || oldContext !== contextType) && $1e79381dc3a64a75$var$callComponentWillReceiveProps(workInProgress, context, nextProps, contextType);
        $1e79381dc3a64a75$var$hasForceUpdate = !1;
        var oldState = workInProgress.memoizedState;
        context.state = oldState;
        $1e79381dc3a64a75$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $1e79381dc3a64a75$var$suspendIfUpdateReadFromEntangledAsyncAction();
        oldContext = workInProgress.memoizedState;
        unresolvedOldProps || oldState !== oldContext || $1e79381dc3a64a75$var$hasForceUpdate ? ("function" === typeof getDerivedStateFromProps && ($1e79381dc3a64a75$var$applyDerivedStateFromProps(workInProgress, Component, getDerivedStateFromProps, nextProps), oldContext = workInProgress.memoizedState), (oldProps = $1e79381dc3a64a75$var$hasForceUpdate || $1e79381dc3a64a75$var$checkShouldComponentUpdate(workInProgress, Component, oldProps, nextProps, oldState, oldContext, contextType)) ? (contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || ("function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount()), "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308)) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = oldContext), context.props = nextProps, context.state = oldContext, context.context = contextType, nextProps = oldProps) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), nextProps = !1);
    } else {
        context = workInProgress.stateNode;
        $1e79381dc3a64a75$var$cloneUpdateQueue(current, workInProgress);
        contextType = workInProgress.memoizedProps;
        contextType$jscomp$0 = $1e79381dc3a64a75$var$resolveClassComponentProps(Component, contextType);
        context.props = contextType$jscomp$0;
        getDerivedStateFromProps = workInProgress.pendingProps;
        oldState = context.context;
        oldContext = Component.contextType;
        oldProps = $1e79381dc3a64a75$var$emptyContextObject;
        "object" === typeof oldContext && null !== oldContext && (oldProps = $1e79381dc3a64a75$var$readContext(oldContext));
        unresolvedOldProps = Component.getDerivedStateFromProps;
        (oldContext = "function" === typeof unresolvedOldProps || "function" === typeof context.getSnapshotBeforeUpdate) || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (contextType !== getDerivedStateFromProps || oldState !== oldProps) && $1e79381dc3a64a75$var$callComponentWillReceiveProps(workInProgress, context, nextProps, oldProps);
        $1e79381dc3a64a75$var$hasForceUpdate = !1;
        oldState = workInProgress.memoizedState;
        context.state = oldState;
        $1e79381dc3a64a75$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $1e79381dc3a64a75$var$suspendIfUpdateReadFromEntangledAsyncAction();
        var newState = workInProgress.memoizedState;
        contextType !== getDerivedStateFromProps || oldState !== newState || $1e79381dc3a64a75$var$hasForceUpdate || null !== current && null !== current.dependencies && $1e79381dc3a64a75$var$checkIfContextChanged(current.dependencies) ? ("function" === typeof unresolvedOldProps && ($1e79381dc3a64a75$var$applyDerivedStateFromProps(workInProgress, Component, unresolvedOldProps, nextProps), newState = workInProgress.memoizedState), (contextType$jscomp$0 = $1e79381dc3a64a75$var$hasForceUpdate || $1e79381dc3a64a75$var$checkShouldComponentUpdate(workInProgress, Component, contextType$jscomp$0, nextProps, oldState, newState, oldProps) || null !== current && null !== current.dependencies && $1e79381dc3a64a75$var$checkIfContextChanged(current.dependencies)) ? (oldContext || "function" !== typeof context.UNSAFE_componentWillUpdate && "function" !== typeof context.componentWillUpdate || ("function" === typeof context.componentWillUpdate && context.componentWillUpdate(nextProps, newState, oldProps), "function" === typeof context.UNSAFE_componentWillUpdate && context.UNSAFE_componentWillUpdate(nextProps, newState, oldProps)), "function" === typeof context.componentDidUpdate && (workInProgress.flags |= 4), "function" === typeof context.getSnapshotBeforeUpdate && (workInProgress.flags |= 1024)) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = newState), context.props = nextProps, context.state = newState, context.context = oldProps, nextProps = contextType$jscomp$0) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), nextProps = !1);
    }
    context = nextProps;
    $1e79381dc3a64a75$var$markRef(current, workInProgress);
    nextProps = 0 !== (workInProgress.flags & 128);
    context || nextProps ? (context = workInProgress.stateNode, Component = nextProps && "function" !== typeof Component.getDerivedStateFromError ? null : context.render(), workInProgress.flags |= 1, null !== current && nextProps ? (workInProgress.child = $1e79381dc3a64a75$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), workInProgress.child = $1e79381dc3a64a75$var$reconcileChildFibers(workInProgress, null, Component, renderLanes)) : $1e79381dc3a64a75$var$reconcileChildren(current, workInProgress, Component, renderLanes), workInProgress.memoizedState = context.state, current = workInProgress.child) : current = $1e79381dc3a64a75$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    return current;
}
function $1e79381dc3a64a75$var$mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes) {
    $1e79381dc3a64a75$var$resetHydrationState();
    workInProgress.flags |= 256;
    $1e79381dc3a64a75$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
var $1e79381dc3a64a75$var$SUSPENDED_MARKER = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0,
    hydrationErrors: null
};
function $1e79381dc3a64a75$var$mountSuspenseOffscreenState(renderLanes) {
    return {
        baseLanes: renderLanes,
        cachePool: $1e79381dc3a64a75$var$getSuspendedCache()
    };
}
function $1e79381dc3a64a75$var$getRemainingWorkInPrimaryTree(current, primaryTreeDidDefer, renderLanes) {
    current = null !== current ? current.childLanes & ~renderLanes : 0;
    primaryTreeDidDefer && (current |= $1e79381dc3a64a75$var$workInProgressDeferredLane);
    return current;
}
function $1e79381dc3a64a75$var$updateSuspenseComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, showFallback = !1, didSuspend = 0 !== (workInProgress.flags & 128), JSCompiler_temp;
    (JSCompiler_temp = didSuspend) || (JSCompiler_temp = null !== current && null === current.memoizedState ? !1 : 0 !== ($1e79381dc3a64a75$var$suspenseStackCursor.current & 2));
    JSCompiler_temp && (showFallback = !0, workInProgress.flags &= -129);
    JSCompiler_temp = 0 !== (workInProgress.flags & 32);
    workInProgress.flags &= -33;
    if (null === current) {
        if ($1e79381dc3a64a75$var$isHydrating) {
            showFallback ? $1e79381dc3a64a75$var$pushPrimaryTreeSuspenseHandler(workInProgress) : $1e79381dc3a64a75$var$reuseSuspenseHandlerOnStack();
            (current = $1e79381dc3a64a75$var$nextHydratableInstance) ? (current = $1e79381dc3a64a75$var$canHydrateHydrationBoundary(current, $1e79381dc3a64a75$var$rootOrSingletonContext), current = null !== current && "&" !== current.data ? current : null, null !== current && (workInProgress.memoizedState = {
                dehydrated: current,
                treeContext: null !== $1e79381dc3a64a75$var$treeContextProvider ? {
                    id: $1e79381dc3a64a75$var$treeContextId,
                    overflow: $1e79381dc3a64a75$var$treeContextOverflow
                } : null,
                retryLane: 536870912,
                hydrationErrors: null
            }, renderLanes = $1e79381dc3a64a75$var$createFiberFromDehydratedFragment(current), renderLanes.return = workInProgress, workInProgress.child = renderLanes, $1e79381dc3a64a75$var$hydrationParentFiber = workInProgress, $1e79381dc3a64a75$var$nextHydratableInstance = null)) : current = null;
            if (null === current) throw $1e79381dc3a64a75$var$throwOnHydrationMismatch(workInProgress);
            $1e79381dc3a64a75$var$isSuspenseInstanceFallback(current) ? workInProgress.lanes = 32 : workInProgress.lanes = 536870912;
            return null;
        }
        didSuspend = nextProps.children;
        nextProps = nextProps.fallback;
        if (showFallback) return $1e79381dc3a64a75$var$reuseSuspenseHandlerOnStack(), showFallback = workInProgress.mode, didSuspend = $1e79381dc3a64a75$var$mountWorkInProgressOffscreenFiber({
            mode: "hidden",
            children: didSuspend
        }, showFallback), nextProps = $1e79381dc3a64a75$var$createFiberFromFragment(nextProps, showFallback, renderLanes, null), didSuspend.return = workInProgress, nextProps.return = workInProgress, didSuspend.sibling = nextProps, workInProgress.child = didSuspend, nextProps = workInProgress.child, nextProps.memoizedState = $1e79381dc3a64a75$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $1e79381dc3a64a75$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $1e79381dc3a64a75$var$SUSPENDED_MARKER, $1e79381dc3a64a75$var$bailoutOffscreenComponent(null, nextProps);
        $1e79381dc3a64a75$var$pushPrimaryTreeSuspenseHandler(workInProgress);
        return $1e79381dc3a64a75$var$mountSuspensePrimaryChildren(workInProgress, didSuspend);
    }
    var prevState = current.memoizedState;
    if (null !== prevState) {
        var dehydrated$96 = prevState.dehydrated;
        if (null !== dehydrated$96) return $1e79381dc3a64a75$var$updateDehydratedSuspenseComponent(current, workInProgress, didSuspend, JSCompiler_temp, nextProps, dehydrated$96, prevState, renderLanes);
    }
    if (showFallback) return $1e79381dc3a64a75$var$reuseSuspenseHandlerOnStack(), showFallback = nextProps.fallback, didSuspend = workInProgress.mode, prevState = current.child, dehydrated$96 = prevState.sibling, nextProps = $1e79381dc3a64a75$var$createWorkInProgress(prevState, {
        mode: "hidden",
        children: nextProps.children
    }), nextProps.subtreeFlags = prevState.subtreeFlags & 1206910976, null !== dehydrated$96 ? showFallback = $1e79381dc3a64a75$var$createWorkInProgress(dehydrated$96, showFallback) : (showFallback = $1e79381dc3a64a75$var$createFiberFromFragment(showFallback, didSuspend, renderLanes, null), showFallback.flags |= 2), showFallback.return = workInProgress, nextProps.return = workInProgress, nextProps.sibling = showFallback, workInProgress.child = nextProps, $1e79381dc3a64a75$var$bailoutOffscreenComponent(null, nextProps), nextProps = workInProgress.child, showFallback = current.child.memoizedState, null === showFallback ? showFallback = $1e79381dc3a64a75$var$mountSuspenseOffscreenState(renderLanes) : (didSuspend = showFallback.cachePool, null !== didSuspend ? (prevState = $1e79381dc3a64a75$var$CacheContext._currentValue, didSuspend = didSuspend.parent !== prevState ? {
        parent: prevState,
        pool: prevState
    } : didSuspend) : didSuspend = $1e79381dc3a64a75$var$getSuspendedCache(), showFallback = {
        baseLanes: showFallback.baseLanes | renderLanes,
        cachePool: didSuspend
    }), nextProps.memoizedState = showFallback, nextProps.childLanes = $1e79381dc3a64a75$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $1e79381dc3a64a75$var$SUSPENDED_MARKER, $1e79381dc3a64a75$var$bailoutOffscreenComponent(current.child, nextProps);
    $1e79381dc3a64a75$var$pushPrimaryTreeSuspenseHandler(workInProgress);
    renderLanes = current.child;
    current = renderLanes.sibling;
    renderLanes = $1e79381dc3a64a75$var$createWorkInProgress(renderLanes, {
        mode: "visible",
        children: nextProps.children
    });
    renderLanes.return = workInProgress;
    renderLanes.sibling = null;
    null !== current && (JSCompiler_temp = workInProgress.deletions, null === JSCompiler_temp ? (workInProgress.deletions = [
        current
    ], workInProgress.flags |= 16) : JSCompiler_temp.push(current));
    workInProgress.child = renderLanes;
    workInProgress.memoizedState = null;
    return renderLanes;
}
function $1e79381dc3a64a75$var$mountSuspensePrimaryChildren(workInProgress, primaryChildren) {
    primaryChildren = $1e79381dc3a64a75$var$mountWorkInProgressOffscreenFiber({
        mode: "visible",
        children: primaryChildren
    }, workInProgress.mode);
    primaryChildren.return = workInProgress;
    return workInProgress.child = primaryChildren;
}
function $1e79381dc3a64a75$var$mountWorkInProgressOffscreenFiber(offscreenProps, mode) {
    offscreenProps = $1e79381dc3a64a75$var$createFiberImplClass(22, offscreenProps, null, mode);
    offscreenProps.lanes = 0;
    return offscreenProps;
}
function $1e79381dc3a64a75$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $1e79381dc3a64a75$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $1e79381dc3a64a75$var$mountSuspensePrimaryChildren(workInProgress, workInProgress.pendingProps.children);
    current.flags |= 2;
    workInProgress.memoizedState = null;
    return current;
}
function $1e79381dc3a64a75$var$updateDehydratedSuspenseComponent(current, workInProgress, didSuspend, didPrimaryChildrenDefer, nextProps, suspenseInstance, suspenseState, renderLanes) {
    if (didSuspend) {
        if (workInProgress.flags & 256) return $1e79381dc3a64a75$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags &= -257, $1e79381dc3a64a75$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        if (null !== workInProgress.memoizedState) return $1e79381dc3a64a75$var$reuseSuspenseHandlerOnStack(), workInProgress.child = current.child, workInProgress.flags |= 128, null;
        $1e79381dc3a64a75$var$reuseSuspenseHandlerOnStack();
        suspenseInstance = nextProps.fallback;
        suspenseState = workInProgress.mode;
        nextProps = $1e79381dc3a64a75$var$mountWorkInProgressOffscreenFiber({
            mode: "visible",
            children: nextProps.children
        }, suspenseState);
        suspenseInstance = $1e79381dc3a64a75$var$createFiberFromFragment(suspenseInstance, suspenseState, renderLanes, null);
        suspenseInstance.flags |= 2;
        nextProps.return = workInProgress;
        suspenseInstance.return = workInProgress;
        nextProps.sibling = suspenseInstance;
        workInProgress.child = nextProps;
        $1e79381dc3a64a75$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
        nextProps = workInProgress.child;
        nextProps.memoizedState = $1e79381dc3a64a75$var$mountSuspenseOffscreenState(renderLanes);
        nextProps.childLanes = $1e79381dc3a64a75$var$getRemainingWorkInPrimaryTree(current, didPrimaryChildrenDefer, renderLanes);
        workInProgress.memoizedState = $1e79381dc3a64a75$var$SUSPENDED_MARKER;
        return $1e79381dc3a64a75$var$bailoutOffscreenComponent(null, nextProps);
    }
    $1e79381dc3a64a75$var$pushPrimaryTreeSuspenseHandler(workInProgress);
    if ($1e79381dc3a64a75$var$isSuspenseInstanceFallback(suspenseInstance)) {
        didPrimaryChildrenDefer = suspenseInstance.nextSibling && suspenseInstance.nextSibling.dataset;
        if (didPrimaryChildrenDefer) var digest = didPrimaryChildrenDefer.dgst;
        didPrimaryChildrenDefer = digest;
        "" !== didPrimaryChildrenDefer && (nextProps = Error($1e79381dc3a64a75$var$formatProdErrorMessage(419)), nextProps.stack = "", nextProps.digest = didPrimaryChildrenDefer, $1e79381dc3a64a75$var$queueHydrationError({
            value: nextProps,
            source: null,
            stack: null
        }));
        return $1e79381dc3a64a75$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
    }
    $1e79381dc3a64a75$var$didReceiveUpdate || $1e79381dc3a64a75$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1);
    didPrimaryChildrenDefer = 0 !== (renderLanes & current.childLanes);
    if ($1e79381dc3a64a75$var$didReceiveUpdate || didPrimaryChildrenDefer) {
        if (null !== $1e79381dc3a64a75$var$currentTreeHiddenStackCursor.current) return $1e79381dc3a64a75$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        didPrimaryChildrenDefer = $1e79381dc3a64a75$var$workInProgressRoot;
        if (null !== didPrimaryChildrenDefer && (nextProps = $1e79381dc3a64a75$var$getBumpedLaneForHydration(didPrimaryChildrenDefer, renderLanes), 0 !== nextProps && nextProps !== suspenseState.retryLane)) throw suspenseState.retryLane = nextProps, $1e79381dc3a64a75$var$enqueueConcurrentRenderForLane(current, nextProps), $1e79381dc3a64a75$var$scheduleUpdateOnFiber(didPrimaryChildrenDefer, current, nextProps), $1e79381dc3a64a75$var$SelectiveHydrationException;
        $1e79381dc3a64a75$var$isSuspenseInstancePending(suspenseInstance) || $1e79381dc3a64a75$var$renderDidSuspendDelayIfPossible();
        return $1e79381dc3a64a75$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
    }
    if ($1e79381dc3a64a75$var$isSuspenseInstancePending(suspenseInstance)) return workInProgress.flags |= 192, workInProgress.child = current.child, null;
    current = suspenseState.treeContext;
    $1e79381dc3a64a75$var$nextHydratableInstance = $1e79381dc3a64a75$var$getNextHydratable(suspenseInstance.nextSibling);
    $1e79381dc3a64a75$var$hydrationParentFiber = workInProgress;
    $1e79381dc3a64a75$var$isHydrating = !0;
    $1e79381dc3a64a75$var$hydrationErrors = null;
    $1e79381dc3a64a75$var$rootOrSingletonContext = !1;
    null !== current && $1e79381dc3a64a75$var$restoreSuspendedTreeContext(workInProgress, current);
    workInProgress = $1e79381dc3a64a75$var$mountSuspensePrimaryChildren(workInProgress, nextProps.children);
    workInProgress.flags |= 134221824;
    return workInProgress;
}
function $1e79381dc3a64a75$var$scheduleSuspenseWorkOnFiber(fiber, renderLanes, propagationRoot) {
    fiber.lanes |= renderLanes;
    var alternate = fiber.alternate;
    null !== alternate && (alternate.lanes |= renderLanes);
    $1e79381dc3a64a75$var$scheduleContextWorkOnParentPath(fiber.return, renderLanes, propagationRoot);
}
function $1e79381dc3a64a75$var$findLastContentRow(firstChild) {
    for(var lastContentRow = null; null !== firstChild;){
        var currentRow = firstChild.alternate;
        null !== currentRow && null === $1e79381dc3a64a75$var$findFirstSuspended(currentRow) && (lastContentRow = firstChild);
        firstChild = firstChild.sibling;
    }
    return lastContentRow;
}
function $1e79381dc3a64a75$var$initSuspenseListRenderState(workInProgress, isBackwards, tail, lastContentRow, tailMode, treeForkCount) {
    var renderState = workInProgress.memoizedState;
    null === renderState ? workInProgress.memoizedState = {
        isBackwards: isBackwards,
        rendering: null,
        renderingStartTime: 0,
        last: lastContentRow,
        tail: tail,
        tailMode: tailMode,
        treeForkCount: treeForkCount
    } : (renderState.isBackwards = isBackwards, renderState.rendering = null, renderState.renderingStartTime = 0, renderState.last = lastContentRow, renderState.tail = tail, renderState.tailMode = tailMode, renderState.treeForkCount = treeForkCount);
}
function $1e79381dc3a64a75$var$reverseChildren(fiber) {
    var row = fiber.child;
    for(fiber.child = null; null !== row;){
        var nextRow = row.sibling;
        row.sibling = fiber.child;
        fiber.child = row;
        row = nextRow;
    }
}
function $1e79381dc3a64a75$var$updateSuspenseListComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, revealOrder = nextProps.revealOrder, tailMode = nextProps.tail;
    nextProps = nextProps.children;
    var suspenseContext = $1e79381dc3a64a75$var$suspenseStackCursor.current;
    if (workInProgress.flags & 128) return $1e79381dc3a64a75$var$pushSuspenseListContext(workInProgress, suspenseContext), null;
    var shouldForceFallback = 0 !== (suspenseContext & 2);
    shouldForceFallback ? (suspenseContext = suspenseContext & 1 | 2, workInProgress.flags |= 128) : suspenseContext &= 1;
    $1e79381dc3a64a75$var$pushSuspenseListContext(workInProgress, suspenseContext);
    "backwards" === revealOrder && null !== current ? ($1e79381dc3a64a75$var$reverseChildren(current), $1e79381dc3a64a75$var$reconcileChildren(current, workInProgress, nextProps, renderLanes), $1e79381dc3a64a75$var$reverseChildren(current)) : $1e79381dc3a64a75$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    nextProps = $1e79381dc3a64a75$var$isHydrating ? $1e79381dc3a64a75$var$treeForkCount : 0;
    if (!shouldForceFallback && null !== current && 0 !== (current.flags & 128)) a: for(current = workInProgress.child; null !== current;){
        if (13 === current.tag) null !== current.memoizedState && $1e79381dc3a64a75$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
        else if (19 === current.tag) $1e79381dc3a64a75$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
        else if (null !== current.child) {
            current.child.return = current;
            current = current.child;
            continue;
        }
        if (current === workInProgress) break a;
        for(; null === current.sibling;){
            if (null === current.return || current.return === workInProgress) break a;
            current = current.return;
        }
        current.sibling.return = current.return;
        current = current.sibling;
    }
    switch(revealOrder){
        case "backwards":
            renderLanes = $1e79381dc3a64a75$var$findLastContentRow(workInProgress.child);
            null === renderLanes ? (revealOrder = workInProgress.child, workInProgress.child = null) : (revealOrder = renderLanes.sibling, renderLanes.sibling = null, $1e79381dc3a64a75$var$reverseChildren(workInProgress));
            $1e79381dc3a64a75$var$initSuspenseListRenderState(workInProgress, !0, revealOrder, null, tailMode, nextProps);
            break;
        case "unstable_legacy-backwards":
            renderLanes = null;
            revealOrder = workInProgress.child;
            for(workInProgress.child = null; null !== revealOrder;){
                current = revealOrder.alternate;
                if (null !== current && null === $1e79381dc3a64a75$var$findFirstSuspended(current)) {
                    workInProgress.child = revealOrder;
                    break;
                }
                current = revealOrder.sibling;
                revealOrder.sibling = renderLanes;
                renderLanes = revealOrder;
                revealOrder = current;
            }
            $1e79381dc3a64a75$var$initSuspenseListRenderState(workInProgress, !0, renderLanes, null, tailMode, nextProps);
            break;
        case "together":
            $1e79381dc3a64a75$var$initSuspenseListRenderState(workInProgress, !1, null, null, void 0, nextProps);
            break;
        case "independent":
            workInProgress.memoizedState = null;
            break;
        default:
            renderLanes = $1e79381dc3a64a75$var$findLastContentRow(workInProgress.child), null === renderLanes ? (revealOrder = workInProgress.child, workInProgress.child = null) : (revealOrder = renderLanes.sibling, renderLanes.sibling = null), $1e79381dc3a64a75$var$initSuspenseListRenderState(workInProgress, !1, revealOrder, renderLanes, tailMode, nextProps);
    }
    return workInProgress.child;
}
function $1e79381dc3a64a75$var$updateContextProvider(current, workInProgress, renderLanes) {
    var newProps = workInProgress.pendingProps;
    $1e79381dc3a64a75$var$pushProvider(workInProgress, workInProgress.type, newProps.value);
    $1e79381dc3a64a75$var$reconcileChildren(current, workInProgress, newProps.children, renderLanes);
    return workInProgress.child;
}
function $1e79381dc3a64a75$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes) {
    null !== current && (workInProgress.dependencies = current.dependencies);
    $1e79381dc3a64a75$var$workInProgressRootSkippedLanes |= workInProgress.lanes;
    if (0 === (renderLanes & workInProgress.childLanes)) {
        if (null !== current) {
            if ($1e79381dc3a64a75$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), 0 === (renderLanes & workInProgress.childLanes)) return null;
        } else return null;
    }
    if (null !== current && workInProgress.child !== current.child) throw Error($1e79381dc3a64a75$var$formatProdErrorMessage(153));
    if (null !== workInProgress.child) {
        current = workInProgress.child;
        renderLanes = $1e79381dc3a64a75$var$createWorkInProgress(current, current.pendingProps);
        workInProgress.child = renderLanes;
        for(renderLanes.return = workInProgress; null !== current.sibling;)current = current.sibling, renderLanes = renderLanes.sibling = $1e79381dc3a64a75$var$createWorkInProgress(current, current.pendingProps), renderLanes.return = workInProgress;
        renderLanes.sibling = null;
    }
    return workInProgress.child;
}
function $1e79381dc3a64a75$var$checkScheduledUpdateOrContext(current, renderLanes) {
    if (0 !== (current.lanes & renderLanes)) return !0;
    current = current.dependencies;
    return null !== current && $1e79381dc3a64a75$var$checkIfContextChanged(current) ? !0 : !1;
}
function $1e79381dc3a64a75$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes) {
    switch(workInProgress.tag){
        case 3:
            $1e79381dc3a64a75$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            $1e79381dc3a64a75$var$pushProvider(workInProgress, $1e79381dc3a64a75$var$CacheContext, current.memoizedState.cache);
            $1e79381dc3a64a75$var$resetHydrationState();
            break;
        case 27:
        case 5:
            $1e79381dc3a64a75$var$pushHostContext(workInProgress);
            break;
        case 4:
            $1e79381dc3a64a75$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            break;
        case 10:
            $1e79381dc3a64a75$var$pushProvider(workInProgress, workInProgress.type, workInProgress.memoizedProps.value);
            break;
        case 31:
            if (null !== workInProgress.memoizedState) return workInProgress.flags |= 128, $1e79381dc3a64a75$var$pushDehydratedActivitySuspenseHandler(workInProgress), null;
            break;
        case 13:
            var state$108 = workInProgress.memoizedState;
            if (null !== state$108) {
                if (null !== state$108.dehydrated) return $1e79381dc3a64a75$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags |= 128, null;
                state$108 = $1e79381dc3a64a75$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1);
                var primaryChildLanes = workInProgress.child.childLanes;
                if (state$108 || 0 !== (renderLanes & primaryChildLanes)) return $1e79381dc3a64a75$var$updateSuspenseComponent(current, workInProgress, renderLanes);
                $1e79381dc3a64a75$var$pushPrimaryTreeSuspenseHandler(workInProgress);
                current = $1e79381dc3a64a75$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                return null !== current ? current.sibling : null;
            }
            $1e79381dc3a64a75$var$pushPrimaryTreeSuspenseHandler(workInProgress);
            break;
        case 19:
            if (workInProgress.flags & 128) return $1e79381dc3a64a75$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
            primaryChildLanes = 0 !== (current.flags & 128);
            state$108 = 0 !== (renderLanes & workInProgress.childLanes);
            state$108 || ($1e79381dc3a64a75$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), state$108 = 0 !== (renderLanes & workInProgress.childLanes));
            if (primaryChildLanes) {
                if (state$108) return $1e79381dc3a64a75$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
                workInProgress.flags |= 128;
            }
            primaryChildLanes = workInProgress.memoizedState;
            null !== primaryChildLanes && (primaryChildLanes.rendering = null, primaryChildLanes.tail = null, primaryChildLanes.lastEffect = null);
            $1e79381dc3a64a75$var$pushSuspenseListContext(workInProgress, $1e79381dc3a64a75$var$suspenseStackCursor.current);
            if (state$108) break;
            else return null;
        case 22:
            return workInProgress.lanes = 0, $1e79381dc3a64a75$var$updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
        case 24:
            $1e79381dc3a64a75$var$pushProvider(workInProgress, $1e79381dc3a64a75$var$CacheContext, current.memoizedState.cache);
    }
    return $1e79381dc3a64a75$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
}
function $1e79381dc3a64a75$var$beginWork(current, workInProgress, renderLanes) {
    if (null !== current) {
        if (current.memoizedProps !== workInProgress.pendingProps) $1e79381dc3a64a75$var$didReceiveUpdate = !0;
        else {
            if (!$1e79381dc3a64a75$var$checkScheduledUpdateOrContext(current, renderLanes) && 0 === (workInProgress.flags & 128)) return $1e79381dc3a64a75$var$didReceiveUpdate = !1, $1e79381dc3a64a75$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes);
            $1e79381dc3a64a75$var$didReceiveUpdate = 0 !== (current.flags & 131072) ? !0 : !1;
        }
    } else $1e79381dc3a64a75$var$didReceiveUpdate = !1, $1e79381dc3a64a75$var$isHydrating && 0 !== (workInProgress.flags & 1048576) && $1e79381dc3a64a75$var$pushTreeId(workInProgress, $1e79381dc3a64a75$var$treeForkCount, workInProgress.index);
    workInProgress.lanes = 0;
    switch(workInProgress.tag){
        case 16:
            a: {
                var props = workInProgress.pendingProps;
                current = $1e79381dc3a64a75$var$resolveLazy(workInProgress.elementType);
                workInProgress.type = current;
                if ("function" === typeof current) $1e79381dc3a64a75$var$shouldConstruct(current) ? (props = $1e79381dc3a64a75$var$resolveClassComponentProps(current, props), workInProgress.tag = 1, workInProgress = $1e79381dc3a64a75$var$updateClassComponent(null, workInProgress, current, props, renderLanes)) : (workInProgress.tag = 0, workInProgress = $1e79381dc3a64a75$var$updateFunctionComponent(null, workInProgress, current, props, renderLanes));
                else {
                    if (void 0 !== current && null !== current) {
                        var $$typeof = current.$$typeof;
                        if ($$typeof === $1e79381dc3a64a75$var$REACT_FORWARD_REF_TYPE) {
                            workInProgress.tag = 11;
                            workInProgress = $1e79381dc3a64a75$var$updateForwardRef(null, workInProgress, current, props, renderLanes);
                            break a;
                        } else if ($$typeof === $1e79381dc3a64a75$var$REACT_MEMO_TYPE) {
                            workInProgress.tag = 14;
                            workInProgress = $1e79381dc3a64a75$var$updateMemoComponent(null, workInProgress, current, props, renderLanes);
                            break a;
                        } else if ($$typeof === $1e79381dc3a64a75$var$REACT_CONTEXT_TYPE) {
                            workInProgress.tag = 10;
                            workInProgress.type = current;
                            workInProgress = $1e79381dc3a64a75$var$updateContextProvider(null, workInProgress, renderLanes);
                            break a;
                        }
                    }
                    workInProgress = $1e79381dc3a64a75$var$getComponentNameFromType(current) || current;
                    throw Error($1e79381dc3a64a75$var$formatProdErrorMessage(306, workInProgress, ""));
                }
            }
            return workInProgress;
        case 0:
            return $1e79381dc3a64a75$var$updateFunctionComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 1:
            return props = workInProgress.type, $$typeof = $1e79381dc3a64a75$var$resolveClassComponentProps(props, workInProgress.pendingProps), $1e79381dc3a64a75$var$updateClassComponent(current, workInProgress, props, $$typeof, renderLanes);
        case 3:
            a: {
                $1e79381dc3a64a75$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
                if (null === current) throw Error($1e79381dc3a64a75$var$formatProdErrorMessage(387));
                props = workInProgress.pendingProps;
                var prevState = workInProgress.memoizedState;
                $$typeof = prevState.element;
                $1e79381dc3a64a75$var$cloneUpdateQueue(current, workInProgress);
                $1e79381dc3a64a75$var$processUpdateQueue(workInProgress, props, null, renderLanes);
                var nextState = workInProgress.memoizedState;
                props = nextState.cache;
                $1e79381dc3a64a75$var$pushProvider(workInProgress, $1e79381dc3a64a75$var$CacheContext, props);
                props !== prevState.cache && $1e79381dc3a64a75$var$propagateContextChanges(workInProgress, [
                    $1e79381dc3a64a75$var$CacheContext
                ], renderLanes, !0);
                $1e79381dc3a64a75$var$suspendIfUpdateReadFromEntangledAsyncAction();
                props = nextState.element;
                if (prevState.isDehydrated) {
                    if (prevState = {
                        element: props,
                        isDehydrated: !1,
                        cache: nextState.cache
                    }, workInProgress.updateQueue.baseState = prevState, workInProgress.memoizedState = prevState, workInProgress.flags & 256) {
                        workInProgress = $1e79381dc3a64a75$var$mountHostRootWithoutHydrating(current, workInProgress, props, renderLanes);
                        break a;
                    } else if (props !== $$typeof) {
                        $$typeof = $1e79381dc3a64a75$var$createCapturedValueAtFiber(Error($1e79381dc3a64a75$var$formatProdErrorMessage(424)), workInProgress);
                        $1e79381dc3a64a75$var$queueHydrationError($$typeof);
                        workInProgress = $1e79381dc3a64a75$var$mountHostRootWithoutHydrating(current, workInProgress, props, renderLanes);
                        break a;
                    } else {
                        current = workInProgress.stateNode.containerInfo;
                        switch(current.nodeType){
                            case 9:
                                current = current.body;
                                break;
                            default:
                                current = "HTML" === current.nodeName ? current.ownerDocument.body : current;
                        }
                        $1e79381dc3a64a75$var$nextHydratableInstance = $1e79381dc3a64a75$var$getNextHydratable(current.firstChild);
                        $1e79381dc3a64a75$var$hydrationParentFiber = workInProgress;
                        $1e79381dc3a64a75$var$isHydrating = !0;
                        $1e79381dc3a64a75$var$hydrationErrors = null;
                        $1e79381dc3a64a75$var$rootOrSingletonContext = !0;
                        renderLanes = $1e79381dc3a64a75$var$mountChildFibers(workInProgress, null, props, renderLanes);
                        for(workInProgress.child = renderLanes; renderLanes;)renderLanes.flags = renderLanes.flags & -3 | 134221824, renderLanes = renderLanes.sibling;
                    }
                } else {
                    $1e79381dc3a64a75$var$resetHydrationState();
                    if (props === $$typeof) {
                        workInProgress = $1e79381dc3a64a75$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                        break a;
                    }
                    $1e79381dc3a64a75$var$reconcileChildren(current, workInProgress, props, renderLanes);
                }
                workInProgress = workInProgress.child;
            }
            return workInProgress;
        case 26:
            return $1e79381dc3a64a75$var$markRef(current, workInProgress), null === current ? (renderLanes = $1e79381dc3a64a75$var$getResource(workInProgress.type, null, workInProgress.pendingProps, null)) ? workInProgress.memoizedState = renderLanes : $1e79381dc3a64a75$var$isHydrating || (workInProgress.stateNode = $1e79381dc3a64a75$var$createHoistableInstance(workInProgress.type, workInProgress.pendingProps, $1e79381dc3a64a75$var$rootInstanceStackCursor.current, workInProgress)) : workInProgress.memoizedState = $1e79381dc3a64a75$var$getResource(workInProgress.type, current.memoizedProps, workInProgress.pendingProps, current.memoizedState), null;
        case 27:
            return $1e79381dc3a64a75$var$pushHostContext(workInProgress), null === current && $1e79381dc3a64a75$var$isHydrating && (props = workInProgress.stateNode = $1e79381dc3a64a75$var$resolveSingletonInstance(workInProgress.type, workInProgress.pendingProps, $1e79381dc3a64a75$var$rootInstanceStackCursor.current), $1e79381dc3a64a75$var$hydrationParentFiber = workInProgress, $1e79381dc3a64a75$var$rootOrSingletonContext = !0, $$typeof = $1e79381dc3a64a75$var$nextHydratableInstance, $1e79381dc3a64a75$var$isSingletonScope(workInProgress.type) ? ($1e79381dc3a64a75$var$previousHydratableOnEnteringScopedSingleton = $$typeof, $1e79381dc3a64a75$var$nextHydratableInstance = $1e79381dc3a64a75$var$getNextHydratable(props.firstChild)) : $1e79381dc3a64a75$var$nextHydratableInstance = $$typeof), $1e79381dc3a64a75$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), $1e79381dc3a64a75$var$markRef(current, workInProgress), null === current && (workInProgress.flags |= 4194304), workInProgress.child;
        case 5:
            if (null === current && $1e79381dc3a64a75$var$isHydrating) {
                if ($$typeof = props = $1e79381dc3a64a75$var$nextHydratableInstance) props = $1e79381dc3a64a75$var$canHydrateInstance(props, workInProgress.type, workInProgress.pendingProps, $1e79381dc3a64a75$var$rootOrSingletonContext), null !== props ? (workInProgress.stateNode = props, $1e79381dc3a64a75$var$hydrationParentFiber = workInProgress, $1e79381dc3a64a75$var$nextHydratableInstance = $1e79381dc3a64a75$var$getNextHydratable(props.firstChild), $1e79381dc3a64a75$var$rootOrSingletonContext = !1, $$typeof = !0) : $$typeof = !1;
                $$typeof || $1e79381dc3a64a75$var$throwOnHydrationMismatch(workInProgress);
            }
            $1e79381dc3a64a75$var$pushHostContext(workInProgress);
            $$typeof = workInProgress.type;
            prevState = workInProgress.pendingProps;
            nextState = null !== current ? current.memoizedProps : null;
            props = prevState.children;
            $1e79381dc3a64a75$var$shouldSetTextContent($$typeof, prevState) ? props = null : null !== nextState && $1e79381dc3a64a75$var$shouldSetTextContent($$typeof, nextState) && (workInProgress.flags |= 32);
            null !== workInProgress.memoizedState && ($$typeof = $1e79381dc3a64a75$var$renderWithHooks(current, workInProgress, $1e79381dc3a64a75$var$TransitionAwareHostComponent, null, null, renderLanes), $1e79381dc3a64a75$var$HostTransitionContext._currentValue = $$typeof);
            $1e79381dc3a64a75$var$markRef(current, workInProgress);
            $1e79381dc3a64a75$var$reconcileChildren(current, workInProgress, props, renderLanes);
            return workInProgress.child;
        case 6:
            if (null === current && $1e79381dc3a64a75$var$isHydrating) {
                if (current = renderLanes = $1e79381dc3a64a75$var$nextHydratableInstance) renderLanes = $1e79381dc3a64a75$var$canHydrateTextInstance(renderLanes, workInProgress.pendingProps, $1e79381dc3a64a75$var$rootOrSingletonContext), null !== renderLanes ? (workInProgress.stateNode = renderLanes, $1e79381dc3a64a75$var$hydrationParentFiber = workInProgress, $1e79381dc3a64a75$var$nextHydratableInstance = null, current = !0) : current = !1;
                current || $1e79381dc3a64a75$var$throwOnHydrationMismatch(workInProgress);
            }
            return null;
        case 13:
            return $1e79381dc3a64a75$var$updateSuspenseComponent(current, workInProgress, renderLanes);
        case 4:
            return $1e79381dc3a64a75$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo), props = workInProgress.pendingProps, null === current ? workInProgress.child = $1e79381dc3a64a75$var$reconcileChildFibers(workInProgress, null, props, renderLanes) : $1e79381dc3a64a75$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 11:
            return $1e79381dc3a64a75$var$updateForwardRef(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 7:
            return props = workInProgress.pendingProps, $1e79381dc3a64a75$var$markRef(current, workInProgress), $1e79381dc3a64a75$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 8:
            return $1e79381dc3a64a75$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 12:
            return $1e79381dc3a64a75$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 10:
            return $1e79381dc3a64a75$var$updateContextProvider(current, workInProgress, renderLanes);
        case 9:
            return $$typeof = workInProgress.type._context, props = workInProgress.pendingProps.children, $1e79381dc3a64a75$var$prepareToReadContext(workInProgress), $$typeof = $1e79381dc3a64a75$var$readContext($$typeof), props = props($$typeof), workInProgress.flags |= 1, $1e79381dc3a64a75$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 14:
            return $1e79381dc3a64a75$var$updateMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 15:
            return $1e79381dc3a64a75$var$updateSimpleMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 19:
            return $1e79381dc3a64a75$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
        case 31:
            return $1e79381dc3a64a75$var$updateActivityComponent(current, workInProgress, renderLanes);
        case 22:
            return $1e79381dc3a64a75$var$updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
        case 24:
            return $1e79381dc3a64a75$var$prepareToReadContext(workInProgress), props = $1e79381dc3a64a75$var$readContext($1e79381dc3a64a75$var$CacheContext), null === current ? ($$typeof = $1e79381dc3a64a75$var$peekCacheFromPool(), null === $$typeof && ($$typeof = $1e79381dc3a64a75$var$workInProgressRoot, prevState = $1e79381dc3a64a75$var$createCache(), $$typeof.pooledCache = prevState, prevState.refCount++, null !== prevState && ($$typeof.pooledCacheLanes |= renderLanes), $$typeof = prevState), workInProgress.memoizedState = {
                parent: props,
                cache: $$typeof
            }, $1e79381dc3a64a75$var$initializeUpdateQueue(workInProgress), $1e79381dc3a64a75$var$pushProvider(workInProgress, $1e79381dc3a64a75$var$CacheContext, $$typeof)) : (0 !== (current.lanes & renderLanes) && ($1e79381dc3a64a75$var$cloneUpdateQueue(current, workInProgress), $1e79381dc3a64a75$var$processUpdateQueue(workInProgress, null, null, renderLanes), $1e79381dc3a64a75$var$suspendIfUpdateReadFromEntangledAsyncAction()), $$typeof = current.memoizedState, prevState = workInProgress.memoizedState, $$typeof.parent !== props ? ($$typeof = {
                parent: props,
                cache: props
            }, workInProgress.memoizedState = $$typeof, 0 === workInProgress.lanes && (workInProgress.memoizedState = workInProgress.updateQueue.baseState = $$typeof), $1e79381dc3a64a75$var$pushProvider(workInProgress, $1e79381dc3a64a75$var$CacheContext, props)) : (props = prevState.cache, $1e79381dc3a64a75$var$pushProvider(workInProgress, $1e79381dc3a64a75$var$CacheContext, props), props !== $$typeof.cache && $1e79381dc3a64a75$var$propagateContextChanges(workInProgress, [
                $1e79381dc3a64a75$var$CacheContext
            ], renderLanes, !0))), $1e79381dc3a64a75$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 30:
            return null === workInProgress.stateNode && (workInProgress.stateNode = {
                autoName: null,
                paired: null,
                clones: null,
                ref: null
            }), props = workInProgress.pendingProps, null != props.name && "auto" !== props.name ? workInProgress.flags |= null === current ? 18882560 : 18874368 : $1e79381dc3a64a75$var$isHydrating && $1e79381dc3a64a75$var$pushMaterializedTreeId(workInProgress), null !== current && current.memoizedProps.name !== props.name ? workInProgress.flags |= 4194816 : $1e79381dc3a64a75$var$markRef(current, workInProgress), $1e79381dc3a64a75$var$reconcileChildren(current, workInProgress, props.children, renderLanes), workInProgress.child;
        case 29:
            throw workInProgress.pendingProps;
    }
    throw Error($1e79381dc3a64a75$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $1e79381dc3a64a75$var$markUpdate(workInProgress) {
    workInProgress.flags |= 4;
}
function $1e79381dc3a64a75$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, oldProps, newProps, renderLanes) {
    var JSCompiler_temp;
    if (JSCompiler_temp = 0 !== (workInProgress.mode & 32)) JSCompiler_temp = null === oldProps ? $1e79381dc3a64a75$var$maySuspendCommit(type, newProps) : $1e79381dc3a64a75$var$maySuspendCommit(type, newProps) && (newProps.src !== oldProps.src || newProps.srcSet !== oldProps.srcSet);
    if (JSCompiler_temp) {
        if (workInProgress.flags |= 16777216, (renderLanes & 335544128) === renderLanes) {
            if (workInProgress.stateNode.complete) workInProgress.flags |= 8192;
            else if ($1e79381dc3a64a75$var$shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
            else throw $1e79381dc3a64a75$var$suspendedThenable = $1e79381dc3a64a75$var$noopSuspenseyCommitThenable, $1e79381dc3a64a75$var$SuspenseyCommitException;
        }
    } else workInProgress.flags &= -16777217;
}
function $1e79381dc3a64a75$var$preloadResourceAndSuspendIfNeeded(workInProgress, resource) {
    if ("stylesheet" !== resource.type || 0 !== (resource.state.loading & 4)) workInProgress.flags &= -16777217;
    else if (workInProgress.flags |= 16777216, !$1e79381dc3a64a75$var$preloadResource(resource)) {
        if ($1e79381dc3a64a75$var$shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
        else throw $1e79381dc3a64a75$var$suspendedThenable = $1e79381dc3a64a75$var$noopSuspenseyCommitThenable, $1e79381dc3a64a75$var$SuspenseyCommitException;
    }
}
function $1e79381dc3a64a75$var$scheduleRetryEffect(workInProgress, retryQueue) {
    null !== retryQueue && (workInProgress.flags |= 4);
    workInProgress.flags & 16384 && (retryQueue = 22 !== workInProgress.tag ? $1e79381dc3a64a75$var$claimNextRetryLane() : 536870912, workInProgress.lanes |= retryQueue, $1e79381dc3a64a75$var$workInProgressSuspendedRetryLanes |= retryQueue);
}
function $1e79381dc3a64a75$var$cutOffTailIfNeeded(renderState, hasRenderedATailFallback) {
    if (!$1e79381dc3a64a75$var$isHydrating) switch(renderState.tailMode){
        case "visible":
            break;
        case "collapsed":
            for(var tailNode = renderState.tail, lastTailNode = null; null !== tailNode;)null !== tailNode.alternate && (lastTailNode = tailNode), tailNode = tailNode.sibling;
            null === lastTailNode ? hasRenderedATailFallback || null === renderState.tail ? renderState.tail = null : renderState.tail.sibling = null : lastTailNode.sibling = null;
            break;
        default:
            hasRenderedATailFallback = renderState.tail;
            for(tailNode = null; null !== hasRenderedATailFallback;)null !== hasRenderedATailFallback.alternate && (tailNode = hasRenderedATailFallback), hasRenderedATailFallback = hasRenderedATailFallback.sibling;
            null === tailNode ? renderState.tail = null : tailNode.sibling = null;
    }
}
function $1e79381dc3a64a75$var$bubbleProperties(completedWork) {
    var didBailout = null !== completedWork.alternate && completedWork.alternate.child === completedWork.child, newChildLanes = 0, subtreeFlags = 0;
    if (didBailout) for(var child$113 = completedWork.child; null !== child$113;)newChildLanes |= child$113.lanes | child$113.childLanes, subtreeFlags |= child$113.subtreeFlags & 1206910976, subtreeFlags |= child$113.flags & 1206910976, child$113.return = completedWork, child$113 = child$113.sibling;
    else for(child$113 = completedWork.child; null !== child$113;)newChildLanes |= child$113.lanes | child$113.childLanes, subtreeFlags |= child$113.subtreeFlags, subtreeFlags |= child$113.flags, child$113.return = completedWork, child$113 = child$113.sibling;
    completedWork.subtreeFlags |= subtreeFlags;
    completedWork.childLanes = newChildLanes;
    return didBailout;
}
function $1e79381dc3a64a75$var$completeWork(current, workInProgress, renderLanes) {
    var newProps = workInProgress.pendingProps;
    $1e79381dc3a64a75$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $1e79381dc3a64a75$var$bubbleProperties(workInProgress), null;
        case 1:
            return $1e79381dc3a64a75$var$bubbleProperties(workInProgress), null;
        case 3:
            renderLanes = workInProgress.stateNode;
            newProps = null;
            null !== current && (newProps = current.memoizedState.cache);
            workInProgress.memoizedState.cache !== newProps && (workInProgress.flags |= 2048);
            $1e79381dc3a64a75$var$popProvider($1e79381dc3a64a75$var$CacheContext);
            $1e79381dc3a64a75$var$popHostContainer();
            renderLanes.pendingContext && (renderLanes.context = renderLanes.pendingContext, renderLanes.pendingContext = null);
            if (null === current || null === current.child) $1e79381dc3a64a75$var$popHydrationState(workInProgress) ? $1e79381dc3a64a75$var$markUpdate(workInProgress) : null === current || current.memoizedState.isDehydrated && 0 === (workInProgress.flags & 256) || (workInProgress.flags |= 1024, $1e79381dc3a64a75$var$upgradeHydrationErrorsToRecoverable());
            $1e79381dc3a64a75$var$bubbleProperties(workInProgress);
            return null;
        case 26:
            var type = workInProgress.type, nextResource = workInProgress.memoizedState;
            null === current ? ($1e79381dc3a64a75$var$markUpdate(workInProgress), null !== nextResource ? ($1e79381dc3a64a75$var$bubbleProperties(workInProgress), $1e79381dc3a64a75$var$preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : ($1e79381dc3a64a75$var$bubbleProperties(workInProgress), $1e79381dc3a64a75$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, null, newProps, renderLanes))) : nextResource ? nextResource !== current.memoizedState ? ($1e79381dc3a64a75$var$markUpdate(workInProgress), $1e79381dc3a64a75$var$bubbleProperties(workInProgress), $1e79381dc3a64a75$var$preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : ($1e79381dc3a64a75$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217) : (current = current.memoizedProps, current !== newProps && $1e79381dc3a64a75$var$markUpdate(workInProgress), $1e79381dc3a64a75$var$bubbleProperties(workInProgress), $1e79381dc3a64a75$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, current, newProps, renderLanes));
            return null;
        case 27:
            $1e79381dc3a64a75$var$popHostContext(workInProgress);
            renderLanes = $1e79381dc3a64a75$var$rootInstanceStackCursor.current;
            type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $1e79381dc3a64a75$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($1e79381dc3a64a75$var$formatProdErrorMessage(166));
                    $1e79381dc3a64a75$var$bubbleProperties(workInProgress);
                    workInProgress.subtreeFlags &= -33554433;
                    return null;
                }
                current = $1e79381dc3a64a75$var$contextStackCursor.current;
                $1e79381dc3a64a75$var$popHydrationState(workInProgress) ? $1e79381dc3a64a75$var$prepareToHydrateHostInstance(workInProgress, current) : (current = $1e79381dc3a64a75$var$resolveSingletonInstance(type, newProps, renderLanes), workInProgress.stateNode = current, $1e79381dc3a64a75$var$markUpdate(workInProgress));
            }
            $1e79381dc3a64a75$var$bubbleProperties(workInProgress);
            workInProgress.subtreeFlags &= -33554433;
            return null;
        case 5:
            $1e79381dc3a64a75$var$popHostContext(workInProgress);
            type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $1e79381dc3a64a75$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($1e79381dc3a64a75$var$formatProdErrorMessage(166));
                    $1e79381dc3a64a75$var$bubbleProperties(workInProgress);
                    workInProgress.subtreeFlags &= -33554433;
                    return null;
                }
                nextResource = $1e79381dc3a64a75$var$contextStackCursor.current;
                if ($1e79381dc3a64a75$var$popHydrationState(workInProgress)) $1e79381dc3a64a75$var$prepareToHydrateHostInstance(workInProgress, nextResource);
                else {
                    var ownerDocument = $1e79381dc3a64a75$var$getOwnerDocumentFromRootContainer($1e79381dc3a64a75$var$rootInstanceStackCursor.current);
                    switch(nextResource){
                        case 1:
                            nextResource = ownerDocument.createElementNS("http://www.w3.org/2000/svg", type);
                            break;
                        case 2:
                            nextResource = ownerDocument.createElementNS("http://www.w3.org/1998/Math/MathML", type);
                            break;
                        default:
                            switch(type){
                                case "svg":
                                    nextResource = ownerDocument.createElementNS("http://www.w3.org/2000/svg", type);
                                    break;
                                case "math":
                                    nextResource = ownerDocument.createElementNS("http://www.w3.org/1998/Math/MathML", type);
                                    break;
                                case "script":
                                    nextResource = ownerDocument.createElement("div");
                                    nextResource.innerHTML = "<script>\x3c/script>";
                                    nextResource = nextResource.removeChild(nextResource.firstChild);
                                    break;
                                case "select":
                                    nextResource = "string" === typeof newProps.is ? ownerDocument.createElement("select", {
                                        is: newProps.is
                                    }) : ownerDocument.createElement("select");
                                    newProps.multiple ? nextResource.multiple = !0 : newProps.size && (nextResource.size = newProps.size);
                                    break;
                                default:
                                    nextResource = "string" === typeof newProps.is ? ownerDocument.createElement(type, {
                                        is: newProps.is
                                    }) : ownerDocument.createElement(type);
                            }
                    }
                    nextResource[$1e79381dc3a64a75$var$internalInstanceKey] = workInProgress;
                    nextResource[$1e79381dc3a64a75$var$internalPropsKey] = newProps;
                    a: for(ownerDocument = workInProgress.child; null !== ownerDocument;){
                        if (5 === ownerDocument.tag || 6 === ownerDocument.tag) nextResource.appendChild(ownerDocument.stateNode);
                        else if (4 !== ownerDocument.tag && 27 !== ownerDocument.tag && null !== ownerDocument.child) {
                            ownerDocument.child.return = ownerDocument;
                            ownerDocument = ownerDocument.child;
                            continue;
                        }
                        if (ownerDocument === workInProgress) break a;
                        for(; null === ownerDocument.sibling;){
                            if (null === ownerDocument.return || ownerDocument.return === workInProgress) break a;
                            ownerDocument = ownerDocument.return;
                        }
                        ownerDocument.sibling.return = ownerDocument.return;
                        ownerDocument = ownerDocument.sibling;
                    }
                    workInProgress.stateNode = nextResource;
                    a: switch($1e79381dc3a64a75$var$setInitialProperties(nextResource, type, newProps), type){
                        case "button":
                        case "input":
                        case "select":
                        case "textarea":
                            newProps = !!newProps.autoFocus;
                            break a;
                        case "img":
                            newProps = !0;
                            break a;
                        default:
                            newProps = !1;
                    }
                    newProps && $1e79381dc3a64a75$var$markUpdate(workInProgress);
                }
            }
            $1e79381dc3a64a75$var$bubbleProperties(workInProgress);
            workInProgress.subtreeFlags &= -33554433;
            $1e79381dc3a64a75$var$preloadInstanceAndSuspendIfNeeded(workInProgress, workInProgress.type, null === current ? null : current.memoizedProps, workInProgress.pendingProps, renderLanes);
            return null;
        case 6:
            if (current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $1e79381dc3a64a75$var$markUpdate(workInProgress);
            else {
                if ("string" !== typeof newProps && null === workInProgress.stateNode) throw Error($1e79381dc3a64a75$var$formatProdErrorMessage(166));
                current = $1e79381dc3a64a75$var$rootInstanceStackCursor.current;
                if ($1e79381dc3a64a75$var$popHydrationState(workInProgress)) {
                    current = workInProgress.stateNode;
                    renderLanes = workInProgress.memoizedProps;
                    newProps = null;
                    type = $1e79381dc3a64a75$var$hydrationParentFiber;
                    if (null !== type) switch(type.tag){
                        case 27:
                        case 5:
                            newProps = type.memoizedProps;
                    }
                    current[$1e79381dc3a64a75$var$internalInstanceKey] = workInProgress;
                    current = current.nodeValue === renderLanes || null !== newProps && !0 === newProps.suppressHydrationWarning || $1e79381dc3a64a75$var$checkForUnmatchedText(current.nodeValue, renderLanes) ? !0 : !1;
                    current || $1e79381dc3a64a75$var$throwOnHydrationMismatch(workInProgress, !0);
                } else current = $1e79381dc3a64a75$var$getOwnerDocumentFromRootContainer(current).createTextNode(newProps), current[$1e79381dc3a64a75$var$internalInstanceKey] = workInProgress, workInProgress.stateNode = current;
            }
            $1e79381dc3a64a75$var$bubbleProperties(workInProgress);
            return null;
        case 31:
            renderLanes = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState) {
                newProps = $1e79381dc3a64a75$var$popHydrationState(workInProgress);
                if (null !== renderLanes) {
                    if (null === current) {
                        if (!newProps) throw Error($1e79381dc3a64a75$var$formatProdErrorMessage(318));
                        current = workInProgress.memoizedState;
                        current = null !== current ? current.dehydrated : null;
                        if (!current) throw Error($1e79381dc3a64a75$var$formatProdErrorMessage(557));
                        current[$1e79381dc3a64a75$var$internalInstanceKey] = workInProgress;
                    } else $1e79381dc3a64a75$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $1e79381dc3a64a75$var$bubbleProperties(workInProgress);
                    current = !1;
                } else renderLanes = $1e79381dc3a64a75$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = renderLanes), current = !0;
                if (!current) {
                    if (workInProgress.flags & 256) return $1e79381dc3a64a75$var$popSuspenseHandler(workInProgress), workInProgress;
                    $1e79381dc3a64a75$var$popSuspenseHandler(workInProgress);
                    return null;
                }
                if (0 !== (workInProgress.flags & 128)) throw Error($1e79381dc3a64a75$var$formatProdErrorMessage(558));
            }
            $1e79381dc3a64a75$var$bubbleProperties(workInProgress);
            return null;
        case 13:
            newProps = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState && null !== current.memoizedState.dehydrated) {
                type = $1e79381dc3a64a75$var$popHydrationState(workInProgress);
                if (null !== newProps && null !== newProps.dehydrated) {
                    if (null === current) {
                        if (!type) throw Error($1e79381dc3a64a75$var$formatProdErrorMessage(318));
                        type = workInProgress.memoizedState;
                        type = null !== type ? type.dehydrated : null;
                        if (!type) throw Error($1e79381dc3a64a75$var$formatProdErrorMessage(317));
                        type[$1e79381dc3a64a75$var$internalInstanceKey] = workInProgress;
                    } else $1e79381dc3a64a75$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $1e79381dc3a64a75$var$bubbleProperties(workInProgress);
                    type = !1;
                } else type = $1e79381dc3a64a75$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = type), type = !0;
                if (!type) {
                    if (workInProgress.flags & 256) return $1e79381dc3a64a75$var$popSuspenseHandler(workInProgress), workInProgress;
                    $1e79381dc3a64a75$var$popSuspenseHandler(workInProgress);
                    return null;
                }
            }
            $1e79381dc3a64a75$var$popSuspenseHandler(workInProgress);
            if (0 !== (workInProgress.flags & 128)) return workInProgress.lanes = renderLanes, workInProgress;
            renderLanes = null !== newProps;
            current = null !== current && null !== current.memoizedState;
            renderLanes && (newProps = workInProgress.child, type = null, null !== newProps.alternate && null !== newProps.alternate.memoizedState && null !== newProps.alternate.memoizedState.cachePool && (type = newProps.alternate.memoizedState.cachePool.pool), nextResource = null, null !== newProps.memoizedState && null !== newProps.memoizedState.cachePool && (nextResource = newProps.memoizedState.cachePool.pool), nextResource !== type && (newProps.flags |= 2048));
            renderLanes !== current && renderLanes && (workInProgress.child.flags |= 8192);
            $1e79381dc3a64a75$var$scheduleRetryEffect(workInProgress, workInProgress.updateQueue);
            $1e79381dc3a64a75$var$bubbleProperties(workInProgress);
            return null;
        case 4:
            return $1e79381dc3a64a75$var$popHostContainer(), null === current && $1e79381dc3a64a75$var$listenToAllSupportedEvents(workInProgress.stateNode.containerInfo), workInProgress.flags |= 67108864, $1e79381dc3a64a75$var$bubbleProperties(workInProgress), null;
        case 10:
            return $1e79381dc3a64a75$var$popProvider(workInProgress.type), $1e79381dc3a64a75$var$bubbleProperties(workInProgress), null;
        case 19:
            $1e79381dc3a64a75$var$popSuspenseListContext(workInProgress);
            newProps = workInProgress.memoizedState;
            if (null === newProps) return $1e79381dc3a64a75$var$bubbleProperties(workInProgress), null;
            type = 0 !== (workInProgress.flags & 128);
            nextResource = newProps.rendering;
            if (null === nextResource) {
                if (type) $1e79381dc3a64a75$var$cutOffTailIfNeeded(newProps, !1);
                else {
                    if (0 !== $1e79381dc3a64a75$var$workInProgressRootExitStatus || null !== current && 0 !== (current.flags & 128)) for(current = workInProgress.child; null !== current;){
                        nextResource = $1e79381dc3a64a75$var$findFirstSuspended(current);
                        if (null !== nextResource) {
                            workInProgress.flags |= 128;
                            $1e79381dc3a64a75$var$cutOffTailIfNeeded(newProps, !1);
                            current = nextResource.updateQueue;
                            workInProgress.updateQueue = current;
                            $1e79381dc3a64a75$var$scheduleRetryEffect(workInProgress, current);
                            workInProgress.subtreeFlags = 0;
                            current = renderLanes;
                            for(renderLanes = workInProgress.child; null !== renderLanes;)$1e79381dc3a64a75$var$resetWorkInProgress(renderLanes, current), renderLanes = renderLanes.sibling;
                            $1e79381dc3a64a75$var$pushSuspenseListContext(workInProgress, $1e79381dc3a64a75$var$suspenseStackCursor.current & 1 | 2);
                            $1e79381dc3a64a75$var$isHydrating && $1e79381dc3a64a75$var$pushTreeFork(workInProgress, newProps.treeForkCount);
                            return workInProgress.child;
                        }
                        current = current.sibling;
                    }
                    null !== newProps.tail && $1e79381dc3a64a75$var$now() > $1e79381dc3a64a75$var$workInProgressRootRenderTargetTime && (workInProgress.flags |= 128, type = !0, $1e79381dc3a64a75$var$cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                }
            } else {
                if (!type) {
                    if (current = $1e79381dc3a64a75$var$findFirstSuspended(nextResource), null !== current) {
                        if (workInProgress.flags |= 128, type = !0, current = current.updateQueue, workInProgress.updateQueue = current, $1e79381dc3a64a75$var$scheduleRetryEffect(workInProgress, current), $1e79381dc3a64a75$var$cutOffTailIfNeeded(newProps, !0), null === newProps.tail && "collapsed" !== newProps.tailMode && "visible" !== newProps.tailMode && !nextResource.alternate && !$1e79381dc3a64a75$var$isHydrating) return $1e79381dc3a64a75$var$bubbleProperties(workInProgress), null;
                    } else 2 * $1e79381dc3a64a75$var$now() - newProps.renderingStartTime > $1e79381dc3a64a75$var$workInProgressRootRenderTargetTime && 536870912 !== renderLanes && (workInProgress.flags |= 128, type = !0, $1e79381dc3a64a75$var$cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                }
                newProps.isBackwards ? (nextResource.sibling = workInProgress.child, workInProgress.child = nextResource) : (current = newProps.last, null !== current ? current.sibling = nextResource : workInProgress.child = nextResource, newProps.last = nextResource);
            }
            if (null !== newProps.tail) {
                current = newProps.tail;
                a: {
                    for(renderLanes = current; null !== renderLanes;){
                        if (null !== renderLanes.alternate) {
                            renderLanes = !1;
                            break a;
                        }
                        renderLanes = renderLanes.sibling;
                    }
                    renderLanes = !0;
                }
                newProps.rendering = current;
                newProps.tail = current.sibling;
                newProps.renderingStartTime = $1e79381dc3a64a75$var$now();
                current.sibling = null;
                nextResource = $1e79381dc3a64a75$var$suspenseStackCursor.current;
                nextResource = type ? nextResource & 1 | 2 : nextResource & 1;
                "visible" === newProps.tailMode || "collapsed" === newProps.tailMode || !renderLanes || $1e79381dc3a64a75$var$isHydrating ? $1e79381dc3a64a75$var$pushSuspenseListContext(workInProgress, nextResource) : (renderLanes = nextResource, $1e79381dc3a64a75$var$push($1e79381dc3a64a75$var$suspenseHandlerStackCursor, workInProgress), $1e79381dc3a64a75$var$push($1e79381dc3a64a75$var$suspenseStackCursor, renderLanes), null === $1e79381dc3a64a75$var$shellBoundary && ($1e79381dc3a64a75$var$shellBoundary = workInProgress));
                $1e79381dc3a64a75$var$isHydrating && $1e79381dc3a64a75$var$pushTreeFork(workInProgress, newProps.treeForkCount);
                return current;
            }
            $1e79381dc3a64a75$var$bubbleProperties(workInProgress);
            return null;
        case 22:
        case 23:
            return $1e79381dc3a64a75$var$popSuspenseHandler(workInProgress), $1e79381dc3a64a75$var$popHiddenContext(), newProps = null !== workInProgress.memoizedState, null !== current ? null !== current.memoizedState !== newProps && (workInProgress.flags |= 8192) : newProps && (workInProgress.flags |= 8192), newProps ? 0 !== (renderLanes & 536870912) && 0 === (workInProgress.flags & 128) && ($1e79381dc3a64a75$var$bubbleProperties(workInProgress), workInProgress.subtreeFlags & 6 && (workInProgress.flags |= 8192)) : $1e79381dc3a64a75$var$bubbleProperties(workInProgress), renderLanes = workInProgress.updateQueue, null !== renderLanes && $1e79381dc3a64a75$var$scheduleRetryEffect(workInProgress, renderLanes.retryQueue), renderLanes = null, null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (renderLanes = current.memoizedState.cachePool.pool), newProps = null, null !== workInProgress.memoizedState && null !== workInProgress.memoizedState.cachePool && (newProps = workInProgress.memoizedState.cachePool.pool), newProps !== renderLanes && (workInProgress.flags |= 2048), null !== current && $1e79381dc3a64a75$var$pop($1e79381dc3a64a75$var$resumedCache), null;
        case 24:
            return renderLanes = null, null !== current && (renderLanes = current.memoizedState.cache), workInProgress.memoizedState.cache !== renderLanes && (workInProgress.flags |= 2048), $1e79381dc3a64a75$var$popProvider($1e79381dc3a64a75$var$CacheContext), $1e79381dc3a64a75$var$bubbleProperties(workInProgress), null;
        case 25:
            return null;
        case 30:
            return workInProgress.flags |= 33554432, $1e79381dc3a64a75$var$bubbleProperties(workInProgress), null;
    }
    throw Error($1e79381dc3a64a75$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $1e79381dc3a64a75$var$unwindWork(current, workInProgress) {
    $1e79381dc3a64a75$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 1:
            return current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 3:
            return $1e79381dc3a64a75$var$popProvider($1e79381dc3a64a75$var$CacheContext), $1e79381dc3a64a75$var$popHostContainer(), current = workInProgress.flags, 0 !== (current & 65536) && 0 === (current & 128) ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 26:
        case 27:
        case 5:
            return $1e79381dc3a64a75$var$popHostContext(workInProgress), null;
        case 31:
            if (null !== workInProgress.memoizedState) {
                $1e79381dc3a64a75$var$popSuspenseHandler(workInProgress);
                if (null === workInProgress.alternate) throw Error($1e79381dc3a64a75$var$formatProdErrorMessage(340));
                $1e79381dc3a64a75$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 13:
            $1e79381dc3a64a75$var$popSuspenseHandler(workInProgress);
            current = workInProgress.memoizedState;
            if (null !== current && null !== current.dehydrated) {
                if (null === workInProgress.alternate) throw Error($1e79381dc3a64a75$var$formatProdErrorMessage(340));
                $1e79381dc3a64a75$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 19:
            return $1e79381dc3a64a75$var$popSuspenseListContext(workInProgress), current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, current = workInProgress.memoizedState, null !== current && (current.rendering = null, current.tail = null), workInProgress.flags |= 4, workInProgress) : null;
        case 4:
            return $1e79381dc3a64a75$var$popHostContainer(), null;
        case 10:
            return $1e79381dc3a64a75$var$popProvider(workInProgress.type), null;
        case 22:
        case 23:
            return $1e79381dc3a64a75$var$popSuspenseHandler(workInProgress), $1e79381dc3a64a75$var$popHiddenContext(), null !== current && $1e79381dc3a64a75$var$pop($1e79381dc3a64a75$var$resumedCache), current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 24:
            return $1e79381dc3a64a75$var$popProvider($1e79381dc3a64a75$var$CacheContext), null;
        case 25:
            return null;
        default:
            return null;
    }
}
function $1e79381dc3a64a75$var$unwindInterruptedWork(current, interruptedWork) {
    $1e79381dc3a64a75$var$popTreeContext(interruptedWork);
    switch(interruptedWork.tag){
        case 3:
            $1e79381dc3a64a75$var$popProvider($1e79381dc3a64a75$var$CacheContext);
            $1e79381dc3a64a75$var$popHostContainer();
            break;
        case 26:
        case 27:
        case 5:
            $1e79381dc3a64a75$var$popHostContext(interruptedWork);
            break;
        case 4:
            $1e79381dc3a64a75$var$popHostContainer();
            break;
        case 31:
            null !== interruptedWork.memoizedState && $1e79381dc3a64a75$var$popSuspenseHandler(interruptedWork);
            break;
        case 13:
            $1e79381dc3a64a75$var$popSuspenseHandler(interruptedWork);
            break;
        case 19:
            $1e79381dc3a64a75$var$popSuspenseListContext(interruptedWork);
            break;
        case 10:
            $1e79381dc3a64a75$var$popProvider(interruptedWork.type);
            break;
        case 22:
        case 23:
            $1e79381dc3a64a75$var$popSuspenseHandler(interruptedWork);
            $1e79381dc3a64a75$var$popHiddenContext();
            null !== current && $1e79381dc3a64a75$var$pop($1e79381dc3a64a75$var$resumedCache);
            break;
        case 24:
            $1e79381dc3a64a75$var$popProvider($1e79381dc3a64a75$var$CacheContext);
    }
}
function $1e79381dc3a64a75$var$commitHookEffectListMount(flags, finishedWork) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    lastEffect = void 0;
                    var create = updateQueue.create, inst = updateQueue.inst;
                    lastEffect = create();
                    inst.destroy = lastEffect;
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $1e79381dc3a64a75$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $1e79381dc3a64a75$var$commitHookEffectListUnmount(flags, finishedWork, nearestMountedAncestor$jscomp$0) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    var inst = updateQueue.inst, destroy = inst.destroy;
                    if (void 0 !== destroy) {
                        inst.destroy = void 0;
                        lastEffect = finishedWork;
                        var nearestMountedAncestor = nearestMountedAncestor$jscomp$0, destroy_ = destroy;
                        try {
                            destroy_();
                        } catch (error) {
                            $1e79381dc3a64a75$var$captureCommitPhaseError(lastEffect, nearestMountedAncestor, error);
                        }
                    }
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $1e79381dc3a64a75$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $1e79381dc3a64a75$var$commitClassCallbacks(finishedWork) {
    var updateQueue = finishedWork.updateQueue;
    if (null !== updateQueue) {
        var instance = finishedWork.stateNode;
        try {
            $1e79381dc3a64a75$var$commitCallbacks(updateQueue, instance);
        } catch (error) {
            $1e79381dc3a64a75$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $1e79381dc3a64a75$var$safelyCallComponentWillUnmount(current, nearestMountedAncestor, instance) {
    instance.props = $1e79381dc3a64a75$var$resolveClassComponentProps(current.type, current.memoizedProps);
    instance.state = current.memoizedState;
    try {
        instance.componentWillUnmount();
    } catch (error) {
        $1e79381dc3a64a75$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $1e79381dc3a64a75$var$safelyAttachRef(current, nearestMountedAncestor) {
    try {
        var ref = current.ref;
        if (null !== ref) {
            switch(current.tag){
                case 26:
                case 27:
                case 5:
                    var instanceToUse = current.stateNode;
                    break;
                case 30:
                    var instance = current.stateNode, name = $1e79381dc3a64a75$var$getViewTransitionName(current.memoizedProps, instance);
                    if (null === instance.ref || instance.ref.name !== name) instance.ref = $1e79381dc3a64a75$var$createViewTransitionInstance(name);
                    instanceToUse = instance.ref;
                    break;
                case 7:
                    if (null === current.stateNode) {
                        var fragmentInstance = new $1e79381dc3a64a75$var$FragmentInstance(current);
                        $1e79381dc3a64a75$var$traverseVisibleInstancesAndTextInstances(current.child, !1, $1e79381dc3a64a75$var$addFragmentHandleToFiber, fragmentInstance, void 0, void 0);
                        current.stateNode = fragmentInstance;
                    }
                    instanceToUse = current.stateNode;
                    break;
                default:
                    instanceToUse = current.stateNode;
            }
            "function" === typeof ref ? current.refCleanup = ref(instanceToUse) : ref.current = instanceToUse;
        }
    } catch (error) {
        $1e79381dc3a64a75$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $1e79381dc3a64a75$var$safelyDetachRef(current, nearestMountedAncestor) {
    var ref = current.ref, refCleanup = current.refCleanup;
    if (null !== ref) {
        if ("function" === typeof refCleanup) try {
            refCleanup();
        } catch (error) {
            $1e79381dc3a64a75$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
        } finally{
            current.refCleanup = null, current = current.alternate, null != current && (current.refCleanup = null);
        }
        else if ("function" === typeof ref) try {
            ref(null);
        } catch (error$148) {
            $1e79381dc3a64a75$var$captureCommitPhaseError(current, nearestMountedAncestor, error$148);
        }
        else ref.current = null;
    }
}
function $1e79381dc3a64a75$var$commitNewChildToFragmentInstances(fiber, parentFragmentInstances) {
    if ((5 === fiber.tag || 27 === fiber.tag || 6 === fiber.tag) && null === fiber.alternate && null !== parentFragmentInstances) for(var i = 0; i < parentFragmentInstances.length; i++)$1e79381dc3a64a75$var$commitNewChildToFragmentInstance(fiber.stateNode, parentFragmentInstances[i]);
}
function $1e79381dc3a64a75$var$commitFragmentInstanceInsertionEffects(fiber) {
    for(var parent = fiber.return; null !== parent;){
        $1e79381dc3a64a75$var$isFragmentInstanceParent(parent) && $1e79381dc3a64a75$var$commitNewChildToFragmentInstance(fiber.stateNode, parent.stateNode);
        if ($1e79381dc3a64a75$var$isFragmentInstanceHostBoundary(parent)) break;
        parent = parent.return;
    }
}
function $1e79381dc3a64a75$var$commitFragmentInstanceDeletionEffects(fiber) {
    for(var parent = fiber.return; null !== parent;){
        $1e79381dc3a64a75$var$isFragmentInstanceParent(parent) && $1e79381dc3a64a75$var$deleteChildFromFragmentInstance(fiber.stateNode, parent.stateNode);
        if ($1e79381dc3a64a75$var$isFragmentInstanceHostBoundary(parent)) break;
        parent = parent.return;
    }
}
function $1e79381dc3a64a75$var$isFragmentInstanceHostBoundary(fiber) {
    return 5 === fiber.tag || 3 === fiber.tag || 27 === fiber.tag;
}
function $1e79381dc3a64a75$var$isFragmentInstanceParent(fiber) {
    return fiber && 7 === fiber.tag && null !== fiber.stateNode;
}
function $1e79381dc3a64a75$var$commitHostMount(finishedWork) {
    var type = finishedWork.type, props = finishedWork.memoizedProps, instance = finishedWork.stateNode;
    try {
        a: switch(type){
            case "button":
            case "input":
            case "select":
            case "textarea":
                props.autoFocus && instance.focus();
                break a;
            case "img":
                props.src ? instance.src = props.src : props.srcSet && (instance.srcset = props.srcSet);
        }
    } catch (error) {
        $1e79381dc3a64a75$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $1e79381dc3a64a75$var$commitHostUpdate(finishedWork, newProps, oldProps) {
    try {
        var domElement = finishedWork.stateNode;
        $1e79381dc3a64a75$var$updateProperties(domElement, finishedWork.type, oldProps, newProps);
        domElement[$1e79381dc3a64a75$var$internalPropsKey] = newProps;
    } catch (error) {
        $1e79381dc3a64a75$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $1e79381dc3a64a75$var$isHostParent(fiber) {
    return 5 === fiber.tag || 3 === fiber.tag || 26 === fiber.tag || 27 === fiber.tag && $1e79381dc3a64a75$var$isSingletonScope(fiber.type) || 4 === fiber.tag;
}
function $1e79381dc3a64a75$var$getHostSibling(fiber) {
    a: for(;;){
        for(; null === fiber.sibling;){
            if (null === fiber.return || $1e79381dc3a64a75$var$isHostParent(fiber.return)) return null;
            fiber = fiber.return;
        }
        fiber.sibling.return = fiber.return;
        for(fiber = fiber.sibling; 5 !== fiber.tag && 6 !== fiber.tag && 18 !== fiber.tag;){
            if (27 === fiber.tag && $1e79381dc3a64a75$var$isSingletonScope(fiber.type)) continue a;
            if (fiber.flags & 2) continue a;
            if (null === fiber.child || 4 === fiber.tag) continue a;
            else fiber.child.return = fiber, fiber = fiber.child;
        }
        if (!(fiber.flags & 2)) return fiber.stateNode;
    }
}
function $1e79381dc3a64a75$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent, parentFragmentInstances) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) tag = node.stateNode, before ? (9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent).insertBefore(tag, before) : (before = 9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent, before.appendChild(tag), parent = parent._reactRootContainer, null !== parent && void 0 !== parent || null !== before.onclick || (before.onclick = $1e79381dc3a64a75$var$noop$1)), $1e79381dc3a64a75$var$commitNewChildToFragmentInstances(node, parentFragmentInstances), $1e79381dc3a64a75$var$viewTransitionMutationContext = !0;
    else if (4 !== tag && (27 === tag && ($1e79381dc3a64a75$var$commitNewChildToFragmentInstances(node, parentFragmentInstances), parentFragmentInstances = null, $1e79381dc3a64a75$var$isSingletonScope(node.type) && (parent = node.stateNode, before = null)), node = node.child, null !== node)) for($1e79381dc3a64a75$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent, parentFragmentInstances), node = node.sibling; null !== node;)$1e79381dc3a64a75$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent, parentFragmentInstances), node = node.sibling;
}
function $1e79381dc3a64a75$var$insertOrAppendPlacementNode(node, before, parent, parentFragmentInstances) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) tag = node.stateNode, before ? parent.insertBefore(tag, before) : parent.appendChild(tag), $1e79381dc3a64a75$var$commitNewChildToFragmentInstances(node, parentFragmentInstances), $1e79381dc3a64a75$var$viewTransitionMutationContext = !0;
    else if (4 !== tag && (27 === tag && ($1e79381dc3a64a75$var$commitNewChildToFragmentInstances(node, parentFragmentInstances), parentFragmentInstances = null, $1e79381dc3a64a75$var$isSingletonScope(node.type) && (parent = node.stateNode)), node = node.child, null !== node)) for($1e79381dc3a64a75$var$insertOrAppendPlacementNode(node, before, parent, parentFragmentInstances), node = node.sibling; null !== node;)$1e79381dc3a64a75$var$insertOrAppendPlacementNode(node, before, parent, parentFragmentInstances), node = node.sibling;
}
function $1e79381dc3a64a75$var$commitHostSingletonAcquisition(finishedWork) {
    var singleton = finishedWork.stateNode, props = finishedWork.memoizedProps;
    try {
        for(var type = finishedWork.type, attributes = singleton.attributes; attributes.length;)singleton.removeAttributeNode(attributes[0]);
        $1e79381dc3a64a75$var$setInitialProperties(singleton, type, props);
        singleton[$1e79381dc3a64a75$var$internalInstanceKey] = finishedWork;
        singleton[$1e79381dc3a64a75$var$internalPropsKey] = props;
    } catch (error) {
        $1e79381dc3a64a75$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
var $1e79381dc3a64a75$var$shouldStartViewTransition = !1, $1e79381dc3a64a75$var$appearingViewTransitions = null;
function $1e79381dc3a64a75$var$trackEnterViewTransitions(placement) {
    if (30 === placement.tag || 0 !== (placement.subtreeFlags & 33554432)) $1e79381dc3a64a75$var$shouldStartViewTransition = !0;
}
var $1e79381dc3a64a75$var$viewTransitionCancelableChildren = null;
function $1e79381dc3a64a75$var$pushViewTransitionCancelableScope() {
    var prevChildren = $1e79381dc3a64a75$var$viewTransitionCancelableChildren;
    $1e79381dc3a64a75$var$viewTransitionCancelableChildren = null;
    return prevChildren;
}
var $1e79381dc3a64a75$var$viewTransitionHostInstanceIdx = 0;
function $1e79381dc3a64a75$var$applyViewTransitionToHostInstances(fiber, name, className, collectMeasurements, stopAtNestedViewTransitions) {
    $1e79381dc3a64a75$var$viewTransitionHostInstanceIdx = 0;
    return $1e79381dc3a64a75$var$applyViewTransitionToHostInstancesRecursive(fiber.child, name, className, collectMeasurements, stopAtNestedViewTransitions);
}
function $1e79381dc3a64a75$var$applyViewTransitionToHostInstancesRecursive(child, name, className, collectMeasurements, stopAtNestedViewTransitions) {
    for(var inViewport = !1; null !== child;){
        if (5 === child.tag) {
            var instance = child.stateNode;
            if (null !== collectMeasurements) {
                var measurement = $1e79381dc3a64a75$var$measureInstance(instance);
                collectMeasurements.push(measurement);
                measurement.view && (inViewport = !0);
            } else inViewport || $1e79381dc3a64a75$var$measureInstance(instance).view && (inViewport = !0);
            $1e79381dc3a64a75$var$shouldStartViewTransition = !0;
            $1e79381dc3a64a75$var$applyViewTransitionName(instance, 0 === $1e79381dc3a64a75$var$viewTransitionHostInstanceIdx ? name : name + "_" + $1e79381dc3a64a75$var$viewTransitionHostInstanceIdx, className);
            $1e79381dc3a64a75$var$viewTransitionHostInstanceIdx++;
        } else if (22 !== child.tag || null === child.memoizedState) 30 === child.tag && stopAtNestedViewTransitions || $1e79381dc3a64a75$var$applyViewTransitionToHostInstancesRecursive(child.child, name, className, collectMeasurements, stopAtNestedViewTransitions) && (inViewport = !0);
        child = child.sibling;
    }
    return inViewport;
}
function $1e79381dc3a64a75$var$restoreViewTransitionOnHostInstances(child, stopAtNestedViewTransitions) {
    for(; null !== child;){
        if (5 === child.tag) $1e79381dc3a64a75$var$restoreViewTransitionName(child.stateNode, child.memoizedProps);
        else if (22 !== child.tag || null === child.memoizedState) 30 === child.tag && stopAtNestedViewTransitions || $1e79381dc3a64a75$var$restoreViewTransitionOnHostInstances(child.child, stopAtNestedViewTransitions);
        child = child.sibling;
    }
}
function $1e79381dc3a64a75$var$commitAppearingPairViewTransitions(placement) {
    if (0 !== (placement.subtreeFlags & 18874368)) for(placement = placement.child; null !== placement;){
        if (22 !== placement.tag || null === placement.memoizedState) {
            if ($1e79381dc3a64a75$var$commitAppearingPairViewTransitions(placement), 30 === placement.tag && 0 !== (placement.flags & 18874368) && placement.stateNode.paired) {
                var props = placement.memoizedProps;
                if (null == props.name || "auto" === props.name) throw Error($1e79381dc3a64a75$var$formatProdErrorMessage(544));
                var name = props.name;
                props = $1e79381dc3a64a75$var$getViewTransitionClassName(props.default, props.share);
                "none" !== props && ($1e79381dc3a64a75$var$applyViewTransitionToHostInstances(placement, name, props, null, !1) || $1e79381dc3a64a75$var$restoreViewTransitionOnHostInstances(placement.child, !1));
            }
        }
        placement = placement.sibling;
    }
}
function $1e79381dc3a64a75$var$commitEnterViewTransitions(placement, gesture) {
    if (30 === placement.tag) {
        var state = placement.stateNode, props = placement.memoizedProps, name = $1e79381dc3a64a75$var$getViewTransitionName(props, state), className = $1e79381dc3a64a75$var$getViewTransitionClassName(props.default, state.paired ? props.share : props.enter);
        "none" !== className ? $1e79381dc3a64a75$var$applyViewTransitionToHostInstances(placement, name, className, null, !1) ? ($1e79381dc3a64a75$var$commitAppearingPairViewTransitions(placement), state.paired || gesture || $1e79381dc3a64a75$var$scheduleViewTransitionEvent(placement, props.onEnter)) : $1e79381dc3a64a75$var$restoreViewTransitionOnHostInstances(placement.child, !1) : $1e79381dc3a64a75$var$commitAppearingPairViewTransitions(placement);
    } else if (0 !== (placement.subtreeFlags & 33554432)) for(placement = placement.child; null !== placement;)$1e79381dc3a64a75$var$commitEnterViewTransitions(placement, gesture), placement = placement.sibling;
    else $1e79381dc3a64a75$var$commitAppearingPairViewTransitions(placement);
}
function $1e79381dc3a64a75$var$commitDeletedPairViewTransitions(deletion) {
    if (null !== $1e79381dc3a64a75$var$appearingViewTransitions && 0 !== $1e79381dc3a64a75$var$appearingViewTransitions.size) {
        var pairs = $1e79381dc3a64a75$var$appearingViewTransitions;
        if (0 !== (deletion.subtreeFlags & 18874368)) for(deletion = deletion.child; null !== deletion;){
            if (22 !== deletion.tag || null === deletion.memoizedState) {
                if (30 === deletion.tag && 0 !== (deletion.flags & 18874368)) {
                    var props = deletion.memoizedProps, name = props.name;
                    if (null != name && "auto" !== name) {
                        var pair = pairs.get(name);
                        if (void 0 !== pair) {
                            var className = $1e79381dc3a64a75$var$getViewTransitionClassName(props.default, props.share);
                            "none" !== className && ($1e79381dc3a64a75$var$applyViewTransitionToHostInstances(deletion, name, className, null, !1) ? (className = deletion.stateNode, pair.paired = className, className.paired = pair, $1e79381dc3a64a75$var$scheduleViewTransitionEvent(deletion, props.onShare)) : $1e79381dc3a64a75$var$restoreViewTransitionOnHostInstances(deletion.child, !1));
                            pairs.delete(name);
                            if (0 === pairs.size) break;
                        }
                    }
                }
                $1e79381dc3a64a75$var$commitDeletedPairViewTransitions(deletion);
            }
            deletion = deletion.sibling;
        }
    }
}
function $1e79381dc3a64a75$var$commitExitViewTransitions(deletion) {
    if (30 === deletion.tag) {
        var props = deletion.memoizedProps, name = $1e79381dc3a64a75$var$getViewTransitionName(props, deletion.stateNode), pair = null !== $1e79381dc3a64a75$var$appearingViewTransitions ? $1e79381dc3a64a75$var$appearingViewTransitions.get(name) : void 0, className = $1e79381dc3a64a75$var$getViewTransitionClassName(props.default, void 0 !== pair ? props.share : props.exit);
        "none" !== className && ($1e79381dc3a64a75$var$applyViewTransitionToHostInstances(deletion, name, className, null, !1) ? void 0 !== pair ? (className = deletion.stateNode, pair.paired = className, className.paired = pair, $1e79381dc3a64a75$var$appearingViewTransitions.delete(name), $1e79381dc3a64a75$var$scheduleViewTransitionEvent(deletion, props.onShare)) : $1e79381dc3a64a75$var$scheduleViewTransitionEvent(deletion, props.onExit) : $1e79381dc3a64a75$var$restoreViewTransitionOnHostInstances(deletion.child, !1));
        null !== $1e79381dc3a64a75$var$appearingViewTransitions && $1e79381dc3a64a75$var$commitDeletedPairViewTransitions(deletion);
    } else if (0 !== (deletion.subtreeFlags & 33554432)) for(deletion = deletion.child; null !== deletion;)$1e79381dc3a64a75$var$commitExitViewTransitions(deletion), deletion = deletion.sibling;
    else null !== $1e79381dc3a64a75$var$appearingViewTransitions && $1e79381dc3a64a75$var$commitDeletedPairViewTransitions(deletion);
}
function $1e79381dc3a64a75$var$commitNestedViewTransitions(changedParent) {
    for(changedParent = changedParent.child; null !== changedParent;){
        if (30 === changedParent.tag) {
            var props = changedParent.memoizedProps, name = $1e79381dc3a64a75$var$getViewTransitionName(props, changedParent.stateNode);
            props = $1e79381dc3a64a75$var$getViewTransitionClassName(props.default, props.update);
            changedParent.flags &= -5;
            "none" !== props && $1e79381dc3a64a75$var$applyViewTransitionToHostInstances(changedParent, name, props, changedParent.memoizedState = [], !1);
        } else 0 !== (changedParent.subtreeFlags & 33554432) && $1e79381dc3a64a75$var$commitNestedViewTransitions(changedParent);
        changedParent = changedParent.sibling;
    }
}
function $1e79381dc3a64a75$var$restorePairedViewTransitions(parent) {
    if (0 !== (parent.subtreeFlags & 18874368)) for(parent = parent.child; null !== parent;){
        if (22 !== parent.tag || null === parent.memoizedState) {
            if (30 === parent.tag && 0 !== (parent.flags & 18874368)) {
                var instance = parent.stateNode;
                null !== instance.paired && (instance.paired = null, $1e79381dc3a64a75$var$restoreViewTransitionOnHostInstances(parent.child, !1));
            }
            $1e79381dc3a64a75$var$restorePairedViewTransitions(parent);
        }
        parent = parent.sibling;
    }
}
function $1e79381dc3a64a75$var$restoreEnterOrExitViewTransitions(fiber) {
    if (30 === fiber.tag) fiber.stateNode.paired = null, $1e79381dc3a64a75$var$restoreViewTransitionOnHostInstances(fiber.child, !1), $1e79381dc3a64a75$var$restorePairedViewTransitions(fiber);
    else if (0 !== (fiber.subtreeFlags & 33554432)) for(fiber = fiber.child; null !== fiber;)$1e79381dc3a64a75$var$restoreEnterOrExitViewTransitions(fiber), fiber = fiber.sibling;
    else $1e79381dc3a64a75$var$restorePairedViewTransitions(fiber);
}
function $1e79381dc3a64a75$var$restoreNestedViewTransitions(changedParent) {
    for(changedParent = changedParent.child; null !== changedParent;)30 === changedParent.tag ? $1e79381dc3a64a75$var$restoreViewTransitionOnHostInstances(changedParent.child, !1) : 0 !== (changedParent.subtreeFlags & 33554432) && $1e79381dc3a64a75$var$restoreNestedViewTransitions(changedParent), changedParent = changedParent.sibling;
}
function $1e79381dc3a64a75$var$measureViewTransitionHostInstancesRecursive(parentViewTransition, child, newName, oldName, className, previousMeasurements, stopAtNestedViewTransitions) {
    for(var inViewport = !1; null !== child;){
        if (5 === child.tag) {
            var instance = child.stateNode;
            if (null !== previousMeasurements && $1e79381dc3a64a75$var$viewTransitionHostInstanceIdx < previousMeasurements.length) {
                var previousMeasurement = previousMeasurements[$1e79381dc3a64a75$var$viewTransitionHostInstanceIdx], nextMeasurement = $1e79381dc3a64a75$var$measureInstance(instance);
                if (previousMeasurement.view || nextMeasurement.view) inViewport = !0;
                var JSCompiler_temp;
                if (JSCompiler_temp = 0 === (parentViewTransition.flags & 4)) {
                    if (nextMeasurement.clip) JSCompiler_temp = !0;
                    else {
                        JSCompiler_temp = previousMeasurement.rect;
                        var newRect = nextMeasurement.rect;
                        JSCompiler_temp = JSCompiler_temp.y !== newRect.y || JSCompiler_temp.x !== newRect.x || JSCompiler_temp.height !== newRect.height || JSCompiler_temp.width !== newRect.width;
                    }
                }
                JSCompiler_temp && (parentViewTransition.flags |= 4);
                nextMeasurement.abs ? nextMeasurement = !previousMeasurement.abs : (previousMeasurement = previousMeasurement.rect, nextMeasurement = nextMeasurement.rect, nextMeasurement = previousMeasurement.height !== nextMeasurement.height || previousMeasurement.width !== nextMeasurement.width);
                nextMeasurement && (parentViewTransition.flags |= 32);
            } else parentViewTransition.flags |= 32;
            0 !== (parentViewTransition.flags & 4) && $1e79381dc3a64a75$var$applyViewTransitionName(instance, 0 === $1e79381dc3a64a75$var$viewTransitionHostInstanceIdx ? newName : newName + "_" + $1e79381dc3a64a75$var$viewTransitionHostInstanceIdx, className);
            inViewport && 0 !== (parentViewTransition.flags & 4) || (null === $1e79381dc3a64a75$var$viewTransitionCancelableChildren && ($1e79381dc3a64a75$var$viewTransitionCancelableChildren = []), $1e79381dc3a64a75$var$viewTransitionCancelableChildren.push(instance, 0 === $1e79381dc3a64a75$var$viewTransitionHostInstanceIdx ? oldName : oldName + "_" + $1e79381dc3a64a75$var$viewTransitionHostInstanceIdx, child.memoizedProps));
            $1e79381dc3a64a75$var$viewTransitionHostInstanceIdx++;
        } else if (22 !== child.tag || null === child.memoizedState) 30 === child.tag && stopAtNestedViewTransitions ? parentViewTransition.flags |= child.flags & 32 : $1e79381dc3a64a75$var$measureViewTransitionHostInstancesRecursive(parentViewTransition, child.child, newName, oldName, className, previousMeasurements, stopAtNestedViewTransitions) && (inViewport = !0);
        child = child.sibling;
    }
    return inViewport;
}
function $1e79381dc3a64a75$var$measureNestedViewTransitions(changedParent, gesture) {
    for(changedParent = changedParent.child; null !== changedParent;){
        if (30 === changedParent.tag) {
            var props = changedParent.memoizedProps, state = changedParent.stateNode, name = $1e79381dc3a64a75$var$getViewTransitionName(props, state), className = $1e79381dc3a64a75$var$getViewTransitionClassName(props.default, props.update);
            if (gesture) {
                state = state.clones;
                var previousMeasurements = null === state ? null : state.map($1e79381dc3a64a75$var$measureClonedInstance);
            } else previousMeasurements = changedParent.memoizedState, changedParent.memoizedState = null;
            state = changedParent;
            var child = changedParent.child;
            $1e79381dc3a64a75$var$viewTransitionHostInstanceIdx = 0;
            name = $1e79381dc3a64a75$var$measureViewTransitionHostInstancesRecursive(state, child, name, name, className, previousMeasurements, !1);
            0 !== (changedParent.flags & 4) && name && (gesture || $1e79381dc3a64a75$var$scheduleViewTransitionEvent(changedParent, props.onUpdate));
        } else 0 !== (changedParent.subtreeFlags & 33554432) && $1e79381dc3a64a75$var$measureNestedViewTransitions(changedParent, gesture);
        changedParent = changedParent.sibling;
    }
}
var $1e79381dc3a64a75$var$offscreenSubtreeIsHidden = !1, $1e79381dc3a64a75$var$offscreenSubtreeWasHidden = !1, $1e79381dc3a64a75$var$offscreenDirectParentIsHidden = !1, $1e79381dc3a64a75$var$needsFormReset = !1, $1e79381dc3a64a75$var$PossiblyWeakSet = "function" === typeof WeakSet ? WeakSet : Set, $1e79381dc3a64a75$var$nextEffect = null, $1e79381dc3a64a75$var$viewTransitionContextChanged = !1, $1e79381dc3a64a75$var$inUpdateViewTransition = !1, $1e79381dc3a64a75$var$rootViewTransitionAffected = !1, $1e79381dc3a64a75$var$rootViewTransitionNameCanceled = !1;
function $1e79381dc3a64a75$var$commitBeforeMutationEffects(root, firstChild, committedLanes) {
    root = root.containerInfo;
    $1e79381dc3a64a75$var$eventsEnabled = $1e79381dc3a64a75$var$_enabled;
    root = $1e79381dc3a64a75$var$getActiveElementDeep(root);
    if ($1e79381dc3a64a75$var$hasSelectionCapabilities(root)) {
        if ("selectionStart" in root) var JSCompiler_temp = {
            start: root.selectionStart,
            end: root.selectionEnd
        };
        else a: {
            JSCompiler_temp = (JSCompiler_temp = root.ownerDocument) && JSCompiler_temp.defaultView || window;
            var selection = JSCompiler_temp.getSelection && JSCompiler_temp.getSelection();
            if (selection && 0 !== selection.rangeCount) {
                JSCompiler_temp = selection.anchorNode;
                var anchorOffset = selection.anchorOffset, focusNode = selection.focusNode;
                selection = selection.focusOffset;
                try {
                    JSCompiler_temp.nodeType, focusNode.nodeType;
                } catch (e$21) {
                    JSCompiler_temp = null;
                    break a;
                }
                var length = 0, start = -1, end = -1, indexWithinAnchor = 0, indexWithinFocus = 0, node = root, parentNode = null;
                b: for(;;){
                    for(var next;;){
                        node !== JSCompiler_temp || 0 !== anchorOffset && 3 !== node.nodeType || (start = length + anchorOffset);
                        node !== focusNode || 0 !== selection && 3 !== node.nodeType || (end = length + selection);
                        3 === node.nodeType && (length += node.nodeValue.length);
                        if (null === (next = node.firstChild)) break;
                        parentNode = node;
                        node = next;
                    }
                    for(;;){
                        if (node === root) break b;
                        parentNode === JSCompiler_temp && ++indexWithinAnchor === anchorOffset && (start = length);
                        parentNode === focusNode && ++indexWithinFocus === selection && (end = length);
                        if (null !== (next = node.nextSibling)) break;
                        node = parentNode;
                        parentNode = node.parentNode;
                    }
                    node = next;
                }
                JSCompiler_temp = -1 === start || -1 === end ? null : {
                    start: start,
                    end: end
                };
            } else JSCompiler_temp = null;
        }
        JSCompiler_temp = JSCompiler_temp || {
            start: 0,
            end: 0
        };
    } else JSCompiler_temp = null;
    $1e79381dc3a64a75$var$selectionInformation = {
        focusedElem: root,
        selectionRange: JSCompiler_temp
    };
    $1e79381dc3a64a75$var$_enabled = !1;
    committedLanes = (committedLanes & 335544064) === committedLanes;
    $1e79381dc3a64a75$var$nextEffect = firstChild;
    for(firstChild = committedLanes ? 9270 : 1024; null !== $1e79381dc3a64a75$var$nextEffect;){
        root = $1e79381dc3a64a75$var$nextEffect;
        if (committedLanes && (JSCompiler_temp = root.deletions, null !== JSCompiler_temp)) for(anchorOffset = 0; anchorOffset < JSCompiler_temp.length; anchorOffset++)committedLanes && $1e79381dc3a64a75$var$commitExitViewTransitions(JSCompiler_temp[anchorOffset]);
        if (null === root.alternate && 0 !== (root.flags & 2)) committedLanes && $1e79381dc3a64a75$var$trackEnterViewTransitions(root), $1e79381dc3a64a75$var$commitBeforeMutationEffects_complete(committedLanes);
        else {
            if (22 === root.tag) {
                if (JSCompiler_temp = root.alternate, null !== root.memoizedState) {
                    null !== JSCompiler_temp && null === JSCompiler_temp.memoizedState && committedLanes && $1e79381dc3a64a75$var$commitExitViewTransitions(JSCompiler_temp);
                    $1e79381dc3a64a75$var$commitBeforeMutationEffects_complete(committedLanes);
                    continue;
                } else if (null !== JSCompiler_temp && null !== JSCompiler_temp.memoizedState) {
                    committedLanes && $1e79381dc3a64a75$var$trackEnterViewTransitions(root);
                    $1e79381dc3a64a75$var$commitBeforeMutationEffects_complete(committedLanes);
                    continue;
                }
            }
            JSCompiler_temp = root.child;
            0 !== (root.subtreeFlags & firstChild) && null !== JSCompiler_temp ? (JSCompiler_temp.return = root, $1e79381dc3a64a75$var$nextEffect = JSCompiler_temp) : (committedLanes && $1e79381dc3a64a75$var$commitNestedViewTransitions(root), $1e79381dc3a64a75$var$commitBeforeMutationEffects_complete(committedLanes));
        }
    }
    $1e79381dc3a64a75$var$appearingViewTransitions = null;
}
function $1e79381dc3a64a75$var$commitBeforeMutationEffects_complete(isViewTransitionEligible$jscomp$0) {
    for(; null !== $1e79381dc3a64a75$var$nextEffect;){
        var fiber = $1e79381dc3a64a75$var$nextEffect, isViewTransitionEligible = isViewTransitionEligible$jscomp$0, current = fiber.alternate, flags = fiber.flags;
        switch(fiber.tag){
            case 0:
            case 11:
            case 15:
                break;
            case 1:
                if (0 !== (flags & 1024) && null !== current) {
                    isViewTransitionEligible = void 0;
                    flags = current.memoizedProps;
                    current = current.memoizedState;
                    var instance = fiber.stateNode;
                    try {
                        var resolvedPrevProps = $1e79381dc3a64a75$var$resolveClassComponentProps(fiber.type, flags);
                        isViewTransitionEligible = instance.getSnapshotBeforeUpdate(resolvedPrevProps, current);
                        instance.__reactInternalSnapshotBeforeUpdate = isViewTransitionEligible;
                    } catch (error) {
                        $1e79381dc3a64a75$var$captureCommitPhaseError(fiber, fiber.return, error);
                    }
                }
                break;
            case 3:
                if (0 !== (flags & 1024)) {
                    if (current = fiber.stateNode.containerInfo, isViewTransitionEligible = current.nodeType, 9 === isViewTransitionEligible) $1e79381dc3a64a75$var$clearContainerSparingly(current);
                    else if (1 === isViewTransitionEligible) switch(current.nodeName){
                        case "HEAD":
                        case "HTML":
                        case "BODY":
                            $1e79381dc3a64a75$var$clearContainerSparingly(current);
                            break;
                        default:
                            current.textContent = "";
                    }
                }
                break;
            case 5:
            case 26:
            case 27:
            case 6:
            case 4:
            case 17:
                break;
            case 30:
                isViewTransitionEligible && null !== current && (isViewTransitionEligible = $1e79381dc3a64a75$var$getViewTransitionName(current.memoizedProps, current.stateNode), flags = fiber.memoizedProps, flags = $1e79381dc3a64a75$var$getViewTransitionClassName(flags.default, flags.update), "none" !== flags && $1e79381dc3a64a75$var$applyViewTransitionToHostInstances(current, isViewTransitionEligible, flags, current.memoizedState = [], !0));
                break;
            default:
                if (0 !== (flags & 1024)) throw Error($1e79381dc3a64a75$var$formatProdErrorMessage(163));
        }
        current = fiber.sibling;
        if (null !== current) {
            current.return = fiber.return;
            $1e79381dc3a64a75$var$nextEffect = current;
            break;
        }
        $1e79381dc3a64a75$var$nextEffect = fiber.return;
    }
}
function $1e79381dc3a64a75$var$commitLayoutEffectOnFiber(finishedRoot, current, finishedWork) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $1e79381dc3a64a75$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $1e79381dc3a64a75$var$commitHookEffectListMount(5, finishedWork);
            break;
        case 1:
            $1e79381dc3a64a75$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 4) {
                if (finishedRoot = finishedWork.stateNode, null === current) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $1e79381dc3a64a75$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
                else {
                    var prevProps = $1e79381dc3a64a75$var$resolveClassComponentProps(finishedWork.type, current.memoizedProps);
                    current = current.memoizedState;
                    try {
                        finishedRoot.componentDidUpdate(prevProps, current, finishedRoot.__reactInternalSnapshotBeforeUpdate);
                    } catch (error$146) {
                        $1e79381dc3a64a75$var$captureCommitPhaseError(finishedWork, finishedWork.return, error$146);
                    }
                }
            }
            flags & 64 && $1e79381dc3a64a75$var$commitClassCallbacks(finishedWork);
            flags & 512 && $1e79381dc3a64a75$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 3:
            $1e79381dc3a64a75$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 64 && (finishedRoot = finishedWork.updateQueue, null !== finishedRoot)) {
                current = null;
                if (null !== finishedWork.child) switch(finishedWork.child.tag){
                    case 27:
                    case 5:
                        current = finishedWork.child.stateNode;
                        break;
                    case 1:
                        current = finishedWork.child.stateNode;
                }
                try {
                    $1e79381dc3a64a75$var$commitCallbacks(finishedRoot, current);
                } catch (error) {
                    $1e79381dc3a64a75$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 27:
            null === current && flags & 4 && $1e79381dc3a64a75$var$commitHostSingletonAcquisition(finishedWork);
        case 26:
        case 5:
            $1e79381dc3a64a75$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            null === current && flags & 4 && $1e79381dc3a64a75$var$commitHostMount(finishedWork);
            flags & 512 && $1e79381dc3a64a75$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 12:
            $1e79381dc3a64a75$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            break;
        case 31:
            $1e79381dc3a64a75$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $1e79381dc3a64a75$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork);
            break;
        case 13:
            $1e79381dc3a64a75$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $1e79381dc3a64a75$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
            flags & 64 && (finishedRoot = finishedWork.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot && (finishedWork = $1e79381dc3a64a75$var$retryDehydratedSuspenseBoundary.bind(null, finishedWork), $1e79381dc3a64a75$var$registerSuspenseInstanceRetry(finishedRoot, finishedWork))));
            break;
        case 22:
            flags = null !== finishedWork.memoizedState || $1e79381dc3a64a75$var$offscreenSubtreeIsHidden;
            if (!flags) {
                var newOffscreenSubtreeWasHidden = null !== current && null !== current.memoizedState || $1e79381dc3a64a75$var$offscreenSubtreeWasHidden;
                current = $1e79381dc3a64a75$var$offscreenSubtreeIsHidden;
                prevProps = $1e79381dc3a64a75$var$offscreenSubtreeWasHidden;
                $1e79381dc3a64a75$var$offscreenSubtreeIsHidden = flags;
                ($1e79381dc3a64a75$var$offscreenSubtreeWasHidden = newOffscreenSubtreeWasHidden) && !prevProps ? (flags = 2, 0 !== (finishedWork.subtreeFlags & 8772) && (flags |= 1), $1e79381dc3a64a75$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, flags)) : $1e79381dc3a64a75$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                $1e79381dc3a64a75$var$offscreenSubtreeIsHidden = current;
                $1e79381dc3a64a75$var$offscreenSubtreeWasHidden = prevProps;
            }
            break;
        case 30:
            $1e79381dc3a64a75$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 512 && $1e79381dc3a64a75$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 7:
            flags & 512 && $1e79381dc3a64a75$var$safelyAttachRef(finishedWork, finishedWork.return);
        default:
            $1e79381dc3a64a75$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
    }
}
function $1e79381dc3a64a75$var$hideOrUnhideAllChildren(parentFiber, isHidden) {
    for(parentFiber = parentFiber.child; null !== parentFiber;)$1e79381dc3a64a75$var$hideOrUnhideAllChildrenOnFiber(parentFiber, isHidden), parentFiber = parentFiber.sibling;
}
function $1e79381dc3a64a75$var$hideOrUnhideAllChildrenOnFiber(fiber, isHidden) {
    switch(fiber.tag){
        case 5:
        case 26:
            try {
                var instance = fiber.stateNode;
                if (isHidden) {
                    var style = instance.style;
                    "function" === typeof style.setProperty ? style.setProperty("display", "none", "important") : style.display = "none";
                } else {
                    var instance$jscomp$0 = fiber.stateNode, styleProp = fiber.memoizedProps.style, display = void 0 !== styleProp && null !== styleProp && styleProp.hasOwnProperty("display") ? styleProp.display : null;
                    instance$jscomp$0.style.display = null == display || "boolean" === typeof display ? "" : ("" + display).trim();
                }
            } catch (error) {
                $1e79381dc3a64a75$var$captureCommitPhaseError(fiber, fiber.return, error);
            }
            $1e79381dc3a64a75$var$hideOrUnhideNearestPortals(fiber, isHidden);
            break;
        case 6:
            try {
                fiber.stateNode.nodeValue = isHidden ? "" : fiber.memoizedProps, $1e79381dc3a64a75$var$viewTransitionMutationContext = !0;
            } catch (error) {
                $1e79381dc3a64a75$var$captureCommitPhaseError(fiber, fiber.return, error);
            }
            break;
        case 18:
            try {
                var instance$jscomp$1 = fiber.stateNode;
                isHidden ? $1e79381dc3a64a75$var$hideOrUnhideDehydratedBoundary(instance$jscomp$1, !0) : $1e79381dc3a64a75$var$hideOrUnhideDehydratedBoundary(fiber.stateNode, !1);
            } catch (error) {
                $1e79381dc3a64a75$var$captureCommitPhaseError(fiber, fiber.return, error);
            }
            break;
        case 22:
        case 23:
            null === fiber.memoizedState && $1e79381dc3a64a75$var$hideOrUnhideAllChildren(fiber, isHidden);
            break;
        default:
            $1e79381dc3a64a75$var$hideOrUnhideAllChildren(fiber, isHidden);
    }
}
function $1e79381dc3a64a75$var$hideOrUnhideNearestPortals(parentFiber, isHidden$jscomp$0) {
    if (parentFiber.subtreeFlags & 67108864) for(parentFiber = parentFiber.child; null !== parentFiber;){
        a: {
            var fiber = parentFiber, isHidden = isHidden$jscomp$0;
            switch(fiber.tag){
                case 4:
                    $1e79381dc3a64a75$var$hideOrUnhideAllChildrenOnFiber(fiber, isHidden);
                    break a;
                case 22:
                    null === fiber.memoizedState && $1e79381dc3a64a75$var$hideOrUnhideNearestPortals(fiber, isHidden);
                    break a;
                default:
                    $1e79381dc3a64a75$var$hideOrUnhideNearestPortals(fiber, isHidden);
            }
        }
        parentFiber = parentFiber.sibling;
    }
}
function $1e79381dc3a64a75$var$detachFiberAfterEffects(fiber) {
    var alternate = fiber.alternate;
    null !== alternate && (fiber.alternate = null, $1e79381dc3a64a75$var$detachFiberAfterEffects(alternate));
    fiber.child = null;
    fiber.deletions = null;
    fiber.sibling = null;
    5 === fiber.tag && (alternate = fiber.stateNode, null !== alternate && $1e79381dc3a64a75$var$detachDeletedInstance(alternate));
    fiber.stateNode = null;
    fiber.return = null;
    fiber.dependencies = null;
    fiber.memoizedProps = null;
    fiber.memoizedState = null;
    fiber.pendingProps = null;
    fiber.stateNode = null;
    fiber.updateQueue = null;
}
var $1e79381dc3a64a75$var$hostParent = null, $1e79381dc3a64a75$var$hostParentIsContainer = !1;
function $1e79381dc3a64a75$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, parent) {
    for(parent = parent.child; null !== parent;)$1e79381dc3a64a75$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, parent), parent = parent.sibling;
}
function $1e79381dc3a64a75$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, deletedFiber) {
    if ($1e79381dc3a64a75$var$injectedHook && "function" === typeof $1e79381dc3a64a75$var$injectedHook.onCommitFiberUnmount) try {
        $1e79381dc3a64a75$var$injectedHook.onCommitFiberUnmount($1e79381dc3a64a75$var$rendererID, deletedFiber);
    } catch (err) {}
    switch(deletedFiber.tag){
        case 26:
            $1e79381dc3a64a75$var$offscreenSubtreeWasHidden || $1e79381dc3a64a75$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $1e79381dc3a64a75$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            deletedFiber.memoizedState ? deletedFiber.memoizedState.count-- : deletedFiber.stateNode && !$1e79381dc3a64a75$var$offscreenSubtreeWasHidden && (deletedFiber = deletedFiber.stateNode, deletedFiber.parentNode.removeChild(deletedFiber));
            break;
        case 27:
            $1e79381dc3a64a75$var$offscreenSubtreeWasHidden || $1e79381dc3a64a75$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $1e79381dc3a64a75$var$commitFragmentInstanceDeletionEffects(deletedFiber);
            var prevHostParent = $1e79381dc3a64a75$var$hostParent, prevHostParentIsContainer = $1e79381dc3a64a75$var$hostParentIsContainer;
            $1e79381dc3a64a75$var$isSingletonScope(deletedFiber.type) && ($1e79381dc3a64a75$var$hostParent = deletedFiber.stateNode, $1e79381dc3a64a75$var$hostParentIsContainer = !1);
            $1e79381dc3a64a75$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $1e79381dc3a64a75$var$releaseSingletonInstance(deletedFiber.stateNode, deletedFiber.type, deletedFiber.memoizedProps);
            $1e79381dc3a64a75$var$hostParent = prevHostParent;
            $1e79381dc3a64a75$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 5:
            $1e79381dc3a64a75$var$offscreenSubtreeWasHidden || $1e79381dc3a64a75$var$safelyDetachRef(deletedFiber, nearestMountedAncestor), $1e79381dc3a64a75$var$commitFragmentInstanceDeletionEffects(deletedFiber);
        case 6:
            6 === deletedFiber.tag && $1e79381dc3a64a75$var$commitFragmentInstanceDeletionEffects(deletedFiber);
            prevHostParent = $1e79381dc3a64a75$var$hostParent;
            prevHostParentIsContainer = $1e79381dc3a64a75$var$hostParentIsContainer;
            $1e79381dc3a64a75$var$hostParent = null;
            $1e79381dc3a64a75$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $1e79381dc3a64a75$var$hostParent = prevHostParent;
            $1e79381dc3a64a75$var$hostParentIsContainer = prevHostParentIsContainer;
            if (null !== $1e79381dc3a64a75$var$hostParent) {
                if ($1e79381dc3a64a75$var$hostParentIsContainer) try {
                    (9 === $1e79381dc3a64a75$var$hostParent.nodeType ? $1e79381dc3a64a75$var$hostParent.body : "HTML" === $1e79381dc3a64a75$var$hostParent.nodeName ? $1e79381dc3a64a75$var$hostParent.ownerDocument.body : $1e79381dc3a64a75$var$hostParent).removeChild(deletedFiber.stateNode), $1e79381dc3a64a75$var$viewTransitionMutationContext = !0;
                } catch (error) {
                    $1e79381dc3a64a75$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
                else try {
                    $1e79381dc3a64a75$var$hostParent.removeChild(deletedFiber.stateNode), $1e79381dc3a64a75$var$viewTransitionMutationContext = !0;
                } catch (error) {
                    $1e79381dc3a64a75$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
            }
            break;
        case 18:
            null !== $1e79381dc3a64a75$var$hostParent && ($1e79381dc3a64a75$var$hostParentIsContainer ? (finishedRoot = $1e79381dc3a64a75$var$hostParent, $1e79381dc3a64a75$var$clearHydrationBoundary(9 === finishedRoot.nodeType ? finishedRoot.body : "HTML" === finishedRoot.nodeName ? finishedRoot.ownerDocument.body : finishedRoot, deletedFiber.stateNode), $1e79381dc3a64a75$var$retryIfBlockedOn(finishedRoot)) : $1e79381dc3a64a75$var$clearHydrationBoundary($1e79381dc3a64a75$var$hostParent, deletedFiber.stateNode));
            break;
        case 4:
            prevHostParent = $1e79381dc3a64a75$var$hostParent;
            prevHostParentIsContainer = $1e79381dc3a64a75$var$hostParentIsContainer;
            $1e79381dc3a64a75$var$hostParent = deletedFiber.stateNode.containerInfo;
            $1e79381dc3a64a75$var$hostParentIsContainer = !0;
            $1e79381dc3a64a75$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $1e79381dc3a64a75$var$hostParent = prevHostParent;
            $1e79381dc3a64a75$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            $1e79381dc3a64a75$var$commitHookEffectListUnmount(2, deletedFiber, nearestMountedAncestor);
            $1e79381dc3a64a75$var$offscreenSubtreeWasHidden || $1e79381dc3a64a75$var$commitHookEffectListUnmount(4, deletedFiber, nearestMountedAncestor);
            $1e79381dc3a64a75$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 1:
            $1e79381dc3a64a75$var$offscreenSubtreeWasHidden || ($1e79381dc3a64a75$var$safelyDetachRef(deletedFiber, nearestMountedAncestor), prevHostParent = deletedFiber.stateNode, "function" === typeof prevHostParent.componentWillUnmount && $1e79381dc3a64a75$var$safelyCallComponentWillUnmount(deletedFiber, nearestMountedAncestor, prevHostParent));
            $1e79381dc3a64a75$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 21:
            $1e79381dc3a64a75$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 22:
            $1e79381dc3a64a75$var$offscreenSubtreeWasHidden = (prevHostParent = $1e79381dc3a64a75$var$offscreenSubtreeWasHidden) || null !== deletedFiber.memoizedState;
            $1e79381dc3a64a75$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $1e79381dc3a64a75$var$offscreenSubtreeWasHidden = prevHostParent;
            break;
        case 30:
            $1e79381dc3a64a75$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $1e79381dc3a64a75$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 7:
            $1e79381dc3a64a75$var$offscreenSubtreeWasHidden || $1e79381dc3a64a75$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $1e79381dc3a64a75$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        default:
            $1e79381dc3a64a75$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
    }
}
function $1e79381dc3a64a75$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot))) {
        finishedRoot = finishedRoot.dehydrated;
        try {
            $1e79381dc3a64a75$var$retryIfBlockedOn(finishedRoot);
        } catch (error) {
            $1e79381dc3a64a75$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $1e79381dc3a64a75$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot)))) try {
        $1e79381dc3a64a75$var$retryIfBlockedOn(finishedRoot);
    } catch (error) {
        $1e79381dc3a64a75$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $1e79381dc3a64a75$var$getRetryCache(finishedWork) {
    switch(finishedWork.tag){
        case 31:
        case 13:
        case 19:
            var retryCache = finishedWork.stateNode;
            null === retryCache && (retryCache = finishedWork.stateNode = new $1e79381dc3a64a75$var$PossiblyWeakSet());
            return retryCache;
        case 22:
            return finishedWork = finishedWork.stateNode, retryCache = finishedWork._retryCache, null === retryCache && (retryCache = finishedWork._retryCache = new $1e79381dc3a64a75$var$PossiblyWeakSet()), retryCache;
        default:
            throw Error($1e79381dc3a64a75$var$formatProdErrorMessage(435, finishedWork.tag));
    }
}
function $1e79381dc3a64a75$var$attachSuspenseRetryListeners(finishedWork, wakeables) {
    var retryCache = $1e79381dc3a64a75$var$getRetryCache(finishedWork);
    wakeables.forEach(function(wakeable) {
        if (!retryCache.has(wakeable)) {
            retryCache.add(wakeable);
            var retry = $1e79381dc3a64a75$var$resolveRetryWakeable.bind(null, finishedWork, wakeable);
            wakeable.then(retry, retry);
        }
    });
}
function $1e79381dc3a64a75$var$recursivelyTraverseMutationEffects(root$jscomp$0, parentFiber, lanes) {
    var deletions = parentFiber.deletions;
    if (null !== deletions) for(var i = 0; i < deletions.length; i++){
        var childToDelete = deletions[i], root = root$jscomp$0, returnFiber = parentFiber, parent = returnFiber;
        a: for(; null !== parent;){
            switch(parent.tag){
                case 27:
                    if ($1e79381dc3a64a75$var$isSingletonScope(parent.type)) {
                        $1e79381dc3a64a75$var$hostParent = parent.stateNode;
                        $1e79381dc3a64a75$var$hostParentIsContainer = !1;
                        break a;
                    }
                    break;
                case 5:
                    $1e79381dc3a64a75$var$hostParent = parent.stateNode;
                    $1e79381dc3a64a75$var$hostParentIsContainer = !1;
                    break a;
                case 3:
                case 4:
                    $1e79381dc3a64a75$var$hostParent = parent.stateNode.containerInfo;
                    $1e79381dc3a64a75$var$hostParentIsContainer = !0;
                    break a;
            }
            parent = parent.return;
        }
        if (null === $1e79381dc3a64a75$var$hostParent) throw Error($1e79381dc3a64a75$var$formatProdErrorMessage(160));
        $1e79381dc3a64a75$var$commitDeletionEffectsOnFiber(root, returnFiber, childToDelete);
        $1e79381dc3a64a75$var$hostParent = null;
        $1e79381dc3a64a75$var$hostParentIsContainer = !1;
        root = childToDelete.alternate;
        null !== root && (root.return = null);
        childToDelete.return = null;
    }
    if (parentFiber.subtreeFlags & 13886) for(parentFiber = parentFiber.child; null !== parentFiber;)$1e79381dc3a64a75$var$commitMutationEffectsOnFiber(parentFiber, root$jscomp$0, lanes), parentFiber = parentFiber.sibling;
}
var $1e79381dc3a64a75$var$currentHoistableRoot = null;
function $1e79381dc3a64a75$var$commitMutationEffectsOnFiber(finishedWork, root, lanes) {
    var current = finishedWork.alternate, flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            if (flags & 4 && (current = finishedWork.updateQueue, current = null !== current ? current.events : null, null !== current)) for(var ii = 0; ii < current.length; ii++){
                var _eventPayloads$ii2 = current[ii];
                _eventPayloads$ii2.ref.impl = _eventPayloads$ii2.nextImpl;
            }
            $1e79381dc3a64a75$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $1e79381dc3a64a75$var$commitReconciliationEffects(finishedWork);
            flags & 4 && ($1e79381dc3a64a75$var$commitHookEffectListUnmount(3, finishedWork, finishedWork.return), $1e79381dc3a64a75$var$commitHookEffectListMount(3, finishedWork), $1e79381dc3a64a75$var$commitHookEffectListUnmount(5, finishedWork, finishedWork.return));
            break;
        case 1:
            $1e79381dc3a64a75$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $1e79381dc3a64a75$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($1e79381dc3a64a75$var$offscreenSubtreeWasHidden || null === current || $1e79381dc3a64a75$var$safelyDetachRef(current, current.return));
            flags & 64 && $1e79381dc3a64a75$var$offscreenSubtreeIsHidden && (finishedWork = finishedWork.updateQueue, null !== finishedWork && (root = finishedWork.callbacks, null !== root && (lanes = finishedWork.shared.hiddenCallbacks, finishedWork.shared.hiddenCallbacks = null === lanes ? root : lanes.concat(root))));
            break;
        case 26:
            ii = $1e79381dc3a64a75$var$currentHoistableRoot;
            $1e79381dc3a64a75$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $1e79381dc3a64a75$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($1e79381dc3a64a75$var$offscreenSubtreeWasHidden || null === current || $1e79381dc3a64a75$var$safelyDetachRef(current, current.return));
            if (flags & 4) {
                if (flags = null !== current ? current.memoizedState : null, lanes = finishedWork.memoizedState, null === current) {
                    if (null === lanes) {
                        if (null === finishedWork.stateNode) {
                            if ($1e79381dc3a64a75$var$offscreenSubtreeIsHidden) finishedWork.stateNode = $1e79381dc3a64a75$var$createHoistableInstance(finishedWork.type, finishedWork.memoizedProps, root.containerInfo, finishedWork);
                            else {
                                a: {
                                    root = finishedWork.type;
                                    lanes = finishedWork.memoizedProps;
                                    flags = ii.ownerDocument || ii;
                                    b: switch(root){
                                        case "title":
                                            current = flags.getElementsByTagName("title")[0];
                                            if (!current || current[$1e79381dc3a64a75$var$internalHoistableMarker] || current[$1e79381dc3a64a75$var$internalInstanceKey] || "http://www.w3.org/2000/svg" === current.namespaceURI || current.hasAttribute("itemprop")) current = flags.createElement(root), flags.head.insertBefore(current, flags.querySelector("head > title"));
                                            $1e79381dc3a64a75$var$setInitialProperties(current, root, lanes);
                                            current[$1e79381dc3a64a75$var$internalInstanceKey] = finishedWork;
                                            $1e79381dc3a64a75$var$markNodeAsHoistable(current);
                                            root = current;
                                            break a;
                                        case "link":
                                            if (ii = $1e79381dc3a64a75$var$getHydratableHoistableCache("link", "href", flags).get(root + (lanes.href || ""))) {
                                                for(_eventPayloads$ii2 = 0; _eventPayloads$ii2 < ii.length; _eventPayloads$ii2++)if (current = ii[_eventPayloads$ii2], current.getAttribute("href") === (null == lanes.href || "" === lanes.href ? null : lanes.href) && current.getAttribute("rel") === (null == lanes.rel ? null : lanes.rel) && current.getAttribute("title") === (null == lanes.title ? null : lanes.title) && current.getAttribute("crossorigin") === (null == lanes.crossOrigin ? null : lanes.crossOrigin)) {
                                                    ii.splice(_eventPayloads$ii2, 1);
                                                    break b;
                                                }
                                            }
                                            current = flags.createElement(root);
                                            $1e79381dc3a64a75$var$setInitialProperties(current, root, lanes);
                                            flags.head.appendChild(current);
                                            break;
                                        case "meta":
                                            if (ii = $1e79381dc3a64a75$var$getHydratableHoistableCache("meta", "content", flags).get(root + (lanes.content || ""))) {
                                                for(_eventPayloads$ii2 = 0; _eventPayloads$ii2 < ii.length; _eventPayloads$ii2++)if (current = ii[_eventPayloads$ii2], current.getAttribute("content") === (null == lanes.content ? null : "" + lanes.content) && current.getAttribute("name") === (null == lanes.name ? null : lanes.name) && current.getAttribute("property") === (null == lanes.property ? null : lanes.property) && current.getAttribute("http-equiv") === (null == lanes.httpEquiv ? null : lanes.httpEquiv) && current.getAttribute("charset") === (null == lanes.charSet ? null : lanes.charSet)) {
                                                    ii.splice(_eventPayloads$ii2, 1);
                                                    break b;
                                                }
                                            }
                                            current = flags.createElement(root);
                                            $1e79381dc3a64a75$var$setInitialProperties(current, root, lanes);
                                            flags.head.appendChild(current);
                                            break;
                                        default:
                                            throw Error($1e79381dc3a64a75$var$formatProdErrorMessage(468, root));
                                    }
                                    current[$1e79381dc3a64a75$var$internalInstanceKey] = finishedWork;
                                    $1e79381dc3a64a75$var$markNodeAsHoistable(current);
                                    root = current;
                                }
                                finishedWork.stateNode = root;
                            }
                        } else $1e79381dc3a64a75$var$offscreenSubtreeIsHidden || $1e79381dc3a64a75$var$mountHoistable(ii, finishedWork.type, finishedWork.stateNode);
                    } else finishedWork.stateNode = $1e79381dc3a64a75$var$acquireResource(ii, lanes, finishedWork.memoizedProps);
                } else flags !== lanes ? (null === flags ? (root = current.stateNode, null === root || $1e79381dc3a64a75$var$offscreenSubtreeWasHidden || root.parentNode.removeChild(root)) : flags.count--, null === lanes ? $1e79381dc3a64a75$var$offscreenSubtreeIsHidden || $1e79381dc3a64a75$var$mountHoistable(ii, finishedWork.type, finishedWork.stateNode) : $1e79381dc3a64a75$var$acquireResource(ii, lanes, finishedWork.memoizedProps)) : null === lanes && null !== finishedWork.stateNode && $1e79381dc3a64a75$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            }
            break;
        case 27:
            $1e79381dc3a64a75$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $1e79381dc3a64a75$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($1e79381dc3a64a75$var$offscreenSubtreeWasHidden || null === current || $1e79381dc3a64a75$var$safelyDetachRef(current, current.return));
            null !== current && flags & 4 && $1e79381dc3a64a75$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            break;
        case 5:
            ii = $1e79381dc3a64a75$var$offscreenDirectParentIsHidden;
            $1e79381dc3a64a75$var$offscreenDirectParentIsHidden = !1;
            $1e79381dc3a64a75$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $1e79381dc3a64a75$var$offscreenDirectParentIsHidden = ii;
            $1e79381dc3a64a75$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($1e79381dc3a64a75$var$offscreenSubtreeWasHidden || null === current || $1e79381dc3a64a75$var$safelyDetachRef(current, current.return));
            if (finishedWork.flags & 32) {
                root = finishedWork.stateNode;
                try {
                    $1e79381dc3a64a75$var$setTextContent(root, ""), $1e79381dc3a64a75$var$viewTransitionMutationContext = !0;
                } catch (error) {
                    $1e79381dc3a64a75$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            flags & 4 && null != finishedWork.stateNode && (root = finishedWork.memoizedProps, $1e79381dc3a64a75$var$commitHostUpdate(finishedWork, root, null !== current ? current.memoizedProps : root));
            flags & 1024 && ($1e79381dc3a64a75$var$needsFormReset = !0);
            break;
        case 6:
            $1e79381dc3a64a75$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $1e79381dc3a64a75$var$commitReconciliationEffects(finishedWork);
            if (flags & 4) {
                if (null === finishedWork.stateNode) throw Error($1e79381dc3a64a75$var$formatProdErrorMessage(162));
                root = finishedWork.memoizedProps;
                lanes = finishedWork.stateNode;
                try {
                    lanes.nodeValue = root, $1e79381dc3a64a75$var$viewTransitionMutationContext = !0;
                } catch (error) {
                    $1e79381dc3a64a75$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 3:
            $1e79381dc3a64a75$var$viewTransitionMutationContext = !1;
            $1e79381dc3a64a75$var$tagCaches = null;
            ii = $1e79381dc3a64a75$var$currentHoistableRoot;
            $1e79381dc3a64a75$var$currentHoistableRoot = $1e79381dc3a64a75$var$getHoistableRoot(root.containerInfo);
            $1e79381dc3a64a75$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $1e79381dc3a64a75$var$currentHoistableRoot = ii;
            $1e79381dc3a64a75$var$commitReconciliationEffects(finishedWork);
            if (flags & 4 && null !== current && current.memoizedState.isDehydrated) try {
                $1e79381dc3a64a75$var$retryIfBlockedOn(root.containerInfo);
            } catch (error) {
                $1e79381dc3a64a75$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
            }
            $1e79381dc3a64a75$var$needsFormReset && ($1e79381dc3a64a75$var$needsFormReset = !1, $1e79381dc3a64a75$var$recursivelyResetForms(finishedWork));
            $1e79381dc3a64a75$var$viewTransitionMutationContext = !1;
            break;
        case 4:
            flags = $1e79381dc3a64a75$var$offscreenDirectParentIsHidden;
            $1e79381dc3a64a75$var$offscreenDirectParentIsHidden = $1e79381dc3a64a75$var$offscreenSubtreeIsHidden;
            current = $1e79381dc3a64a75$var$pushMutationContext();
            ii = $1e79381dc3a64a75$var$currentHoistableRoot;
            $1e79381dc3a64a75$var$currentHoistableRoot = $1e79381dc3a64a75$var$getHoistableRoot(finishedWork.stateNode.containerInfo);
            $1e79381dc3a64a75$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $1e79381dc3a64a75$var$commitReconciliationEffects(finishedWork);
            $1e79381dc3a64a75$var$currentHoistableRoot = ii;
            $1e79381dc3a64a75$var$viewTransitionMutationContext && $1e79381dc3a64a75$var$inUpdateViewTransition && ($1e79381dc3a64a75$var$rootViewTransitionAffected = !0);
            $1e79381dc3a64a75$var$viewTransitionMutationContext = current;
            $1e79381dc3a64a75$var$offscreenDirectParentIsHidden = flags;
            break;
        case 12:
            $1e79381dc3a64a75$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $1e79381dc3a64a75$var$commitReconciliationEffects(finishedWork);
            break;
        case 31:
            $1e79381dc3a64a75$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $1e79381dc3a64a75$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (root = finishedWork.updateQueue, null !== root && (finishedWork.updateQueue = null, $1e79381dc3a64a75$var$attachSuspenseRetryListeners(finishedWork, root)));
            break;
        case 13:
            $1e79381dc3a64a75$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $1e79381dc3a64a75$var$commitReconciliationEffects(finishedWork);
            finishedWork.child.flags & 8192 && null !== finishedWork.memoizedState !== (null !== current && null !== current.memoizedState) && ($1e79381dc3a64a75$var$globalMostRecentFallbackTime = $1e79381dc3a64a75$var$now());
            flags & 4 && (root = finishedWork.updateQueue, null !== root && (finishedWork.updateQueue = null, $1e79381dc3a64a75$var$attachSuspenseRetryListeners(finishedWork, root)));
            break;
        case 22:
            ii = null !== finishedWork.memoizedState;
            _eventPayloads$ii2 = null !== current && null !== current.memoizedState;
            var prevOffscreenSubtreeIsHidden = $1e79381dc3a64a75$var$offscreenSubtreeIsHidden, prevOffscreenSubtreeWasHidden = $1e79381dc3a64a75$var$offscreenSubtreeWasHidden, prevOffscreenDirectParentIsHidden$166 = $1e79381dc3a64a75$var$offscreenDirectParentIsHidden;
            $1e79381dc3a64a75$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden || ii;
            $1e79381dc3a64a75$var$offscreenDirectParentIsHidden = prevOffscreenDirectParentIsHidden$166 || ii;
            $1e79381dc3a64a75$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden || _eventPayloads$ii2;
            $1e79381dc3a64a75$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $1e79381dc3a64a75$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            $1e79381dc3a64a75$var$offscreenDirectParentIsHidden = prevOffscreenDirectParentIsHidden$166;
            $1e79381dc3a64a75$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden;
            $1e79381dc3a64a75$var$commitReconciliationEffects(finishedWork);
            flags & 8192 && (root = finishedWork.stateNode, root._visibility = ii ? root._visibility & -2 : root._visibility | 1, !ii || null === current || _eventPayloads$ii2 || $1e79381dc3a64a75$var$offscreenSubtreeIsHidden || $1e79381dc3a64a75$var$offscreenSubtreeWasHidden || (root = _eventPayloads$ii2 || $1e79381dc3a64a75$var$offscreenSubtreeWasHidden, lanes = $1e79381dc3a64a75$var$offscreenSubtreeIsHidden, current = $1e79381dc3a64a75$var$offscreenSubtreeWasHidden, $1e79381dc3a64a75$var$offscreenSubtreeIsHidden = ii || $1e79381dc3a64a75$var$offscreenSubtreeIsHidden, $1e79381dc3a64a75$var$offscreenSubtreeWasHidden = root, $1e79381dc3a64a75$var$recursivelyTraverseDisappearLayoutEffects(finishedWork, 2), $1e79381dc3a64a75$var$offscreenSubtreeIsHidden = lanes, $1e79381dc3a64a75$var$offscreenSubtreeWasHidden = current), !ii && $1e79381dc3a64a75$var$offscreenDirectParentIsHidden || $1e79381dc3a64a75$var$hideOrUnhideAllChildren(finishedWork, ii));
            flags & 4 && (root = finishedWork.updateQueue, null !== root && (lanes = root.retryQueue, null !== lanes && (root.retryQueue = null, $1e79381dc3a64a75$var$attachSuspenseRetryListeners(finishedWork, lanes))));
            break;
        case 19:
            $1e79381dc3a64a75$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $1e79381dc3a64a75$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (root = finishedWork.updateQueue, null !== root && (finishedWork.updateQueue = null, $1e79381dc3a64a75$var$attachSuspenseRetryListeners(finishedWork, root)));
            break;
        case 30:
            flags & 512 && ($1e79381dc3a64a75$var$offscreenSubtreeWasHidden || null === current || $1e79381dc3a64a75$var$safelyDetachRef(current, current.return));
            flags = $1e79381dc3a64a75$var$pushMutationContext();
            ii = $1e79381dc3a64a75$var$inUpdateViewTransition;
            _eventPayloads$ii2 = (lanes & 335544064) === lanes;
            prevOffscreenSubtreeIsHidden = finishedWork.memoizedProps;
            $1e79381dc3a64a75$var$inUpdateViewTransition = _eventPayloads$ii2 && "none" !== $1e79381dc3a64a75$var$getViewTransitionClassName(prevOffscreenSubtreeIsHidden.default, prevOffscreenSubtreeIsHidden.update);
            $1e79381dc3a64a75$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $1e79381dc3a64a75$var$commitReconciliationEffects(finishedWork);
            _eventPayloads$ii2 && null !== current && $1e79381dc3a64a75$var$viewTransitionMutationContext && (finishedWork.flags |= 4);
            $1e79381dc3a64a75$var$inUpdateViewTransition = ii;
            $1e79381dc3a64a75$var$viewTransitionMutationContext = flags;
            break;
        case 21:
            break;
        case 7:
            flags & 512 && ($1e79381dc3a64a75$var$offscreenSubtreeWasHidden || null === current || $1e79381dc3a64a75$var$safelyDetachRef(current, current.return)), current && null !== current.stateNode && (current.stateNode._fragmentFiber = finishedWork);
        default:
            $1e79381dc3a64a75$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes), $1e79381dc3a64a75$var$commitReconciliationEffects(finishedWork);
    }
}
function $1e79381dc3a64a75$var$commitReconciliationEffects(finishedWork) {
    var flags = finishedWork.flags;
    if (flags & 2) {
        try {
            for(var hostParentFiber, parentFiber = finishedWork.return; null !== parentFiber;){
                if ($1e79381dc3a64a75$var$isHostParent(parentFiber)) {
                    hostParentFiber = parentFiber;
                    break;
                }
                parentFiber = parentFiber.return;
            }
            parentFiber = null;
            for(var parent = finishedWork.return; null !== parent;){
                if ($1e79381dc3a64a75$var$isFragmentInstanceParent(parent)) {
                    var fragmentInstance = parent.stateNode;
                    null === parentFiber ? parentFiber = [
                        fragmentInstance
                    ] : parentFiber.push(fragmentInstance);
                }
                if ($1e79381dc3a64a75$var$isFragmentInstanceHostBoundary(parent)) break;
                parent = parent.return;
            }
            var JSCompiler_inline_result = parentFiber;
            if (null == hostParentFiber) throw Error($1e79381dc3a64a75$var$formatProdErrorMessage(160));
            switch(hostParentFiber.tag){
                case 27:
                    var parent$jscomp$0 = hostParentFiber.stateNode, before = $1e79381dc3a64a75$var$getHostSibling(finishedWork);
                    $1e79381dc3a64a75$var$insertOrAppendPlacementNode(finishedWork, before, parent$jscomp$0, JSCompiler_inline_result);
                    break;
                case 5:
                    var parent$149 = hostParentFiber.stateNode;
                    hostParentFiber.flags & 32 && ($1e79381dc3a64a75$var$setTextContent(parent$149, ""), hostParentFiber.flags &= -33);
                    var before$150 = $1e79381dc3a64a75$var$getHostSibling(finishedWork);
                    $1e79381dc3a64a75$var$insertOrAppendPlacementNode(finishedWork, before$150, parent$149, JSCompiler_inline_result);
                    break;
                case 3:
                case 4:
                    var parent$151 = hostParentFiber.stateNode.containerInfo, before$152 = $1e79381dc3a64a75$var$getHostSibling(finishedWork);
                    $1e79381dc3a64a75$var$insertOrAppendPlacementNodeIntoContainer(finishedWork, before$152, parent$151, JSCompiler_inline_result);
                    break;
                default:
                    throw Error($1e79381dc3a64a75$var$formatProdErrorMessage(161));
            }
        } catch (error) {
            $1e79381dc3a64a75$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
        finishedWork.flags &= -3;
    }
    flags & 4096 && (finishedWork.flags &= -4097);
}
function $1e79381dc3a64a75$var$recursivelyResetForms(parentFiber) {
    if (parentFiber.subtreeFlags & 1024) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var fiber = parentFiber;
        $1e79381dc3a64a75$var$recursivelyResetForms(fiber);
        5 === fiber.tag && fiber.flags & 1024 && (fiber = fiber.stateNode, $1e79381dc3a64a75$var$_enabled = !0, fiber.reset(), $1e79381dc3a64a75$var$_enabled = !1);
        parentFiber = parentFiber.sibling;
    }
}
function $1e79381dc3a64a75$var$recursivelyTraverseAfterMutationEffects(root, parentFiber) {
    if (parentFiber.subtreeFlags & 9270) for(parentFiber = parentFiber.child; null !== parentFiber;)$1e79381dc3a64a75$var$commitAfterMutationEffectsOnFiber(parentFiber, root), parentFiber = parentFiber.sibling;
    else $1e79381dc3a64a75$var$measureNestedViewTransitions(parentFiber, !1);
}
function $1e79381dc3a64a75$var$commitAfterMutationEffectsOnFiber(finishedWork, root) {
    var current = finishedWork.alternate;
    if (null === current) $1e79381dc3a64a75$var$commitEnterViewTransitions(finishedWork, !1);
    else switch(finishedWork.tag){
        case 3:
            $1e79381dc3a64a75$var$rootViewTransitionNameCanceled = $1e79381dc3a64a75$var$viewTransitionContextChanged = !1;
            $1e79381dc3a64a75$var$pushViewTransitionCancelableScope();
            $1e79381dc3a64a75$var$recursivelyTraverseAfterMutationEffects(root, finishedWork);
            if (!$1e79381dc3a64a75$var$viewTransitionContextChanged && !$1e79381dc3a64a75$var$rootViewTransitionAffected) {
                finishedWork = $1e79381dc3a64a75$var$viewTransitionCancelableChildren;
                if (null !== finishedWork) for(var i = 0; i < finishedWork.length; i += 3){
                    current = finishedWork[i];
                    var oldName = finishedWork[i + 1];
                    $1e79381dc3a64a75$var$restoreViewTransitionName(current, finishedWork[i + 2]);
                    current = current.ownerDocument.documentElement;
                    null !== current && current.animate({
                        opacity: [
                            0,
                            0
                        ],
                        pointerEvents: [
                            "none",
                            "none"
                        ]
                    }, {
                        duration: 0,
                        fill: "forwards",
                        pseudoElement: "::view-transition-group(" + oldName + ")"
                    });
                }
                finishedWork = root.containerInfo;
                finishedWork = 9 === finishedWork.nodeType ? finishedWork.documentElement : finishedWork.ownerDocument.documentElement;
                null !== finishedWork && "" === finishedWork.style.viewTransitionName && (finishedWork.style.viewTransitionName = "none", finishedWork.animate({
                    opacity: [
                        0,
                        0
                    ],
                    pointerEvents: [
                        "none",
                        "none"
                    ]
                }, {
                    duration: 0,
                    fill: "forwards",
                    pseudoElement: "::view-transition-group(root)"
                }), finishedWork.animate({
                    width: [
                        0,
                        0
                    ],
                    height: [
                        0,
                        0
                    ]
                }, {
                    duration: 0,
                    fill: "forwards",
                    pseudoElement: "::view-transition"
                }));
                $1e79381dc3a64a75$var$rootViewTransitionNameCanceled = !0;
            }
            $1e79381dc3a64a75$var$viewTransitionCancelableChildren = null;
            break;
        case 5:
            $1e79381dc3a64a75$var$recursivelyTraverseAfterMutationEffects(root, finishedWork);
            break;
        case 4:
            i = $1e79381dc3a64a75$var$viewTransitionContextChanged;
            $1e79381dc3a64a75$var$viewTransitionContextChanged = !1;
            $1e79381dc3a64a75$var$recursivelyTraverseAfterMutationEffects(root, finishedWork);
            $1e79381dc3a64a75$var$viewTransitionContextChanged && ($1e79381dc3a64a75$var$rootViewTransitionAffected = !0);
            $1e79381dc3a64a75$var$viewTransitionContextChanged = i;
            break;
        case 22:
            null === finishedWork.memoizedState && (null !== current.memoizedState ? $1e79381dc3a64a75$var$commitEnterViewTransitions(finishedWork, !1) : $1e79381dc3a64a75$var$recursivelyTraverseAfterMutationEffects(root, finishedWork));
            break;
        case 30:
            i = $1e79381dc3a64a75$var$viewTransitionContextChanged;
            oldName = $1e79381dc3a64a75$var$pushViewTransitionCancelableScope();
            $1e79381dc3a64a75$var$viewTransitionContextChanged = !1;
            $1e79381dc3a64a75$var$recursivelyTraverseAfterMutationEffects(root, finishedWork);
            $1e79381dc3a64a75$var$viewTransitionContextChanged && (finishedWork.flags |= 4);
            var props = finishedWork.memoizedProps, state = finishedWork.stateNode;
            root = $1e79381dc3a64a75$var$getViewTransitionName(props, state);
            state = $1e79381dc3a64a75$var$getViewTransitionName(current.memoizedProps, state);
            var className = $1e79381dc3a64a75$var$getViewTransitionClassName(props.default, props.update);
            "none" === className ? root = !1 : (props = current.memoizedState, current.memoizedState = null, current = finishedWork.child, $1e79381dc3a64a75$var$viewTransitionHostInstanceIdx = 0, root = $1e79381dc3a64a75$var$measureViewTransitionHostInstancesRecursive(finishedWork, current, root, state, className, props, !0), $1e79381dc3a64a75$var$viewTransitionHostInstanceIdx !== (null === props ? 0 : props.length) && (finishedWork.flags |= 32));
            0 !== (finishedWork.flags & 4) && root ? ($1e79381dc3a64a75$var$scheduleViewTransitionEvent(finishedWork, finishedWork.memoizedProps.onUpdate), $1e79381dc3a64a75$var$viewTransitionCancelableChildren = oldName) : null !== oldName && (oldName.push.apply(oldName, $1e79381dc3a64a75$var$viewTransitionCancelableChildren), $1e79381dc3a64a75$var$viewTransitionCancelableChildren = oldName);
            $1e79381dc3a64a75$var$viewTransitionContextChanged = 0 !== (finishedWork.flags & 32) ? !0 : i;
            break;
        default:
            $1e79381dc3a64a75$var$recursivelyTraverseAfterMutationEffects(root, finishedWork);
    }
}
function $1e79381dc3a64a75$var$recursivelyTraverseLayoutEffects(root, parentFiber) {
    if (parentFiber.subtreeFlags & 8772) for(parentFiber = parentFiber.child; null !== parentFiber;)$1e79381dc3a64a75$var$commitLayoutEffectOnFiber(root, parentFiber.alternate, parentFiber), parentFiber = parentFiber.sibling;
}
function $1e79381dc3a64a75$var$recursivelyTraverseDisappearLayoutEffects(parentFiber, layoutEffectTraversalFlags$jscomp$0) {
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedWork = parentFiber, layoutEffectTraversalFlags = layoutEffectTraversalFlags$jscomp$0;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 14:
            case 15:
                $1e79381dc3a64a75$var$commitHookEffectListUnmount(4, finishedWork, finishedWork.return);
                $1e79381dc3a64a75$var$recursivelyTraverseDisappearLayoutEffects(finishedWork, layoutEffectTraversalFlags);
                break;
            case 1:
                $1e79381dc3a64a75$var$safelyDetachRef(finishedWork, finishedWork.return);
                var instance = finishedWork.stateNode;
                "function" === typeof instance.componentWillUnmount && $1e79381dc3a64a75$var$safelyCallComponentWillUnmount(finishedWork, finishedWork.return, instance);
                $1e79381dc3a64a75$var$recursivelyTraverseDisappearLayoutEffects(finishedWork, layoutEffectTraversalFlags);
                break;
            case 27:
                0 !== (layoutEffectTraversalFlags & 2) && $1e79381dc3a64a75$var$releaseSingletonInstance(finishedWork.stateNode, finishedWork.type, finishedWork.memoizedProps);
            case 5:
                $1e79381dc3a64a75$var$safelyDetachRef(finishedWork, finishedWork.return);
                5 !== finishedWork.tag && 27 !== finishedWork.tag || $1e79381dc3a64a75$var$commitFragmentInstanceDeletionEffects(finishedWork);
                $1e79381dc3a64a75$var$recursivelyTraverseDisappearLayoutEffects(finishedWork, layoutEffectTraversalFlags);
                break;
            case 6:
                $1e79381dc3a64a75$var$commitFragmentInstanceDeletionEffects(finishedWork);
                break;
            case 26:
                $1e79381dc3a64a75$var$safelyDetachRef(finishedWork, finishedWork.return);
                instance = finishedWork.stateNode;
                null !== finishedWork.memoizedState || null === instance || $1e79381dc3a64a75$var$offscreenSubtreeWasHidden || instance.parentNode.removeChild(instance);
                $1e79381dc3a64a75$var$recursivelyTraverseDisappearLayoutEffects(finishedWork, layoutEffectTraversalFlags);
                break;
            case 22:
                null === finishedWork.memoizedState && $1e79381dc3a64a75$var$recursivelyTraverseDisappearLayoutEffects(finishedWork, layoutEffectTraversalFlags);
                break;
            case 30:
                $1e79381dc3a64a75$var$safelyDetachRef(finishedWork, finishedWork.return);
                $1e79381dc3a64a75$var$recursivelyTraverseDisappearLayoutEffects(finishedWork, layoutEffectTraversalFlags);
                break;
            case 7:
                $1e79381dc3a64a75$var$safelyDetachRef(finishedWork, finishedWork.return);
            default:
                $1e79381dc3a64a75$var$recursivelyTraverseDisappearLayoutEffects(finishedWork, layoutEffectTraversalFlags);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $1e79381dc3a64a75$var$recursivelyTraverseReappearLayoutEffects(finishedRoot$jscomp$0, parentFiber, layoutEffectTraversalFlags) {
    layoutEffectTraversalFlags = 0 !== (parentFiber.subtreeFlags & 8772) ? layoutEffectTraversalFlags : layoutEffectTraversalFlags & -2;
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var current = parentFiber.alternate, finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags, includeWorkInProgressEffects = 0 !== (layoutEffectTraversalFlags & 1);
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $1e79381dc3a64a75$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                $1e79381dc3a64a75$var$commitHookEffectListMount(4, finishedWork);
                break;
            case 1:
                $1e79381dc3a64a75$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                current = finishedWork;
                finishedRoot = current.stateNode;
                if ("function" === typeof finishedRoot.componentDidMount) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $1e79381dc3a64a75$var$captureCommitPhaseError(current, current.return, error);
                }
                current = finishedWork;
                finishedRoot = current.updateQueue;
                if (null !== finishedRoot) {
                    var instance = current.stateNode;
                    try {
                        var hiddenCallbacks = finishedRoot.shared.hiddenCallbacks;
                        if (null !== hiddenCallbacks) for(finishedRoot.shared.hiddenCallbacks = null, finishedRoot = 0; finishedRoot < hiddenCallbacks.length; finishedRoot++)$1e79381dc3a64a75$var$callCallback(hiddenCallbacks[finishedRoot], instance);
                    } catch (error) {
                        $1e79381dc3a64a75$var$captureCommitPhaseError(current, current.return, error);
                    }
                }
                includeWorkInProgressEffects && flags & 64 && $1e79381dc3a64a75$var$commitClassCallbacks(finishedWork);
                $1e79381dc3a64a75$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 27:
                0 !== (layoutEffectTraversalFlags & 2) && $1e79381dc3a64a75$var$commitHostSingletonAcquisition(finishedWork);
            case 5:
                5 !== finishedWork.tag && 27 !== finishedWork.tag || $1e79381dc3a64a75$var$commitFragmentInstanceInsertionEffects(finishedWork);
                $1e79381dc3a64a75$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                includeWorkInProgressEffects && null === current && flags & 4 && $1e79381dc3a64a75$var$commitHostMount(finishedWork);
                $1e79381dc3a64a75$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 6:
                $1e79381dc3a64a75$var$commitFragmentInstanceInsertionEffects(finishedWork);
                break;
            case 26:
                instance = finishedWork.stateNode;
                null !== finishedWork.memoizedState || null === instance || $1e79381dc3a64a75$var$offscreenSubtreeIsHidden || $1e79381dc3a64a75$var$mountHoistable($1e79381dc3a64a75$var$getHoistableRoot(instance.ownerDocument), finishedWork.type, instance);
                $1e79381dc3a64a75$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                includeWorkInProgressEffects && null === current && flags & 4 && $1e79381dc3a64a75$var$commitHostMount(finishedWork);
                $1e79381dc3a64a75$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 12:
                $1e79381dc3a64a75$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                break;
            case 31:
                $1e79381dc3a64a75$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                includeWorkInProgressEffects && flags & 4 && $1e79381dc3a64a75$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 13:
                $1e79381dc3a64a75$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                includeWorkInProgressEffects && flags & 4 && $1e79381dc3a64a75$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $1e79381dc3a64a75$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                $1e79381dc3a64a75$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 30:
                $1e79381dc3a64a75$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                $1e79381dc3a64a75$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 7:
                $1e79381dc3a64a75$var$safelyAttachRef(finishedWork, finishedWork.return);
            default:
                $1e79381dc3a64a75$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $1e79381dc3a64a75$var$commitOffscreenPassiveMountEffects(current, finishedWork) {
    var previousCache = null;
    null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (previousCache = current.memoizedState.cachePool.pool);
    current = null;
    null !== finishedWork.memoizedState && null !== finishedWork.memoizedState.cachePool && (current = finishedWork.memoizedState.cachePool.pool);
    current !== previousCache && (null != current && current.refCount++, null != previousCache && $1e79381dc3a64a75$var$releaseCache(previousCache));
}
function $1e79381dc3a64a75$var$commitCachePassiveMountEffect(current, finishedWork) {
    current = null;
    null !== finishedWork.alternate && (current = finishedWork.alternate.memoizedState.cache);
    finishedWork = finishedWork.memoizedState.cache;
    finishedWork !== current && (finishedWork.refCount++, null != current && $1e79381dc3a64a75$var$releaseCache(current));
}
function $1e79381dc3a64a75$var$recursivelyTraversePassiveMountEffects(root, parentFiber, committedLanes, committedTransitions) {
    var isViewTransitionEligible = (committedLanes & 335544064) === committedLanes;
    if (parentFiber.subtreeFlags & (isViewTransitionEligible ? 10262 : 10256)) for(parentFiber = parentFiber.child; null !== parentFiber;)$1e79381dc3a64a75$var$commitPassiveMountOnFiber(root, parentFiber, committedLanes, committedTransitions), parentFiber = parentFiber.sibling;
    else isViewTransitionEligible && $1e79381dc3a64a75$var$restoreNestedViewTransitions(parentFiber);
}
function $1e79381dc3a64a75$var$commitPassiveMountOnFiber(finishedRoot, finishedWork, committedLanes, committedTransitions) {
    var isViewTransitionEligible = (committedLanes & 335544064) === committedLanes;
    isViewTransitionEligible && null === finishedWork.alternate && null !== finishedWork.return && null !== finishedWork.return.alternate && $1e79381dc3a64a75$var$restoreEnterOrExitViewTransitions(finishedWork);
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $1e79381dc3a64a75$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $1e79381dc3a64a75$var$commitHookEffectListMount(9, finishedWork);
            break;
        case 1:
            $1e79381dc3a64a75$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 3:
            $1e79381dc3a64a75$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            isViewTransitionEligible && $1e79381dc3a64a75$var$rootViewTransitionNameCanceled && (finishedRoot = finishedRoot.containerInfo, finishedRoot = 9 === finishedRoot.nodeType ? finishedRoot.body : "HTML" === finishedRoot.nodeName ? finishedRoot.ownerDocument.body : finishedRoot, "root" === finishedRoot.style.viewTransitionName && (finishedRoot.style.viewTransitionName = ""), finishedRoot = finishedRoot.ownerDocument.documentElement, null !== finishedRoot && "none" === finishedRoot.style.viewTransitionName && (finishedRoot.style.viewTransitionName = ""));
            flags & 2048 && (flags = null, null !== finishedWork.alternate && (flags = finishedWork.alternate.memoizedState.cache), finishedWork = finishedWork.memoizedState.cache, finishedWork !== flags && (finishedWork.refCount++, null != flags && $1e79381dc3a64a75$var$releaseCache(flags)));
            break;
        case 12:
            if (flags & 2048) {
                $1e79381dc3a64a75$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
                flags = finishedWork.stateNode;
                try {
                    var _finishedWork$memoize2 = finishedWork.memoizedProps, id = _finishedWork$memoize2.id, onPostCommit = _finishedWork$memoize2.onPostCommit;
                    "function" === typeof onPostCommit && onPostCommit(id, null === finishedWork.alternate ? "mount" : "update", flags.passiveEffectDuration, -0);
                } catch (error) {
                    $1e79381dc3a64a75$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            } else $1e79381dc3a64a75$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 31:
            $1e79381dc3a64a75$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 13:
            $1e79381dc3a64a75$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 23:
            break;
        case 22:
            _finishedWork$memoize2 = finishedWork.stateNode;
            id = finishedWork.alternate;
            null !== finishedWork.memoizedState ? (isViewTransitionEligible && null !== id && null === id.memoizedState && $1e79381dc3a64a75$var$restoreEnterOrExitViewTransitions(id), _finishedWork$memoize2._visibility & 2 ? $1e79381dc3a64a75$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : $1e79381dc3a64a75$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork)) : (isViewTransitionEligible && null !== id && null !== id.memoizedState && $1e79381dc3a64a75$var$restoreEnterOrExitViewTransitions(finishedWork), _finishedWork$memoize2._visibility & 2 ? $1e79381dc3a64a75$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : (_finishedWork$memoize2._visibility |= 2, $1e79381dc3a64a75$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, 0 !== (finishedWork.subtreeFlags & 10256) || !1)));
            flags & 2048 && $1e79381dc3a64a75$var$commitOffscreenPassiveMountEffects(id, finishedWork);
            break;
        case 24:
            $1e79381dc3a64a75$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $1e79381dc3a64a75$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
            break;
        case 30:
            isViewTransitionEligible && (flags = finishedWork.alternate, null !== flags && ($1e79381dc3a64a75$var$restoreViewTransitionOnHostInstances(flags.child, !0), $1e79381dc3a64a75$var$restoreViewTransitionOnHostInstances(finishedWork.child, !0)));
            $1e79381dc3a64a75$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        default:
            $1e79381dc3a64a75$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
    }
}
function $1e79381dc3a64a75$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot$jscomp$0, parentFiber, committedLanes$jscomp$0, committedTransitions$jscomp$0, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && (0 !== (parentFiber.subtreeFlags & 10256) || !1);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, committedLanes = committedLanes$jscomp$0, committedTransitions = committedTransitions$jscomp$0, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $1e79381dc3a64a75$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                $1e79381dc3a64a75$var$commitHookEffectListMount(8, finishedWork);
                break;
            case 23:
                break;
            case 22:
                var instance = finishedWork.stateNode;
                null !== finishedWork.memoizedState ? instance._visibility & 2 ? $1e79381dc3a64a75$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects) : $1e79381dc3a64a75$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : (instance._visibility |= 2, $1e79381dc3a64a75$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects));
                includeWorkInProgressEffects && flags & 2048 && $1e79381dc3a64a75$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $1e79381dc3a64a75$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 2048 && $1e79381dc3a64a75$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $1e79381dc3a64a75$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $1e79381dc3a64a75$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot$jscomp$0, parentFiber) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 22:
                $1e79381dc3a64a75$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $1e79381dc3a64a75$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $1e79381dc3a64a75$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $1e79381dc3a64a75$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $1e79381dc3a64a75$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
var $1e79381dc3a64a75$var$suspenseyCommitFlag = 8192;
function $1e79381dc3a64a75$var$recursivelyAccumulateSuspenseyCommit(parentFiber, committedLanes, suspendedState) {
    if (parentFiber.subtreeFlags & $1e79381dc3a64a75$var$suspenseyCommitFlag) for(parentFiber = parentFiber.child; null !== parentFiber;)$1e79381dc3a64a75$var$accumulateSuspenseyCommitOnFiber(parentFiber, committedLanes, suspendedState), parentFiber = parentFiber.sibling;
}
function $1e79381dc3a64a75$var$accumulateSuspenseyCommitOnFiber(fiber, committedLanes, suspendedState) {
    switch(fiber.tag){
        case 26:
            $1e79381dc3a64a75$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            fiber.flags & $1e79381dc3a64a75$var$suspenseyCommitFlag && (null !== fiber.memoizedState ? $1e79381dc3a64a75$var$suspendResource(suspendedState, $1e79381dc3a64a75$var$currentHoistableRoot, fiber.memoizedState, fiber.memoizedProps) : (fiber = fiber.stateNode, (committedLanes & 335544128) === committedLanes && $1e79381dc3a64a75$var$suspendInstance(suspendedState, fiber)));
            break;
        case 5:
            $1e79381dc3a64a75$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            fiber.flags & $1e79381dc3a64a75$var$suspenseyCommitFlag && (fiber = fiber.stateNode, (committedLanes & 335544128) === committedLanes && $1e79381dc3a64a75$var$suspendInstance(suspendedState, fiber));
            break;
        case 3:
        case 4:
            var previousHoistableRoot = $1e79381dc3a64a75$var$currentHoistableRoot;
            $1e79381dc3a64a75$var$currentHoistableRoot = $1e79381dc3a64a75$var$getHoistableRoot(fiber.stateNode.containerInfo);
            $1e79381dc3a64a75$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            $1e79381dc3a64a75$var$currentHoistableRoot = previousHoistableRoot;
            break;
        case 22:
            null === fiber.memoizedState && (previousHoistableRoot = fiber.alternate, null !== previousHoistableRoot && null !== previousHoistableRoot.memoizedState ? (previousHoistableRoot = $1e79381dc3a64a75$var$suspenseyCommitFlag, $1e79381dc3a64a75$var$suspenseyCommitFlag = 16777216, $1e79381dc3a64a75$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState), $1e79381dc3a64a75$var$suspenseyCommitFlag = previousHoistableRoot) : $1e79381dc3a64a75$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState));
            break;
        case 30:
            if (0 !== (fiber.flags & $1e79381dc3a64a75$var$suspenseyCommitFlag) && (previousHoistableRoot = fiber.memoizedProps.name, null != previousHoistableRoot && "auto" !== previousHoistableRoot)) {
                var state = fiber.stateNode;
                state.paired = null;
                null === $1e79381dc3a64a75$var$appearingViewTransitions && ($1e79381dc3a64a75$var$appearingViewTransitions = new Map());
                $1e79381dc3a64a75$var$appearingViewTransitions.set(previousHoistableRoot, state);
            }
            $1e79381dc3a64a75$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            break;
        default:
            $1e79381dc3a64a75$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
    }
}
function $1e79381dc3a64a75$var$detachAlternateSiblings(parentFiber) {
    var previousFiber = parentFiber.alternate;
    if (null !== previousFiber && (parentFiber = previousFiber.child, null !== parentFiber)) {
        previousFiber.child = null;
        do previousFiber = parentFiber.sibling, parentFiber.sibling = null, parentFiber = previousFiber;
        while (null !== parentFiber);
    }
}
function $1e79381dc3a64a75$var$recursivelyTraversePassiveUnmountEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $1e79381dc3a64a75$var$nextEffect = childToDelete;
            $1e79381dc3a64a75$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $1e79381dc3a64a75$var$detachAlternateSiblings(parentFiber);
    }
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$1e79381dc3a64a75$var$commitPassiveUnmountOnFiber(parentFiber), parentFiber = parentFiber.sibling;
}
function $1e79381dc3a64a75$var$commitPassiveUnmountOnFiber(finishedWork) {
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $1e79381dc3a64a75$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            finishedWork.flags & 2048 && $1e79381dc3a64a75$var$commitHookEffectListUnmount(9, finishedWork, finishedWork.return);
            break;
        case 3:
            $1e79381dc3a64a75$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 12:
            $1e79381dc3a64a75$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 22:
            var instance = finishedWork.stateNode;
            null !== finishedWork.memoizedState && instance._visibility & 2 && (null === finishedWork.return || 13 !== finishedWork.return.tag) ? (instance._visibility &= -3, $1e79381dc3a64a75$var$recursivelyTraverseDisconnectPassiveEffects(finishedWork)) : $1e79381dc3a64a75$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        default:
            $1e79381dc3a64a75$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
    }
}
function $1e79381dc3a64a75$var$recursivelyTraverseDisconnectPassiveEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $1e79381dc3a64a75$var$nextEffect = childToDelete;
            $1e79381dc3a64a75$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $1e79381dc3a64a75$var$detachAlternateSiblings(parentFiber);
    }
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        deletions = parentFiber;
        switch(deletions.tag){
            case 0:
            case 11:
            case 15:
                $1e79381dc3a64a75$var$commitHookEffectListUnmount(8, deletions, deletions.return);
                $1e79381dc3a64a75$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
                break;
            case 22:
                i = deletions.stateNode;
                i._visibility & 2 && (i._visibility &= -3, $1e79381dc3a64a75$var$recursivelyTraverseDisconnectPassiveEffects(deletions));
                break;
            default:
                $1e79381dc3a64a75$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $1e79381dc3a64a75$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(deletedSubtreeRoot, nearestMountedAncestor) {
    for(; null !== $1e79381dc3a64a75$var$nextEffect;){
        var fiber = $1e79381dc3a64a75$var$nextEffect;
        switch(fiber.tag){
            case 0:
            case 11:
            case 15:
                $1e79381dc3a64a75$var$commitHookEffectListUnmount(8, fiber, nearestMountedAncestor);
                break;
            case 23:
            case 22:
                if (null !== fiber.memoizedState && null !== fiber.memoizedState.cachePool) {
                    var cache = fiber.memoizedState.cachePool.pool;
                    null != cache && cache.refCount++;
                }
                break;
            case 24:
                $1e79381dc3a64a75$var$releaseCache(fiber.memoizedState.cache);
        }
        cache = fiber.child;
        if (null !== cache) cache.return = fiber, $1e79381dc3a64a75$var$nextEffect = cache;
        else a: for(fiber = deletedSubtreeRoot; null !== $1e79381dc3a64a75$var$nextEffect;){
            cache = $1e79381dc3a64a75$var$nextEffect;
            var sibling = cache.sibling, returnFiber = cache.return;
            $1e79381dc3a64a75$var$detachFiberAfterEffects(cache);
            if (cache === fiber) {
                $1e79381dc3a64a75$var$nextEffect = null;
                break a;
            }
            if (null !== sibling) {
                sibling.return = returnFiber;
                $1e79381dc3a64a75$var$nextEffect = sibling;
                break a;
            }
            $1e79381dc3a64a75$var$nextEffect = returnFiber;
        }
    }
}
var $1e79381dc3a64a75$var$DefaultAsyncDispatcher = {
    getCacheForType: function(resourceType) {
        var cache = $1e79381dc3a64a75$var$readContext($1e79381dc3a64a75$var$CacheContext), cacheForType = cache.data.get(resourceType);
        void 0 === cacheForType && (cacheForType = resourceType(), cache.data.set(resourceType, cacheForType));
        return cacheForType;
    },
    cacheSignal: function() {
        return $1e79381dc3a64a75$var$readContext($1e79381dc3a64a75$var$CacheContext).controller.signal;
    }
}, $1e79381dc3a64a75$var$PossiblyWeakMap = "function" === typeof WeakMap ? WeakMap : Map, $1e79381dc3a64a75$var$executionContext = 0, $1e79381dc3a64a75$var$workInProgressRoot = null, $1e79381dc3a64a75$var$workInProgress = null, $1e79381dc3a64a75$var$workInProgressRootRenderLanes = 0, $1e79381dc3a64a75$var$workInProgressSuspendedReason = 0, $1e79381dc3a64a75$var$workInProgressThrownValue = null, $1e79381dc3a64a75$var$workInProgressRootDidSkipSuspendedSiblings = !1, $1e79381dc3a64a75$var$workInProgressRootIsPrerendering = !1, $1e79381dc3a64a75$var$workInProgressRootDidAttachPingListener = !1, $1e79381dc3a64a75$var$entangledRenderLanes = 0, $1e79381dc3a64a75$var$workInProgressRootExitStatus = 0, $1e79381dc3a64a75$var$workInProgressRootSkippedLanes = 0, $1e79381dc3a64a75$var$workInProgressRootInterleavedUpdatedLanes = 0, $1e79381dc3a64a75$var$workInProgressRootPingedLanes = 0, $1e79381dc3a64a75$var$workInProgressDeferredLane = 0, $1e79381dc3a64a75$var$workInProgressSuspendedRetryLanes = 0, $1e79381dc3a64a75$var$workInProgressRootConcurrentErrors = null, $1e79381dc3a64a75$var$workInProgressRootRecoverableErrors = null, $1e79381dc3a64a75$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1, $1e79381dc3a64a75$var$globalMostRecentFallbackTime = 0, $1e79381dc3a64a75$var$globalMostRecentTransitionTime = 0, $1e79381dc3a64a75$var$workInProgressRootRenderTargetTime = Infinity, $1e79381dc3a64a75$var$workInProgressTransitions = null, $1e79381dc3a64a75$var$legacyErrorBoundariesThatAlreadyFailed = null, $1e79381dc3a64a75$var$pendingEffectsStatus = 0, $1e79381dc3a64a75$var$pendingEffectsRoot = null, $1e79381dc3a64a75$var$pendingFinishedWork = null, $1e79381dc3a64a75$var$pendingEffectsLanes = 0, $1e79381dc3a64a75$var$pendingEffectsRemainingLanes = 0, $1e79381dc3a64a75$var$pendingPassiveTransitions = null, $1e79381dc3a64a75$var$pendingRecoverableErrors = null, $1e79381dc3a64a75$var$pendingViewTransition = null, $1e79381dc3a64a75$var$pendingViewTransitionEvents = null, $1e79381dc3a64a75$var$pendingTransitionTypes = null, $1e79381dc3a64a75$var$nestedUpdateCount = 0, $1e79381dc3a64a75$var$rootWithNestedUpdates = null;
function $1e79381dc3a64a75$var$requestUpdateLane() {
    return 0 !== ($1e79381dc3a64a75$var$executionContext & 2) && 0 !== $1e79381dc3a64a75$var$workInProgressRootRenderLanes ? $1e79381dc3a64a75$var$workInProgressRootRenderLanes & -$1e79381dc3a64a75$var$workInProgressRootRenderLanes : null !== $1e79381dc3a64a75$var$ReactSharedInternals.T ? $1e79381dc3a64a75$var$requestTransitionLane() : $1e79381dc3a64a75$var$resolveUpdatePriority();
}
function $1e79381dc3a64a75$var$requestDeferredLane() {
    if (0 === $1e79381dc3a64a75$var$workInProgressDeferredLane) {
        if (0 === ($1e79381dc3a64a75$var$workInProgressRootRenderLanes & 536870912) || $1e79381dc3a64a75$var$isHydrating) {
            var lane = $1e79381dc3a64a75$var$nextTransitionDeferredLane;
            $1e79381dc3a64a75$var$nextTransitionDeferredLane <<= 1;
            0 === ($1e79381dc3a64a75$var$nextTransitionDeferredLane & 3932160) && ($1e79381dc3a64a75$var$nextTransitionDeferredLane = 262144);
            $1e79381dc3a64a75$var$workInProgressDeferredLane = lane;
        } else $1e79381dc3a64a75$var$workInProgressDeferredLane = 536870912;
    }
    lane = $1e79381dc3a64a75$var$suspenseHandlerStackCursor.current;
    null !== lane && (lane.flags |= 32);
    return $1e79381dc3a64a75$var$workInProgressDeferredLane;
}
function $1e79381dc3a64a75$var$scheduleViewTransitionEvent(fiber, callback) {
    if (null != callback) {
        var state = fiber.stateNode, instance = state.ref;
        null === instance && (instance = state.ref = $1e79381dc3a64a75$var$createViewTransitionInstance($1e79381dc3a64a75$var$getViewTransitionName(fiber.memoizedProps, state)));
        null === $1e79381dc3a64a75$var$pendingViewTransitionEvents && ($1e79381dc3a64a75$var$pendingViewTransitionEvents = []);
        $1e79381dc3a64a75$var$pendingViewTransitionEvents.push(callback.bind(null, instance));
    }
}
function $1e79381dc3a64a75$var$scheduleUpdateOnFiber(root, fiber, lane) {
    if (root === $1e79381dc3a64a75$var$workInProgressRoot && (2 === $1e79381dc3a64a75$var$workInProgressSuspendedReason || 9 === $1e79381dc3a64a75$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) $1e79381dc3a64a75$var$prepareFreshStack(root, 0), $1e79381dc3a64a75$var$markRootSuspended(root, $1e79381dc3a64a75$var$workInProgressRootRenderLanes, $1e79381dc3a64a75$var$workInProgressDeferredLane, !1);
    $1e79381dc3a64a75$var$markRootUpdated$1(root, lane);
    if (0 === ($1e79381dc3a64a75$var$executionContext & 2) || root !== $1e79381dc3a64a75$var$workInProgressRoot) root === $1e79381dc3a64a75$var$workInProgressRoot && (0 === ($1e79381dc3a64a75$var$executionContext & 2) && ($1e79381dc3a64a75$var$workInProgressRootInterleavedUpdatedLanes |= lane), 4 === $1e79381dc3a64a75$var$workInProgressRootExitStatus && $1e79381dc3a64a75$var$markRootSuspended(root, $1e79381dc3a64a75$var$workInProgressRootRenderLanes, $1e79381dc3a64a75$var$workInProgressDeferredLane, !1)), $1e79381dc3a64a75$var$ensureRootIsScheduled(root);
}
function $1e79381dc3a64a75$var$performWorkOnRoot(root$jscomp$0, lanes, forceSync) {
    if (0 !== ($1e79381dc3a64a75$var$executionContext & 6)) throw Error($1e79381dc3a64a75$var$formatProdErrorMessage(327));
    var shouldTimeSlice = !forceSync && 0 === (lanes & 127) && 0 === (lanes & root$jscomp$0.expiredLanes) || $1e79381dc3a64a75$var$checkIfRootIsPrerendering(root$jscomp$0, lanes), exitStatus = shouldTimeSlice ? $1e79381dc3a64a75$var$renderRootConcurrent(root$jscomp$0, lanes) : $1e79381dc3a64a75$var$renderRootSync(root$jscomp$0, lanes, !0), renderWasConcurrent = shouldTimeSlice;
    do {
        if (0 === exitStatus) {
            $1e79381dc3a64a75$var$workInProgressRootIsPrerendering && !shouldTimeSlice && $1e79381dc3a64a75$var$markRootSuspended(root$jscomp$0, lanes, 0, !1);
            break;
        } else {
            forceSync = root$jscomp$0.current.alternate;
            if (renderWasConcurrent && !$1e79381dc3a64a75$var$isRenderConsistentWithExternalStores(forceSync)) {
                exitStatus = $1e79381dc3a64a75$var$renderRootSync(root$jscomp$0, lanes, !1);
                renderWasConcurrent = !1;
                continue;
            }
            if (2 === exitStatus) {
                renderWasConcurrent = lanes;
                if (root$jscomp$0.errorRecoveryDisabledLanes & renderWasConcurrent) var JSCompiler_inline_result = 0;
                else JSCompiler_inline_result = root$jscomp$0.pendingLanes & -536870913, JSCompiler_inline_result = 0 !== JSCompiler_inline_result ? JSCompiler_inline_result : JSCompiler_inline_result & 536870912 ? 536870912 : 0;
                if (0 !== JSCompiler_inline_result) {
                    lanes = JSCompiler_inline_result;
                    a: {
                        var root = root$jscomp$0;
                        exitStatus = $1e79381dc3a64a75$var$workInProgressRootConcurrentErrors;
                        var wasRootDehydrated = root.current.memoizedState.isDehydrated;
                        wasRootDehydrated && ($1e79381dc3a64a75$var$prepareFreshStack(root, JSCompiler_inline_result).flags |= 256);
                        JSCompiler_inline_result = $1e79381dc3a64a75$var$renderRootSync(root, JSCompiler_inline_result, !1);
                        if (2 !== JSCompiler_inline_result && 6 !== JSCompiler_inline_result) {
                            if ($1e79381dc3a64a75$var$workInProgressRootDidAttachPingListener && !wasRootDehydrated) {
                                root.errorRecoveryDisabledLanes |= renderWasConcurrent;
                                $1e79381dc3a64a75$var$workInProgressRootInterleavedUpdatedLanes |= renderWasConcurrent;
                                exitStatus = 4;
                                break a;
                            }
                            renderWasConcurrent = $1e79381dc3a64a75$var$workInProgressRootRecoverableErrors;
                            $1e79381dc3a64a75$var$workInProgressRootRecoverableErrors = exitStatus;
                            null !== renderWasConcurrent && (null === $1e79381dc3a64a75$var$workInProgressRootRecoverableErrors ? $1e79381dc3a64a75$var$workInProgressRootRecoverableErrors = renderWasConcurrent : $1e79381dc3a64a75$var$workInProgressRootRecoverableErrors.push.apply($1e79381dc3a64a75$var$workInProgressRootRecoverableErrors, renderWasConcurrent));
                        }
                        exitStatus = JSCompiler_inline_result;
                    }
                    renderWasConcurrent = !1;
                    if (2 !== exitStatus) continue;
                }
            }
            if (1 === exitStatus) {
                $1e79381dc3a64a75$var$prepareFreshStack(root$jscomp$0, 0);
                $1e79381dc3a64a75$var$markRootSuspended(root$jscomp$0, lanes, 0, !0);
                break;
            }
            a: {
                shouldTimeSlice = root$jscomp$0;
                renderWasConcurrent = exitStatus;
                switch(renderWasConcurrent){
                    case 0:
                    case 1:
                        throw Error($1e79381dc3a64a75$var$formatProdErrorMessage(345));
                    case 4:
                        if ((lanes & 4194048) !== lanes && (lanes & 62914560) !== lanes) break;
                    case 6:
                        $1e79381dc3a64a75$var$markRootSuspended(shouldTimeSlice, lanes, $1e79381dc3a64a75$var$workInProgressDeferredLane, !$1e79381dc3a64a75$var$workInProgressRootDidSkipSuspendedSiblings);
                        break a;
                    case 2:
                        $1e79381dc3a64a75$var$workInProgressRootRecoverableErrors = null;
                        break;
                    case 3:
                    case 5:
                        break;
                    default:
                        throw Error($1e79381dc3a64a75$var$formatProdErrorMessage(329));
                }
                if ((lanes & 62914560) === lanes && (exitStatus = $1e79381dc3a64a75$var$globalMostRecentFallbackTime + 300 - $1e79381dc3a64a75$var$now(), 10 < exitStatus)) {
                    $1e79381dc3a64a75$var$markRootSuspended(shouldTimeSlice, lanes, $1e79381dc3a64a75$var$workInProgressDeferredLane, !$1e79381dc3a64a75$var$workInProgressRootDidSkipSuspendedSiblings);
                    if (0 !== $1e79381dc3a64a75$var$getNextLanes(shouldTimeSlice, 0, !0)) break a;
                    $1e79381dc3a64a75$var$pendingEffectsLanes = lanes;
                    shouldTimeSlice.timeoutHandle = $1e79381dc3a64a75$var$scheduleTimeout($1e79381dc3a64a75$var$completeRootWhenReady.bind(null, shouldTimeSlice, forceSync, $1e79381dc3a64a75$var$workInProgressRootRecoverableErrors, $1e79381dc3a64a75$var$workInProgressTransitions, $1e79381dc3a64a75$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $1e79381dc3a64a75$var$workInProgressDeferredLane, $1e79381dc3a64a75$var$workInProgressRootInterleavedUpdatedLanes, $1e79381dc3a64a75$var$workInProgressSuspendedRetryLanes, $1e79381dc3a64a75$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, "Throttled", -0, 0), exitStatus);
                    break a;
                }
                $1e79381dc3a64a75$var$completeRootWhenReady(shouldTimeSlice, forceSync, $1e79381dc3a64a75$var$workInProgressRootRecoverableErrors, $1e79381dc3a64a75$var$workInProgressTransitions, $1e79381dc3a64a75$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $1e79381dc3a64a75$var$workInProgressDeferredLane, $1e79381dc3a64a75$var$workInProgressRootInterleavedUpdatedLanes, $1e79381dc3a64a75$var$workInProgressSuspendedRetryLanes, $1e79381dc3a64a75$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, null, -0, 0);
            }
        }
        break;
    }while (1);
    $1e79381dc3a64a75$var$ensureRootIsScheduled(root$jscomp$0);
}
function $1e79381dc3a64a75$var$completeRootWhenReady(root, finishedWork, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime) {
    root.timeoutHandle = -1;
    var subtreeFlags = finishedWork.subtreeFlags, isViewTransitionEligible = (lanes & 335544064) === lanes;
    suspendedCommitReason = null;
    if (isViewTransitionEligible || subtreeFlags & 8192 || 16785408 === (subtreeFlags & 16785408)) {
        if (suspendedCommitReason = {
            stylesheets: null,
            count: 0,
            imgCount: 0,
            imgBytes: 0,
            suspenseyImages: [],
            waitingForImages: !0,
            waitingForViewTransition: !1,
            unsuspend: $1e79381dc3a64a75$var$noop$1
        }, $1e79381dc3a64a75$var$appearingViewTransitions = null, $1e79381dc3a64a75$var$accumulateSuspenseyCommitOnFiber(finishedWork, lanes, suspendedCommitReason), isViewTransitionEligible && (subtreeFlags = suspendedCommitReason, isViewTransitionEligible = root.containerInfo, isViewTransitionEligible = (9 === isViewTransitionEligible.nodeType ? isViewTransitionEligible : isViewTransitionEligible.ownerDocument).__reactViewTransition, null != isViewTransitionEligible && (subtreeFlags.count++, subtreeFlags.waitingForViewTransition = !0, subtreeFlags = $1e79381dc3a64a75$var$onUnsuspend.bind(subtreeFlags), isViewTransitionEligible.finished.then(subtreeFlags, subtreeFlags))), subtreeFlags = (lanes & 62914560) === lanes ? $1e79381dc3a64a75$var$globalMostRecentFallbackTime - $1e79381dc3a64a75$var$now() : (lanes & 4194048) === lanes ? $1e79381dc3a64a75$var$globalMostRecentTransitionTime - $1e79381dc3a64a75$var$now() : 0, subtreeFlags = $1e79381dc3a64a75$var$waitForCommitToBeReady(suspendedCommitReason, subtreeFlags), null !== subtreeFlags) {
            $1e79381dc3a64a75$var$pendingEffectsLanes = lanes;
            root.cancelPendingCommit = subtreeFlags($1e79381dc3a64a75$var$completeRoot.bind(null, root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedCommitReason, null, completedRenderStartTime, completedRenderEndTime));
            $1e79381dc3a64a75$var$markRootSuspended(root, lanes, spawnedLane, !didSkipSuspendedSiblings);
            return;
        }
    }
    $1e79381dc3a64a75$var$completeRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedCommitReason);
}
function $1e79381dc3a64a75$var$isRenderConsistentWithExternalStores(finishedWork) {
    for(var node = finishedWork;;){
        var tag = node.tag;
        if ((0 === tag || 11 === tag || 15 === tag) && node.flags & 16384 && (tag = node.updateQueue, null !== tag && (tag = tag.stores, null !== tag))) for(var i = 0; i < tag.length; i++){
            var check = tag[i], getSnapshot = check.getSnapshot;
            check = check.value;
            try {
                if (!$1e79381dc3a64a75$var$objectIs(getSnapshot(), check)) return !1;
            } catch (error) {
                return !1;
            }
        }
        tag = node.child;
        if (node.subtreeFlags & 16384 && null !== tag) tag.return = node, node = tag;
        else {
            if (node === finishedWork) break;
            for(; null === node.sibling;){
                if (null === node.return || node.return === finishedWork) return !0;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    return !0;
}
function $1e79381dc3a64a75$var$markRootSuspended(root, suspendedLanes, spawnedLane, didAttemptEntireTree) {
    suspendedLanes = $1e79381dc3a64a75$var$getEntangledLanes(root, suspendedLanes);
    suspendedLanes &= ~$1e79381dc3a64a75$var$workInProgressRootPingedLanes;
    suspendedLanes &= ~$1e79381dc3a64a75$var$workInProgressRootInterleavedUpdatedLanes;
    root.suspendedLanes |= suspendedLanes;
    root.pingedLanes &= ~suspendedLanes;
    didAttemptEntireTree && (root.warmLanes |= suspendedLanes);
    didAttemptEntireTree = root.expirationTimes;
    for(var lanes = suspendedLanes; 0 < lanes;){
        var index$6 = 31 - $1e79381dc3a64a75$var$clz32(lanes), lane = 1 << index$6;
        didAttemptEntireTree[index$6] = -1;
        lanes &= ~lane;
    }
    0 !== spawnedLane && $1e79381dc3a64a75$var$markSpawnedDeferredLane(root, spawnedLane, suspendedLanes);
}
function $1e79381dc3a64a75$var$flushSyncWork$1() {
    return 0 === ($1e79381dc3a64a75$var$executionContext & 6) ? ($1e79381dc3a64a75$var$flushSyncWorkAcrossRoots_impl(0, !1), !1) : !0;
}
function $1e79381dc3a64a75$var$resetWorkInProgressStack() {
    if (null !== $1e79381dc3a64a75$var$workInProgress) {
        if (0 === $1e79381dc3a64a75$var$workInProgressSuspendedReason) var interruptedWork = $1e79381dc3a64a75$var$workInProgress.return;
        else interruptedWork = $1e79381dc3a64a75$var$workInProgress, $1e79381dc3a64a75$var$lastContextDependency = $1e79381dc3a64a75$var$currentlyRenderingFiber$1 = null, $1e79381dc3a64a75$var$resetHooksOnUnwind(interruptedWork), $1e79381dc3a64a75$var$thenableState$1 = null, $1e79381dc3a64a75$var$thenableIndexCounter$1 = 0, interruptedWork = $1e79381dc3a64a75$var$workInProgress;
        for(; null !== interruptedWork;)$1e79381dc3a64a75$var$unwindInterruptedWork(interruptedWork.alternate, interruptedWork), interruptedWork = interruptedWork.return;
        $1e79381dc3a64a75$var$workInProgress = null;
    }
}
function $1e79381dc3a64a75$var$prepareFreshStack(root, lanes) {
    var timeoutHandle = root.timeoutHandle;
    -1 !== timeoutHandle && (root.timeoutHandle = -1, $1e79381dc3a64a75$var$cancelTimeout(timeoutHandle));
    timeoutHandle = root.cancelPendingCommit;
    null !== timeoutHandle && (root.cancelPendingCommit = null, timeoutHandle());
    $1e79381dc3a64a75$var$pendingEffectsLanes = 0;
    $1e79381dc3a64a75$var$resetWorkInProgressStack();
    $1e79381dc3a64a75$var$workInProgressRoot = root;
    $1e79381dc3a64a75$var$workInProgress = timeoutHandle = $1e79381dc3a64a75$var$createWorkInProgress(root.current, null);
    $1e79381dc3a64a75$var$workInProgressRootRenderLanes = lanes;
    $1e79381dc3a64a75$var$workInProgressSuspendedReason = 0;
    $1e79381dc3a64a75$var$workInProgressThrownValue = null;
    $1e79381dc3a64a75$var$workInProgressRootDidSkipSuspendedSiblings = !1;
    $1e79381dc3a64a75$var$workInProgressRootIsPrerendering = $1e79381dc3a64a75$var$checkIfRootIsPrerendering(root, lanes);
    $1e79381dc3a64a75$var$workInProgressRootDidAttachPingListener = !1;
    $1e79381dc3a64a75$var$workInProgressSuspendedRetryLanes = $1e79381dc3a64a75$var$workInProgressDeferredLane = $1e79381dc3a64a75$var$workInProgressRootPingedLanes = $1e79381dc3a64a75$var$workInProgressRootInterleavedUpdatedLanes = $1e79381dc3a64a75$var$workInProgressRootSkippedLanes = $1e79381dc3a64a75$var$workInProgressRootExitStatus = 0;
    $1e79381dc3a64a75$var$workInProgressRootRecoverableErrors = $1e79381dc3a64a75$var$workInProgressRootConcurrentErrors = null;
    $1e79381dc3a64a75$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1;
    $1e79381dc3a64a75$var$entangledRenderLanes = $1e79381dc3a64a75$var$getEntangledLanes(root, lanes);
    $1e79381dc3a64a75$var$finishQueueingConcurrentUpdates();
    return timeoutHandle;
}
function $1e79381dc3a64a75$var$handleThrow(root, thrownValue) {
    $1e79381dc3a64a75$var$currentlyRenderingFiber = null;
    $1e79381dc3a64a75$var$ReactSharedInternals.H = $1e79381dc3a64a75$var$ContextOnlyDispatcher;
    thrownValue === $1e79381dc3a64a75$var$SuspenseException || thrownValue === $1e79381dc3a64a75$var$SuspenseActionException ? (thrownValue = $1e79381dc3a64a75$var$getSuspendedThenable(), $1e79381dc3a64a75$var$workInProgressSuspendedReason = 3) : thrownValue === $1e79381dc3a64a75$var$SuspenseyCommitException ? (thrownValue = $1e79381dc3a64a75$var$getSuspendedThenable(), $1e79381dc3a64a75$var$workInProgressSuspendedReason = 4) : $1e79381dc3a64a75$var$workInProgressSuspendedReason = thrownValue === $1e79381dc3a64a75$var$SelectiveHydrationException ? 8 : null !== thrownValue && "object" === typeof thrownValue && "function" === typeof thrownValue.then ? 6 : 1;
    $1e79381dc3a64a75$var$workInProgressThrownValue = thrownValue;
    null === $1e79381dc3a64a75$var$workInProgress && ($1e79381dc3a64a75$var$workInProgressRootExitStatus = 1, $1e79381dc3a64a75$var$logUncaughtError(root, $1e79381dc3a64a75$var$createCapturedValueAtFiber(thrownValue, root.current)));
}
function $1e79381dc3a64a75$var$shouldRemainOnPreviousScreen() {
    var handler = $1e79381dc3a64a75$var$suspenseHandlerStackCursor.current;
    return null === handler ? !0 : ($1e79381dc3a64a75$var$workInProgressRootRenderLanes & 4194048) === $1e79381dc3a64a75$var$workInProgressRootRenderLanes ? null === $1e79381dc3a64a75$var$shellBoundary ? !0 : !1 : ($1e79381dc3a64a75$var$workInProgressRootRenderLanes & 62914560) === $1e79381dc3a64a75$var$workInProgressRootRenderLanes || 0 !== ($1e79381dc3a64a75$var$workInProgressRootRenderLanes & 536870912) ? handler === $1e79381dc3a64a75$var$shellBoundary : !1;
}
function $1e79381dc3a64a75$var$pushDispatcher() {
    var prevDispatcher = $1e79381dc3a64a75$var$ReactSharedInternals.H;
    $1e79381dc3a64a75$var$ReactSharedInternals.H = $1e79381dc3a64a75$var$ContextOnlyDispatcher;
    return null === prevDispatcher ? $1e79381dc3a64a75$var$ContextOnlyDispatcher : prevDispatcher;
}
function $1e79381dc3a64a75$var$pushAsyncDispatcher() {
    var prevAsyncDispatcher = $1e79381dc3a64a75$var$ReactSharedInternals.A;
    $1e79381dc3a64a75$var$ReactSharedInternals.A = $1e79381dc3a64a75$var$DefaultAsyncDispatcher;
    return prevAsyncDispatcher;
}
function $1e79381dc3a64a75$var$renderDidSuspendDelayIfPossible() {
    $1e79381dc3a64a75$var$workInProgressRootExitStatus = 4;
    $1e79381dc3a64a75$var$workInProgressRootDidSkipSuspendedSiblings || ($1e79381dc3a64a75$var$workInProgressRootRenderLanes & 4194048) !== $1e79381dc3a64a75$var$workInProgressRootRenderLanes && null !== $1e79381dc3a64a75$var$suspenseHandlerStackCursor.current || ($1e79381dc3a64a75$var$workInProgressRootIsPrerendering = !0);
    0 === ($1e79381dc3a64a75$var$workInProgressRootSkippedLanes & 134217727) && 0 === ($1e79381dc3a64a75$var$workInProgressRootInterleavedUpdatedLanes & 134217727) || null === $1e79381dc3a64a75$var$workInProgressRoot || $1e79381dc3a64a75$var$markRootSuspended($1e79381dc3a64a75$var$workInProgressRoot, $1e79381dc3a64a75$var$workInProgressRootRenderLanes, $1e79381dc3a64a75$var$workInProgressDeferredLane, !1);
}
function $1e79381dc3a64a75$var$renderRootSync(root, lanes, shouldYieldForPrerendering) {
    var prevExecutionContext = $1e79381dc3a64a75$var$executionContext;
    $1e79381dc3a64a75$var$executionContext |= 2;
    var prevDispatcher = $1e79381dc3a64a75$var$pushDispatcher(), prevAsyncDispatcher = $1e79381dc3a64a75$var$pushAsyncDispatcher();
    if ($1e79381dc3a64a75$var$workInProgressRoot !== root || $1e79381dc3a64a75$var$workInProgressRootRenderLanes !== lanes) $1e79381dc3a64a75$var$workInProgressTransitions = null, $1e79381dc3a64a75$var$prepareFreshStack(root, lanes);
    lanes = !1;
    var exitStatus = $1e79381dc3a64a75$var$workInProgressRootExitStatus;
    a: do try {
        if (0 !== $1e79381dc3a64a75$var$workInProgressSuspendedReason && null !== $1e79381dc3a64a75$var$workInProgress) {
            var unitOfWork = $1e79381dc3a64a75$var$workInProgress, thrownValue = $1e79381dc3a64a75$var$workInProgressThrownValue;
            switch($1e79381dc3a64a75$var$workInProgressSuspendedReason){
                case 8:
                    $1e79381dc3a64a75$var$resetWorkInProgressStack();
                    exitStatus = 6;
                    break a;
                case 3:
                case 2:
                case 9:
                case 6:
                    null === $1e79381dc3a64a75$var$suspenseHandlerStackCursor.current && (lanes = !0);
                    var reason = $1e79381dc3a64a75$var$workInProgressSuspendedReason;
                    $1e79381dc3a64a75$var$workInProgressSuspendedReason = 0;
                    $1e79381dc3a64a75$var$workInProgressThrownValue = null;
                    $1e79381dc3a64a75$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
                    if (shouldYieldForPrerendering && $1e79381dc3a64a75$var$workInProgressRootIsPrerendering) {
                        exitStatus = 0;
                        break a;
                    }
                    break;
                default:
                    reason = $1e79381dc3a64a75$var$workInProgressSuspendedReason, $1e79381dc3a64a75$var$workInProgressSuspendedReason = 0, $1e79381dc3a64a75$var$workInProgressThrownValue = null, $1e79381dc3a64a75$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
            }
        }
        $1e79381dc3a64a75$var$workLoopSync();
        exitStatus = $1e79381dc3a64a75$var$workInProgressRootExitStatus;
        break;
    } catch (thrownValue$184) {
        $1e79381dc3a64a75$var$handleThrow(root, thrownValue$184);
    }
    while (1);
    lanes && root.shellSuspendCounter++;
    $1e79381dc3a64a75$var$lastContextDependency = $1e79381dc3a64a75$var$currentlyRenderingFiber$1 = null;
    $1e79381dc3a64a75$var$executionContext = prevExecutionContext;
    $1e79381dc3a64a75$var$ReactSharedInternals.H = prevDispatcher;
    $1e79381dc3a64a75$var$ReactSharedInternals.A = prevAsyncDispatcher;
    null === $1e79381dc3a64a75$var$workInProgress && ($1e79381dc3a64a75$var$workInProgressRoot = null, $1e79381dc3a64a75$var$workInProgressRootRenderLanes = 0, $1e79381dc3a64a75$var$finishQueueingConcurrentUpdates());
    return exitStatus;
}
function $1e79381dc3a64a75$var$workLoopSync() {
    for(; null !== $1e79381dc3a64a75$var$workInProgress;)$1e79381dc3a64a75$var$performUnitOfWork($1e79381dc3a64a75$var$workInProgress);
}
function $1e79381dc3a64a75$var$renderRootConcurrent(root, lanes) {
    var prevExecutionContext = $1e79381dc3a64a75$var$executionContext;
    $1e79381dc3a64a75$var$executionContext |= 2;
    var prevDispatcher = $1e79381dc3a64a75$var$pushDispatcher(), prevAsyncDispatcher = $1e79381dc3a64a75$var$pushAsyncDispatcher();
    $1e79381dc3a64a75$var$workInProgressRoot !== root || $1e79381dc3a64a75$var$workInProgressRootRenderLanes !== lanes ? ($1e79381dc3a64a75$var$workInProgressTransitions = null, $1e79381dc3a64a75$var$workInProgressRootRenderTargetTime = $1e79381dc3a64a75$var$now() + 500, $1e79381dc3a64a75$var$prepareFreshStack(root, lanes)) : $1e79381dc3a64a75$var$workInProgressRootIsPrerendering = $1e79381dc3a64a75$var$checkIfRootIsPrerendering(root, lanes);
    a: do try {
        if (0 !== $1e79381dc3a64a75$var$workInProgressSuspendedReason && null !== $1e79381dc3a64a75$var$workInProgress) {
            lanes = $1e79381dc3a64a75$var$workInProgress;
            var thrownValue = $1e79381dc3a64a75$var$workInProgressThrownValue;
            b: switch($1e79381dc3a64a75$var$workInProgressSuspendedReason){
                case 1:
                    $1e79381dc3a64a75$var$workInProgressSuspendedReason = 0;
                    $1e79381dc3a64a75$var$workInProgressThrownValue = null;
                    $1e79381dc3a64a75$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 1);
                    break;
                case 2:
                case 9:
                    if ($1e79381dc3a64a75$var$isThenableResolved(thrownValue)) {
                        $1e79381dc3a64a75$var$workInProgressSuspendedReason = 0;
                        $1e79381dc3a64a75$var$workInProgressThrownValue = null;
                        $1e79381dc3a64a75$var$replaySuspendedUnitOfWork(lanes);
                        break;
                    }
                    lanes = function() {
                        2 !== $1e79381dc3a64a75$var$workInProgressSuspendedReason && 9 !== $1e79381dc3a64a75$var$workInProgressSuspendedReason || $1e79381dc3a64a75$var$workInProgressRoot !== root || ($1e79381dc3a64a75$var$workInProgressSuspendedReason = 7);
                        $1e79381dc3a64a75$var$ensureRootIsScheduled(root);
                    };
                    thrownValue.then(lanes, lanes);
                    break a;
                case 3:
                    $1e79381dc3a64a75$var$workInProgressSuspendedReason = 7;
                    break a;
                case 4:
                    $1e79381dc3a64a75$var$workInProgressSuspendedReason = 5;
                    break a;
                case 7:
                    $1e79381dc3a64a75$var$isThenableResolved(thrownValue) ? ($1e79381dc3a64a75$var$workInProgressSuspendedReason = 0, $1e79381dc3a64a75$var$workInProgressThrownValue = null, $1e79381dc3a64a75$var$replaySuspendedUnitOfWork(lanes)) : ($1e79381dc3a64a75$var$workInProgressSuspendedReason = 0, $1e79381dc3a64a75$var$workInProgressThrownValue = null, $1e79381dc3a64a75$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 7));
                    break;
                case 5:
                    var resource = null;
                    switch($1e79381dc3a64a75$var$workInProgress.tag){
                        case 26:
                            resource = $1e79381dc3a64a75$var$workInProgress.memoizedState;
                        case 5:
                        case 27:
                            var hostFiber = $1e79381dc3a64a75$var$workInProgress;
                            if (resource ? $1e79381dc3a64a75$var$preloadResource(resource) : hostFiber.stateNode.complete) {
                                $1e79381dc3a64a75$var$workInProgressSuspendedReason = 0;
                                $1e79381dc3a64a75$var$workInProgressThrownValue = null;
                                var sibling = hostFiber.sibling;
                                if (null !== sibling) $1e79381dc3a64a75$var$workInProgress = sibling;
                                else {
                                    var returnFiber = hostFiber.return;
                                    null !== returnFiber ? ($1e79381dc3a64a75$var$workInProgress = returnFiber, $1e79381dc3a64a75$var$completeUnitOfWork(returnFiber)) : $1e79381dc3a64a75$var$workInProgress = null;
                                }
                                break b;
                            }
                    }
                    $1e79381dc3a64a75$var$workInProgressSuspendedReason = 0;
                    $1e79381dc3a64a75$var$workInProgressThrownValue = null;
                    $1e79381dc3a64a75$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 5);
                    break;
                case 6:
                    $1e79381dc3a64a75$var$workInProgressSuspendedReason = 0;
                    $1e79381dc3a64a75$var$workInProgressThrownValue = null;
                    $1e79381dc3a64a75$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 6);
                    break;
                case 8:
                    $1e79381dc3a64a75$var$resetWorkInProgressStack();
                    $1e79381dc3a64a75$var$workInProgressRootExitStatus = 6;
                    break a;
                default:
                    throw Error($1e79381dc3a64a75$var$formatProdErrorMessage(462));
            }
        }
        $1e79381dc3a64a75$var$workLoopConcurrentByScheduler();
        break;
    } catch (thrownValue$186) {
        $1e79381dc3a64a75$var$handleThrow(root, thrownValue$186);
    }
    while (1);
    $1e79381dc3a64a75$var$lastContextDependency = $1e79381dc3a64a75$var$currentlyRenderingFiber$1 = null;
    $1e79381dc3a64a75$var$ReactSharedInternals.H = prevDispatcher;
    $1e79381dc3a64a75$var$ReactSharedInternals.A = prevAsyncDispatcher;
    $1e79381dc3a64a75$var$executionContext = prevExecutionContext;
    if (null !== $1e79381dc3a64a75$var$workInProgress) return 0;
    $1e79381dc3a64a75$var$workInProgressRoot = null;
    $1e79381dc3a64a75$var$workInProgressRootRenderLanes = 0;
    $1e79381dc3a64a75$var$finishQueueingConcurrentUpdates();
    return $1e79381dc3a64a75$var$workInProgressRootExitStatus;
}
function $1e79381dc3a64a75$var$workLoopConcurrentByScheduler() {
    for(; null !== $1e79381dc3a64a75$var$workInProgress && !$1e79381dc3a64a75$var$shouldYield();)$1e79381dc3a64a75$var$performUnitOfWork($1e79381dc3a64a75$var$workInProgress);
}
function $1e79381dc3a64a75$var$performUnitOfWork(unitOfWork) {
    var next = $1e79381dc3a64a75$var$beginWork(unitOfWork.alternate, unitOfWork, $1e79381dc3a64a75$var$entangledRenderLanes);
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $1e79381dc3a64a75$var$completeUnitOfWork(unitOfWork) : $1e79381dc3a64a75$var$workInProgress = next;
}
function $1e79381dc3a64a75$var$replaySuspendedUnitOfWork(unitOfWork) {
    var next = unitOfWork;
    var current = next.alternate;
    switch(next.tag){
        case 15:
        case 0:
            next = $1e79381dc3a64a75$var$replayFunctionComponent(current, next, next.pendingProps, next.type, void 0, $1e79381dc3a64a75$var$workInProgressRootRenderLanes);
            break;
        case 11:
            next = $1e79381dc3a64a75$var$replayFunctionComponent(current, next, next.pendingProps, next.type.render, next.ref, $1e79381dc3a64a75$var$workInProgressRootRenderLanes);
            break;
        case 5:
            $1e79381dc3a64a75$var$resetHooksOnUnwind(next);
            var fiber = next;
            fiber === $1e79381dc3a64a75$var$hydrationParentFiber && ($1e79381dc3a64a75$var$isHydrating ? ($1e79381dc3a64a75$var$popToNextHostParent(fiber), 5 === fiber.tag && null != fiber.stateNode && ($1e79381dc3a64a75$var$nextHydratableInstance = fiber.stateNode)) : ($1e79381dc3a64a75$var$popToNextHostParent(fiber), $1e79381dc3a64a75$var$isHydrating = !0));
        default:
            $1e79381dc3a64a75$var$unwindInterruptedWork(current, next), next = $1e79381dc3a64a75$var$workInProgress = $1e79381dc3a64a75$var$resetWorkInProgress(next, $1e79381dc3a64a75$var$entangledRenderLanes), next = $1e79381dc3a64a75$var$beginWork(current, next, $1e79381dc3a64a75$var$entangledRenderLanes);
    }
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $1e79381dc3a64a75$var$completeUnitOfWork(unitOfWork) : $1e79381dc3a64a75$var$workInProgress = next;
}
function $1e79381dc3a64a75$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, suspendedReason) {
    $1e79381dc3a64a75$var$lastContextDependency = $1e79381dc3a64a75$var$currentlyRenderingFiber$1 = null;
    $1e79381dc3a64a75$var$resetHooksOnUnwind(unitOfWork);
    $1e79381dc3a64a75$var$thenableState$1 = null;
    $1e79381dc3a64a75$var$thenableIndexCounter$1 = 0;
    var returnFiber = unitOfWork.return;
    try {
        if ($1e79381dc3a64a75$var$throwException(root, returnFiber, unitOfWork, thrownValue, $1e79381dc3a64a75$var$workInProgressRootRenderLanes)) {
            $1e79381dc3a64a75$var$workInProgressRootExitStatus = 1;
            $1e79381dc3a64a75$var$logUncaughtError(root, $1e79381dc3a64a75$var$createCapturedValueAtFiber(thrownValue, root.current));
            $1e79381dc3a64a75$var$workInProgress = null;
            return;
        }
    } catch (error) {
        if (null !== returnFiber) throw $1e79381dc3a64a75$var$workInProgress = returnFiber, error;
        $1e79381dc3a64a75$var$workInProgressRootExitStatus = 1;
        $1e79381dc3a64a75$var$logUncaughtError(root, $1e79381dc3a64a75$var$createCapturedValueAtFiber(thrownValue, root.current));
        $1e79381dc3a64a75$var$workInProgress = null;
        return;
    }
    if (unitOfWork.flags & 32768) {
        if ($1e79381dc3a64a75$var$isHydrating || 1 === suspendedReason) root = !0;
        else if ($1e79381dc3a64a75$var$workInProgressRootIsPrerendering || 0 !== ($1e79381dc3a64a75$var$workInProgressRootRenderLanes & 536870912)) root = !1;
        else if ($1e79381dc3a64a75$var$workInProgressRootDidSkipSuspendedSiblings = root = !0, 2 === suspendedReason || 9 === suspendedReason || 3 === suspendedReason || 6 === suspendedReason) suspendedReason = $1e79381dc3a64a75$var$suspenseHandlerStackCursor.current, null !== suspendedReason && 13 === suspendedReason.tag && (suspendedReason.flags |= 16384);
        $1e79381dc3a64a75$var$unwindUnitOfWork(unitOfWork, root);
    } else $1e79381dc3a64a75$var$completeUnitOfWork(unitOfWork);
}
function $1e79381dc3a64a75$var$completeUnitOfWork(unitOfWork) {
    var completedWork = unitOfWork;
    do {
        if (0 !== (completedWork.flags & 32768)) {
            $1e79381dc3a64a75$var$unwindUnitOfWork(completedWork, $1e79381dc3a64a75$var$workInProgressRootDidSkipSuspendedSiblings);
            return;
        }
        unitOfWork = completedWork.return;
        var next = $1e79381dc3a64a75$var$completeWork(completedWork.alternate, completedWork, $1e79381dc3a64a75$var$entangledRenderLanes);
        if (null !== next) {
            $1e79381dc3a64a75$var$workInProgress = next;
            return;
        }
        completedWork = completedWork.sibling;
        if (null !== completedWork) {
            $1e79381dc3a64a75$var$workInProgress = completedWork;
            return;
        }
        $1e79381dc3a64a75$var$workInProgress = completedWork = unitOfWork;
    }while (null !== completedWork);
    0 === $1e79381dc3a64a75$var$workInProgressRootExitStatus && ($1e79381dc3a64a75$var$workInProgressRootExitStatus = 5);
}
function $1e79381dc3a64a75$var$unwindUnitOfWork(unitOfWork, skipSiblings) {
    do {
        var next = $1e79381dc3a64a75$var$unwindWork(unitOfWork.alternate, unitOfWork);
        if (null !== next) {
            next.flags &= 32767;
            $1e79381dc3a64a75$var$workInProgress = next;
            return;
        }
        next = unitOfWork.return;
        null !== next && (next.flags |= 32768, next.subtreeFlags = 0, next.deletions = null);
        if (!skipSiblings && (unitOfWork = unitOfWork.sibling, null !== unitOfWork)) {
            $1e79381dc3a64a75$var$workInProgress = unitOfWork;
            return;
        }
        $1e79381dc3a64a75$var$workInProgress = unitOfWork = next;
    }while (null !== unitOfWork);
    $1e79381dc3a64a75$var$workInProgressRootExitStatus = 6;
    $1e79381dc3a64a75$var$workInProgress = null;
}
function $1e79381dc3a64a75$var$completeRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedState) {
    root.cancelPendingCommit = null;
    do $1e79381dc3a64a75$var$flushPendingEffects();
    while (0 !== $1e79381dc3a64a75$var$pendingEffectsStatus);
    if (0 !== ($1e79381dc3a64a75$var$executionContext & 6)) throw Error($1e79381dc3a64a75$var$formatProdErrorMessage(327));
    if (null !== finishedWork) {
        if (finishedWork === root.current) throw Error($1e79381dc3a64a75$var$formatProdErrorMessage(177));
        root === $1e79381dc3a64a75$var$workInProgressRoot && ($1e79381dc3a64a75$var$workInProgress = $1e79381dc3a64a75$var$workInProgressRoot = null, $1e79381dc3a64a75$var$workInProgressRootRenderLanes = 0);
        $1e79381dc3a64a75$var$pendingFinishedWork = finishedWork;
        $1e79381dc3a64a75$var$pendingEffectsRoot = root;
        $1e79381dc3a64a75$var$pendingEffectsLanes = lanes;
        $1e79381dc3a64a75$var$pendingPassiveTransitions = transitions;
        $1e79381dc3a64a75$var$pendingRecoverableErrors = recoverableErrors;
        $1e79381dc3a64a75$var$commitRoot(root, finishedWork, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, suspendedState);
    }
}
function $1e79381dc3a64a75$var$commitRoot(root, finishedWork, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, suspendedState) {
    var remainingLanes = finishedWork.lanes | finishedWork.childLanes;
    $1e79381dc3a64a75$var$pendingEffectsRemainingLanes = remainingLanes;
    remainingLanes |= $1e79381dc3a64a75$var$concurrentlyUpdatedLanes;
    $1e79381dc3a64a75$var$markRootFinished(root, lanes, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes);
    $1e79381dc3a64a75$var$pendingViewTransitionEvents = null;
    (lanes & 335544064) === lanes ? ($1e79381dc3a64a75$var$pendingTransitionTypes = $1e79381dc3a64a75$var$claimQueuedTransitionTypes(root), spawnedLane = 10262) : ($1e79381dc3a64a75$var$pendingTransitionTypes = null, spawnedLane = 10256);
    0 !== (finishedWork.subtreeFlags & spawnedLane) || 0 !== (finishedWork.flags & spawnedLane) ? (root.callbackNode = null, root.callbackPriority = 0, $1e79381dc3a64a75$var$scheduleCallback$1($1e79381dc3a64a75$var$NormalPriority$1, function() {
        $1e79381dc3a64a75$var$flushPassiveEffects();
        return null;
    })) : (root.callbackNode = null, root.callbackPriority = 0);
    $1e79381dc3a64a75$var$shouldStartViewTransition = !1;
    spawnedLane = 0 !== (finishedWork.flags & 13878);
    if (0 !== (finishedWork.subtreeFlags & 13878) || spawnedLane) {
        spawnedLane = $1e79381dc3a64a75$var$ReactSharedInternals.T;
        $1e79381dc3a64a75$var$ReactSharedInternals.T = null;
        updatedLanes = $1e79381dc3a64a75$var$ReactDOMSharedInternals.p;
        $1e79381dc3a64a75$var$ReactDOMSharedInternals.p = 2;
        suspendedRetryLanes = $1e79381dc3a64a75$var$executionContext;
        $1e79381dc3a64a75$var$executionContext |= 4;
        try {
            $1e79381dc3a64a75$var$commitBeforeMutationEffects(root, finishedWork, lanes);
        } finally{
            $1e79381dc3a64a75$var$executionContext = suspendedRetryLanes, $1e79381dc3a64a75$var$ReactDOMSharedInternals.p = updatedLanes, $1e79381dc3a64a75$var$ReactSharedInternals.T = spawnedLane;
        }
    }
    $1e79381dc3a64a75$var$pendingEffectsStatus = 1;
    $1e79381dc3a64a75$var$shouldStartViewTransition ? $1e79381dc3a64a75$var$pendingViewTransition = $1e79381dc3a64a75$var$startViewTransition(suspendedState, root.containerInfo, $1e79381dc3a64a75$var$pendingTransitionTypes, $1e79381dc3a64a75$var$flushMutationEffects, $1e79381dc3a64a75$var$flushLayoutEffects, $1e79381dc3a64a75$var$flushAfterMutationEffects, $1e79381dc3a64a75$var$flushSpawnedWork, $1e79381dc3a64a75$var$flushPassiveEffects, $1e79381dc3a64a75$var$reportViewTransitionError, null, null) : ($1e79381dc3a64a75$var$flushMutationEffects(), $1e79381dc3a64a75$var$flushLayoutEffects(), $1e79381dc3a64a75$var$flushSpawnedWork());
}
function $1e79381dc3a64a75$var$reportViewTransitionError(error) {
    if (0 !== $1e79381dc3a64a75$var$pendingEffectsStatus) {
        var onRecoverableError = $1e79381dc3a64a75$var$pendingEffectsRoot.onRecoverableError;
        onRecoverableError(error, {
            componentStack: null
        });
    }
}
function $1e79381dc3a64a75$var$flushAfterMutationEffects() {
    3 === $1e79381dc3a64a75$var$pendingEffectsStatus && ($1e79381dc3a64a75$var$pendingEffectsStatus = 0, $1e79381dc3a64a75$var$commitAfterMutationEffectsOnFiber($1e79381dc3a64a75$var$pendingFinishedWork, $1e79381dc3a64a75$var$pendingEffectsRoot), $1e79381dc3a64a75$var$pendingEffectsStatus = 4);
}
function $1e79381dc3a64a75$var$flushMutationEffects() {
    if (1 === $1e79381dc3a64a75$var$pendingEffectsStatus) {
        $1e79381dc3a64a75$var$pendingEffectsStatus = 0;
        var root = $1e79381dc3a64a75$var$pendingEffectsRoot, finishedWork = $1e79381dc3a64a75$var$pendingFinishedWork, lanes = $1e79381dc3a64a75$var$pendingEffectsLanes, rootMutationHasEffect = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || rootMutationHasEffect) {
            rootMutationHasEffect = $1e79381dc3a64a75$var$ReactSharedInternals.T;
            $1e79381dc3a64a75$var$ReactSharedInternals.T = null;
            var previousPriority = $1e79381dc3a64a75$var$ReactDOMSharedInternals.p;
            $1e79381dc3a64a75$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $1e79381dc3a64a75$var$executionContext;
            $1e79381dc3a64a75$var$executionContext |= 4;
            try {
                $1e79381dc3a64a75$var$inUpdateViewTransition = $1e79381dc3a64a75$var$rootViewTransitionAffected = !1;
                $1e79381dc3a64a75$var$commitMutationEffectsOnFiber(finishedWork, root, lanes);
                lanes = $1e79381dc3a64a75$var$selectionInformation;
                var curFocusedElem = $1e79381dc3a64a75$var$getActiveElementDeep(root.containerInfo), priorFocusedElem = lanes.focusedElem, priorSelectionRange = lanes.selectionRange;
                if (curFocusedElem !== priorFocusedElem && priorFocusedElem && priorFocusedElem.ownerDocument && $1e79381dc3a64a75$var$containsNode(priorFocusedElem.ownerDocument.documentElement, priorFocusedElem)) {
                    if (null !== priorSelectionRange && $1e79381dc3a64a75$var$hasSelectionCapabilities(priorFocusedElem)) {
                        var start = priorSelectionRange.start, end = priorSelectionRange.end;
                        void 0 === end && (end = start);
                        if ("selectionStart" in priorFocusedElem) priorFocusedElem.selectionStart = start, priorFocusedElem.selectionEnd = Math.min(end, priorFocusedElem.value.length);
                        else {
                            var doc = priorFocusedElem.ownerDocument || document, win = doc && doc.defaultView || window;
                            if (win.getSelection) {
                                var selection = win.getSelection(), length = priorFocusedElem.textContent.length, start$jscomp$0 = Math.min(priorSelectionRange.start, length), end$jscomp$0 = void 0 === priorSelectionRange.end ? start$jscomp$0 : Math.min(priorSelectionRange.end, length);
                                !selection.extend && start$jscomp$0 > end$jscomp$0 && (curFocusedElem = end$jscomp$0, end$jscomp$0 = start$jscomp$0, start$jscomp$0 = curFocusedElem);
                                var startMarker = $1e79381dc3a64a75$var$getNodeForCharacterOffset(priorFocusedElem, start$jscomp$0), endMarker = $1e79381dc3a64a75$var$getNodeForCharacterOffset(priorFocusedElem, end$jscomp$0);
                                if (startMarker && endMarker && (1 !== selection.rangeCount || selection.anchorNode !== startMarker.node || selection.anchorOffset !== startMarker.offset || selection.focusNode !== endMarker.node || selection.focusOffset !== endMarker.offset)) {
                                    var range = doc.createRange();
                                    range.setStart(startMarker.node, startMarker.offset);
                                    selection.removeAllRanges();
                                    start$jscomp$0 > end$jscomp$0 ? (selection.addRange(range), selection.extend(endMarker.node, endMarker.offset)) : (range.setEnd(endMarker.node, endMarker.offset), selection.addRange(range));
                                }
                            }
                        }
                    }
                    doc = [];
                    for(selection = priorFocusedElem; selection = selection.parentNode;)1 === selection.nodeType && doc.push({
                        element: selection,
                        left: selection.scrollLeft,
                        top: selection.scrollTop
                    });
                    "function" === typeof priorFocusedElem.focus && priorFocusedElem.focus();
                    for(priorFocusedElem = 0; priorFocusedElem < doc.length; priorFocusedElem++){
                        var info = doc[priorFocusedElem];
                        info.element.scrollLeft = info.left;
                        info.element.scrollTop = info.top;
                    }
                }
                $1e79381dc3a64a75$var$_enabled = !!$1e79381dc3a64a75$var$eventsEnabled;
                $1e79381dc3a64a75$var$selectionInformation = $1e79381dc3a64a75$var$eventsEnabled = null;
            } finally{
                $1e79381dc3a64a75$var$executionContext = prevExecutionContext, $1e79381dc3a64a75$var$ReactDOMSharedInternals.p = previousPriority, $1e79381dc3a64a75$var$ReactSharedInternals.T = rootMutationHasEffect;
            }
        }
        root.current = finishedWork;
        $1e79381dc3a64a75$var$pendingEffectsStatus = 2;
    }
}
function $1e79381dc3a64a75$var$flushLayoutEffects() {
    if (2 === $1e79381dc3a64a75$var$pendingEffectsStatus) {
        $1e79381dc3a64a75$var$pendingEffectsStatus = 0;
        var root = $1e79381dc3a64a75$var$pendingEffectsRoot, finishedWork = $1e79381dc3a64a75$var$pendingFinishedWork, rootHasLayoutEffect = 0 !== (finishedWork.flags & 8772);
        if (0 !== (finishedWork.subtreeFlags & 8772) || rootHasLayoutEffect) {
            rootHasLayoutEffect = $1e79381dc3a64a75$var$ReactSharedInternals.T;
            $1e79381dc3a64a75$var$ReactSharedInternals.T = null;
            var previousPriority = $1e79381dc3a64a75$var$ReactDOMSharedInternals.p;
            $1e79381dc3a64a75$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $1e79381dc3a64a75$var$executionContext;
            $1e79381dc3a64a75$var$executionContext |= 4;
            try {
                $1e79381dc3a64a75$var$commitLayoutEffectOnFiber(root, finishedWork.alternate, finishedWork);
            } finally{
                $1e79381dc3a64a75$var$executionContext = prevExecutionContext, $1e79381dc3a64a75$var$ReactDOMSharedInternals.p = previousPriority, $1e79381dc3a64a75$var$ReactSharedInternals.T = rootHasLayoutEffect;
            }
        }
        $1e79381dc3a64a75$var$pendingEffectsStatus = 3;
    }
}
function $1e79381dc3a64a75$var$flushSpawnedWork() {
    if (4 === $1e79381dc3a64a75$var$pendingEffectsStatus || 3 === $1e79381dc3a64a75$var$pendingEffectsStatus) {
        $1e79381dc3a64a75$var$pendingEffectsStatus = 0;
        var committedViewTransition = $1e79381dc3a64a75$var$pendingViewTransition;
        $1e79381dc3a64a75$var$pendingViewTransition = null;
        $1e79381dc3a64a75$var$requestPaint();
        var root = $1e79381dc3a64a75$var$pendingEffectsRoot, finishedWork = $1e79381dc3a64a75$var$pendingFinishedWork, lanes = $1e79381dc3a64a75$var$pendingEffectsLanes, recoverableErrors = $1e79381dc3a64a75$var$pendingRecoverableErrors, passiveSubtreeMask = (lanes & 335544064) === lanes ? 10262 : 10256;
        0 !== (finishedWork.subtreeFlags & passiveSubtreeMask) || 0 !== (finishedWork.flags & passiveSubtreeMask) ? $1e79381dc3a64a75$var$pendingEffectsStatus = 5 : ($1e79381dc3a64a75$var$pendingEffectsStatus = 0, $1e79381dc3a64a75$var$pendingFinishedWork = $1e79381dc3a64a75$var$pendingEffectsRoot = null, $1e79381dc3a64a75$var$releaseRootPooledCache(root, root.pendingLanes));
        passiveSubtreeMask = root.pendingLanes;
        0 === passiveSubtreeMask && ($1e79381dc3a64a75$var$legacyErrorBoundariesThatAlreadyFailed = null);
        $1e79381dc3a64a75$var$lanesToEventPriority(lanes);
        finishedWork = finishedWork.stateNode;
        if ($1e79381dc3a64a75$var$injectedHook && "function" === typeof $1e79381dc3a64a75$var$injectedHook.onCommitFiberRoot) try {
            $1e79381dc3a64a75$var$injectedHook.onCommitFiberRoot($1e79381dc3a64a75$var$rendererID, finishedWork, void 0, 128 === (finishedWork.current.flags & 128));
        } catch (err) {}
        if (null !== recoverableErrors) {
            finishedWork = $1e79381dc3a64a75$var$ReactSharedInternals.T;
            passiveSubtreeMask = $1e79381dc3a64a75$var$ReactDOMSharedInternals.p;
            $1e79381dc3a64a75$var$ReactDOMSharedInternals.p = 2;
            $1e79381dc3a64a75$var$ReactSharedInternals.T = null;
            try {
                for(var onRecoverableError = root.onRecoverableError, i = 0; i < recoverableErrors.length; i++){
                    var recoverableError = recoverableErrors[i];
                    onRecoverableError(recoverableError.value, {
                        componentStack: recoverableError.stack
                    });
                }
            } finally{
                $1e79381dc3a64a75$var$ReactSharedInternals.T = finishedWork, $1e79381dc3a64a75$var$ReactDOMSharedInternals.p = passiveSubtreeMask;
            }
        }
        recoverableErrors = $1e79381dc3a64a75$var$pendingViewTransitionEvents;
        onRecoverableError = $1e79381dc3a64a75$var$pendingTransitionTypes;
        $1e79381dc3a64a75$var$pendingTransitionTypes = null;
        if (null !== recoverableErrors && ($1e79381dc3a64a75$var$pendingViewTransitionEvents = null, null === onRecoverableError && (onRecoverableError = []), null !== committedViewTransition)) for(recoverableError = 0; recoverableError < recoverableErrors.length; recoverableError++)finishedWork = (0, recoverableErrors[recoverableError])(onRecoverableError), void 0 !== finishedWork && committedViewTransition.finished.finally(finishedWork);
        0 !== ($1e79381dc3a64a75$var$pendingEffectsLanes & 3) && $1e79381dc3a64a75$var$flushPendingEffects();
        $1e79381dc3a64a75$var$ensureRootIsScheduled(root);
        passiveSubtreeMask = root.pendingLanes;
        0 !== (lanes & 261930) && 0 !== (passiveSubtreeMask & 42) ? root === $1e79381dc3a64a75$var$rootWithNestedUpdates ? $1e79381dc3a64a75$var$nestedUpdateCount++ : ($1e79381dc3a64a75$var$nestedUpdateCount = 0, $1e79381dc3a64a75$var$rootWithNestedUpdates = root) : ($1e79381dc3a64a75$var$nestedUpdateCount = 0, $1e79381dc3a64a75$var$rootWithNestedUpdates = null);
        $1e79381dc3a64a75$var$flushSyncWorkAcrossRoots_impl(0, !1);
    }
}
function $1e79381dc3a64a75$var$releaseRootPooledCache(root, remainingLanes) {
    0 === (root.pooledCacheLanes &= remainingLanes) && (remainingLanes = root.pooledCache, null != remainingLanes && (root.pooledCache = null, $1e79381dc3a64a75$var$releaseCache(remainingLanes)));
}
function $1e79381dc3a64a75$var$flushPendingEffects() {
    null !== $1e79381dc3a64a75$var$pendingViewTransition && ($1e79381dc3a64a75$var$pendingViewTransition.skipTransition(), $1e79381dc3a64a75$var$pendingViewTransition = null);
    $1e79381dc3a64a75$var$flushMutationEffects();
    $1e79381dc3a64a75$var$flushLayoutEffects();
    $1e79381dc3a64a75$var$flushSpawnedWork();
    return $1e79381dc3a64a75$var$flushPassiveEffects();
}
function $1e79381dc3a64a75$var$flushPassiveEffects() {
    if (5 !== $1e79381dc3a64a75$var$pendingEffectsStatus) return !1;
    var root = $1e79381dc3a64a75$var$pendingEffectsRoot, remainingLanes = $1e79381dc3a64a75$var$pendingEffectsRemainingLanes;
    $1e79381dc3a64a75$var$pendingEffectsRemainingLanes = 0;
    var renderPriority = $1e79381dc3a64a75$var$lanesToEventPriority($1e79381dc3a64a75$var$pendingEffectsLanes), prevTransition = $1e79381dc3a64a75$var$ReactSharedInternals.T, previousPriority = $1e79381dc3a64a75$var$ReactDOMSharedInternals.p;
    try {
        $1e79381dc3a64a75$var$ReactDOMSharedInternals.p = 32 > renderPriority ? 32 : renderPriority;
        $1e79381dc3a64a75$var$ReactSharedInternals.T = null;
        renderPriority = $1e79381dc3a64a75$var$pendingPassiveTransitions;
        $1e79381dc3a64a75$var$pendingPassiveTransitions = null;
        var root$jscomp$0 = $1e79381dc3a64a75$var$pendingEffectsRoot, lanes = $1e79381dc3a64a75$var$pendingEffectsLanes;
        $1e79381dc3a64a75$var$pendingEffectsStatus = 0;
        $1e79381dc3a64a75$var$pendingFinishedWork = $1e79381dc3a64a75$var$pendingEffectsRoot = null;
        $1e79381dc3a64a75$var$pendingEffectsLanes = 0;
        if (0 !== ($1e79381dc3a64a75$var$executionContext & 6)) throw Error($1e79381dc3a64a75$var$formatProdErrorMessage(331));
        var prevExecutionContext = $1e79381dc3a64a75$var$executionContext;
        $1e79381dc3a64a75$var$executionContext |= 4;
        $1e79381dc3a64a75$var$commitPassiveUnmountOnFiber(root$jscomp$0.current);
        $1e79381dc3a64a75$var$commitPassiveMountOnFiber(root$jscomp$0, root$jscomp$0.current, lanes, renderPriority);
        $1e79381dc3a64a75$var$executionContext = prevExecutionContext;
        $1e79381dc3a64a75$var$flushSyncWorkAcrossRoots_impl(0, !1);
        if ($1e79381dc3a64a75$var$injectedHook && "function" === typeof $1e79381dc3a64a75$var$injectedHook.onPostCommitFiberRoot) try {
            $1e79381dc3a64a75$var$injectedHook.onPostCommitFiberRoot($1e79381dc3a64a75$var$rendererID, root$jscomp$0);
        } catch (err) {}
        return !0;
    } finally{
        $1e79381dc3a64a75$var$ReactDOMSharedInternals.p = previousPriority, $1e79381dc3a64a75$var$ReactSharedInternals.T = prevTransition, $1e79381dc3a64a75$var$releaseRootPooledCache(root, remainingLanes);
    }
}
function $1e79381dc3a64a75$var$captureCommitPhaseErrorOnRoot(rootFiber, sourceFiber, error) {
    sourceFiber = $1e79381dc3a64a75$var$createCapturedValueAtFiber(error, sourceFiber);
    sourceFiber = $1e79381dc3a64a75$var$createRootErrorUpdate(rootFiber.stateNode, sourceFiber, 2);
    rootFiber = $1e79381dc3a64a75$var$enqueueUpdate(rootFiber, sourceFiber, 2);
    null !== rootFiber && ($1e79381dc3a64a75$var$markRootUpdated$1(rootFiber, 2), $1e79381dc3a64a75$var$ensureRootIsScheduled(rootFiber));
}
function $1e79381dc3a64a75$var$captureCommitPhaseError(sourceFiber, nearestMountedAncestor, error) {
    if (3 === sourceFiber.tag) $1e79381dc3a64a75$var$captureCommitPhaseErrorOnRoot(sourceFiber, sourceFiber, error);
    else for(; null !== nearestMountedAncestor;){
        if (3 === nearestMountedAncestor.tag) {
            $1e79381dc3a64a75$var$captureCommitPhaseErrorOnRoot(nearestMountedAncestor, sourceFiber, error);
            break;
        } else if (1 === nearestMountedAncestor.tag) {
            var instance = nearestMountedAncestor.stateNode;
            if ("function" === typeof nearestMountedAncestor.type.getDerivedStateFromError || "function" === typeof instance.componentDidCatch && (null === $1e79381dc3a64a75$var$legacyErrorBoundariesThatAlreadyFailed || !$1e79381dc3a64a75$var$legacyErrorBoundariesThatAlreadyFailed.has(instance))) {
                sourceFiber = $1e79381dc3a64a75$var$createCapturedValueAtFiber(error, sourceFiber);
                error = $1e79381dc3a64a75$var$createClassErrorUpdate(2);
                instance = $1e79381dc3a64a75$var$enqueueUpdate(nearestMountedAncestor, error, 2);
                null !== instance && ($1e79381dc3a64a75$var$initializeClassErrorUpdate(error, instance, nearestMountedAncestor, sourceFiber), $1e79381dc3a64a75$var$markRootUpdated$1(instance, 2), $1e79381dc3a64a75$var$ensureRootIsScheduled(instance));
                break;
            }
        }
        nearestMountedAncestor = nearestMountedAncestor.return;
    }
}
function $1e79381dc3a64a75$var$attachPingListener(root, wakeable, lanes) {
    var pingCache = root.pingCache;
    if (null === pingCache) {
        pingCache = root.pingCache = new $1e79381dc3a64a75$var$PossiblyWeakMap();
        var threadIDs = new Set();
        pingCache.set(wakeable, threadIDs);
    } else threadIDs = pingCache.get(wakeable), void 0 === threadIDs && (threadIDs = new Set(), pingCache.set(wakeable, threadIDs));
    threadIDs.has(lanes) || ($1e79381dc3a64a75$var$workInProgressRootDidAttachPingListener = !0, threadIDs.add(lanes), root = $1e79381dc3a64a75$var$pingSuspendedRoot.bind(null, root, wakeable, lanes), wakeable.then(root, root));
}
function $1e79381dc3a64a75$var$pingSuspendedRoot(root, wakeable, pingedLanes) {
    var pingCache = root.pingCache;
    null !== pingCache && pingCache.delete(wakeable);
    root.pingedLanes |= root.suspendedLanes & pingedLanes;
    root.warmLanes &= ~pingedLanes;
    $1e79381dc3a64a75$var$workInProgressRoot === root && ($1e79381dc3a64a75$var$workInProgressRootRenderLanes & pingedLanes) === pingedLanes && (4 === $1e79381dc3a64a75$var$workInProgressRootExitStatus || 3 === $1e79381dc3a64a75$var$workInProgressRootExitStatus && ($1e79381dc3a64a75$var$workInProgressRootRenderLanes & 62914560) === $1e79381dc3a64a75$var$workInProgressRootRenderLanes && 300 > $1e79381dc3a64a75$var$now() - $1e79381dc3a64a75$var$globalMostRecentFallbackTime ? 0 === ($1e79381dc3a64a75$var$executionContext & 2) ? $1e79381dc3a64a75$var$prepareFreshStack(root, 0) : $1e79381dc3a64a75$var$workInProgressRootPingedLanes |= pingedLanes : $1e79381dc3a64a75$var$workInProgressRootPingedLanes |= pingedLanes, $1e79381dc3a64a75$var$workInProgressSuspendedRetryLanes === $1e79381dc3a64a75$var$workInProgressRootRenderLanes && ($1e79381dc3a64a75$var$workInProgressSuspendedRetryLanes = 0));
    $1e79381dc3a64a75$var$ensureRootIsScheduled(root);
}
function $1e79381dc3a64a75$var$retryTimedOutBoundary(boundaryFiber, retryLane) {
    0 === retryLane && (retryLane = $1e79381dc3a64a75$var$claimNextRetryLane());
    boundaryFiber = $1e79381dc3a64a75$var$enqueueConcurrentRenderForLane(boundaryFiber, retryLane);
    null !== boundaryFiber && ($1e79381dc3a64a75$var$markRootUpdated$1(boundaryFiber, retryLane), $1e79381dc3a64a75$var$ensureRootIsScheduled(boundaryFiber));
}
function $1e79381dc3a64a75$var$retryDehydratedSuspenseBoundary(boundaryFiber) {
    var suspenseState = boundaryFiber.memoizedState, retryLane = 0;
    null !== suspenseState && (retryLane = suspenseState.retryLane);
    $1e79381dc3a64a75$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $1e79381dc3a64a75$var$resolveRetryWakeable(boundaryFiber, wakeable) {
    var retryLane = 0;
    switch(boundaryFiber.tag){
        case 31:
        case 13:
            var retryCache = boundaryFiber.stateNode;
            var suspenseState = boundaryFiber.memoizedState;
            null !== suspenseState && (retryLane = suspenseState.retryLane);
            break;
        case 19:
            retryCache = boundaryFiber.stateNode;
            break;
        case 22:
            retryCache = boundaryFiber.stateNode._retryCache;
            break;
        default:
            throw Error($1e79381dc3a64a75$var$formatProdErrorMessage(314));
    }
    null !== retryCache && retryCache.delete(wakeable);
    $1e79381dc3a64a75$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $1e79381dc3a64a75$var$scheduleCallback$1(priorityLevel, callback) {
    return $1e79381dc3a64a75$var$scheduleCallback$3(priorityLevel, callback);
}
var $1e79381dc3a64a75$var$firstScheduledRoot = null, $1e79381dc3a64a75$var$lastScheduledRoot = null, $1e79381dc3a64a75$var$didScheduleMicrotask = !1, $1e79381dc3a64a75$var$mightHavePendingSyncWork = !1, $1e79381dc3a64a75$var$isFlushingWork = !1, $1e79381dc3a64a75$var$currentEventTransitionLane = 0;
function $1e79381dc3a64a75$var$ensureRootIsScheduled(root) {
    root !== $1e79381dc3a64a75$var$lastScheduledRoot && null === root.next && (null === $1e79381dc3a64a75$var$lastScheduledRoot ? $1e79381dc3a64a75$var$firstScheduledRoot = $1e79381dc3a64a75$var$lastScheduledRoot = root : $1e79381dc3a64a75$var$lastScheduledRoot = $1e79381dc3a64a75$var$lastScheduledRoot.next = root);
    $1e79381dc3a64a75$var$mightHavePendingSyncWork = !0;
    $1e79381dc3a64a75$var$didScheduleMicrotask || ($1e79381dc3a64a75$var$didScheduleMicrotask = !0, $1e79381dc3a64a75$var$scheduleImmediateRootScheduleTask());
}
function $1e79381dc3a64a75$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, onlyLegacy) {
    if (!$1e79381dc3a64a75$var$isFlushingWork && $1e79381dc3a64a75$var$mightHavePendingSyncWork) {
        $1e79381dc3a64a75$var$isFlushingWork = !0;
        do {
            var didPerformSomeWork = !1;
            for(var root$190 = $1e79381dc3a64a75$var$firstScheduledRoot; null !== root$190;){
                if (!onlyLegacy) {
                    if (0 !== syncTransitionLanes) {
                        var pendingLanes = root$190.pendingLanes;
                        if (0 === pendingLanes) var JSCompiler_inline_result = 0;
                        else {
                            var suspendedLanes = root$190.suspendedLanes, pingedLanes = root$190.pingedLanes;
                            JSCompiler_inline_result = (1 << 31 - $1e79381dc3a64a75$var$clz32(42 | syncTransitionLanes) + 1) - 1;
                            JSCompiler_inline_result &= pendingLanes & ~(suspendedLanes & ~pingedLanes);
                            JSCompiler_inline_result = JSCompiler_inline_result & 201326741 ? JSCompiler_inline_result & 201326741 | 1 : JSCompiler_inline_result ? JSCompiler_inline_result | 2 : 0;
                        }
                        0 !== JSCompiler_inline_result && (didPerformSomeWork = !0, $1e79381dc3a64a75$var$performSyncWorkOnRoot(root$190, JSCompiler_inline_result));
                    } else JSCompiler_inline_result = $1e79381dc3a64a75$var$workInProgressRootRenderLanes, JSCompiler_inline_result = $1e79381dc3a64a75$var$getNextLanes(root$190, root$190 === $1e79381dc3a64a75$var$workInProgressRoot ? JSCompiler_inline_result : 0, null !== root$190.cancelPendingCommit || -1 !== root$190.timeoutHandle), 0 === (JSCompiler_inline_result & 3) || $1e79381dc3a64a75$var$checkIfRootIsPrerendering(root$190, JSCompiler_inline_result) || (didPerformSomeWork = !0, $1e79381dc3a64a75$var$performSyncWorkOnRoot(root$190, JSCompiler_inline_result));
                }
                root$190 = root$190.next;
            }
        }while (didPerformSomeWork);
        $1e79381dc3a64a75$var$isFlushingWork = !1;
    }
}
function $1e79381dc3a64a75$var$processRootScheduleInImmediateTask() {
    $1e79381dc3a64a75$var$processRootScheduleInMicrotask();
}
function $1e79381dc3a64a75$var$processRootScheduleInMicrotask() {
    $1e79381dc3a64a75$var$mightHavePendingSyncWork = $1e79381dc3a64a75$var$didScheduleMicrotask = !1;
    var syncTransitionLanes = 0;
    0 !== $1e79381dc3a64a75$var$currentEventTransitionLane && $1e79381dc3a64a75$var$shouldAttemptEagerTransition() && (syncTransitionLanes = $1e79381dc3a64a75$var$currentEventTransitionLane);
    for(var currentTime = $1e79381dc3a64a75$var$now(), prev = null, root = $1e79381dc3a64a75$var$firstScheduledRoot; null !== root;){
        var next = root.next, nextLanes = $1e79381dc3a64a75$var$scheduleTaskForRootDuringMicrotask(root, currentTime);
        if (0 === nextLanes) root.next = null, null === prev ? $1e79381dc3a64a75$var$firstScheduledRoot = next : prev.next = next, null === next && ($1e79381dc3a64a75$var$lastScheduledRoot = prev);
        else if (prev = root, 0 !== syncTransitionLanes || 0 !== (nextLanes & 3)) $1e79381dc3a64a75$var$mightHavePendingSyncWork = !0;
        root = next;
    }
    0 !== $1e79381dc3a64a75$var$pendingEffectsStatus && 5 !== $1e79381dc3a64a75$var$pendingEffectsStatus || $1e79381dc3a64a75$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, !1);
    0 !== $1e79381dc3a64a75$var$currentEventTransitionLane && ($1e79381dc3a64a75$var$currentEventTransitionLane = 0);
}
function $1e79381dc3a64a75$var$scheduleTaskForRootDuringMicrotask(root, currentTime) {
    for(var suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes, expirationTimes = root.expirationTimes, lanes = root.pendingLanes & -62914561; 0 < lanes;){
        var index$5 = 31 - $1e79381dc3a64a75$var$clz32(lanes), lane = 1 << index$5, expirationTime = expirationTimes[index$5];
        if (-1 === expirationTime) {
            if (0 === (lane & suspendedLanes) || 0 !== (lane & pingedLanes)) expirationTimes[index$5] = $1e79381dc3a64a75$var$computeExpirationTime(lane, currentTime);
        } else expirationTime <= currentTime && (root.expiredLanes |= lane);
        lanes &= ~lane;
    }
    currentTime = $1e79381dc3a64a75$var$workInProgressRoot;
    suspendedLanes = $1e79381dc3a64a75$var$workInProgressRootRenderLanes;
    suspendedLanes = $1e79381dc3a64a75$var$getNextLanes(root, root === currentTime ? suspendedLanes : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    pingedLanes = root.callbackNode;
    if (0 === suspendedLanes || root === currentTime && (2 === $1e79381dc3a64a75$var$workInProgressSuspendedReason || 9 === $1e79381dc3a64a75$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) return null !== pingedLanes && null !== pingedLanes && $1e79381dc3a64a75$var$cancelCallback$1(pingedLanes), root.callbackNode = null, root.callbackPriority = 0;
    if (0 === (suspendedLanes & 3) || $1e79381dc3a64a75$var$checkIfRootIsPrerendering(root, suspendedLanes)) {
        currentTime = suspendedLanes & -suspendedLanes;
        if (currentTime === root.callbackPriority) return currentTime;
        null !== pingedLanes && $1e79381dc3a64a75$var$cancelCallback$1(pingedLanes);
        switch($1e79381dc3a64a75$var$lanesToEventPriority(suspendedLanes)){
            case 2:
            case 8:
                suspendedLanes = $1e79381dc3a64a75$var$UserBlockingPriority;
                break;
            case 32:
                suspendedLanes = $1e79381dc3a64a75$var$NormalPriority$1;
                break;
            case 268435456:
                suspendedLanes = $1e79381dc3a64a75$var$IdlePriority;
                break;
            default:
                suspendedLanes = $1e79381dc3a64a75$var$NormalPriority$1;
        }
        pingedLanes = $1e79381dc3a64a75$var$performWorkOnRootViaSchedulerTask.bind(null, root);
        suspendedLanes = $1e79381dc3a64a75$var$scheduleCallback$3(suspendedLanes, pingedLanes);
        root.callbackPriority = currentTime;
        root.callbackNode = suspendedLanes;
        return currentTime;
    }
    null !== pingedLanes && null !== pingedLanes && $1e79381dc3a64a75$var$cancelCallback$1(pingedLanes);
    root.callbackPriority = 2;
    root.callbackNode = null;
    return 2;
}
function $1e79381dc3a64a75$var$performWorkOnRootViaSchedulerTask(root, didTimeout) {
    if (0 !== $1e79381dc3a64a75$var$pendingEffectsStatus && 5 !== $1e79381dc3a64a75$var$pendingEffectsStatus) return root.callbackNode = null, root.callbackPriority = 0, null;
    var originalCallbackNode = root.callbackNode;
    if ($1e79381dc3a64a75$var$flushPendingEffects() && root.callbackNode !== originalCallbackNode) return null;
    var workInProgressRootRenderLanes$jscomp$0 = $1e79381dc3a64a75$var$workInProgressRootRenderLanes;
    workInProgressRootRenderLanes$jscomp$0 = $1e79381dc3a64a75$var$getNextLanes(root, root === $1e79381dc3a64a75$var$workInProgressRoot ? workInProgressRootRenderLanes$jscomp$0 : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    if (0 === workInProgressRootRenderLanes$jscomp$0) return null;
    $1e79381dc3a64a75$var$performWorkOnRoot(root, workInProgressRootRenderLanes$jscomp$0, didTimeout);
    $1e79381dc3a64a75$var$scheduleTaskForRootDuringMicrotask(root, $1e79381dc3a64a75$var$now());
    return null != root.callbackNode && root.callbackNode === originalCallbackNode ? $1e79381dc3a64a75$var$performWorkOnRootViaSchedulerTask.bind(null, root) : null;
}
function $1e79381dc3a64a75$var$performSyncWorkOnRoot(root, lanes) {
    if ($1e79381dc3a64a75$var$flushPendingEffects()) return null;
    $1e79381dc3a64a75$var$performWorkOnRoot(root, lanes, !0);
}
function $1e79381dc3a64a75$var$scheduleImmediateRootScheduleTask() {
    $1e79381dc3a64a75$var$scheduleMicrotask(function() {
        0 !== ($1e79381dc3a64a75$var$executionContext & 6) ? $1e79381dc3a64a75$var$scheduleCallback$3($1e79381dc3a64a75$var$ImmediatePriority, $1e79381dc3a64a75$var$processRootScheduleInImmediateTask) : $1e79381dc3a64a75$var$processRootScheduleInMicrotask();
    });
}
function $1e79381dc3a64a75$var$requestTransitionLane() {
    if (0 === $1e79381dc3a64a75$var$currentEventTransitionLane) {
        var actionScopeLane = $1e79381dc3a64a75$var$currentEntangledLane;
        0 === actionScopeLane && (actionScopeLane = $1e79381dc3a64a75$var$nextTransitionUpdateLane, $1e79381dc3a64a75$var$nextTransitionUpdateLane <<= 1, 0 === ($1e79381dc3a64a75$var$nextTransitionUpdateLane & 261888) && ($1e79381dc3a64a75$var$nextTransitionUpdateLane = 256));
        $1e79381dc3a64a75$var$currentEventTransitionLane = actionScopeLane;
    }
    return $1e79381dc3a64a75$var$currentEventTransitionLane;
}
function $1e79381dc3a64a75$var$coerceFormActionProp(actionProp) {
    return null == actionProp || "symbol" === typeof actionProp || "boolean" === typeof actionProp ? null : "function" === typeof actionProp ? actionProp : $1e79381dc3a64a75$var$sanitizeURL(actionProp);
}
function $1e79381dc3a64a75$var$extractEvents$1(dispatchQueue, domEventName, maybeTargetInst, nativeEvent, nativeEventTarget) {
    if ("submit" === domEventName && maybeTargetInst && maybeTargetInst.stateNode === nativeEventTarget) {
        var action = $1e79381dc3a64a75$var$coerceFormActionProp((nativeEventTarget[$1e79381dc3a64a75$var$internalPropsKey] || null).action), submitter = nativeEvent.submitter;
        submitter && (domEventName = (domEventName = submitter[$1e79381dc3a64a75$var$internalPropsKey] || null) ? $1e79381dc3a64a75$var$coerceFormActionProp(domEventName.formAction) : submitter.getAttribute("formAction"), null !== domEventName && (action = domEventName, submitter = null));
        var event = new $1e79381dc3a64a75$var$SyntheticEvent("action", "action", null, nativeEvent, nativeEventTarget);
        dispatchQueue.push({
            event: event,
            listeners: [
                {
                    instance: null,
                    listener: function() {
                        if (nativeEvent.defaultPrevented) {
                            if (0 !== $1e79381dc3a64a75$var$currentEventTransitionLane) {
                                var formData = new FormData(nativeEventTarget, submitter);
                                $1e79381dc3a64a75$var$startHostTransition(maybeTargetInst, {
                                    pending: !0,
                                    data: formData,
                                    method: nativeEventTarget.method,
                                    action: action
                                }, null, formData);
                            }
                        } else "function" === typeof action && (event.preventDefault(), formData = new FormData(nativeEventTarget, submitter), $1e79381dc3a64a75$var$startHostTransition(maybeTargetInst, {
                            pending: !0,
                            data: formData,
                            method: nativeEventTarget.method,
                            action: action
                        }, action, formData));
                    },
                    currentTarget: nativeEventTarget
                }
            ]
        });
    }
}
for(var $1e79381dc3a64a75$var$i$jscomp$inline_1667 = 0; $1e79381dc3a64a75$var$i$jscomp$inline_1667 < $1e79381dc3a64a75$var$simpleEventPluginEvents.length; $1e79381dc3a64a75$var$i$jscomp$inline_1667++){
    var $1e79381dc3a64a75$var$eventName$jscomp$inline_1668 = $1e79381dc3a64a75$var$simpleEventPluginEvents[$1e79381dc3a64a75$var$i$jscomp$inline_1667], $1e79381dc3a64a75$var$domEventName$jscomp$inline_1669 = $1e79381dc3a64a75$var$eventName$jscomp$inline_1668.toLowerCase(), $1e79381dc3a64a75$var$capitalizedEvent$jscomp$inline_1670 = $1e79381dc3a64a75$var$eventName$jscomp$inline_1668[0].toUpperCase() + $1e79381dc3a64a75$var$eventName$jscomp$inline_1668.slice(1);
    $1e79381dc3a64a75$var$registerSimpleEvent($1e79381dc3a64a75$var$domEventName$jscomp$inline_1669, "on" + $1e79381dc3a64a75$var$capitalizedEvent$jscomp$inline_1670);
}
$1e79381dc3a64a75$var$registerSimpleEvent($1e79381dc3a64a75$var$ANIMATION_END, "onAnimationEnd");
$1e79381dc3a64a75$var$registerSimpleEvent($1e79381dc3a64a75$var$ANIMATION_ITERATION, "onAnimationIteration");
$1e79381dc3a64a75$var$registerSimpleEvent($1e79381dc3a64a75$var$ANIMATION_START, "onAnimationStart");
$1e79381dc3a64a75$var$registerSimpleEvent("dblclick", "onDoubleClick");
$1e79381dc3a64a75$var$registerSimpleEvent("focusin", "onFocus");
$1e79381dc3a64a75$var$registerSimpleEvent("focusout", "onBlur");
$1e79381dc3a64a75$var$registerSimpleEvent($1e79381dc3a64a75$var$TRANSITION_RUN, "onTransitionRun");
$1e79381dc3a64a75$var$registerSimpleEvent($1e79381dc3a64a75$var$TRANSITION_START, "onTransitionStart");
$1e79381dc3a64a75$var$registerSimpleEvent($1e79381dc3a64a75$var$TRANSITION_CANCEL, "onTransitionCancel");
$1e79381dc3a64a75$var$registerSimpleEvent($1e79381dc3a64a75$var$TRANSITION_END, "onTransitionEnd");
$1e79381dc3a64a75$var$registerDirectEvent("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$1e79381dc3a64a75$var$registerDirectEvent("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$1e79381dc3a64a75$var$registerDirectEvent("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$1e79381dc3a64a75$var$registerDirectEvent("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$1e79381dc3a64a75$var$registerTwoPhaseEvent("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$1e79381dc3a64a75$var$registerTwoPhaseEvent("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$1e79381dc3a64a75$var$registerTwoPhaseEvent("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$1e79381dc3a64a75$var$registerTwoPhaseEvent("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$1e79381dc3a64a75$var$registerTwoPhaseEvent("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$1e79381dc3a64a75$var$registerTwoPhaseEvent("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $1e79381dc3a64a75$var$mediaEventTypes = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $1e79381dc3a64a75$var$nonDelegatedEvents = new Set("beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat($1e79381dc3a64a75$var$mediaEventTypes));
function $1e79381dc3a64a75$var$processDispatchQueue(dispatchQueue, eventSystemFlags) {
    eventSystemFlags = 0 !== (eventSystemFlags & 4);
    for(var i = 0; i < dispatchQueue.length; i++){
        var _dispatchQueue$i = dispatchQueue[i], event = _dispatchQueue$i.event;
        _dispatchQueue$i = _dispatchQueue$i.listeners;
        a: {
            var previousInstance = void 0;
            if (eventSystemFlags) for(var i$jscomp$0 = _dispatchQueue$i.length - 1; 0 <= i$jscomp$0; i$jscomp$0--){
                var _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0], instance = _dispatchListeners$i.instance, currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $1e79381dc3a64a75$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
            else for(i$jscomp$0 = 0; i$jscomp$0 < _dispatchQueue$i.length; i$jscomp$0++){
                _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0];
                instance = _dispatchListeners$i.instance;
                currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $1e79381dc3a64a75$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
        }
    }
}
function $1e79381dc3a64a75$var$listenToNonDelegatedEvent(domEventName, targetElement) {
    var JSCompiler_inline_result = targetElement[$1e79381dc3a64a75$var$internalEventHandlersKey];
    void 0 === JSCompiler_inline_result && (JSCompiler_inline_result = targetElement[$1e79381dc3a64a75$var$internalEventHandlersKey] = new Set());
    var listenerSetKey = domEventName + "__bubble";
    JSCompiler_inline_result.has(listenerSetKey) || ($1e79381dc3a64a75$var$addTrappedEventListener(targetElement, domEventName, 2, !1), JSCompiler_inline_result.add(listenerSetKey));
}
function $1e79381dc3a64a75$var$listenToNativeEvent(domEventName, isCapturePhaseListener, target) {
    var eventSystemFlags = 0;
    isCapturePhaseListener && (eventSystemFlags |= 4);
    $1e79381dc3a64a75$var$addTrappedEventListener(target, domEventName, eventSystemFlags, isCapturePhaseListener);
}
var $1e79381dc3a64a75$var$listeningMarker = "_reactListening" + Math.random().toString(36).slice(2);
function $1e79381dc3a64a75$var$listenToAllSupportedEvents(rootContainerElement) {
    if (!rootContainerElement[$1e79381dc3a64a75$var$listeningMarker]) {
        rootContainerElement[$1e79381dc3a64a75$var$listeningMarker] = !0;
        $1e79381dc3a64a75$var$allNativeEvents.forEach(function(domEventName) {
            "selectionchange" !== domEventName && ($1e79381dc3a64a75$var$nonDelegatedEvents.has(domEventName) || $1e79381dc3a64a75$var$listenToNativeEvent(domEventName, !1, rootContainerElement), $1e79381dc3a64a75$var$listenToNativeEvent(domEventName, !0, rootContainerElement));
        });
        var ownerDocument = 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
        null === ownerDocument || ownerDocument[$1e79381dc3a64a75$var$listeningMarker] || (ownerDocument[$1e79381dc3a64a75$var$listeningMarker] = !0, $1e79381dc3a64a75$var$listenToNativeEvent("selectionchange", !1, ownerDocument));
    }
}
function $1e79381dc3a64a75$var$addTrappedEventListener(targetContainer, domEventName, eventSystemFlags, isCapturePhaseListener) {
    switch($1e79381dc3a64a75$var$getEventPriority(domEventName)){
        case 2:
            var listenerWrapper = $1e79381dc3a64a75$var$dispatchDiscreteEvent;
            break;
        case 8:
            listenerWrapper = $1e79381dc3a64a75$var$dispatchContinuousEvent;
            break;
        default:
            listenerWrapper = $1e79381dc3a64a75$var$dispatchEvent;
    }
    eventSystemFlags = listenerWrapper.bind(null, domEventName, eventSystemFlags, targetContainer);
    listenerWrapper = void 0;
    !$1e79381dc3a64a75$var$passiveBrowserEventsSupported || "touchstart" !== domEventName && "touchmove" !== domEventName && "wheel" !== domEventName || (listenerWrapper = !0);
    isCapturePhaseListener ? void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        capture: !0,
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !0) : void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !1);
}
function $1e79381dc3a64a75$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, targetInst$jscomp$0, targetContainer) {
    var ancestorInst = targetInst$jscomp$0;
    if (0 === (eventSystemFlags & 1) && 0 === (eventSystemFlags & 2) && null !== targetInst$jscomp$0) a: for(;;){
        if (null === targetInst$jscomp$0) return;
        var nodeTag = targetInst$jscomp$0.tag;
        if (3 === nodeTag || 4 === nodeTag) {
            var container = targetInst$jscomp$0.stateNode.containerInfo;
            if (container === targetContainer) break;
            if (4 === nodeTag) for(nodeTag = targetInst$jscomp$0.return; null !== nodeTag;){
                var grandTag = nodeTag.tag;
                if ((3 === grandTag || 4 === grandTag) && nodeTag.stateNode.containerInfo === targetContainer) return;
                nodeTag = nodeTag.return;
            }
            for(; null !== container;){
                nodeTag = $1e79381dc3a64a75$var$getClosestInstanceFromNode(container);
                if (null === nodeTag) return;
                grandTag = nodeTag.tag;
                if (5 === grandTag || 6 === grandTag || 26 === grandTag || 27 === grandTag) {
                    targetInst$jscomp$0 = ancestorInst = nodeTag;
                    continue a;
                }
                container = container.parentNode;
            }
        }
        targetInst$jscomp$0 = targetInst$jscomp$0.return;
    }
    $1e79381dc3a64a75$var$batchedUpdates$1(function() {
        var targetInst = ancestorInst, nativeEventTarget = $1e79381dc3a64a75$var$getEventTarget(nativeEvent), dispatchQueue = [];
        a: {
            var reactName = $1e79381dc3a64a75$var$topLevelEventsToReactNames.get(domEventName);
            if (void 0 !== reactName) {
                var SyntheticEventCtor = $1e79381dc3a64a75$var$SyntheticEvent, reactEventType = domEventName;
                switch(domEventName){
                    case "keypress":
                        if (0 === $1e79381dc3a64a75$var$getEventCharCode(nativeEvent)) break a;
                    case "keydown":
                    case "keyup":
                        SyntheticEventCtor = $1e79381dc3a64a75$var$SyntheticKeyboardEvent;
                        break;
                    case "focusin":
                        reactEventType = "focus";
                        SyntheticEventCtor = $1e79381dc3a64a75$var$SyntheticFocusEvent;
                        break;
                    case "focusout":
                        reactEventType = "blur";
                        SyntheticEventCtor = $1e79381dc3a64a75$var$SyntheticFocusEvent;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        SyntheticEventCtor = $1e79381dc3a64a75$var$SyntheticFocusEvent;
                        break;
                    case "click":
                        if (2 === nativeEvent.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        SyntheticEventCtor = $1e79381dc3a64a75$var$SyntheticMouseEvent;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        SyntheticEventCtor = $1e79381dc3a64a75$var$SyntheticDragEvent;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        SyntheticEventCtor = $1e79381dc3a64a75$var$SyntheticTouchEvent;
                        break;
                    case $1e79381dc3a64a75$var$ANIMATION_END:
                    case $1e79381dc3a64a75$var$ANIMATION_ITERATION:
                    case $1e79381dc3a64a75$var$ANIMATION_START:
                        SyntheticEventCtor = $1e79381dc3a64a75$var$SyntheticAnimationEvent;
                        break;
                    case $1e79381dc3a64a75$var$TRANSITION_END:
                        SyntheticEventCtor = $1e79381dc3a64a75$var$SyntheticTransitionEvent;
                        break;
                    case "scroll":
                    case "scrollend":
                        SyntheticEventCtor = $1e79381dc3a64a75$var$SyntheticUIEvent;
                        break;
                    case "wheel":
                        SyntheticEventCtor = $1e79381dc3a64a75$var$SyntheticWheelEvent;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        SyntheticEventCtor = $1e79381dc3a64a75$var$SyntheticClipboardEvent;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        SyntheticEventCtor = $1e79381dc3a64a75$var$SyntheticPointerEvent;
                        break;
                    case "submit":
                        SyntheticEventCtor = $1e79381dc3a64a75$var$SyntheticSubmitEvent;
                        break;
                    case "toggle":
                    case "beforetoggle":
                        SyntheticEventCtor = $1e79381dc3a64a75$var$SyntheticToggleEvent;
                }
                var inCapturePhase = 0 !== (eventSystemFlags & 4), accumulateTargetOnly = !inCapturePhase && ("scroll" === domEventName || "scrollend" === domEventName), reactEventName = inCapturePhase ? null !== reactName ? reactName + "Capture" : null : reactName;
                inCapturePhase = [];
                for(var instance = targetInst, lastHostComponent; null !== instance;){
                    var _instance = instance;
                    lastHostComponent = _instance.stateNode;
                    _instance = _instance.tag;
                    5 !== _instance && 26 !== _instance && 27 !== _instance || null === lastHostComponent || null === reactEventName || (_instance = $1e79381dc3a64a75$var$getListener(instance, reactEventName), null != _instance && inCapturePhase.push($1e79381dc3a64a75$var$createDispatchListener(instance, _instance, lastHostComponent)));
                    if (accumulateTargetOnly) break;
                    instance = instance.return;
                }
                0 < inCapturePhase.length && (reactName = new SyntheticEventCtor(reactName, reactEventType, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                    event: reactName,
                    listeners: inCapturePhase
                }));
            }
        }
        if (0 === (eventSystemFlags & 7)) {
            a: {
                SyntheticEventCtor = "mouseover" === domEventName || "pointerover" === domEventName;
                reactName = "mouseout" === domEventName || "pointerout" === domEventName;
                if (SyntheticEventCtor && nativeEvent !== $1e79381dc3a64a75$var$currentReplayingEvent && (reactEventType = nativeEvent.relatedTarget || nativeEvent.fromElement) && ($1e79381dc3a64a75$var$getClosestInstanceFromNode(reactEventType) || reactEventType[$1e79381dc3a64a75$var$internalContainerInstanceKey])) break a;
                if (reactName || SyntheticEventCtor) {
                    reactEventType = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget : (SyntheticEventCtor = nativeEventTarget.ownerDocument) ? SyntheticEventCtor.defaultView || SyntheticEventCtor.parentWindow : window;
                    if (reactName) {
                        if (SyntheticEventCtor = nativeEvent.relatedTarget || nativeEvent.toElement, reactName = targetInst, SyntheticEventCtor = SyntheticEventCtor ? $1e79381dc3a64a75$var$getClosestInstanceFromNode(SyntheticEventCtor) : null, null !== SyntheticEventCtor && (accumulateTargetOnly = $1e79381dc3a64a75$var$getNearestMountedFiber(SyntheticEventCtor), inCapturePhase = SyntheticEventCtor.tag, SyntheticEventCtor !== accumulateTargetOnly || 5 !== inCapturePhase && 27 !== inCapturePhase && 6 !== inCapturePhase)) SyntheticEventCtor = null;
                    } else reactName = null, SyntheticEventCtor = targetInst;
                    if (reactName !== SyntheticEventCtor) {
                        inCapturePhase = $1e79381dc3a64a75$var$SyntheticMouseEvent;
                        _instance = "onMouseLeave";
                        reactEventName = "onMouseEnter";
                        instance = "mouse";
                        if ("pointerout" === domEventName || "pointerover" === domEventName) inCapturePhase = $1e79381dc3a64a75$var$SyntheticPointerEvent, _instance = "onPointerLeave", reactEventName = "onPointerEnter", instance = "pointer";
                        accumulateTargetOnly = null == reactName ? reactEventType : $1e79381dc3a64a75$var$getNodeFromInstance(reactName);
                        lastHostComponent = null == SyntheticEventCtor ? reactEventType : $1e79381dc3a64a75$var$getNodeFromInstance(SyntheticEventCtor);
                        reactEventType = new inCapturePhase(_instance, instance + "leave", reactName, nativeEvent, nativeEventTarget);
                        reactEventType.target = accumulateTargetOnly;
                        reactEventType.relatedTarget = lastHostComponent;
                        _instance = null;
                        $1e79381dc3a64a75$var$getClosestInstanceFromNode(nativeEventTarget) === targetInst && (inCapturePhase = new inCapturePhase(reactEventName, instance + "enter", SyntheticEventCtor, nativeEvent, nativeEventTarget), inCapturePhase.target = lastHostComponent, inCapturePhase.relatedTarget = accumulateTargetOnly, _instance = inCapturePhase);
                        accumulateTargetOnly = _instance;
                        inCapturePhase = reactName && SyntheticEventCtor ? $1e79381dc3a64a75$var$getLowestCommonAncestor(reactName, SyntheticEventCtor, $1e79381dc3a64a75$var$getParent) : null;
                        null !== reactName && $1e79381dc3a64a75$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, reactEventType, reactName, inCapturePhase, !1);
                        null !== SyntheticEventCtor && null !== accumulateTargetOnly && $1e79381dc3a64a75$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, accumulateTargetOnly, SyntheticEventCtor, inCapturePhase, !0);
                    }
                }
            }
            a: {
                reactName = targetInst ? $1e79381dc3a64a75$var$getNodeFromInstance(targetInst) : window;
                SyntheticEventCtor = reactName.nodeName && reactName.nodeName.toLowerCase();
                if ("select" === SyntheticEventCtor || "input" === SyntheticEventCtor && "file" === reactName.type) var getTargetInstFunc = $1e79381dc3a64a75$var$getTargetInstForChangeEvent;
                else if ($1e79381dc3a64a75$var$isTextInputElement(reactName)) {
                    if ($1e79381dc3a64a75$var$isInputEventSupported) getTargetInstFunc = $1e79381dc3a64a75$var$getTargetInstForInputOrChangeEvent;
                    else {
                        getTargetInstFunc = $1e79381dc3a64a75$var$getTargetInstForInputEventPolyfill;
                        var handleEventFunc = $1e79381dc3a64a75$var$handleEventsForInputEventPolyfill;
                    }
                } else SyntheticEventCtor = reactName.nodeName, !SyntheticEventCtor || "input" !== SyntheticEventCtor.toLowerCase() || "checkbox" !== reactName.type && "radio" !== reactName.type ? targetInst && $1e79381dc3a64a75$var$isCustomElement(targetInst.elementType) && (getTargetInstFunc = $1e79381dc3a64a75$var$getTargetInstForChangeEvent) : getTargetInstFunc = $1e79381dc3a64a75$var$getTargetInstForClickEvent;
                if (getTargetInstFunc && (getTargetInstFunc = getTargetInstFunc(domEventName, targetInst))) {
                    $1e79381dc3a64a75$var$createAndAccumulateChangeEvent(dispatchQueue, getTargetInstFunc, nativeEvent, nativeEventTarget);
                    break a;
                }
                handleEventFunc && handleEventFunc(domEventName, reactName, targetInst);
            }
            handleEventFunc = targetInst ? $1e79381dc3a64a75$var$getNodeFromInstance(targetInst) : window;
            switch(domEventName){
                case "focusin":
                    if ($1e79381dc3a64a75$var$isTextInputElement(handleEventFunc) || "true" === handleEventFunc.contentEditable) $1e79381dc3a64a75$var$activeElement = handleEventFunc, $1e79381dc3a64a75$var$activeElementInst = targetInst, $1e79381dc3a64a75$var$lastSelection = null;
                    break;
                case "focusout":
                    $1e79381dc3a64a75$var$lastSelection = $1e79381dc3a64a75$var$activeElementInst = $1e79381dc3a64a75$var$activeElement = null;
                    break;
                case "mousedown":
                    $1e79381dc3a64a75$var$mouseDown = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $1e79381dc3a64a75$var$mouseDown = !1;
                    $1e79381dc3a64a75$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
                    break;
                case "selectionchange":
                    if ($1e79381dc3a64a75$var$skipSelectionChangeEvent) break;
                case "keydown":
                case "keyup":
                    $1e79381dc3a64a75$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
            }
            var fallbackData;
            if ($1e79381dc3a64a75$var$canUseCompositionEvent) b: {
                switch(domEventName){
                    case "compositionstart":
                        var eventType = "onCompositionStart";
                        break b;
                    case "compositionend":
                        eventType = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        eventType = "onCompositionUpdate";
                        break b;
                }
                eventType = void 0;
            }
            else $1e79381dc3a64a75$var$isComposing ? $1e79381dc3a64a75$var$isFallbackCompositionEnd(domEventName, nativeEvent) && (eventType = "onCompositionEnd") : "keydown" === domEventName && 229 === nativeEvent.keyCode && (eventType = "onCompositionStart");
            eventType && ($1e79381dc3a64a75$var$useFallbackCompositionData && "ko" !== nativeEvent.locale && ($1e79381dc3a64a75$var$isComposing || "onCompositionStart" !== eventType ? "onCompositionEnd" === eventType && $1e79381dc3a64a75$var$isComposing && (fallbackData = $1e79381dc3a64a75$var$getData()) : ($1e79381dc3a64a75$var$root = nativeEventTarget, $1e79381dc3a64a75$var$startText = "value" in $1e79381dc3a64a75$var$root ? $1e79381dc3a64a75$var$root.value : $1e79381dc3a64a75$var$root.textContent, $1e79381dc3a64a75$var$isComposing = !0)), handleEventFunc = $1e79381dc3a64a75$var$accumulateTwoPhaseListeners(targetInst, eventType), 0 < handleEventFunc.length && (eventType = new $1e79381dc3a64a75$var$SyntheticCompositionEvent(eventType, domEventName, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: eventType,
                listeners: handleEventFunc
            }), fallbackData ? eventType.data = fallbackData : (fallbackData = $1e79381dc3a64a75$var$getDataFromCustomEvent(nativeEvent), null !== fallbackData && (eventType.data = fallbackData))));
            if (fallbackData = $1e79381dc3a64a75$var$canUseTextInputEvent ? $1e79381dc3a64a75$var$getNativeBeforeInputChars(domEventName, nativeEvent) : $1e79381dc3a64a75$var$getFallbackBeforeInputChars(domEventName, nativeEvent)) eventType = $1e79381dc3a64a75$var$accumulateTwoPhaseListeners(targetInst, "onBeforeInput"), 0 < eventType.length && (handleEventFunc = new $1e79381dc3a64a75$var$SyntheticCompositionEvent("onBeforeInput", "beforeinput", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: handleEventFunc,
                listeners: eventType
            }), handleEventFunc.data = fallbackData);
            $1e79381dc3a64a75$var$extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
        }
        $1e79381dc3a64a75$var$processDispatchQueue(dispatchQueue, eventSystemFlags);
    });
}
function $1e79381dc3a64a75$var$createDispatchListener(instance, listener, currentTarget) {
    return {
        instance: instance,
        listener: listener,
        currentTarget: currentTarget
    };
}
function $1e79381dc3a64a75$var$accumulateTwoPhaseListeners(targetFiber, reactName) {
    for(var captureName = reactName + "Capture", listeners = []; null !== targetFiber;){
        var _instance2 = targetFiber, stateNode = _instance2.stateNode;
        _instance2 = _instance2.tag;
        5 !== _instance2 && 26 !== _instance2 && 27 !== _instance2 || null === stateNode || (_instance2 = $1e79381dc3a64a75$var$getListener(targetFiber, captureName), null != _instance2 && listeners.unshift($1e79381dc3a64a75$var$createDispatchListener(targetFiber, _instance2, stateNode)), _instance2 = $1e79381dc3a64a75$var$getListener(targetFiber, reactName), null != _instance2 && listeners.push($1e79381dc3a64a75$var$createDispatchListener(targetFiber, _instance2, stateNode)));
        if (3 === targetFiber.tag) return listeners;
        targetFiber = targetFiber.return;
    }
    return [];
}
function $1e79381dc3a64a75$var$getParent(inst) {
    if (null === inst) return null;
    do inst = inst.return;
    while (inst && 5 !== inst.tag && 27 !== inst.tag);
    return inst ? inst : null;
}
function $1e79381dc3a64a75$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, event, target, common, inCapturePhase) {
    for(var registrationName = event._reactName, listeners = []; null !== target && target !== common;){
        var _instance3 = target, alternate = _instance3.alternate, stateNode = _instance3.stateNode;
        _instance3 = _instance3.tag;
        if (null !== alternate && alternate === common) break;
        5 !== _instance3 && 26 !== _instance3 && 27 !== _instance3 || null === stateNode || (alternate = stateNode, inCapturePhase ? (stateNode = $1e79381dc3a64a75$var$getListener(target, registrationName), null != stateNode && listeners.unshift($1e79381dc3a64a75$var$createDispatchListener(target, stateNode, alternate))) : inCapturePhase || (stateNode = $1e79381dc3a64a75$var$getListener(target, registrationName), null != stateNode && listeners.push($1e79381dc3a64a75$var$createDispatchListener(target, stateNode, alternate))));
        target = target.return;
    }
    0 !== listeners.length && dispatchQueue.push({
        event: event,
        listeners: listeners
    });
}
var $1e79381dc3a64a75$var$NORMALIZE_NEWLINES_REGEX = /\r\n?/g, $1e79381dc3a64a75$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX = /\u0000|\uFFFD/g;
function $1e79381dc3a64a75$var$normalizeMarkupForTextOrAttribute(markup) {
    return ("string" === typeof markup ? markup : "" + markup).replace($1e79381dc3a64a75$var$NORMALIZE_NEWLINES_REGEX, "\n").replace($1e79381dc3a64a75$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX, "");
}
function $1e79381dc3a64a75$var$checkForUnmatchedText(serverText, clientText) {
    clientText = $1e79381dc3a64a75$var$normalizeMarkupForTextOrAttribute(clientText);
    return $1e79381dc3a64a75$var$normalizeMarkupForTextOrAttribute(serverText) === clientText ? !0 : !1;
}
function $1e79381dc3a64a75$var$setProp(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "children":
            if ("string" === typeof value) "body" === tag || "textarea" === tag && "" === value || $1e79381dc3a64a75$var$setTextContent(domElement, value);
            else if ("number" === typeof value || "bigint" === typeof value) "body" !== tag && $1e79381dc3a64a75$var$setTextContent(domElement, "" + value);
            else return;
            break;
        case "className":
            $1e79381dc3a64a75$var$setValueForKnownAttribute(domElement, "class", value);
            break;
        case "tabIndex":
            $1e79381dc3a64a75$var$setValueForKnownAttribute(domElement, "tabindex", value);
            break;
        case "dir":
        case "role":
        case "viewBox":
        case "width":
        case "height":
            $1e79381dc3a64a75$var$setValueForKnownAttribute(domElement, key, value);
            break;
        case "style":
            $1e79381dc3a64a75$var$setValueForStyles(domElement, value, prevValue);
            return;
        case "data":
            if ("object" !== tag) {
                $1e79381dc3a64a75$var$setValueForKnownAttribute(domElement, "data", value);
                break;
            }
        case "src":
        case "href":
            if ("" === value && ("a" !== tag || "href" !== key)) {
                domElement.removeAttribute(key);
                break;
            }
            if (null == value || "function" === typeof value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $1e79381dc3a64a75$var$sanitizeURL(value);
            domElement.setAttribute(key, value);
            break;
        case "action":
        case "formAction":
            if ("function" === typeof value) {
                domElement.setAttribute(key, "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')");
                break;
            } else "function" === typeof prevValue && ("formAction" === key ? ("input" !== tag && $1e79381dc3a64a75$var$setProp(domElement, tag, "name", props.name, props, null), $1e79381dc3a64a75$var$setProp(domElement, tag, "formEncType", props.formEncType, props, null), $1e79381dc3a64a75$var$setProp(domElement, tag, "formMethod", props.formMethod, props, null), $1e79381dc3a64a75$var$setProp(domElement, tag, "formTarget", props.formTarget, props, null)) : ($1e79381dc3a64a75$var$setProp(domElement, tag, "encType", props.encType, props, null), $1e79381dc3a64a75$var$setProp(domElement, tag, "method", props.method, props, null), $1e79381dc3a64a75$var$setProp(domElement, tag, "target", props.target, props, null)));
            if (null == value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $1e79381dc3a64a75$var$sanitizeURL(value);
            domElement.setAttribute(key, value);
            break;
        case "onClick":
            null != value && (domElement.onclick = $1e79381dc3a64a75$var$noop$1);
            return;
        case "onScroll":
            null != value && $1e79381dc3a64a75$var$listenToNonDelegatedEvent("scroll", domElement);
            return;
        case "onScrollEnd":
            null != value && $1e79381dc3a64a75$var$listenToNonDelegatedEvent("scrollend", domElement);
            return;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($1e79381dc3a64a75$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($1e79381dc3a64a75$var$formatProdErrorMessage(60));
                    (null != prevValue ? prevValue.__html : void 0) !== key && (domElement.innerHTML = key);
                }
            }
            break;
        case "multiple":
            domElement.multiple = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "muted":
            domElement.muted = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "ref":
            break;
        case "autoFocus":
            break;
        case "xlinkHref":
            if (null == value || "function" === typeof value || "boolean" === typeof value || "symbol" === typeof value) {
                domElement.removeAttribute("xlink:href");
                break;
            }
            key = $1e79381dc3a64a75$var$sanitizeURL(value);
            domElement.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", key);
            break;
        case "contentEditable":
        case "spellCheck":
        case "draggable":
        case "value":
        case "autoReverse":
        case "externalResourcesRequired":
        case "focusable":
        case "preserveAlpha":
            null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "inert":
        case "allowFullScreen":
        case "async":
        case "autoPlay":
        case "controls":
        case "credentialless":
        case "default":
        case "defer":
        case "disabled":
        case "disablePictureInPicture":
        case "disableRemotePlayback":
        case "formNoValidate":
        case "hidden":
        case "loop":
        case "noModule":
        case "noValidate":
        case "open":
        case "playsInline":
        case "readOnly":
        case "required":
        case "reversed":
        case "scoped":
        case "seamless":
        case "itemScope":
            value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "") : domElement.removeAttribute(key);
            break;
        case "capture":
        case "download":
            !0 === value ? domElement.setAttribute(key, "") : !1 !== value && null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "cols":
        case "rows":
        case "size":
        case "span":
            null != value && "function" !== typeof value && "symbol" !== typeof value && !isNaN(value) && 1 <= value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "rowSpan":
        case "start":
            null == value || "function" === typeof value || "symbol" === typeof value || isNaN(value) ? domElement.removeAttribute(key) : domElement.setAttribute(key, value);
            break;
        case "popover":
            $1e79381dc3a64a75$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $1e79381dc3a64a75$var$listenToNonDelegatedEvent("toggle", domElement);
            $1e79381dc3a64a75$var$setValueForAttribute(domElement, "popover", value);
            break;
        case "xlinkActuate":
            $1e79381dc3a64a75$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:actuate", value);
            break;
        case "xlinkArcrole":
            $1e79381dc3a64a75$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:arcrole", value);
            break;
        case "xlinkRole":
            $1e79381dc3a64a75$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:role", value);
            break;
        case "xlinkShow":
            $1e79381dc3a64a75$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:show", value);
            break;
        case "xlinkTitle":
            $1e79381dc3a64a75$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:title", value);
            break;
        case "xlinkType":
            $1e79381dc3a64a75$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:type", value);
            break;
        case "xmlBase":
            $1e79381dc3a64a75$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:base", value);
            break;
        case "xmlLang":
            $1e79381dc3a64a75$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:lang", value);
            break;
        case "xmlSpace":
            $1e79381dc3a64a75$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:space", value);
            break;
        case "is":
            $1e79381dc3a64a75$var$setValueForAttribute(domElement, "is", value);
            break;
        case "innerText":
        case "textContent":
            return;
        default:
            if (!(2 < key.length) || "o" !== key[0] && "O" !== key[0] || "n" !== key[1] && "N" !== key[1]) key = $1e79381dc3a64a75$var$aliases.get(key) || key, $1e79381dc3a64a75$var$setValueForAttribute(domElement, key, value);
            else return;
    }
    $1e79381dc3a64a75$var$viewTransitionMutationContext = !0;
}
function $1e79381dc3a64a75$var$setPropOnCustomElement(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "style":
            $1e79381dc3a64a75$var$setValueForStyles(domElement, value, prevValue);
            return;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($1e79381dc3a64a75$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($1e79381dc3a64a75$var$formatProdErrorMessage(60));
                    (null != prevValue ? prevValue.__html : void 0) !== key && (domElement.innerHTML = key);
                }
            }
            break;
        case "children":
            if ("string" === typeof value) $1e79381dc3a64a75$var$setTextContent(domElement, value);
            else if ("number" === typeof value || "bigint" === typeof value) $1e79381dc3a64a75$var$setTextContent(domElement, "" + value);
            else return;
            break;
        case "onScroll":
            null != value && $1e79381dc3a64a75$var$listenToNonDelegatedEvent("scroll", domElement);
            return;
        case "onScrollEnd":
            null != value && $1e79381dc3a64a75$var$listenToNonDelegatedEvent("scrollend", domElement);
            return;
        case "onClick":
            null != value && (domElement.onclick = $1e79381dc3a64a75$var$noop$1);
            return;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "innerHTML":
        case "ref":
            return;
        case "innerText":
        case "textContent":
            return;
        default:
            if (!$1e79381dc3a64a75$var$registrationNameDependencies.hasOwnProperty(key)) a: {
                if ("o" === key[0] && "n" === key[1] && (props = key.endsWith("Capture"), prevValue = key.slice(2, props ? key.length - 7 : void 0), tag = domElement[$1e79381dc3a64a75$var$internalPropsKey] || null, tag = null != tag ? tag[key] : null, "function" === typeof tag && domElement.removeEventListener(prevValue, tag, props), "function" === typeof value)) {
                    "function" !== typeof tag && null !== tag && (key in domElement ? domElement[key] = null : domElement.hasAttribute(key) && domElement.removeAttribute(key));
                    domElement.addEventListener(prevValue, value, props);
                    break a;
                }
                $1e79381dc3a64a75$var$viewTransitionMutationContext = !0;
                key in domElement ? domElement[key] = value : !0 === value ? domElement.setAttribute(key, "") : $1e79381dc3a64a75$var$setValueForAttribute(domElement, key, value);
            }
            return;
    }
    $1e79381dc3a64a75$var$viewTransitionMutationContext = !0;
}
function $1e79381dc3a64a75$var$setInitialProperties(domElement, tag, props) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "img":
            $1e79381dc3a64a75$var$listenToNonDelegatedEvent("error", domElement);
            $1e79381dc3a64a75$var$listenToNonDelegatedEvent("load", domElement);
            var hasSrc = !1, hasSrcSet = !1, propKey;
            for(propKey in props)if (props.hasOwnProperty(propKey)) {
                var propValue = props[propKey];
                if (null != propValue) switch(propKey){
                    case "src":
                        hasSrc = !0;
                        break;
                    case "srcSet":
                        hasSrcSet = !0;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        throw Error($1e79381dc3a64a75$var$formatProdErrorMessage(137, tag));
                    default:
                        $1e79381dc3a64a75$var$setProp(domElement, tag, propKey, propValue, props, null);
                }
            }
            hasSrcSet && $1e79381dc3a64a75$var$setProp(domElement, tag, "srcSet", props.srcSet, props, null);
            hasSrc && $1e79381dc3a64a75$var$setProp(domElement, tag, "src", props.src, props, null);
            return;
        case "input":
            $1e79381dc3a64a75$var$listenToNonDelegatedEvent("invalid", domElement);
            var defaultValue = propKey = propValue = hasSrcSet = null, checked = null, defaultChecked = null;
            for(hasSrc in props)if (props.hasOwnProperty(hasSrc)) {
                var propValue$204 = props[hasSrc];
                if (null != propValue$204) switch(hasSrc){
                    case "name":
                        hasSrcSet = propValue$204;
                        break;
                    case "type":
                        propValue = propValue$204;
                        break;
                    case "checked":
                        checked = propValue$204;
                        break;
                    case "defaultChecked":
                        defaultChecked = propValue$204;
                        break;
                    case "value":
                        propKey = propValue$204;
                        break;
                    case "defaultValue":
                        defaultValue = propValue$204;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propValue$204) throw Error($1e79381dc3a64a75$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        $1e79381dc3a64a75$var$setProp(domElement, tag, hasSrc, propValue$204, props, null);
                }
            }
            $1e79381dc3a64a75$var$initInput(domElement, propKey, defaultValue, checked, defaultChecked, propValue, hasSrcSet, !1);
            return;
        case "select":
            $1e79381dc3a64a75$var$listenToNonDelegatedEvent("invalid", domElement);
            hasSrc = propValue = propKey = null;
            for(hasSrcSet in props)if (props.hasOwnProperty(hasSrcSet) && (defaultValue = props[hasSrcSet], null != defaultValue)) switch(hasSrcSet){
                case "value":
                    propKey = defaultValue;
                    break;
                case "defaultValue":
                    propValue = defaultValue;
                    break;
                case "multiple":
                    hasSrc = defaultValue;
                default:
                    $1e79381dc3a64a75$var$setProp(domElement, tag, hasSrcSet, defaultValue, props, null);
            }
            tag = propKey;
            props = propValue;
            domElement.multiple = !!hasSrc;
            null != tag ? $1e79381dc3a64a75$var$updateOptions(domElement, !!hasSrc, tag, !1) : null != props && $1e79381dc3a64a75$var$updateOptions(domElement, !!hasSrc, props, !0);
            return;
        case "textarea":
            $1e79381dc3a64a75$var$listenToNonDelegatedEvent("invalid", domElement);
            propKey = hasSrcSet = hasSrc = null;
            for(propValue in props)if (props.hasOwnProperty(propValue) && (defaultValue = props[propValue], null != defaultValue)) switch(propValue){
                case "value":
                    hasSrc = defaultValue;
                    break;
                case "defaultValue":
                    hasSrcSet = defaultValue;
                    break;
                case "children":
                    propKey = defaultValue;
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != defaultValue) throw Error($1e79381dc3a64a75$var$formatProdErrorMessage(91));
                    break;
                default:
                    $1e79381dc3a64a75$var$setProp(domElement, tag, propValue, defaultValue, props, null);
            }
            $1e79381dc3a64a75$var$initTextarea(domElement, hasSrc, hasSrcSet, propKey);
            return;
        case "option":
            for(checked in props)if (props.hasOwnProperty(checked) && (hasSrc = props[checked], null != hasSrc)) switch(checked){
                case "selected":
                    domElement.selected = hasSrc && "function" !== typeof hasSrc && "symbol" !== typeof hasSrc;
                    break;
                default:
                    $1e79381dc3a64a75$var$setProp(domElement, tag, checked, hasSrc, props, null);
            }
            return;
        case "dialog":
            $1e79381dc3a64a75$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $1e79381dc3a64a75$var$listenToNonDelegatedEvent("toggle", domElement);
            $1e79381dc3a64a75$var$listenToNonDelegatedEvent("cancel", domElement);
            $1e79381dc3a64a75$var$listenToNonDelegatedEvent("close", domElement);
            break;
        case "iframe":
        case "object":
            $1e79381dc3a64a75$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "video":
        case "audio":
            for(hasSrc = 0; hasSrc < $1e79381dc3a64a75$var$mediaEventTypes.length; hasSrc++)$1e79381dc3a64a75$var$listenToNonDelegatedEvent($1e79381dc3a64a75$var$mediaEventTypes[hasSrc], domElement);
            break;
        case "image":
            $1e79381dc3a64a75$var$listenToNonDelegatedEvent("error", domElement);
            $1e79381dc3a64a75$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "details":
            $1e79381dc3a64a75$var$listenToNonDelegatedEvent("toggle", domElement);
            break;
        case "embed":
        case "source":
        case "link":
            $1e79381dc3a64a75$var$listenToNonDelegatedEvent("error", domElement), $1e79381dc3a64a75$var$listenToNonDelegatedEvent("load", domElement);
        case "area":
        case "base":
        case "br":
        case "col":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "track":
        case "wbr":
        case "menuitem":
            for(defaultChecked in props)if (props.hasOwnProperty(defaultChecked) && (hasSrc = props[defaultChecked], null != hasSrc)) switch(defaultChecked){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($1e79381dc3a64a75$var$formatProdErrorMessage(137, tag));
                default:
                    $1e79381dc3a64a75$var$setProp(domElement, tag, defaultChecked, hasSrc, props, null);
            }
            return;
        default:
            if ($1e79381dc3a64a75$var$isCustomElement(tag)) {
                for(propValue$204 in props)props.hasOwnProperty(propValue$204) && (hasSrc = props[propValue$204], void 0 !== hasSrc && $1e79381dc3a64a75$var$setPropOnCustomElement(domElement, tag, propValue$204, hasSrc, props, void 0));
                return;
            }
    }
    for(defaultValue in props)props.hasOwnProperty(defaultValue) && (hasSrc = props[defaultValue], null != hasSrc && $1e79381dc3a64a75$var$setProp(domElement, tag, defaultValue, hasSrc, props, null));
}
var $1e79381dc3a64a75$var$emptyProps = {};
function $1e79381dc3a64a75$var$updateProperties(domElement, tag, lastProps, nextProps) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "input":
            var name = null, type = null, value = null, defaultValue = null, lastDefaultValue = null, checked = null, defaultChecked = null;
            for(propKey in lastProps){
                var lastProp = lastProps[propKey];
                if (lastProps.hasOwnProperty(propKey) && null != lastProp) switch(propKey){
                    case "checked":
                        break;
                    case "value":
                        break;
                    case "defaultValue":
                        lastDefaultValue = lastProp;
                    default:
                        nextProps.hasOwnProperty(propKey) || $1e79381dc3a64a75$var$setProp(domElement, tag, propKey, null, nextProps, lastProp);
                }
            }
            for(var propKey$221 in nextProps){
                var propKey = nextProps[propKey$221];
                lastProp = lastProps[propKey$221];
                if (nextProps.hasOwnProperty(propKey$221) && (null != propKey || null != lastProp)) switch(propKey$221){
                    case "type":
                        propKey !== lastProp && ($1e79381dc3a64a75$var$viewTransitionMutationContext = !0);
                        type = propKey;
                        break;
                    case "name":
                        propKey !== lastProp && ($1e79381dc3a64a75$var$viewTransitionMutationContext = !0);
                        name = propKey;
                        break;
                    case "checked":
                        propKey !== lastProp && ($1e79381dc3a64a75$var$viewTransitionMutationContext = !0);
                        checked = propKey;
                        break;
                    case "defaultChecked":
                        propKey !== lastProp && ($1e79381dc3a64a75$var$viewTransitionMutationContext = !0);
                        defaultChecked = propKey;
                        break;
                    case "value":
                        propKey !== lastProp && ($1e79381dc3a64a75$var$viewTransitionMutationContext = !0);
                        value = propKey;
                        break;
                    case "defaultValue":
                        propKey !== lastProp && ($1e79381dc3a64a75$var$viewTransitionMutationContext = !0);
                        defaultValue = propKey;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propKey) throw Error($1e79381dc3a64a75$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        propKey !== lastProp && $1e79381dc3a64a75$var$setProp(domElement, tag, propKey$221, propKey, nextProps, lastProp);
                }
            }
            $1e79381dc3a64a75$var$updateInput(domElement, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name);
            return;
        case "select":
            propKey = value = defaultValue = propKey$221 = null;
            for(type in lastProps)if (lastDefaultValue = lastProps[type], lastProps.hasOwnProperty(type) && null != lastDefaultValue) switch(type){
                case "value":
                    break;
                case "multiple":
                    propKey = lastDefaultValue;
                default:
                    nextProps.hasOwnProperty(type) || $1e79381dc3a64a75$var$setProp(domElement, tag, type, null, nextProps, lastDefaultValue);
            }
            for(name in nextProps)if (type = nextProps[name], lastDefaultValue = lastProps[name], nextProps.hasOwnProperty(name) && (null != type || null != lastDefaultValue)) switch(name){
                case "value":
                    type !== lastDefaultValue && ($1e79381dc3a64a75$var$viewTransitionMutationContext = !0);
                    propKey$221 = type;
                    break;
                case "defaultValue":
                    type !== lastDefaultValue && ($1e79381dc3a64a75$var$viewTransitionMutationContext = !0);
                    defaultValue = type;
                    break;
                case "multiple":
                    type !== lastDefaultValue && ($1e79381dc3a64a75$var$viewTransitionMutationContext = !0), value = type;
                default:
                    type !== lastDefaultValue && $1e79381dc3a64a75$var$setProp(domElement, tag, name, type, nextProps, lastDefaultValue);
            }
            tag = defaultValue;
            lastProps = value;
            nextProps = propKey;
            null != propKey$221 ? $1e79381dc3a64a75$var$updateOptions(domElement, !!lastProps, propKey$221, !1) : !!nextProps !== !!lastProps && (null != tag ? $1e79381dc3a64a75$var$updateOptions(domElement, !!lastProps, tag, !0) : $1e79381dc3a64a75$var$updateOptions(domElement, !!lastProps, lastProps ? [] : "", !1));
            return;
        case "textarea":
            propKey = propKey$221 = null;
            for(defaultValue in lastProps)if (name = lastProps[defaultValue], lastProps.hasOwnProperty(defaultValue) && null != name && !nextProps.hasOwnProperty(defaultValue)) switch(defaultValue){
                case "value":
                    break;
                case "children":
                    break;
                default:
                    $1e79381dc3a64a75$var$setProp(domElement, tag, defaultValue, null, nextProps, name);
            }
            for(value in nextProps)if (name = nextProps[value], type = lastProps[value], nextProps.hasOwnProperty(value) && (null != name || null != type)) switch(value){
                case "value":
                    name !== type && ($1e79381dc3a64a75$var$viewTransitionMutationContext = !0);
                    propKey$221 = name;
                    break;
                case "defaultValue":
                    name !== type && ($1e79381dc3a64a75$var$viewTransitionMutationContext = !0);
                    propKey = name;
                    break;
                case "children":
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != name) throw Error($1e79381dc3a64a75$var$formatProdErrorMessage(91));
                    break;
                default:
                    name !== type && $1e79381dc3a64a75$var$setProp(domElement, tag, value, name, nextProps, type);
            }
            $1e79381dc3a64a75$var$updateTextarea(domElement, propKey$221, propKey);
            return;
        case "option":
            for(var propKey$237 in lastProps)if (propKey$221 = lastProps[propKey$237], lastProps.hasOwnProperty(propKey$237) && null != propKey$221 && !nextProps.hasOwnProperty(propKey$237)) switch(propKey$237){
                case "selected":
                    domElement.selected = !1;
                    break;
                default:
                    $1e79381dc3a64a75$var$setProp(domElement, tag, propKey$237, null, nextProps, propKey$221);
            }
            for(lastDefaultValue in nextProps)if (propKey$221 = nextProps[lastDefaultValue], propKey = lastProps[lastDefaultValue], nextProps.hasOwnProperty(lastDefaultValue) && propKey$221 !== propKey && (null != propKey$221 || null != propKey)) switch(lastDefaultValue){
                case "selected":
                    propKey$221 !== propKey && ($1e79381dc3a64a75$var$viewTransitionMutationContext = !0);
                    domElement.selected = propKey$221 && "function" !== typeof propKey$221 && "symbol" !== typeof propKey$221;
                    break;
                default:
                    $1e79381dc3a64a75$var$setProp(domElement, tag, lastDefaultValue, propKey$221, nextProps, propKey);
            }
            return;
        case "img":
        case "link":
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
        case "menuitem":
            for(var propKey$242 in lastProps)propKey$221 = lastProps[propKey$242], lastProps.hasOwnProperty(propKey$242) && null != propKey$221 && !nextProps.hasOwnProperty(propKey$242) && $1e79381dc3a64a75$var$setProp(domElement, tag, propKey$242, null, nextProps, propKey$221);
            for(checked in nextProps)if (propKey$221 = nextProps[checked], propKey = lastProps[checked], nextProps.hasOwnProperty(checked) && propKey$221 !== propKey && (null != propKey$221 || null != propKey)) switch(checked){
                case "children":
                case "dangerouslySetInnerHTML":
                    if (null != propKey$221) throw Error($1e79381dc3a64a75$var$formatProdErrorMessage(137, tag));
                    break;
                default:
                    $1e79381dc3a64a75$var$setProp(domElement, tag, checked, propKey$221, nextProps, propKey);
            }
            return;
        default:
            if ($1e79381dc3a64a75$var$isCustomElement(tag)) {
                for(var propKey$247 in lastProps)propKey$221 = lastProps[propKey$247], lastProps.hasOwnProperty(propKey$247) && void 0 !== propKey$221 && !nextProps.hasOwnProperty(propKey$247) && $1e79381dc3a64a75$var$setPropOnCustomElement(domElement, tag, propKey$247, void 0, nextProps, propKey$221);
                for(defaultChecked in nextProps)propKey$221 = nextProps[defaultChecked], propKey = lastProps[defaultChecked], !nextProps.hasOwnProperty(defaultChecked) || propKey$221 === propKey || void 0 === propKey$221 && void 0 === propKey || $1e79381dc3a64a75$var$setPropOnCustomElement(domElement, tag, defaultChecked, propKey$221, nextProps, propKey);
                return;
            }
    }
    for(var propKey$252 in lastProps)propKey$221 = lastProps[propKey$252], lastProps.hasOwnProperty(propKey$252) && null != propKey$221 && !nextProps.hasOwnProperty(propKey$252) && $1e79381dc3a64a75$var$setProp(domElement, tag, propKey$252, null, nextProps, propKey$221);
    for(lastProp in nextProps)propKey$221 = nextProps[lastProp], propKey = lastProps[lastProp], !nextProps.hasOwnProperty(lastProp) || propKey$221 === propKey || null == propKey$221 && null == propKey || $1e79381dc3a64a75$var$setProp(domElement, tag, lastProp, propKey$221, nextProps, propKey);
}
function $1e79381dc3a64a75$var$isLikelyStaticResource(initiatorType) {
    switch(initiatorType){
        case "css":
        case "script":
        case "font":
        case "img":
        case "image":
        case "input":
        case "link":
            return !0;
        default:
            return !1;
    }
}
function $1e79381dc3a64a75$var$estimateBandwidth() {
    if ("function" === typeof performance.getEntriesByType) {
        for(var count = 0, bits = 0, resourceEntries = performance.getEntriesByType("resource"), i = 0; i < resourceEntries.length; i++){
            var entry = resourceEntries[i], transferSize = entry.transferSize, initiatorType = entry.initiatorType, duration = entry.duration;
            if (transferSize && duration && $1e79381dc3a64a75$var$isLikelyStaticResource(initiatorType)) {
                initiatorType = 0;
                duration = entry.responseEnd;
                for(i += 1; i < resourceEntries.length; i++){
                    var overlapEntry = resourceEntries[i], overlapStartTime = overlapEntry.startTime;
                    if (overlapStartTime > duration) break;
                    var overlapTransferSize = overlapEntry.transferSize, overlapInitiatorType = overlapEntry.initiatorType;
                    overlapTransferSize && $1e79381dc3a64a75$var$isLikelyStaticResource(overlapInitiatorType) && (overlapEntry = overlapEntry.responseEnd, initiatorType += overlapTransferSize * (overlapEntry < duration ? 1 : (duration - overlapStartTime) / (overlapEntry - overlapStartTime)));
                }
                --i;
                bits += 8 * (transferSize + initiatorType) / (entry.duration / 1e3);
                count++;
                if (10 < count) break;
            }
        }
        if (0 < count) return bits / count / 1e6;
    }
    return navigator.connection && (count = navigator.connection.downlink, "number" === typeof count) ? count : 5;
}
var $1e79381dc3a64a75$var$eventsEnabled = null, $1e79381dc3a64a75$var$selectionInformation = null;
function $1e79381dc3a64a75$var$getOwnerDocumentFromRootContainer(rootContainerElement) {
    return 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
}
function $1e79381dc3a64a75$var$getOwnHostContext(namespaceURI) {
    switch(namespaceURI){
        case "http://www.w3.org/2000/svg":
            return 1;
        case "http://www.w3.org/1998/Math/MathML":
            return 2;
        default:
            return 0;
    }
}
function $1e79381dc3a64a75$var$getChildHostContextProd(parentNamespace, type) {
    if (0 === parentNamespace) switch(type){
        case "svg":
            return 1;
        case "math":
            return 2;
        default:
            return 0;
    }
    return 1 === parentNamespace && "foreignObject" === type ? 0 : parentNamespace;
}
function $1e79381dc3a64a75$var$createHoistableInstance(type, props, rootContainerInstance, internalInstanceHandle) {
    rootContainerInstance = $1e79381dc3a64a75$var$getOwnerDocumentFromRootContainer(rootContainerInstance).createElement(type);
    rootContainerInstance[$1e79381dc3a64a75$var$internalInstanceKey] = internalInstanceHandle;
    rootContainerInstance[$1e79381dc3a64a75$var$internalPropsKey] = props;
    $1e79381dc3a64a75$var$setInitialProperties(rootContainerInstance, type, props);
    $1e79381dc3a64a75$var$markNodeAsHoistable(rootContainerInstance);
    return rootContainerInstance;
}
function $1e79381dc3a64a75$var$shouldSetTextContent(type, props) {
    return "textarea" === type || "noscript" === type || "string" === typeof props.children || "number" === typeof props.children || "bigint" === typeof props.children || "object" === typeof props.dangerouslySetInnerHTML && null !== props.dangerouslySetInnerHTML && null != props.dangerouslySetInnerHTML.__html;
}
var $1e79381dc3a64a75$var$currentPopstateTransitionEvent = null;
function $1e79381dc3a64a75$var$shouldAttemptEagerTransition() {
    var event = window.event;
    if (event && "popstate" === event.type) {
        if (event === $1e79381dc3a64a75$var$currentPopstateTransitionEvent) return !1;
        $1e79381dc3a64a75$var$currentPopstateTransitionEvent = event;
        return !0;
    }
    $1e79381dc3a64a75$var$currentPopstateTransitionEvent = null;
    return !1;
}
var $1e79381dc3a64a75$var$scheduleTimeout = "function" === typeof setTimeout ? setTimeout : void 0, $1e79381dc3a64a75$var$cancelTimeout = "function" === typeof clearTimeout ? clearTimeout : void 0, $1e79381dc3a64a75$var$localPromise = "function" === typeof Promise ? Promise : void 0, $1e79381dc3a64a75$var$localRequestAnimationFrame = "function" === typeof requestAnimationFrame ? requestAnimationFrame : $1e79381dc3a64a75$var$scheduleTimeout, $1e79381dc3a64a75$var$scheduleMicrotask = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $1e79381dc3a64a75$var$localPromise ? function(callback) {
    return $1e79381dc3a64a75$var$localPromise.resolve(null).then(callback).catch($1e79381dc3a64a75$var$handleErrorInNextTick);
} : $1e79381dc3a64a75$var$scheduleTimeout;
function $1e79381dc3a64a75$var$handleErrorInNextTick(error) {
    setTimeout(function() {
        throw error;
    });
}
function $1e79381dc3a64a75$var$isSingletonScope(type) {
    return "head" === type;
}
function $1e79381dc3a64a75$var$clearHydrationBoundary(parentInstance, hydrationInstance) {
    var node = hydrationInstance, depth = 0;
    do {
        var nextNode = node.nextSibling;
        parentInstance.removeChild(node);
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node || "/&" === node) {
                if (0 === depth) {
                    parentInstance.removeChild(nextNode);
                    $1e79381dc3a64a75$var$retryIfBlockedOn(hydrationInstance);
                    return;
                }
                depth--;
            } else if ("$" === node || "$?" === node || "$~" === node || "$!" === node || "&" === node) depth++;
            else if ("html" === node) $1e79381dc3a64a75$var$clearSingletonPreambleContribution(parentInstance.ownerDocument.documentElement);
            else if ("head" === node) {
                node = parentInstance.ownerDocument.head;
                $1e79381dc3a64a75$var$clearSingletonPreambleContribution(node);
                for(var node$jscomp$0 = node.firstChild; node$jscomp$0;){
                    var nextNode$jscomp$0 = node$jscomp$0.nextSibling, nodeName = node$jscomp$0.nodeName;
                    node$jscomp$0[$1e79381dc3a64a75$var$internalHoistableMarker] || "SCRIPT" === nodeName || "STYLE" === nodeName || "LINK" === nodeName && "stylesheet" === node$jscomp$0.rel.toLowerCase() || node.removeChild(node$jscomp$0);
                    node$jscomp$0 = nextNode$jscomp$0;
                }
            } else "body" === node && $1e79381dc3a64a75$var$clearSingletonPreambleContribution(parentInstance.ownerDocument.body);
        }
        node = nextNode;
    }while (node);
    $1e79381dc3a64a75$var$retryIfBlockedOn(hydrationInstance);
}
function $1e79381dc3a64a75$var$hideOrUnhideDehydratedBoundary(suspenseInstance, isHidden) {
    var node = suspenseInstance;
    suspenseInstance = 0;
    do {
        var nextNode = node.nextSibling;
        1 === node.nodeType ? isHidden ? (node._stashedDisplay = node.style.display, node.style.display = "none") : (node.style.display = node._stashedDisplay || "", "" === node.getAttribute("style") && node.removeAttribute("style")) : 3 === node.nodeType && (isHidden ? (node._stashedText = node.nodeValue, node.nodeValue = "") : node.nodeValue = node._stashedText || "");
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node) {
                if (0 === suspenseInstance) break;
                else suspenseInstance--;
            } else "$" !== node && "$?" !== node && "$~" !== node && "$!" !== node || suspenseInstance++;
        }
        node = nextNode;
    }while (node);
}
function $1e79381dc3a64a75$var$applyViewTransitionName(instance, name, className) {
    name = CSS.escape(name) !== name ? "r-" + btoa(name).replace(/=/g, "") : name;
    instance.style.viewTransitionName = name;
    null != className && (instance.style.viewTransitionClass = className);
    className = getComputedStyle(instance);
    if ("inline" === className.display) {
        name = instance.getClientRects();
        if (1 === name.length) var JSCompiler_inline_result = 1;
        else for(var i = JSCompiler_inline_result = 0; i < name.length; i++){
            var rect = name[i];
            0 < rect.width && 0 < rect.height && JSCompiler_inline_result++;
        }
        1 === JSCompiler_inline_result && (instance = instance.style, instance.display = 1 === name.length ? "inline-block" : "block", instance.marginTop = "-" + className.paddingTop, instance.marginBottom = "-" + className.paddingBottom);
    }
}
function $1e79381dc3a64a75$var$restoreViewTransitionName(instance, props) {
    instance = instance.style;
    props = props.style;
    var viewTransitionName = null != props ? props.hasOwnProperty("viewTransitionName") ? props.viewTransitionName : props.hasOwnProperty("view-transition-name") ? props["view-transition-name"] : null : null;
    instance.viewTransitionName = null == viewTransitionName || "boolean" === typeof viewTransitionName ? "" : ("" + viewTransitionName).trim();
    viewTransitionName = null != props ? props.hasOwnProperty("viewTransitionClass") ? props.viewTransitionClass : props.hasOwnProperty("view-transition-class") ? props["view-transition-class"] : null : null;
    instance.viewTransitionClass = null == viewTransitionName || "boolean" === typeof viewTransitionName ? "" : ("" + viewTransitionName).trim();
    "inline-block" === instance.display && (null == props ? instance.display = instance.margin = "" : (viewTransitionName = props.display, instance.display = null == viewTransitionName || "boolean" === typeof viewTransitionName ? "" : viewTransitionName, viewTransitionName = props.margin, null != viewTransitionName ? instance.margin = viewTransitionName : (viewTransitionName = props.hasOwnProperty("marginTop") ? props.marginTop : props["margin-top"], instance.marginTop = null == viewTransitionName || "boolean" === typeof viewTransitionName ? "" : viewTransitionName, props = props.hasOwnProperty("marginBottom") ? props.marginBottom : props["margin-bottom"], instance.marginBottom = null == props || "boolean" === typeof props ? "" : props)));
}
function $1e79381dc3a64a75$var$createMeasurement(rect, computedStyle, element) {
    element = element.ownerDocument.defaultView;
    return {
        rect: rect,
        abs: "absolute" === computedStyle.position || "fixed" === computedStyle.position,
        clip: "none" !== computedStyle.clipPath || "visible" !== computedStyle.overflow || "none" !== computedStyle.filter || "none" !== computedStyle.mask || "none" !== computedStyle.mask || "0px" !== computedStyle.borderRadius,
        view: 0 <= rect.bottom && 0 <= rect.right && rect.top <= element.innerHeight && rect.left <= element.innerWidth
    };
}
function $1e79381dc3a64a75$var$measureInstance(instance) {
    var rect = instance.getBoundingClientRect(), computedStyle = getComputedStyle(instance);
    return $1e79381dc3a64a75$var$createMeasurement(rect, computedStyle, instance);
}
function $1e79381dc3a64a75$var$measureClonedInstance(instance) {
    var measuredRect = instance.getBoundingClientRect();
    measuredRect = new DOMRect(measuredRect.x + 2e4, measuredRect.y + 2e4, measuredRect.width, measuredRect.height);
    var computedStyle = getComputedStyle(instance);
    return $1e79381dc3a64a75$var$createMeasurement(measuredRect, computedStyle, instance);
}
function $1e79381dc3a64a75$var$forceLayout(ownerDocument) {
    return ownerDocument.documentElement.clientHeight;
}
function $1e79381dc3a64a75$var$waitForImageToLoad(resolve) {
    this.addEventListener("load", resolve);
    this.addEventListener("error", resolve);
}
function $1e79381dc3a64a75$var$startViewTransition(suspendedState, rootContainer, transitionTypes, mutationCallback, layoutCallback, afterMutationCallback, spawnedWorkCallback, passiveCallback, errorCallback) {
    var ownerDocument = 9 === rootContainer.nodeType ? rootContainer : rootContainer.ownerDocument;
    try {
        var transition = ownerDocument.startViewTransition({
            update: function() {
                var ownerWindow = ownerDocument.defaultView, pendingNavigation = ownerWindow.navigation && ownerWindow.navigation.transition, previousFontLoadingStatus = ownerDocument.fonts.status;
                mutationCallback();
                var blockingPromises = [];
                "loaded" === previousFontLoadingStatus && ($1e79381dc3a64a75$var$forceLayout(ownerDocument), "loading" === ownerDocument.fonts.status && blockingPromises.push(ownerDocument.fonts.ready));
                previousFontLoadingStatus = blockingPromises.length;
                if (null !== suspendedState) for(var suspenseyImages = suspendedState.suspenseyImages, imgBytes = 0, i = 0; i < suspenseyImages.length; i++){
                    var suspenseyImage = suspenseyImages[i];
                    if (!suspenseyImage.complete) {
                        var rect = suspenseyImage.getBoundingClientRect();
                        if (0 < rect.bottom && 0 < rect.right && rect.top < ownerWindow.innerHeight && rect.left < ownerWindow.innerWidth) {
                            imgBytes += $1e79381dc3a64a75$var$estimateImageBytes(suspenseyImage);
                            if (imgBytes > $1e79381dc3a64a75$var$estimatedBytesWithinLimit) {
                                blockingPromises.length = previousFontLoadingStatus;
                                break;
                            }
                            suspenseyImage = new Promise($1e79381dc3a64a75$var$waitForImageToLoad.bind(suspenseyImage));
                            blockingPromises.push(suspenseyImage);
                        }
                    }
                }
                if (0 < blockingPromises.length) return ownerWindow = Promise.race([
                    Promise.all(blockingPromises),
                    new Promise(function(resolve) {
                        return setTimeout(resolve, 500);
                    })
                ]).then(layoutCallback, layoutCallback), (pendingNavigation ? Promise.allSettled([
                    pendingNavigation.finished,
                    ownerWindow
                ]) : ownerWindow).then(afterMutationCallback, afterMutationCallback);
                layoutCallback();
                if (pendingNavigation) return pendingNavigation.finished.then(afterMutationCallback, afterMutationCallback);
                afterMutationCallback();
            },
            types: transitionTypes
        });
        ownerDocument.__reactViewTransition = transition;
        var viewTransitionAnimations = [];
        transition.ready.then(function() {
            for(var animations = ownerDocument.documentElement.getAnimations({
                subtree: !0
            }), i = 0; i < animations.length; i++){
                var animation = animations[i], effect = animation.effect, pseudoElement = effect.pseudoElement;
                if (null != pseudoElement && pseudoElement.startsWith("::view-transition")) {
                    viewTransitionAnimations.push(animation);
                    animation = effect.getKeyframes();
                    for(var height = pseudoElement = void 0, unchangedDimensions = !0, j = 0; j < animation.length; j++){
                        var keyframe = animation[j], w = keyframe.width;
                        if (void 0 === pseudoElement) pseudoElement = w;
                        else if (pseudoElement !== w) {
                            unchangedDimensions = !1;
                            break;
                        }
                        w = keyframe.height;
                        if (void 0 === height) height = w;
                        else if (height !== w) {
                            unchangedDimensions = !1;
                            break;
                        }
                        delete keyframe.width;
                        delete keyframe.height;
                        "none" === keyframe.transform && delete keyframe.transform;
                    }
                    unchangedDimensions && void 0 !== pseudoElement && void 0 !== height && (effect.setKeyframes(animation), unchangedDimensions = getComputedStyle(effect.target, effect.pseudoElement), unchangedDimensions.width !== pseudoElement || unchangedDimensions.height !== height) && (unchangedDimensions = animation[0], unchangedDimensions.width = pseudoElement, unchangedDimensions.height = height, unchangedDimensions = animation[animation.length - 1], unchangedDimensions.width = pseudoElement, unchangedDimensions.height = height, effect.setKeyframes(animation));
                }
            }
            spawnedWorkCallback();
        }, function(error) {
            ownerDocument.__reactViewTransition === transition && (ownerDocument.__reactViewTransition = null);
            try {
                if ("object" === typeof error && null !== error) switch(error.name){
                    case "InvalidStateError":
                        if ("View transition was skipped because document visibility state is hidden." === error.message || "Skipping view transition because document visibility state has become hidden." === error.message || "Skipping view transition because viewport size changed." === error.message || "Transition was aborted because of invalid state" === error.message) error = null;
                }
                null !== error && errorCallback(error);
            } finally{
                mutationCallback(), layoutCallback(), spawnedWorkCallback();
            }
        });
        transition.finished.finally(function() {
            for(var i = 0; i < viewTransitionAnimations.length; i++)viewTransitionAnimations[i].cancel();
            ownerDocument.__reactViewTransition === transition && (ownerDocument.__reactViewTransition = null);
            passiveCallback();
        });
        return transition;
    } catch (x) {
        return mutationCallback(), layoutCallback(), spawnedWorkCallback(), null;
    }
}
function $1e79381dc3a64a75$var$ViewTransitionPseudoElement(pseudo, name) {
    this._scope = document.documentElement;
    this._selector = "::view-transition-" + pseudo + "(" + name + ")";
}
$1e79381dc3a64a75$var$ViewTransitionPseudoElement.prototype.animate = function(keyframes, options) {
    options = "number" === typeof options ? {
        duration: options
    } : $1e79381dc3a64a75$var$assign({}, options);
    options.pseudoElement = this._selector;
    return this._scope.animate(keyframes, options);
};
$1e79381dc3a64a75$var$ViewTransitionPseudoElement.prototype.getAnimations = function() {
    for(var scope = this._scope, selector = this._selector, animations = scope.getAnimations({
        subtree: !0
    }), result = [], i = 0; i < animations.length; i++){
        var effect = animations[i].effect;
        null !== effect && effect.target === scope && effect.pseudoElement === selector && result.push(animations[i]);
    }
    return result;
};
$1e79381dc3a64a75$var$ViewTransitionPseudoElement.prototype.getComputedStyle = function() {
    return getComputedStyle(this._scope, this._selector);
};
function $1e79381dc3a64a75$var$createViewTransitionInstance(name) {
    return {
        name: name,
        group: new $1e79381dc3a64a75$var$ViewTransitionPseudoElement("group", name),
        imagePair: new $1e79381dc3a64a75$var$ViewTransitionPseudoElement("image-pair", name),
        old: new $1e79381dc3a64a75$var$ViewTransitionPseudoElement("old", name),
        new: new $1e79381dc3a64a75$var$ViewTransitionPseudoElement("new", name)
    };
}
function $1e79381dc3a64a75$var$FragmentInstance(fragmentFiber) {
    this._fragmentFiber = fragmentFiber;
    this._observers = this._eventListeners = null;
}
$1e79381dc3a64a75$var$FragmentInstance.prototype.addEventListener = function(type, listener, optionsOrUseCapture) {
    var signal = null, cleanup = null;
    if (null != optionsOrUseCapture && "boolean" !== typeof optionsOrUseCapture && (signal = optionsOrUseCapture.signal || null, null !== signal && signal.aborted)) return;
    null === this._eventListeners && (this._eventListeners = []);
    var listeners = this._eventListeners;
    if (-1 === $1e79381dc3a64a75$var$indexOfEventListener(listeners, type, listener, optionsOrUseCapture)) {
        var fragmentInstance = this, attachedListener = listener;
        null != optionsOrUseCapture && "boolean" !== typeof optionsOrUseCapture && !0 === optionsOrUseCapture.once && (attachedListener = function(event) {
            fragmentInstance.removeEventListener(type, listener, optionsOrUseCapture);
            "function" === typeof listener ? listener.call(this, event) : listener.handleEvent(event);
        });
        null !== signal && (cleanup = fragmentInstance.removeEventListener.bind(fragmentInstance, type, listener, optionsOrUseCapture), signal.addEventListener("abort", cleanup, {
            once: !0
        }), cleanup = signal.removeEventListener.bind(signal, "abort", cleanup));
        signal = $1e79381dc3a64a75$var$getAttachOptions(optionsOrUseCapture);
        listeners.push({
            type: type,
            listener: listener,
            optionsOrUseCapture: optionsOrUseCapture,
            attachedListener: attachedListener,
            cleanup: cleanup
        });
        $1e79381dc3a64a75$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !1, $1e79381dc3a64a75$var$addEventListenerToChild, type, attachedListener, signal);
    }
    this._eventListeners = listeners;
};
function $1e79381dc3a64a75$var$addEventListenerToChild(child, type, listener, optionsOrUseCapture) {
    $1e79381dc3a64a75$var$getInstanceFromHostFiber(child).addEventListener(type, listener, optionsOrUseCapture);
    return !1;
}
$1e79381dc3a64a75$var$FragmentInstance.prototype.removeEventListener = function(type, listener, optionsOrUseCapture) {
    var listeners = this._eventListeners;
    if (null !== listeners && (listener = $1e79381dc3a64a75$var$indexOfEventListener(listeners, type, listener, optionsOrUseCapture), -1 !== listener)) {
        var _listeners$index = listeners[listener];
        optionsOrUseCapture = _listeners$index.attachedListener;
        var cleanup = _listeners$index.cleanup;
        _listeners$index = $1e79381dc3a64a75$var$getAttachOptions(_listeners$index.optionsOrUseCapture);
        $1e79381dc3a64a75$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !1, $1e79381dc3a64a75$var$removeEventListenerFromChild, type, optionsOrUseCapture, _listeners$index);
        listeners.splice(listener, 1);
        null !== cleanup && cleanup();
    }
};
function $1e79381dc3a64a75$var$removeEventListenerFromChild(child, type, listener, optionsOrUseCapture) {
    $1e79381dc3a64a75$var$getInstanceFromHostFiber(child).removeEventListener(type, listener, optionsOrUseCapture);
    return !1;
}
function $1e79381dc3a64a75$var$getAttachOptions(opts) {
    return null != opts && "boolean" !== typeof opts && (!0 === opts.once || opts.signal instanceof AbortSignal) ? {
        capture: opts.capture,
        passive: opts.passive
    } : opts;
}
function $1e79381dc3a64a75$var$normalizeListenerOptions(opts) {
    return null == opts ? "c=0" : "boolean" === typeof opts ? "c=" + (opts ? "1" : "0") : "c=" + (opts.capture ? "1" : "0");
}
function $1e79381dc3a64a75$var$indexOfEventListener(eventListeners, type, listener, optionsOrUseCapture) {
    if (0 === eventListeners.length) return -1;
    optionsOrUseCapture = $1e79381dc3a64a75$var$normalizeListenerOptions(optionsOrUseCapture);
    for(var i = 0; i < eventListeners.length; i++){
        var item = eventListeners[i];
        if (item.type === type && item.listener === listener && $1e79381dc3a64a75$var$normalizeListenerOptions(item.optionsOrUseCapture) === optionsOrUseCapture) return i;
    }
    return -1;
}
$1e79381dc3a64a75$var$FragmentInstance.prototype.dispatchEvent = function(event) {
    var parentHostFiber = $1e79381dc3a64a75$var$getFragmentParentInstanceOrContainerFiber(this._fragmentFiber);
    if (null === parentHostFiber) return !0;
    parentHostFiber = $1e79381dc3a64a75$var$getInstanceFromHostFiber(parentHostFiber);
    var eventListeners = this._eventListeners;
    if (null !== eventListeners && 0 < eventListeners.length || !event.bubbles) {
        var temp = 9 === parentHostFiber.nodeType ? parentHostFiber.createComment("") : document.createTextNode("");
        if (eventListeners) for(var i = 0; i < eventListeners.length; i++){
            var _eventListeners$i = eventListeners[i];
            temp.addEventListener(_eventListeners$i.type, _eventListeners$i.attachedListener, $1e79381dc3a64a75$var$getAttachOptions(_eventListeners$i.optionsOrUseCapture));
        }
        parentHostFiber.appendChild(temp);
        event = temp.dispatchEvent(event);
        if (eventListeners) for(i = 0; i < eventListeners.length; i++)_eventListeners$i = eventListeners[i], temp.removeEventListener(_eventListeners$i.type, _eventListeners$i.attachedListener, $1e79381dc3a64a75$var$getAttachOptions(_eventListeners$i.optionsOrUseCapture));
        parentHostFiber.removeChild(temp);
        return event;
    }
    return parentHostFiber.dispatchEvent(event);
};
$1e79381dc3a64a75$var$FragmentInstance.prototype.focus = function(focusOptions) {
    $1e79381dc3a64a75$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !0, $1e79381dc3a64a75$var$setFocusOnFiberIfFocusable, focusOptions, void 0, void 0);
};
function $1e79381dc3a64a75$var$setFocusOnFiberIfFocusable(fiber, focusOptions) {
    if (6 === fiber.tag) return !1;
    fiber = $1e79381dc3a64a75$var$getInstanceFromHostFiber(fiber);
    return $1e79381dc3a64a75$var$setFocusIfFocusable(fiber, focusOptions);
}
$1e79381dc3a64a75$var$FragmentInstance.prototype.focusLast = function(focusOptions) {
    var children = [];
    $1e79381dc3a64a75$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !0, $1e79381dc3a64a75$var$collectChildren, children, void 0, void 0);
    for(var i = children.length - 1; 0 <= i && !$1e79381dc3a64a75$var$setFocusOnFiberIfFocusable(children[i], focusOptions); i--);
};
function $1e79381dc3a64a75$var$collectChildren(child, collection) {
    collection.push(child);
    return !1;
}
$1e79381dc3a64a75$var$FragmentInstance.prototype.blur = function() {
    var parentHostFiber = $1e79381dc3a64a75$var$getFragmentParentInstanceOrContainerFiber(this._fragmentFiber);
    null !== parentHostFiber && (parentHostFiber = $1e79381dc3a64a75$var$getInstanceFromHostFiber(parentHostFiber), parentHostFiber = $1e79381dc3a64a75$var$getOwnerDocumentFromRootContainer(parentHostFiber).activeElement, null !== parentHostFiber && $1e79381dc3a64a75$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !1, $1e79381dc3a64a75$var$blurActiveElementWithinFragment, parentHostFiber, void 0, void 0));
};
function $1e79381dc3a64a75$var$blurActiveElementWithinFragment(child, activeElement) {
    if (6 === child.tag) return !1;
    child = $1e79381dc3a64a75$var$getInstanceFromHostFiber(child);
    return child === activeElement || child.contains(activeElement) ? (activeElement.blur(), !0) : !1;
}
$1e79381dc3a64a75$var$FragmentInstance.prototype.observeUsing = function(observer) {
    null === this._observers && (this._observers = new Set());
    this._observers.add(observer);
    $1e79381dc3a64a75$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !1, $1e79381dc3a64a75$var$observeChild, observer, void 0, void 0);
};
function $1e79381dc3a64a75$var$observeChild(child, observer) {
    if (6 === child.tag) return !1;
    child = $1e79381dc3a64a75$var$getInstanceFromHostFiber(child);
    observer.observe(child);
    return !1;
}
$1e79381dc3a64a75$var$FragmentInstance.prototype.unobserveUsing = function(observer) {
    var observers = this._observers;
    if (null !== observers && observers.has(observer)) {
        observers.delete(observer);
        $1e79381dc3a64a75$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !1, $1e79381dc3a64a75$var$unobserveChild, observer, void 0, void 0);
        for(var i = observers = 0; i < $1e79381dc3a64a75$var$pendingIntersectionUnobserves.length; i++){
            var pending = $1e79381dc3a64a75$var$pendingIntersectionUnobserves[i];
            pending.fragmentInstance === this && pending.observer === observer ? observer.unobserve(pending.instance) : $1e79381dc3a64a75$var$pendingIntersectionUnobserves[observers++] = pending;
        }
        $1e79381dc3a64a75$var$pendingIntersectionUnobserves.length = observers;
    }
};
function $1e79381dc3a64a75$var$unobserveChild(child, observer) {
    if (6 === child.tag) return !1;
    child = $1e79381dc3a64a75$var$getInstanceFromHostFiber(child);
    observer.unobserve(child);
    return !1;
}
var $1e79381dc3a64a75$var$pendingIntersectionUnobserves = [], $1e79381dc3a64a75$var$intersectionUnobserveScheduled = !1;
function $1e79381dc3a64a75$var$schedulePendingIntersectionUnobserve(fragmentInstance, observer, instance) {
    $1e79381dc3a64a75$var$pendingIntersectionUnobserves.push({
        fragmentInstance: fragmentInstance,
        observer: observer,
        instance: instance
    });
    $1e79381dc3a64a75$var$intersectionUnobserveScheduled || ($1e79381dc3a64a75$var$intersectionUnobserveScheduled = !0, $1e79381dc3a64a75$var$requestPostPaintCallback(function() {
        $1e79381dc3a64a75$var$intersectionUnobserveScheduled = !1;
        var pending = $1e79381dc3a64a75$var$pendingIntersectionUnobserves;
        $1e79381dc3a64a75$var$pendingIntersectionUnobserves = [];
        for(var i = 0; i < pending.length; i++){
            var item = pending[i];
            item.observer.unobserve(item.instance);
        }
    }));
}
$1e79381dc3a64a75$var$FragmentInstance.prototype.getClientRects = function() {
    var rects = [];
    $1e79381dc3a64a75$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !1, $1e79381dc3a64a75$var$collectClientRects, rects, void 0, void 0);
    return rects;
};
function $1e79381dc3a64a75$var$collectClientRects(child, rects) {
    if (6 === child.tag) {
        child = child.stateNode;
        var range = child.ownerDocument.createRange();
        range.selectNodeContents(child);
        rects.push.apply(rects, range.getClientRects());
    } else child = $1e79381dc3a64a75$var$getInstanceFromHostFiber(child), rects.push.apply(rects, child.getClientRects());
    return !1;
}
$1e79381dc3a64a75$var$FragmentInstance.prototype.getRootNode = function(getRootNodeOptions) {
    var parentHostFiber = $1e79381dc3a64a75$var$getFragmentParentInstanceOrContainerFiber(this._fragmentFiber);
    return null === parentHostFiber ? this : $1e79381dc3a64a75$var$getInstanceFromHostFiber(parentHostFiber).getRootNode(getRootNodeOptions);
};
$1e79381dc3a64a75$var$FragmentInstance.prototype.compareDocumentPosition = function(otherNode) {
    var parentHostFiber = $1e79381dc3a64a75$var$getFragmentParentInstanceOrContainerFiber(this._fragmentFiber);
    if (null === parentHostFiber) return Node.DOCUMENT_POSITION_DISCONNECTED;
    var children = [];
    $1e79381dc3a64a75$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !1, $1e79381dc3a64a75$var$collectChildren, children, void 0, void 0);
    var parentHostInstance = $1e79381dc3a64a75$var$getInstanceFromHostFiber(parentHostFiber);
    if (0 === children.length) {
        children = parentHostInstance;
        if ($1e79381dc3a64a75$var$fiberIsPortaledIntoHost(this._fragmentFiber)) {
            a: {
                for(parentHostFiber = this._fragmentFiber.return; null !== parentHostFiber;){
                    if (4 === parentHostFiber.tag) {
                        parentHostFiber = parentHostFiber.stateNode.containerInfo;
                        break a;
                    }
                    if (3 === parentHostFiber.tag || 5 === parentHostFiber.tag || 27 === parentHostFiber.tag) break;
                    parentHostFiber = parentHostFiber.return;
                }
                parentHostFiber = null;
            }
            null != parentHostFiber && (children = parentHostFiber);
        }
        parentHostFiber = this._fragmentFiber;
        var result = parentHostInstance = children.compareDocumentPosition(otherNode);
        children === otherNode ? result = Node.DOCUMENT_POSITION_CONTAINS : parentHostInstance & Node.DOCUMENT_POSITION_CONTAINED_BY && (children = $1e79381dc3a64a75$var$getFragmentInstanceOrTextInstanceSiblings(parentHostFiber)[1], null === children ? result = Node.DOCUMENT_POSITION_PRECEDING : (otherNode = $1e79381dc3a64a75$var$getInstanceFromHostFiber(children).compareDocumentPosition(otherNode), result = 0 === otherNode || otherNode & Node.DOCUMENT_POSITION_FOLLOWING ? Node.DOCUMENT_POSITION_FOLLOWING : Node.DOCUMENT_POSITION_PRECEDING));
        return result |= Node.DOCUMENT_POSITION_IMPLEMENTATION_SPECIFIC;
    }
    parentHostFiber = $1e79381dc3a64a75$var$getInstanceFromHostFiber(children[0]);
    result = $1e79381dc3a64a75$var$getInstanceFromHostFiber(children[children.length - 1]);
    var parentHostInstanceFromDOM = $1e79381dc3a64a75$var$fiberIsPortaledIntoHost(this._fragmentFiber) ? parentHostFiber.parentElement : parentHostInstance;
    if (null == parentHostInstanceFromDOM) return Node.DOCUMENT_POSITION_DISCONNECTED;
    parentHostInstance = parentHostInstanceFromDOM.compareDocumentPosition(parentHostFiber) & Node.DOCUMENT_POSITION_CONTAINED_BY;
    parentHostInstanceFromDOM = parentHostInstanceFromDOM.compareDocumentPosition(result) & Node.DOCUMENT_POSITION_CONTAINED_BY;
    var firstResult = parentHostFiber.compareDocumentPosition(otherNode), lastResult = result.compareDocumentPosition(otherNode), otherNodeIsWithinFirstOrLastChild = firstResult & Node.DOCUMENT_POSITION_CONTAINED_BY || lastResult & Node.DOCUMENT_POSITION_CONTAINED_BY;
    lastResult = parentHostInstance && parentHostInstanceFromDOM && firstResult & Node.DOCUMENT_POSITION_FOLLOWING && lastResult & Node.DOCUMENT_POSITION_PRECEDING;
    parentHostFiber = parentHostInstance && parentHostFiber === otherNode || parentHostInstanceFromDOM && result === otherNode || otherNodeIsWithinFirstOrLastChild || lastResult ? Node.DOCUMENT_POSITION_CONTAINED_BY : !parentHostInstance && parentHostFiber === otherNode || !parentHostInstanceFromDOM && result === otherNode ? Node.DOCUMENT_POSITION_IMPLEMENTATION_SPECIFIC : firstResult;
    return parentHostFiber & Node.DOCUMENT_POSITION_DISCONNECTED || parentHostFiber & Node.DOCUMENT_POSITION_IMPLEMENTATION_SPECIFIC || $1e79381dc3a64a75$var$validateDocumentPositionWithFiberTree(parentHostFiber, this._fragmentFiber, children[0], children[children.length - 1], otherNode) ? parentHostFiber : Node.DOCUMENT_POSITION_IMPLEMENTATION_SPECIFIC;
};
function $1e79381dc3a64a75$var$validateDocumentPositionWithFiberTree(documentPosition, fragmentFiber, precedingBoundaryFiber, followingBoundaryFiber, otherNode) {
    var otherFiber = $1e79381dc3a64a75$var$getClosestInstanceFromNode(otherNode);
    if (documentPosition & Node.DOCUMENT_POSITION_CONTAINED_BY) {
        if (precedingBoundaryFiber = !!otherFiber) a: {
            for(; null !== otherFiber;){
                if (7 === otherFiber.tag && (otherFiber === fragmentFiber || otherFiber.alternate === fragmentFiber)) {
                    precedingBoundaryFiber = !0;
                    break a;
                }
                otherFiber = otherFiber.return;
            }
            precedingBoundaryFiber = !1;
        }
        return precedingBoundaryFiber;
    }
    if (documentPosition & Node.DOCUMENT_POSITION_CONTAINS) {
        if (null === otherFiber) return otherFiber = otherNode.ownerDocument, otherNode === otherFiber || otherNode === otherFiber.documentElement || otherNode === otherFiber.body;
        a: {
            otherFiber = fragmentFiber;
            for(fragmentFiber = $1e79381dc3a64a75$var$getFragmentParentInstanceOrContainerFiber(fragmentFiber); null !== otherFiber;){
                if (!(5 !== otherFiber.tag && 3 !== otherFiber.tag && 27 !== otherFiber.tag || otherFiber !== fragmentFiber && otherFiber.alternate !== fragmentFiber)) {
                    otherFiber = !0;
                    break a;
                }
                otherFiber = otherFiber.return;
            }
            otherFiber = !1;
        }
        return otherFiber;
    }
    return documentPosition & Node.DOCUMENT_POSITION_PRECEDING ? ((fragmentFiber = !!otherFiber) && !(fragmentFiber = otherFiber === precedingBoundaryFiber) && (fragmentFiber = $1e79381dc3a64a75$var$getLowestCommonAncestor(precedingBoundaryFiber, otherFiber, $1e79381dc3a64a75$var$getParentForFragmentAncestors), null === fragmentFiber ? fragmentFiber = !1 : ($1e79381dc3a64a75$var$traverseVisibleInstancesAndTextInstances(fragmentFiber, !0, $1e79381dc3a64a75$var$isFiberPrecedingCheck, otherFiber, precedingBoundaryFiber), otherFiber = $1e79381dc3a64a75$var$searchTarget, $1e79381dc3a64a75$var$searchTarget = null, fragmentFiber = null !== otherFiber)), fragmentFiber) : documentPosition & Node.DOCUMENT_POSITION_FOLLOWING ? ((fragmentFiber = !!otherFiber) && !(fragmentFiber = otherFiber === followingBoundaryFiber) && (fragmentFiber = $1e79381dc3a64a75$var$getLowestCommonAncestor(followingBoundaryFiber, otherFiber, $1e79381dc3a64a75$var$getParentForFragmentAncestors), null === fragmentFiber ? fragmentFiber = !1 : ($1e79381dc3a64a75$var$traverseVisibleInstancesAndTextInstances(fragmentFiber, !0, $1e79381dc3a64a75$var$isFiberFollowingCheck, otherFiber, followingBoundaryFiber), otherFiber = $1e79381dc3a64a75$var$searchTarget, $1e79381dc3a64a75$var$searchBoundary = $1e79381dc3a64a75$var$searchTarget = null, fragmentFiber = null !== otherFiber)), fragmentFiber) : !1;
}
function $1e79381dc3a64a75$var$scrollTextNodeIntoView(textNode, resolvedAlignToTop) {
    var range = textNode.ownerDocument.createRange();
    range.selectNodeContents(textNode);
    textNode = range.getBoundingClientRect();
    window.scrollTo(window.scrollX + textNode.left, resolvedAlignToTop ? window.scrollY + textNode.top : window.scrollY + textNode.bottom - window.innerHeight);
}
$1e79381dc3a64a75$var$FragmentInstance.prototype.scrollIntoView = function(alignToTop) {
    if ("object" === typeof alignToTop) throw Error($1e79381dc3a64a75$var$formatProdErrorMessage(566));
    var children = [];
    $1e79381dc3a64a75$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !1, $1e79381dc3a64a75$var$collectChildren, children, void 0, void 0);
    var resolvedAlignToTop = !1 !== alignToTop;
    if (0 === children.length) {
        var hostSiblings = $1e79381dc3a64a75$var$getFragmentInstanceOrTextInstanceSiblings(this._fragmentFiber);
        hostSiblings = resolvedAlignToTop ? hostSiblings[1] || hostSiblings[0] || $1e79381dc3a64a75$var$getFragmentParentInstanceOrContainerFiber(this._fragmentFiber) : hostSiblings[0] || hostSiblings[1];
        if (null === hostSiblings) return;
        if (6 === hostSiblings.tag) {
            alignToTop = $1e79381dc3a64a75$var$getInstanceFromHostFiber(hostSiblings);
            $1e79381dc3a64a75$var$scrollTextNodeIntoView(alignToTop, resolvedAlignToTop);
            return;
        }
        hostSiblings = $1e79381dc3a64a75$var$getInstanceFromHostFiber(hostSiblings);
        if (9 !== hostSiblings.nodeType) {
            if (11 === hostSiblings.nodeType) {
                resolvedAlignToTop = "host" in hostSiblings ? hostSiblings.host : null;
                null !== resolvedAlignToTop && resolvedAlignToTop.scrollIntoView(alignToTop);
                return;
            }
            hostSiblings.scrollIntoView(alignToTop);
        }
    }
    for(hostSiblings = resolvedAlignToTop ? children.length - 1 : 0; hostSiblings !== (resolvedAlignToTop ? -1 : children.length);){
        var child = children[hostSiblings];
        6 === child.tag ? (child = $1e79381dc3a64a75$var$getInstanceFromHostFiber(child), $1e79381dc3a64a75$var$scrollTextNodeIntoView(child, resolvedAlignToTop)) : $1e79381dc3a64a75$var$getInstanceFromHostFiber(child).scrollIntoView(alignToTop);
        hostSiblings += resolvedAlignToTop ? -1 : 1;
    }
};
function $1e79381dc3a64a75$var$addFragmentHandleToFiber(child, fragmentInstance) {
    child = $1e79381dc3a64a75$var$getInstanceFromHostFiber(child);
    $1e79381dc3a64a75$var$addFragmentHandleToInstance(child, fragmentInstance);
    return !1;
}
function $1e79381dc3a64a75$var$addFragmentHandleToInstance(instance, fragmentInstance) {
    null == instance.reactFragments && (instance.reactFragments = new Set());
    instance.reactFragments.add(fragmentInstance);
}
function $1e79381dc3a64a75$var$commitNewChildToFragmentInstance(childInstance, fragmentInstance) {
    var eventListeners = fragmentInstance._eventListeners;
    if (null !== eventListeners) for(var i$jscomp$0 = 0; i$jscomp$0 < eventListeners.length; i$jscomp$0++){
        var _eventListeners$i3 = eventListeners[i$jscomp$0];
        childInstance.addEventListener(_eventListeners$i3.type, _eventListeners$i3.attachedListener, $1e79381dc3a64a75$var$getAttachOptions(_eventListeners$i3.optionsOrUseCapture));
    }
    3 !== childInstance.nodeType && (eventListeners = fragmentInstance._observers, null !== eventListeners && eventListeners.forEach(function(observer) {
        for(var writeIdx = 0, i = 0; i < $1e79381dc3a64a75$var$pendingIntersectionUnobserves.length; i++){
            var pending = $1e79381dc3a64a75$var$pendingIntersectionUnobserves[i];
            if (pending.fragmentInstance !== fragmentInstance || pending.observer !== observer || pending.instance !== childInstance) $1e79381dc3a64a75$var$pendingIntersectionUnobserves[writeIdx++] = pending;
        }
        $1e79381dc3a64a75$var$pendingIntersectionUnobserves.length = writeIdx;
        observer.observe(childInstance);
    }), $1e79381dc3a64a75$var$addFragmentHandleToInstance(childInstance, fragmentInstance));
}
function $1e79381dc3a64a75$var$deleteChildFromFragmentInstance(childInstance, fragmentInstance) {
    var eventListeners = fragmentInstance._eventListeners;
    if (null !== eventListeners) for(var i = 0; i < eventListeners.length; i++){
        var _eventListeners$i4 = eventListeners[i];
        childInstance.removeEventListener(_eventListeners$i4.type, _eventListeners$i4.attachedListener, $1e79381dc3a64a75$var$getAttachOptions(_eventListeners$i4.optionsOrUseCapture));
    }
    3 !== childInstance.nodeType && (eventListeners = fragmentInstance._observers, null !== eventListeners && eventListeners.forEach(function(observer) {
        "string" === typeof observer.rootMargin ? $1e79381dc3a64a75$var$schedulePendingIntersectionUnobserve(fragmentInstance, observer, childInstance) : observer.unobserve(childInstance);
    }), null != childInstance.reactFragments && childInstance.reactFragments.delete(fragmentInstance));
}
function $1e79381dc3a64a75$var$clearContainerSparingly(container) {
    var nextNode = container.firstChild;
    nextNode && 10 === nextNode.nodeType && (nextNode = nextNode.nextSibling);
    for(; nextNode;){
        var node = nextNode;
        nextNode = nextNode.nextSibling;
        switch(node.nodeName){
            case "HTML":
            case "HEAD":
            case "BODY":
                $1e79381dc3a64a75$var$clearContainerSparingly(node);
                $1e79381dc3a64a75$var$detachDeletedInstance(node);
                continue;
            case "SCRIPT":
            case "STYLE":
                continue;
            case "LINK":
                if ("stylesheet" === node.rel.toLowerCase()) continue;
        }
        container.removeChild(node);
    }
}
function $1e79381dc3a64a75$var$canHydrateInstance(instance, type, props, inRootOrSingleton) {
    for(; 1 === instance.nodeType;){
        var anyProps = props;
        if (instance.nodeName.toLowerCase() !== type.toLowerCase()) {
            if (!inRootOrSingleton && ("INPUT" !== instance.nodeName || "hidden" !== instance.type)) break;
        } else if (!inRootOrSingleton) {
            if ("input" === type && "hidden" === instance.type) {
                var name = null == anyProps.name ? null : "" + anyProps.name;
                if ("hidden" === anyProps.type && instance.getAttribute("name") === name) return instance;
            } else return instance;
        } else if (!instance[$1e79381dc3a64a75$var$internalHoistableMarker]) switch(type){
            case "meta":
                if (!instance.hasAttribute("itemprop")) break;
                return instance;
            case "link":
                name = instance.getAttribute("rel");
                if ("stylesheet" === name && instance.hasAttribute("data-precedence")) break;
                else if (name !== anyProps.rel || instance.getAttribute("href") !== (null == anyProps.href || "" === anyProps.href ? null : anyProps.href) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin) || instance.getAttribute("title") !== (null == anyProps.title ? null : anyProps.title)) break;
                return instance;
            case "style":
                if (instance.hasAttribute("data-precedence")) break;
                return instance;
            case "script":
                name = instance.getAttribute("src");
                if ((name !== (null == anyProps.src ? null : anyProps.src) || instance.getAttribute("type") !== (null == anyProps.type ? null : anyProps.type) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin)) && name && instance.hasAttribute("async") && !instance.hasAttribute("itemprop")) break;
                return instance;
            default:
                return instance;
        }
        instance = $1e79381dc3a64a75$var$getNextHydratable(instance.nextSibling);
        if (null === instance) break;
    }
    return null;
}
function $1e79381dc3a64a75$var$canHydrateTextInstance(instance, text, inRootOrSingleton) {
    if ("" === text) return null;
    for(; 3 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $1e79381dc3a64a75$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $1e79381dc3a64a75$var$canHydrateHydrationBoundary(instance, inRootOrSingleton) {
    for(; 8 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $1e79381dc3a64a75$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $1e79381dc3a64a75$var$isSuspenseInstancePending(instance) {
    return "$?" === instance.data || "$~" === instance.data;
}
function $1e79381dc3a64a75$var$isSuspenseInstanceFallback(instance) {
    return "$!" === instance.data || "$?" === instance.data && "loading" !== instance.ownerDocument.readyState;
}
function $1e79381dc3a64a75$var$registerSuspenseInstanceRetry(instance, callback) {
    var ownerDocument = instance.ownerDocument;
    if ("$~" === instance.data) instance._reactRetry = callback;
    else if ("$?" !== instance.data || "loading" !== ownerDocument.readyState) callback();
    else {
        var listener = function() {
            callback();
            ownerDocument.removeEventListener("DOMContentLoaded", listener);
        };
        ownerDocument.addEventListener("DOMContentLoaded", listener);
        instance._reactRetry = listener;
    }
}
function $1e79381dc3a64a75$var$getNextHydratable(node) {
    for(; null != node; node = node.nextSibling){
        var nodeType = node.nodeType;
        if (1 === nodeType || 3 === nodeType) break;
        if (8 === nodeType) {
            nodeType = node.data;
            if ("$" === nodeType || "$!" === nodeType || "$?" === nodeType || "$~" === nodeType || "&" === nodeType || "F!" === nodeType || "F" === nodeType) break;
            if ("/$" === nodeType || "/&" === nodeType) return null;
        }
    }
    return node;
}
var $1e79381dc3a64a75$var$previousHydratableOnEnteringScopedSingleton = null;
function $1e79381dc3a64a75$var$getNextHydratableInstanceAfterHydrationBoundary(hydrationInstance) {
    hydrationInstance = hydrationInstance.nextSibling;
    for(var depth = 0; hydrationInstance;){
        if (8 === hydrationInstance.nodeType) {
            var data = hydrationInstance.data;
            if ("/$" === data || "/&" === data) {
                if (0 === depth) return $1e79381dc3a64a75$var$getNextHydratable(hydrationInstance.nextSibling);
                depth--;
            } else "$" !== data && "$!" !== data && "$?" !== data && "$~" !== data && "&" !== data || depth++;
        }
        hydrationInstance = hydrationInstance.nextSibling;
    }
    return null;
}
function $1e79381dc3a64a75$var$getParentHydrationBoundary(targetInstance) {
    targetInstance = targetInstance.previousSibling;
    for(var depth = 0; targetInstance;){
        if (8 === targetInstance.nodeType) {
            var data = targetInstance.data;
            if ("$" === data || "$!" === data || "$?" === data || "$~" === data || "&" === data) {
                if (0 === depth) return targetInstance;
                depth--;
            } else "/$" !== data && "/&" !== data || depth++;
        }
        targetInstance = targetInstance.previousSibling;
    }
    return null;
}
function $1e79381dc3a64a75$var$setFocusIfFocusable(node, focusOptions) {
    function handleFocus() {
        didFocus = !0;
    }
    if (node.ownerDocument.activeElement === node) return !0;
    var didFocus = !1;
    try {
        node.ownerDocument.addEventListener("focus", handleFocus, !0), (node.focus || HTMLElement.prototype.focus).call(node, focusOptions);
    } finally{
        node.ownerDocument.removeEventListener("focus", handleFocus, !0);
    }
    return didFocus;
}
function $1e79381dc3a64a75$var$requestPostPaintCallback(callback) {
    $1e79381dc3a64a75$var$localRequestAnimationFrame(function() {
        $1e79381dc3a64a75$var$localRequestAnimationFrame(function(time) {
            return callback(time);
        });
    });
}
function $1e79381dc3a64a75$var$resolveSingletonInstance(type, props, rootContainerInstance) {
    props = $1e79381dc3a64a75$var$getOwnerDocumentFromRootContainer(rootContainerInstance);
    switch(type){
        case "html":
            type = props.documentElement;
            if (!type) throw Error($1e79381dc3a64a75$var$formatProdErrorMessage(452));
            return type;
        case "head":
            type = props.head;
            if (!type) throw Error($1e79381dc3a64a75$var$formatProdErrorMessage(453));
            return type;
        case "body":
            type = props.body;
            if (!type) throw Error($1e79381dc3a64a75$var$formatProdErrorMessage(454));
            return type;
        default:
            throw Error($1e79381dc3a64a75$var$formatProdErrorMessage(451));
    }
}
function $1e79381dc3a64a75$var$releaseSingletonInstance(instance, type, props) {
    for(var propKey in props){
        var propValue = props[propKey];
        props.hasOwnProperty(propKey) && null != propValue && $1e79381dc3a64a75$var$setProp(instance, type, propKey, null, $1e79381dc3a64a75$var$emptyProps, propValue);
    }
    null != props.dangerouslySetInnerHTML && (instance.textContent = "");
    instance.onclick === $1e79381dc3a64a75$var$noop$1 && (instance.onclick = null);
    $1e79381dc3a64a75$var$detachDeletedInstance(instance);
}
function $1e79381dc3a64a75$var$clearSingletonPreambleContribution(instance) {
    for(var attributes = instance.attributes; attributes.length;)instance.removeAttributeNode(attributes[0]);
    $1e79381dc3a64a75$var$detachDeletedInstance(instance);
}
var $1e79381dc3a64a75$var$preloadPropsMap = new Map(), $1e79381dc3a64a75$var$preconnectsSet = new Set();
function $1e79381dc3a64a75$var$getHoistableRoot(container) {
    if ("function" === typeof container.getRootNode) {
        var rootNode = container.getRootNode();
        if (9 === rootNode.nodeType || 11 === rootNode.nodeType) return rootNode;
    }
    return 9 === container.nodeType ? container : container.ownerDocument;
}
var $1e79381dc3a64a75$var$previousDispatcher = $1e79381dc3a64a75$var$ReactDOMSharedInternals.d;
$1e79381dc3a64a75$var$ReactDOMSharedInternals.d = {
    f: $1e79381dc3a64a75$var$flushSyncWork,
    r: $1e79381dc3a64a75$var$requestFormReset,
    D: $1e79381dc3a64a75$var$prefetchDNS,
    C: $1e79381dc3a64a75$var$preconnect,
    L: $1e79381dc3a64a75$var$preload,
    m: $1e79381dc3a64a75$var$preloadModule,
    X: $1e79381dc3a64a75$var$preinitScript,
    S: $1e79381dc3a64a75$var$preinitStyle,
    M: $1e79381dc3a64a75$var$preinitModuleScript
};
function $1e79381dc3a64a75$var$flushSyncWork() {
    var previousWasRendering = $1e79381dc3a64a75$var$previousDispatcher.f(), wasRendering = $1e79381dc3a64a75$var$flushSyncWork$1();
    return previousWasRendering || wasRendering;
}
function $1e79381dc3a64a75$var$requestFormReset(form) {
    var formInst = $1e79381dc3a64a75$var$getInstanceFromNode(form);
    null !== formInst && 5 === formInst.tag && "form" === formInst.type ? $1e79381dc3a64a75$var$requestFormReset$1(formInst) : $1e79381dc3a64a75$var$previousDispatcher.r(form);
}
var $1e79381dc3a64a75$var$globalDocument = "undefined" === typeof document ? null : document;
function $1e79381dc3a64a75$var$preconnectAs(rel, href, crossOrigin) {
    var ownerDocument = $1e79381dc3a64a75$var$globalDocument;
    if (ownerDocument && "string" === typeof href && href) {
        var limitedEscapedHref = $1e79381dc3a64a75$var$escapeSelectorAttributeValueInsideDoubleQuotes(href);
        limitedEscapedHref = 'link[rel="' + rel + '"][href="' + limitedEscapedHref + '"]';
        "string" === typeof crossOrigin && (limitedEscapedHref += '[crossorigin="' + crossOrigin + '"]');
        $1e79381dc3a64a75$var$preconnectsSet.has(limitedEscapedHref) || ($1e79381dc3a64a75$var$preconnectsSet.add(limitedEscapedHref), rel = {
            rel: rel,
            crossOrigin: crossOrigin,
            href: href
        }, null === ownerDocument.querySelector(limitedEscapedHref) && (href = ownerDocument.createElement("link"), $1e79381dc3a64a75$var$setInitialProperties(href, "link", rel), $1e79381dc3a64a75$var$markNodeAsHoistable(href), ownerDocument.head.appendChild(href)));
    }
}
function $1e79381dc3a64a75$var$prefetchDNS(href) {
    $1e79381dc3a64a75$var$previousDispatcher.D(href);
    $1e79381dc3a64a75$var$preconnectAs("dns-prefetch", href, null);
}
function $1e79381dc3a64a75$var$preconnect(href, crossOrigin) {
    $1e79381dc3a64a75$var$previousDispatcher.C(href, crossOrigin);
    $1e79381dc3a64a75$var$preconnectAs("preconnect", href, crossOrigin);
}
function $1e79381dc3a64a75$var$preload(href, as, options) {
    $1e79381dc3a64a75$var$previousDispatcher.L(href, as, options);
    var ownerDocument = $1e79381dc3a64a75$var$globalDocument;
    if (ownerDocument && href && as) {
        var preloadSelector = 'link[rel="preload"][as="' + $1e79381dc3a64a75$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"]';
        "image" === as ? options && options.imageSrcSet ? (preloadSelector += '[imagesrcset="' + $1e79381dc3a64a75$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSrcSet) + '"]', "string" === typeof options.imageSizes && (preloadSelector += '[imagesizes="' + $1e79381dc3a64a75$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSizes) + '"]')) : preloadSelector += '[href="' + $1e79381dc3a64a75$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]' : preloadSelector += '[href="' + $1e79381dc3a64a75$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]';
        var key = preloadSelector;
        switch(as){
            case "style":
                key = $1e79381dc3a64a75$var$getStyleKey(href);
                break;
            case "script":
                key = $1e79381dc3a64a75$var$getScriptKey(href);
        }
        if (!($1e79381dc3a64a75$var$preloadPropsMap.has(key) || (href = $1e79381dc3a64a75$var$assign({
            rel: "preload",
            href: "image" === as && options && options.imageSrcSet ? void 0 : href,
            as: as
        }, options), $1e79381dc3a64a75$var$preloadPropsMap.set(key, href), null !== ownerDocument.querySelector(preloadSelector) || "style" === as && ownerDocument.querySelector($1e79381dc3a64a75$var$getStylesheetSelectorFromKey(key)) || "script" === as && ownerDocument.querySelector($1e79381dc3a64a75$var$getScriptSelectorFromKey(key))))) {
            var instance = ownerDocument.createElement("link");
            $1e79381dc3a64a75$var$setInitialProperties(instance, "link", href);
            "style" === as && (instance[$1e79381dc3a64a75$var$internalLoadPendingKey] = !0, instance.onload = instance.onerror = function() {
                $1e79381dc3a64a75$var$clearPendingLoadOnNode(instance);
            });
            $1e79381dc3a64a75$var$markNodeAsHoistable(instance);
            ownerDocument.head.appendChild(instance);
        }
    }
}
function $1e79381dc3a64a75$var$preloadModule(href, options) {
    $1e79381dc3a64a75$var$previousDispatcher.m(href, options);
    var ownerDocument = $1e79381dc3a64a75$var$globalDocument;
    if (ownerDocument && href) {
        var as = options && "string" === typeof options.as ? options.as : "script", preloadSelector = 'link[rel="modulepreload"][as="' + $1e79381dc3a64a75$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"][href="' + $1e79381dc3a64a75$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]', key = preloadSelector;
        switch(as){
            case "audioworklet":
            case "paintworklet":
            case "serviceworker":
            case "sharedworker":
            case "worker":
            case "script":
                key = $1e79381dc3a64a75$var$getScriptKey(href);
        }
        if (!$1e79381dc3a64a75$var$preloadPropsMap.has(key) && (href = $1e79381dc3a64a75$var$assign({
            rel: "modulepreload",
            href: href
        }, options), $1e79381dc3a64a75$var$preloadPropsMap.set(key, href), null === ownerDocument.querySelector(preloadSelector))) {
            switch(as){
                case "audioworklet":
                case "paintworklet":
                case "serviceworker":
                case "sharedworker":
                case "worker":
                case "script":
                    if (ownerDocument.querySelector($1e79381dc3a64a75$var$getScriptSelectorFromKey(key))) return;
            }
            as = ownerDocument.createElement("link");
            $1e79381dc3a64a75$var$setInitialProperties(as, "link", href);
            $1e79381dc3a64a75$var$markNodeAsHoistable(as);
            ownerDocument.head.appendChild(as);
        }
    }
}
function $1e79381dc3a64a75$var$preinitStyle(href, precedence, options) {
    $1e79381dc3a64a75$var$previousDispatcher.S(href, precedence, options);
    var ownerDocument = $1e79381dc3a64a75$var$globalDocument;
    if (ownerDocument && href) {
        var styles = $1e79381dc3a64a75$var$getResourcesFromRoot(ownerDocument).hoistableStyles, key = $1e79381dc3a64a75$var$getStyleKey(href);
        precedence = precedence || "default";
        var resource = styles.get(key);
        if (!resource) {
            var state = {
                loading: 0,
                preload: null
            };
            if (resource = ownerDocument.querySelector($1e79381dc3a64a75$var$getStylesheetSelectorFromKey(key))) state.loading = 5;
            else {
                href = $1e79381dc3a64a75$var$assign({
                    rel: "stylesheet",
                    href: href,
                    "data-precedence": precedence
                }, options);
                (options = $1e79381dc3a64a75$var$preloadPropsMap.get(key)) && $1e79381dc3a64a75$var$adoptPreloadPropsForStylesheet(href, options);
                var link = resource = ownerDocument.createElement("link");
                $1e79381dc3a64a75$var$markNodeAsHoistable(link);
                $1e79381dc3a64a75$var$setInitialProperties(link, "link", href);
                link._p = new Promise(function(resolve, reject) {
                    link.onload = resolve;
                    link.onerror = reject;
                });
                link.addEventListener("load", function() {
                    state.loading |= 1;
                });
                link.addEventListener("error", function() {
                    state.loading |= 2;
                });
                state.loading |= 4;
                $1e79381dc3a64a75$var$insertStylesheet(resource, precedence, ownerDocument);
            }
            resource = {
                type: "stylesheet",
                instance: resource,
                count: 1,
                state: state
            };
            styles.set(key, resource);
        }
    }
}
function $1e79381dc3a64a75$var$preinitScript(src, options) {
    $1e79381dc3a64a75$var$previousDispatcher.X(src, options);
    var ownerDocument = $1e79381dc3a64a75$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $1e79381dc3a64a75$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $1e79381dc3a64a75$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($1e79381dc3a64a75$var$getScriptSelectorFromKey(key)), resource || (src = $1e79381dc3a64a75$var$assign({
            src: src,
            async: !0
        }, options), (options = $1e79381dc3a64a75$var$preloadPropsMap.get(key)) && $1e79381dc3a64a75$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $1e79381dc3a64a75$var$markNodeAsHoistable(resource), $1e79381dc3a64a75$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $1e79381dc3a64a75$var$preinitModuleScript(src, options) {
    $1e79381dc3a64a75$var$previousDispatcher.M(src, options);
    var ownerDocument = $1e79381dc3a64a75$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $1e79381dc3a64a75$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $1e79381dc3a64a75$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($1e79381dc3a64a75$var$getScriptSelectorFromKey(key)), resource || (src = $1e79381dc3a64a75$var$assign({
            src: src,
            async: !0,
            type: "module"
        }, options), (options = $1e79381dc3a64a75$var$preloadPropsMap.get(key)) && $1e79381dc3a64a75$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $1e79381dc3a64a75$var$markNodeAsHoistable(resource), $1e79381dc3a64a75$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $1e79381dc3a64a75$var$getResource(type, currentProps, pendingProps, currentResource) {
    var JSCompiler_inline_result = (JSCompiler_inline_result = $1e79381dc3a64a75$var$rootInstanceStackCursor.current) ? $1e79381dc3a64a75$var$getHoistableRoot(JSCompiler_inline_result) : null;
    if (!JSCompiler_inline_result) throw Error($1e79381dc3a64a75$var$formatProdErrorMessage(446));
    switch(type){
        case "meta":
        case "title":
            return null;
        case "style":
            return "string" === typeof pendingProps.precedence && "string" === typeof pendingProps.href ? (pendingProps = $1e79381dc3a64a75$var$getStyleKey(pendingProps.href), currentProps = $1e79381dc3a64a75$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, currentResource = currentProps.get(pendingProps), currentResource || (currentResource = {
                type: "style",
                instance: null,
                count: 0,
                state: null
            }, currentProps.set(pendingProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        case "link":
            if ("stylesheet" === pendingProps.rel && "string" === typeof pendingProps.href && "string" === typeof pendingProps.precedence) {
                type = $1e79381dc3a64a75$var$getStyleKey(pendingProps.href);
                var styles$268 = $1e79381dc3a64a75$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, resource$269 = styles$268.get(type);
                resource$269 || (JSCompiler_inline_result = JSCompiler_inline_result.ownerDocument || JSCompiler_inline_result, resource$269 = {
                    type: "stylesheet",
                    instance: null,
                    count: 0,
                    state: {
                        loading: 0,
                        preload: null
                    }
                }, styles$268.set(type, resource$269), (styles$268 = JSCompiler_inline_result.querySelector($1e79381dc3a64a75$var$getStylesheetSelectorFromKey(type))) ? styles$268._p || (resource$269.instance = styles$268, resource$269.state.loading = 5) : (styles$268 = $1e79381dc3a64a75$var$preloadPropsMap.get(type), styles$268 || (styles$268 = {
                    rel: "preload",
                    as: "style",
                    href: pendingProps.href,
                    crossOrigin: pendingProps.crossOrigin,
                    integrity: pendingProps.integrity,
                    media: pendingProps.media,
                    hrefLang: pendingProps.hrefLang,
                    referrerPolicy: pendingProps.referrerPolicy
                }, $1e79381dc3a64a75$var$preloadPropsMap.set(type, styles$268)), $1e79381dc3a64a75$var$preloadStylesheet(JSCompiler_inline_result, type, styles$268, resource$269.state)));
                if (currentProps && null === currentResource) throw Error($1e79381dc3a64a75$var$formatProdErrorMessage(528, ""));
                return resource$269;
            }
            if (currentProps && null !== currentResource) throw Error($1e79381dc3a64a75$var$formatProdErrorMessage(529, ""));
            return null;
        case "script":
            return currentProps = pendingProps.async, pendingProps = pendingProps.src, "string" === typeof pendingProps && currentProps && "function" !== typeof currentProps && "symbol" !== typeof currentProps ? (pendingProps = $1e79381dc3a64a75$var$getScriptKey(pendingProps), currentProps = $1e79381dc3a64a75$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableScripts, currentResource = currentProps.get(pendingProps), currentResource || (currentResource = {
                type: "script",
                instance: null,
                count: 0,
                state: null
            }, currentProps.set(pendingProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        default:
            throw Error($1e79381dc3a64a75$var$formatProdErrorMessage(444, type));
    }
}
function $1e79381dc3a64a75$var$getStyleKey(href) {
    return 'href="' + $1e79381dc3a64a75$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"';
}
function $1e79381dc3a64a75$var$getStylesheetSelectorFromKey(key) {
    return 'link[rel="stylesheet"][' + key + "]";
}
function $1e79381dc3a64a75$var$stylesheetPropsFromRawProps(rawProps) {
    return $1e79381dc3a64a75$var$assign({}, rawProps, {
        "data-precedence": rawProps.precedence,
        precedence: null
    });
}
function $1e79381dc3a64a75$var$preloadStylesheet(ownerDocument, key, preloadProps, state) {
    if (key = ownerDocument.querySelector('link[rel="preload"][as="style"][' + key + "]")) {
        if (!0 !== key[$1e79381dc3a64a75$var$internalLoadPendingKey]) {
            state.loading = 1;
            return;
        }
    } else key = ownerDocument.createElement("link"), key[$1e79381dc3a64a75$var$internalLoadPendingKey] = !0, key.onload = key.onerror = $1e79381dc3a64a75$var$clearPendingLoadOnNode.bind(null, key), $1e79381dc3a64a75$var$setInitialProperties(key, "link", preloadProps), $1e79381dc3a64a75$var$markNodeAsHoistable(key), ownerDocument.head.appendChild(key);
    state.preload = key;
    key.addEventListener("load", function() {
        return state.loading |= 1;
    });
    key.addEventListener("error", function() {
        return state.loading |= 2;
    });
}
function $1e79381dc3a64a75$var$getScriptKey(src) {
    return '[src="' + $1e79381dc3a64a75$var$escapeSelectorAttributeValueInsideDoubleQuotes(src) + '"]';
}
function $1e79381dc3a64a75$var$getScriptSelectorFromKey(key) {
    return "script[async]" + key;
}
function $1e79381dc3a64a75$var$acquireResource(hoistableRoot, resource, props) {
    resource.count++;
    if (null === resource.instance) switch(resource.type){
        case "style":
            var instance = hoistableRoot.querySelector('style[data-href~="' + $1e79381dc3a64a75$var$escapeSelectorAttributeValueInsideDoubleQuotes(props.href) + '"]');
            if (instance) return resource.instance = instance, $1e79381dc3a64a75$var$markNodeAsHoistable(instance), instance;
            var styleProps = $1e79381dc3a64a75$var$assign({}, props, {
                "data-href": props.href,
                "data-precedence": props.precedence,
                href: null,
                precedence: null
            });
            instance = (hoistableRoot.ownerDocument || hoistableRoot).createElement("style");
            $1e79381dc3a64a75$var$markNodeAsHoistable(instance);
            $1e79381dc3a64a75$var$setInitialProperties(instance, "style", styleProps);
            $1e79381dc3a64a75$var$insertStylesheet(instance, props.precedence, hoistableRoot);
            return resource.instance = instance;
        case "stylesheet":
            styleProps = $1e79381dc3a64a75$var$getStyleKey(props.href);
            var instance$274 = hoistableRoot.querySelector($1e79381dc3a64a75$var$getStylesheetSelectorFromKey(styleProps));
            if (instance$274) return resource.state.loading |= 4, resource.instance = instance$274, $1e79381dc3a64a75$var$markNodeAsHoistable(instance$274), instance$274;
            instance = $1e79381dc3a64a75$var$stylesheetPropsFromRawProps(props);
            (styleProps = $1e79381dc3a64a75$var$preloadPropsMap.get(styleProps)) && $1e79381dc3a64a75$var$adoptPreloadPropsForStylesheet(instance, styleProps);
            instance$274 = (hoistableRoot.ownerDocument || hoistableRoot).createElement("link");
            $1e79381dc3a64a75$var$markNodeAsHoistable(instance$274);
            var linkInstance = instance$274;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $1e79381dc3a64a75$var$setInitialProperties(instance$274, "link", instance);
            resource.state.loading |= 4;
            $1e79381dc3a64a75$var$insertStylesheet(instance$274, props.precedence, hoistableRoot);
            return resource.instance = instance$274;
        case "script":
            instance$274 = $1e79381dc3a64a75$var$getScriptKey(props.src);
            if (styleProps = hoistableRoot.querySelector($1e79381dc3a64a75$var$getScriptSelectorFromKey(instance$274))) return resource.instance = styleProps, $1e79381dc3a64a75$var$markNodeAsHoistable(styleProps), styleProps;
            instance = props;
            if (styleProps = $1e79381dc3a64a75$var$preloadPropsMap.get(instance$274)) instance = $1e79381dc3a64a75$var$assign({}, props), $1e79381dc3a64a75$var$adoptPreloadPropsForScript(instance, styleProps);
            hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
            styleProps = hoistableRoot.createElement("script");
            $1e79381dc3a64a75$var$markNodeAsHoistable(styleProps);
            $1e79381dc3a64a75$var$setInitialProperties(styleProps, "link", instance);
            hoistableRoot.head.appendChild(styleProps);
            return resource.instance = styleProps;
        case "void":
            return null;
        default:
            throw Error($1e79381dc3a64a75$var$formatProdErrorMessage(443, resource.type));
    }
    else "stylesheet" === resource.type && 0 === (resource.state.loading & 4) && (instance = resource.instance, resource.state.loading |= 4, $1e79381dc3a64a75$var$insertStylesheet(instance, props.precedence, hoistableRoot));
    return resource.instance;
}
function $1e79381dc3a64a75$var$insertStylesheet(instance, precedence, root) {
    for(var nodes = root.querySelectorAll('link[rel="stylesheet"][data-precedence],style[data-precedence]'), last = nodes.length ? nodes[nodes.length - 1] : null, prior = last, i = 0; i < nodes.length; i++){
        var node = nodes[i];
        if (node.dataset.precedence === precedence) prior = node;
        else if (prior !== last) break;
    }
    prior ? prior.parentNode.insertBefore(instance, prior.nextSibling) : (precedence = 9 === root.nodeType ? root.head : root, precedence.insertBefore(instance, precedence.firstChild));
}
function $1e79381dc3a64a75$var$adoptPreloadPropsForStylesheet(stylesheetProps, preloadProps) {
    null == stylesheetProps.crossOrigin && (stylesheetProps.crossOrigin = preloadProps.crossOrigin);
    null == stylesheetProps.referrerPolicy && (stylesheetProps.referrerPolicy = preloadProps.referrerPolicy);
    null == stylesheetProps.title && (stylesheetProps.title = preloadProps.title);
}
function $1e79381dc3a64a75$var$adoptPreloadPropsForScript(scriptProps, preloadProps) {
    null == scriptProps.crossOrigin && (scriptProps.crossOrigin = preloadProps.crossOrigin);
    null == scriptProps.referrerPolicy && (scriptProps.referrerPolicy = preloadProps.referrerPolicy);
    null == scriptProps.integrity && (scriptProps.integrity = preloadProps.integrity);
}
var $1e79381dc3a64a75$var$tagCaches = null;
function $1e79381dc3a64a75$var$getHydratableHoistableCache(type, keyAttribute, ownerDocument) {
    if (null === $1e79381dc3a64a75$var$tagCaches) {
        var cache = new Map();
        var caches = $1e79381dc3a64a75$var$tagCaches = new Map();
        caches.set(ownerDocument, cache);
    } else caches = $1e79381dc3a64a75$var$tagCaches, cache = caches.get(ownerDocument), cache || (cache = new Map(), caches.set(ownerDocument, cache));
    if (cache.has(type)) return cache;
    cache.set(type, null);
    ownerDocument = ownerDocument.getElementsByTagName(type);
    for(caches = 0; caches < ownerDocument.length; caches++){
        var node = ownerDocument[caches];
        if (!(node[$1e79381dc3a64a75$var$internalHoistableMarker] || node[$1e79381dc3a64a75$var$internalInstanceKey] || "link" === type && "stylesheet" === node.getAttribute("rel")) && "http://www.w3.org/2000/svg" !== node.namespaceURI) {
            var nodeKey = node.getAttribute(keyAttribute) || "";
            nodeKey = type + nodeKey;
            var existing = cache.get(nodeKey);
            existing ? existing.push(node) : cache.set(nodeKey, [
                node
            ]);
        }
    }
    return cache;
}
function $1e79381dc3a64a75$var$mountHoistable(hoistableRoot, type, instance) {
    hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
    hoistableRoot.head.insertBefore(instance, "title" === type ? hoistableRoot.querySelector("head > title") : null);
}
function $1e79381dc3a64a75$var$isHostHoistableType(type, props, hostContext) {
    if (1 === hostContext || null != props.itemProp) return !1;
    switch(type){
        case "meta":
        case "title":
            return !0;
        case "style":
            if ("string" !== typeof props.precedence || "string" !== typeof props.href || "" === props.href) break;
            return !0;
        case "link":
            if ("string" !== typeof props.rel || "string" !== typeof props.href || "" === props.href || props.onLoad || props.onError) break;
            switch(props.rel){
                case "stylesheet":
                    return type = props.disabled, "string" === typeof props.precedence && null == type;
                default:
                    return !0;
            }
        case "script":
            if (props.async && "function" !== typeof props.async && "symbol" !== typeof props.async && !props.onLoad && !props.onError && props.src && "string" === typeof props.src) return !0;
    }
    return !1;
}
function $1e79381dc3a64a75$var$maySuspendCommit(type, props) {
    return "img" === type && null != props.src && "" !== props.src && null == props.onLoad && "lazy" !== props.loading;
}
function $1e79381dc3a64a75$var$preloadResource(resource) {
    return "stylesheet" === resource.type && 0 === (resource.state.loading & 3) ? !1 : !0;
}
function $1e79381dc3a64a75$var$estimateImageBytes(instance) {
    return (instance.width || 100) * (instance.height || 100) * ("number" === typeof devicePixelRatio ? devicePixelRatio : 1) * 0.25;
}
function $1e79381dc3a64a75$var$suspendInstance(state, instance) {
    "function" === typeof instance.decode && (state.imgCount++, instance.complete || (state.imgBytes += $1e79381dc3a64a75$var$estimateImageBytes(instance), state.suspenseyImages.push(instance)), state = $1e79381dc3a64a75$var$onUnsuspendImg.bind(state), instance.decode().then(state, state));
}
function $1e79381dc3a64a75$var$suspendResource(state, hoistableRoot, resource, props) {
    if ("stylesheet" === resource.type && ("string" !== typeof props.media || !1 !== matchMedia(props.media).matches) && 0 === (resource.state.loading & 4)) {
        if (null === resource.instance) {
            var key = $1e79381dc3a64a75$var$getStyleKey(props.href), instance = hoistableRoot.querySelector($1e79381dc3a64a75$var$getStylesheetSelectorFromKey(key));
            if (instance) {
                hoistableRoot = instance._p;
                null !== hoistableRoot && "object" === typeof hoistableRoot && "function" === typeof hoistableRoot.then && (state.count++, state = $1e79381dc3a64a75$var$onUnsuspend.bind(state), hoistableRoot.then(state, state));
                resource.state.loading |= 4;
                resource.instance = instance;
                $1e79381dc3a64a75$var$markNodeAsHoistable(instance);
                return;
            }
            instance = hoistableRoot.ownerDocument || hoistableRoot;
            props = $1e79381dc3a64a75$var$stylesheetPropsFromRawProps(props);
            (key = $1e79381dc3a64a75$var$preloadPropsMap.get(key)) && $1e79381dc3a64a75$var$adoptPreloadPropsForStylesheet(props, key);
            instance = instance.createElement("link");
            $1e79381dc3a64a75$var$markNodeAsHoistable(instance);
            var linkInstance = instance;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $1e79381dc3a64a75$var$setInitialProperties(instance, "link", props);
            resource.instance = instance;
        }
        null === state.stylesheets && (state.stylesheets = new Map());
        state.stylesheets.set(resource, hoistableRoot);
        (hoistableRoot = resource.state.preload) && 0 === (resource.state.loading & 3) && (state.count++, resource = $1e79381dc3a64a75$var$onUnsuspend.bind(state), hoistableRoot.addEventListener("load", resource), hoistableRoot.addEventListener("error", resource));
    }
}
var $1e79381dc3a64a75$var$estimatedBytesWithinLimit = 0;
function $1e79381dc3a64a75$var$waitForCommitToBeReady(state, timeoutOffset) {
    state.stylesheets && 0 === state.count && $1e79381dc3a64a75$var$insertSuspendedStylesheets(state, state.stylesheets);
    return 0 < state.count || 0 < state.imgCount ? function(commit) {
        var stylesheetTimer = setTimeout(function() {
            state.stylesheets && $1e79381dc3a64a75$var$insertSuspendedStylesheets(state, state.stylesheets);
            if (state.unsuspend) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, 6e4 + timeoutOffset);
        0 < state.imgBytes && 0 === $1e79381dc3a64a75$var$estimatedBytesWithinLimit && ($1e79381dc3a64a75$var$estimatedBytesWithinLimit = 62500 * $1e79381dc3a64a75$var$estimateBandwidth());
        var imgTimer = setTimeout(function() {
            state.waitingForImages = !1;
            if (0 === state.count && (state.stylesheets && $1e79381dc3a64a75$var$insertSuspendedStylesheets(state, state.stylesheets), state.unsuspend)) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, (state.imgBytes > $1e79381dc3a64a75$var$estimatedBytesWithinLimit ? 50 : 800) + timeoutOffset);
        state.unsuspend = commit;
        return function() {
            state.unsuspend = null;
            clearTimeout(stylesheetTimer);
            clearTimeout(imgTimer);
        };
    } : null;
}
function $1e79381dc3a64a75$var$checkIfFullyUnsuspended(state) {
    if (0 === state.count && (0 === state.imgCount || !state.waitingForImages)) {
        if (state.stylesheets) $1e79381dc3a64a75$var$insertSuspendedStylesheets(state, state.stylesheets);
        else if (state.unsuspend) {
            var unsuspend = state.unsuspend;
            state.unsuspend = null;
            unsuspend();
        }
    }
}
function $1e79381dc3a64a75$var$onUnsuspend() {
    this.count--;
    $1e79381dc3a64a75$var$checkIfFullyUnsuspended(this);
}
function $1e79381dc3a64a75$var$onUnsuspendImg() {
    this.imgCount--;
    $1e79381dc3a64a75$var$checkIfFullyUnsuspended(this);
}
var $1e79381dc3a64a75$var$precedencesByRoot = null;
function $1e79381dc3a64a75$var$insertSuspendedStylesheets(state, resources) {
    state.stylesheets = null;
    null !== state.unsuspend && (state.count++, $1e79381dc3a64a75$var$precedencesByRoot = new Map(), resources.forEach($1e79381dc3a64a75$var$insertStylesheetIntoRoot, state), $1e79381dc3a64a75$var$precedencesByRoot = null, $1e79381dc3a64a75$var$onUnsuspend.call(state));
}
function $1e79381dc3a64a75$var$insertStylesheetIntoRoot(root, resource) {
    if (!(resource.state.loading & 4)) {
        var precedences = $1e79381dc3a64a75$var$precedencesByRoot.get(root);
        if (precedences) var last = precedences.get(null);
        else {
            precedences = new Map();
            $1e79381dc3a64a75$var$precedencesByRoot.set(root, precedences);
            for(var nodes = root.querySelectorAll("link[data-precedence],style[data-precedence]"), i = 0; i < nodes.length; i++){
                var node = nodes[i];
                if ("LINK" === node.nodeName || "not all" !== node.getAttribute("media")) precedences.set(node.dataset.precedence, node), last = node;
            }
            last && precedences.set(null, last);
        }
        nodes = resource.instance;
        node = nodes.getAttribute("data-precedence");
        i = precedences.get(node) || last;
        i === last && precedences.set(null, nodes);
        precedences.set(node, nodes);
        this.count++;
        last = $1e79381dc3a64a75$var$onUnsuspend.bind(this);
        nodes.addEventListener("load", last);
        nodes.addEventListener("error", last);
        i ? i.parentNode.insertBefore(nodes, i.nextSibling) : (root = 9 === root.nodeType ? root.head : root, root.insertBefore(nodes, root.firstChild));
        resource.state.loading |= 4;
    }
}
var $1e79381dc3a64a75$var$HostTransitionContext = {
    $$typeof: $1e79381dc3a64a75$var$REACT_CONTEXT_TYPE,
    Provider: null,
    Consumer: null,
    _currentValue: $1e79381dc3a64a75$var$sharedNotPendingObject,
    _currentValue2: $1e79381dc3a64a75$var$sharedNotPendingObject,
    _threadCount: 0
};
function $1e79381dc3a64a75$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState) {
    this.tag = 1;
    this.containerInfo = containerInfo;
    this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null;
    this.callbackPriority = 0;
    this.expirationTimes = $1e79381dc3a64a75$var$createLaneMap(-1);
    this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $1e79381dc3a64a75$var$createLaneMap(0);
    this.hiddenUpdates = $1e79381dc3a64a75$var$createLaneMap(null);
    this.identifierPrefix = identifierPrefix;
    this.onUncaughtError = onUncaughtError;
    this.onCaughtError = onCaughtError;
    this.onRecoverableError = onRecoverableError;
    this.pooledCache = null;
    this.pooledCacheLanes = 0;
    this.formState = formState;
    this.transitionTypes = null;
    this.incompleteTransitions = new Map();
}
function $1e79381dc3a64a75$var$createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator) {
    containerInfo = new $1e79381dc3a64a75$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState);
    tag = 1;
    !0 === isStrictMode && (tag |= 24);
    isStrictMode = $1e79381dc3a64a75$var$createFiberImplClass(3, null, null, tag);
    containerInfo.current = isStrictMode;
    isStrictMode.stateNode = containerInfo;
    tag = $1e79381dc3a64a75$var$createCache();
    tag.refCount++;
    containerInfo.pooledCache = tag;
    tag.refCount++;
    isStrictMode.memoizedState = {
        element: initialChildren,
        isDehydrated: hydrate,
        cache: tag
    };
    $1e79381dc3a64a75$var$initializeUpdateQueue(isStrictMode);
    return containerInfo;
}
function $1e79381dc3a64a75$var$getContextForSubtree(parentComponent) {
    if (!parentComponent) return $1e79381dc3a64a75$var$emptyContextObject;
    parentComponent = $1e79381dc3a64a75$var$emptyContextObject;
    return parentComponent;
}
function $1e79381dc3a64a75$var$updateContainerImpl(rootFiber, lane, element, container, parentComponent, callback) {
    parentComponent = $1e79381dc3a64a75$var$getContextForSubtree(parentComponent);
    null === container.context ? container.context = parentComponent : container.pendingContext = parentComponent;
    container = $1e79381dc3a64a75$var$createUpdate(lane);
    container.payload = {
        element: element
    };
    callback = void 0 === callback ? null : callback;
    null !== callback && (container.callback = callback);
    element = $1e79381dc3a64a75$var$enqueueUpdate(rootFiber, container, lane);
    null !== element && ($1e79381dc3a64a75$var$scheduleUpdateOnFiber(element, rootFiber, lane), $1e79381dc3a64a75$var$entangleTransitions(element, rootFiber, lane));
}
function $1e79381dc3a64a75$var$markRetryLaneImpl(fiber, retryLane) {
    fiber = fiber.memoizedState;
    if (null !== fiber && null !== fiber.dehydrated) {
        var a = fiber.retryLane;
        fiber.retryLane = 0 !== a && a < retryLane ? a : retryLane;
    }
}
function $1e79381dc3a64a75$var$markRetryLaneIfNotHydrated(fiber, retryLane) {
    $1e79381dc3a64a75$var$markRetryLaneImpl(fiber, retryLane);
    (fiber = fiber.alternate) && $1e79381dc3a64a75$var$markRetryLaneImpl(fiber, retryLane);
}
function $1e79381dc3a64a75$var$attemptContinuousHydration(fiber) {
    if (13 === fiber.tag || 31 === fiber.tag) {
        var root = $1e79381dc3a64a75$var$enqueueConcurrentRenderForLane(fiber, 67108864);
        null !== root && $1e79381dc3a64a75$var$scheduleUpdateOnFiber(root, fiber, 67108864);
        $1e79381dc3a64a75$var$markRetryLaneIfNotHydrated(fiber, 67108864);
    }
}
function $1e79381dc3a64a75$var$attemptHydrationAtCurrentPriority(fiber) {
    if (13 === fiber.tag || 31 === fiber.tag) {
        var lane = $1e79381dc3a64a75$var$requestUpdateLane();
        lane = $1e79381dc3a64a75$var$getBumpedLaneForHydrationByLane(lane);
        var root = $1e79381dc3a64a75$var$enqueueConcurrentRenderForLane(fiber, lane);
        null !== root && $1e79381dc3a64a75$var$scheduleUpdateOnFiber(root, fiber, lane);
        $1e79381dc3a64a75$var$markRetryLaneIfNotHydrated(fiber, lane);
    }
}
var $1e79381dc3a64a75$var$_enabled = !0;
function $1e79381dc3a64a75$var$dispatchDiscreteEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $1e79381dc3a64a75$var$ReactSharedInternals.T;
    $1e79381dc3a64a75$var$ReactSharedInternals.T = null;
    var previousPriority = $1e79381dc3a64a75$var$ReactDOMSharedInternals.p;
    try {
        $1e79381dc3a64a75$var$ReactDOMSharedInternals.p = 2, $1e79381dc3a64a75$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $1e79381dc3a64a75$var$ReactDOMSharedInternals.p = previousPriority, $1e79381dc3a64a75$var$ReactSharedInternals.T = prevTransition;
    }
}
function $1e79381dc3a64a75$var$dispatchContinuousEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $1e79381dc3a64a75$var$ReactSharedInternals.T;
    $1e79381dc3a64a75$var$ReactSharedInternals.T = null;
    var previousPriority = $1e79381dc3a64a75$var$ReactDOMSharedInternals.p;
    try {
        $1e79381dc3a64a75$var$ReactDOMSharedInternals.p = 8, $1e79381dc3a64a75$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $1e79381dc3a64a75$var$ReactDOMSharedInternals.p = previousPriority, $1e79381dc3a64a75$var$ReactSharedInternals.T = prevTransition;
    }
}
function $1e79381dc3a64a75$var$dispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if ($1e79381dc3a64a75$var$_enabled) {
        var blockedOn = $1e79381dc3a64a75$var$findInstanceBlockingEvent(nativeEvent);
        if (null === blockedOn) $1e79381dc3a64a75$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $1e79381dc3a64a75$var$return_targetInst, targetContainer), $1e79381dc3a64a75$var$clearIfContinuousEvent(domEventName, nativeEvent);
        else if ($1e79381dc3a64a75$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)) nativeEvent.stopPropagation();
        else if ($1e79381dc3a64a75$var$clearIfContinuousEvent(domEventName, nativeEvent), eventSystemFlags & 4 && -1 < $1e79381dc3a64a75$var$discreteReplayableEvents.indexOf(domEventName)) {
            for(; null !== blockedOn;){
                var fiber = $1e79381dc3a64a75$var$getInstanceFromNode(blockedOn);
                if (null !== fiber) switch(fiber.tag){
                    case 3:
                        fiber = fiber.stateNode;
                        if (fiber.current.memoizedState.isDehydrated) {
                            var lanes = $1e79381dc3a64a75$var$getHighestPriorityLanes(fiber.pendingLanes);
                            if (0 !== lanes) {
                                var root = fiber;
                                root.pendingLanes |= 2;
                                for(root.entangledLanes |= 2; lanes;){
                                    var lane = 1 << 31 - $1e79381dc3a64a75$var$clz32(lanes);
                                    root.entanglements[1] |= lane;
                                    lanes &= ~lane;
                                }
                                $1e79381dc3a64a75$var$ensureRootIsScheduled(fiber);
                                0 === ($1e79381dc3a64a75$var$executionContext & 6) && ($1e79381dc3a64a75$var$workInProgressRootRenderTargetTime = $1e79381dc3a64a75$var$now() + 500, $1e79381dc3a64a75$var$flushSyncWorkAcrossRoots_impl(0, !1));
                            }
                        }
                        break;
                    case 31:
                    case 13:
                        root = $1e79381dc3a64a75$var$enqueueConcurrentRenderForLane(fiber, 2), null !== root && $1e79381dc3a64a75$var$scheduleUpdateOnFiber(root, fiber, 2), $1e79381dc3a64a75$var$flushSyncWork$1(), $1e79381dc3a64a75$var$markRetryLaneIfNotHydrated(fiber, 2);
                }
                fiber = $1e79381dc3a64a75$var$findInstanceBlockingEvent(nativeEvent);
                null === fiber && $1e79381dc3a64a75$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $1e79381dc3a64a75$var$return_targetInst, targetContainer);
                if (fiber === blockedOn) break;
                blockedOn = fiber;
            }
            null !== blockedOn && nativeEvent.stopPropagation();
        } else $1e79381dc3a64a75$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, null, targetContainer);
    }
}
function $1e79381dc3a64a75$var$findInstanceBlockingEvent(nativeEvent) {
    nativeEvent = $1e79381dc3a64a75$var$getEventTarget(nativeEvent);
    return $1e79381dc3a64a75$var$findInstanceBlockingTarget(nativeEvent);
}
var $1e79381dc3a64a75$var$return_targetInst = null;
function $1e79381dc3a64a75$var$findInstanceBlockingTarget(targetNode) {
    $1e79381dc3a64a75$var$return_targetInst = null;
    targetNode = $1e79381dc3a64a75$var$getClosestInstanceFromNode(targetNode);
    if (null !== targetNode) {
        var nearestMounted = $1e79381dc3a64a75$var$getNearestMountedFiber(targetNode);
        if (null === nearestMounted) targetNode = null;
        else {
            var tag = nearestMounted.tag;
            if (13 === tag) {
                targetNode = $1e79381dc3a64a75$var$getSuspenseInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (31 === tag) {
                targetNode = $1e79381dc3a64a75$var$getActivityInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (3 === tag) {
                if (nearestMounted.stateNode.current.memoizedState.isDehydrated) return 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                targetNode = null;
            } else nearestMounted !== targetNode && (targetNode = null);
        }
    }
    $1e79381dc3a64a75$var$return_targetInst = targetNode;
    return null;
}
function $1e79381dc3a64a75$var$getEventPriority(domEventName) {
    switch(domEventName){
        case "beforetoggle":
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "seeked":
        case "submit":
        case "toggle":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "fullscreenerror":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 2;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "resize":
        case "scroll":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 8;
        case "message":
            switch($1e79381dc3a64a75$var$getCurrentPriorityLevel()){
                case $1e79381dc3a64a75$var$ImmediatePriority:
                    return 2;
                case $1e79381dc3a64a75$var$UserBlockingPriority:
                    return 8;
                case $1e79381dc3a64a75$var$NormalPriority$1:
                case $1e79381dc3a64a75$var$LowPriority:
                    return 32;
                case $1e79381dc3a64a75$var$IdlePriority:
                    return 268435456;
                default:
                    return 32;
            }
        default:
            return 32;
    }
}
var $1e79381dc3a64a75$var$hasScheduledReplayAttempt = !1, $1e79381dc3a64a75$var$queuedFocus = null, $1e79381dc3a64a75$var$queuedDrag = null, $1e79381dc3a64a75$var$queuedMouse = null, $1e79381dc3a64a75$var$queuedPointers = new Map(), $1e79381dc3a64a75$var$queuedPointerCaptures = new Map(), $1e79381dc3a64a75$var$queuedExplicitHydrationTargets = [], $1e79381dc3a64a75$var$discreteReplayableEvents = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(" ");
function $1e79381dc3a64a75$var$clearIfContinuousEvent(domEventName, nativeEvent) {
    switch(domEventName){
        case "focusin":
        case "focusout":
            $1e79381dc3a64a75$var$queuedFocus = null;
            break;
        case "dragenter":
        case "dragleave":
            $1e79381dc3a64a75$var$queuedDrag = null;
            break;
        case "mouseover":
        case "mouseout":
            $1e79381dc3a64a75$var$queuedMouse = null;
            break;
        case "pointerover":
        case "pointerout":
            $1e79381dc3a64a75$var$queuedPointers.delete(nativeEvent.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $1e79381dc3a64a75$var$queuedPointerCaptures.delete(nativeEvent.pointerId);
    }
}
function $1e79381dc3a64a75$var$accumulateOrCreateContinuousQueuedReplayableEvent(existingQueuedEvent, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if (null === existingQueuedEvent || existingQueuedEvent.nativeEvent !== nativeEvent) return existingQueuedEvent = {
        blockedOn: blockedOn,
        domEventName: domEventName,
        eventSystemFlags: eventSystemFlags,
        nativeEvent: nativeEvent,
        targetContainers: [
            targetContainer
        ]
    }, null !== blockedOn && (blockedOn = $1e79381dc3a64a75$var$getInstanceFromNode(blockedOn), null !== blockedOn && $1e79381dc3a64a75$var$attemptContinuousHydration(blockedOn)), existingQueuedEvent;
    existingQueuedEvent.eventSystemFlags |= eventSystemFlags;
    blockedOn = existingQueuedEvent.targetContainers;
    null !== targetContainer && -1 === blockedOn.indexOf(targetContainer) && blockedOn.push(targetContainer);
    return existingQueuedEvent;
}
function $1e79381dc3a64a75$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    switch(domEventName){
        case "focusin":
            return $1e79381dc3a64a75$var$queuedFocus = $1e79381dc3a64a75$var$accumulateOrCreateContinuousQueuedReplayableEvent($1e79381dc3a64a75$var$queuedFocus, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "dragenter":
            return $1e79381dc3a64a75$var$queuedDrag = $1e79381dc3a64a75$var$accumulateOrCreateContinuousQueuedReplayableEvent($1e79381dc3a64a75$var$queuedDrag, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "mouseover":
            return $1e79381dc3a64a75$var$queuedMouse = $1e79381dc3a64a75$var$accumulateOrCreateContinuousQueuedReplayableEvent($1e79381dc3a64a75$var$queuedMouse, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "pointerover":
            var pointerId = nativeEvent.pointerId;
            $1e79381dc3a64a75$var$queuedPointers.set(pointerId, $1e79381dc3a64a75$var$accumulateOrCreateContinuousQueuedReplayableEvent($1e79381dc3a64a75$var$queuedPointers.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent));
            return !0;
        case "gotpointercapture":
            return pointerId = nativeEvent.pointerId, $1e79381dc3a64a75$var$queuedPointerCaptures.set(pointerId, $1e79381dc3a64a75$var$accumulateOrCreateContinuousQueuedReplayableEvent($1e79381dc3a64a75$var$queuedPointerCaptures.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)), !0;
    }
    return !1;
}
function $1e79381dc3a64a75$var$attemptExplicitHydrationTarget(queuedTarget) {
    var targetInst = $1e79381dc3a64a75$var$getClosestInstanceFromNode(queuedTarget.target);
    if (null !== targetInst) {
        var nearestMounted = $1e79381dc3a64a75$var$getNearestMountedFiber(targetInst);
        if (null !== nearestMounted) {
            if (targetInst = nearestMounted.tag, 13 === targetInst) {
                if (targetInst = $1e79381dc3a64a75$var$getSuspenseInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $1e79381dc3a64a75$var$runWithPriority(queuedTarget.priority, function() {
                        $1e79381dc3a64a75$var$attemptHydrationAtCurrentPriority(nearestMounted);
                    });
                    return;
                }
            } else if (31 === targetInst) {
                if (targetInst = $1e79381dc3a64a75$var$getActivityInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $1e79381dc3a64a75$var$runWithPriority(queuedTarget.priority, function() {
                        $1e79381dc3a64a75$var$attemptHydrationAtCurrentPriority(nearestMounted);
                    });
                    return;
                }
            } else if (3 === targetInst && nearestMounted.stateNode.current.memoizedState.isDehydrated) {
                queuedTarget.blockedOn = 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                return;
            }
        }
    }
    queuedTarget.blockedOn = null;
}
function $1e79381dc3a64a75$var$attemptReplayContinuousQueuedEvent(queuedEvent) {
    if (null !== queuedEvent.blockedOn) return !1;
    for(var targetContainers = queuedEvent.targetContainers; 0 < targetContainers.length;){
        var nextBlockedOn = $1e79381dc3a64a75$var$findInstanceBlockingEvent(queuedEvent.nativeEvent);
        if (null === nextBlockedOn) {
            nextBlockedOn = queuedEvent.nativeEvent;
            var nativeEventClone = new nextBlockedOn.constructor(nextBlockedOn.type, nextBlockedOn);
            $1e79381dc3a64a75$var$currentReplayingEvent = nativeEventClone;
            nextBlockedOn.target.dispatchEvent(nativeEventClone);
            $1e79381dc3a64a75$var$currentReplayingEvent = null;
        } else return targetContainers = $1e79381dc3a64a75$var$getInstanceFromNode(nextBlockedOn), null !== targetContainers && $1e79381dc3a64a75$var$attemptContinuousHydration(targetContainers), queuedEvent.blockedOn = nextBlockedOn, !1;
        targetContainers.shift();
    }
    return !0;
}
function $1e79381dc3a64a75$var$attemptReplayContinuousQueuedEventInMap(queuedEvent, key, map) {
    $1e79381dc3a64a75$var$attemptReplayContinuousQueuedEvent(queuedEvent) && map.delete(key);
}
function $1e79381dc3a64a75$var$replayUnblockedEvents() {
    $1e79381dc3a64a75$var$hasScheduledReplayAttempt = !1;
    null !== $1e79381dc3a64a75$var$queuedFocus && $1e79381dc3a64a75$var$attemptReplayContinuousQueuedEvent($1e79381dc3a64a75$var$queuedFocus) && ($1e79381dc3a64a75$var$queuedFocus = null);
    null !== $1e79381dc3a64a75$var$queuedDrag && $1e79381dc3a64a75$var$attemptReplayContinuousQueuedEvent($1e79381dc3a64a75$var$queuedDrag) && ($1e79381dc3a64a75$var$queuedDrag = null);
    null !== $1e79381dc3a64a75$var$queuedMouse && $1e79381dc3a64a75$var$attemptReplayContinuousQueuedEvent($1e79381dc3a64a75$var$queuedMouse) && ($1e79381dc3a64a75$var$queuedMouse = null);
    $1e79381dc3a64a75$var$queuedPointers.forEach($1e79381dc3a64a75$var$attemptReplayContinuousQueuedEventInMap);
    $1e79381dc3a64a75$var$queuedPointerCaptures.forEach($1e79381dc3a64a75$var$attemptReplayContinuousQueuedEventInMap);
}
function $1e79381dc3a64a75$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked) {
    queuedEvent.blockedOn === unblocked && (queuedEvent.blockedOn = null, $1e79381dc3a64a75$var$hasScheduledReplayAttempt || ($1e79381dc3a64a75$var$hasScheduledReplayAttempt = !0, $3T9qK.unstable_scheduleCallback($3T9qK.unstable_NormalPriority, $1e79381dc3a64a75$var$replayUnblockedEvents)));
}
var $1e79381dc3a64a75$var$lastScheduledReplayQueue = null;
function $1e79381dc3a64a75$var$scheduleReplayQueueIfNeeded(formReplayingQueue) {
    $1e79381dc3a64a75$var$lastScheduledReplayQueue !== formReplayingQueue && ($1e79381dc3a64a75$var$lastScheduledReplayQueue = formReplayingQueue, $3T9qK.unstable_scheduleCallback($3T9qK.unstable_NormalPriority, function() {
        $1e79381dc3a64a75$var$lastScheduledReplayQueue === formReplayingQueue && ($1e79381dc3a64a75$var$lastScheduledReplayQueue = null);
        for(var i = 0; i < formReplayingQueue.length; i += 3){
            var form = formReplayingQueue[i], submitterOrAction = formReplayingQueue[i + 1], formData = formReplayingQueue[i + 2];
            if ("function" !== typeof submitterOrAction) {
                if (null === $1e79381dc3a64a75$var$findInstanceBlockingTarget(submitterOrAction || form)) continue;
                else break;
            }
            var formInst = $1e79381dc3a64a75$var$getInstanceFromNode(form);
            null !== formInst && (formReplayingQueue.splice(i, 3), i -= 3, $1e79381dc3a64a75$var$startHostTransition(formInst, {
                pending: !0,
                data: formData,
                method: form.method,
                action: submitterOrAction
            }, submitterOrAction, formData));
        }
    }));
}
function $1e79381dc3a64a75$var$retryIfBlockedOn(unblocked) {
    function unblock(queuedEvent) {
        return $1e79381dc3a64a75$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked);
    }
    null !== $1e79381dc3a64a75$var$queuedFocus && $1e79381dc3a64a75$var$scheduleCallbackIfUnblocked($1e79381dc3a64a75$var$queuedFocus, unblocked);
    null !== $1e79381dc3a64a75$var$queuedDrag && $1e79381dc3a64a75$var$scheduleCallbackIfUnblocked($1e79381dc3a64a75$var$queuedDrag, unblocked);
    null !== $1e79381dc3a64a75$var$queuedMouse && $1e79381dc3a64a75$var$scheduleCallbackIfUnblocked($1e79381dc3a64a75$var$queuedMouse, unblocked);
    $1e79381dc3a64a75$var$queuedPointers.forEach(unblock);
    $1e79381dc3a64a75$var$queuedPointerCaptures.forEach(unblock);
    for(var i = 0; i < $1e79381dc3a64a75$var$queuedExplicitHydrationTargets.length; i++){
        var queuedTarget = $1e79381dc3a64a75$var$queuedExplicitHydrationTargets[i];
        queuedTarget.blockedOn === unblocked && (queuedTarget.blockedOn = null);
    }
    for(; 0 < $1e79381dc3a64a75$var$queuedExplicitHydrationTargets.length && (i = $1e79381dc3a64a75$var$queuedExplicitHydrationTargets[0], null === i.blockedOn);)$1e79381dc3a64a75$var$attemptExplicitHydrationTarget(i), null === i.blockedOn && $1e79381dc3a64a75$var$queuedExplicitHydrationTargets.shift();
    i = (unblocked.ownerDocument || unblocked).$$reactFormReplay;
    if (null != i) for(queuedTarget = 0; queuedTarget < i.length; queuedTarget += 3){
        var form = i[queuedTarget], submitterOrAction = i[queuedTarget + 1], formProps = form[$1e79381dc3a64a75$var$internalPropsKey] || null;
        if ("function" === typeof submitterOrAction) formProps || $1e79381dc3a64a75$var$scheduleReplayQueueIfNeeded(i);
        else if (formProps) {
            var action = null;
            if (submitterOrAction && submitterOrAction.hasAttribute("formAction")) {
                if (form = submitterOrAction, formProps = submitterOrAction[$1e79381dc3a64a75$var$internalPropsKey] || null) action = formProps.formAction;
                else {
                    if (null !== $1e79381dc3a64a75$var$findInstanceBlockingTarget(form)) continue;
                }
            } else action = formProps.action;
            "function" === typeof action ? i[queuedTarget + 1] = action : (i.splice(queuedTarget, 3), queuedTarget -= 3);
            $1e79381dc3a64a75$var$scheduleReplayQueueIfNeeded(i);
        }
    }
}
function $1e79381dc3a64a75$var$defaultOnDefaultTransitionIndicator() {
    function handleNavigate(event) {
        event.canIntercept && "react-transition" === event.info && event.intercept({
            handler: function() {
                return new Promise(function(resolve) {
                    return pendingResolve = resolve;
                });
            },
            focusReset: "manual",
            scroll: "manual"
        });
    }
    function handleNavigateComplete() {
        null !== pendingResolve && (pendingResolve(), pendingResolve = null);
        isCancelled || setTimeout(startFakeNavigation, 20);
    }
    function startFakeNavigation() {
        if (!isCancelled && !navigation.transition) {
            var currentEntry = navigation.currentEntry;
            currentEntry && null != currentEntry.url && navigation.navigate(currentEntry.url, {
                state: currentEntry.getState(),
                info: "react-transition",
                history: "replace"
            });
        }
    }
    if ("object" === typeof navigation) {
        var isCancelled = !1, pendingResolve = null;
        navigation.addEventListener("navigate", handleNavigate);
        navigation.addEventListener("navigatesuccess", handleNavigateComplete);
        navigation.addEventListener("navigateerror", handleNavigateComplete);
        setTimeout(startFakeNavigation, 100);
        return function() {
            isCancelled = !0;
            navigation.removeEventListener("navigate", handleNavigate);
            navigation.removeEventListener("navigatesuccess", handleNavigateComplete);
            navigation.removeEventListener("navigateerror", handleNavigateComplete);
            null !== pendingResolve && (pendingResolve(), pendingResolve = null);
        };
    }
}
function $1e79381dc3a64a75$var$ReactDOMRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$1e79381dc3a64a75$var$ReactDOMHydrationRoot.prototype.render = $1e79381dc3a64a75$var$ReactDOMRoot.prototype.render = function(children) {
    var root = this._internalRoot;
    if (null === root) throw Error($1e79381dc3a64a75$var$formatProdErrorMessage(409));
    var current = root.current, lane = $1e79381dc3a64a75$var$requestUpdateLane();
    $1e79381dc3a64a75$var$updateContainerImpl(current, lane, children, root, null, null);
};
$1e79381dc3a64a75$var$ReactDOMHydrationRoot.prototype.unmount = $1e79381dc3a64a75$var$ReactDOMRoot.prototype.unmount = function() {
    var root = this._internalRoot;
    if (null !== root) {
        this._internalRoot = null;
        var container = root.containerInfo;
        $1e79381dc3a64a75$var$updateContainerImpl(root.current, 2, null, root, null, null);
        $1e79381dc3a64a75$var$flushSyncWork$1();
        container[$1e79381dc3a64a75$var$internalContainerInstanceKey] = null;
    }
};
function $1e79381dc3a64a75$var$ReactDOMHydrationRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$1e79381dc3a64a75$var$ReactDOMHydrationRoot.prototype.unstable_scheduleHydration = function(target) {
    if (target) {
        var updatePriority = $1e79381dc3a64a75$var$resolveUpdatePriority();
        target = {
            blockedOn: null,
            target: target,
            priority: updatePriority
        };
        for(var i = 0; i < $1e79381dc3a64a75$var$queuedExplicitHydrationTargets.length && 0 !== updatePriority && updatePriority < $1e79381dc3a64a75$var$queuedExplicitHydrationTargets[i].priority; i++);
        $1e79381dc3a64a75$var$queuedExplicitHydrationTargets.splice(i, 0, target);
        0 === i && $1e79381dc3a64a75$var$attemptExplicitHydrationTarget(target);
    }
};
var $1e79381dc3a64a75$var$isomorphicReactPackageVersion$jscomp$inline_2043 = $bFZzf.version;
if ("19.3.1" !== $1e79381dc3a64a75$var$isomorphicReactPackageVersion$jscomp$inline_2043) throw Error($1e79381dc3a64a75$var$formatProdErrorMessage(527, $1e79381dc3a64a75$var$isomorphicReactPackageVersion$jscomp$inline_2043, "19.3.1"));
$1e79381dc3a64a75$var$ReactDOMSharedInternals.findDOMNode = function(componentOrElement) {
    var fiber = componentOrElement._reactInternals;
    if (void 0 === fiber) {
        if ("function" === typeof componentOrElement.render) throw Error($1e79381dc3a64a75$var$formatProdErrorMessage(188));
        componentOrElement = Object.keys(componentOrElement).join(",");
        throw Error($1e79381dc3a64a75$var$formatProdErrorMessage(268, componentOrElement));
    }
    componentOrElement = $1e79381dc3a64a75$var$findCurrentFiberUsingSlowPath(fiber);
    componentOrElement = null !== componentOrElement ? $1e79381dc3a64a75$var$findCurrentHostFiberImpl(componentOrElement) : null;
    componentOrElement = null === componentOrElement ? null : componentOrElement.stateNode;
    return componentOrElement;
};
var $1e79381dc3a64a75$var$internals$jscomp$inline_2586 = {
    bundleType: 0,
    version: "19.3.1",
    rendererPackageName: "react-dom",
    currentDispatcherRef: $1e79381dc3a64a75$var$ReactSharedInternals,
    reconcilerVersion: "19.3.1"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $1e79381dc3a64a75$var$hook$jscomp$inline_2587 = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$1e79381dc3a64a75$var$hook$jscomp$inline_2587.isDisabled && $1e79381dc3a64a75$var$hook$jscomp$inline_2587.supportsFiber) try {
        $1e79381dc3a64a75$var$rendererID = $1e79381dc3a64a75$var$hook$jscomp$inline_2587.inject($1e79381dc3a64a75$var$internals$jscomp$inline_2586), $1e79381dc3a64a75$var$injectedHook = $1e79381dc3a64a75$var$hook$jscomp$inline_2587;
    } catch (err) {}
}
$1e79381dc3a64a75$export$882461b6382ed46c = function(container, options) {
    if (!$1e79381dc3a64a75$var$isValidContainer(container)) throw Error($1e79381dc3a64a75$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $1e79381dc3a64a75$var$defaultOnUncaughtError, onCaughtError = $1e79381dc3a64a75$var$defaultOnCaughtError, onRecoverableError = $1e79381dc3a64a75$var$defaultOnRecoverableError;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError));
    options = $1e79381dc3a64a75$var$createFiberRoot(container, 1, !1, null, null, isStrictMode, identifierPrefix, null, onUncaughtError, onCaughtError, onRecoverableError, $1e79381dc3a64a75$var$defaultOnDefaultTransitionIndicator);
    container[$1e79381dc3a64a75$var$internalContainerInstanceKey] = options.current;
    $1e79381dc3a64a75$var$listenToAllSupportedEvents(container);
    return new $1e79381dc3a64a75$var$ReactDOMRoot(options);
};
$1e79381dc3a64a75$export$757ceba2d55c277e = function(container, initialChildren, options) {
    if (!$1e79381dc3a64a75$var$isValidContainer(container)) throw Error($1e79381dc3a64a75$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $1e79381dc3a64a75$var$defaultOnUncaughtError, onCaughtError = $1e79381dc3a64a75$var$defaultOnCaughtError, onRecoverableError = $1e79381dc3a64a75$var$defaultOnRecoverableError, formState = null;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.formState && (formState = options.formState));
    initialChildren = $1e79381dc3a64a75$var$createFiberRoot(container, 1, !0, initialChildren, null != options ? options : null, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, $1e79381dc3a64a75$var$defaultOnDefaultTransitionIndicator);
    initialChildren.context = $1e79381dc3a64a75$var$getContextForSubtree(null);
    options = initialChildren.current;
    isStrictMode = $1e79381dc3a64a75$var$requestUpdateLane();
    isStrictMode = $1e79381dc3a64a75$var$getBumpedLaneForHydrationByLane(isStrictMode);
    identifierPrefix = $1e79381dc3a64a75$var$createUpdate(isStrictMode);
    identifierPrefix.callback = null;
    $1e79381dc3a64a75$var$enqueueUpdate(options, identifierPrefix, isStrictMode);
    options = isStrictMode;
    initialChildren.current.lanes = options;
    $1e79381dc3a64a75$var$markRootUpdated$1(initialChildren, options);
    $1e79381dc3a64a75$var$ensureRootIsScheduled(initialChildren);
    container[$1e79381dc3a64a75$var$internalContainerInstanceKey] = initialChildren.current;
    $1e79381dc3a64a75$var$listenToAllSupportedEvents(container);
    return new $1e79381dc3a64a75$var$ReactDOMHydrationRoot(initialChildren);
};
$1e79381dc3a64a75$export$83d89fbfd8236492 = "19.3.1";

});
parcelRegister("3T9qK", function(module, exports) {
'use strict';

module.exports = (parcelRequire("8Pqz3"));

});
parcelRegister("8Pqz3", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $66d7b1486190e6b7$export$c4744153514ff05d, (v) => $66d7b1486190e6b7$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $66d7b1486190e6b7$export$3e506c1ccc9cc1a7, (v) => $66d7b1486190e6b7$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $66d7b1486190e6b7$export$e26fe2ed2fa76875, (v) => $66d7b1486190e6b7$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $66d7b1486190e6b7$export$502329bbf4b505b1, (v) => $66d7b1486190e6b7$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $66d7b1486190e6b7$export$6e3807111c4874c4, (v) => $66d7b1486190e6b7$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $66d7b1486190e6b7$export$c27134553091fb3a, (v) => $66d7b1486190e6b7$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $66d7b1486190e6b7$export$33ee1acdc04fd2a2, (v) => $66d7b1486190e6b7$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $66d7b1486190e6b7$export$b00a404bbd5edef2, (v) => $66d7b1486190e6b7$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $66d7b1486190e6b7$export$d66a1c1c77bd778b, (v) => $66d7b1486190e6b7$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $66d7b1486190e6b7$export$d3dfb8e4810cb555, (v) => $66d7b1486190e6b7$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_next", () => $66d7b1486190e6b7$export$72fdf0e06517287b, (v) => $66d7b1486190e6b7$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $66d7b1486190e6b7$export$816d2913ae6b83b1, (v) => $66d7b1486190e6b7$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $66d7b1486190e6b7$export$61bcfe829111a1d0, (v) => $66d7b1486190e6b7$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $66d7b1486190e6b7$export$7ee8c9beb337bc3f, (v) => $66d7b1486190e6b7$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $66d7b1486190e6b7$export$b5836b71941fa3ed, (v) => $66d7b1486190e6b7$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $66d7b1486190e6b7$export$cf845f2c119da08a, (v) => $66d7b1486190e6b7$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $66d7b1486190e6b7$export$c4744153514ff05d;
var $66d7b1486190e6b7$export$3e506c1ccc9cc1a7;
var $66d7b1486190e6b7$export$e26fe2ed2fa76875;
var $66d7b1486190e6b7$export$502329bbf4b505b1;
var $66d7b1486190e6b7$export$6e3807111c4874c4;
var $66d7b1486190e6b7$export$c27134553091fb3a;
var $66d7b1486190e6b7$export$33ee1acdc04fd2a2;
var $66d7b1486190e6b7$export$b00a404bbd5edef2;
var $66d7b1486190e6b7$export$d66a1c1c77bd778b;
var $66d7b1486190e6b7$export$d3dfb8e4810cb555;
var $66d7b1486190e6b7$export$72fdf0e06517287b;
var $66d7b1486190e6b7$export$816d2913ae6b83b1;
var $66d7b1486190e6b7$export$61bcfe829111a1d0;
var $66d7b1486190e6b7$export$7ee8c9beb337bc3f;
var $66d7b1486190e6b7$export$b5836b71941fa3ed;
var $66d7b1486190e6b7$export$cf845f2c119da08a;
"use strict";
function $66d7b1486190e6b7$var$push(heap, node) {
    var index = heap.length;
    heap.push(node);
    a: for(; 0 < index;){
        var parentIndex = index - 1 >>> 1, parent = heap[parentIndex];
        if (0 < $66d7b1486190e6b7$var$compare(parent, node)) heap[parentIndex] = node, heap[index] = parent, index = parentIndex;
        else break a;
    }
}
function $66d7b1486190e6b7$var$peek(heap) {
    return 0 === heap.length ? null : heap[0];
}
function $66d7b1486190e6b7$var$pop(heap) {
    if (0 === heap.length) return null;
    var first = heap[0], last = heap.pop();
    if (last !== first) {
        heap[0] = last;
        a: for(var index = 0, length = heap.length, halfLength = length >>> 1; index < halfLength;){
            var leftIndex = 2 * (index + 1) - 1, left = heap[leftIndex], rightIndex = leftIndex + 1, right = heap[rightIndex];
            if (0 > $66d7b1486190e6b7$var$compare(left, last)) rightIndex < length && 0 > $66d7b1486190e6b7$var$compare(right, left) ? (heap[index] = right, heap[rightIndex] = last, index = rightIndex) : (heap[index] = left, heap[leftIndex] = last, index = leftIndex);
            else if (rightIndex < length && 0 > $66d7b1486190e6b7$var$compare(right, last)) heap[index] = right, heap[rightIndex] = last, index = rightIndex;
            else break a;
        }
    }
    return first;
}
function $66d7b1486190e6b7$var$compare(a, b) {
    var diff = a.sortIndex - b.sortIndex;
    return 0 !== diff ? diff : a.id - b.id;
}
$66d7b1486190e6b7$export$c4744153514ff05d = void 0;
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $66d7b1486190e6b7$var$localPerformance = performance;
    $66d7b1486190e6b7$export$c4744153514ff05d = function() {
        return $66d7b1486190e6b7$var$localPerformance.now();
    };
} else {
    var $66d7b1486190e6b7$var$localDate = Date, $66d7b1486190e6b7$var$initialTime = $66d7b1486190e6b7$var$localDate.now();
    $66d7b1486190e6b7$export$c4744153514ff05d = function() {
        return $66d7b1486190e6b7$var$localDate.now() - $66d7b1486190e6b7$var$initialTime;
    };
}
var $66d7b1486190e6b7$var$taskQueue = [], $66d7b1486190e6b7$var$timerQueue = [], $66d7b1486190e6b7$var$taskIdCounter = 1, $66d7b1486190e6b7$var$currentTask = null, $66d7b1486190e6b7$var$currentPriorityLevel = 3, $66d7b1486190e6b7$var$isPerformingWork = !1, $66d7b1486190e6b7$var$isHostCallbackScheduled = !1, $66d7b1486190e6b7$var$isHostTimeoutScheduled = !1, $66d7b1486190e6b7$var$needsPaint = !1, $66d7b1486190e6b7$var$localSetTimeout = "function" === typeof setTimeout ? setTimeout : null, $66d7b1486190e6b7$var$localClearTimeout = "function" === typeof clearTimeout ? clearTimeout : null, $66d7b1486190e6b7$var$localSetImmediate = "undefined" !== typeof setImmediate ? setImmediate : null;
function $66d7b1486190e6b7$var$advanceTimers(currentTime) {
    for(var timer = $66d7b1486190e6b7$var$peek($66d7b1486190e6b7$var$timerQueue); null !== timer;){
        if (null === timer.callback) $66d7b1486190e6b7$var$pop($66d7b1486190e6b7$var$timerQueue);
        else if (timer.startTime <= currentTime) $66d7b1486190e6b7$var$pop($66d7b1486190e6b7$var$timerQueue), timer.sortIndex = timer.expirationTime, $66d7b1486190e6b7$var$push($66d7b1486190e6b7$var$taskQueue, timer);
        else break;
        timer = $66d7b1486190e6b7$var$peek($66d7b1486190e6b7$var$timerQueue);
    }
}
function $66d7b1486190e6b7$var$handleTimeout(currentTime) {
    $66d7b1486190e6b7$var$isHostTimeoutScheduled = !1;
    $66d7b1486190e6b7$var$advanceTimers(currentTime);
    if (!$66d7b1486190e6b7$var$isHostCallbackScheduled) {
        if (null !== $66d7b1486190e6b7$var$peek($66d7b1486190e6b7$var$taskQueue)) $66d7b1486190e6b7$var$isHostCallbackScheduled = !0, $66d7b1486190e6b7$var$isMessageLoopRunning || ($66d7b1486190e6b7$var$isMessageLoopRunning = !0, $66d7b1486190e6b7$var$schedulePerformWorkUntilDeadline());
        else {
            var firstTimer = $66d7b1486190e6b7$var$peek($66d7b1486190e6b7$var$timerQueue);
            null !== firstTimer && $66d7b1486190e6b7$var$requestHostTimeout($66d7b1486190e6b7$var$handleTimeout, firstTimer.startTime - currentTime);
        }
    }
}
var $66d7b1486190e6b7$var$isMessageLoopRunning = !1, $66d7b1486190e6b7$var$taskTimeoutID = -1, $66d7b1486190e6b7$var$frameInterval = 5, $66d7b1486190e6b7$var$startTime = -1;
function $66d7b1486190e6b7$var$shouldYieldToHost() {
    return $66d7b1486190e6b7$var$needsPaint ? !0 : $66d7b1486190e6b7$export$c4744153514ff05d() - $66d7b1486190e6b7$var$startTime < $66d7b1486190e6b7$var$frameInterval ? !1 : !0;
}
function $66d7b1486190e6b7$var$performWorkUntilDeadline() {
    $66d7b1486190e6b7$var$needsPaint = !1;
    if ($66d7b1486190e6b7$var$isMessageLoopRunning) {
        var currentTime = $66d7b1486190e6b7$export$c4744153514ff05d();
        $66d7b1486190e6b7$var$startTime = currentTime;
        var hasMoreWork = !0;
        try {
            a: {
                $66d7b1486190e6b7$var$isHostCallbackScheduled = !1;
                $66d7b1486190e6b7$var$isHostTimeoutScheduled && ($66d7b1486190e6b7$var$isHostTimeoutScheduled = !1, $66d7b1486190e6b7$var$localClearTimeout($66d7b1486190e6b7$var$taskTimeoutID), $66d7b1486190e6b7$var$taskTimeoutID = -1);
                $66d7b1486190e6b7$var$isPerformingWork = !0;
                var previousPriorityLevel = $66d7b1486190e6b7$var$currentPriorityLevel;
                try {
                    b: {
                        $66d7b1486190e6b7$var$advanceTimers(currentTime);
                        for($66d7b1486190e6b7$var$currentTask = $66d7b1486190e6b7$var$peek($66d7b1486190e6b7$var$taskQueue); null !== $66d7b1486190e6b7$var$currentTask && !($66d7b1486190e6b7$var$currentTask.expirationTime > currentTime && $66d7b1486190e6b7$var$shouldYieldToHost());){
                            var callback = $66d7b1486190e6b7$var$currentTask.callback;
                            if ("function" === typeof callback) {
                                $66d7b1486190e6b7$var$currentTask.callback = null;
                                $66d7b1486190e6b7$var$currentPriorityLevel = $66d7b1486190e6b7$var$currentTask.priorityLevel;
                                var continuationCallback = callback($66d7b1486190e6b7$var$currentTask.expirationTime <= currentTime);
                                currentTime = $66d7b1486190e6b7$export$c4744153514ff05d();
                                if ("function" === typeof continuationCallback) {
                                    $66d7b1486190e6b7$var$currentTask.callback = continuationCallback;
                                    $66d7b1486190e6b7$var$advanceTimers(currentTime);
                                    hasMoreWork = !0;
                                    break b;
                                }
                                $66d7b1486190e6b7$var$currentTask === $66d7b1486190e6b7$var$peek($66d7b1486190e6b7$var$taskQueue) && $66d7b1486190e6b7$var$pop($66d7b1486190e6b7$var$taskQueue);
                                $66d7b1486190e6b7$var$advanceTimers(currentTime);
                            } else $66d7b1486190e6b7$var$pop($66d7b1486190e6b7$var$taskQueue);
                            $66d7b1486190e6b7$var$currentTask = $66d7b1486190e6b7$var$peek($66d7b1486190e6b7$var$taskQueue);
                        }
                        if (null !== $66d7b1486190e6b7$var$currentTask) hasMoreWork = !0;
                        else {
                            var firstTimer = $66d7b1486190e6b7$var$peek($66d7b1486190e6b7$var$timerQueue);
                            null !== firstTimer && $66d7b1486190e6b7$var$requestHostTimeout($66d7b1486190e6b7$var$handleTimeout, firstTimer.startTime - currentTime);
                            hasMoreWork = !1;
                        }
                    }
                    break a;
                } finally{
                    $66d7b1486190e6b7$var$currentTask = null, $66d7b1486190e6b7$var$currentPriorityLevel = previousPriorityLevel, $66d7b1486190e6b7$var$isPerformingWork = !1;
                }
                hasMoreWork = void 0;
            }
        } finally{
            hasMoreWork ? $66d7b1486190e6b7$var$schedulePerformWorkUntilDeadline() : $66d7b1486190e6b7$var$isMessageLoopRunning = !1;
        }
    }
}
var $66d7b1486190e6b7$var$schedulePerformWorkUntilDeadline;
if ("function" === typeof $66d7b1486190e6b7$var$localSetImmediate) $66d7b1486190e6b7$var$schedulePerformWorkUntilDeadline = function() {
    $66d7b1486190e6b7$var$localSetImmediate($66d7b1486190e6b7$var$performWorkUntilDeadline);
};
else if ("undefined" !== typeof MessageChannel) {
    var $66d7b1486190e6b7$var$channel = new MessageChannel(), $66d7b1486190e6b7$var$port = $66d7b1486190e6b7$var$channel.port2;
    $66d7b1486190e6b7$var$channel.port1.onmessage = $66d7b1486190e6b7$var$performWorkUntilDeadline;
    $66d7b1486190e6b7$var$schedulePerformWorkUntilDeadline = function() {
        $66d7b1486190e6b7$var$port.postMessage(null);
    };
} else $66d7b1486190e6b7$var$schedulePerformWorkUntilDeadline = function() {
    $66d7b1486190e6b7$var$localSetTimeout($66d7b1486190e6b7$var$performWorkUntilDeadline, 0);
};
function $66d7b1486190e6b7$var$requestHostTimeout(callback, ms) {
    $66d7b1486190e6b7$var$taskTimeoutID = $66d7b1486190e6b7$var$localSetTimeout(function() {
        callback($66d7b1486190e6b7$export$c4744153514ff05d());
    }, ms);
}
$66d7b1486190e6b7$export$3e506c1ccc9cc1a7 = 5;
$66d7b1486190e6b7$export$e26fe2ed2fa76875 = 1;
$66d7b1486190e6b7$export$502329bbf4b505b1 = 4;
$66d7b1486190e6b7$export$6e3807111c4874c4 = 3;
$66d7b1486190e6b7$export$c27134553091fb3a = null;
$66d7b1486190e6b7$export$33ee1acdc04fd2a2 = 2;
$66d7b1486190e6b7$export$b00a404bbd5edef2 = function(task) {
    task.callback = null;
};
$66d7b1486190e6b7$export$d66a1c1c77bd778b = function(fps) {
    0 > fps || 125 < fps ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $66d7b1486190e6b7$var$frameInterval = 0 < fps ? Math.floor(1e3 / fps) : 5;
};
$66d7b1486190e6b7$export$d3dfb8e4810cb555 = function() {
    return $66d7b1486190e6b7$var$currentPriorityLevel;
};
$66d7b1486190e6b7$export$72fdf0e06517287b = function(eventHandler) {
    switch($66d7b1486190e6b7$var$currentPriorityLevel){
        case 1:
        case 2:
        case 3:
            var priorityLevel = 3;
            break;
        default:
            priorityLevel = $66d7b1486190e6b7$var$currentPriorityLevel;
    }
    var previousPriorityLevel = $66d7b1486190e6b7$var$currentPriorityLevel;
    $66d7b1486190e6b7$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $66d7b1486190e6b7$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$66d7b1486190e6b7$export$816d2913ae6b83b1 = function() {
    $66d7b1486190e6b7$var$needsPaint = !0;
};
$66d7b1486190e6b7$export$61bcfe829111a1d0 = function(priorityLevel, eventHandler) {
    switch(priorityLevel){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            priorityLevel = 3;
    }
    var previousPriorityLevel = $66d7b1486190e6b7$var$currentPriorityLevel;
    $66d7b1486190e6b7$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $66d7b1486190e6b7$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$66d7b1486190e6b7$export$7ee8c9beb337bc3f = function(priorityLevel, callback, options) {
    var currentTime = $66d7b1486190e6b7$export$c4744153514ff05d();
    "object" === typeof options && null !== options ? (options = options.delay, options = "number" === typeof options && 0 < options ? currentTime + options : currentTime) : options = currentTime;
    switch(priorityLevel){
        case 1:
            var timeout = -1;
            break;
        case 2:
            timeout = 250;
            break;
        case 5:
            timeout = 1073741823;
            break;
        case 4:
            timeout = 1e4;
            break;
        default:
            timeout = 5e3;
    }
    timeout = options + timeout;
    priorityLevel = {
        id: $66d7b1486190e6b7$var$taskIdCounter++,
        callback: callback,
        priorityLevel: priorityLevel,
        startTime: options,
        expirationTime: timeout,
        sortIndex: -1
    };
    options > currentTime ? (priorityLevel.sortIndex = options, $66d7b1486190e6b7$var$push($66d7b1486190e6b7$var$timerQueue, priorityLevel), null === $66d7b1486190e6b7$var$peek($66d7b1486190e6b7$var$taskQueue) && priorityLevel === $66d7b1486190e6b7$var$peek($66d7b1486190e6b7$var$timerQueue) && ($66d7b1486190e6b7$var$isHostTimeoutScheduled ? ($66d7b1486190e6b7$var$localClearTimeout($66d7b1486190e6b7$var$taskTimeoutID), $66d7b1486190e6b7$var$taskTimeoutID = -1) : $66d7b1486190e6b7$var$isHostTimeoutScheduled = !0, $66d7b1486190e6b7$var$requestHostTimeout($66d7b1486190e6b7$var$handleTimeout, options - currentTime))) : (priorityLevel.sortIndex = timeout, $66d7b1486190e6b7$var$push($66d7b1486190e6b7$var$taskQueue, priorityLevel), $66d7b1486190e6b7$var$isHostCallbackScheduled || $66d7b1486190e6b7$var$isPerformingWork || ($66d7b1486190e6b7$var$isHostCallbackScheduled = !0, $66d7b1486190e6b7$var$isMessageLoopRunning || ($66d7b1486190e6b7$var$isMessageLoopRunning = !0, $66d7b1486190e6b7$var$schedulePerformWorkUntilDeadline())));
    return priorityLevel;
};
$66d7b1486190e6b7$export$b5836b71941fa3ed = $66d7b1486190e6b7$var$shouldYieldToHost;
$66d7b1486190e6b7$export$cf845f2c119da08a = function(callback) {
    var parentPriorityLevel = $66d7b1486190e6b7$var$currentPriorityLevel;
    return function() {
        var previousPriorityLevel = $66d7b1486190e6b7$var$currentPriorityLevel;
        $66d7b1486190e6b7$var$currentPriorityLevel = parentPriorityLevel;
        try {
            return callback.apply(this, arguments);
        } finally{
            $66d7b1486190e6b7$var$currentPriorityLevel = previousPriorityLevel;
        }
    };
};

});


parcelRegister("bFZzf", function(module, exports) {
'use strict';

module.exports = (parcelRequire("at1B7"));

});

parcelRegister("5g5IQ", function(module, exports) {
'use strict';
function $3d42e2b16b1aec6c$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($3d42e2b16b1aec6c$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$3d42e2b16b1aec6c$var$checkDCE();

module.exports = (parcelRequire("5hGc2"));

});
parcelRegister("5hGc2", function(module, exports) {

$parcel$export(module.exports, "__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", () => $3d8f44f5662b021d$export$69ce8ef3fe5cead0, (v) => $3d8f44f5662b021d$export$69ce8ef3fe5cead0 = v);
$parcel$export(module.exports, "browser", () => $3d8f44f5662b021d$export$3f2684e5d7cb1006, (v) => $3d8f44f5662b021d$export$3f2684e5d7cb1006 = v);
$parcel$export(module.exports, "createPortal", () => $3d8f44f5662b021d$export$d39a5bbd09211389, (v) => $3d8f44f5662b021d$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "flushSync", () => $3d8f44f5662b021d$export$cd75ccfd720a3cd4, (v) => $3d8f44f5662b021d$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "preconnect", () => $3d8f44f5662b021d$export$a0816fa17a9e79be, (v) => $3d8f44f5662b021d$export$a0816fa17a9e79be = v);
$parcel$export(module.exports, "prefetchDNS", () => $3d8f44f5662b021d$export$7292efcadded39f3, (v) => $3d8f44f5662b021d$export$7292efcadded39f3 = v);
$parcel$export(module.exports, "preinit", () => $3d8f44f5662b021d$export$da407abadb9b8f86, (v) => $3d8f44f5662b021d$export$da407abadb9b8f86 = v);
$parcel$export(module.exports, "preinitModule", () => $3d8f44f5662b021d$export$314cfea32580671c, (v) => $3d8f44f5662b021d$export$314cfea32580671c = v);
$parcel$export(module.exports, "preload", () => $3d8f44f5662b021d$export$513ccb98c53b8039, (v) => $3d8f44f5662b021d$export$513ccb98c53b8039 = v);
$parcel$export(module.exports, "preloadModule", () => $3d8f44f5662b021d$export$dbca993bc2d264a, (v) => $3d8f44f5662b021d$export$dbca993bc2d264a = v);
$parcel$export(module.exports, "requestFormReset", () => $3d8f44f5662b021d$export$4797a8006f0655d0, (v) => $3d8f44f5662b021d$export$4797a8006f0655d0 = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $3d8f44f5662b021d$export$c78a37762a8d58e1, (v) => $3d8f44f5662b021d$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "useFormState", () => $3d8f44f5662b021d$export$606f11b2eb45ecc6, (v) => $3d8f44f5662b021d$export$606f11b2eb45ecc6 = v);
$parcel$export(module.exports, "useFormStatus", () => $3d8f44f5662b021d$export$f7e8a0bf92324b1e, (v) => $3d8f44f5662b021d$export$f7e8a0bf92324b1e = v);
$parcel$export(module.exports, "version", () => $3d8f44f5662b021d$export$83d89fbfd8236492, (v) => $3d8f44f5662b021d$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $3d8f44f5662b021d$export$69ce8ef3fe5cead0;
var $3d8f44f5662b021d$export$3f2684e5d7cb1006;
var $3d8f44f5662b021d$export$d39a5bbd09211389;
var $3d8f44f5662b021d$export$cd75ccfd720a3cd4;
var $3d8f44f5662b021d$export$a0816fa17a9e79be;
var $3d8f44f5662b021d$export$7292efcadded39f3;
var $3d8f44f5662b021d$export$da407abadb9b8f86;
var $3d8f44f5662b021d$export$314cfea32580671c;
var $3d8f44f5662b021d$export$513ccb98c53b8039;
var $3d8f44f5662b021d$export$dbca993bc2d264a;
var $3d8f44f5662b021d$export$4797a8006f0655d0;
var $3d8f44f5662b021d$export$c78a37762a8d58e1;
var $3d8f44f5662b021d$export$606f11b2eb45ecc6;
var $3d8f44f5662b021d$export$f7e8a0bf92324b1e;
var $3d8f44f5662b021d$export$83d89fbfd8236492;
"use strict";

var $bFZzf = parcelRequire("bFZzf");
function $3d8f44f5662b021d$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $3d8f44f5662b021d$var$noop() {}
var $3d8f44f5662b021d$var$Internals = {
    d: {
        f: $3d8f44f5662b021d$var$noop,
        r: function() {
            throw Error($3d8f44f5662b021d$var$formatProdErrorMessage(522));
        },
        D: $3d8f44f5662b021d$var$noop,
        C: $3d8f44f5662b021d$var$noop,
        L: $3d8f44f5662b021d$var$noop,
        m: $3d8f44f5662b021d$var$noop,
        X: $3d8f44f5662b021d$var$noop,
        S: $3d8f44f5662b021d$var$noop,
        M: $3d8f44f5662b021d$var$noop
    },
    p: 0,
    findDOMNode: null
}, $3d8f44f5662b021d$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $3d8f44f5662b021d$var$REACT_RECOVERABLE_TYPE = Symbol.for("react.recoverable"), $3d8f44f5662b021d$var$REACT_OPTIMISTIC_KEY = Symbol.for("react.optimistic_key");
function $3d8f44f5662b021d$var$createPortal$1(children, containerInfo, implementation) {
    var key = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $3d8f44f5662b021d$var$REACT_PORTAL_TYPE,
        key: null == key ? null : key === $3d8f44f5662b021d$var$REACT_OPTIMISTIC_KEY ? $3d8f44f5662b021d$var$REACT_OPTIMISTIC_KEY : "" + key,
        children: children,
        containerInfo: containerInfo,
        implementation: implementation
    };
}
var $3d8f44f5662b021d$var$ReactSharedInternals = $bFZzf.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
function $3d8f44f5662b021d$var$getCrossOriginStringAs(as, input) {
    if ("font" === as) return "";
    if ("string" === typeof input) return "use-credentials" === input ? input : "";
}
$3d8f44f5662b021d$export$69ce8ef3fe5cead0 = $3d8f44f5662b021d$var$Internals;
$3d8f44f5662b021d$export$3f2684e5d7cb1006 = function(reason) {
    return {
        $$typeof: $3d8f44f5662b021d$var$REACT_RECOVERABLE_TYPE,
        _reason: reason
    };
};
$3d8f44f5662b021d$export$d39a5bbd09211389 = function(children, container) {
    var key = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!container || 1 !== container.nodeType && 9 !== container.nodeType && 11 !== container.nodeType) throw Error($3d8f44f5662b021d$var$formatProdErrorMessage(299));
    return $3d8f44f5662b021d$var$createPortal$1(children, container, null, key);
};
$3d8f44f5662b021d$export$cd75ccfd720a3cd4 = function(fn) {
    var previousTransition = $3d8f44f5662b021d$var$ReactSharedInternals.T, previousUpdatePriority = $3d8f44f5662b021d$var$Internals.p;
    try {
        if ($3d8f44f5662b021d$var$ReactSharedInternals.T = null, $3d8f44f5662b021d$var$Internals.p = 2, fn) return fn();
    } finally{
        $3d8f44f5662b021d$var$ReactSharedInternals.T = previousTransition, $3d8f44f5662b021d$var$Internals.p = previousUpdatePriority, $3d8f44f5662b021d$var$Internals.d.f();
    }
};
$3d8f44f5662b021d$export$a0816fa17a9e79be = function(href, options) {
    "string" === typeof href && (options ? (options = options.crossOrigin, options = "string" === typeof options ? "use-credentials" === options ? options : "" : void 0) : options = null, $3d8f44f5662b021d$var$Internals.d.C(href, options));
};
$3d8f44f5662b021d$export$7292efcadded39f3 = function(href) {
    "string" === typeof href && $3d8f44f5662b021d$var$Internals.d.D(href);
};
$3d8f44f5662b021d$export$da407abadb9b8f86 = function(href, options) {
    if ("string" === typeof href && options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $3d8f44f5662b021d$var$getCrossOriginStringAs(as, options.crossOrigin), integrity = "string" === typeof options.integrity ? options.integrity : void 0, fetchPriority = "string" === typeof options.fetchPriority ? options.fetchPriority : void 0;
        "style" === as ? $3d8f44f5662b021d$var$Internals.d.S(href, "string" === typeof options.precedence ? options.precedence : void 0, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority
        }) : "script" === as && $3d8f44f5662b021d$var$Internals.d.X(href, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0
        });
    }
};
$3d8f44f5662b021d$export$314cfea32580671c = function(href, options) {
    if ("string" === typeof href) {
        if ("object" === typeof options && null !== options) {
            if (null == options.as || "script" === options.as) {
                var crossOrigin = $3d8f44f5662b021d$var$getCrossOriginStringAs(options.as, options.crossOrigin);
                $3d8f44f5662b021d$var$Internals.d.M(href, {
                    crossOrigin: crossOrigin,
                    integrity: "string" === typeof options.integrity ? options.integrity : void 0,
                    nonce: "string" === typeof options.nonce ? options.nonce : void 0,
                    fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0
                });
            }
        } else null == options && $3d8f44f5662b021d$var$Internals.d.M(href);
    }
};
$3d8f44f5662b021d$export$513ccb98c53b8039 = function(href, options) {
    if ("string" === typeof href && "object" === typeof options && null !== options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $3d8f44f5662b021d$var$getCrossOriginStringAs(as, options.crossOrigin);
        $3d8f44f5662b021d$var$Internals.d.L(href, as, {
            crossOrigin: crossOrigin,
            integrity: "string" === typeof options.integrity ? options.integrity : void 0,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0,
            type: "string" === typeof options.type ? options.type : void 0,
            fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0,
            referrerPolicy: "string" === typeof options.referrerPolicy ? options.referrerPolicy : void 0,
            imageSrcSet: "string" === typeof options.imageSrcSet ? options.imageSrcSet : void 0,
            imageSizes: "string" === typeof options.imageSizes ? options.imageSizes : void 0,
            media: "string" === typeof options.media ? options.media : void 0
        });
    }
};
$3d8f44f5662b021d$export$dbca993bc2d264a = function(href, options) {
    if ("string" === typeof href) {
        if (options) {
            var crossOrigin = $3d8f44f5662b021d$var$getCrossOriginStringAs(options.as, options.crossOrigin);
            $3d8f44f5662b021d$var$Internals.d.m(href, {
                as: "string" === typeof options.as && "script" !== options.as ? options.as : void 0,
                crossOrigin: crossOrigin,
                integrity: "string" === typeof options.integrity ? options.integrity : void 0,
                nonce: "string" === typeof options.nonce ? options.nonce : void 0,
                fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0
            });
        } else $3d8f44f5662b021d$var$Internals.d.m(href);
    }
};
$3d8f44f5662b021d$export$4797a8006f0655d0 = function(form) {
    $3d8f44f5662b021d$var$Internals.d.r(form);
};
$3d8f44f5662b021d$export$c78a37762a8d58e1 = function(fn, a) {
    return fn(a);
};
$3d8f44f5662b021d$export$606f11b2eb45ecc6 = function(action, initialState, permalink) {
    return $3d8f44f5662b021d$var$ReactSharedInternals.H.useFormState(action, initialState, permalink);
};
$3d8f44f5662b021d$export$f7e8a0bf92324b1e = function() {
    return $3d8f44f5662b021d$var$ReactSharedInternals.H.useHostTransitionStatus();
};
$3d8f44f5662b021d$export$83d89fbfd8236492 = "19.3.1";

});



var $eeebe4096ef7ee1f$exports = {};
'use strict';

$eeebe4096ef7ee1f$exports = (parcelRequire("buXuT"));



var $bFZzf = parcelRequire("bFZzf");
var $6fa0a1dddf463a10$exports = {};
'use strict';
function $6fa0a1dddf463a10$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($6fa0a1dddf463a10$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$6fa0a1dddf463a10$var$checkDCE();

$6fa0a1dddf463a10$exports = (parcelRequire("2Cd0r"));


const $8a3c98632a397758$export$9dd6ff9ea0189349 = {
    container: {
        width: '100%',
        maxWidth: '100%',
        padding: '24px',
        display: 'flex',
        flexDirection: 'column',
        gap: '24px',
        boxSizing: 'border-box'
    },
    header: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '16px 24px',
        backgroundColor: 'var(--card-bg)',
        borderRadius: '12px',
        border: '1px solid var(--border-color)',
        boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)'
    },
    logoGroup: {
        display: 'flex',
        alignItems: 'center',
        gap: '12px'
    },
    badge: {
        padding: '4px 8px',
        borderRadius: '6px',
        fontSize: '11px',
        fontWeight: 'bold',
        backgroundColor: 'var(--accent)',
        color: '#fff',
        letterSpacing: '0.05em'
    },
    title: {
        fontSize: '20px',
        fontWeight: 700,
        letterSpacing: '-0.02em',
        color: 'var(--text-main)'
    },
    healthStatus: {
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        fontSize: '13px'
    },
    dot: {
        width: '8px',
        height: '8px',
        borderRadius: '50%'
    },
    statusText: {
        color: 'var(--text-muted)'
    },
    urlInput: {
        padding: '6px 12px',
        borderRadius: '6px',
        border: '1px solid var(--border-color)',
        backgroundColor: 'var(--bg-color)',
        color: 'var(--text-main)',
        fontFamily: 'monospace',
        fontSize: '12px',
        width: '320px',
        marginLeft: '8px',
        outline: 'none',
        transition: 'border-color 0.2s'
    },
    mainGrid: {
        display: 'flex',
        flexDirection: 'column',
        gap: '24px'
    },
    card: {
        backgroundColor: 'var(--card-bg)',
        borderRadius: '12px',
        border: '1px solid var(--border-color)',
        padding: '24px',
        display: 'flex',
        flexDirection: 'column',
        gap: '16px',
        boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.3)'
    },
    sectionHeader: {
        fontSize: '18px',
        fontWeight: 600,
        color: 'var(--text-main)',
        borderBottom: '1px solid var(--border-color)',
        paddingBottom: '12px',
        marginBottom: '4px'
    },
    subHeader: {
        fontSize: '14px',
        fontWeight: 600,
        color: 'var(--text-main)',
        marginBottom: '10px',
        letterSpacing: '0.03em',
        textTransform: 'uppercase'
    },
    buttonGroup: {
        display: 'flex',
        flexDirection: 'column',
        gap: '8px'
    },
    row: {
        display: 'flex',
        gap: '12px',
        flexWrap: 'wrap'
    },
    col: {
        flex: 1,
        minWidth: '150px',
        display: 'flex',
        flexDirection: 'column',
        gap: '6px'
    },
    fieldLabel: {
        fontSize: '12px',
        fontWeight: 600,
        color: 'var(--text-muted)',
        textTransform: 'uppercase',
        letterSpacing: '0.05em'
    },
    numberLabel: {
        fontSize: '11px',
        color: 'var(--text-muted)'
    },
    formGroup: {
        display: 'flex',
        flexDirection: 'column',
        gap: '8px'
    },
    input: {
        padding: '8px 12px',
        borderRadius: '6px',
        border: '1px solid var(--border-color)',
        backgroundColor: 'var(--bg-color)',
        color: 'var(--text-main)',
        fontSize: '14px',
        outline: 'none'
    },
    textarea: {
        padding: '12px',
        borderRadius: '6px',
        border: '1px solid var(--border-color)',
        backgroundColor: 'var(--bg-color)',
        color: 'var(--text-main)',
        fontSize: '14px',
        outline: 'none',
        resize: 'vertical',
        fontFamily: 'inherit'
    },
    checkboxContainer: {
        display: 'flex',
        flexDirection: 'row',
        gap: '24px',
        padding: '4px 0',
        flexWrap: 'wrap'
    },
    checkboxLabel: {
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        fontSize: '13px',
        cursor: 'pointer'
    },
    checkbox: {
        cursor: 'pointer'
    },
    primaryButton: {
        padding: '12px 24px',
        borderRadius: '6px',
        border: 'none',
        backgroundColor: 'var(--accent)',
        color: '#fff',
        fontSize: '14px',
        fontWeight: 600,
        cursor: 'pointer',
        transition: 'background-color 0.2s',
        outline: 'none'
    },
    errorAlert: {
        padding: '12px',
        backgroundColor: 'rgba(239, 68, 68, 0.1)',
        border: '1px solid rgba(239, 68, 68, 0.3)',
        color: '#fca5a5',
        borderRadius: '6px',
        fontSize: '13px'
    },
    canvasContainer: {
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: 'var(--bg-color)',
        borderRadius: '8px',
        padding: '16px',
        border: '1px solid var(--border-color)',
        minHeight: '500px',
        overflow: 'hidden',
        cursor: 'grab'
    },
    canvasContainerDragging: {
        cursor: 'grabbing'
    },
    svg: {
        display: 'block',
        userSelect: 'none'
    },
    coordinatesList: {
        marginTop: '8px'
    },
    table: {
        width: '100%',
        borderCollapse: 'collapse',
        fontSize: '13px'
    },
    th: {
        textAlign: 'left',
        padding: '10px 8px',
        borderBottom: '2px solid var(--border-color)',
        color: 'var(--text-muted)',
        fontWeight: 600
    },
    tr: {
        borderBottom: '1px solid var(--border-color)'
    },
    td: {
        padding: '10px 8px',
        color: 'var(--text-main)'
    },
    code: {
        fontFamily: 'monospace',
        color: '#ab47bc',
        backgroundColor: 'rgba(171, 71, 188, 0.1)',
        padding: '2px 4px',
        borderRadius: '4px'
    },
    typeSpan: {
        color: 'var(--text-muted)',
        fontSize: '11px'
    },
    logsSplitGrid: {
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gap: '20px',
        width: '100%'
    },
    logBox: {
        backgroundColor: 'var(--bg-color)',
        border: '1px solid var(--border-color)',
        borderRadius: '8px',
        padding: '16px',
        maxHeight: '320px',
        overflowY: 'auto',
        display: 'flex',
        flexDirection: 'column',
        gap: '12px'
    },
    emptyLogs: {
        color: 'var(--text-muted)',
        fontSize: '13px',
        textAlign: 'center',
        padding: '40px 0'
    },
    logItem: {
        borderBottom: '1px solid rgba(255, 255, 255, 0.05)',
        paddingBottom: '10px'
    },
    logMeta: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '4px'
    },
    logBadge: {
        fontSize: '9px',
        fontWeight: 'bold',
        padding: '2px 6px',
        borderRadius: '4px',
        color: '#fff'
    },
    logTime: {
        fontSize: '10px',
        color: 'var(--text-muted)'
    },
    logText: {
        fontSize: '12px',
        color: 'var(--text-main)',
        lineHeight: '1.4'
    },
    details: {
        marginTop: '6px'
    },
    summary: {
        fontSize: '11px',
        color: 'var(--accent)',
        cursor: 'pointer',
        outline: 'none'
    },
    json: {
        marginTop: '6px',
        fontSize: '10px',
        backgroundColor: 'rgba(0,0,0,0.3)',
        padding: '8px',
        borderRadius: '4px',
        overflowX: 'auto',
        fontFamily: 'JetBrains Mono, monospace',
        color: '#34d399'
    },
    codeBox: {
        backgroundColor: 'var(--bg-color)',
        border: '1px solid var(--border-color)',
        borderRadius: '8px',
        padding: '16px',
        maxHeight: '320px',
        overflowY: 'auto'
    },
    scriptPre: {
        margin: 0,
        fontFamily: 'JetBrains Mono, monospace',
        fontSize: '12px'
    },
    python: {
        color: '#ab47bc'
    },
    emptyScript: {
        color: 'var(--text-muted)',
        fontSize: '13px',
        textAlign: 'center',
        padding: '40px 0'
    },
    validationSection: {
        marginTop: '8px',
        paddingTop: '8px'
    },
    validationSummaryGrid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(4, 1fr)',
        gap: '12px',
        marginBottom: '16px'
    },
    validationCard: {
        backgroundColor: 'rgba(255,255,255,0.02)',
        border: '1px solid var(--border-color)',
        borderRadius: '8px',
        padding: '12px',
        textAlign: 'center'
    },
    valNumber: {
        fontSize: '22px',
        fontWeight: 'bold',
        color: 'var(--text-main)'
    },
    valLabel: {
        fontSize: '11px',
        color: 'var(--text-muted)',
        marginTop: '2px',
        textTransform: 'uppercase',
        letterSpacing: '0.05em'
    },
    rulesList: {
        display: 'flex',
        flexDirection: 'column',
        gap: '10px'
    },
    ruleItem: {
        backgroundColor: 'rgba(255,255,255,0.01)',
        border: '1px solid var(--border-color)',
        borderRadius: '6px',
        padding: '12px'
    },
    ruleHeader: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '4px'
    },
    ruleId: {
        fontSize: '12px',
        fontWeight: 'bold',
        color: 'var(--text-main)',
        fontFamily: 'monospace'
    },
    statusBadge: {
        fontSize: '10px',
        fontWeight: 'bold',
        padding: '2px 6px',
        borderRadius: '4px'
    },
    ruleMsg: {
        fontSize: '12px',
        color: 'var(--text-muted)',
        lineHeight: '1.4'
    },
    repairInfo: {
        marginTop: '6px',
        fontSize: '11px',
        color: '#fca5a5',
        backgroundColor: 'rgba(239, 68, 68, 0.05)',
        padding: '6px 10px',
        borderRadius: '4px',
        borderLeft: '2px solid #ef4444',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        gap: '12px',
        flexWrap: 'wrap'
    },
    select: {
        padding: '8px 12px',
        borderRadius: '6px',
        border: '1px solid var(--border-color)',
        backgroundColor: 'var(--bg-color)',
        color: 'var(--text-main)',
        fontSize: '14px',
        outline: 'none',
        width: '100%',
        cursor: 'pointer'
    },
    saveButton: {
        padding: '12px 24px',
        borderRadius: '6px',
        border: 'none',
        backgroundColor: '#2e7d32',
        color: '#fff',
        fontSize: '14px',
        fontWeight: 600,
        cursor: 'pointer',
        transition: 'background-color 0.2s',
        outline: 'none'
    },
    // NEW STYLES:
    fileUploadRow: {
        display: 'flex',
        alignItems: 'center',
        gap: '12px',
        padding: '16px',
        border: '2px dashed var(--border-color)',
        borderRadius: '8px',
        backgroundColor: 'rgba(255,255,255,0.01)',
        transition: 'all 0.2s ease',
        width: '100%'
    },
    fileUploadBtn: {
        padding: '8px 16px',
        borderRadius: '6px',
        border: '1px solid var(--border-color)',
        backgroundColor: 'var(--bg-color)',
        color: 'var(--text-main)',
        cursor: 'pointer',
        fontSize: '13px',
        fontWeight: 500,
        outline: 'none'
    },
    fileUploadText: {
        fontSize: '13px',
        color: 'var(--text-muted)'
    },
    accordion: {
        border: '1px solid var(--border-color)',
        borderRadius: '8px',
        overflow: 'hidden',
        marginTop: '16px',
        backgroundColor: 'rgba(255,255,255,0.01)'
    },
    accordionHeader: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '14px 20px',
        backgroundColor: 'rgba(255, 255, 255, 0.02)',
        cursor: 'pointer',
        userSelect: 'none',
        transition: 'background-color 0.2s'
    },
    accordionTitle: {
        fontSize: '15px',
        fontWeight: 600,
        color: 'var(--text-main)',
        display: 'flex',
        alignItems: 'center',
        gap: '8px'
    },
    accordionArrow: {
        fontSize: '12px',
        color: 'var(--text-muted)',
        transition: 'transform 0.2s ease'
    },
    accordionContent: {
        padding: '20px',
        backgroundColor: 'transparent',
        borderTop: '1px solid var(--border-color)'
    },
    solveBtn: {
        padding: '4px 10px',
        borderRadius: '4px',
        border: '1px solid #ef4444',
        backgroundColor: 'rgba(239, 68, 68, 0.1)',
        color: '#fca5a5',
        cursor: 'pointer',
        fontSize: '11px',
        fontWeight: 600,
        transition: 'all 0.2s',
        outline: 'none'
    },
    solveAllBtn: {
        padding: '10px 16px',
        borderRadius: '6px',
        border: '1px solid #ef4444',
        backgroundColor: 'rgba(239, 68, 68, 0.15)',
        color: '#fca5a5',
        cursor: 'pointer',
        fontSize: '12px',
        fontWeight: 600,
        transition: 'all 0.2s',
        outline: 'none',
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '6px',
        marginTop: '4px',
        boxSizing: 'border-box'
    },
    canvasControls: {
        position: 'absolute',
        bottom: '16px',
        right: '16px',
        display: 'flex',
        gap: '8px',
        zIndex: 10
    },
    canvasBtn: {
        width: '36px',
        height: '36px',
        borderRadius: '6px',
        border: '1px solid var(--border-color)',
        backgroundColor: 'var(--card-bg)',
        color: 'var(--text-main)',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontWeight: 'bold',
        fontSize: '16px',
        boxShadow: '0 4px 6px rgba(0,0,0,0.3)',
        userSelect: 'none',
        outline: 'none',
        transition: 'all 0.2s'
    },
    geminiPromptsBox: {
        display: 'flex',
        flexDirection: 'column',
        gap: '12px',
        marginTop: '16px',
        padding: '16px',
        backgroundColor: 'rgba(255, 255, 255, 0.02)',
        borderRadius: '8px',
        border: '1px solid var(--border-color)'
    },
    geminiCallCard: {
        backgroundColor: 'var(--bg-color)',
        border: '1px solid var(--border-color)',
        borderRadius: '6px',
        padding: '14px',
        display: 'flex',
        flexDirection: 'column',
        gap: '10px'
    },
    preWrap: {
        margin: 0,
        whiteSpace: 'pre-wrap',
        fontFamily: 'JetBrains Mono, monospace',
        fontSize: '12px',
        color: 'var(--text-main)',
        backgroundColor: 'rgba(0,0,0,0.2)',
        padding: '10px',
        borderRadius: '4px',
        overflowX: 'auto'
    },
    sideBySideContainer: {
        display: 'flex',
        gap: '24px',
        flexWrap: 'wrap',
        width: '100%',
        alignItems: 'stretch'
    },
    leftColumn: {
        flex: '1 1 600px',
        display: 'flex',
        flexDirection: 'column',
        gap: '16px',
        minWidth: '320px'
    },
    rightColumn: {
        flex: '1 1 400px',
        display: 'flex',
        flexDirection: 'column',
        gap: '16px',
        minWidth: '320px'
    }
};



parcelRequire("bFZzf");

function $bb4933fc8764fe54$export$8b251419efc915eb({ backendHealthy: backendHealthy, backendUrl: backendUrl, setBackendUrl: setBackendUrl, activeTab: activeTab = 'editor', onTabChange: onTabChange }) {
    return /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("header", {
        style: (0, $8a3c98632a397758$export$9dd6ff9ea0189349).header,
        children: [
            /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("div", {
                style: (0, $8a3c98632a397758$export$9dd6ff9ea0189349).logoGroup,
                children: [
                    /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("div", {
                        style: (0, $8a3c98632a397758$export$9dd6ff9ea0189349).badge,
                        children: "Phase 1 R&D"
                    }),
                    /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("h1", {
                        style: (0, $8a3c98632a397758$export$9dd6ff9ea0189349).title,
                        children: "Partial Design Generator"
                    })
                ]
            }),
            onTabChange && /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("div", {
                style: {
                    display: 'flex',
                    gap: '8px',
                    marginLeft: '20px'
                },
                children: [
                    /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("button", {
                        onClick: ()=>onTabChange('editor'),
                        style: {
                            padding: '6px 14px',
                            borderRadius: '6px',
                            fontSize: '13px',
                            fontWeight: 600,
                            cursor: 'pointer',
                            border: activeTab === 'editor' ? '1px solid var(--accent)' : '1px solid #333',
                            backgroundColor: activeTab === 'editor' ? 'rgba(156, 39, 176, 0.2)' : '#1e1e1e',
                            color: activeTab === 'editor' ? '#ffffff' : '#9ca3af',
                            transition: 'all 0.2s'
                        },
                        children: "\uD83C\uDFA8 N\xe1vrh M\xedstnosti & Chat"
                    }),
                    /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("button", {
                        onClick: ()=>onTabChange('skills'),
                        style: {
                            padding: '6px 14px',
                            borderRadius: '6px',
                            fontSize: '13px',
                            fontWeight: 600,
                            cursor: 'pointer',
                            border: activeTab === 'skills' ? '1px solid var(--accent)' : '1px solid #333',
                            backgroundColor: activeTab === 'skills' ? 'rgba(156, 39, 176, 0.2)' : '#1e1e1e',
                            color: activeTab === 'skills' ? '#ffffff' : '#9ca3af',
                            transition: 'all 0.2s'
                        },
                        children: "\uD83E\uDDE0 Agent Skills Library"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("div", {
                style: (0, $8a3c98632a397758$export$9dd6ff9ea0189349).healthStatus,
                children: [
                    /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("span", {
                        style: {
                            ...(0, $8a3c98632a397758$export$9dd6ff9ea0189349).dot,
                            backgroundColor: backendHealthy === true ? 'var(--success)' : backendHealthy === false ? '#ef4444' : '#f59e0b'
                        }
                    }),
                    /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("span", {
                        style: (0, $8a3c98632a397758$export$9dd6ff9ea0189349).statusText,
                        children: [
                            "Backend: ",
                            backendHealthy === true ? 'Connected' : backendHealthy === false ? 'Disconnected' : 'Checking...'
                        ]
                    }),
                    /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("input", {
                        type: "text",
                        value: backendUrl,
                        onChange: (e)=>setBackendUrl(e.target.value),
                        style: (0, $8a3c98632a397758$export$9dd6ff9ea0189349).urlInput
                    }),
                    /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("a", {
                        href: `${backendUrl}/chatbot-doc`,
                        target: "_blank",
                        rel: "noopener noreferrer",
                        className: "readme-btn",
                        style: {
                            borderColor: 'rgba(156, 39, 176, 0.4)',
                            color: '#e1bee7'
                        },
                        children: "\uD83D\uDCAC CHATBOT.md"
                    }),
                    /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("a", {
                        href: `${backendUrl}/zoning-doc`,
                        target: "_blank",
                        rel: "noopener noreferrer",
                        className: "readme-btn",
                        style: {
                            borderColor: 'rgba(59, 130, 246, 0.3)',
                            color: '#93c5fd'
                        },
                        children: "\uD83D\uDCD0 ZONING.md"
                    }),
                    /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("a", {
                        href: `${backendUrl}/readme`,
                        target: "_blank",
                        rel: "noopener noreferrer",
                        className: "readme-btn",
                        children: "\uD83D\uDCD6 README.md"
                    })
                ]
            })
        ]
    });
}




var $bFZzf = parcelRequire("bFZzf");
/**
 * Shared Type Definitions for Partial Design Generator
 * 
 * ==============================================================================
 * COORDINATE SYSTEM & UNIT CONVENTIONS
 * ==============================================================================
 * 
 * | Parameter     | DB Format (SceneData)           | LLM / Python Format (RoomLayoutDb)  | Discriminator Format (ValidationRequest) |
 * |---------------|---------------------------------|--------------------------------------|-------------------------------------------|
 * | Width Axis    | X (horizontal)                  | X (horizontal)                       | X (horizontal)                            |
 * | Length Axis   | Z (horizontal)                  | Y (horizontal)                       | Z (horizontal)                            |
 * | Height Axis   | Y (vertical)                    | Z (vertical)                         | Y (vertical)                              |
 * | Origin        | Center of room floor (0, 0, 0)  | Bottom-left corner (0, 0, 0)         | Center of room floor (0, 0, 0)            |
 * | Length Units  | Meters (m)                      | Meters (m)                           | Millimeters (mm)                          |
 * | Size Units    | Millimeters (mm)                | Meters (m)                           | Millimeters (mm)                          |
 * | Rotation Axis | Y-axis                          | Z-axis                               | Y-axis                                    |
 * | Rotation Units| Radians (rad)                   | Degrees (deg, 0-360 CCW)             | Radians (rad)                             |
 * 
 * ==============================================================================
 * IDENTIFIER (ID) CONVENTIONS
 * ==============================================================================
 * 
 * 1. Room ID:
 *    - Located at `Room.id`. This is a database UUID string.
 * 2. Instance ID (within a layout):
 *    - In the DB: `SceneObject._id` is a unique number (e.g., 1, 2, 3...) within the scene.
 *    - In the AI: `RoomLayoutDb.items[].itemId` is the string representation of `SceneObject._id`.
 * 3. Accessory/Catalog ID:
 *    - In the DB: `SceneObject._accesoryId` is a UUID string referencing the furniture catalog template.
 *    - In the AI: stored inside `metadata.accesoryId` of `RoomLayoutDb.items` to prevent data loss.
 * 4. Snapping Parent ID:
 *    - In the DB: `SceneObject._parentId` references the `_id` of the parent object.
 *    - In the AI: stored inside `metadata.parentId`.
 */ // ==============================================================================
// SECTION 1: DATABASE & CATALOG RAW FORMATS (DB CLIENT)
// ==============================================================================
/**
 * Represents the primary Room document stored in the database.
 */ 



function $51b2f438b0a0db3d$export$c6a3326defc57bc2(roomDb, questionnaire) {
    const promptContext = `
Room Dimensions:
- Width (X): ${roomDb.width} meters (horizontal range: [0, ${roomDb.width}])
- Length (Y): ${roomDb.length} meters (horizontal range: [0, ${roomDb.length}])
- Height (Z): ${roomDb.height} meters (vertical range: [0, ${roomDb.height}])

Coordinate System Rules:
1. Corner Origin: The bottom-left corner of the room floor is at (0, 0, 0).
2. Axes:
   - X: width of the room (left-to-right)
   - Y: length of the room (front-to-back)
   - Z: elevation height above the floor (0.0 means sitting on the floor)
3. Sizes:
   - size.width: item width (along X axis)
   - size.length: item length/depth (along Y axis)
   - size.height: item height (along Z axis)
4. Rotation: Rotation in degrees (0 to 360) around the vertical Z-axis.

Occupants/Preferences:
- Adults: ${questionnaire.numberOfAdults}
- Children: ${questionnaire.numberOfChildren}
- Guests: ${questionnaire.numberOfGuests}
- Needs Workplace: ${questionnaire.workplace ? 'Yes' : 'No'}
- Needs Playground: ${questionnaire.playground ? 'Yes' : 'No'}
`;
    // Format a simplified representation of the items for clean context
    const itemsJson = roomDb.items.map((item)=>({
            itemId: item.itemId,
            label: item.label,
            description: item.description,
            type: item.type,
            size: {
                width: Math.round(item.size.width * 1000) / 1000,
                length: Math.round(item.size.length * 1000) / 1000,
                height: Math.round(item.size.height * 1000) / 1000
            },
            position: {
                x: Math.round(item.position.x * 1000) / 1000,
                y: Math.round(item.position.y * 1000) / 1000,
                z: Math.round(item.position.z * 1000) / 1000
            },
            rotationDegrees: Math.round(item.angle),
            materials: item.materials || []
        }));
    const currentLayoutJson = JSON.stringify(itemsJson, null, 2);
    return {
        promptContext: promptContext,
        currentLayoutJson: currentLayoutJson
    };
}


function $48d1860fd57fbbdb$export$33fa355554efae18(rawOutput) {
    try {
        const data = JSON.parse(rawOutput.trim());
        if (data && typeof data === 'object' && data.status === 'success') {
            const items = data.items || [];
            const placements = items.map((item)=>({
                    id: item.itemId,
                    position: item.position,
                    rotation: item.angle
                }));
            return {
                status: 'success',
                placements: placements,
                items: items,
                warnings: data.warnings || []
            };
        }
        // Backward compatibility check for placements-only response
        if (data && typeof data === 'object' && 'placements' in data) return {
            status: 'success',
            placements: data.placements
        };
        return {
            status: 'error',
            error: data.error || 'Python output did not contain valid placement coordinate structure.',
            placements: []
        };
    } catch (error) {
        return {
            status: 'error',
            error: `Failed to parse Python stdout as JSON: ${error instanceof Error ? error.message : String(error)}`,
            placements: []
        };
    }
}


// Strip Czech diacritics and lowercase for string matching
function $be86c3182e7e6769$export$cb0bbc88c7f09596(str) {
    return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
}
function $be86c3182e7e6769$export$e196931a45036452(categoryName, objectName) {
    const cleanObj = $be86c3182e7e6769$export$cb0bbc88c7f09596(objectName);
    if (cleanObj.includes('okn') || cleanObj.includes('window')) return 'window';
    if (cleanObj.includes('dver') || cleanObj.includes('door')) return 'door';
    if (cleanObj.includes('postel') || cleanObj.includes('luzk') || cleanObj.includes('bed')) return 'bed';
    if (categoryName) {
        const cleanCat = $be86c3182e7e6769$export$cb0bbc88c7f09596(categoryName);
        // Check Czech category names from the database (normalized)
        if (cleanCat.includes('postel') || cleanCat.includes('luzk') || cleanCat.includes('matrac') || cleanCat.includes('valend') || cleanCat.includes('paland') || cleanCat.includes('kolib') || cleanCat.includes('bed')) return 'bed';
        if (cleanCat.includes('pohov') || cleanCat.includes('sedac') || cleanCat.includes('kresl')) return 'sofa';
        if (cleanCat.includes('zidl') || cleanCat.includes('kreslo') || cleanCat.includes('taburet') || cleanCat.includes('lavic')) return 'chair';
        if (cleanCat.includes('stol') || cleanCat.includes('stul')) return 'table';
        if (cleanCat.includes('komod') || cleanCat.includes('skrin') || cleanCat.includes('ulozn') || cleanCat.includes('knihovn') || cleanCat.includes('regal') || cleanCat.includes('vitrin') || cleanCat.includes('sestav') || cleanCat.includes('sten')) return 'cabinet';
        if (cleanCat.includes('dver')) return 'door';
        if (cleanCat.includes('okn')) return 'window';
        if (cleanCat.includes('svit') || cleanCat.includes('svetl') || cleanCat.includes('lamp') || cleanCat.includes('osvetl')) return 'lighting';
        if (cleanCat.includes('dekor')) return 'decoration';
    }
    // Fallback classification by object name (English or general matching)
    const lower = objectName.toLowerCase();
    const cleanLower = $be86c3182e7e6769$export$cb0bbc88c7f09596(objectName);
    if (cleanLower.includes('bed') || cleanLower.includes('postel') || cleanLower.includes('luzk') || cleanLower.includes('matrac') || cleanLower.includes('valend') || cleanLower.includes('paland') || cleanLower.includes('kolib')) return 'bed';
    if (lower.includes('chair') || lower.includes('kreslo') || lower.includes('zidle') || lower.includes('stolicka')) return 'chair';
    if (lower.includes('sofa') || lower.includes('gauci') || lower.includes('sedacka')) return 'sofa';
    if (lower.includes('desk') || lower.includes('psaci') || lower.includes('stul') || lower.includes('stol')) return 'table';
    if (lower.includes('cabinet') || lower.includes('komoda') || lower.includes('skrin') || lower.includes('knihovna')) return 'cabinet';
    if (lower.includes('door') || lower.includes('dvere')) return 'door';
    if (lower.includes('window') || lower.includes('okno')) return 'window';
    if (lower.includes('light') || lower.includes('lampa') || lower.includes('osvetleni') || lower.includes('ceilinglight')) return 'lighting';
    return 'decoration';
}



function $90c3eb9fdb4d1b68$export$ecb7313f4bd51d67(roomOrScene) {
    if (roomOrScene && typeof roomOrScene === 'object' && 'sceneData' in roomOrScene) return typeof roomOrScene.sceneData === 'string' ? JSON.parse(roomOrScene.sceneData) : roomOrScene.sceneData;
    return roomOrScene;
}
function $90c3eb9fdb4d1b68$export$9bdd500d89ec814(roomOrScene, accessoryToCategoryMap) {
    const sceneData = $90c3eb9fdb4d1b68$export$ecb7313f4bd51d67(roomOrScene);
    const firstRoom = sceneData._rooms[0];
    if (!firstRoom) throw new Error('SceneData does not contain any room specifications.');
    const roomWidth = firstRoom._size.x; // meters
    const roomHeight = firstRoom._size.y; // meters
    const roomLength = firstRoom._size.z; // meters
    const items = firstRoom._objects.map((obj)=>{
        // Resolve exact category details from helper map
        const categoryInfo = accessoryToCategoryMap?.get(obj._accesoryId);
        // DB position is in meters, relative to room center (0,0,0)
        const x = obj._position.x + roomWidth / 2;
        const y = obj._position.z + roomLength / 2;
        const z = obj._position.y;
        // DB size is in millimeters
        const dimX = obj._size.x / 1000;
        const dimY = obj._size.z / 1000; // Z depth maps to Y length
        const dimZ = obj._size.y / 1000; // Y height maps to Z height
        // Convert rotation: DB can return Quaternions (with w) or Euler angles (without w)
        let angle = 0;
        const rot = obj._rotation;
        if (rot && rot.w !== undefined) {
            // It's a Quaternion, compute yaw (rotation around vertical Y-axis)
            const qx = rot.x || 0;
            const qy = rot.y || 0;
            const qz = rot.z || 0;
            const qw = rot.w;
            const yawRad = Math.atan2(2 * (qx * qz + qw * qy), 1 - 2 * (qy * qy + qz * qz));
            angle = yawRad * 180 / Math.PI % 360;
        } else // Fallback: It's Euler angles in radians around Y-axis
        angle = rot.y * 180 / Math.PI % 360;
        if (angle < 0) angle += 360;
        // Resolve strict description, colors, materials
        const description = obj.description || categoryInfo?.categoryName || obj._name;
        const colors = obj.colors || [];
        const materials = obj.materials || obj._materials?.map((m)=>m._variant).filter(Boolean) || [];
        return {
            itemId: obj._id.toString(),
            label: obj._name,
            description: description,
            type: (0, $be86c3182e7e6769$export$e196931a45036452)(categoryInfo?.categoryName, obj._name),
            position: {
                x: x,
                y: y,
                z: z
            },
            size: {
                width: dimX,
                length: dimY,
                height: dimZ
            },
            angle: angle,
            colors: colors,
            materials: materials,
            metadata: {
                originalId: obj._id,
                parentId: obj._parentId,
                accesoryId: obj._accesoryId,
                categoryId: categoryInfo?.categoryId,
                url: obj._url,
                snapType: obj._snapType,
                materials: obj._materials,
                _originalSize: obj._size,
                _originalRotation: obj._rotation,
                ...obj // Preserve any enhanced/custom properties present in the source database object
            }
        };
    });
    // Extract ID and name from DB level if available
    const roomId = 'id' in roomOrScene ? roomOrScene.id : 'scene-room';
    const roomName = 'name' in roomOrScene ? roomOrScene.name : sceneData._name || 'Room Layout';
    return {
        id: roomId,
        name: roomName,
        width: roomWidth,
        length: roomLength,
        height: roomHeight,
        items: items,
        metadata: {
            originalGroups: sceneData._groups,
            originalMaterials: sceneData._materials,
            originalWalls: firstRoom._walls,
            originalFloor: firstRoom._floor,
            originalVersion: sceneData._version
        }
    };
}
function $90c3eb9fdb4d1b68$export$ef429a605c1612c(roomDb, originalSceneData) {
    const sceneData = JSON.parse(JSON.stringify(originalSceneData));
    const firstRoom = sceneData._rooms[0];
    if (!firstRoom) throw new Error('SceneData does not contain any rooms.');
    const roomWidth = firstRoom._size.x;
    const roomLength = firstRoom._size.z;
    const dbItemMap = new Map(roomDb.items.map((item)=>[
            item.itemId,
            item
        ]));
    firstRoom._objects = firstRoom._objects.map((obj)=>{
        const updated = dbItemMap.get(obj._id.toString());
        if (updated) {
            const x = updated.position.x - roomWidth / 2;
            const z = updated.position.y - roomLength / 2;
            const y = updated.position.z;
            const yaw = updated.angle * Math.PI / 180;
            let rotation;
            if (obj._rotation && obj._rotation.w !== undefined) rotation = {
                x: 0,
                y: Math.sin(yaw / 2),
                z: 0,
                w: Math.cos(yaw / 2)
            };
            else rotation = {
                x: obj._rotation.x,
                y: yaw,
                z: obj._rotation.z
            };
            return {
                ...obj,
                _position: {
                    x: x,
                    y: y,
                    z: z
                },
                _rotation: rotation
            };
        }
        return obj;
    });
    return sceneData;
}
function $90c3eb9fdb4d1b68$export$6a1ccd8cd7784f95(roomDb) {
    const reconstructedObjects = roomDb.items.map((item, index)=>{
        const meta = item.metadata || {};
        const x = item.position.x - roomDb.width / 2;
        const z = item.position.y - roomDb.length / 2;
        const y = item.position.z;
        const yaw = item.angle * Math.PI / 180;
        const originalRot = meta._originalRotation || {};
        let rotation;
        const isNewItem = typeof meta.originalId !== 'number' || Number.isNaN(meta.originalId);
        if (isNewItem || originalRot && originalRot.w !== undefined) rotation = {
            x: 0,
            y: Math.sin(yaw / 2),
            z: 0,
            w: Math.cos(yaw / 2)
        };
        else rotation = {
            x: originalRot.x ?? 0,
            y: yaw,
            z: originalRot.z ?? 0
        };
        let idVal = typeof meta.originalId === 'number' && !Number.isNaN(meta.originalId) ? meta.originalId : NaN;
        if (Number.isNaN(idVal)) idVal = Number.parseInt(item.itemId, 10);
        if (Number.isNaN(idVal)) idVal = 1000 + index;
        let parentIdVal = typeof meta.parentId === 'number' && !Number.isNaN(meta.parentId) ? meta.parentId : NaN;
        if (Number.isNaN(parentIdVal) || parentIdVal === 0) parentIdVal = -1; // Floor component parent ID is -1, 0 is invalid and hides the object
        return {
            _id: idVal,
            _accesoryId: meta.accesoryId ?? "",
            _parentId: parentIdVal,
            _name: item.label,
            _position: {
                x: x,
                y: y,
                z: z
            },
            _rotation: rotation,
            _size: meta._originalSize ?? {
                x: item.size.width * 1000,
                y: item.size.height * 1000,
                z: item.size.length * 1000
            },
            _url: meta.url && /\.(glb|gbl)(\?.*)?$/i.test(meta.url) ? meta.url : "",
            _snapType: meta.snapType ?? 1,
            _materials: meta.materials ?? []
        };
    });
    const rootMeta = roomDb.metadata || {};
    return {
        _version: rootMeta.originalVersion || 2,
        _name: roomDb.name || 'Moravio PDG Layout',
        _rooms: [
            {
                _size: {
                    x: roomDb.width,
                    y: roomDb.height,
                    z: roomDb.length
                },
                _position: {
                    x: 0,
                    y: 0,
                    z: 0
                },
                _rotation: {
                    x: 0,
                    y: 0,
                    z: 0
                },
                _objects: reconstructedObjects,
                _floor: rootMeta.originalFloor || "Parquet",
                _walls: rootMeta.originalWalls || {
                    _leftWall: {
                        r: 255,
                        g: 255,
                        b: 255,
                        a: 1
                    },
                    _rightWall: {
                        r: 255,
                        g: 255,
                        b: 255,
                        a: 1
                    },
                    _frontWall: {
                        r: 255,
                        g: 255,
                        b: 255,
                        a: 1
                    },
                    _backWall: {
                        r: 255,
                        g: 255,
                        b: 255,
                        a: 1
                    },
                    _ceiling: {
                        r: 255,
                        g: 255,
                        b: 255,
                        a: 1
                    }
                }
            }
        ],
        _groups: rootMeta.originalGroups || [],
        _materials: rootMeta.originalMaterials || []
    };
}



function $91be3a269430647e$var$parseToRgbObject(color) {
    if (!color) return null;
    if (typeof color === 'object' && typeof color.r === 'number' && typeof color.g === 'number' && typeof color.b === 'number') return {
        r: color.r,
        g: color.g,
        b: color.b
    };
    if (typeof color === 'string') {
        const rgbMatch = color.match(/rgb\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*\)/i);
        if (rgbMatch) return {
            r: parseInt(rgbMatch[1], 10),
            g: parseInt(rgbMatch[2], 10),
            b: parseInt(rgbMatch[3], 10)
        };
        const hexMatch = color.match(/#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})/i);
        if (hexMatch) return {
            r: parseInt(hexMatch[1], 16),
            g: parseInt(hexMatch[2], 16),
            b: parseInt(hexMatch[3], 16)
        };
    }
    return null;
}
function $91be3a269430647e$export$c5bda7ba0dba797(roomDb, questionnaire) {
    const width = roomDb.width;
    const length = roomDb.length;
    const height = roomDb.height;
    const objects = roomDb.items.map((item)=>{
        const meta = item.metadata || {};
        // Infer seating capacity
        let seatingCapacity = meta.seatingCapacity ?? 0;
        if (seatingCapacity === 0) {
            const typeLower = item.type.toLowerCase();
            const labelLower = item.label.toLowerCase();
            if (typeLower.includes('sofa') || labelLower.includes('sofa')) seatingCapacity = 3;
            else if (typeLower.includes('chair') || labelLower.includes('chair') || labelLower.includes('zidle') || labelLower.includes('kreslo')) seatingCapacity = 1;
        }
        const rawColors = item.colors || meta.colors || [];
        const normalizedColors = rawColors.map((c)=>$91be3a269430647e$var$parseToRgbObject(c)).filter((c)=>c !== null);
        return {
            id: item.itemId,
            name: item.label,
            categoryId: meta.categoryId || meta.accesoryId || item.type || 'unknown',
            position: {
                x: (item.position.x - width / 2) * 1000,
                y: item.position.z * 1000,
                z: (item.position.y - length / 2) * 1000
            },
            size: {
                x: item.size.width * 1000,
                y: item.size.height * 1000,
                z: item.size.length * 1000
            },
            rotation: item.angle * Math.PI / 180,
            colors: normalizedColors,
            designStyle: meta.designStyle || [],
            material: item.materials || meta.material || [],
            seatingCapacity: seatingCapacity,
            isDominant: meta.isDominant || false,
            zoneId: item.zoneId || meta.zoneId || null,
            isZoneDev: meta.isZoneDev || false,
            isBorder: meta.isBorder || false
        };
    });
    const activeZones = roomDb.metadata?.zones && Array.isArray(roomDb.metadata.zones) && roomDb.metadata.zones.length > 0 ? roomDb.metadata.zones.map((z)=>({
            id: z.id,
            polygon: z.polygon
        })) : null;
    return {
        lang: 'en',
        roomData: {
            size: {
                x: width * 1000,
                y: height * 1000,
                z: length * 1000
            },
            objects: objects
        },
        questionnaire: {
            numberOfAdults: questionnaire.numberOfAdults,
            numberOfChildren: questionnaire.numberOfChildren,
            numberOfGuests: questionnaire.numberOfGuests,
            workplace: questionnaire.workplace,
            playground: questionnaire.playground
        },
        zones: activeZones,
        paths: null
    };
}
function $91be3a269430647e$export$e6cb1acb5dbef59f(roomOrScene, questionnaire, placements, accessoryToCategoryMap) {
    const sceneData = (0, $90c3eb9fdb4d1b68$export$ecb7313f4bd51d67)(roomOrScene);
    let roomDb = (0, $90c3eb9fdb4d1b68$export$9bdd500d89ec814)(sceneData, accessoryToCategoryMap);
    if (placements && placements.length > 0) {
        const placementMap = new Map(placements.map((p)=>[
                p.id,
                p
            ]));
        roomDb = {
            ...roomDb,
            items: roomDb.items.map((item)=>{
                const placed = placementMap.get(item.itemId);
                if (placed) return {
                    ...item,
                    position: {
                        x: placed.position.x,
                        y: placed.position.y,
                        z: placed.position.z
                    },
                    angle: placed.rotation
                };
                return item;
            })
        };
    }
    return $91be3a269430647e$export$c5bda7ba0dba797(roomDb, questionnaire);
}
function $91be3a269430647e$export$49d820340edc1971(roomDb, questionnaire, placements) {
    const placementMap = new Map(placements.map((p)=>[
            p.id,
            p
        ]));
    const updatedRoomDb = {
        ...roomDb,
        items: roomDb.items.map((item)=>{
            const placed = placementMap.get(item.itemId);
            if (placed) return {
                ...item,
                position: {
                    x: placed.position.x,
                    y: placed.position.y,
                    z: placed.position.z
                },
                angle: placed.rotation
            };
            return item;
        })
    };
    return $91be3a269430647e$export$c5bda7ba0dba797(updatedRoomDb, questionnaire);
}







function $545b9db0cff2c060$export$2d5166f3af0c3560({ roomData: roomData, questionnaire: questionnaire, handleFieldChange: handleFieldChange, handleQuestionnaireChange: handleQuestionnaireChange, dbRooms: dbRooms, selectedRoomId: selectedRoomId, handleRoomSelect: handleRoomSelect, onRoomDataChange: onRoomDataChange }) {
    const fileInputRef = (0, $bFZzf.useRef)(null);
    const handleFileChange = (e)=>{
        const file = e.target.files?.[0];
        if (!file) return;
        const reader = new FileReader();
        reader.onload = (event)=>{
            try {
                const rawContent = event.target?.result;
                const parsed = JSON.parse(rawContent);
                let roomDataToUse;
                // Detect if this is standard SceneData (has _rooms or _version) or RoomLayout
                if (parsed && (parsed._rooms || parsed._version)) roomDataToUse = (0, $90c3eb9fdb4d1b68$export$9bdd500d89ec814)(parsed);
                else {
                    if (!parsed.id || !parsed.name || typeof parsed.width !== 'number' || !Array.isArray(parsed.items)) {
                        alert('Invalid room layout JSON structure. The JSON must contain at least "id", "name", "width", "length", "height", and "items".');
                        return;
                    }
                    roomDataToUse = parsed;
                }
                onRoomDataChange(roomDataToUse);
            } catch (err) {
                alert('Failed to parse JSON file: ' + (err instanceof Error ? err.message : String(err)));
            }
        };
        reader.readAsText(file);
    };
    return /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("section", {
        style: (0, $8a3c98632a397758$export$9dd6ff9ea0189349).card,
        children: [
            /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("h2", {
                style: (0, $8a3c98632a397758$export$9dd6ff9ea0189349).sectionHeader,
                children: "Room Configuration Settings"
            }),
            /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("div", {
                style: (0, $8a3c98632a397758$export$9dd6ff9ea0189349).row,
                children: [
                    /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("div", {
                        style: {
                            ...(0, $8a3c98632a397758$export$9dd6ff9ea0189349).col,
                            flex: 2
                        },
                        children: [
                            /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("label", {
                                style: (0, $8a3c98632a397758$export$9dd6ff9ea0189349).fieldLabel,
                                children: "Select Room Source:"
                            }),
                            /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("select", {
                                value: selectedRoomId,
                                onChange: (e)=>handleRoomSelect(e.target.value),
                                style: (0, $8a3c98632a397758$export$9dd6ff9ea0189349).select,
                                children: [
                                    /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("option", {
                                        value: "empty",
                                        children: "-- Empty Room (5x5m) --"
                                    }),
                                    dbRooms.map((room)=>/*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("option", {
                                            value: room.id,
                                            children: [
                                                room.name,
                                                " ",
                                                room.isEmpty ? ' [Empty]' : ''
                                            ]
                                        }, room.id))
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("div", {
                        style: {
                            ...(0, $8a3c98632a397758$export$9dd6ff9ea0189349).col,
                            flex: 2
                        },
                        children: [
                            /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("label", {
                                style: (0, $8a3c98632a397758$export$9dd6ff9ea0189349).fieldLabel,
                                children: "Upload Room Layout (JSON):"
                            }),
                            /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("div", {
                                style: (0, $8a3c98632a397758$export$9dd6ff9ea0189349).fileUploadRow,
                                children: [
                                    /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("input", {
                                        type: "file",
                                        accept: ".json",
                                        ref: fileInputRef,
                                        onChange: handleFileChange,
                                        style: {
                                            display: 'none'
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("button", {
                                        type: "button",
                                        onClick: ()=>fileInputRef.current?.click(),
                                        style: (0, $8a3c98632a397758$export$9dd6ff9ea0189349).fileUploadBtn,
                                        children: "Choose JSON File"
                                    }),
                                    /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("span", {
                                        style: (0, $8a3c98632a397758$export$9dd6ff9ea0189349).fileUploadText,
                                        children: roomData.id && roomData.id !== 'room-empty' && roomData.id !== 'room-office' && roomData.id !== 'room-living' ? `Active: ${roomData.name || roomData.id}` : 'No custom file loaded'
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("div", {
                style: (0, $8a3c98632a397758$export$9dd6ff9ea0189349).row,
                children: [
                    /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("div", {
                        style: (0, $8a3c98632a397758$export$9dd6ff9ea0189349).col,
                        children: [
                            /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("label", {
                                style: (0, $8a3c98632a397758$export$9dd6ff9ea0189349).fieldLabel,
                                children: "Width (m)"
                            }),
                            /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("input", {
                                type: "number",
                                step: "0.1",
                                value: roomData.width,
                                onChange: (e)=>handleFieldChange('width', parseFloat(e.target.value) || 0),
                                style: (0, $8a3c98632a397758$export$9dd6ff9ea0189349).input
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("div", {
                        style: (0, $8a3c98632a397758$export$9dd6ff9ea0189349).col,
                        children: [
                            /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("label", {
                                style: (0, $8a3c98632a397758$export$9dd6ff9ea0189349).fieldLabel,
                                children: "Length (m)"
                            }),
                            /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("input", {
                                type: "number",
                                step: "0.1",
                                value: roomData.length,
                                onChange: (e)=>handleFieldChange('length', parseFloat(e.target.value) || 0),
                                style: (0, $8a3c98632a397758$export$9dd6ff9ea0189349).input
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("div", {
                        style: (0, $8a3c98632a397758$export$9dd6ff9ea0189349).col,
                        children: [
                            /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("label", {
                                style: (0, $8a3c98632a397758$export$9dd6ff9ea0189349).fieldLabel,
                                children: "Height (m)"
                            }),
                            /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("input", {
                                type: "number",
                                step: "0.1",
                                value: roomData.height,
                                onChange: (e)=>handleFieldChange('height', parseFloat(e.target.value) || 0),
                                style: (0, $8a3c98632a397758$export$9dd6ff9ea0189349).input
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("div", {
                style: (0, $8a3c98632a397758$export$9dd6ff9ea0189349).formGroup,
                children: [
                    /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("label", {
                        style: (0, $8a3c98632a397758$export$9dd6ff9ea0189349).fieldLabel,
                        children: "Occupancy Preferences (Questionnaire):"
                    }),
                    /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("div", {
                        style: (0, $8a3c98632a397758$export$9dd6ff9ea0189349).row,
                        children: [
                            /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("div", {
                                style: (0, $8a3c98632a397758$export$9dd6ff9ea0189349).col,
                                children: [
                                    /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("span", {
                                        style: (0, $8a3c98632a397758$export$9dd6ff9ea0189349).numberLabel,
                                        children: "Adults"
                                    }),
                                    /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("input", {
                                        type: "number",
                                        value: questionnaire.numberOfAdults,
                                        onChange: (e)=>handleQuestionnaireChange('numberOfAdults', parseInt(e.target.value) || 0),
                                        style: (0, $8a3c98632a397758$export$9dd6ff9ea0189349).input
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("div", {
                                style: (0, $8a3c98632a397758$export$9dd6ff9ea0189349).col,
                                children: [
                                    /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("span", {
                                        style: (0, $8a3c98632a397758$export$9dd6ff9ea0189349).numberLabel,
                                        children: "Children"
                                    }),
                                    /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("input", {
                                        type: "number",
                                        value: questionnaire.numberOfChildren,
                                        onChange: (e)=>handleQuestionnaireChange('numberOfChildren', parseInt(e.target.value) || 0),
                                        style: (0, $8a3c98632a397758$export$9dd6ff9ea0189349).input
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("div", {
                                style: (0, $8a3c98632a397758$export$9dd6ff9ea0189349).col,
                                children: [
                                    /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("span", {
                                        style: (0, $8a3c98632a397758$export$9dd6ff9ea0189349).numberLabel,
                                        children: "Guests"
                                    }),
                                    /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("input", {
                                        type: "number",
                                        value: questionnaire.numberOfGuests,
                                        onChange: (e)=>handleQuestionnaireChange('numberOfGuests', parseInt(e.target.value) || 0),
                                        style: (0, $8a3c98632a397758$export$9dd6ff9ea0189349).input
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("div", {
                style: (0, $8a3c98632a397758$export$9dd6ff9ea0189349).formGroup,
                children: [
                    /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("label", {
                        style: (0, $8a3c98632a397758$export$9dd6ff9ea0189349).fieldLabel,
                        children: "Zone Inclusions:"
                    }),
                    /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("div", {
                        style: (0, $8a3c98632a397758$export$9dd6ff9ea0189349).checkboxContainer,
                        children: [
                            /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("label", {
                                style: (0, $8a3c98632a397758$export$9dd6ff9ea0189349).checkboxLabel,
                                children: [
                                    /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("input", {
                                        type: "checkbox",
                                        checked: questionnaire.workplace,
                                        onChange: (e)=>handleQuestionnaireChange('workplace', e.target.checked),
                                        style: (0, $8a3c98632a397758$export$9dd6ff9ea0189349).checkbox
                                    }),
                                    "Include Workspace Zone"
                                ]
                            }),
                            /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("label", {
                                style: (0, $8a3c98632a397758$export$9dd6ff9ea0189349).checkboxLabel,
                                children: [
                                    /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("input", {
                                        type: "checkbox",
                                        checked: questionnaire.playground,
                                        onChange: (e)=>handleQuestionnaireChange('playground', e.target.checked),
                                        style: (0, $8a3c98632a397758$export$9dd6ff9ea0189349).checkbox
                                    }),
                                    "Include Kids Playground"
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
}




var $bFZzf = parcelRequire("bFZzf");

const $a7f3ce86011fb77e$export$2020fa29d940ee6a = {
    living: {
        id: 'living-id',
        type: 'living',
        nameCs: "Ob\xfdvac\xed z\xf3na",
        nameEn: 'Living Zone',
        descriptionCs: "Centr\xe1ln\xed spole\u010Densk\xfd prostor pro odpo\u010Dinek, sledov\xe1n\xed televize a setk\xe1v\xe1n\xed s rodinou.",
        descriptionEn: 'Central social area for relaxation, TV entertainment, and family gathering.',
        typicalFurniture: [
            'Sofa',
            'Television',
            'Coffee Table',
            'Carpet / Rug',
            'TV Media Unit'
        ],
        color: 'rgba(59, 130, 246, 0.22)',
        strokeColor: '#3b82f6',
        badgeColor: '#3b82f6'
    },
    dining: {
        id: 'dining-id',
        type: 'dining',
        nameCs: "J\xeddeln\xed z\xf3na",
        nameEn: 'Dining Zone',
        descriptionCs: "Prostor pro stolov\xe1n\xed, ob\u011Bdy a ve\u010De\u0159e v bl\xedzkosti kuchyn\u011B nebo ob\xfdvac\xedho pokoje.",
        descriptionEn: 'Dining space for meals and family dinners adjacent to kitchen or living area.',
        typicalFurniture: [
            'Dining Table',
            'Chairs',
            'Sideboard',
            'Dresser / Credenza'
        ],
        color: 'rgba(234, 88, 12, 0.22)',
        strokeColor: '#ea580c',
        badgeColor: '#ea580c'
    },
    kitchen: {
        id: 'kitchen-id',
        type: 'kitchen',
        nameCs: "Kuchy\u0148sk\xe1 z\xf3na",
        nameEn: 'Kitchen Zone',
        descriptionCs: "Pracovn\xed plocha pro p\u0159\xedpravu a va\u0159en\xed j\xeddla s dostatkem \xfalo\u017En\xe9ho prostoru a spot\u0159ebi\u010D\u016F.",
        descriptionEn: 'Food preparation and cooking area with countertop workspace and appliances.',
        typicalFurniture: [
            'Kitchen Counter',
            'Refrigerator',
            'Cooktop',
            'Sink',
            'Dishwasher'
        ],
        color: 'rgba(16, 185, 129, 0.22)',
        strokeColor: '#10b981',
        badgeColor: '#10b981'
    },
    workplace: {
        id: 'workplace-id',
        type: 'workplace',
        nameCs: "Pracovn\xed z\xf3na",
        nameEn: 'Workplace Zone',
        descriptionCs: "Ergonomick\xfd koutek pro pr\xe1ci z domova, studium nebo soust\u0159ed\u011Bn\xe9 \u010Dinnosti.",
        descriptionEn: 'Ergonomic workspace for home office, focus work, or study.',
        typicalFurniture: [
            'Desk',
            'Office Chair',
            'Shelving Unit',
            'Desk Lamp'
        ],
        color: 'rgba(168, 85, 247, 0.22)',
        strokeColor: '#a855f7',
        badgeColor: '#a855f7'
    },
    playground: {
        id: 'playground-id',
        type: 'playground',
        nameCs: "D\u011Btsk\xe1 z\xf3na",
        nameEn: 'Playground Zone',
        descriptionCs: "Hrac\xed a kreativn\xed koutek pro d\u011Bti s m\u011Bkk\xfdm kobercem a \xfalo\u017En\xfdmi boxy na hra\u010Dky.",
        descriptionEn: 'Play and creativity area for children with soft carpet and toy storage.',
        typicalFurniture: [
            'Toy Storage Units',
            'Play Carpet / Rug',
            'Kids Table',
            'Small Chairs'
        ],
        color: 'rgba(236, 72, 153, 0.22)',
        strokeColor: '#ec4899',
        badgeColor: '#ec4899'
    },
    relax: {
        id: 'relax-id',
        type: 'relax',
        nameCs: "Relax z\xf3na",
        nameEn: 'Relax Zone',
        descriptionCs: "Klidn\xe9 m\xedsto pro \u010Dten\xed knih, poslech hudby a odpo\u010Dinek s pohodln\xfdm k\u0159eslem a lampou.",
        descriptionEn: 'Quiet reading and lounge nook with comfortable armchair, lamp, and side table.',
        typicalFurniture: [
            'Lounge Armchair',
            'Side Table',
            'Floor Reading Lamp',
            'Bookcase'
        ],
        color: 'rgba(20, 184, 166, 0.22)',
        strokeColor: '#14b8a6',
        badgeColor: '#14b8a6'
    }
};
const $a7f3ce86011fb77e$export$74a5ebd84f0bbe97 = Object.values($a7f3ce86011fb77e$export$2020fa29d940ee6a).reduce((acc, def)=>{
    acc[def.id] = def;
    acc[def.type] = def;
    return acc;
}, {});
function $a7f3ce86011fb77e$export$89e58b52dcca6de0(zoneIdOrType) {
    const normalized = zoneIdOrType.toLowerCase().trim();
    if ($a7f3ce86011fb77e$export$74a5ebd84f0bbe97[normalized]) return $a7f3ce86011fb77e$export$74a5ebd84f0bbe97[normalized];
    // Fuzzy match
    for (const [type, def] of Object.entries($a7f3ce86011fb77e$export$2020fa29d940ee6a)){
        if (normalized.includes(type) || normalized.includes(def.id)) return def;
    }
    // Fallback default
    return {
        id: zoneIdOrType,
        type: 'living',
        nameCs: `Z\xf3na ${zoneIdOrType}`,
        nameEn: `Zone ${zoneIdOrType}`,
        descriptionCs: 'Custom Zone',
        descriptionEn: 'Custom Zone',
        typicalFurniture: [],
        color: 'rgba(156, 39, 176, 0.2)',
        strokeColor: '#9c27b0',
        badgeColor: '#9c27b0'
    };
}


function $dd277cc5481ddeb6$export$d3ae2e2a0de15619({ roomData: roomData, validationResult: validationResult, isValidating: isValidating, onSaveRoom: onSaveRoom, onSolveError: onSolveError, onSolveAllErrors: onSolveAllErrors, status: status, onUndo: onUndo, onRedo: onRedo, canUndo: canUndo, canRedo: canRedo, zones: zones = [], showZonesInPreview: showZonesInPreview = true, focusedZoneId: focusedZoneId, zoneAnchors: zoneAnchors = [], showZoneAnchors: showZoneAnchors = true, focusedAnchorId: focusedAnchorId }) {
    // SVG drawing math
    const METER_TO_PX = 80;
    const centerX = 500;
    const centerY = 300;
    const roomWidthPx = roomData.width * METER_TO_PX;
    const roomLengthPx = roomData.length * METER_TO_PX;
    const roomLeft = centerX - roomWidthPx / 2;
    const roomTop = centerY - roomLengthPx / 2;
    // Zoom / Pan states
    const [zoom, setZoom] = (0, $bFZzf.useState)(1.0);
    const [pan, setPan] = (0, $bFZzf.useState)({
        x: 0,
        y: 0
    });
    const [isDragging, setIsDragging] = (0, $bFZzf.useState)(false);
    const dragStart = (0, $bFZzf.useRef)({
        x: 0,
        y: 0
    });
    // Separate accordion states - both collapsed (closed) by default
    const [valAccordionOpen, setValAccordionOpen] = (0, $bFZzf.useState)(false);
    const [coordAccordionOpen, setCoordAccordionOpen] = (0, $bFZzf.useState)(false);
    // Ref to canvas container for native wheel event listener
    const canvasRef = (0, $bFZzf.useRef)(null);
    // Auto-reset zoom/pan when room dimensions change
    (0, $bFZzf.useEffect)(()=>{
        setZoom(1.0);
        setPan({
            x: 0,
            y: 0
        });
    }, [
        roomData.width,
        roomData.length
    ]);
    // Bind wheel events natively to support preventDefault() inside non-passive listener
    (0, $bFZzf.useEffect)(()=>{
        const canvasElement = canvasRef.current;
        if (!canvasElement) return;
        const handleNativeWheel = (e)=>{
            // Prevent standard browser page scroll
            e.preventDefault();
            if (e.deltaY < 0) setZoom((prev)=>Math.min(prev * 1.1, 5.0)); // Zoom In
            else setZoom((prev)=>Math.max(prev / 1.1, 0.2)); // Zoom Out
        };
        canvasElement.addEventListener('wheel', handleNativeWheel, {
            passive: false
        });
        return ()=>{
            canvasElement.removeEventListener('wheel', handleNativeWheel);
        };
    }, []);
    const handleMouseDown = (e)=>{
        if (e.button !== 0) return; // Only pan with left click
        setIsDragging(true);
        dragStart.current = {
            x: e.clientX - pan.x,
            y: e.clientY - pan.y
        };
    };
    const handleMouseMove = (e)=>{
        if (!isDragging) return;
        setPan({
            x: e.clientX - dragStart.current.x,
            y: e.clientY - dragStart.current.y
        });
    };
    const handleMouseUp = ()=>{
        setIsDragging(false);
    };
    const handleZoomIn = ()=>{
        setZoom((prev)=>Math.min(prev * 1.2, 5.0));
    };
    const handleZoomOut = ()=>{
        setZoom((prev)=>Math.max(prev / 1.2, 0.2));
    };
    const handleReset = ()=>{
        setZoom(1.0);
        setPan({
            x: 0,
            y: 0
        });
    };
    // Determine status color badge for validation header
    const getValidationSummaryText = ()=>{
        if (isValidating) return 'Checking layout constraints...';
        if (!validationResult) return 'No validation results';
        const { passed: passed, failed: failed, warnings: warnings } = validationResult.summary;
        return `${passed} passed, ${failed} failed, ${warnings} warnings`;
    };
    const getValidationBadgeStyle = ()=>{
        if (isValidating) return {
            color: '#f59e0b',
            backgroundColor: 'rgba(245, 158, 11, 0.1)'
        };
        if (!validationResult) return {
            color: 'var(--text-muted)',
            backgroundColor: 'rgba(255, 255, 255, 0.05)'
        };
        const { failed: failed, warnings: warnings } = validationResult.summary;
        if (failed > 0) return {
            color: '#ef4444',
            backgroundColor: 'rgba(239, 68, 68, 0.1)'
        };
        if (warnings > 0) return {
            color: '#f59e0b',
            backgroundColor: 'rgba(245, 158, 11, 0.1)'
        };
        return {
            color: 'var(--success)',
            backgroundColor: 'rgba(46, 125, 50, 0.1)'
        };
    };
    // Sort rules: failed first, then warning, then pass
    const sortedRules = validationResult?.results ? [
        ...validationResult.results
    ].sort((a, b)=>{
        const order = {
            fail: 0,
            warning: 1,
            pass: 2
        };
        const scoreA = order[a.status] ?? 3;
        const scoreB = order[b.status] ?? 3;
        return scoreA - scoreB;
    }) : [];
    return /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("div", {
        style: (0, $8a3c98632a397758$export$9dd6ff9ea0189349).sideBySideContainer,
        children: [
            /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("div", {
                style: (0, $8a3c98632a397758$export$9dd6ff9ea0189349).leftColumn,
                children: /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("section", {
                    style: {
                        ...(0, $8a3c98632a397758$export$9dd6ff9ea0189349).card,
                        flex: 1
                    },
                    children: [
                        /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("div", {
                            style: {
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                borderBottom: '1px solid var(--border-color)',
                                paddingBottom: '12px'
                            },
                            children: [
                                /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("h2", {
                                    style: {
                                        fontSize: '18px',
                                        fontWeight: 600,
                                        color: 'var(--text-main)',
                                        margin: 0
                                    },
                                    children: "Room Layout Preview"
                                }),
                                /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("div", {
                                    style: {
                                        display: 'flex',
                                        gap: '8px',
                                        alignItems: 'center'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("button", {
                                            onClick: onUndo,
                                            disabled: !canUndo,
                                            style: {
                                                ...(0, $8a3c98632a397758$export$9dd6ff9ea0189349).fileUploadBtn,
                                                padding: '6px 12px',
                                                opacity: canUndo ? 1 : 0.3,
                                                cursor: canUndo ? 'pointer' : 'default',
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '4px'
                                            },
                                            title: "Go to previous layout (Back)",
                                            children: "\u25C0 Back"
                                        }),
                                        /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("button", {
                                            onClick: onRedo,
                                            disabled: !canRedo,
                                            style: {
                                                ...(0, $8a3c98632a397758$export$9dd6ff9ea0189349).fileUploadBtn,
                                                padding: '6px 12px',
                                                opacity: canRedo ? 1 : 0.3,
                                                cursor: canRedo ? 'pointer' : 'default',
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '4px'
                                            },
                                            title: "Go to next layout (Forward)",
                                            children: "Forward \u25B6"
                                        }),
                                        /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("button", {
                                            onClick: onSaveRoom,
                                            disabled: status === 'loading',
                                            style: {
                                                ...(0, $8a3c98632a397758$export$9dd6ff9ea0189349).saveButton,
                                                opacity: status === 'loading' ? 0.6 : 1
                                            },
                                            children: status === 'loading' ? 'Saving...' : 'Save and View'
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("div", {
                            ref: canvasRef,
                            style: {
                                ...(0, $8a3c98632a397758$export$9dd6ff9ea0189349).canvasContainer,
                                ...isDragging ? (0, $8a3c98632a397758$export$9dd6ff9ea0189349).canvasContainerDragging : {}
                            },
                            children: [
                                /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("svg", {
                                    viewBox: "0 0 1000 600",
                                    width: "100%",
                                    height: "100%",
                                    style: (0, $8a3c98632a397758$export$9dd6ff9ea0189349).svg,
                                    onMouseDown: handleMouseDown,
                                    onMouseMove: handleMouseMove,
                                    onMouseUp: handleMouseUp,
                                    onMouseLeave: handleMouseUp,
                                    children: [
                                        /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("defs", {
                                            children: /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("pattern", {
                                                id: "room-grid",
                                                width: METER_TO_PX,
                                                height: METER_TO_PX,
                                                patternUnits: "userSpaceOnUse",
                                                children: /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("path", {
                                                    d: `M ${METER_TO_PX} 0 L 0 0 0 ${METER_TO_PX}`,
                                                    fill: "none",
                                                    stroke: "rgba(255, 255, 255, 0.05)",
                                                    strokeWidth: "1"
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("rect", {
                                            width: "1000",
                                            height: "600",
                                            fill: "transparent"
                                        }),
                                        /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("g", {
                                            transform: `translate(${pan.x + centerX}, ${pan.y + centerY}) scale(${zoom}) translate(${-centerX}, ${-centerY})`,
                                            children: [
                                                /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("rect", {
                                                    x: roomLeft,
                                                    y: roomTop,
                                                    width: roomWidthPx,
                                                    height: roomLengthPx,
                                                    fill: "url(#room-grid)"
                                                }),
                                                /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("rect", {
                                                    x: roomLeft,
                                                    y: roomTop,
                                                    width: roomWidthPx,
                                                    height: roomLengthPx,
                                                    fill: "none",
                                                    stroke: "var(--border-color)",
                                                    strokeWidth: "4",
                                                    rx: "4"
                                                }),
                                                showZonesInPreview && zones.map((zone)=>{
                                                    if (!zone.polygon || zone.polygon.length < 3) return null;
                                                    const isFocused = focusedZoneId === zone.id;
                                                    const pointsStr = zone.polygon.map((p)=>`${centerX + p[0] / 1000 * METER_TO_PX},${centerY + p[1] / 1000 * METER_TO_PX}`).join(' ');
                                                    const centroidX = centerX + zone.centroid[0] / 1000 * METER_TO_PX;
                                                    const centroidY = centerY + zone.centroid[1] / 1000 * METER_TO_PX;
                                                    return /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("g", {
                                                        className: "zone-polygon-group",
                                                        children: [
                                                            /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("polygon", {
                                                                points: pointsStr,
                                                                fill: zone.color,
                                                                stroke: zone.strokeColor,
                                                                strokeWidth: isFocused ? '3' : '2',
                                                                strokeDasharray: isFocused ? 'none' : '8 4',
                                                                opacity: isFocused ? 1.0 : 0.85,
                                                                style: {
                                                                    transition: 'all 0.3s ease'
                                                                }
                                                            }),
                                                            /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("g", {
                                                                transform: `translate(${centroidX}, ${centroidY}) scale(${1 / zoom}) translate(${-centroidX}, ${-centroidY})`,
                                                                children: [
                                                                    /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("rect", {
                                                                        x: centroidX - 60,
                                                                        y: centroidY - 18,
                                                                        width: 120,
                                                                        height: 36,
                                                                        rx: 8,
                                                                        fill: "rgba(24, 24, 27, 0.88)",
                                                                        stroke: zone.strokeColor,
                                                                        strokeWidth: isFocused ? '2' : '1'
                                                                    }),
                                                                    /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("text", {
                                                                        x: centroidX,
                                                                        y: centroidY - 4,
                                                                        fill: "#f3f4f6",
                                                                        fontSize: "11",
                                                                        fontWeight: "700",
                                                                        textAnchor: "middle",
                                                                        alignmentBaseline: "middle",
                                                                        children: zone.name
                                                                    }),
                                                                    /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("text", {
                                                                        x: centroidX,
                                                                        y: centroidY + 9,
                                                                        fill: zone.strokeColor,
                                                                        fontSize: "9",
                                                                        fontWeight: "600",
                                                                        textAnchor: "middle",
                                                                        alignmentBaseline: "middle",
                                                                        children: [
                                                                            zone.area,
                                                                            " m\xb2 (",
                                                                            zone.areaPercent,
                                                                            "%)"
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }, zone.id);
                                                }),
                                                showZoneAnchors && zoneAnchors.map((anchor)=>{
                                                    const width = anchor.size?.width ?? 1;
                                                    const length = anchor.size?.length ?? 1;
                                                    const posX = anchor.position?.x ?? 0;
                                                    const posY = anchor.position?.y ?? 0;
                                                    const angle = anchor.rotationDegrees ?? 0;
                                                    const widthPx = width * METER_TO_PX;
                                                    const lengthPx = length * METER_TO_PX;
                                                    const cx = roomLeft + posX * METER_TO_PX;
                                                    const cy = roomTop + posY * METER_TO_PX;
                                                    const xPx = cx - widthPx / 2;
                                                    const yPx = cy - lengthPx / 2;
                                                    const zoneDef = (0, $a7f3ce86011fb77e$export$2020fa29d940ee6a)[anchor.zoneType] || (0, $a7f3ce86011fb77e$export$2020fa29d940ee6a).living;
                                                    const isFocused = focusedZoneId === anchor.zoneId || focusedAnchorId === anchor.id;
                                                    return /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("g", {
                                                        transform: `rotate(${-angle}, ${cx}, ${cy})`,
                                                        className: "zone-anchor-group",
                                                        style: {
                                                            pointerEvents: 'none'
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("rect", {
                                                                x: xPx,
                                                                y: yPx,
                                                                width: widthPx,
                                                                height: lengthPx,
                                                                fill: zoneDef.color,
                                                                stroke: zoneDef.strokeColor,
                                                                strokeWidth: isFocused ? '3' : '2',
                                                                strokeDasharray: isFocused ? 'none' : '6 3',
                                                                rx: "6",
                                                                opacity: isFocused ? 0.95 : 0.75
                                                            }),
                                                            /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("g", {
                                                                transform: `translate(${cx}, ${cy}) scale(${1 / zoom}) translate(${-cx}, ${-cy})`,
                                                                children: [
                                                                    /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("rect", {
                                                                        x: cx - 65,
                                                                        y: cy - 13,
                                                                        width: 130,
                                                                        height: 26,
                                                                        rx: 6,
                                                                        fill: "rgba(15, 23, 42, 0.94)",
                                                                        stroke: zoneDef.strokeColor,
                                                                        strokeWidth: "1.5"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("text", {
                                                                        x: cx,
                                                                        y: cy,
                                                                        fill: "#f8fafc",
                                                                        fontSize: "10",
                                                                        fontWeight: "700",
                                                                        textAnchor: "middle",
                                                                        alignmentBaseline: "middle",
                                                                        children: [
                                                                            "\u2693 ",
                                                                            anchor.name
                                                                        ]
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("g", {
                                                                transform: `translate(${cx}, ${cy + 19}) scale(${1 / zoom}) translate(${-cx}, ${-(cy + 19)})`,
                                                                children: /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("text", {
                                                                    x: cx,
                                                                    y: cy + 19,
                                                                    fill: zoneDef.strokeColor,
                                                                    fontSize: "8.5",
                                                                    fontWeight: "700",
                                                                    textAnchor: "middle",
                                                                    children: [
                                                                        "[",
                                                                        width.toFixed(1),
                                                                        "\xd7",
                                                                        length.toFixed(1),
                                                                        "m] ",
                                                                        anchor.isVirtualAnchor ? '(Kotva)' : ''
                                                                    ]
                                                                })
                                                            })
                                                        ]
                                                    }, anchor.id);
                                                }),
                                                roomData.items.map((item)=>{
                                                    const width = item.size?.width ?? 1;
                                                    const length = item.size?.length ?? 1;
                                                    const posX = item.position?.x ?? 0;
                                                    const posY = item.position?.y ?? 0;
                                                    const angle = item.angle ?? 0;
                                                    const widthPx = width * METER_TO_PX;
                                                    const lengthPx = length * METER_TO_PX;
                                                    const cx = roomLeft + posX * METER_TO_PX;
                                                    const cy = roomTop + posY * METER_TO_PX;
                                                    const xPx = cx - widthPx / 2;
                                                    const yPx = cy - lengthPx / 2;
                                                    return /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("g", {
                                                        transform: `rotate(${-angle}, ${cx}, ${cy})`,
                                                        children: [
                                                            /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("rect", {
                                                                x: xPx,
                                                                y: yPx,
                                                                width: widthPx,
                                                                height: lengthPx,
                                                                fill: "rgba(156, 39, 176, 0.15)",
                                                                stroke: "var(--accent)",
                                                                strokeWidth: "2",
                                                                rx: "4"
                                                            }),
                                                            /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("line", {
                                                                x1: xPx,
                                                                y1: yPx + lengthPx,
                                                                x2: xPx + widthPx,
                                                                y2: yPx + lengthPx,
                                                                stroke: "#ef4444",
                                                                strokeWidth: "3"
                                                            }),
                                                            /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("g", {
                                                                transform: `translate(${cx}, ${cy}) scale(${1 / zoom}) translate(${-cx}, ${-cy})`,
                                                                children: /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("text", {
                                                                    x: cx,
                                                                    y: cy,
                                                                    fill: "var(--text-main)",
                                                                    fontSize: "11",
                                                                    fontWeight: "600",
                                                                    textAnchor: "middle",
                                                                    alignmentBaseline: "middle",
                                                                    children: item.label
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("g", {
                                                                transform: `translate(${cx}, ${cy + 14}) scale(${1 / zoom}) translate(${-cx}, ${-(cy + 14)})`,
                                                                children: /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("text", {
                                                                    x: cx,
                                                                    y: cy + 14,
                                                                    fill: "var(--text-muted)",
                                                                    fontSize: "9",
                                                                    textAnchor: "middle",
                                                                    children: [
                                                                        "(",
                                                                        item.type,
                                                                        ")"
                                                                    ]
                                                                })
                                                            })
                                                        ]
                                                    }, item.itemId);
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("div", {
                                    style: (0, $8a3c98632a397758$export$9dd6ff9ea0189349).canvasControls,
                                    children: [
                                        /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("button", {
                                            onClick: handleZoomIn,
                                            title: "Zoom In",
                                            style: (0, $8a3c98632a397758$export$9dd6ff9ea0189349).canvasBtn,
                                            children: "+"
                                        }),
                                        /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("button", {
                                            onClick: handleZoomOut,
                                            title: "Zoom Out",
                                            style: (0, $8a3c98632a397758$export$9dd6ff9ea0189349).canvasBtn,
                                            children: "\u2212"
                                        }),
                                        /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("button", {
                                            onClick: handleReset,
                                            title: "Reset view",
                                            style: {
                                                ...(0, $8a3c98632a397758$export$9dd6ff9ea0189349).canvasBtn,
                                                fontSize: '11px',
                                                fontWeight: 600
                                            },
                                            children: "Reset"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("div", {
                            style: (0, $8a3c98632a397758$export$9dd6ff9ea0189349).accordion,
                            children: [
                                /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("div", {
                                    onClick: ()=>setCoordAccordionOpen(!coordAccordionOpen),
                                    style: (0, $8a3c98632a397758$export$9dd6ff9ea0189349).accordionHeader,
                                    children: [
                                        /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("div", {
                                            style: (0, $8a3c98632a397758$export$9dd6ff9ea0189349).accordionTitle,
                                            children: /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("span", {
                                                children: [
                                                    "\uD83D\uDECB\uFE0F Furniture Placements (",
                                                    roomData.items.length,
                                                    " items)"
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("span", {
                                            style: {
                                                ...(0, $8a3c98632a397758$export$9dd6ff9ea0189349).accordionArrow,
                                                transform: coordAccordionOpen ? 'rotate(90deg)' : 'rotate(0deg)'
                                            },
                                            children: "\u25B6"
                                        })
                                    ]
                                }),
                                coordAccordionOpen && /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("div", {
                                    style: (0, $8a3c98632a397758$export$9dd6ff9ea0189349).accordionContent,
                                    children: roomData.items.length === 0 ? /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("div", {
                                        style: {
                                            color: 'var(--text-muted)',
                                            fontSize: '13px',
                                            fontStyle: 'italic'
                                        },
                                        children: "No items placed in this room."
                                    }) : /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("table", {
                                        style: (0, $8a3c98632a397758$export$9dd6ff9ea0189349).table,
                                        children: [
                                            /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("thead", {
                                                children: /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("tr", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("th", {
                                                            style: (0, $8a3c98632a397758$export$9dd6ff9ea0189349).th,
                                                            children: "Item ID"
                                                        }),
                                                        /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("th", {
                                                            style: (0, $8a3c98632a397758$export$9dd6ff9ea0189349).th,
                                                            children: "Label (Type)"
                                                        }),
                                                        /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("th", {
                                                            style: (0, $8a3c98632a397758$export$9dd6ff9ea0189349).th,
                                                            children: "Size (W x L x H)"
                                                        }),
                                                        /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("th", {
                                                            style: (0, $8a3c98632a397758$export$9dd6ff9ea0189349).th,
                                                            children: "Position (X, Y, Z)"
                                                        }),
                                                        /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("th", {
                                                            style: (0, $8a3c98632a397758$export$9dd6ff9ea0189349).th,
                                                            children: "Rotation (\xb0)"
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("tbody", {
                                                children: roomData.items.map((item)=>/*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("tr", {
                                                        style: (0, $8a3c98632a397758$export$9dd6ff9ea0189349).tr,
                                                        children: [
                                                            /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("td", {
                                                                style: (0, $8a3c98632a397758$export$9dd6ff9ea0189349).td,
                                                                children: /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("code", {
                                                                    style: (0, $8a3c98632a397758$export$9dd6ff9ea0189349).code,
                                                                    children: item.itemId
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("td", {
                                                                style: (0, $8a3c98632a397758$export$9dd6ff9ea0189349).td,
                                                                children: [
                                                                    item.label,
                                                                    " ",
                                                                    /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("span", {
                                                                        style: (0, $8a3c98632a397758$export$9dd6ff9ea0189349).typeSpan,
                                                                        children: [
                                                                            "(",
                                                                            item.type || 'unknown',
                                                                            ")"
                                                                        ]
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("td", {
                                                                style: (0, $8a3c98632a397758$export$9dd6ff9ea0189349).td,
                                                                children: [
                                                                    (item.size?.width ?? 0).toFixed(2),
                                                                    "m \xd7 ",
                                                                    (item.size?.length ?? 0).toFixed(2),
                                                                    "m \xd7 ",
                                                                    (item.size?.height ?? 0).toFixed(2),
                                                                    "m"
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("td", {
                                                                style: (0, $8a3c98632a397758$export$9dd6ff9ea0189349).td,
                                                                children: [
                                                                    (item.position?.x ?? 0).toFixed(2),
                                                                    "m, ",
                                                                    (item.position?.y ?? 0).toFixed(2),
                                                                    "m, ",
                                                                    (item.position?.z ?? 0).toFixed(2),
                                                                    "m"
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("td", {
                                                                style: (0, $8a3c98632a397758$export$9dd6ff9ea0189349).td,
                                                                children: [
                                                                    (item.angle ?? 0).toFixed(1),
                                                                    "\xb0"
                                                                ]
                                                            })
                                                        ]
                                                    }, item.itemId))
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("div", {
                style: (0, $8a3c98632a397758$export$9dd6ff9ea0189349).rightColumn,
                children: /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("section", {
                    style: {
                        ...(0, $8a3c98632a397758$export$9dd6ff9ea0189349).card,
                        flex: 1,
                        boxSizing: 'border-box'
                    },
                    children: [
                        /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("div", {
                            style: {
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                borderBottom: '1px solid var(--border-color)',
                                paddingBottom: '12px'
                            },
                            children: [
                                /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("h2", {
                                    style: {
                                        fontSize: '18px',
                                        fontWeight: 600,
                                        color: 'var(--text-main)',
                                        margin: 0
                                    },
                                    children: "Discriminator Validation Summary"
                                }),
                                /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("span", {
                                    style: {
                                        ...(0, $8a3c98632a397758$export$9dd6ff9ea0189349).statusBadge,
                                        ...getValidationBadgeStyle(),
                                        fontSize: '11px'
                                    },
                                    children: getValidationSummaryText()
                                })
                            ]
                        }),
                        validationResult ? /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("div", {
                            style: {
                                display: 'flex',
                                flexDirection: 'column',
                                gap: '16px',
                                flex: 1,
                                minHeight: 0
                            },
                            children: [
                                /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("div", {
                                    style: (0, $8a3c98632a397758$export$9dd6ff9ea0189349).validationSummaryGrid,
                                    children: [
                                        /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("div", {
                                            style: (0, $8a3c98632a397758$export$9dd6ff9ea0189349).validationCard,
                                            children: [
                                                /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("div", {
                                                    style: (0, $8a3c98632a397758$export$9dd6ff9ea0189349).valNumber,
                                                    children: [
                                                        validationResult.summary.passRate.toFixed(0),
                                                        "%"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("div", {
                                                    style: (0, $8a3c98632a397758$export$9dd6ff9ea0189349).valLabel,
                                                    children: "Pass Rate"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("div", {
                                            style: (0, $8a3c98632a397758$export$9dd6ff9ea0189349).validationCard,
                                            children: [
                                                /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("div", {
                                                    style: {
                                                        ...(0, $8a3c98632a397758$export$9dd6ff9ea0189349).valNumber,
                                                        color: 'var(--success)'
                                                    },
                                                    children: validationResult.summary.passed
                                                }),
                                                /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("div", {
                                                    style: (0, $8a3c98632a397758$export$9dd6ff9ea0189349).valLabel,
                                                    children: "Passed"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("div", {
                                            style: (0, $8a3c98632a397758$export$9dd6ff9ea0189349).validationCard,
                                            children: [
                                                /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("div", {
                                                    style: {
                                                        ...(0, $8a3c98632a397758$export$9dd6ff9ea0189349).valNumber,
                                                        color: '#ef4444'
                                                    },
                                                    children: validationResult.summary.failed
                                                }),
                                                /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("div", {
                                                    style: (0, $8a3c98632a397758$export$9dd6ff9ea0189349).valLabel,
                                                    children: "Failed"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("div", {
                                            style: (0, $8a3c98632a397758$export$9dd6ff9ea0189349).validationCard,
                                            children: [
                                                /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("div", {
                                                    style: {
                                                        ...(0, $8a3c98632a397758$export$9dd6ff9ea0189349).valNumber,
                                                        color: '#f59e0b'
                                                    },
                                                    children: validationResult.summary.warnings
                                                }),
                                                /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("div", {
                                                    style: (0, $8a3c98632a397758$export$9dd6ff9ea0189349).valLabel,
                                                    children: "Warnings"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                validationResult.summary.failed > 0 && /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("button", {
                                    type: "button",
                                    onClick: onSolveAllErrors,
                                    style: (0, $8a3c98632a397758$export$9dd6ff9ea0189349).solveAllBtn,
                                    children: "\u26A1 Solve All Errors"
                                }),
                                /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("div", {
                                    style: {
                                        ...(0, $8a3c98632a397758$export$9dd6ff9ea0189349).accordion,
                                        marginTop: 0
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("div", {
                                            onClick: ()=>setValAccordionOpen(!valAccordionOpen),
                                            style: (0, $8a3c98632a397758$export$9dd6ff9ea0189349).accordionHeader,
                                            children: [
                                                /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("div", {
                                                    style: (0, $8a3c98632a397758$export$9dd6ff9ea0189349).accordionTitle,
                                                    children: /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("span", {
                                                        children: "\uD83D\uDCCB Rule Verification Details"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("span", {
                                                    style: {
                                                        ...(0, $8a3c98632a397758$export$9dd6ff9ea0189349).accordionArrow,
                                                        transform: valAccordionOpen ? 'rotate(90deg)' : 'rotate(0deg)'
                                                    },
                                                    children: "\u25B6"
                                                })
                                            ]
                                        }),
                                        valAccordionOpen && /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("div", {
                                            style: {
                                                ...(0, $8a3c98632a397758$export$9dd6ff9ea0189349).accordionContent,
                                                maxHeight: '450px',
                                                overflowY: 'auto'
                                            },
                                            children: /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("div", {
                                                style: (0, $8a3c98632a397758$export$9dd6ff9ea0189349).rulesList,
                                                children: sortedRules.map((rule, idx)=>/*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("div", {
                                                        style: {
                                                            ...(0, $8a3c98632a397758$export$9dd6ff9ea0189349).ruleItem,
                                                            borderLeft: `4px solid ${rule.status === 'pass' ? 'var(--success)' : rule.status === 'fail' ? '#ef4444' : '#f59e0b'}`
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("div", {
                                                                style: (0, $8a3c98632a397758$export$9dd6ff9ea0189349).ruleHeader,
                                                                children: [
                                                                    /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("span", {
                                                                        style: (0, $8a3c98632a397758$export$9dd6ff9ea0189349).ruleId,
                                                                        children: rule.ruleId
                                                                    }),
                                                                    /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("span", {
                                                                        style: {
                                                                            ...(0, $8a3c98632a397758$export$9dd6ff9ea0189349).statusBadge,
                                                                            color: rule.status === 'pass' ? 'var(--success)' : rule.status === 'fail' ? '#ef4444' : '#f59e0b',
                                                                            backgroundColor: rule.status === 'pass' ? 'rgba(46, 125, 50, 0.1)' : rule.status === 'fail' ? 'rgba(239, 68, 68, 0.1)' : 'rgba(245, 158, 11, 0.1)'
                                                                        },
                                                                        children: rule.status.toUpperCase()
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("div", {
                                                                style: (0, $8a3c98632a397758$export$9dd6ff9ea0189349).ruleMsg,
                                                                children: rule.userMessage
                                                            }),
                                                            rule.status !== 'pass' && rule.userRepairInstructions && /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("div", {
                                                                style: (0, $8a3c98632a397758$export$9dd6ff9ea0189349).repairInfo,
                                                                children: [
                                                                    /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("span", {
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("strong", {
                                                                                children: "Fix Recommendation:"
                                                                            }),
                                                                            " ",
                                                                            rule.userRepairInstructions
                                                                        ]
                                                                    }),
                                                                    rule.status === 'fail' && /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("button", {
                                                                        type: "button",
                                                                        onClick: ()=>onSolveError(rule.userRepairInstructions, rule.impactedObjectId, rule),
                                                                        style: (0, $8a3c98632a397758$export$9dd6ff9ea0189349).solveBtn,
                                                                        children: "Solve"
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }, idx))
                                            })
                                        })
                                    ]
                                })
                            ]
                        }) : /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("div", {
                            style: {
                                color: 'var(--text-muted)',
                                fontSize: '13px',
                                fontStyle: 'italic'
                            },
                            children: isValidating ? 'Checking layout constraints...' : 'No active verification results. Perform a layout load or change to trigger.'
                        })
                    ]
                })
            })
        ]
    });
}



parcelRequire("bFZzf");

/**
 * Canonical Gemini Model Definitions
 * Jediné centrální místo v kódu pro všechny modely Gemini v celé aplikaci
 * (Layout Orchestrator, Room Architect Chatbot, Intelligent Zoning).
 *
 * Povoleno pouze 3 specifické modely:
 * 1. gemini-4-argon       (Gemini 4 Argon - Nejvýkonnější reasoning)
 * 2. gemini-3.8-flash     (Gemini 3.8 Flash - Doporučeno)
 * 3. gemini-3.5-flash-lite (Gemini 3.5 Flash Lite)
 */ const $0d8d43ca0bd0e763$export$b9237242c9be0e8c = [
    {
        id: 'gemini-4-argon',
        name: "Gemini 4 Argon (Nejv\xfdkonn\u011Bj\u0161\xed)",
        description: "Vlajkov\xfd model pro komplexn\xed architektonick\xe9 uva\u017Eov\xe1n\xed a v\xedcekriteri\xe1ln\xed prostorov\xe9 pl\xe1nov\xe1n\xed",
        isDefault: false
    },
    {
        id: 'gemini-3.8-flash',
        name: "Gemini 3.8 Flash (Doporu\u010Deno)",
        description: "Hlavn\xed doporu\u010Den\xfd model s vysokou inteligenc\xed, rychlost\xed a p\u0159esnou prostorovou logikou",
        isDefault: true
    },
    {
        id: 'gemini-3.5-flash-lite',
        name: 'Gemini 3.5 Flash Lite',
        description: "Lehk\xfd a rychl\xfd model pro okam\u017Eit\xe9 generov\xe1n\xed a n\xedzkou latenci",
        isDefault: false
    }
];
const $0d8d43ca0bd0e763$export$29b5792eb3806f43 = 'gemini-3.8-flash';
function $0d8d43ca0bd0e763$export$d1f890e93047c3f4(modelId) {
    if (!modelId) return $0d8d43ca0bd0e763$export$29b5792eb3806f43;
    const found = $0d8d43ca0bd0e763$export$b9237242c9be0e8c.find((m)=>m.id === modelId);
    return found ? found.id : $0d8d43ca0bd0e763$export$29b5792eb3806f43;
}


function $b92cc80221770949$export$766ea011d7fc650f({ model: model, prompt: prompt, status: status, errorMessage: errorMessage, aiMessage: aiMessage, onModelChange: onModelChange, onPromptChange: onPromptChange, onUpdateLayout: onUpdateLayout }) {
    return /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("section", {
        style: (0, $8a3c98632a397758$export$9dd6ff9ea0189349).card,
        children: [
            /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("style", {
                dangerouslySetInnerHTML: {
                    __html: `
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
        @keyframes pulse-opacity {
          0%, 100% { opacity: 0.6; }
          50% { opacity: 1; }
        }
      `
                }
            }),
            /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("h2", {
                style: (0, $8a3c98632a397758$export$9dd6ff9ea0189349).sectionHeader,
                children: "Prompt Instructions"
            }),
            /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("div", {
                style: (0, $8a3c98632a397758$export$9dd6ff9ea0189349).formGroup,
                children: [
                    /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("label", {
                        style: (0, $8a3c98632a397758$export$9dd6ff9ea0189349).fieldLabel,
                        children: "Select AI Model:"
                    }),
                    /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("select", {
                        value: model,
                        onChange: (e)=>onModelChange(e.target.value),
                        style: {
                            ...(0, $8a3c98632a397758$export$9dd6ff9ea0189349).select,
                            maxWidth: '300px'
                        },
                        children: (0, $0d8d43ca0bd0e763$export$b9237242c9be0e8c).map((m)=>/*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("option", {
                                value: m.id,
                                children: m.name
                            }, m.id))
                    })
                ]
            }),
            /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("div", {
                style: (0, $8a3c98632a397758$export$9dd6ff9ea0189349).formGroup,
                children: [
                    /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("label", {
                        style: (0, $8a3c98632a397758$export$9dd6ff9ea0189349).fieldLabel,
                        children: "Design Prompt Instructions:"
                    }),
                    /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("textarea", {
                        id: "design-prompt-textarea",
                        value: prompt,
                        onChange: (e)=>onPromptChange(e.target.value),
                        style: (0, $8a3c98632a397758$export$9dd6ff9ea0189349).textarea,
                        rows: 4,
                        placeholder: "e.g. Move the sofa opposite the door and clear out a space for a workspace desk near the window."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("div", {
                style: {
                    display: 'flex',
                    gap: '12px'
                },
                children: /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("button", {
                    onClick: onUpdateLayout,
                    disabled: status === 'loading',
                    style: {
                        ...(0, $8a3c98632a397758$export$9dd6ff9ea0189349).primaryButton,
                        flex: 1,
                        opacity: status === 'loading' ? 0.6 : 1
                    },
                    children: status === 'loading' ? 'Running Layout Update...' : 'Update Room Layout'
                })
            }),
            status === 'loading' && /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("div", {
                style: {
                    display: 'flex',
                    alignItems: 'center',
                    gap: '10px',
                    padding: '12px 16px',
                    backgroundColor: 'rgba(255, 255, 255, 0.02)',
                    border: '1px dashed var(--border-color)',
                    borderRadius: '6px',
                    color: 'var(--text-muted)',
                    fontSize: '13px',
                    animation: 'pulse-opacity 2s infinite ease-in-out'
                },
                children: [
                    /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("span", {
                        style: {
                            display: 'inline-block',
                            width: '14px',
                            height: '14px',
                            border: '2px solid var(--text-muted)',
                            borderTopColor: 'transparent',
                            borderRadius: '50%',
                            animation: 'spin 0.8s linear infinite'
                        }
                    }),
                    /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("span", {
                        children: "Updating layout and solving constraints with Gemini AI..."
                    })
                ]
            }),
            aiMessage && status !== 'loading' && /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("div", {
                style: {
                    padding: '16px',
                    backgroundColor: 'rgba(171, 71, 188, 0.06)',
                    border: '1px solid rgba(171, 71, 188, 0.2)',
                    borderRadius: '8px',
                    boxShadow: '0 4px 12px rgba(171, 71, 188, 0.04)',
                    display: 'flex',
                    gap: '12px',
                    alignItems: 'flex-start'
                },
                children: [
                    /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("span", {
                        style: {
                            fontSize: '18px',
                            lineHeight: 1
                        },
                        children: "\u2728"
                    }),
                    /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("div", {
                                style: {
                                    fontSize: '11px',
                                    fontWeight: 600,
                                    color: 'var(--accent)',
                                    textTransform: 'uppercase',
                                    letterSpacing: '0.05em',
                                    marginBottom: '4px'
                                },
                                children: "Gemini AI Explanation"
                            }),
                            /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("div", {
                                style: {
                                    fontSize: '13px',
                                    color: 'var(--text-main)',
                                    lineHeight: '1.4',
                                    fontWeight: 500
                                },
                                children: aiMessage
                            })
                        ]
                    })
                ]
            }),
            status === 'error' && /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("div", {
                style: (0, $8a3c98632a397758$export$9dd6ff9ea0189349).errorAlert,
                children: [
                    /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("strong", {
                        children: "Error:"
                    }),
                    " ",
                    errorMessage
                ]
            })
        ]
    });
}



parcelRequire("bFZzf");

function $608ea1dd4cd3078a$export$5bbd2894fcdab524({ logs: logs, generatedScript: generatedScript, geminiCalls: geminiCalls = [], searchLogs: searchLogs = [] }) {
    return /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("section", {
        style: (0, $8a3c98632a397758$export$9dd6ff9ea0189349).card,
        children: [
            /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("h2", {
                style: (0, $8a3c98632a397758$export$9dd6ff9ea0189349).sectionHeader,
                children: "Log Stream & Generated Logic"
            }),
            /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("div", {
                style: (0, $8a3c98632a397758$export$9dd6ff9ea0189349).logsSplitGrid,
                children: [
                    /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("h3", {
                                style: (0, $8a3c98632a397758$export$9dd6ff9ea0189349).subHeader,
                                children: "Pipeline Events"
                            }),
                            /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("div", {
                                style: (0, $8a3c98632a397758$export$9dd6ff9ea0189349).logBox,
                                children: logs.length === 0 ? /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("div", {
                                    style: (0, $8a3c98632a397758$export$9dd6ff9ea0189349).emptyLogs,
                                    children: "No pipeline events logged. Trigger a layout generation to view status."
                                }) : logs.map((log, idx)=>/*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("div", {
                                        style: (0, $8a3c98632a397758$export$9dd6ff9ea0189349).logItem,
                                        children: [
                                            /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("div", {
                                                style: (0, $8a3c98632a397758$export$9dd6ff9ea0189349).logMeta,
                                                children: [
                                                    /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("span", {
                                                        style: {
                                                            ...(0, $8a3c98632a397758$export$9dd6ff9ea0189349).logBadge,
                                                            backgroundColor: log.stage === 'error' ? '#ef4444' : log.stage === 'complete' ? 'var(--success)' : 'rgba(255,255,255,0.1)'
                                                        },
                                                        children: log.stage.toUpperCase()
                                                    }),
                                                    /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("span", {
                                                        style: (0, $8a3c98632a397758$export$9dd6ff9ea0189349).logTime,
                                                        children: new Date(log.timestamp).toLocaleTimeString()
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("div", {
                                                style: (0, $8a3c98632a397758$export$9dd6ff9ea0189349).logText,
                                                children: log.message
                                            }),
                                            log.data && /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("details", {
                                                style: (0, $8a3c98632a397758$export$9dd6ff9ea0189349).details,
                                                children: [
                                                    /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("summary", {
                                                        style: (0, $8a3c98632a397758$export$9dd6ff9ea0189349).summary,
                                                        children: "View raw payload data"
                                                    }),
                                                    /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("pre", {
                                                        style: (0, $8a3c98632a397758$export$9dd6ff9ea0189349).json,
                                                        children: JSON.stringify(log.data, null, 2)
                                                    })
                                                ]
                                            })
                                        ]
                                    }, idx))
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("h3", {
                                style: (0, $8a3c98632a397758$export$9dd6ff9ea0189349).subHeader,
                                children: "Generated Math Code"
                            }),
                            /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("div", {
                                style: (0, $8a3c98632a397758$export$9dd6ff9ea0189349).codeBox,
                                children: generatedScript ? /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("pre", {
                                    style: (0, $8a3c98632a397758$export$9dd6ff9ea0189349).scriptPre,
                                    children: /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("code", {
                                        style: (0, $8a3c98632a397758$export$9dd6ff9ea0189349).python,
                                        children: generatedScript
                                    })
                                }) : /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("div", {
                                    style: (0, $8a3c98632a397758$export$9dd6ff9ea0189349).emptyScript,
                                    children: "Python math placement calculations for layout update generated by Gemini will display here."
                                })
                            })
                        ]
                    })
                ]
            }),
            searchLogs && searchLogs.length > 0 && /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("div", {
                style: {
                    marginTop: '16px',
                    borderTop: '1px solid var(--border-color)',
                    paddingTop: '20px'
                },
                children: [
                    /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("h3", {
                        style: (0, $8a3c98632a397758$export$9dd6ff9ea0189349).subHeader,
                        children: "Typesense Catalog Searches"
                    }),
                    /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("div", {
                        style: {
                            display: 'flex',
                            flexDirection: 'column',
                            gap: '12px',
                            marginTop: '12px'
                        },
                        children: searchLogs.map((search, idx)=>/*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("details", {
                                style: (0, $8a3c98632a397758$export$9dd6ff9ea0189349).accordion,
                                open: idx === 0,
                                children: [
                                    /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("summary", {
                                        style: {
                                            ...(0, $8a3c98632a397758$export$9dd6ff9ea0189349).accordionHeader,
                                            listStyle: 'none'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("div", {
                                                style: (0, $8a3c98632a397758$export$9dd6ff9ea0189349).accordionTitle,
                                                children: [
                                                    /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("span", {
                                                        children: "\uD83D\uDD0D"
                                                    }),
                                                    /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("span", {
                                                        children: [
                                                            'Query: "',
                                                            search.query,
                                                            '"'
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("span", {
                                                style: {
                                                    ...(0, $8a3c98632a397758$export$9dd6ff9ea0189349).badge,
                                                    backgroundColor: search.resultsCount > 0 ? '#2e7d32' : '#ef4444'
                                                },
                                                children: [
                                                    search.resultsCount,
                                                    " ",
                                                    search.resultsCount === 1 ? 'item' : 'items',
                                                    " found"
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("div", {
                                        style: (0, $8a3c98632a397758$export$9dd6ff9ea0189349).accordionContent,
                                        children: search.results.length === 0 ? /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("div", {
                                            style: {
                                                color: 'var(--text-muted)',
                                                fontSize: '13px',
                                                fontStyle: 'italic'
                                            },
                                            children: "No matching furniture found in catalog for this query."
                                        }) : /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("div", {
                                            style: {
                                                overflowX: 'auto'
                                            },
                                            children: /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("table", {
                                                style: (0, $8a3c98632a397758$export$9dd6ff9ea0189349).table,
                                                children: [
                                                    /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("thead", {
                                                        children: /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("tr", {
                                                            children: [
                                                                /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("th", {
                                                                    style: (0, $8a3c98632a397758$export$9dd6ff9ea0189349).th,
                                                                    children: "ID"
                                                                }),
                                                                /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("th", {
                                                                    style: (0, $8a3c98632a397758$export$9dd6ff9ea0189349).th,
                                                                    children: "Name"
                                                                }),
                                                                /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("th", {
                                                                    style: (0, $8a3c98632a397758$export$9dd6ff9ea0189349).th,
                                                                    children: "Type"
                                                                }),
                                                                /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("th", {
                                                                    style: (0, $8a3c98632a397758$export$9dd6ff9ea0189349).th,
                                                                    children: "Dimensions (W \xd7 L \xd7 H)"
                                                                }),
                                                                /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("th", {
                                                                    style: (0, $8a3c98632a397758$export$9dd6ff9ea0189349).th,
                                                                    children: "Price"
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("tbody", {
                                                        children: search.results.map((item, itemIdx)=>/*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("tr", {
                                                                style: (0, $8a3c98632a397758$export$9dd6ff9ea0189349).tr,
                                                                children: [
                                                                    /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("td", {
                                                                        style: {
                                                                            ...(0, $8a3c98632a397758$export$9dd6ff9ea0189349).td,
                                                                            fontFamily: 'monospace',
                                                                            fontSize: '11px',
                                                                            color: 'var(--text-muted)'
                                                                        },
                                                                        children: [
                                                                            item.id.substring(0, 8),
                                                                            "..."
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("td", {
                                                                        style: {
                                                                            ...(0, $8a3c98632a397758$export$9dd6ff9ea0189349).td,
                                                                            fontWeight: 'bold'
                                                                        },
                                                                        children: item.name
                                                                    }),
                                                                    /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("td", {
                                                                        style: (0, $8a3c98632a397758$export$9dd6ff9ea0189349).td,
                                                                        children: /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("span", {
                                                                            style: (0, $8a3c98632a397758$export$9dd6ff9ea0189349).code,
                                                                            children: item.type
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("td", {
                                                                        style: (0, $8a3c98632a397758$export$9dd6ff9ea0189349).td,
                                                                        children: [
                                                                            item.dimensions.width.toFixed(2),
                                                                            "m \xd7 ",
                                                                            item.dimensions.length.toFixed(2),
                                                                            "m \xd7 ",
                                                                            item.dimensions.height.toFixed(2),
                                                                            "m"
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("td", {
                                                                        style: {
                                                                            ...(0, $8a3c98632a397758$export$9dd6ff9ea0189349).td,
                                                                            color: '#a78bfa',
                                                                            fontWeight: 'bold'
                                                                        },
                                                                        children: item.price
                                                                    })
                                                                ]
                                                            }, itemIdx))
                                                    })
                                                ]
                                            })
                                        })
                                    })
                                ]
                            }, idx))
                    })
                ]
            }),
            /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("div", {
                style: {
                    marginTop: '16px',
                    borderTop: '1px solid var(--border-color)',
                    paddingTop: '20px'
                },
                children: [
                    /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("h3", {
                        style: (0, $8a3c98632a397758$export$9dd6ff9ea0189349).subHeader,
                        children: "Gemini API Request Inspector"
                    }),
                    geminiCalls.length === 0 ? /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("div", {
                        style: {
                            color: 'var(--text-muted)',
                            fontSize: '13px',
                            fontStyle: 'italic',
                            padding: '10px 0'
                        },
                        children: "No active API payloads inspected. Update layout to view prompt contexts."
                    }) : /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("div", {
                        style: (0, $8a3c98632a397758$export$9dd6ff9ea0189349).geminiPromptsBox,
                        children: geminiCalls.map((call, idx)=>/*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("div", {
                                style: (0, $8a3c98632a397758$export$9dd6ff9ea0189349).geminiCallCard,
                                children: [
                                    /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("div", {
                                        style: {
                                            fontSize: '12px',
                                            fontWeight: 'bold',
                                            color: 'var(--accent)',
                                            textTransform: 'uppercase',
                                            letterSpacing: '0.05em'
                                        },
                                        children: [
                                            "Gemini API Request #",
                                            idx + 1
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("div", {
                                                style: {
                                                    ...(0, $8a3c98632a397758$export$9dd6ff9ea0189349).fieldLabel,
                                                    marginBottom: '6px',
                                                    fontSize: '10px'
                                                },
                                                children: "System Instruction"
                                            }),
                                            /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("pre", {
                                                style: (0, $8a3c98632a397758$export$9dd6ff9ea0189349).preWrap,
                                                children: call.systemInstruction
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("div", {
                                                style: {
                                                    ...(0, $8a3c98632a397758$export$9dd6ff9ea0189349).fieldLabel,
                                                    marginBottom: '6px',
                                                    fontSize: '10px'
                                                },
                                                children: "User Prompt & Layout Context"
                                            }),
                                            /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("pre", {
                                                style: (0, $8a3c98632a397758$export$9dd6ff9ea0189349).preWrap,
                                                children: call.prompt
                                            })
                                        ]
                                    }),
                                    call.response && /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("div", {
                                                style: {
                                                    ...(0, $8a3c98632a397758$export$9dd6ff9ea0189349).fieldLabel,
                                                    marginBottom: '6px',
                                                    fontSize: '10px',
                                                    color: 'var(--success)'
                                                },
                                                children: "AI Response"
                                            }),
                                            /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("pre", {
                                                style: {
                                                    ...(0, $8a3c98632a397758$export$9dd6ff9ea0189349).preWrap,
                                                    borderLeft: '3px solid var(--success)',
                                                    paddingLeft: '8px'
                                                },
                                                children: call.response
                                            })
                                        ]
                                    })
                                ]
                            }, idx))
                    })
                ]
            })
        ]
    });
}



var $bFZzf = parcelRequire("bFZzf");

const $4c3b4c9354be7270$export$9799dafc1a1deb28 = {
    empty: {
        id: "room-empty",
        name: "Empty 5x5 Room",
        width: 5.0,
        length: 5.0,
        height: 3.0,
        items: []
    },
    office: {
        id: "room-office",
        name: "Compact Home Office",
        width: 4.5,
        length: 5.0,
        height: 2.8,
        items: [
            {
                itemId: "desk-1",
                label: "Executive Desk",
                description: "Large wooden executive desk for workspace area",
                type: "desk",
                position: {
                    x: 2.25,
                    y: 1.2,
                    z: 0
                },
                size: {
                    width: 1.5,
                    length: 0.75,
                    height: 0.75
                },
                angle: 0,
                colors: [
                    {
                        r: 139,
                        g: 69,
                        b: 19
                    }
                ],
                materials: [
                    "wood"
                ]
            },
            {
                itemId: "chair-1",
                label: "Ergonomic Chair",
                description: "Mesh high-back ergonomic office chair",
                type: "chair",
                position: {
                    x: 2.25,
                    y: 2.0,
                    z: 0
                },
                size: {
                    width: 0.65,
                    length: 0.65,
                    height: 1.0
                },
                angle: 180,
                colors: [
                    {
                        r: 0,
                        g: 0,
                        b: 0
                    }
                ],
                materials: [
                    "plastic",
                    "fabric"
                ]
            },
            {
                itemId: "cabinet-1",
                label: "Filing Cabinet",
                description: "Metal filing cabinet for storage",
                type: "cabinet",
                position: {
                    x: 0.5,
                    y: 4.0,
                    z: 0
                },
                size: {
                    width: 0.9,
                    length: 0.45,
                    height: 1.2
                },
                angle: 90,
                colors: [
                    {
                        r: 128,
                        g: 128,
                        b: 128
                    }
                ],
                materials: [
                    "metal"
                ]
            },
            {
                itemId: "lounge-1",
                label: "Reading Chair",
                description: "Comfortable leather lounge chair",
                type: "chair",
                position: {
                    x: 3.8,
                    y: 4.2,
                    z: 0
                },
                size: {
                    width: 0.8,
                    length: 0.8,
                    height: 0.85
                },
                angle: 315,
                colors: [
                    {
                        r: 210,
                        g: 105,
                        b: 30
                    }
                ],
                materials: [
                    "leather",
                    "wood"
                ]
            }
        ]
    },
    living: {
        id: "room-living",
        name: "Spacious Living Room",
        width: 6.0,
        length: 6.0,
        height: 3.0,
        items: [
            {
                itemId: "sofa-1",
                label: "Sectional Sofa",
                description: "Comfortable grey fabric sectional sofa",
                type: "sofa",
                position: {
                    x: 3.0,
                    y: 1.5,
                    z: 0
                },
                size: {
                    width: 2.4,
                    length: 0.95,
                    height: 0.8
                },
                angle: 0,
                colors: [
                    {
                        r: 100,
                        g: 100,
                        b: 100
                    }
                ],
                materials: [
                    "fabric"
                ]
            },
            {
                itemId: "tv-unit-1",
                label: "Media Console",
                description: "Low-profile TV stand unit",
                type: "cabinet",
                position: {
                    x: 3.0,
                    y: 5.2,
                    z: 0
                },
                size: {
                    width: 1.8,
                    length: 0.4,
                    height: 0.5
                },
                angle: 180,
                colors: [
                    {
                        r: 0,
                        g: 0,
                        b: 0
                    }
                ],
                materials: [
                    "wood",
                    "metal"
                ]
            },
            {
                itemId: "coffee-table",
                label: "Wood Coffee Table",
                description: "Solid oak coffee table",
                type: "table",
                position: {
                    x: 3.0,
                    y: 2.8,
                    z: 0
                },
                size: {
                    width: 1.1,
                    length: 0.7,
                    height: 0.4
                },
                angle: 0,
                colors: [
                    {
                        r: 160,
                        g: 82,
                        b: 45
                    }
                ],
                materials: [
                    "wood"
                ]
            },
            {
                itemId: "plant-1",
                label: "Fiddle Leaf Fig",
                description: "Indoor potted plant for decoration",
                type: "decoration",
                position: {
                    x: 0.5,
                    y: 5.2,
                    z: 0
                },
                size: {
                    width: 0.5,
                    length: 0.5,
                    height: 1.5
                },
                angle: 0,
                colors: [
                    {
                        r: 34,
                        g: 139,
                        b: 34
                    }
                ],
                materials: [
                    "organic"
                ]
            }
        ]
    }
};
const $4c3b4c9354be7270$export$6af22e4fcd800fea = {
    numberOfAdults: 2,
    numberOfChildren: 0,
    numberOfGuests: 2,
    workplace: true,
    playground: false
};


function $f9af346427ba4536$export$260ca91bcd5499f3() {
    const [roomData, setRoomData] = (0, $bFZzf.useState)((0, $4c3b4c9354be7270$export$9799dafc1a1deb28).empty);
    const [questionnaire, setQuestionnaire] = (0, $bFZzf.useState)((0, $4c3b4c9354be7270$export$6af22e4fcd800fea));
    const [prompt, setPrompt] = (0, $bFZzf.useState)('Arrange the desk facing the room entrance, ensure the chair is behind it, and position the cabinet neatly against the wall.');
    const [model, setModel] = (0, $bFZzf.useState)((0, $0d8d43ca0bd0e763$export$29b5792eb3806f43));
    const [aiMessage, setAiMessage] = (0, $bFZzf.useState)('');
    const [backendUrl, setBackendUrl] = (0, $bFZzf.useState)(()=>{
        if (typeof window !== 'undefined') {
            if (window.location.port === '3000') return 'http://localhost:5001';
            return window.location.origin;
        }
        return 'http://localhost:5001';
    });
    const [status, setStatus] = (0, $bFZzf.useState)('idle');
    const [errorMessage, setErrorMessage] = (0, $bFZzf.useState)('');
    // Pipeline outputs
    const [logs, setLogs] = (0, $bFZzf.useState)([]);
    const [generatedScript, setGeneratedScript] = (0, $bFZzf.useState)('');
    const [validationResult, setValidationResult] = (0, $bFZzf.useState)(null);
    const [geminiCalls, setGeminiCalls] = (0, $bFZzf.useState)([]);
    const [searchLogs, setSearchLogs] = (0, $bFZzf.useState)([]);
    // Zoning Service states
    const [zones, setZones] = (0, $bFZzf.useState)([]);
    const [variants, setVariants] = (0, $bFZzf.useState)([]);
    const [activeVariantIndex, setActiveVariantIndex] = (0, $bFZzf.useState)(0);
    const [zoneAnchors, setZoneAnchors] = (0, $bFZzf.useState)([]);
    const [showZoneAnchors, setShowZoneAnchors] = (0, $bFZzf.useState)(true);
    const [includeAllSkills, setIncludeAllSkills] = (0, $bFZzf.useState)(false);
    const [focusedAnchorId, setFocusedAnchorId] = (0, $bFZzf.useState)(null);
    const [isZoning, setIsZoning] = (0, $bFZzf.useState)(false);
    const [zoningPrompt, setZoningPrompt] = (0, $bFZzf.useState)("Rozd\u011Bl m\xedstnost na funk\u010Dn\xed z\xf3ny dle architektonick\xfdch pravidel: kuchy\u0148sk\xe1, j\xeddeln\xed, ob\xfdvac\xed a p\u0159\xedpadn\u011B pracovn\xed \u010Di hern\xed z\xf3na.");
    const [zoningModel, setZoningModel] = (0, $bFZzf.useState)((0, $0d8d43ca0bd0e763$export$29b5792eb3806f43));
    const [zoningExplanation, setZoningExplanation] = (0, $bFZzf.useState)('');
    const [zoningErrorMessage, setZoningErrorMessage] = (0, $bFZzf.useState)('');
    const [showZonesInPreview, setShowZonesInPreview] = (0, $bFZzf.useState)(true);
    const [focusedZoneId, setFocusedZoneId] = (0, $bFZzf.useState)(null);
    // Checking active validation state
    const [isValidating, setIsValidating] = (0, $bFZzf.useState)(false);
    // DB Rooms listing & selection
    const [dbRooms, setDbRooms] = (0, $bFZzf.useState)([]);
    const [selectedRoomId, setSelectedRoomId] = (0, $bFZzf.useState)('empty');
    // Connection status checks
    const [backendHealthy, setBackendHealthy] = (0, $bFZzf.useState)(null);
    // Undo/Redo State History Stack
    const [history, setHistory] = (0, $bFZzf.useState)([]);
    const [historyIndex, setHistoryIndex] = (0, $bFZzf.useState)(-1);
    // Initialize history on first mount
    (0, $bFZzf.useEffect)(()=>{
        if (history.length === 0) {
            const initialEntry = {
                roomData: (0, $4c3b4c9354be7270$export$9799dafc1a1deb28).empty,
                questionnaire: (0, $4c3b4c9354be7270$export$6af22e4fcd800fea),
                prompt: 'Arrange the desk facing the room entrance, ensure the chair is behind it, and position the cabinet neatly against the wall.',
                generatedScript: '',
                validationResult: null,
                geminiCalls: [],
                logs: [],
                model: (0, $0d8d43ca0bd0e763$export$29b5792eb3806f43),
                aiMessage: '',
                searchLogs: [],
                zones: [],
                zoningExplanation: '',
                zoneAnchors: [],
                variants: [],
                activeVariantIndex: 0
            };
            setHistory([
                initialEntry
            ]);
            setHistoryIndex(0);
        }
    }, []);
    // Poll backend health & fetch rooms list when healthy
    (0, $bFZzf.useEffect)(()=>{
        fetch(`${backendUrl}/api/health`).then((res)=>res.json()).then((data)=>{
            const healthy = data.status === 'Healthy';
            setBackendHealthy(healthy);
            if (healthy) fetch(`${backendUrl}/api/rooms`).then((r)=>r.json()).then((rooms)=>{
                if (Array.isArray(rooms)) setDbRooms(rooms);
            }).catch((e)=>console.error('Failed to fetch rooms list:', e));
        }).catch(()=>setBackendHealthy(false));
    }, [
        backendUrl
    ]);
    // Debounced auto-validation triggered on layout/config changes
    (0, $bFZzf.useEffect)(()=>{
        const timer = setTimeout(async ()=>{
            // Avoid auto-validating when full generation is running
            if (status === 'loading') return;
            setIsValidating(true);
            try {
                const response = await fetch(`${backendUrl}/api/validate-layout`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        roomData: roomData,
                        questionnaire: questionnaire
                    })
                });
                if (!response.ok) throw new Error(`Validation status check failed: ${response.status}`);
                const data = await response.json();
                if (data.success) setValidationResult(data.validation);
            } catch (err) {
                console.warn('Auto-validation check failed:', err);
            } finally{
                setIsValidating(false);
            }
        }, 450); // 450ms debounce window
        return ()=>clearTimeout(timer);
    }, [
        roomData,
        questionnaire,
        backendUrl,
        status
    ]);
    // Push new snapshot to the history stack
    const pushToHistory = (newRoom, newQuest, newPr, newScript, newVal, newCalls, newLogs, newModel, newAiMessage, newSearchLogs, newZones, newZoningExpl, newAnchors, newVariants, newVarIdx)=>{
        const targetZones = newZones !== undefined ? newZones : newRoom.metadata?.zones && Array.isArray(newRoom.metadata.zones) ? newRoom.metadata.zones : [];
        const targetZoningExpl = newZoningExpl !== undefined ? newZoningExpl : newRoom.metadata?.zoningExplanation || '';
        const targetAnchors = newAnchors !== undefined ? newAnchors : zoneAnchors;
        const targetVariants = newVariants !== undefined ? newVariants : variants;
        const targetVarIdx = newVarIdx !== undefined ? newVarIdx : activeVariantIndex;
        // Anchor zones directly into room metadata
        const roomWithZones = {
            ...newRoom,
            metadata: {
                ...newRoom.metadata,
                zones: targetZones,
                zoningExplanation: targetZoningExpl
            }
        };
        setHistory((prev)=>{
            // Truncate any forward history if we navigated back and then generated new path
            const cleanHistory = prev.slice(0, historyIndex + 1);
            const newEntry = {
                roomData: JSON.parse(JSON.stringify(roomWithZones)),
                questionnaire: JSON.parse(JSON.stringify(newQuest)),
                prompt: newPr,
                generatedScript: newScript,
                validationResult: newVal,
                geminiCalls: newCalls,
                logs: newLogs,
                model: newModel,
                aiMessage: newAiMessage,
                searchLogs: JSON.parse(JSON.stringify(newSearchLogs)),
                zones: JSON.parse(JSON.stringify(targetZones)),
                zoningExplanation: targetZoningExpl,
                zoneAnchors: JSON.parse(JSON.stringify(targetAnchors)),
                variants: JSON.parse(JSON.stringify(targetVariants)),
                activeVariantIndex: targetVarIdx
            };
            return [
                ...cleanHistory,
                newEntry
            ];
        });
        setHistoryIndex((prev)=>prev + 1);
    };
    // Sync manual input values directly in the current history index
    const updateCurrentHistoryEntry = (updatedRoom, updatedQuest, updatedPrompt, updatedModel, updatedAiMessage, updatedZones, updatedZoningExpl, updatedAnchors)=>{
        setHistory((prev)=>{
            if (historyIndex < 0 || historyIndex >= prev.length) return prev;
            const targetZones = updatedZones !== undefined ? updatedZones : updatedRoom.metadata?.zones && Array.isArray(updatedRoom.metadata.zones) ? updatedRoom.metadata.zones : prev[historyIndex].zones || [];
            const targetZoningExpl = updatedZoningExpl !== undefined ? updatedZoningExpl : updatedRoom.metadata?.zoningExplanation || prev[historyIndex].zoningExplanation || '';
            const targetAnchors = updatedAnchors !== undefined ? updatedAnchors : prev[historyIndex].zoneAnchors || [];
            const roomWithZones = {
                ...updatedRoom,
                metadata: {
                    ...updatedRoom.metadata,
                    zones: targetZones,
                    zoningExplanation: targetZoningExpl
                }
            };
            const copy = [
                ...prev
            ];
            copy[historyIndex] = {
                ...copy[historyIndex],
                roomData: JSON.parse(JSON.stringify(roomWithZones)),
                questionnaire: JSON.parse(JSON.stringify(updatedQuest)),
                prompt: updatedPrompt,
                model: updatedModel,
                aiMessage: typeof updatedAiMessage !== 'undefined' ? updatedAiMessage : copy[historyIndex].aiMessage,
                zones: JSON.parse(JSON.stringify(targetZones)),
                zoningExplanation: targetZoningExpl,
                zoneAnchors: JSON.parse(JSON.stringify(targetAnchors)),
                variants: copy[historyIndex].variants || [],
                activeVariantIndex: copy[historyIndex].activeVariantIndex ?? 0
            };
            return copy;
        });
    };
    // Undo (Zpět)
    const handleUndo = ()=>{
        if (historyIndex > 0) {
            const prevIndex = historyIndex - 1;
            setHistoryIndex(prevIndex);
            const entry = history[prevIndex];
            const entryZones = entry.roomData.metadata?.zones || entry.zones || [];
            const entryExpl = entry.roomData.metadata?.zoningExplanation || entry.zoningExplanation || '';
            setRoomData(entry.roomData);
            setQuestionnaire(entry.questionnaire);
            setPrompt(entry.prompt);
            setGeneratedScript(entry.generatedScript);
            setValidationResult(entry.validationResult);
            setGeminiCalls(entry.geminiCalls);
            setLogs(entry.logs);
            setModel(entry.model);
            setAiMessage(entry.aiMessage);
            setSearchLogs(entry.searchLogs || []);
            setZones(entryZones);
            setZoningExplanation(entryExpl);
            setZoneAnchors(entry.zoneAnchors || []);
            setVariants(entry.variants || []);
            setActiveVariantIndex(entry.activeVariantIndex ?? 0);
        }
    };
    // Redo (Dopředu)
    const handleRedo = ()=>{
        if (historyIndex < history.length - 1) {
            const nextIndex = historyIndex + 1;
            setHistoryIndex(nextIndex);
            const entry = history[nextIndex];
            const entryZones = entry.roomData.metadata?.zones || entry.zones || [];
            const entryExpl = entry.roomData.metadata?.zoningExplanation || entry.zoningExplanation || '';
            setRoomData(entry.roomData);
            setQuestionnaire(entry.questionnaire);
            setPrompt(entry.prompt);
            setGeneratedScript(entry.generatedScript);
            setValidationResult(entry.validationResult);
            setGeminiCalls(entry.geminiCalls);
            setLogs(entry.logs);
            setModel(entry.model);
            setAiMessage(entry.aiMessage);
            setSearchLogs(entry.searchLogs || []);
            setZones(entryZones);
            setZoningExplanation(entryExpl);
            setZoneAnchors(entry.zoneAnchors || []);
            setVariants(entry.variants || []);
            setActiveVariantIndex(entry.activeVariantIndex ?? 0);
        }
    };
    // Handle changing DB Room source dropdown
    const handleRoomSelect = async (roomId)=>{
        setSelectedRoomId(roomId);
        if (roomId === 'empty') {
            const emptyLayout = (0, $4c3b4c9354be7270$export$9799dafc1a1deb28).empty;
            setRoomData(emptyLayout);
            setZones([]);
            setZoningExplanation('');
            setFocusedZoneId(null);
            pushToHistory(emptyLayout, questionnaire, prompt, '', null, [], [], model, '', [], [], '');
            return;
        }
        setStatus('loading');
        setErrorMessage('');
        try {
            const response = await fetch(`${backendUrl}/api/rooms/${encodeURIComponent(roomId)}`);
            if (!response.ok) throw new Error(`Failed to retrieve room from database (status ${response.status})`);
            const data = await response.json();
            const roomZones = data.metadata?.zones && Array.isArray(data.metadata.zones) ? data.metadata.zones : [];
            const roomZoningExpl = data.metadata?.zoningExplanation || '';
            setRoomData(data);
            setZones(roomZones);
            setZoningExplanation(roomZoningExpl);
            setFocusedZoneId(null);
            setStatus('idle');
            pushToHistory(data, questionnaire, prompt, '', null, [], [], model, '', [], roomZones, roomZoningExpl);
        } catch (err) {
            setStatus('error');
            setErrorMessage(err instanceof Error ? err.message : String(err));
        }
    };
    // Save the current layout into the DB test room ALLOWED_ROOM_PATCH_ID and redirect
    const handleSaveRoom = async ()=>{
        setStatus('loading');
        setErrorMessage('');
        try {
            const response = await fetch(`${backendUrl}/api/rooms/019ef3c1-e54d-d9a9-17d0-91154620d070`, {
                method: 'PATCH',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    roomData: roomData
                })
            });
            if (!response.ok) throw new Error(`Failed to patch room layout in database (status ${response.status})`);
            const data = await response.json();
            if (data.success) {
                setStatus('success');
                // Open the graphical editor page in a new tab
                const viewerUrl = 'https://archie.iwory.cz/rooms/019ef3c1-e54d-d9a9-17d0-91154620d070';
                window.open(viewerUrl, '_blank');
                // Retrieve fresh database room list
                const roomsRes = await fetch(`${backendUrl}/api/rooms`);
                const rooms = await roomsRes.json();
                if (Array.isArray(rooms)) setDbRooms(rooms);
            } else throw new Error(data.error || 'Failed to update test room');
        } catch (err) {
            setStatus('error');
            setErrorMessage(err instanceof Error ? err.message : String(err));
        }
    };
    const handleFieldChange = (field, val)=>{
        const updated = {
            ...roomData,
            [field]: val
        };
        setRoomData(updated);
        updateCurrentHistoryEntry(updated, questionnaire, prompt, model);
    };
    const handleQuestionnaireChange = (field, val)=>{
        const updated = {
            ...questionnaire,
            [field]: val
        };
        setQuestionnaire(updated);
        updateCurrentHistoryEntry(roomData, updated, prompt, model);
    };
    const handlePromptChange = (newPrompt)=>{
        setPrompt(newPrompt);
        updateCurrentHistoryEntry(roomData, questionnaire, newPrompt, model);
    };
    const handleModelChange = (newModel)=>{
        setModel(newModel);
        updateCurrentHistoryEntry(roomData, questionnaire, prompt, newModel);
    };
    // Drag and drop JSON file uploads
    const handleRoomDataUpload = (uploadedData)=>{
        const uploadedZones = uploadedData.metadata?.zones && Array.isArray(uploadedData.metadata.zones) ? uploadedData.metadata.zones : [];
        const uploadedZoningExpl = uploadedData.metadata?.zoningExplanation || '';
        setRoomData(uploadedData);
        setZones(uploadedZones);
        setZoningExplanation(uploadedZoningExpl);
        setFocusedZoneId(null);
        setSelectedRoomId('uploaded');
        pushToHistory(uploadedData, questionnaire, prompt, '', null, [], [], model, '', [], uploadedZones, uploadedZoningExpl);
    };
    // Apply visual error repairs proposed by the Discriminator
    const handleSolveError = (repairInstructions, impactedObjectId, rule)=>{
        if (!repairInstructions) return;
        let targetPrompt = '';
        const item = impactedObjectId ? roomData.items.find((i)=>i.itemId === impactedObjectId) : null;
        if (item) targetPrompt = `Fix layout: For the object "${item.label}" (ID: ${impactedObjectId}), please apply: ${repairInstructions}`;
        else if (impactedObjectId) targetPrompt = `Fix layout: For object with ID: ${impactedObjectId}, please apply: ${repairInstructions}`;
        else if (rule) targetPrompt = `Fix layout issue ${rule.ruleId || ''}: "${rule.userMessage || ''}". Fix Recommendation: ${repairInstructions}`;
        else targetPrompt = `Fix layout issue: ${repairInstructions}`;
        setPrompt(targetPrompt);
        updateCurrentHistoryEntry(roomData, questionnaire, targetPrompt, model);
        // Scroll to design prompt textarea and focus it
        setTimeout(()=>{
            const textarea = document.getElementById('design-prompt-textarea');
            if (textarea) {
                textarea.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center'
                });
                textarea.focus();
            }
        }, 50);
    };
    const handleSolveAllErrors = ()=>{
        if (!validationResult || !validationResult.results) return;
        const failedRules = validationResult.results.filter((r)=>r.status === 'fail');
        if (failedRules.length === 0) return;
        const instructions = failedRules.map((rule)=>{
            const impactedObjectId = rule.impactedObjectId;
            const repairInstructions = rule.userRepairInstructions || '';
            const item = impactedObjectId ? roomData.items.find((i)=>i.itemId === impactedObjectId) : null;
            if (item) return `- For the object "${item.label}" (ID: ${impactedObjectId}): ${repairInstructions}`;
            else if (impactedObjectId) return `- For object with ID: ${impactedObjectId}: ${repairInstructions}`;
            else return `- Issue ${rule.ruleId || ''}: "${rule.userMessage || ''}". Fix Recommendation: ${repairInstructions}`;
        }).join('\n');
        const targetPrompt = `Fix the following layout issues:\n${instructions}`;
        setPrompt(targetPrompt);
        updateCurrentHistoryEntry(roomData, questionnaire, targetPrompt, model);
        // Scroll to design prompt textarea and focus it
        setTimeout(()=>{
            const textarea = document.getElementById('design-prompt-textarea');
            if (textarea) {
                textarea.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center'
                });
                textarea.focus();
            }
        }, 50);
    };
    const handleUpdateLayout = async ()=>{
        setStatus('loading');
        setErrorMessage('');
        setAiMessage('');
        setLogs([]);
        setGeneratedScript('');
        setValidationResult(null);
        setGeminiCalls([]);
        setSearchLogs([]);
        try {
            const response = await fetch(`${backendUrl}/api/update-layout`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    roomData: roomData,
                    questionnaire: questionnaire,
                    prompt: prompt,
                    model: model
                })
            });
            const resData = await response.json();
            setLogs(resData.logs || []);
            const aiMsg = resData.aiMessage || '';
            setAiMessage(aiMsg);
            if (!response.ok || !resData.success) {
                setStatus('error');
                setErrorMessage(resData.error || 'Server error occurred during layout update.');
                return;
            }
            const script = resData.pythonScript || '';
            const validation = resData.validation || null;
            const calls = resData.geminiCalls || [];
            const sLogs = resData.searchLogs || [];
            setGeneratedScript(script);
            setValidationResult(validation);
            setGeminiCalls(calls);
            setSearchLogs(sLogs);
            let updatedRoom = roomData;
            if (resData.roomData) updatedRoom = resData.roomData;
            else if (resData.placements && Array.isArray(resData.placements)) {
                const placementMap = new Map(resData.placements.map((p)=>[
                        p.id,
                        p
                    ]));
                updatedRoom = {
                    ...roomData,
                    items: roomData.items.map((item)=>{
                        const placed = placementMap.get(item.itemId);
                        if (placed) return {
                            ...item,
                            position: {
                                x: placed.position.x,
                                y: placed.position.y,
                                z: placed.position.z
                            },
                            angle: placed.rotation
                        };
                        return item;
                    })
                };
            }
            setRoomData(updatedRoom);
            setStatus('success');
            pushToHistory(updatedRoom, questionnaire, prompt, script, validation, calls, resData.logs || [], model, aiMsg, sLogs, zones, zoningExplanation);
        } catch (err) {
            setStatus('error');
            setErrorMessage(err instanceof Error ? err.message : String(err));
        }
    };
    // Generate zones using Gemini spatial reasoning + Discriminator /api/v2/zone
    const handleGenerateZones = async (customRules)=>{
        setIsZoning(true);
        setZoningErrorMessage('');
        try {
            const response = await fetch(`${backendUrl}/api/zoning/generate`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    roomData: roomData,
                    prompt: zoningPrompt,
                    questionnaire: questionnaire,
                    model: zoningModel,
                    customRulesMarkdown: customRules,
                    includeAllSkills: includeAllSkills
                })
            });
            const resData = await response.json();
            if (!response.ok || !resData.success) throw new Error(resData.error || 'Zoning generation failed.');
            const generatedVariants = Array.isArray(resData.variants) && resData.variants.length > 0 ? resData.variants : [];
            const primaryVariant = generatedVariants[0];
            const generatedZones = primaryVariant ? primaryVariant.zones : resData.zones || [];
            const explanation = primaryVariant ? primaryVariant.description : resData.aiExplanation || '';
            const anchors = primaryVariant ? primaryVariant.zoneAnchors : resData.generatedAnchors || [];
            setVariants(generatedVariants);
            setActiveVariantIndex(0);
            setZones(generatedZones);
            setZoneAnchors(anchors);
            setZoningExplanation(explanation);
            setShowZonesInPreview(true);
            setShowZoneAnchors(true);
            setFocusedZoneId(null);
            setFocusedAnchorId(null);
            const updatedLayout = primaryVariant ? primaryVariant.updatedRoomData : resData.updatedRoomData || {
                ...roomData,
                metadata: {
                    ...roomData.metadata,
                    zones: generatedZones,
                    zoningExplanation: explanation
                }
            };
            setRoomData(updatedLayout);
            pushToHistory(updatedLayout, questionnaire, prompt, generatedScript, validationResult, geminiCalls, logs, model, aiMessage, searchLogs, generatedZones, explanation, anchors, generatedVariants, 0);
        } catch (err) {
            const msg = err instanceof Error ? err.message : String(err);
            setZoningErrorMessage(msg);
        } finally{
            setIsZoning(false);
        }
    };
    const selectZoningVariant = (index)=>{
        if (!variants[index]) return;
        setActiveVariantIndex(index);
        const chosen = variants[index];
        setZones(chosen.zones);
        setZoneAnchors(chosen.zoneAnchors);
        setZoningExplanation(chosen.description);
        setRoomData(chosen.updatedRoomData);
        setFocusedZoneId(null);
        setFocusedAnchorId(null);
    };
    const handleClearZones = ()=>{
        setZones([]);
        setZoneAnchors([]);
        setVariants([]);
        setActiveVariantIndex(0);
        setZoningExplanation('');
        setFocusedZoneId(null);
        setFocusedAnchorId(null);
        const cleanedRoom = {
            ...roomData,
            items: roomData.items.map((item)=>{
                const meta = {
                    ...item.metadata || {}
                };
                delete meta.zoneId;
                return {
                    ...item,
                    zoneId: null,
                    metadata: meta
                };
            }),
            metadata: {
                ...roomData.metadata,
                zones: [],
                zoningExplanation: ''
            }
        };
        setRoomData(cleanedRoom);
        pushToHistory(cleanedRoom, questionnaire, prompt, generatedScript, validationResult, geminiCalls, logs, model, aiMessage, searchLogs, [], '', [], [], 0);
    };
    const handleZoningPromptChange = (newZoningPrompt)=>{
        setZoningPrompt(newZoningPrompt);
    };
    const handleZoningModelChange = (newZoningModel)=>{
        setZoningModel(newZoningModel);
    };
    const handleToggleShowZones = (show)=>{
        setShowZonesInPreview(show);
    };
    const handleToggleShowZoneAnchors = (show)=>{
        setShowZoneAnchors(show);
    };
    const handleToggleIncludeAllSkills = (include)=>{
        setIncludeAllSkills(include);
    };
    const handleFocusZone = (zoneId)=>{
        setFocusedZoneId(zoneId);
    };
    const handleFocusAnchor = (anchorId)=>{
        setFocusedAnchorId(anchorId);
    };
    return {
        roomData: roomData,
        questionnaire: questionnaire,
        prompt: prompt,
        model: model,
        aiMessage: aiMessage,
        backendUrl: backendUrl,
        setBackendUrl: setBackendUrl,
        status: status,
        errorMessage: errorMessage,
        logs: logs,
        generatedScript: generatedScript,
        validationResult: validationResult,
        geminiCalls: geminiCalls,
        searchLogs: searchLogs,
        isValidating: isValidating,
        dbRooms: dbRooms,
        selectedRoomId: selectedRoomId,
        backendHealthy: backendHealthy,
        history: history,
        historyIndex: historyIndex,
        zones: // Zoning states & methods
        zones,
        variants: variants,
        activeVariantIndex: activeVariantIndex,
        selectZoningVariant: selectZoningVariant,
        zoneAnchors: zoneAnchors,
        showZoneAnchors: showZoneAnchors,
        handleToggleShowZoneAnchors: handleToggleShowZoneAnchors,
        includeAllSkills: includeAllSkills,
        handleToggleIncludeAllSkills: handleToggleIncludeAllSkills,
        focusedAnchorId: focusedAnchorId,
        handleFocusAnchor: handleFocusAnchor,
        isZoning: isZoning,
        zoningPrompt: zoningPrompt,
        zoningModel: zoningModel,
        zoningExplanation: zoningExplanation,
        zoningErrorMessage: zoningErrorMessage,
        showZonesInPreview: showZonesInPreview,
        focusedZoneId: focusedZoneId,
        handleGenerateZones: handleGenerateZones,
        handleClearZones: handleClearZones,
        handleZoningPromptChange: handleZoningPromptChange,
        handleZoningModelChange: handleZoningModelChange,
        handleToggleShowZones: handleToggleShowZones,
        handleFocusZone: handleFocusZone,
        handleUndo: // Other handlers
        handleUndo,
        handleRedo: handleRedo,
        handleRoomSelect: handleRoomSelect,
        handleSaveRoom: handleSaveRoom,
        handleFieldChange: handleFieldChange,
        handleQuestionnaireChange: handleQuestionnaireChange,
        handlePromptChange: handlePromptChange,
        handleModelChange: handleModelChange,
        handleRoomDataUpload: handleRoomDataUpload,
        handleSolveError: handleSolveError,
        handleSolveAllErrors: handleSolveAllErrors,
        handleUpdateLayout: handleUpdateLayout
    };
}



const $983329fb19a3ee8c$export$6ac6d84497c9bbbe = (0, $0d8d43ca0bd0e763$export$b9237242c9be0e8c);



var $bFZzf = parcelRequire("bFZzf");


const $4e654b9969462068$var$STORAGE_KEY_MESSAGES = 'architect_chat_messages';
const $4e654b9969462068$var$STORAGE_KEY_MODEL = 'architect_chat_model';
const $4e654b9969462068$var$INITIAL_WELCOME_MESSAGE = {
    id: 'init-msg',
    sender: 'architect',
    text: "Dobr\xfd den! Jsem V\xe1\u0161 AI architekt interi\xe9ru. Jak V\xe1m mohu pomoci s n\xe1vrhem a uspo\u0159\xe1d\xe1n\xedm n\xe1bytku v t\xe9to m\xedstnosti? M\u016F\u017Eeme probrat ergonomii, pr\u016Fchody i estetick\xe9 lad\u011Bn\xed.",
    timestamp: new Date().toLocaleTimeString([], {
        hour: '2-digit',
        minute: '2-digit'
    })
};
function $4e654b9969462068$var$getStoredMessages() {
    if (typeof window === 'undefined') return [
        $4e654b9969462068$var$INITIAL_WELCOME_MESSAGE
    ];
    try {
        const raw = sessionStorage.getItem($4e654b9969462068$var$STORAGE_KEY_MESSAGES);
        if (raw) {
            const parsed = JSON.parse(raw);
            if (Array.isArray(parsed) && parsed.length > 0) return parsed;
        }
    } catch (err) {
        console.warn('Failed to parse stored chat messages from sessionStorage:', err);
    }
    return [
        $4e654b9969462068$var$INITIAL_WELCOME_MESSAGE
    ];
}
function $4e654b9969462068$var$getStoredModel() {
    if (typeof window === 'undefined') return 0, $0d8d43ca0bd0e763$export$29b5792eb3806f43;
    try {
        const saved = sessionStorage.getItem($4e654b9969462068$var$STORAGE_KEY_MODEL);
        if (saved && (0, $983329fb19a3ee8c$export$6ac6d84497c9bbbe).some((m)=>m.id === saved)) return saved;
    } catch (err) {
        console.warn('Failed to load stored model from sessionStorage:', err);
    }
    return 0, $0d8d43ca0bd0e763$export$29b5792eb3806f43;
}
function $4e654b9969462068$export$10d302cd18edaee1({ backendUrl: backendUrl, roomData: roomData, onApplyPromptToOrchestrator: onApplyPromptToOrchestrator }) {
    const [selectedModel, setSelectedModel] = (0, $bFZzf.useState)($4e654b9969462068$var$getStoredModel);
    const [messages, setMessages] = (0, $bFZzf.useState)($4e654b9969462068$var$getStoredMessages);
    const [isLoading, setIsLoading] = (0, $bFZzf.useState)(false);
    const [errorMessage, setErrorMessage] = (0, $bFZzf.useState)(null);
    // Sync messages to sessionStorage whenever they change
    (0, $bFZzf.useEffect)(()=>{
        try {
            sessionStorage.setItem($4e654b9969462068$var$STORAGE_KEY_MESSAGES, JSON.stringify(messages));
        } catch (err) {
            console.warn('Failed to save chat messages to sessionStorage:', err);
        }
    }, [
        messages
    ]);
    // Sync selectedModel to sessionStorage whenever it changes
    (0, $bFZzf.useEffect)(()=>{
        try {
            sessionStorage.setItem($4e654b9969462068$var$STORAGE_KEY_MODEL, selectedModel);
        } catch (err) {
            console.warn('Failed to save selected model to sessionStorage:', err);
        }
    }, [
        selectedModel
    ]);
    const sendMessage = (0, $bFZzf.useCallback)(async (text, activeSkillIds)=>{
        if (!text.trim() || isLoading) return;
        const userMsg = {
            id: `user-${Date.now()}`,
            sender: 'user',
            text: text.trim(),
            timestamp: new Date().toLocaleTimeString([], {
                hour: '2-digit',
                minute: '2-digit'
            })
        };
        setMessages((prev)=>[
                ...prev,
                userMsg
            ]);
        setIsLoading(true);
        setErrorMessage(null);
        // Build chat history for Gemini API payload
        const historyPayload = messages.filter((m)=>m.id !== 'init-msg').map((m)=>({
                role: m.sender === 'user' ? 'user' : 'model',
                text: m.text
            }));
        try {
            const response = await fetch(`${backendUrl}/api/architect-chat`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    message: text.trim(),
                    history: historyPayload,
                    roomLayout: roomData,
                    model: selectedModel,
                    activeSkillIds: activeSkillIds
                })
            });
            if (!response.ok) {
                const errData = await response.json().catch(()=>({}));
                throw new Error(errData.message || `Chyba API serveru (${response.status})`);
            }
            const result = await response.json();
            const architectMsg = {
                id: `arch-${Date.now()}`,
                sender: 'architect',
                text: result.userMessage,
                timestamp: new Date().toLocaleTimeString([], {
                    hour: '2-digit',
                    minute: '2-digit'
                }),
                action: result.action,
                targetTextareaValue: result.targetTextareaValue,
                modelUsed: selectedModel,
                usedSkills: result.usedSkills
            };
            setMessages((prev)=>[
                    ...prev,
                    architectMsg
                ]);
            // If action is EXECUTE_ORCHESTRATOR, fill target Textarea value
            if (result.action === 'EXECUTE_ORCHESTRATOR' && result.targetTextareaValue) onApplyPromptToOrchestrator(result.targetTextareaValue, false);
        } catch (err) {
            const msg = err instanceof Error ? err.message : String(err);
            setErrorMessage(msg);
            setMessages((prev)=>[
                    ...prev,
                    {
                        id: `err-${Date.now()}`,
                        sender: 'architect',
                        text: `Omlouv\xe1m se, p\u{159}i komunikaci s AI do\u{161}lo k chyb\u{11B}: ${msg}`,
                        timestamp: new Date().toLocaleTimeString([], {
                            hour: '2-digit',
                            minute: '2-digit'
                        })
                    }
                ]);
        } finally{
            setIsLoading(false);
        }
    }, [
        backendUrl,
        roomData,
        selectedModel,
        messages,
        isLoading,
        onApplyPromptToOrchestrator
    ]);
    const clearChat = (0, $bFZzf.useCallback)(()=>{
        const resetMsg = {
            id: `init-${Date.now()}`,
            sender: 'architect',
            text: "Konverzace byla resetov\xe1na. Jak\xe9 \xfapravy v m\xedstnosti byste cht\u011Bl navrhnout?",
            timestamp: new Date().toLocaleTimeString([], {
                hour: '2-digit',
                minute: '2-digit'
            })
        };
        setMessages([
            resetMsg
        ]);
        setErrorMessage(null);
        try {
            sessionStorage.setItem($4e654b9969462068$var$STORAGE_KEY_MESSAGES, JSON.stringify([
                resetMsg
            ]));
        } catch (err) {
            console.warn('Failed to clear chat in sessionStorage:', err);
        }
    }, []);
    return {
        messages: messages,
        selectedModel: selectedModel,
        setSelectedModel: setSelectedModel,
        availableModels: (0, $983329fb19a3ee8c$export$6ac6d84497c9bbbe),
        isLoading: isLoading,
        errorMessage: errorMessage,
        sendMessage: sendMessage,
        clearChat: clearChat
    };
}



var $bFZzf = parcelRequire("bFZzf");
function $6d3477a982cfb87f$export$52147cc63c0ab0e2(backendUrl) {
    const [skills, setSkills] = (0, $bFZzf.useState)([]);
    const [isLoading, setIsLoading] = (0, $bFZzf.useState)(false);
    const [error, setError] = (0, $bFZzf.useState)(null);
    const fetchSkills = (0, $bFZzf.useCallback)(async ()=>{
        setIsLoading(true);
        setError(null);
        try {
            const res = await fetch(`${backendUrl}/api/skills`);
            if (!res.ok) throw new Error("Nepoda\u0159ilo se na\u010D\xedst skilly.");
            const data = await res.json();
            setSkills(data);
        } catch (err) {
            setError(err instanceof Error ? err.message : String(err));
        } finally{
            setIsLoading(false);
        }
    }, [
        backendUrl
    ]);
    (0, $bFZzf.useEffect)(()=>{
        fetchSkills();
    }, [
        fetchSkills
    ]);
    const toggleSkill = (0, $bFZzf.useCallback)(async (id, enabled)=>{
        try {
            const res = await fetch(`${backendUrl}/api/skills/${id}`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    enabled: enabled
                })
            });
            if (!res.ok) throw new Error("Nepoda\u0159ilo se upravit stav skillu.");
            const updated = await res.json();
            setSkills((prev)=>prev.map((s)=>s.id === id ? updated : s));
        } catch (err) {
            setError(err instanceof Error ? err.message : String(err));
        }
    }, [
        backendUrl
    ]);
    const addSkill = (0, $bFZzf.useCallback)(async (input)=>{
        try {
            const res = await fetch(`${backendUrl}/api/skills`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(input)
            });
            if (!res.ok) throw new Error("Nepoda\u0159ilo se vytvo\u0159it nov\xfd skill.");
            const newSkill = await res.json();
            setSkills((prev)=>[
                    ...prev,
                    newSkill
                ]);
            return newSkill;
        } catch (err) {
            setError(err instanceof Error ? err.message : String(err));
            throw err;
        }
    }, [
        backendUrl
    ]);
    const updateSkillContent = (0, $bFZzf.useCallback)(async (id, updates)=>{
        try {
            const res = await fetch(`${backendUrl}/api/skills/${id}`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(updates)
            });
            if (!res.ok) throw new Error("Nepoda\u0159ilo se aktualizovat skill.");
            const updated = await res.json();
            setSkills((prev)=>prev.map((s)=>s.id === id ? updated : s));
        } catch (err) {
            setError(err instanceof Error ? err.message : String(err));
            throw err;
        }
    }, [
        backendUrl
    ]);
    const deleteSkill = (0, $bFZzf.useCallback)(async (id)=>{
        try {
            const res = await fetch(`${backendUrl}/api/skills/${id}`, {
                method: 'DELETE'
            });
            if (!res.ok) throw new Error("Nepoda\u0159ilo se smazat skill.");
            setSkills((prev)=>prev.filter((s)=>s.id !== id));
        } catch (err) {
            setError(err instanceof Error ? err.message : String(err));
            throw err;
        }
    }, [
        backendUrl
    ]);
    return {
        skills: skills,
        isLoading: isLoading,
        error: error,
        fetchSkills: fetchSkills,
        toggleSkill: toggleSkill,
        addSkill: addSkill,
        updateSkillContent: updateSkillContent,
        deleteSkill: deleteSkill
    };
}




var $bFZzf = parcelRequire("bFZzf");
var $1c80c15edccb5c8b$exports = {};
/**
 * marked v18.1.3 - a markdown parser
 * Copyright (c) 2018-2026, MarkedJS. (MIT License)
 * Copyright (c) 2011-2018, Christopher Jeffrey. (MIT License)
 * https://github.com/markedjs/marked
 */ /**
 * DO NOT EDIT THIS FILE
 * The code in this file is generated from files in ./src/
 */ (function(g, f) {
    $1c80c15edccb5c8b$exports = f();
})(typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : $1c80c15edccb5c8b$exports, function() {
    var exports = {};
    var __exports = exports;
    var module1 = {
        exports: exports
    };
    "use strict";
    var se = Object.defineProperty;
    var He = Object.getOwnPropertyDescriptor;
    var je = Object.getOwnPropertyNames;
    var Ge = Object.prototype.hasOwnProperty;
    var Ne = (a, e)=>{
        for(var t in e)se(a, t, {
            get: e[t],
            enumerable: !0
        });
    }, Fe = (a, e, t, n)=>{
        if (e && typeof e == "object" || typeof e == "function") for (let s of je(e))!Ge.call(a, s) && s !== t && se(a, s, {
            get: ()=>e[s],
            enumerable: !(n = He(e, s)) || n.enumerable
        });
        return a;
    };
    var Qe = (a)=>Fe(se({}, "__esModule", {
            value: !0
        }), a);
    var Jt = {};
    Ne(Jt, {
        Hooks: ()=>L,
        Lexer: ()=>O,
        Marked: ()=>Q,
        Parser: ()=>w,
        Renderer: ()=>$,
        TextRenderer: ()=>A,
        Tokenizer: ()=>_,
        defaults: ()=>P,
        getDefaults: ()=>D,
        lexer: ()=>Vt,
        marked: ()=>m,
        options: ()=>Ft,
        parse: ()=>Kt,
        parseInline: ()=>Wt,
        parser: ()=>Xt,
        setOptions: ()=>Qt,
        use: ()=>ve,
        walkTokens: ()=>Ut
    });
    module1.exports = Qe(Jt);
    function D() {
        return {
            async: !1,
            breaks: !1,
            extensions: null,
            gfm: !0,
            hooks: null,
            pedantic: !1,
            renderer: null,
            silent: !1,
            tokenizer: null,
            walkTokens: null
        };
    }
    var P = D();
    function ie(a) {
        P = a;
    }
    var q = {
        exec: ()=>null
    };
    function B(a) {
        let e = [];
        return (t)=>{
            let n = Math.max(0, Math.min(3, t - 1)), s = e[n];
            return s || (s = a(n), e[n] = s), s;
        };
    }
    function c(a, e = "") {
        let t = typeof a == "string" ? a : a.source, n = {
            replace: (s, r)=>{
                let o = typeof r == "string" ? r : r.source;
                return o = o.replace(T.caret, "$1"), t = t.replace(s, o), n;
            },
            getRegex: ()=>new RegExp(t, e)
        };
        return n;
    }
    var Oe = ((a = "")=>{
        try {
            return new RegExp("(?<=1)(?<!1)" + a), true;
        } catch  {
            return !1;
        }
    })(), T = {
        codeRemoveIndent: /^(?: {0,3}\t| {1,4})/gm,
        outputLinkReplace: /\\([\[\]])/g,
        indentCodeCompensation: /^(\s+)(?:```)/,
        beginningSpace: /^\s+/,
        endingHash: /#$/,
        startingSpaceChar: /^ /,
        endingSpaceChar: / $/,
        endingSpaceTabChar: /[ \t]$/,
        nonSpaceChar: /[^ ]/,
        newLineCharGlobal: /\n/g,
        tabCharGlobal: /\t/g,
        leadingSpaceTab: /^[ \t]+/,
        multipleSpaceGlobal: /\s+/g,
        blankLine: /^[ \t]*$/,
        doubleBlankLine: /\n[ \t]*\n[ \t]*$/,
        blockquoteStart: /^ {0,3}>/,
        blockquoteSetextReplace: /\n {0,3}((?:=+|-+)[ \t]*)(?=\n|$)/g,
        blockquoteSetextReplace2: /^ {0,3}>[ \t]?/gm,
        blockquoteMarkerWhitespace: /^( {0,3}>)([ \t]+)/gm,
        listReplaceNesting: /^ {1,4}(?=( {4})*[^ ])/g,
        listIsTask: /^\[[ xX]\][ \t]+\S/,
        listReplaceTask: /^\[[ xX]\][ \t]+/,
        listTaskCheckbox: /\[[ xX]\]/,
        anyLine: /\n.*\n/,
        hrefBrackets: /^<(.*)>$/,
        tableDelimiter: /[:|]/,
        tableAlignChars: /^\||\| *$/g,
        tableRowBlankLine: /\n[ \t]*$/,
        tableAlignRight: /^ *-+: *$/,
        tableAlignCenter: /^ *:-+: *$/,
        tableAlignLeft: /^ *:-+ *$/,
        startATag: /^<a /i,
        endATag: /^<\/a>/i,
        startPreScriptTag: /^<(pre|code|kbd|script)(\s|>)/i,
        endPreScriptTag: /^<\/(pre|code|kbd|script)(\s|>)/i,
        startAngleBracket: /^</,
        endAngleBracket: />$/,
        pedanticHrefTitle: /^([^'"]*[^\s])\s+(['"])(.*)\2/,
        unicodeAlphaNumeric: /[\p{L}\p{N}]/u,
        numericCharacterReference: /&#(?:(\d{1,7})|[Xx]([A-Fa-f0-9]{1,6}));/,
        numericCharacterReferenceOrAmpersand: /&#(?:(\d{1,7})|[Xx]([A-Fa-f0-9]{1,6}));|&(?!(#\d{1,7}|#[Xx][a-fA-F0-9]{1,6}|\w+);)/g,
        escapeTest: /[&<>"']/,
        escapeReplace: /[&<>"']/g,
        escapeTestNoEncode: /[<>"']|&(?!(#\d{1,7}|#[Xx][a-fA-F0-9]{1,6}|\w+);)/,
        escapeReplaceNoEncode: /[<>"']|&(?!(#\d{1,7}|#[Xx][a-fA-F0-9]{1,6}|\w+);)/g,
        caret: /(^|[^\[])\^/g,
        percentDecode: /%25/g,
        findPipe: /\|/g,
        splitPipe: / \|/,
        slashPipe: /\\\|/g,
        carriageReturn: /\r\n|\r/g,
        spaceLine: /^ +$/gm,
        notSpaceStart: /^\S*/,
        endingNewline: /\n$/,
        listItemRegex: (a)=>new RegExp(`^( {0,3}${a})((?:[	 ][^\\n]*)?(?:\\n|$))`),
        nextBulletRegex: B((a)=>new RegExp(`^ {0,${a}}(?:[*+-]|\\d{1,9}[.)])((?:[ 	][^\\n]*)?(?:\\n|$))`)),
        hrRegex: B((a)=>new RegExp(`^ {0,${a}}((?:-[ 	]*){3,}|(?:_[ 	]*){3,}|(?:\\*[ 	]*){3,})(?:\\n+|$)`)),
        fencesBeginRegex: B((a)=>new RegExp(`^ {0,${a}}(?:\`\`\`|~~~)`)),
        headingBeginRegex: B((a)=>new RegExp(`^ {0,${a}}#{1,6}(?:\\s|$)`)),
        pedanticHeadingBeginRegex: B((a)=>new RegExp(`^ {0,${a}}#`)),
        htmlBeginRegex: B((a)=>new RegExp(`^ {0,${a}}(?:</?(?:${X})(?: +|$|/?>)|<(?:(?:script|pre|style|textarea)(?:[\\s>]|$)|!--)|<\\?|<![A-Za-z]|<!\\[CDATA\\[)`, "i")),
        blockquoteBeginRegex: B((a)=>new RegExp(`^ {0,${a}}>`))
    }, Ue = /^(?:[ \t]*(?:\n|$))+/, We = /^((?: {4}| {0,3}\t)[^\n]+(?:\n(?:[ \t]*(?:\n|$))*)?)+/, Ke = /^ {0,3}(`{3,}(?=[^`\n]*(?:\n|$))|~{3,})([^\n]*)(?:\n|$)(?:|([\s\S]*?)(?:\n|$))(?: {0,3}(?:(?=`)\1`*|(?=~)\1~*) *(?=\n|$)|$)/, K = /^ {0,3}((?:-[\t ]*){3,}|(?:_[ \t]*){3,}|(?:\*[ \t]*){3,})(?:\n+|$)/, Xe = /^ {0,3}(#{1,6})(?=\s|$)(.*)(?:\n+|$)/, ae = / {0,3}(?:[*+-]|\d{1,9}[.)])/, we = /^(?!bull |blockCode|fences|blockquote|heading|html|table)((?:.|\n(?!\s*?\n|bull |fences|blockquote|heading|hr|html|table))+?)\n {0,3}(=+|-+)[ \t]*(?:\n+|$)/, Pe = c(we).replace(/bull/g, ae).replace(/blockCode/g, /(?: {4}| {0,3}\t)/).replace(/fences/g, / {0,3}(?:`{3,}|~{3,})/).replace(/blockquote/g, / {0,3}>/).replace(/heading/g, / {0,3}#{1,6}(?:\s|$)/).replace(/hr/g, / {0,3}(?:(?:-[\t ]*){3,}|(?:_[ \t]*){3,}|(?:\*[ \t]*){3,})(?:\n+|$)/).replace(/html/g, / {0,3}<[^\n>]+>\n/).replace(/\|table/g, "").getRegex(), Ve = c(we).replace(/bull/g, ae).replace(/blockCode/g, /(?: {4}| {0,3}\t)/).replace(/fences/g, / {0,3}(?:`{3,}|~{3,})/).replace(/blockquote/g, / {0,3}>/).replace(/heading/g, / {0,3}#{1,6}(?:\s|$)/).replace(/hr/g, / {0,3}(?:(?:-[\t ]*){3,}|(?:_[ \t]*){3,}|(?:\*[ \t]*){3,})(?:\n+|$)/).replace(/html/g, / {0,3}<[^\n>]+>\n/).replace(/table/g, / {0,3}\|?(?:[:\- ]*\|)+[\:\- ]*\n/).getRegex(), le = /^([^\n]+(?:\n(?!hr|heading|lheading|blockquote|fences|list|html|table|[ \t]+\n)[^\n]+)*)/, Je = /^[^\n]+/, ue = /(?!\s*\])(?:\\[\s\S]|[^\[\]\\\n]|\n(?![ \t]*\n))+/, Ye = c(/^ {0,3}\[(label)\]: *(?:\n[ \t]*)?([^<\s][^\s]*|<.*?>)(?:(?: +(?:\n[ \t]*)?| *\n[ \t]*)(title))? *(?:\n+|$)/).replace("label", ue).replace("title", /(?:"(?:\\[\s\S]|[^"\\])*"|'(?:\\[\s\S]|[^'\\\n]|\n(?!\n))*'|\((?:\\[\s\S]|[^()\\])*\))/).getRegex(), et = c(/^(bull)([ \t][^\n]*?)?(?:\n|$)/).replace(/bull/g, ae).getRegex(), X = "address|article|aside|base|basefont|blockquote|body|caption|center|col|colgroup|dd|details|dialog|dir|div|dl|dt|fieldset|figcaption|figure|footer|form|frame|frameset|h[1-6]|head|header|hr|html|iframe|legend|li|link|main|menu|menuitem|meta|nav|noframes|ol|optgroup|option|p|param|search|section|summary|table|tbody|td|tfoot|th|thead|title|tr|track|ul", pe = /<!--(?:-?>|[\s\S]*?(?:-->|$))/, tt = c("^ {0,3}(?:<(script|pre|style|textarea)[\\s>][\\s\\S]*?(?:</\\1>[^\\n]*\\n*|$)|comment[^\\n]*(\\n+|$)|<\\?[\\s\\S]*?(?:\\?>[^\\n]*\\n*|$)|<![A-Z][\\s\\S]*?(?:>[^\\n]*\\n*|$)|<!\\[CDATA\\[[\\s\\S]*?(?:\\]\\]>[^\\n]*\\n*|$)|</?(tag)(?:[ \\t]+|\\n|/?>|$)[\\s\\S]*?(?:(?:\\n[ 	]*)+\\n|$)|<(?!(?:script|pre|style|textarea)(?![a-z0-9-]))([a-z][a-z0-9-]*)(?:attribute)*? */?>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:(?:\\n[ 	]*)+\\n|$)|</[a-z][a-z0-9-]*\\s*>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:(?:\\n[ 	]*)+\\n|$))", "i").replace("comment", pe).replace("tag", X).replace("attribute", / +[a-zA-Z:_][\w.:-]*(?: *= *"[^"\n]*"| *= *'[^'\n]*'| *= *[^\s"'=<>`]+)?/).getRegex(), Se = (a)=>c(le).replace("hr", K).replace("heading", " {0,3}#{1,6}(?:\\s|$)").replace("|lheading", "").replace("|table", "").replace("blockquote", " {0,3}>").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*(?:\\n|$))|~~~)[^\\n]*(?:\\n|$)").replace("list", a).replace("html", " {0,3}(?:</?(?:tag)(?: +|\\n|/?>)|<(?:(?:script|pre|style|textarea)(?:[\\s>]|$)|!--)|<\\?|<![A-Za-z]|<!\\[CDATA\\[)").replace("tag", X).getRegex(), nt = Se(/ {0,3}(?:[*+-]|1[.)])[ \t]+[^ \t\n]/), rt = Se(/ {0,3}(?:[*+-]|\d{1,9}[.)])(?:[ \t]|\n|$)/), st = c(/^( {0,3}> ?(?:(?![ \t]*(?:\n|$))(paragraph)|[^\n]*)(?:\n|$))+/).replace("paragraph", rt).getRegex(), ce = {
        blockquote: st,
        code: We,
        def: Ye,
        fences: Ke,
        heading: Xe,
        hr: K,
        html: tt,
        lheading: Pe,
        list: et,
        newline: Ue,
        paragraph: nt,
        table: q,
        text: Je
    }, be = c("^ *([^\\n ].*)\\n {0,3}((?:\\| *)?:?-+:? *(?:\\| *:?-+:? *)*(?:\\| *)?)(?:\\n((?:(?! *\\n|hr|heading|blockquote|code|fences|list|html).*(?:\\n|$))*)\\n*|$)").replace("hr", K).replace("heading", " {0,3}#{1,6}(?:\\s|$)").replace("blockquote", " {0,3}>").replace("code", "(?: {4}| {0,3}	)[^\\n]").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*(?:\\n|$))|~~~)[^\\n]*(?:\\n|$)").replace("list", " {0,3}(?:[*+-]|1[.)])[ \\t]").replace("html", " {0,3}(?:</?(?:tag)(?: +|\\n|/?>)|<(?:(?:script|pre|style|textarea)(?:[\\s>]|$)|!--)|<\\?|<![A-Za-z]|<!\\[CDATA\\[)").replace("tag", X).getRegex(), it = {
        ...ce,
        lheading: Ve,
        table: be,
        paragraph: c(le).replace("hr", K).replace("heading", " {0,3}#{1,6}(?:\\s|$)").replace("|lheading", "").replace("table", be).replace("blockquote", " {0,3}>").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*(?:\\n|$))|~~~)[^\\n]*(?:\\n|$)").replace("list", " {0,3}(?:[*+-]|1[.)])[ \\t]+[^ \\t\\n]").replace("html", " {0,3}(?:</?(?:tag)(?: +|\\n|/?>)|<(?:(?:script|pre|style|textarea)(?:[\\s>]|$)|!--)|<\\?|<![A-Za-z]|<!\\[CDATA\\[)").replace("tag", X).getRegex()
    }, ot = {
        ...ce,
        html: c(`^ *(?:comment(?: *\\n|\\s*$)|<(tag)[\\s\\S]+?</\\1>(?: *\\n{2,}|\\s*$)|<tag(?:"[^"]*"|'[^']*'|\\s[^'"/>\\s]*)*?/?>(?: *\\n{2,}|\\s*$))`).replace("comment", pe).replace(/tag/g, "(?!(?:a|em|strong|small|s|cite|q|dfn|abbr|data|time|code|var|samp|kbd|sub|sup|i|b|u|mark|ruby|rt|rp|bdi|bdo|span|br|wbr|ins|del|img)\\b)\\w+(?!:|[^\\w\\s@]*@)\\b").getRegex(),
        def: /^ *\[([^\]]+)\]: *<?([^\s>]+)>?(?: +(["(][^\n]+[")]))? *(?:\n+|$)/,
        heading: /^(#{1,6})(.*)(?:\n+|$)/,
        fences: q,
        lheading: /^(.+?)\n {0,3}(=+|-+) *(?:\n+|$)/,
        paragraph: c(le).replace("hr", K).replace("heading", ` *#{1,6} *[^
]`).replace("lheading", Pe).replace("|table", "").replace("blockquote", " {0,3}>").replace("|fences", "").replace("|list", "").replace("|html", "").replace("|tag", "").getRegex()
    }, at = /^\\([!"#$%&'()*+,\-./:;<=>?@\[\]\\^_`{|}~])/, lt = /^(`+)([^`]|[^`][\s\S]*?[^`])\1(?!`)/, ye = /^( {2,}|\\)\n(?!\s*$)[ \t]*/, ut = /^(`+|[^`])(?:(?= {2,}\n)|[\s\S]*?(?:(?=[\\<!\[`*_]|\b_|$)|[^ ](?= {2,}\n)))/, C = /[\p{P}\p{S}]/u, j = /[\s\p{P}\p{S}]/u, V = /[^\s\p{P}\p{S}]/u, pt = c(/^((?![*_])punctSpace)/, "u").replace(/punctSpace/g, j).getRegex(), ct = /[\p{Pi}\p{Ps}"']/u, _e = /(?!~)[\p{P}\p{S}]/u, ht = /(?!~)[\s\p{P}\p{S}]/u, dt = /(?:[^\s\p{P}\p{S}]|~)/u, gt = c(/link|precode-code|html/, "g").replace("link", /\[(?:[^\[\]`]|(?<a>`+)[^`]+\k<a>(?!`))*?\]\((?:\\[\s\S]|[^\\\(\)]|\((?:\\[\s\S]|[^\\\(\)])*\))*\)/).replace("precode-", Oe ? "(?<!`)()" : "(^^|[^`])").replace("code", /(?<b>`+)[^`]+\k<b>(?!`)/).replace("html", /<(?! )[^<>]*?>/).getRegex(), $e = /^(?:\*+(?:((?!\*)punct)|([^\s*]))?)|^_+(?:((?!_)punct)|([^\s_]))?/, kt = c($e, "u").replace(/punct/g, C).getRegex(), ft = c($e, "u").replace(/punct/g, _e).getRegex(), mt = /^(?:\*+(?:((?!\*)(?!openQuote)punct)|([^\s*]))?)|^_+(?:((?!_)(?!openQuote)punct)|([^\s_]))?/, xt = c(mt, "u").replace(/openQuote/g, ct).replace(/punct/g, C).getRegex(), Le = "^[^_*]*?__[^_*]*?\\*[^_*]*?(?=__)|[^*]+(?=[^*])|(?!\\*)punct(\\*+)(?=[\\s]|$)|notPunctSpace(\\*+)(?!\\*)(?=punctSpace|$)|(?!\\*)punctSpace(\\*+)(?=notPunctSpace)|[\\s](\\*+)(?!\\*)(?=punct)|(?!\\*)punct(\\*+)(?!\\*)(?=punct)|notPunctSpace(\\*+)(?=notPunctSpace)", bt = c(Le, "gu").replace(/notPunctSpace/g, V).replace(/punctSpace/g, j).replace(/punct/g, C).getRegex(), Rt = c(Le, "gu").replace(/notPunctSpace/g, dt).replace(/punctSpace/g, ht).replace(/punct/g, _e).getRegex(), Tt = "^[^_*]*?__[^_*]*?\\*[^_*]*?(?=__)|[^*]+(?=[^*])|(?!\\*)punct(\\*+)(?=[\\s]|$)|notPunctSpace(\\*+)(?!\\*)(?=punctSpace|$)|(?!\\*)[\\s](\\*+)(?=notPunctSpace)|[\\s](\\*+)(?!\\*)(?=punct)|(?!\\*)punct(\\*+)(?!\\*)(?=punct)|(?:(?!\\*)punct|notPunctSpace)(\\*+)(?!\\*)(?=notPunctSpace)", Ot = c(Tt, "gu").replace(/notPunctSpace/g, V).replace(/punctSpace/g, j).replace(/punct/g, C).getRegex(), wt = c("^[^_*]*?\\*\\*[^_*]*?_[^_*]*?(?=\\*\\*)|[^_]+(?=[^_])|(?!_)punct(_+)(?=[\\s]|$)|notPunctSpace(_+)(?!_)(?=punctSpace|$)|(?!_)punctSpace(_+)(?=notPunctSpace)|[\\s](_+)(?!_)(?=punct)|(?!_)punct(_+)(?!_)(?=punct)", "gu").replace(/notPunctSpace/g, V).replace(/punctSpace/g, j).replace(/punct/g, C).getRegex(), Pt = "^[^_*]*?\\*\\*[^_*]*?_[^_*]*?(?=\\*\\*)|[^_]+(?=[^_])|(?!_)punct(_+)(?=[\\s]|$)|notPunctSpace(_+)(?!_)(?=punctSpace|$)|(?!_)[\\s](_+)(?=notPunctSpace)|[\\s](_+)(?!_)(?=punct)|(?!_)punct(_+)(?!_)(?=punct)|(?:(?!_)punct|notPunctSpace)(_+)(?!_)(?=notPunctSpace)", St = c(Pt, "gu").replace(/notPunctSpace/g, V).replace(/punctSpace/g, j).replace(/punct/g, C).getRegex(), yt = c(/^~~?(?:((?!~)punct)|[^\s~])/, "u").replace(/punct/g, C).getRegex(), _t = "^[^~]+(?=[^~])|(?!~)punct(~~?)(?=[\\s]|$)|notPunctSpace(~~?)(?!~)(?=punctSpace|$)|(?!~)punctSpace(~~?)(?=notPunctSpace)|[\\s](~~?)(?!~)(?=punct)|(?!~)punct(~~?)(?!~)(?=punct)|notPunctSpace(~~?)(?=notPunctSpace)", $t = c(_t, "gu").replace(/notPunctSpace/g, V).replace(/punctSpace/g, j).replace(/punct/g, C).getRegex(), Lt = c(/\\(punct)/, "gu").replace(/punct/g, C).getRegex(), Ct = c(/(`+)(?:[^`]|[^`][\s\S]*?[^`])\1(?!`)|`+|\\(punct)/, "gu").replace(/punct/g, C).getRegex(), It = c(/^<(scheme:[^\s\x00-\x1f<>]*|email)>/).replace("scheme", /[a-zA-Z][a-zA-Z0-9+.-]{1,31}/).replace("email", /[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+(@)[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+(?![-_])/).getRegex(), At = c(pe).replace("(?:-->|$)", "-->").getRegex(), Et = c("^comment|^</[a-zA-Z][a-zA-Z0-9-]*\\s*>|^<[a-zA-Z][a-zA-Z0-9-]*(?:attribute)*?\\s*/?>|^<\\?[\\s\\S]*?\\?>|^<![a-zA-Z]+\\s[\\s\\S]*?>|^<!\\[CDATA\\[[\\s\\S]*?\\]\\]>").replace("comment", At).replace("attribute", /\s+[a-zA-Z:_][\w.:-]*(?:\s*=\s*"[^"]*"|\s*=\s*'[^']*'|\s*=\s*[^\s"'=<>`]+)?/).getRegex(), Ce = /\[(?:\\[\s\S]|[^\[\]\\])*\]/, re = c(/(?:\[(?:brackets|\\[\s\S]|[^\[\]\\])*\]|\\[\s\S]|`+(?!`)[^`]*?`+(?!`)|``+(?=\])|[^\[\]\\`])*?/).replace("brackets", Ce).getRegex(), zt = c(/^!?\[(label)\]\([ \t\n]*(href)(?:(?:[ \t]+(?:\n[ \t]*)?|\n[ \t]*)(title))?[ \t\n]*\)/).replace("label", re).replace("href", /<(?:\\.|[^\n<>\\])+>|[^ \t\n\x00-\x1f]+|(?=\))/).replace("title", /"(?:\\[\s\S]|[^"\\])*"|'(?:\\[\s\S]|[^'\\])*'|\((?:\\[\s\S]|[^)\\])*\)/).getRegex(), Mt = c(/^!?\[(label)\]\[(ref)\]/).replace("label", re).replace("ref", ue).getRegex(), Dt = c(/^!?\[(ref)\](?:\[\])?/).replace("ref", ue).getRegex(), Re = /(?!\s*\])(?:\\[\s\S]|[^\[\]\\]){1,999}/, Bt = c(/(?:[^\[\]\\`]*(?:\[(?:brackets|\\[\s\S]|[^\[\]\\])*\]|\\[\s\S]|`+(?!`)[^`]*?`+(?!`)|``+(?=\]))){0,999}?[^\[\]\\`]*?/).replace("brackets", Ce).getRegex(), qt = c("reflink|nolink(?!\\()", "g").replace("reflink", c(/^!?\[(label)\]\[(ref)\]/).replace("label", Bt).replace("ref", Re).getRegex()).replace("nolink", c(/^!?\[(ref)\](?:\[\])?/).replace("ref", Re).getRegex()).getRegex(), Te = /[hH][tT][tT][pP][sS]?|[fF][tT][pP]/, vt = /[A-Za-z0-9._+-]+@[a-zA-Z0-9-_]+(?:\.[a-zA-Z0-9-_]*[a-zA-Z0-9])+(?![\w-])/, Zt = c(/(?:mailto:email|xmpp:email(?:\/[A-Za-z0-9@.]+)?)/).replace(/email/g, vt).getRegex(), he = {
        _backpedal: q,
        anyPunctuation: Lt,
        anyPunctuationOutsideCode: Ct,
        autolink: It,
        blockSkip: gt,
        br: ye,
        code: lt,
        del: q,
        delLDelim: q,
        delRDelim: q,
        emStrongLDelim: kt,
        emStrongRDelimAst: bt,
        emStrongRDelimUnd: wt,
        escape: at,
        link: zt,
        nolink: Dt,
        punctuation: pt,
        reflink: Mt,
        reflinkSearch: qt,
        tag: Et,
        text: ut,
        url: q
    }, Ht = {
        ...he,
        emStrongLDelim: xt,
        emStrongRDelimAst: Ot,
        emStrongRDelimUnd: St,
        link: c(/^!?\[(label)\]\((.*?)\)/).replace("label", re).getRegex(),
        reflink: c(/^!?\[(label)\]\s*\[([^\]]*)\]/).replace("label", re).getRegex()
    }, oe = {
        ...he,
        emStrongRDelimAst: Rt,
        emStrongLDelim: ft,
        delLDelim: yt,
        delRDelim: $t,
        url: c(/^emailProtocol|^((?:protocol):\/\/|www\.)(?:[a-zA-Z0-9\-]+\.?)+[^\s<]*|^email/).replace("emailProtocol", Zt).replace("protocol", Te).replace("email", /[A-Za-z0-9._+-]+(@)[a-zA-Z0-9-_]+(?:\.[a-zA-Z0-9-_]*[a-zA-Z0-9])+(?![\w-])/).getRegex(),
        _backpedal: /(?:[^?!.,:;*_'"~()&]+|\([^)]*\)|&(?![a-zA-Z0-9]+;$)|[?!.,:;*_'"~)]+(?!$))+/,
        del: /^(~~?)(?=[^\s~])((?:\\[\s\S]|[^\\])*?(?:\\[\s\S]|[^\s~\\]))\1(?=[^~]|$)/,
        text: c(/^(?:[^a-zA-Z0-9](?=emailProtocol)|(`+|~+|[^`~])(?:(?=[`~])|(?= {2,}\n)|(?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@)|[\s\S]*?(?:(?=[\\<!\[`*~_]|\b_|protocol:\/\/|wwwStart|$)|[^ ](?= {2,}\n)|[^a-zA-Z0-9](?=emailProtocol)|[^a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-](?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@))))/).replace("protocol", Te).replace(/emailProtocol/g, /(?:mailto|xmpp):/).replace("wwwStart", Oe ? "(?<![^\\s*_~(])www\\." : "www\\.").getRegex()
    }, jt = {
        ...oe,
        br: c(ye).replace("{2,}", "*").getRegex(),
        text: c(oe.text).replace("\\b_", "\\b_| {2,}\\n").replace(/\{2,\}/g, "*").getRegex()
    }, J = {
        normal: ce,
        gfm: it,
        pedantic: ot
    }, G = {
        normal: he,
        gfm: oe,
        breaks: jt,
        pedantic: Ht
    };
    var Gt = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;"
    }, Ie = (a)=>Gt[a];
    function S(a, e) {
        if (e) {
            if (T.escapeTest.test(a)) return a.replace(T.escapeReplace, Ie);
        } else if (T.escapeTestNoEncode.test(a)) return a.replace(T.escapeReplaceNoEncode, Ie);
        return a;
    }
    function Ae(a) {
        return T.numericCharacterReference.test(a) ? a.replace(T.numericCharacterReferenceOrAmpersand, (e, t, n)=>{
            if (t === void 0 && n === void 0) return "&amp;";
            let s = t === void 0 ? Number.parseInt(n, 16) : Number.parseInt(t, 10);
            return s === 0 || s > 1114111 || s >= 55296 && s <= 57343 ? "\uFFFD" : s === 38 ? "&amp;" : String.fromCodePoint(s);
        }) : a;
    }
    function de(a) {
        try {
            a = encodeURI(a).replace(T.percentDecode, "%");
        } catch  {
            return null;
        }
        return a;
    }
    function ge(a, e) {
        let t = a.replace(T.findPipe, (r, o, i)=>{
            let l = !1, p = o;
            for(; --p >= 0 && i[p] === "\\";)l = !l;
            return l ? "|" : " |";
        }), n = t.split(T.splitPipe), s = 0;
        if (n[0].trim() || n.shift(), n.length > 0 && !n.at(-1)?.trim() && n.pop(), e) {
            if (n.length > e) n.splice(e);
            else for(; n.length < e;)n.push("");
        }
        for(; s < n.length; s++)n[s] = n[s].trim().replace(T.slashPipe, "|");
        return n;
    }
    function I(a, e, t) {
        let n = a.length;
        if (n === 0) return "";
        let s = 0;
        for(; s < n;){
            let r = a.charAt(n - s - 1);
            if (r === e && !t) s++;
            else if (r !== e && t) s++;
            else break;
        }
        return a.slice(0, n - s);
    }
    function ke(a) {
        let e = a.split(`
`), t = e.length - 1;
        for(; t >= 0 && T.blankLine.test(e[t]);)t--;
        return e.length - t <= 2 ? a : e.slice(0, t + 1).join(`
`);
    }
    function F(a) {
        return a.trim().replace(T.multipleSpaceGlobal, " ").toLowerCase().toUpperCase().toLowerCase();
    }
    function fe(a, e) {
        if (a.indexOf(e[0]) === -1 && a.indexOf(e[1]) === -1) return -1;
        let t = 0;
        for(let n = 0; n < a.length; n++)if (a[n] === "\\") n++;
        else if (a[n] === e[0]) t++;
        else if (a[n] === e[1] && (t--, t < 0)) return n;
        return t > 0 ? -2 : -1;
    }
    var N = new WeakMap;
    function me(a) {
        let e = {
            "*": -1,
            _: -1
        }, t = -1, n = a.length;
        for(let s = 0; s < n; s++){
            let r = a[s];
            if (r !== "*" && r !== "_" && r !== "~") continue;
            let o = s === 0 ? `
` : a[s - 1], i = s + 1;
            for(; i < n && a[i] === r;)i++;
            o !== " " && o !== "	" && o !== `
` && o !== "\r" && o !== "\f" && (r === "~" ? t = s : e[r] = s), s = i - 1;
        }
        return {
            maskedSrc: a,
            lastPossibleEmStrongCloserIndex: e,
            lastPossibleDelCloserIndex: t
        };
    }
    function Ee(a, e) {
        let t = me(e), n = N.get(a);
        n ? n.push(t) : N.set(a, [
            t
        ]);
    }
    function ze(a) {
        let e = N.get(a);
        e && (e.pop(), e.length === 0 && N.delete(a));
    }
    function Me(a, e, t) {
        let n = N.get(a)?.at(-1);
        return n && n.maskedSrc === e ? n.lastPossibleEmStrongCloserIndex[t] : me(e).lastPossibleEmStrongCloserIndex[t];
    }
    function De(a, e) {
        let t = N.get(a)?.at(-1);
        return t && t.maskedSrc === e ? t.lastPossibleDelCloserIndex : me(e).lastPossibleDelCloserIndex;
    }
    function Y(a, e = 0) {
        let t = e, n = "";
        for (let s of a)if (s === "	") {
            let r = 4 - t % 4;
            n += " ".repeat(r), t += r;
        } else n += s, t++;
        return n;
    }
    function Be(a, e, t, n, s) {
        let r = e.href, o = e.title || null, i = a[1].replace(s.other.outputLinkReplace, "$1"), l = a[0].charAt(0) === "!", p = n.state.inLink, h = n.state.linkEmitted, u = n.state.inRawBlock;
        n.state.inLink = !0, n.state.linkEmitted = !1;
        let d = n.inlineTokens(i), k = n.state.linkEmitted;
        if (n.state.linkEmitted = h, n.state.inLink = p, !l) {
            if (k) {
                n.state.inRawBlock = u;
                return;
            }
            n.state.linkEmitted = !0;
        }
        return {
            type: l ? "image" : "link",
            raw: t,
            href: r,
            title: o,
            text: i,
            tokens: d
        };
    }
    function Nt(a, e, t) {
        let n = a.match(t.other.indentCodeCompensation);
        if (n === null) return e;
        let s = n[1];
        return e.split(`
`).map((r)=>{
            let o = r.match(t.other.beginningSpace);
            if (o === null) return r;
            let [i] = o;
            return r.slice(Math.min(i.length, s.length));
        }).join(`
`);
    }
    function qe(a, e, t, n) {
        if (!e.includes("<")) return !1;
        for(let s = 0; s < e.length; s++){
            if (e[s] === "\\") {
                s++;
                continue;
            }
            if (e[s] === "`") {
                let i = n.inline.code.exec(e.slice(s));
                if (i) {
                    s += i[0].length - 1;
                    continue;
                }
            }
            if (e[s] !== "<") continue;
            let r = a.slice(t + s), o = n.inline.tag.exec(r) || n.inline.autolink.exec(r);
            if (o) {
                if (o[0].length > e.length - s) return !0;
                s += o[0].length - 1;
            }
        }
        return !1;
    }
    var _ = class {
        options;
        rules;
        lexer;
        constructor(e){
            this.options = e || P;
        }
        space(e) {
            let t = this.rules.block.newline.exec(e);
            if (t && t[0].length > 0) return {
                type: "space",
                raw: t[0]
            };
        }
        code(e) {
            let t = this.rules.block.code.exec(e);
            if (t) {
                let n = this.options.pedantic ? t[0] : ke(t[0]), s = n.replace(this.rules.other.codeRemoveIndent, "");
                return {
                    type: "code",
                    raw: n,
                    codeBlockStyle: "indented",
                    text: s
                };
            }
        }
        fences(e) {
            let t = this.rules.block.fences.exec(e);
            if (t) {
                let n = t[0], s = Nt(n, t[3] || "", this.rules);
                return {
                    type: "code",
                    raw: n,
                    lang: t[2] ? t[2].trim().replace(this.rules.inline.anyPunctuation, "$1") : t[2],
                    text: s
                };
            }
        }
        heading(e) {
            let t = this.rules.block.heading.exec(e);
            if (t) {
                let n = t[2].trim();
                if (this.rules.other.endingHash.test(n)) {
                    let s = I(n, "#");
                    (this.options.pedantic || !s || this.rules.other.endingSpaceTabChar.test(s)) && (n = s.trim());
                }
                return {
                    type: "heading",
                    raw: I(t[0], `
`),
                    depth: t[1].length,
                    text: n,
                    tokens: this.lexer.inline(n)
                };
            }
        }
        hr(e) {
            let t = this.rules.block.hr.exec(e);
            if (t) return {
                type: "hr",
                raw: I(t[0], `
`)
            };
        }
        blockquote(e) {
            let t = this.rules.block.blockquote.exec(e);
            if (t) {
                let n = I(t[0], `
`).split(`
`), s = "", r = "", o = [];
                for(; n.length > 0;){
                    let i = !1, l = [], p;
                    for(p = 0; p < n.length; p++)if (this.rules.other.blockquoteStart.test(n[p])) l.push(n[p]), i = !0;
                    else if (!i) l.push(n[p]);
                    else break;
                    n = n.slice(p);
                    let h = l.join(`
`), u = h.replace(this.rules.other.blockquoteMarkerWhitespace, (g, b, x)=>b + Y(x, b.length)).replace(this.rules.other.blockquoteSetextReplace, `
    $1`).replace(this.rules.other.blockquoteSetextReplace2, "");
                    s = s ? `${s}
${h}` : h, r = r ? `${r}
${u}` : u;
                    let d = this.lexer.state.top;
                    if (this.lexer.state.top = !0, this.lexer.blockTokens(u, o, !0), this.lexer.state.top = d, n.length === 0) break;
                    let k = o.at(-1);
                    if (k?.type === "code" || k?.type === "heading" || k?.type === "hr" || k?.type === "html" || k?.type === "table") break;
                    if (k?.type === "blockquote") {
                        let g = k, b = n.join(`
`), x = g.raw + `
` + b.replace(this.rules.other.blockquoteSetextReplace2, ""), f = this.blockquote(x);
                        o[o.length - 1] = f;
                        let y = x.substring(f.raw.length).replace(/^\n/, ""), R = y ? y.split(`
`).length : 0, E = R ? n.slice(0, -R) : n;
                        if (E.length > 0 && (s = `${s}
${E.join(`
`)}`), r = r.substring(0, r.length - g.text.length) + f.text, n = n.slice(E.length), n.length > 0 && this.rules.other.blockquoteStart.test(n[0])) continue;
                        break;
                    } else if (k?.type === "list") {
                        let g = k, b = g.raw + `
` + n.join(`
`), x = this.list(b);
                        o[o.length - 1] = x;
                        let f = x.raw.length > g.raw.length ? b.slice(g.raw.length + 1, x.raw.length).split(`
`).length : 0;
                        if (f > 0) {
                            let y = n.slice(0, f).join(`
`);
                            s = `${s}
${y}`, r = `${r}
${y}`;
                        }
                        n = n.slice(f);
                        continue;
                    }
                }
                return {
                    type: "blockquote",
                    raw: s,
                    tokens: o,
                    text: r
                };
            }
        }
        list(e) {
            let t = this.rules.block.list.exec(e);
            if (t) {
                let n = e, s = ()=>n.length - e.length, r = t[1].trim(), o = r.length > 1, i = {
                    type: "list",
                    raw: "",
                    ordered: o,
                    start: o ? +r.slice(0, -1) : "",
                    loose: !1,
                    items: []
                };
                r = o ? `\\d{1,9}\\${r.slice(-1)}` : `\\${r}`, this.options.pedantic && (r = o ? r : "[*+-]");
                let l = this.rules.other.listItemRegex(r), p = !1;
                for(; e;){
                    let u = !1, d = "";
                    if (!(t = l.exec(e)) || this.rules.block.hr.test(e)) break;
                    let k = s();
                    e = e.substring(t[0].length);
                    let g = t[2].split(`
`, 1)[0], b = t[1].length, x = this.options.pedantic ? Y(g, b) : g.replace(this.rules.other.leadingSpaceTab, (Z)=>Y(Z, b)), f = e.split(`
`, 1)[0], y = !x.trim(), R = 0;
                    if (this.options.pedantic ? (R = 2, d = x.trimStart()) : y ? R = b + 1 : (R = x.search(this.rules.other.nonSpaceChar), R = R > 4 ? 1 : R, d = x.slice(R), R += b), y && this.rules.other.blankLine.test(f) && (e = e.substring(f.length + 1), u = !0), !u) {
                        let Z = this.rules.other.nextBulletRegex(R), U = this.rules.other.hrRegex(R), ee = this.rules.other.fencesBeginRegex(R), te = this.options.pedantic ? this.rules.other.pedanticHeadingBeginRegex(R) : this.rules.other.headingBeginRegex(R), M = this.rules.other.htmlBeginRegex(R), ne = this.rules.other.blockquoteBeginRegex(R);
                        for(; e;){
                            let W = e.split(`
`, 1)[0], H;
                            if (f = W, this.options.pedantic ? (f = f.replace(this.rules.other.listReplaceNesting, "  "), H = f) : H = f.replace(this.rules.other.leadingSpaceTab, (xe)=>Y(xe)), ee.test(f) || te.test(f) || M.test(f) || ne.test(f) || Z.test(f) || U.test(f)) break;
                            if (H.search(this.rules.other.nonSpaceChar) >= R || !f.trim()) d += `
` + H.slice(R);
                            else {
                                if (y || x.replace(this.rules.other.tabCharGlobal, "    ").search(this.rules.other.nonSpaceChar) >= 4 || ee.test(x) || te.test(x) || M.test(x) || U.test(x)) break;
                                let Ze = !this.options.pedantic && /^ {0,3}(?:=+|-+) *$/.test(f) && this.rules.block.lheading.test(`${x}
${f}`) ? `    ${H.replace(/^ {0,3}/, "")}` : f;
                                d += `
` + Ze;
                            }
                            y = !f.trim(), e = e.substring(W.length + 1), x = H.slice(R);
                        }
                    }
                    let E = n.slice(k, s());
                    i.loose || (p ? i.loose = !0 : this.rules.other.doubleBlankLine.test(E) && (p = !0)), i.items.push({
                        type: "list_item",
                        raw: E,
                        task: !!this.options.gfm && this.rules.other.listIsTask.test(d),
                        loose: !1,
                        text: d,
                        tokens: []
                    });
                }
                let h = i.items.at(-1);
                if (h) h.raw = h.raw.trimEnd(), h.text = h.text.trimEnd();
                else return;
                i.raw = n.slice(0, s()).trimEnd();
                for (let u of i.items)if (this.lexer.state.top = !1, u.tokens = this.lexer.blockTokens(u.text, []), !i.loose) {
                    let d = u.tokens.filter((g)=>g.type === "space"), k = d.length > 0 && d.some((g)=>this.rules.other.anyLine.test(g.raw));
                    i.loose = k;
                }
                for (let u of i.items){
                    let d = u.tokens[0];
                    if (u.task && (d?.type === "text" || d?.type === "paragraph")) {
                        u.text = u.text.replace(this.rules.other.listReplaceTask, ""), d.raw = d.raw.replace(this.rules.other.listReplaceTask, ""), d.text = d.text.replace(this.rules.other.listReplaceTask, "");
                        for(let g = this.lexer.inlineQueue.length - 1; g >= 0; g--)if (this.rules.other.listIsTask.test(this.lexer.inlineQueue[g].src)) {
                            this.lexer.inlineQueue[g].src = this.lexer.inlineQueue[g].src.replace(this.rules.other.listReplaceTask, "");
                            break;
                        }
                        let k = this.rules.other.listTaskCheckbox.exec(u.raw);
                        if (k) {
                            let g = {
                                type: "checkbox",
                                raw: k[0] + " ",
                                checked: k[0] !== "[ ]"
                            };
                            u.checked = g.checked, i.loose ? u.tokens[0] && [
                                "paragraph",
                                "text"
                            ].includes(u.tokens[0].type) && "tokens" in u.tokens[0] && u.tokens[0].tokens ? (u.tokens[0].raw = g.raw + u.tokens[0].raw, u.tokens[0].text = g.raw + u.tokens[0].text, u.tokens[0].tokens.unshift(g)) : u.tokens.unshift({
                                type: "paragraph",
                                raw: g.raw,
                                text: g.raw,
                                tokens: [
                                    g
                                ]
                            }) : u.tokens.unshift(g);
                        }
                    } else u.task && (u.task = !1);
                }
                if (i.loose) for (let u of i.items){
                    u.loose = !0;
                    for (let d of u.tokens)d.type === "text" && (d.type = "paragraph");
                }
                return i;
            }
        }
        html(e) {
            let t = this.rules.block.html.exec(e);
            if (t) {
                let n = ke(t[0]);
                return {
                    type: "html",
                    block: !0,
                    raw: n,
                    pre: t[1] === "pre" || t[1] === "script" || t[1] === "style",
                    text: n
                };
            }
        }
        def(e) {
            let t = this.rules.block.def.exec(e);
            if (t) {
                if (!this.rules.other.startAngleBracket.test(t[2]) && fe(t[2], "()") !== -1) return;
                let n = F(t[1]), s = t[2] ? t[2].replace(this.rules.other.hrefBrackets, "$1").replace(this.rules.inline.anyPunctuation, "$1") : "", r = t[3] ? t[3].substring(1, t[3].length - 1).replace(this.rules.inline.anyPunctuation, "$1") : t[3];
                return {
                    type: "def",
                    tag: n,
                    raw: I(t[0], `
`),
                    href: s,
                    title: r
                };
            }
        }
        table(e) {
            let t = this.rules.block.table.exec(e);
            if (!t || !this.rules.other.tableDelimiter.test(t[2])) return;
            let n = ge(t[1]), s = t[2].replace(this.rules.other.tableAlignChars, "").split("|"), r = t[3]?.trim() ? t[3].replace(this.rules.other.tableRowBlankLine, "").split(`
`) : [], o = {
                type: "table",
                raw: I(t[0], `
`),
                header: [],
                align: [],
                rows: []
            };
            if (n.length === s.length) {
                for (let i of s)this.rules.other.tableAlignRight.test(i) ? o.align.push("right") : this.rules.other.tableAlignCenter.test(i) ? o.align.push("center") : this.rules.other.tableAlignLeft.test(i) ? o.align.push("left") : o.align.push(null);
                for(let i = 0; i < n.length; i++)o.header.push({
                    text: n[i],
                    tokens: this.lexer.inline(n[i]),
                    header: !0,
                    align: o.align[i]
                });
                for (let i of r)o.rows.push(ge(i, o.header.length).map((l, p)=>({
                        text: l,
                        tokens: this.lexer.inline(l),
                        header: !1,
                        align: o.align[p]
                    })));
                return o;
            }
        }
        lheading(e) {
            let t = this.rules.block.lheading.exec(e);
            if (t) {
                let n = t[1].trim();
                return {
                    type: "heading",
                    raw: I(t[0], `
`),
                    depth: t[2].charAt(0) === "=" ? 1 : 2,
                    text: n,
                    tokens: this.lexer.inline(n)
                };
            }
        }
        paragraph(e) {
            let t = this.rules.block.paragraph.exec(e);
            if (t) {
                let n = t[1].charAt(t[1].length - 1) === `
` ? t[1].slice(0, -1) : t[1];
                return {
                    type: "paragraph",
                    raw: t[0],
                    text: n,
                    tokens: this.lexer.inline(n)
                };
            }
        }
        text(e) {
            let t = this.rules.block.text.exec(e);
            if (t) return {
                type: "text",
                raw: t[0],
                text: t[0],
                tokens: this.lexer.inline(t[0])
            };
        }
        escape(e) {
            let t = this.rules.inline.escape.exec(e);
            if (t) return {
                type: "escape",
                raw: t[0],
                text: t[1]
            };
        }
        tag(e) {
            let t = this.rules.inline.tag.exec(e);
            if (t) return !this.lexer.state.inLink && this.rules.other.startATag.test(t[0]) ? this.lexer.state.inLink = !0 : this.lexer.state.inLink && this.rules.other.endATag.test(t[0]) && (this.lexer.state.inLink = !1), !this.lexer.state.inRawBlock && this.rules.other.startPreScriptTag.test(t[0]) ? this.lexer.state.inRawBlock = !0 : this.lexer.state.inRawBlock && this.rules.other.endPreScriptTag.test(t[0]) && (this.lexer.state.inRawBlock = !1), {
                type: "html",
                raw: t[0],
                inLink: this.lexer.state.inLink,
                inRawBlock: this.lexer.state.inRawBlock,
                block: !1,
                text: t[0]
            };
        }
        link(e) {
            if (this.lexer.state.linkParenPossible === !1) return;
            let t = this.rules.inline.link.exec(e);
            if (t) {
                let n = t[0].charAt(0) === "!" ? 2 : 1;
                if (!this.options.pedantic && qe(e, t[1], n, this.rules)) return;
                let s = t[2].trim();
                if (!this.options.pedantic && this.rules.other.startAngleBracket.test(s)) {
                    if (!this.rules.other.endAngleBracket.test(s)) return;
                    let l = I(s.slice(0, -1), "\\");
                    if ((s.length - l.length) % 2 === 0) return;
                } else {
                    let l = fe(t[2], "()");
                    if (l === -2) return;
                    if (l > -1) {
                        let h = (t[0].indexOf("!") === 0 ? 5 : 4) + t[1].length + l;
                        t[2] = t[2].substring(0, l), t[0] = t[0].substring(0, h).trim(), t[3] = "";
                    }
                }
                let r = I(t[0].slice(0, -1), "\\");
                if ((t[0].length - r.length) % 2 === 0) return;
                let o = t[2], i = "";
                if (this.options.pedantic) {
                    let l = this.rules.other.pedanticHrefTitle.exec(o);
                    l && (o = l[1], i = l[3]);
                } else i = t[3] ? t[3].slice(1, -1) : "";
                return o = o.trim(), this.rules.other.startAngleBracket.test(o) && (this.options.pedantic && !this.rules.other.endAngleBracket.test(s) ? o = o.slice(1) : o = o.slice(1, -1)), Be(t, {
                    href: o && o.replace(this.rules.inline.anyPunctuation, "$1"),
                    title: i && i.replace(this.rules.inline.anyPunctuation, "$1")
                }, t[0], this.lexer, this.rules);
            }
        }
        reflink(e, t) {
            let n;
            if ((n = this.rules.inline.reflink.exec(e)) || (n = this.rules.inline.nolink.exec(e))) {
                let s = n[0].charAt(0) === "!" ? 2 : 1;
                if (!this.options.pedantic && qe(e, n[1], s, this.rules)) return;
                let r = t[F(n[2] || n[1])];
                if (!r) {
                    let o = n[0].charAt(0);
                    return {
                        type: "text",
                        raw: o,
                        text: o
                    };
                }
                return Be(n, r, n[0], this.lexer, this.rules);
            }
        }
        emStrong(e, t, n = "") {
            let s = this.rules.inline.emStrongLDelim.exec(e);
            if (!s || !s[1] && !s[2] && !s[3] && !s[4]) return;
            let r = s[0][0], o = n === r, i = t.length - e.length, l = i;
            for(; !this.options.pedantic && l > 0 && t[l - 1] === r;)l--;
            let p = [
                ...t.slice(Math.max(0, l - 2), l)
            ].at(-1) ?? "", h = p === "*" || p === "_" || !!this.rules.inline.punctuation.exec(p);
            l < i && (n = p);
            let u = l < i ? h : !!this.rules.inline.punctuation.exec(n);
            if (s[4] && n.match(this.rules.other.unicodeAlphaNumeric)) return;
            let d = s[1] || s[3] || "";
            if (!d || !n || u) {
                let k = [
                    ...s[0]
                ].length - 1, g, b, x = k, f = 0, y = i - l + k, R = !this.options.pedantic && !!p.trim() && (!!d || r === "*" && !h);
                if (r !== "*" && r !== "_") return;
                let E = r === "*" ? this.rules.inline.emStrongRDelimAst : this.rules.inline.emStrongRDelimUnd, Z = Me(this, t, r), U = t.length - e.length + k;
                if (Z < U) return;
                t = t.slice(-1 * e.length + k);
                let ee = Z - U;
                for(E.lastIndex = 0; (s = E.exec(t)) !== null && !(s.index > ee);){
                    if (g = s[1] || s[2] || s[3] || s[4] || s[5] || s[6], !g) continue;
                    if (b = [
                        ...g
                    ].length, s[3] || s[4]) {
                        x += b;
                        continue;
                    } else if (s[5] || s[6] || R) {
                        if (o && (s[5] || s[6])) break;
                        if (y % 3 && !((y + b) % 3)) {
                            f += b;
                            continue;
                        }
                    }
                    if (x -= b, x > 0) continue;
                    b = Math.min(b, b + x + f);
                    let te = [
                        ...s[0]
                    ][0].length, M = e.slice(0, k + s.index + te + b);
                    if (Math.min(k, b) % 2) {
                        let W = M.slice(1, -1);
                        return {
                            type: "em",
                            raw: M,
                            text: W,
                            tokens: this.lexer.inlineTokens(W)
                        };
                    }
                    let ne = M.slice(2, -2);
                    return {
                        type: "strong",
                        raw: M,
                        text: ne,
                        tokens: this.lexer.inlineTokens(ne)
                    };
                }
            }
        }
        codespan(e) {
            let t = this.rules.inline.code.exec(e);
            if (t) {
                let n = t[2].replace(this.rules.other.newLineCharGlobal, " "), s = this.rules.other.nonSpaceChar.test(n), r = this.rules.other.startingSpaceChar.test(n) && this.rules.other.endingSpaceChar.test(n);
                return s && r && (n = n.substring(1, n.length - 1)), {
                    type: "codespan",
                    raw: t[0],
                    text: n
                };
            }
        }
        br(e) {
            let t = this.rules.inline.br.exec(e);
            if (t) return {
                type: "br",
                raw: t[0]
            };
        }
        del(e, t, n = "") {
            let s = this.rules.inline.delLDelim.exec(e);
            if (!s) return;
            if (!(s[1] || "") || !n || this.rules.inline.punctuation.exec(n)) {
                let o = [
                    ...s[0]
                ].length - 1, i, l, p = o, h = this.rules.inline.delRDelim, u = De(this, t), d = t.length - e.length + o;
                if (u < d) return;
                t = t.slice(-1 * e.length + o);
                let k = u - d;
                for(h.lastIndex = 0; (s = h.exec(t)) !== null && !(s.index > k);){
                    if (i = s[1] || s[2] || s[3] || s[4] || s[5] || s[6], !i || (l = [
                        ...i
                    ].length, l !== o)) continue;
                    if (s[3] || s[4]) {
                        p += l;
                        continue;
                    }
                    if (p -= l, p > 0) continue;
                    l = Math.min(l, l + p);
                    let g = [
                        ...s[0]
                    ][0].length, b = e.slice(0, o + s.index + g + l), x = b.slice(o, -o);
                    return {
                        type: "del",
                        raw: b,
                        text: x,
                        tokens: this.lexer.inlineTokens(x)
                    };
                }
            }
        }
        autolink(e) {
            let t = this.rules.inline.autolink.exec(e);
            if (t) {
                let n, s;
                return t[2] === "@" ? (n = t[1], s = "mailto:" + n) : (n = t[1], s = n), {
                    type: "link",
                    raw: t[0],
                    text: n,
                    href: s,
                    autolink: !0,
                    tokens: [
                        {
                            type: "text",
                            raw: n,
                            text: n
                        }
                    ]
                };
            }
        }
        url(e) {
            let t;
            if (t = this.rules.inline.url.exec(e)) {
                let n, s;
                if (t[2] === "@") n = t[0], s = "mailto:" + n;
                else {
                    let r;
                    do r = t[0], t[0] = this.rules.inline._backpedal.exec(t[0])?.[0] ?? "";
                    while (r !== t[0]);
                    n = t[0], t[1] === "www." ? s = "http://" + t[0] : s = t[0];
                }
                return {
                    type: "link",
                    raw: t[0],
                    text: n,
                    href: s,
                    autolink: !0,
                    tokens: [
                        {
                            type: "text",
                            raw: n,
                            text: n
                        }
                    ]
                };
            }
        }
        inlineText(e) {
            let t = this.rules.inline.text.exec(e);
            if (t) {
                let n = this.lexer.state.inRawBlock;
                return {
                    type: "text",
                    raw: t[0],
                    text: n ? t[0] : Ae(t[0]),
                    escaped: n
                };
            }
        }
    };
    var O = class a {
        tokens;
        options;
        state;
        inlineQueue;
        tokenizer;
        constructor(e){
            this.tokens = [], this.tokens.links = Object.create(null), this.options = e || P, this.options.tokenizer = this.options.tokenizer || new _, this.tokenizer = this.options.tokenizer, this.tokenizer.options = this.options, this.tokenizer.lexer = this, this.inlineQueue = [], this.state = {
                inLink: !1,
                inRawBlock: !1,
                linkEmitted: !1,
                linkParenPossible: !0,
                top: !0
            };
            let t = {
                other: T,
                block: J.normal,
                inline: G.normal
            };
            this.options.pedantic ? (t.block = J.pedantic, t.inline = G.pedantic) : this.options.gfm && (t.block = J.gfm, this.options.breaks ? t.inline = G.breaks : t.inline = G.gfm), this.tokenizer.rules = t;
        }
        static get rules() {
            return {
                block: J,
                inline: G
            };
        }
        static lex(e, t) {
            return new a(t).lex(e);
        }
        static lexInline(e, t) {
            return new a(t).inlineTokens(e);
        }
        lex(e) {
            e = e.replace(T.carriageReturn, `
`), this.blockTokens(e, this.tokens);
            for(let t = 0; t < this.inlineQueue.length; t++){
                let n = this.inlineQueue[t];
                this.state.inRawBlock = !1, this.inlineTokens(n.src, n.tokens);
            }
            return this.inlineQueue = [], this.tokens;
        }
        blockTokens(e, t = [], n = !1) {
            this.tokenizer.lexer = this, this.options.pedantic && (e = e.replace(T.tabCharGlobal, "    ").replace(T.spaceLine, ""));
            let s = 1 / 0;
            for(; e;){
                if (e.length < s) s = e.length;
                else {
                    this.infiniteLoopError(e.charCodeAt(0));
                    break;
                }
                let r;
                if (this.options.extensions?.block?.some((i)=>(r = i.call({
                        lexer: this
                    }, e, t)) ? (e = e.substring(r.raw.length), t.push(r), !0) : !1)) continue;
                if (r = this.tokenizer.space(e)) {
                    e = e.substring(r.raw.length);
                    let i = t.at(-1);
                    r.raw.length === 1 && i !== void 0 ? i.raw += `
` : t.push(r);
                    continue;
                }
                if (r = this.tokenizer.code(e)) {
                    e = e.substring(r.raw.length);
                    let i = t.at(-1);
                    i?.type === "paragraph" || i?.type === "text" ? (i.raw += (i.raw.endsWith(`
`) ? "" : `
`) + r.raw, i.text += `
` + r.text, this.inlineQueue.at(-1).src = i.text) : t.push(r);
                    continue;
                }
                if (r = this.tokenizer.fences(e)) {
                    e = e.substring(r.raw.length), t.push(r);
                    continue;
                }
                if (r = this.tokenizer.heading(e)) {
                    e = e.substring(r.raw.length), t.push(r);
                    continue;
                }
                if (r = this.tokenizer.hr(e)) {
                    e = e.substring(r.raw.length), t.push(r);
                    continue;
                }
                if (r = this.tokenizer.blockquote(e)) {
                    e = e.substring(r.raw.length), t.push(r);
                    continue;
                }
                if (r = this.tokenizer.list(e)) {
                    e = e.substring(r.raw.length), t.push(r);
                    continue;
                }
                if (r = this.tokenizer.html(e)) {
                    e = e.substring(r.raw.length), t.push(r);
                    continue;
                }
                if (r = this.tokenizer.def(e)) {
                    e = e.substring(r.raw.length);
                    let i = t.at(-1);
                    i?.type === "paragraph" || i?.type === "text" ? (i.raw += (i.raw.endsWith(`
`) ? "" : `
`) + r.raw, i.text += `
` + r.raw, this.inlineQueue.at(-1).src = i.text) : (this.tokens.links[r.tag] || (this.tokens.links[r.tag] = {
                        href: r.href,
                        title: r.title
                    }), t.push(r));
                    continue;
                }
                if (r = this.tokenizer.table(e)) {
                    e = e.substring(r.raw.length), t.push(r);
                    continue;
                }
                if (r = this.tokenizer.lheading(e)) {
                    e = e.substring(r.raw.length), t.push(r);
                    continue;
                }
                let o = e;
                if (this.options.extensions?.startBlock) {
                    let i = 1 / 0, l = e.slice(1), p;
                    this.options.extensions.startBlock.forEach((h)=>{
                        p = h.call({
                            lexer: this
                        }, l), typeof p == "number" && p >= 0 && (i = Math.min(i, p));
                    }), i < 1 / 0 && i >= 0 && (o = e.substring(0, i + 1));
                }
                if (this.state.top && (r = this.tokenizer.paragraph(o))) {
                    let i = t.at(-1);
                    n && i?.type === "paragraph" ? (i.raw += (i.raw.endsWith(`
`) ? "" : `
`) + r.raw, i.text += `
` + r.text, this.inlineQueue.pop(), this.inlineQueue.at(-1).src = i.text) : t.push(r), n = o.length !== e.length, e = e.substring(r.raw.length);
                    continue;
                }
                if (r = this.tokenizer.text(e)) {
                    e = e.substring(r.raw.length);
                    let i = t.at(-1);
                    i?.type === "text" ? (i.raw += (i.raw.endsWith(`
`) ? "" : `
`) + r.raw, i.text += `
` + r.text, this.inlineQueue.pop(), this.inlineQueue.at(-1).src = i.text) : t.push(r);
                    continue;
                }
                if (e) {
                    this.infiniteLoopError(e.charCodeAt(0));
                    break;
                }
            }
            return this.state.top = !0, t;
        }
        inline(e, t = []) {
            return this.inlineQueue.push({
                src: e,
                tokens: t
            }), t;
        }
        linkInText(e) {
            if (!e.includes("[")) return !1;
            let t = this.tokenizer.rules.inline.link;
            for (let n of e.matchAll(this.tokenizer.rules.inline.blockSkip))if (t.test(n[0]) && e.charAt(n.index - 1) !== "!") return !0;
            for (let n of e.matchAll(this.tokenizer.rules.inline.reflinkSearch)){
                let s = n[0], r = s.lastIndexOf("[");
                if (!(s.charAt(0) === "!" || !Object.hasOwn(this.tokens.links, F(s.slice(r + 1, -1)))) && !(r > 1 && this.linkInText(s.slice(1, r - 1)))) return !0;
            }
            return !1;
        }
        inlineTokens(e, t = []) {
            this.tokenizer.lexer = this;
            let n = this.state.linkParenPossible;
            this.state.linkParenPossible = n && e.includes(")");
            try {
                return this.#e(e, t);
            } finally{
                this.state.linkParenPossible = n;
            }
        }
        #e(e, t) {
            let n = e.includes("*") || e.includes("_") || e.includes("~") || this.options.hooks?.emStrongMask || this.tokenizer.emStrong !== _.prototype.emStrong || this.tokenizer.del !== _.prototype.del ? this.#n(e) : e;
            Ee(this.tokenizer, n);
            try {
                return this.#t(e, n, t);
            } finally{
                ze(this.tokenizer);
            }
        }
        #t(e, t, n) {
            let s = !1, r = "", o = 1 / 0;
            for(; e;){
                if (e.length < o) o = e.length;
                else {
                    this.infiniteLoopError(e.charCodeAt(0));
                    break;
                }
                s || (r = ""), s = !1;
                let i;
                if (this.options.extensions?.inline?.some((p)=>(i = p.call({
                        lexer: this
                    }, e, n)) ? (e = e.substring(i.raw.length), n.push(i), !0) : !1)) continue;
                if (i = this.tokenizer.escape(e)) {
                    e = e.substring(i.raw.length), n.push(i);
                    continue;
                }
                if (i = this.tokenizer.tag(e)) {
                    e = e.substring(i.raw.length), n.push(i);
                    continue;
                }
                if (i = this.tokenizer.link(e)) {
                    e = e.substring(i.raw.length), n.push(i);
                    continue;
                }
                if (i = this.tokenizer.reflink(e, this.tokens.links)) {
                    e = e.substring(i.raw.length);
                    let p = n.at(-1);
                    i.type === "text" && p?.type === "text" ? (p.raw += i.raw, p.text += i.text) : n.push(i);
                    continue;
                }
                if (i = this.tokenizer.emStrong(e, t, r)) {
                    e = e.substring(i.raw.length), n.push(i);
                    continue;
                }
                if (i = this.tokenizer.codespan(e)) {
                    e = e.substring(i.raw.length), n.push(i);
                    continue;
                }
                if (i = this.tokenizer.br(e)) {
                    e = e.substring(i.raw.length), n.push(i);
                    continue;
                }
                if (i = this.tokenizer.del(e, t, r)) {
                    e = e.substring(i.raw.length), n.push(i);
                    continue;
                }
                if (i = this.tokenizer.autolink(e)) {
                    e = e.substring(i.raw.length), n.push(i);
                    continue;
                }
                if (!this.state.inLink && (i = this.tokenizer.url(e))) {
                    e = e.substring(i.raw.length), n.push(i);
                    continue;
                }
                let l = e;
                if (this.options.extensions?.startInline) {
                    let p = 1 / 0, h = e.slice(1), u;
                    this.options.extensions.startInline.forEach((d)=>{
                        u = d.call({
                            lexer: this
                        }, h), typeof u == "number" && u >= 0 && (p = Math.min(p, u));
                    }), p < 1 / 0 && p >= 0 && (l = e.substring(0, p + 1));
                }
                if (i = this.tokenizer.inlineText(l)) {
                    e = e.substring(i.raw.length), i.raw.slice(-1) !== "_" && (r = i.raw.slice(-1)), s = !0;
                    let p = n.at(-1);
                    p?.type === "text" ? (p.raw += i.raw, p.text += i.text) : n.push(i);
                    continue;
                }
                if (e) {
                    this.infiniteLoopError(e.charCodeAt(0));
                    break;
                }
            }
            return n;
        }
        #n(e) {
            let t = e;
            if (this.tokens.links && e.includes("[")) {
                let n = this.tokenizer.rules.inline.reflinkSearch, s = (r)=>{
                    let o = r.lastIndexOf("[");
                    if (!Object.hasOwn(this.tokens.links, F(r.slice(o + 1, -1)))) return r;
                    if (o > 1 && r.charAt(0) !== "!") {
                        let i = r.slice(1, o - 1);
                        if (this.linkInText(i)) return "[" + i.replace(n, s) + "][" + "a".repeat(r.length - o - 2) + "]";
                    }
                    return "[" + "a".repeat(r.length - 2) + "]";
                };
                t = t.replace(n, s);
            }
            return t = t.replace(this.tokenizer.rules.inline.anyPunctuationOutsideCode, (n, s, r)=>r ? "+".repeat(n.length) : s ? s + n.slice(s.length, -s.length).replace(/`/g, "+") + s : n), t = t.replace(this.tokenizer.rules.inline.blockSkip, (n, s, r)=>{
                let o = r ? r.length : 0;
                return n.slice(0, o) + "[" + "a".repeat(n.length - o - 2) + "]";
            }), t = this.options.hooks?.emStrongMask?.call({
                lexer: this
            }, t) ?? t, t;
        }
        infiniteLoopError(e) {
            let t = "Infinite loop on byte: " + e;
            if (this.options.silent) console.error(t);
            else throw new Error(t);
        }
    };
    var $ = class {
        options;
        parser;
        constructor(e){
            this.options = e || P;
        }
        space(e) {
            return "";
        }
        code({ text: e, lang: t, escaped: n }) {
            let s = (t || "").match(T.notSpaceStart)?.[0], r = e ? e.replace(T.endingNewline, "") + `
` : "";
            return s ? '<pre><code class="language-' + S(s) + '">' + (n ? r : S(r, !0)) + `</code></pre>
` : "<pre><code>" + (n ? r : S(r, !0)) + `</code></pre>
`;
        }
        blockquote({ tokens: e }) {
            return `<blockquote>
${this.parser.parse(e)}</blockquote>
`;
        }
        html({ text: e }) {
            return e;
        }
        def(e) {
            return "";
        }
        heading({ tokens: e, depth: t }) {
            return `<h${t}>${this.parser.parseInline(e)}</h${t}>
`;
        }
        hr(e) {
            return `<hr>
`;
        }
        list(e) {
            let t = e.ordered, n = e.start, s = "";
            for(let i = 0; i < e.items.length; i++){
                let l = e.items[i];
                s += this.listitem(l);
            }
            let r = t ? "ol" : "ul", o = t && n !== 1 ? ' start="' + n + '"' : "";
            return "<" + r + o + `>
` + s + "</" + r + `>
`;
        }
        listitem(e) {
            return `<li>${this.parser.parse(e.tokens)}</li>
`;
        }
        checkbox({ checked: e }) {
            return "<input " + (e ? 'checked="" ' : "") + 'disabled="" type="checkbox"> ';
        }
        paragraph({ tokens: e }) {
            return `<p>${this.parser.parseInline(e)}</p>
`;
        }
        table(e) {
            let t = "", n = "";
            for(let r = 0; r < e.header.length; r++)n += this.tablecell(e.header[r]);
            t += this.tablerow({
                text: n
            });
            let s = "";
            for(let r = 0; r < e.rows.length; r++){
                let o = e.rows[r];
                n = "";
                for(let i = 0; i < o.length; i++)n += this.tablecell(o[i]);
                s += this.tablerow({
                    text: n
                });
            }
            return s && (s = `<tbody>${s}</tbody>`), `<table>
<thead>
` + t + `</thead>
` + s + `</table>
`;
        }
        tablerow({ text: e }) {
            return `<tr>
${e}</tr>
`;
        }
        tablecell(e) {
            let t = this.parser.parseInline(e.tokens), n = e.header ? "th" : "td";
            return (e.align ? `<${n} align="${e.align}">` : `<${n}>`) + t + `</${n}>
`;
        }
        strong({ tokens: e }) {
            return `<strong>${this.parser.parseInline(e)}</strong>`;
        }
        em({ tokens: e }) {
            return `<em>${this.parser.parseInline(e)}</em>`;
        }
        codespan({ text: e }) {
            return `<code>${S(e, !0)}</code>`;
        }
        br(e) {
            return "<br>";
        }
        del({ tokens: e }) {
            return `<del>${this.parser.parseInline(e)}</del>`;
        }
        link({ href: e, title: t, text: n, tokens: s, autolink: r }) {
            let o = r ? S(n, !0) : this.parser.parseInline(s), i = de(e);
            if (i === null) return o;
            e = S(i, r);
            let l = '<a href="' + e + '"';
            return t && (l += ' title="' + S(t) + '"'), l += ">" + o + "</a>", l;
        }
        image({ href: e, title: t, text: n, tokens: s }) {
            s && (n = this.parser.parseInline(s, this.parser.textRenderer));
            let r = de(e);
            if (r === null) return S(n);
            e = r;
            let o = `<img src="${S(e)}" alt="${S(n)}"`;
            return t && (o += ` title="${S(t)}"`), o += ">", o;
        }
        text(e) {
            return "tokens" in e && e.tokens ? this.parser.parseInline(e.tokens) : "escaped" in e && e.escaped ? e.text : S(e.text);
        }
    };
    var A = class {
        parser;
        strong({ text: e, tokens: t }) {
            return t ? this.parser.parseInline(t, this) : e;
        }
        em({ text: e, tokens: t }) {
            return t ? this.parser.parseInline(t, this) : e;
        }
        codespan({ text: e }) {
            return e;
        }
        del({ text: e, tokens: t }) {
            return t ? this.parser.parseInline(t, this) : e;
        }
        html({ text: e }) {
            return e;
        }
        text({ text: e }) {
            return e;
        }
        link({ text: e, tokens: t }) {
            return t ? this.parser.parseInline(t, this) : e;
        }
        image({ text: e, tokens: t }) {
            return t ? this.parser.parseInline(t, this) : e;
        }
        br() {
            return "";
        }
        checkbox({ raw: e }) {
            return e;
        }
    };
    var w = class a {
        options;
        renderer;
        textRenderer;
        constructor(e){
            this.options = e || P, this.options.renderer = this.options.renderer || new $, this.renderer = this.options.renderer, this.renderer.options = this.options, this.renderer.parser = this, this.textRenderer = new A, this.textRenderer.parser = this;
        }
        static parse(e, t) {
            return new a(t).parse(e);
        }
        static parseInline(e, t) {
            return new a(t).parseInline(e);
        }
        parse(e) {
            this.renderer.parser = this;
            let t = "";
            for(let n = 0; n < e.length; n++){
                let s = e[n];
                if (this.options.extensions?.renderers?.[s.type]) {
                    let o = s, i = this.options.extensions.renderers[o.type].call({
                        parser: this
                    }, o);
                    if (i !== !1 || ![
                        "space",
                        "hr",
                        "heading",
                        "code",
                        "table",
                        "blockquote",
                        "list",
                        "checkbox",
                        "html",
                        "def",
                        "paragraph",
                        "text"
                    ].includes(o.type)) {
                        t += i || "";
                        continue;
                    }
                }
                let r = s;
                switch(r.type){
                    case "space":
                        t += this.renderer.space(r);
                        break;
                    case "hr":
                        t += this.renderer.hr(r);
                        break;
                    case "heading":
                        t += this.renderer.heading(r);
                        break;
                    case "code":
                        t += this.renderer.code(r);
                        break;
                    case "table":
                        t += this.renderer.table(r);
                        break;
                    case "blockquote":
                        t += this.renderer.blockquote(r);
                        break;
                    case "list":
                        t += this.renderer.list(r);
                        break;
                    case "checkbox":
                        t += this.renderer.checkbox(r);
                        break;
                    case "html":
                        t += this.renderer.html(r);
                        break;
                    case "def":
                        t += this.renderer.def(r);
                        break;
                    case "paragraph":
                        t += this.renderer.paragraph(r);
                        break;
                    case "text":
                        t += this.renderer.text(r);
                        break;
                    default:
                        {
                            let o = 'Token with "' + r.type + '" type was not found.';
                            if (this.options.silent) return console.error(o), "";
                            throw new Error(o);
                        }
                }
            }
            return t;
        }
        parseInline(e, t = this.renderer) {
            this.renderer.parser = this;
            let n = "";
            for(let s = 0; s < e.length; s++){
                let r = e[s];
                if (this.options.extensions?.renderers?.[r.type]) {
                    let i = this.options.extensions.renderers[r.type].call({
                        parser: this
                    }, r);
                    if (i !== !1 || ![
                        "escape",
                        "html",
                        "link",
                        "image",
                        "checkbox",
                        "strong",
                        "em",
                        "codespan",
                        "br",
                        "del",
                        "text"
                    ].includes(r.type)) {
                        n += i || "";
                        continue;
                    }
                }
                let o = r;
                switch(o.type){
                    case "escape":
                        n += t.text(o);
                        break;
                    case "html":
                        n += t.html(o);
                        break;
                    case "link":
                        n += t.link(o);
                        break;
                    case "image":
                        n += t.image(o);
                        break;
                    case "checkbox":
                        n += t.checkbox(o);
                        break;
                    case "strong":
                        n += t.strong(o);
                        break;
                    case "em":
                        n += t.em(o);
                        break;
                    case "codespan":
                        n += t.codespan(o);
                        break;
                    case "br":
                        n += t.br(o);
                        break;
                    case "del":
                        n += t.del(o);
                        break;
                    case "text":
                        n += t.text(o);
                        break;
                    default:
                        {
                            let i = 'Token with "' + o.type + '" type was not found.';
                            if (this.options.silent) return console.error(i), "";
                            throw new Error(i);
                        }
                }
            }
            return n;
        }
    };
    var L = class {
        options;
        block;
        constructor(e){
            this.options = e || P;
        }
        static passThroughHooks = new Set([
            "preprocess",
            "postprocess",
            "processAllTokens",
            "emStrongMask"
        ]);
        static passThroughHooksRespectAsync = new Set([
            "preprocess",
            "postprocess",
            "processAllTokens"
        ]);
        preprocess(e) {
            return e;
        }
        postprocess(e) {
            return e;
        }
        processAllTokens(e) {
            return e;
        }
        emStrongMask(e) {
            return e;
        }
        provideLexer(e = this.block) {
            return e ? O.lex : O.lexInline;
        }
        provideParser(e = this.block) {
            return e ? w.parse : w.parseInline;
        }
    };
    function z(a, e) {
        if (Array.isArray(e)) for(let t = 0; t < e.length; t++)a.push(e[t]);
        else a.push(e);
    }
    var Q = class {
        defaults = D();
        options = this.setOptions;
        parse = this.parseMarkdown(!0);
        parseInline = this.parseMarkdown(!1);
        Parser = w;
        Renderer = $;
        TextRenderer = A;
        Lexer = O;
        Tokenizer = _;
        Hooks = L;
        constructor(...e){
            this.use(...e);
        }
        walkTokens(e, t) {
            let n = [];
            for (let s of e)switch(z(n, t.call(this, s)), s.type){
                case "table":
                    {
                        let r = s;
                        for (let o of r.header)z(n, this.walkTokens(o.tokens, t));
                        for (let o of r.rows)for (let i of o)z(n, this.walkTokens(i.tokens, t));
                        break;
                    }
                case "list":
                    {
                        let r = s;
                        z(n, this.walkTokens(r.items, t));
                        break;
                    }
                default:
                    {
                        let r = s;
                        this.defaults.extensions?.childTokens?.[r.type] ? this.defaults.extensions.childTokens[r.type].forEach((o)=>{
                            let i = r[o].flat(1 / 0);
                            z(n, this.walkTokens(i, t));
                        }) : r.tokens && z(n, this.walkTokens(r.tokens, t));
                    }
            }
            return n;
        }
        use(...e) {
            let t = this.defaults.extensions || {
                renderers: Object.create(null),
                childTokens: Object.create(null)
            };
            return e.forEach((n)=>{
                let s = {
                    ...n
                };
                if (s.async = this.defaults.async || s.async || !1, n.extensions && (n.extensions.forEach((r)=>{
                    if (!r.name) throw new Error("extension name required");
                    if ("renderer" in r) {
                        let o = t.renderers[r.name];
                        o ? t.renderers[r.name] = function(...i) {
                            let l = r.renderer.apply(this, i);
                            return l === !1 && (l = o.apply(this, i)), l;
                        } : t.renderers[r.name] = r.renderer;
                    }
                    if ("tokenizer" in r) {
                        if (!r.level || r.level !== "block" && r.level !== "inline") throw new Error("extension level must be 'block' or 'inline'");
                        let o = t[r.level];
                        o ? o.unshift(r.tokenizer) : t[r.level] = [
                            r.tokenizer
                        ], r.start && (r.level === "block" ? t.startBlock ? t.startBlock.push(r.start) : t.startBlock = [
                            r.start
                        ] : r.level === "inline" && (t.startInline ? t.startInline.push(r.start) : t.startInline = [
                            r.start
                        ]));
                    }
                    "childTokens" in r && r.childTokens && (t.childTokens[r.name] = r.childTokens);
                }), s.extensions = t), n.renderer) {
                    let r = this.defaults.renderer || new $(this.defaults);
                    for(let o in n.renderer){
                        if (!(o in r)) throw new Error(`renderer '${o}' does not exist`);
                        if ([
                            "options",
                            "parser"
                        ].includes(o)) continue;
                        let i = o, l = n.renderer[i], p = r[i];
                        r[i] = (...h)=>{
                            let u = l.apply(r, h);
                            return u === !1 && (u = p.apply(r, h)), u === !1 ? "" : u ?? "";
                        };
                    }
                    s.renderer = r;
                }
                if (n.tokenizer) {
                    let r = this.defaults.tokenizer || new _(this.defaults);
                    for(let o in n.tokenizer){
                        if (!(o in r)) throw new Error(`tokenizer '${o}' does not exist`);
                        if ([
                            "options",
                            "rules",
                            "lexer"
                        ].includes(o)) continue;
                        let i = o, l = n.tokenizer[i], p = r[i];
                        r[i] = (...h)=>{
                            let u = l.apply(r, h);
                            return u === !1 && (u = p.apply(r, h)), u;
                        };
                    }
                    s.tokenizer = r;
                }
                if (n.hooks) {
                    let r = this.defaults.hooks || new L;
                    for(let o in n.hooks){
                        if (!(o in r)) throw new Error(`hook '${o}' does not exist`);
                        if ([
                            "options",
                            "block"
                        ].includes(o)) continue;
                        let i = o, l = n.hooks[i], p = r[i];
                        L.passThroughHooks.has(o) ? r[i] = (h)=>{
                            if (r.options.async && L.passThroughHooksRespectAsync.has(o)) return (async ()=>{
                                let d = await l.call(r, h);
                                return p.call(r, d);
                            })();
                            let u = l.call(r, h);
                            return p.call(r, u);
                        } : r[i] = (...h)=>{
                            if (r.options.async) return (async ()=>{
                                let d = await l.apply(r, h);
                                return d === !1 && (d = await p.apply(r, h)), d;
                            })();
                            let u = l.apply(r, h);
                            return u === !1 && (u = p.apply(r, h)), u;
                        };
                    }
                    s.hooks = r;
                }
                if (n.walkTokens) {
                    let r = this.defaults.walkTokens, o = n.walkTokens;
                    s.walkTokens = function(i) {
                        let l = [];
                        return z(l, o.call(this, i)), r && z(l, r.call(this, i)), l;
                    };
                }
                this.defaults = {
                    ...this.defaults,
                    ...s
                };
            }), this;
        }
        setOptions(e) {
            return this.defaults = {
                ...this.defaults,
                ...e
            }, this;
        }
        lexer(e, t) {
            return O.lex(e, t ?? this.defaults);
        }
        parser(e, t) {
            return w.parse(e, t ?? this.defaults);
        }
        parseMarkdown(e) {
            return (n, s)=>{
                let r = {
                    ...s
                }, o = {
                    ...this.defaults,
                    ...r
                }, i = this.onError(!!o.silent, !!o.async);
                if (this.defaults.async === !0 && r.async === !1) return i(new Error("marked(): The async option was set to true by an extension. Remove async: false from the parse options object to return a Promise."));
                if (typeof n > "u" || n === null) return i(new Error("marked(): input parameter is undefined or null"));
                if (typeof n != "string") return i(new Error("marked(): input parameter is of type " + Object.prototype.toString.call(n) + ", string expected"));
                if (o.hooks && (o.hooks.options = o, o.hooks.block = e), o.async) return (async ()=>{
                    let l = o.hooks ? await o.hooks.preprocess(n) : n, h = await (o.hooks ? await o.hooks.provideLexer(e) : e ? O.lex : O.lexInline)(l, o), u = o.hooks ? await o.hooks.processAllTokens(h) : h;
                    o.walkTokens && await Promise.all(this.walkTokens(u, o.walkTokens));
                    let k = await (o.hooks ? await o.hooks.provideParser(e) : e ? w.parse : w.parseInline)(u, o);
                    return o.hooks ? await o.hooks.postprocess(k) : k;
                })().catch(i);
                try {
                    o.hooks && (n = o.hooks.preprocess(n));
                    let p = (o.hooks ? o.hooks.provideLexer(e) : e ? O.lex : O.lexInline)(n, o);
                    o.hooks && (p = o.hooks.processAllTokens(p)), o.walkTokens && this.walkTokens(p, o.walkTokens);
                    let u = (o.hooks ? o.hooks.provideParser(e) : e ? w.parse : w.parseInline)(p, o);
                    return o.hooks && (u = o.hooks.postprocess(u)), u;
                } catch (l) {
                    return i(l);
                }
            };
        }
        onError(e, t) {
            return (n)=>{
                if (n.message += `
Please report this to https://github.com/markedjs/marked.`, e) {
                    let s = "<p>An error occurred:</p><pre>" + S(n.message + "", !0) + "</pre>";
                    return t ? Promise.resolve(s) : s;
                }
                if (t) return Promise.reject(n);
                throw n;
            };
        }
    };
    var v = new Q;
    function m(a, e) {
        return v.parse(a, e);
    }
    m.options = m.setOptions = function(a) {
        return v.setOptions(a), m.defaults = v.defaults, ie(m.defaults), m;
    };
    m.getDefaults = D;
    m.defaults = P;
    function ve(...a) {
        return v.use(...a), m.defaults = v.defaults, ie(m.defaults), m;
    }
    m.use = ve;
    m.walkTokens = function(a, e) {
        return v.walkTokens(a, e);
    };
    m.parseInline = v.parseInline;
    m.Parser = w;
    m.parser = w.parse;
    m.Renderer = $;
    m.TextRenderer = A;
    m.Lexer = O;
    m.lexer = O.lex;
    m.Tokenizer = _;
    m.Hooks = L;
    m.parse = m;
    var Ft = m.options, Qt = m.setOptions, Ut = m.walkTokens, Wt = m.parseInline, Kt = m, Xt = w.parse, Vt = O.lex;
    if (__exports != exports) module1.exports = exports;
    return module1.exports;
});



// Helper to parse markdown synchronously into HTML string
function $5d9edfad2f50c8f1$var$renderMarkdown(text) {
    const html = (0, $1c80c15edccb5c8b$exports.marked).parse(text, {
        breaks: true,
        gfm: true
    });
    return {
        __html: html
    };
}
function $5d9edfad2f50c8f1$export$ecfd0f5195a7a18({ backendUrl: backendUrl, roomData: roomData, skills: skills, onApplyPromptToOrchestrator: onApplyPromptToOrchestrator, onRunOrchestrator: onRunOrchestrator, onOpenSkillsLibrary: onOpenSkillsLibrary }) {
    const [inputText, setInputText] = (0, $bFZzf.useState)('');
    const messagesContainerRef = (0, $bFZzf.useRef)(null);
    const activeSkillsCount = skills.filter((s)=>s.enabled).length;
    const { messages: messages, selectedModel: selectedModel, setSelectedModel: setSelectedModel, availableModels: availableModels, isLoading: isLoading, errorMessage: errorMessage, sendMessage: sendMessage, clearChat: clearChat } = (0, $4e654b9969462068$export$10d302cd18edaee1)({
        backendUrl: backendUrl,
        roomData: roomData,
        onApplyPromptToOrchestrator: (promptText)=>{
            onApplyPromptToOrchestrator(promptText);
        }
    });
    (0, $bFZzf.useEffect)(()=>{
        if (messagesContainerRef.current) messagesContainerRef.current.scrollTop = messagesContainerRef.current.scrollHeight;
    }, [
        messages,
        isLoading
    ]);
    const handleSend = ()=>{
        if (!inputText.trim() || isLoading) return;
        const text = inputText;
        setInputText('');
        const activeSkillIds = skills.filter((s)=>s.enabled).map((s)=>s.id);
        sendMessage(text, activeSkillIds);
    };
    const handleKeyDown = (e)=>{
        if (e.key === 'Enter' && !e.shiftKey) {
            e.preventDefault();
            handleSend();
        }
    };
    return /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("div", {
        style: $5d9edfad2f50c8f1$var$cardStyle,
        children: [
            /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("style", {
                dangerouslySetInnerHTML: {
                    __html: `
        @keyframes pulseGlow {
          0% { box-shadow: 0 0 8px rgba(156, 39, 176, 0.3); }
          50% { box-shadow: 0 0 20px rgba(156, 39, 176, 0.7); }
          100% { box-shadow: 0 0 8px rgba(156, 39, 176, 0.3); }
        }
        @keyframes chatDotBounce {
          0%, 80%, 100% { transform: scale(0); }
          40% { transform: scale(1.0); }
        }
        .markdown-chat-content p {
          margin: 0 0 8px 0;
        }
        .markdown-chat-content p:last-child {
          margin-bottom: 0;
        }
        .markdown-chat-content strong, .markdown-chat-content b {
          font-weight: 700;
          color: #ffffff;
        }
        .markdown-chat-content ul, .markdown-chat-content ol {
          margin: 6px 0 8px 0;
          padding-left: 20px;
        }
        .markdown-chat-content li {
          margin-bottom: 4px;
        }
        .markdown-chat-content li:last-child {
          margin-bottom: 0;
        }
        .markdown-chat-content code {
          background-color: rgba(0, 0, 0, 0.3);
          padding: 2px 6px;
          border-radius: 4px;
          font-family: monospace;
          font-size: 12px;
        }
        .markdown-chat-content pre {
          background-color: #121212;
          padding: 10px;
          border-radius: 6px;
          overflow-x: auto;
          margin: 8px 0;
          border: 1px solid #333;
        }
        .markdown-chat-content pre code {
          background: none;
          padding: 0;
        }
        .markdown-chat-content h1, .markdown-chat-content h2, .markdown-chat-content h3, .markdown-chat-content h4 {
          margin: 10px 0 6px 0;
          font-weight: 600;
          line-height: 1.3;
        }
        .markdown-chat-content h1:first-child, .markdown-chat-content h2:first-child, .markdown-chat-content h3:first-child, .markdown-chat-content h4:first-child {
          margin-top: 0;
        }
      `
                }
            }),
            /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("div", {
                style: $5d9edfad2f50c8f1$var$headerStyle,
                children: [
                    /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("div", {
                        style: {
                            display: 'flex',
                            alignItems: 'center',
                            gap: '10px'
                        },
                        children: [
                            /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("div", {
                                style: $5d9edfad2f50c8f1$var$avatarStyle,
                                children: "\uD83C\uDFDB\uFE0F"
                            }),
                            /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("h3", {
                                        style: {
                                            margin: 0,
                                            fontSize: '15px',
                                            fontWeight: 600,
                                            color: '#f3f4f6'
                                        },
                                        children: "Architekt M\xedstnosti (AI Chat)"
                                    }),
                                    /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("span", {
                                        style: {
                                            fontSize: '11px',
                                            color: '#9ca3af'
                                        },
                                        children: [
                                            activeSkillsCount,
                                            " aktivn\xedch skill\u016F"
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("div", {
                        style: {
                            display: 'flex',
                            gap: '8px',
                            alignItems: 'center'
                        },
                        children: [
                            onOpenSkillsLibrary && /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("button", {
                                onClick: onOpenSkillsLibrary,
                                style: $5d9edfad2f50c8f1$var$skillsBtnStyle,
                                title: "Otev\u0159\xedt Knihovnu Skill\u016F (Agent Skills Library)",
                                children: "\uD83E\uDDE0 Agent Skills Library"
                            }),
                            /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("button", {
                                onClick: clearChat,
                                style: $5d9edfad2f50c8f1$var$clearBtnStyle,
                                title: "Resetovat konverzaci",
                                children: "\uD83D\uDDD1\uFE0F Reset"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("div", {
                style: $5d9edfad2f50c8f1$var$modelSelectorContainerStyle,
                children: [
                    /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("label", {
                        style: {
                            fontSize: '12px',
                            color: '#9ca3af',
                            fontWeight: 500
                        },
                        children: "AI Model:"
                    }),
                    /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("select", {
                        value: selectedModel,
                        onChange: (e)=>setSelectedModel(e.target.value),
                        style: $5d9edfad2f50c8f1$var$modelSelectStyle,
                        children: availableModels.map((m)=>/*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("option", {
                                value: m.id,
                                children: m.name
                            }, m.id))
                    })
                ]
            }),
            /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("div", {
                ref: messagesContainerRef,
                style: $5d9edfad2f50c8f1$var$messagesScrollStyle,
                children: [
                    messages.map((msg)=>{
                        const isUser = msg.sender === 'user';
                        return /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("div", {
                            style: {
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: isUser ? 'flex-end' : 'flex-start',
                                marginBottom: '14px'
                            },
                            children: [
                                /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("div", {
                                    style: {
                                        fontSize: '11px',
                                        color: '#9ca3af',
                                        marginBottom: '4px',
                                        padding: '0 4px'
                                    },
                                    children: [
                                        isUser ? 'Vy' : "Architekt M\xedstnosti",
                                        " \u2022 ",
                                        msg.timestamp
                                    ]
                                }),
                                /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("div", {
                                    style: isUser ? $5d9edfad2f50c8f1$var$userBubbleStyle : $5d9edfad2f50c8f1$var$architectBubbleStyle,
                                    children: [
                                        /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("div", {
                                            className: "markdown-chat-content",
                                            style: {
                                                lineHeight: '1.5'
                                            },
                                            dangerouslySetInnerHTML: $5d9edfad2f50c8f1$var$renderMarkdown(msg.text)
                                        }),
                                        !isUser && msg.usedSkills && msg.usedSkills.length > 0 && /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("div", {
                                            style: {
                                                display: 'flex',
                                                flexWrap: 'wrap',
                                                alignItems: 'center',
                                                gap: '6px',
                                                marginTop: '10px',
                                                paddingTop: '8px',
                                                borderTop: '1px solid rgba(255, 255, 255, 0.08)'
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("span", {
                                                    style: {
                                                        fontSize: '11px',
                                                        color: '#9ca3af',
                                                        fontWeight: 500
                                                    },
                                                    children: [
                                                        "\uD83E\uDDE0 Konsultovan\xe9 skilly (",
                                                        msg.usedSkills.length,
                                                        "):"
                                                    ]
                                                }),
                                                msg.usedSkills.map((s)=>/*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("span", {
                                                        title: s.description,
                                                        style: {
                                                            fontSize: '10px',
                                                            fontWeight: 600,
                                                            backgroundColor: 'rgba(156, 39, 176, 0.15)',
                                                            color: '#e9d5ff',
                                                            border: '1px solid rgba(156, 39, 176, 0.3)',
                                                            borderRadius: '12px',
                                                            padding: '2px 8px'
                                                        },
                                                        children: [
                                                            "\u2713 ",
                                                            s.name
                                                        ]
                                                    }, s.id))
                                            ]
                                        }),
                                        msg.action === 'EXECUTE_ORCHESTRATOR' && msg.targetTextareaValue && /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("div", {
                                            style: $5d9edfad2f50c8f1$var$handoffCardStyle,
                                            children: [
                                                /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("div", {
                                                    style: $5d9edfad2f50c8f1$var$handoffHeaderStyle,
                                                    children: /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("span", {
                                                        children: "\u2728 P\u0159ipraven\xe1 instrukce pro Orchestr\xe1tor:"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("div", {
                                                    style: $5d9edfad2f50c8f1$var$handoffPromptBoxStyle,
                                                    children: msg.targetTextareaValue
                                                }),
                                                /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("div", {
                                                    style: {
                                                        display: 'flex',
                                                        gap: '8px',
                                                        marginTop: '10px'
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("button", {
                                                            onClick: ()=>{
                                                                onApplyPromptToOrchestrator(msg.targetTextareaValue);
                                                                onRunOrchestrator(msg.targetTextareaValue);
                                                            },
                                                            style: $5d9edfad2f50c8f1$var$runOrchestratorBtnStyle,
                                                            children: "\uD83D\uDE80 Spustit Orchestr\xe1tor N\xe1bytku"
                                                        }),
                                                        /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("button", {
                                                            onClick: ()=>{
                                                                onApplyPromptToOrchestrator(msg.targetTextareaValue);
                                                            },
                                                            style: $5d9edfad2f50c8f1$var$copyPromptBtnStyle,
                                                            children: "\u270D\uFE0F Pouze vlo\u017Eit do Textarea"
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }, msg.id);
                    }),
                    isLoading && /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("div", {
                        style: {
                            display: 'flex',
                            alignItems: 'center',
                            gap: '8px',
                            padding: '10px 14px'
                        },
                        children: /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("div", {
                            style: $5d9edfad2f50c8f1$var$architectBubbleStyle,
                            children: /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("div", {
                                style: {
                                    display: 'flex',
                                    gap: '4px',
                                    alignItems: 'center'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("span", {
                                        style: {
                                            fontSize: '12px',
                                            color: '#9c27b0'
                                        },
                                        children: "Architekt p\u0159em\xfd\u0161l\xed"
                                    }),
                                    /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("span", {
                                        style: $5d9edfad2f50c8f1$var$dotStyle(0),
                                        children: "\u2022"
                                    }),
                                    /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("span", {
                                        style: $5d9edfad2f50c8f1$var$dotStyle(200),
                                        children: "\u2022"
                                    }),
                                    /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("span", {
                                        style: $5d9edfad2f50c8f1$var$dotStyle(400),
                                        children: "\u2022"
                                    })
                                ]
                            })
                        })
                    }),
                    errorMessage && /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("div", {
                        style: $5d9edfad2f50c8f1$var$errorStyle,
                        children: [
                            "Chyba: ",
                            errorMessage
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("div", {
                style: $5d9edfad2f50c8f1$var$inputContainerStyle,
                children: [
                    /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("input", {
                        type: "text",
                        value: inputText,
                        onChange: (e)=>setInputText(e.target.value),
                        onKeyDown: handleKeyDown,
                        placeholder: "Napi\u0161te zpr\xe1vu pro architekta (nap\u0159. 'Kam bys mi doporu\u010Dil d\xe1t gau\u010D?')...",
                        disabled: isLoading,
                        style: $5d9edfad2f50c8f1$var$inputStyle
                    }),
                    /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("button", {
                        onClick: handleSend,
                        disabled: isLoading || !inputText.trim(),
                        style: $5d9edfad2f50c8f1$var$sendBtnStyle(isLoading || !inputText.trim()),
                        children: isLoading ? '...' : 'Odeslat'
                    })
                ]
            })
        ]
    });
}
// ---------------------------------- Styles -----------------------------------
const $5d9edfad2f50c8f1$var$cardStyle = {
    backgroundColor: '#1e1e1e',
    border: '1px solid #333333',
    borderRadius: '12px',
    display: 'flex',
    flexDirection: 'column',
    height: '750px',
    boxShadow: '0 8px 24px rgba(0, 0, 0, 0.3)',
    overflow: 'hidden'
};
const $5d9edfad2f50c8f1$var$headerStyle = {
    padding: '14px 18px',
    backgroundColor: 'rgba(255, 255, 255, 0.02)',
    borderBottom: '1px solid #333333',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
};
const $5d9edfad2f50c8f1$var$avatarStyle = {
    width: '36px',
    height: '36px',
    borderRadius: '50%',
    backgroundColor: 'rgba(156, 39, 176, 0.2)',
    border: '1px solid rgba(156, 39, 176, 0.4)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '18px'
};
const $5d9edfad2f50c8f1$var$skillsBtnStyle = {
    backgroundColor: 'rgba(156, 39, 176, 0.15)',
    border: '1px solid rgba(156, 39, 176, 0.4)',
    color: '#e1bee7',
    fontSize: '12px',
    fontWeight: 500,
    padding: '4px 10px',
    borderRadius: '6px',
    cursor: 'pointer',
    transition: 'all 0.2s'
};
const $5d9edfad2f50c8f1$var$clearBtnStyle = {
    background: 'none',
    border: '1px solid #444',
    color: '#9ca3af',
    fontSize: '12px',
    padding: '4px 10px',
    borderRadius: '6px',
    cursor: 'pointer',
    transition: 'all 0.2s'
};
const $5d9edfad2f50c8f1$var$modelSelectorContainerStyle = {
    padding: '8px 18px',
    backgroundColor: 'rgba(0, 0, 0, 0.2)',
    borderBottom: '1px solid #2a2a2a',
    display: 'flex',
    alignItems: 'center',
    gap: '10px'
};
const $5d9edfad2f50c8f1$var$modelSelectStyle = {
    backgroundColor: '#121212',
    color: '#f3f4f6',
    border: '1px solid #333',
    borderRadius: '6px',
    padding: '4px 8px',
    fontSize: '12px',
    outline: 'none',
    flex: 1
};
const $5d9edfad2f50c8f1$var$messagesScrollStyle = {
    flex: 1,
    padding: '16px',
    overflowY: 'auto',
    display: 'flex',
    flexDirection: 'column'
};
const $5d9edfad2f50c8f1$var$userBubbleStyle = {
    backgroundColor: '#9c27b0',
    color: '#ffffff',
    padding: '10px 14px',
    borderRadius: '14px 14px 2px 14px',
    maxWidth: '85%',
    fontSize: '13px',
    boxShadow: '0 2px 8px rgba(156, 39, 176, 0.2)'
};
const $5d9edfad2f50c8f1$var$architectBubbleStyle = {
    backgroundColor: '#2a2a2a',
    color: '#f3f4f6',
    padding: '12px 16px',
    borderRadius: '14px 14px 14px 2px',
    maxWidth: '90%',
    fontSize: '13px',
    border: '1px solid #383838',
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.2)'
};
const $5d9edfad2f50c8f1$var$handoffCardStyle = {
    marginTop: '12px',
    padding: '12px',
    backgroundColor: 'rgba(156, 39, 176, 0.1)',
    border: '1px solid rgba(156, 39, 176, 0.3)',
    borderRadius: '8px',
    animation: 'pulseGlow 3s infinite'
};
const $5d9edfad2f50c8f1$var$handoffHeaderStyle = {
    fontSize: '12px',
    fontWeight: 600,
    color: '#ab47bc',
    marginBottom: '6px'
};
const $5d9edfad2f50c8f1$var$handoffPromptBoxStyle = {
    fontFamily: 'monospace',
    fontSize: '12px',
    backgroundColor: '#121212',
    padding: '8px 10px',
    borderRadius: '6px',
    color: '#4ade80',
    border: '1px solid #282828',
    lineHeight: '1.4'
};
const $5d9edfad2f50c8f1$var$runOrchestratorBtnStyle = {
    backgroundColor: '#9c27b0',
    color: '#ffffff',
    border: 'none',
    borderRadius: '6px',
    padding: '8px 14px',
    fontSize: '12px',
    fontWeight: 600,
    cursor: 'pointer',
    flex: 1,
    boxShadow: '0 4px 12px rgba(156, 39, 176, 0.3)'
};
const $5d9edfad2f50c8f1$var$copyPromptBtnStyle = {
    backgroundColor: '#333333',
    color: '#e5e7eb',
    border: '1px solid #444444',
    borderRadius: '6px',
    padding: '8px 12px',
    fontSize: '12px',
    cursor: 'pointer'
};
const $5d9edfad2f50c8f1$var$inputContainerStyle = {
    padding: '12px 16px',
    borderTop: '1px solid #333333',
    backgroundColor: 'rgba(255, 255, 255, 0.01)',
    display: 'flex',
    gap: '10px'
};
const $5d9edfad2f50c8f1$var$inputStyle = {
    flex: 1,
    backgroundColor: '#121212',
    border: '1px solid #333',
    borderRadius: '8px',
    padding: '10px 14px',
    color: '#f3f4f6',
    fontSize: '13px',
    outline: 'none'
};
const $5d9edfad2f50c8f1$var$sendBtnStyle = (disabled)=>({
        backgroundColor: disabled ? '#333333' : '#9c27b0',
        color: disabled ? '#888888' : '#ffffff',
        border: 'none',
        borderRadius: '8px',
        padding: '0 18px',
        fontWeight: 600,
        fontSize: '13px',
        cursor: disabled ? 'not-allowed' : 'pointer',
        transition: 'background-color 0.2s'
    });
const $5d9edfad2f50c8f1$var$errorStyle = {
    padding: '8px 12px',
    backgroundColor: 'rgba(239, 68, 68, 0.1)',
    border: '1px solid rgba(239, 68, 68, 0.3)',
    borderRadius: '6px',
    color: '#fca5a5',
    fontSize: '12px',
    marginTop: '8px'
};
const $5d9edfad2f50c8f1$var$dotStyle = (delayMs)=>({
        display: 'inline-block',
        fontSize: '16px',
        animation: 'chatDotBounce 1.4s infinite ease-in-out both',
        animationDelay: `${delayMs}ms`
    });




var $bFZzf = parcelRequire("bFZzf");

function $418a8156cf324d8a$export$f16c619bb7a6cd8({ backendUrl: backendUrl }) {
    const { skills: skills, isLoading: isLoading, error: error, toggleSkill: toggleSkill, addSkill: addSkill, updateSkillContent: updateSkillContent, deleteSkill: deleteSkill } = (0, $6d3477a982cfb87f$export$52147cc63c0ab0e2)(backendUrl);
    const [activeSkill, setActiveSkill] = (0, $bFZzf.useState)(null);
    const [isEditing, setIsEditing] = (0, $bFZzf.useState)(false);
    const [isCreating, setIsCreating] = (0, $bFZzf.useState)(false);
    // Form state
    const [formName, setFormName] = (0, $bFZzf.useState)('');
    const [formDescription, setFormDescription] = (0, $bFZzf.useState)('');
    const [formContent, setFormContent] = (0, $bFZzf.useState)('');
    const handleOpenEdit = (skill)=>{
        setActiveSkill(skill);
        setFormName(skill.name);
        setFormDescription(skill.description);
        setFormContent(skill.bodyContent || skill.content);
        setIsEditing(true);
        setIsCreating(false);
    };
    const handleOpenCreate = ()=>{
        setActiveSkill(null);
        setFormName('');
        setFormDescription('');
        setFormContent("1. Napi\u0161te sem konkr\xe9tn\xed pravidla pro rozvr\u017Een\xed n\xe1bytku...\n2. Dal\u0161\xed pravidlo...");
        setIsCreating(true);
        setIsEditing(false);
    };
    const handleSave = async ()=>{
        if (!formName.trim() || !formContent.trim()) return;
        if (isCreating) {
            await addSkill({
                name: formName,
                description: formDescription,
                content: formContent
            });
            setIsCreating(false);
        } else if (isEditing && activeSkill) {
            await updateSkillContent(activeSkill.id, {
                name: formName,
                description: formDescription,
                content: formContent
            });
            setIsEditing(false);
        }
    };
    const handleDelete = async (id)=>{
        if (window.confirm('Opravdu chcete smazat tento skill a jeho .md soubor?')) {
            await deleteSkill(id);
            if (activeSkill?.id === id) {
                setActiveSkill(null);
                setIsEditing(false);
            }
        }
    };
    return /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("div", {
        style: $418a8156cf324d8a$var$containerStyle,
        children: [
            /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("div", {
                style: $418a8156cf324d8a$var$headerStyle,
                children: [
                    /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("h2", {
                                style: {
                                    margin: 0,
                                    fontSize: '20px',
                                    fontWeight: 600,
                                    color: '#f3f4f6'
                                },
                                children: "\uD83E\uDDE0 Knihovna Klientsk\xfdch Skill\u016F (Agent Skills)"
                            }),
                            /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("p", {
                                style: {
                                    margin: '4px 0 0 0',
                                    fontSize: '13px',
                                    color: '#9ca3af'
                                },
                                children: [
                                    "Spravujte pravidla a znalostn\xed b\xe1zi pro AI architekta. Ka\u017Ed\xfd skill je ulo\u017Een jako ",
                                    /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("code", {
                                        children: "/skills/*.md"
                                    }),
                                    " soubor."
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("div", {
                        children: /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("button", {
                            onClick: handleOpenCreate,
                            style: $418a8156cf324d8a$var$createBtnStyle,
                            children: "\u2795 Vytvo\u0159it Nov\xfd Skill"
                        })
                    })
                ]
            }),
            error && /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("div", {
                style: $418a8156cf324d8a$var$errorAlertStyle,
                children: [
                    "Chyba: ",
                    error
                ]
            }),
            /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("div", {
                style: $418a8156cf324d8a$var$gridStyle,
                children: [
                    /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("div", {
                        style: $418a8156cf324d8a$var$skillsListColumnStyle,
                        children: [
                            /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("h3", {
                                style: $418a8156cf324d8a$var$sectionHeaderStyle,
                                children: [
                                    "Aktivn\xed a Dostupn\xe9 Skilly (",
                                    skills.length,
                                    ")"
                                ]
                            }),
                            isLoading ? /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("div", {
                                style: {
                                    color: '#9ca3af',
                                    padding: '20px',
                                    fontSize: '14px'
                                },
                                children: "Na\u010D\xedt\xe1n\xed skill\u016F..."
                            }) : /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("div", {
                                style: {
                                    display: 'flex',
                                    flexDirection: 'column',
                                    gap: '12px'
                                },
                                children: skills.map((skill)=>/*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("div", {
                                        style: $418a8156cf324d8a$var$skillCardStyle(skill.enabled),
                                        children: /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("div", {
                                            style: {
                                                display: 'flex',
                                                alignItems: 'flex-start',
                                                justifyContent: 'space-between'
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("div", {
                                                    style: {
                                                        flex: 1,
                                                        paddingRight: '12px'
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("div", {
                                                            style: {
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                gap: '8px'
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("span", {
                                                                    style: {
                                                                        fontSize: '15px',
                                                                        fontWeight: 600,
                                                                        color: '#f3f4f6'
                                                                    },
                                                                    children: skill.name
                                                                }),
                                                                /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("span", {
                                                                    style: $418a8156cf324d8a$var$badgeStyle(skill.enabled),
                                                                    children: skill.enabled ? "Aktivn\xed" : 'Vypnuto'
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("p", {
                                                            style: {
                                                                margin: '6px 0 0 0',
                                                                fontSize: '12px',
                                                                color: '#9ca3af',
                                                                lineHeight: '1.4'
                                                            },
                                                            children: skill.description
                                                        }),
                                                        /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("div", {
                                                            style: {
                                                                marginTop: '8px',
                                                                fontSize: '11px',
                                                                color: '#6b7280',
                                                                fontFamily: 'monospace'
                                                            },
                                                            children: [
                                                                "\uD83D\uDCC4 ",
                                                                skill.filePath ? skill.filePath.split('/').pop() : `${skill.id}.md`
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("div", {
                                                    style: {
                                                        display: 'flex',
                                                        flexDirection: 'column',
                                                        alignItems: 'flex-end',
                                                        gap: '10px'
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("label", {
                                                            style: $418a8156cf324d8a$var$toggleLabelStyle,
                                                            children: [
                                                                /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("input", {
                                                                    type: "checkbox",
                                                                    checked: skill.enabled,
                                                                    onChange: (e)=>toggleSkill(skill.id, e.target.checked),
                                                                    style: {
                                                                        cursor: 'pointer'
                                                                    }
                                                                }),
                                                                /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("span", {
                                                                    style: {
                                                                        fontSize: '12px',
                                                                        color: skill.enabled ? '#ab47bc' : '#9ca3af'
                                                                    },
                                                                    children: skill.enabled ? 'Zapnuto' : 'Vypnuto'
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("div", {
                                                            style: {
                                                                display: 'flex',
                                                                gap: '6px'
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("button", {
                                                                    onClick: ()=>handleOpenEdit(skill),
                                                                    style: $418a8156cf324d8a$var$smallActionBtnStyle,
                                                                    children: "\u270F\uFE0F Upravit"
                                                                }),
                                                                /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("button", {
                                                                    onClick: ()=>handleDelete(skill.id),
                                                                    style: $418a8156cf324d8a$var$smallDeleteBtnStyle,
                                                                    children: "\uD83D\uDDD1\uFE0F"
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    }, skill.id))
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("div", {
                        style: $418a8156cf324d8a$var$editorColumnStyle,
                        children: isEditing || isCreating ? /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("div", {
                            style: $418a8156cf324d8a$var$editorCardStyle,
                            children: [
                                /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("h3", {
                                    style: $418a8156cf324d8a$var$sectionHeaderStyle,
                                    children: isCreating ? "\u2795 Vytvo\u0159en\xed Nov\xe9ho Skillu" : `\u{270F}\u{FE0F} \xdaprava Skillu: ${activeSkill?.name}`
                                }),
                                /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("div", {
                                    style: {
                                        marginBottom: '16px'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("label", {
                                            style: $418a8156cf324d8a$var$fieldLabelStyle,
                                            children: "N\xe1zev Skillu:"
                                        }),
                                        /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("input", {
                                            type: "text",
                                            value: formName,
                                            onChange: (e)=>setFormName(e.target.value),
                                            placeholder: "nap\u0159. Ergonomie N\xe1bytku a Vzd\xe1lenost\xed",
                                            style: $418a8156cf324d8a$var$inputStyle
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("div", {
                                    style: {
                                        marginBottom: '16px'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("label", {
                                            style: $418a8156cf324d8a$var$fieldLabelStyle,
                                            children: "Stru\u010Dn\xfd Popis (Description):"
                                        }),
                                        /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("div", {
                                            style: {
                                                fontSize: '11px',
                                                color: '#9ca3af',
                                                marginBottom: '6px'
                                            },
                                            children: "\uD83D\uDCA1 Stru\u010Dn\xe9 shrnut\xed pravidel. Tento popis se pos\xedl\xe1 do 1. f\xe1ze (Discovery) pro rozhodnut\xed, zda skill pou\u017E\xedt."
                                        }),
                                        /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("input", {
                                            type: "text",
                                            value: formDescription,
                                            onChange: (e)=>setFormDescription(e.target.value),
                                            placeholder: "nap\u0159. Pravidla pro odstup stolku od pohovky a vzd\xe1lenost TV",
                                            style: $418a8156cf324d8a$var$inputStyle
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("div", {
                                    style: {
                                        marginBottom: '18px'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("label", {
                                            style: $418a8156cf324d8a$var$fieldLabelStyle,
                                            children: "Obsah Pravidel (Markdown Content):"
                                        }),
                                        /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("div", {
                                            style: {
                                                fontSize: '11px',
                                                color: '#9ca3af',
                                                marginBottom: '6px'
                                            },
                                            children: "\uD83D\uDCA1 Pln\xe9 zn\u011Bn\xed pravidel a parametr\u016F v Markdown form\xe1tu. Na\u010Dte se a po\u0161le do syst\xe9mu ve 2. f\xe1zi pro generov\xe1n\xed odpov\u011Bdi (i s nadpisem a popisem)."
                                        }),
                                        /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("textarea", {
                                            value: formContent,
                                            onChange: (e)=>setFormContent(e.target.value),
                                            rows: 14,
                                            style: $418a8156cf324d8a$var$textareaStyle
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("div", {
                                    style: {
                                        display: 'flex',
                                        gap: '10px',
                                        justifyContent: 'flex-end'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("button", {
                                            onClick: ()=>{
                                                setIsEditing(false);
                                                setIsCreating(false);
                                            },
                                            style: $418a8156cf324d8a$var$cancelBtnStyle,
                                            children: "Zru\u0161it"
                                        }),
                                        /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("button", {
                                            onClick: handleSave,
                                            style: $418a8156cf324d8a$var$saveBtnStyle,
                                            children: "\uD83D\uDCBE Ulo\u017Eit Skill"
                                        })
                                    ]
                                })
                            ]
                        }) : /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("div", {
                            style: $418a8156cf324d8a$var$placeholderCardStyle,
                            children: [
                                /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("div", {
                                    style: {
                                        fontSize: '32px',
                                        marginBottom: '12px'
                                    },
                                    children: "\uD83D\uDCD6"
                                }),
                                /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("h4", {
                                    style: {
                                        margin: 0,
                                        fontSize: '16px',
                                        color: '#f3f4f6'
                                    },
                                    children: "Vyberte skill k \xfaprav\u011B nebo vytvo\u0159te nov\xfd"
                                }),
                                /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("p", {
                                    style: {
                                        margin: '8px 0 0 0',
                                        fontSize: '13px',
                                        color: '#9ca3af'
                                    },
                                    children: "Skilly p\u0159edstavuj\xed klientsk\xe1 pravidla a principy architektury. P\u0159i spu\u0161t\u011Bn\xed chatu se automaticky p\u0159ipoj\xed do syst\xe9mov\xfdch instrukc\xed pro Gemini AI."
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
}
// ---------------------------------- Styles -----------------------------------
const $418a8156cf324d8a$var$containerStyle = {
    backgroundColor: '#1e1e1e',
    border: '1px solid #333333',
    borderRadius: '12px',
    padding: '24px',
    boxShadow: '0 8px 24px rgba(0, 0, 0, 0.3)'
};
const $418a8156cf324d8a$var$headerStyle = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    borderBottom: '1px solid #333333',
    paddingBottom: '16px',
    marginBottom: '20px'
};
const $418a8156cf324d8a$var$createBtnStyle = {
    backgroundColor: '#9c27b0',
    color: '#ffffff',
    border: 'none',
    borderRadius: '8px',
    padding: '10px 16px',
    fontSize: '13px',
    fontWeight: 600,
    cursor: 'pointer'
};
const $418a8156cf324d8a$var$gridStyle = {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: '24px'
};
const $418a8156cf324d8a$var$skillsListColumnStyle = {
    display: 'flex',
    flexDirection: 'column'
};
const $418a8156cf324d8a$var$sectionHeaderStyle = {
    fontSize: '15px',
    fontWeight: 600,
    color: '#f3f4f6',
    marginTop: 0,
    marginBottom: '14px'
};
const $418a8156cf324d8a$var$skillCardStyle = (enabled)=>({
        backgroundColor: enabled ? '#262626' : '#1a1a1a',
        border: enabled ? '1px solid #3c3c3c' : '1px solid #282828',
        borderRadius: '10px',
        padding: '16px',
        opacity: enabled ? 1 : 0.65,
        transition: 'all 0.2s'
    });
const $418a8156cf324d8a$var$badgeStyle = (enabled)=>({
        fontSize: '10px',
        fontWeight: 600,
        padding: '2px 8px',
        borderRadius: '10px',
        backgroundColor: enabled ? 'rgba(74, 222, 128, 0.15)' : 'rgba(156, 163, 175, 0.15)',
        color: enabled ? '#4ade80' : '#9ca3af',
        border: enabled ? '1px solid rgba(74, 222, 128, 0.3)' : '1px solid rgba(156, 163, 175, 0.3)'
    });
const $418a8156cf324d8a$var$toggleLabelStyle = {
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
    cursor: 'pointer'
};
const $418a8156cf324d8a$var$smallActionBtnStyle = {
    backgroundColor: '#333',
    color: '#e5e7eb',
    border: '1px solid #444',
    borderRadius: '4px',
    padding: '4px 8px',
    fontSize: '11px',
    cursor: 'pointer'
};
const $418a8156cf324d8a$var$smallDeleteBtnStyle = {
    backgroundColor: 'rgba(239, 68, 68, 0.15)',
    color: '#fca5a5',
    border: '1px solid rgba(239, 68, 68, 0.3)',
    borderRadius: '4px',
    padding: '4px 8px',
    fontSize: '11px',
    cursor: 'pointer'
};
const $418a8156cf324d8a$var$editorColumnStyle = {
    display: 'flex',
    flexDirection: 'column'
};
const $418a8156cf324d8a$var$editorCardStyle = {
    backgroundColor: '#262626',
    border: '1px solid #333333',
    borderRadius: '10px',
    padding: '20px'
};
const $418a8156cf324d8a$var$placeholderCardStyle = {
    backgroundColor: '#1a1a1a',
    border: '1px dashed #333333',
    borderRadius: '10px',
    padding: '40px 20px',
    textAlign: 'center',
    color: '#9ca3af'
};
const $418a8156cf324d8a$var$fieldLabelStyle = {
    display: 'block',
    fontSize: '12px',
    color: '#9ca3af',
    fontWeight: 500,
    marginBottom: '6px'
};
const $418a8156cf324d8a$var$inputStyle = {
    width: '100%',
    backgroundColor: '#121212',
    border: '1px solid #333',
    borderRadius: '6px',
    padding: '8px 12px',
    color: '#f3f4f6',
    fontSize: '13px',
    boxSizing: 'border-box'
};
const $418a8156cf324d8a$var$textareaStyle = {
    width: '100%',
    backgroundColor: '#121212',
    border: '1px solid #333',
    borderRadius: '6px',
    padding: '10px 12px',
    color: '#f3f4f6',
    fontFamily: 'monospace',
    fontSize: '12px',
    lineHeight: '1.4',
    boxSizing: 'border-box',
    resize: 'vertical'
};
const $418a8156cf324d8a$var$saveBtnStyle = {
    backgroundColor: '#9c27b0',
    color: '#ffffff',
    border: 'none',
    borderRadius: '6px',
    padding: '8px 16px',
    fontSize: '13px',
    fontWeight: 600,
    cursor: 'pointer'
};
const $418a8156cf324d8a$var$cancelBtnStyle = {
    backgroundColor: '#333333',
    color: '#e5e7eb',
    border: '1px solid #444',
    borderRadius: '6px',
    padding: '8px 14px',
    fontSize: '13px',
    cursor: 'pointer'
};
const $418a8156cf324d8a$var$errorAlertStyle = {
    padding: '10px 14px',
    backgroundColor: 'rgba(239, 68, 68, 0.1)',
    border: '1px solid rgba(239, 68, 68, 0.3)',
    borderRadius: '6px',
    color: '#fca5a5',
    fontSize: '13px',
    marginBottom: '16px'
};






var $bFZzf = parcelRequire("bFZzf");

const $347f08a9fa010a1a$export$142368568726dda = (0, $0d8d43ca0bd0e763$export$b9237242c9be0e8c);



const $a3ed16d8c0bbb224$var$ZONING_PRESETS = [
    {
        label: "\uD83D\uDECB\uFE0F Ob\xfdv\xe1k + \uD83C\uDF7D\uFE0F J\xeddelna + \uD83C\uDF73 Kuchy\u0148",
        prompt: "Otev\u0159en\xfd koncept: funk\u010Dn\xed kuchy\u0148sk\xe1 z\xf3na s p\u0159\xedmou n\xe1vaznost\xed na j\xeddeln\xed kout a samostatn\xe1 ob\xfdvac\xed z\xf3na s pohovkou orientovanou k TV."
    },
    {
        label: "\uD83D\uDECB\uFE0F Ob\xfdv\xe1k + \uD83D\uDCBB Pracovn\xed kout + \uD83C\uDF3F Relax",
        prompt: "Vytvo\u0159 prostorn\xfd ob\xfdvac\xed pokoj pro setk\xe1v\xe1n\xed rodiny, tich\xfd pracovn\xed kout se stolem u bo\u010Dn\xedho denn\xedho sv\u011Btla a klidn\xe9 \u010Dtec\xed z\xe1kout\xed s k\u0159eslem."
    },
    {
        label: "\uD83C\uDF7D\uFE0F J\xeddelna jako spojovac\xed \u010Dl\xe1nek",
        prompt: "Uspo\u0159\xe1dej prostor tak, aby j\xeddeln\xed st\u016Fl tvo\u0159il p\u0159irozen\xfd spojovac\xed \u010Dl\xe1nek mezi kuchyn\xed a ob\xfdvac\xedm prostorem a zachovej p\u0159\xedm\xe9 pr\u016Fchody."
    },
    {
        label: "\uD83E\uDDF8 D\u011Btsk\xe1 herna + \uD83D\uDECB\uFE0F Rodinn\xfd ob\xfdv\xe1k",
        prompt: "Bezpe\u010Dn\xe9 rodinn\xe9 uspo\u0159\xe1d\xe1n\xed: souvisl\xe1 hern\xed plocha pro d\u011Bti s n\xedzk\xfdm \xfalo\u017En\xfdm reg\xe1lem v p\u0159\xedm\xe9m dohledu z kuchyn\u011B i pohovky."
    }
];
function $a3ed16d8c0bbb224$export$ab08871484d62e13({ prompt: prompt, onPromptChange: onPromptChange, model: model, onModelChange: onModelChange, onGenerateZones: onGenerateZones, onClearZones: onClearZones, isZoning: isZoning, zones: zones, variants: variants = [], activeVariantIndex: activeVariantIndex = 0, onSelectVariant: onSelectVariant, zoneAnchors: zoneAnchors = [], showZoneAnchors: showZoneAnchors = true, onToggleShowZoneAnchors: onToggleShowZoneAnchors, includeAllSkills: includeAllSkills = false, onToggleIncludeAllSkills: onToggleIncludeAllSkills, onFocusAnchor: onFocusAnchor, focusedAnchorId: focusedAnchorId, aiExplanation: aiExplanation, errorMessage: errorMessage, backendUrl: backendUrl, showZonesInPreview: showZonesInPreview, onToggleShowZones: onToggleShowZones, onFocusZone: onFocusZone, focusedZoneId: focusedZoneId }) {
    // Rules editor state
    const [rulesOpen, setRulesOpen] = (0, $bFZzf.useState)(false);
    const [rulesContent, setRulesContent] = (0, $bFZzf.useState)('');
    const [isSavingRules, setIsSavingRules] = (0, $bFZzf.useState)(false);
    const [rulesSavedMessage, setRulesSavedMessage] = (0, $bFZzf.useState)('');
    // Fetch current server rules
    (0, $bFZzf.useEffect)(()=>{
        fetch(`${backendUrl}/api/zoning/rules`).then((res)=>res.json()).then((data)=>{
            if (data.content) setRulesContent(data.content);
        }).catch((err)=>console.warn('Could not load zoning rules:', err));
    }, [
        backendUrl
    ]);
    const handleSaveRules = async ()=>{
        setIsSavingRules(true);
        setRulesSavedMessage('');
        try {
            const res = await fetch(`${backendUrl}/api/zoning/rules`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    content: rulesContent
                })
            });
            if (res.ok) {
                setRulesSavedMessage('Rules saved successfully to server!');
                setTimeout(()=>setRulesSavedMessage(''), 4000);
            } else throw new Error('Failed to save rules to server.');
        } catch (err) {
            alert(err instanceof Error ? err.message : String(err));
        } finally{
            setIsSavingRules(false);
        }
    };
    const handleRunZoning = ()=>{
        onGenerateZones(rulesContent);
    };
    const activeVariant = variants[activeVariantIndex];
    return /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("section", {
        style: {
            backgroundColor: '#1e1e1e',
            border: '1px solid #333333',
            borderRadius: '12px',
            padding: '24px',
            marginTop: '16px',
            display: 'flex',
            flexDirection: 'column',
            gap: '20px',
            boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.2)'
        },
        children: [
            /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("div", {
                style: {
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    borderBottom: '1px solid #333333',
                    paddingBottom: '14px'
                },
                children: [
                    /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("div", {
                        style: {
                            display: 'flex',
                            alignItems: 'center',
                            gap: '10px'
                        },
                        children: [
                            /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("div", {
                                style: {
                                    width: '34px',
                                    height: '34px',
                                    borderRadius: '8px',
                                    backgroundColor: 'rgba(59, 130, 246, 0.15)',
                                    color: '#60a5fa',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    fontSize: '18px'
                                },
                                children: "\uD83D\uDCD0"
                            }),
                            /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("h2", {
                                        style: {
                                            fontSize: '18px',
                                            fontWeight: 600,
                                            color: '#f3f4f6',
                                            margin: 0
                                        },
                                        children: "Inteligentn\xed z\xf3nov\xe1n\xed m\xedstnosti (Archie Zone Planner)"
                                    }),
                                    /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("div", {
                                        style: {
                                            fontSize: '12px',
                                            color: '#9ca3af',
                                            marginTop: '2px'
                                        },
                                        children: [
                                            "Pravidla ze slo\u017Eky ",
                                            /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("code", {
                                                children: "skills-zoning"
                                            }),
                                            " + 3 varianty + zobrazen\xed kotevn\xedch objekt\u016F"
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("div", {
                        style: {
                            display: 'flex',
                            gap: '10px',
                            alignItems: 'center'
                        },
                        children: [
                            /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("button", {
                                type: "button",
                                onClick: ()=>setRulesOpen(!rulesOpen),
                                style: {
                                    backgroundColor: rulesOpen ? 'rgba(168, 85, 247, 0.2)' : 'rgba(255, 255, 255, 0.05)',
                                    border: '1px solid #444444',
                                    color: rulesOpen ? '#c084fc' : '#e5e7eb',
                                    padding: '6px 12px',
                                    borderRadius: '6px',
                                    fontSize: '12px',
                                    fontWeight: 500,
                                    cursor: 'pointer',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '6px',
                                    transition: 'all 0.2s'
                                },
                                title: "Zobrazit a upravit architektonick\xe1 pravidla z\xf3nov\xe1n\xed",
                                children: [
                                    "\uD83D\uDCCB ",
                                    rulesOpen ? "Skr\xfdt pravidla" : "Pravidla z\xf3nov\xe1n\xed (Markdown)"
                                ]
                            }),
                            /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("a", {
                                href: `${backendUrl}/zoning-doc`,
                                target: "_blank",
                                rel: "noopener noreferrer",
                                style: {
                                    backgroundColor: 'rgba(59, 130, 246, 0.1)',
                                    border: '1px solid rgba(59, 130, 246, 0.3)',
                                    color: '#93c5fd',
                                    padding: '6px 14px',
                                    borderRadius: '6px',
                                    fontSize: '12px',
                                    fontWeight: 500,
                                    cursor: 'pointer',
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    gap: '6px',
                                    textDecoration: 'none',
                                    transition: 'all 0.2s'
                                },
                                title: "Otev\u0159\xedt dokumentaci ZONING.md v nov\xe9 z\xe1lo\u017Ece",
                                children: "\uD83D\uDCD6 Dokumentace ZONING.md \u2197"
                            })
                        ]
                    })
                ]
            }),
            rulesOpen && /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("div", {
                style: {
                    backgroundColor: '#141414',
                    border: '1px solid #2a2a2a',
                    borderRadius: '8px',
                    padding: '16px',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '12px'
                },
                children: [
                    /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("div", {
                        style: {
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center'
                        },
                        children: [
                            /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("span", {
                                        style: {
                                            fontSize: '13px',
                                            fontWeight: 600,
                                            color: '#f3f4f6'
                                        },
                                        children: [
                                            "\uD83D\uDCCB Hlavn\xed pravidla z\xf3nov\xe1n\xed (slo\u017Eka ",
                                            /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("code", {
                                                children: "skills-zoning"
                                            }),
                                            ")"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("span", {
                                        style: {
                                            fontSize: '11px',
                                            color: '#9ca3af',
                                            marginLeft: '10px'
                                        },
                                        children: [
                                            "Na\u010D\xedt\xe1 se z ",
                                            /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("code", {
                                                children: "skills-zoning/*.md"
                                            }),
                                            " a p\u0159ipojuje se ke ka\u017Ed\xe9mu promptu"
                                        ]
                                    })
                                ]
                            }),
                            rulesSavedMessage && /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("span", {
                                style: {
                                    fontSize: '12px',
                                    color: '#10b981',
                                    fontWeight: 600
                                },
                                children: [
                                    "\u2713 ",
                                    rulesSavedMessage
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("textarea", {
                        value: rulesContent,
                        onChange: (e)=>setRulesContent(e.target.value),
                        rows: 10,
                        style: {
                            width: '100%',
                            backgroundColor: '#0d0d0d',
                            border: '1px solid #333333',
                            borderRadius: '6px',
                            color: '#e5e7eb',
                            padding: '12px',
                            fontSize: '12px',
                            fontFamily: 'JetBrains Mono, monospace',
                            lineHeight: '1.5',
                            boxSizing: 'border-box'
                        }
                    }),
                    /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("div", {
                        style: {
                            display: 'flex',
                            justifyContent: 'flex-end',
                            gap: '8px'
                        },
                        children: /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("button", {
                            type: "button",
                            onClick: handleSaveRules,
                            disabled: isSavingRules,
                            style: {
                                backgroundColor: '#2563eb',
                                border: 'none',
                                color: '#ffffff',
                                padding: '6px 14px',
                                borderRadius: '6px',
                                fontSize: '12px',
                                fontWeight: 600,
                                cursor: isSavingRules ? 'wait' : 'pointer'
                            },
                            children: isSavingRules ? "Ukl\xe1d\xe1m..." : "\uD83D\uDCBE Ulo\u017Eit pravidla"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("div", {
                        style: {
                            fontSize: '12px',
                            fontWeight: 600,
                            color: '#9ca3af',
                            marginBottom: '8px',
                            textTransform: 'uppercase',
                            letterSpacing: '0.5px'
                        },
                        children: "Dostupn\xfd katalog z\xf3n (m\xedstnost nemus\xed obsahovat v\u0161echny):"
                    }),
                    /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("div", {
                        style: {
                            display: 'flex',
                            flexWrap: 'wrap',
                            gap: '8px'
                        },
                        children: Object.values((0, $a7f3ce86011fb77e$export$2020fa29d940ee6a)).map((def)=>/*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("div", {
                                style: {
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    gap: '6px',
                                    padding: '5px 12px',
                                    borderRadius: '16px',
                                    fontSize: '12px',
                                    backgroundColor: 'rgba(255, 255, 255, 0.04)',
                                    border: `1px solid ${def.strokeColor}44`,
                                    color: '#e5e7eb'
                                },
                                title: `${def.descriptionCs}\nKotvy: ${def.typicalFurniture.join(', ')}`,
                                children: [
                                    /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("span", {
                                        style: {
                                            width: '8px',
                                            height: '8px',
                                            borderRadius: '50%',
                                            backgroundColor: def.strokeColor
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("span", {
                                        style: {
                                            fontWeight: 500
                                        },
                                        children: def.nameCs
                                    }),
                                    /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("span", {
                                        style: {
                                            fontSize: '10px',
                                            color: '#9ca3af'
                                        },
                                        children: [
                                            "(",
                                            def.typicalFurniture.slice(0, 2).join(', '),
                                            "...)"
                                        ]
                                    })
                                ]
                            }, def.id))
                    })
                ]
            }),
            /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("div", {
                style: {
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '10px'
                },
                children: [
                    /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("div", {
                        style: {
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center'
                        },
                        children: [
                            /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("label", {
                                style: {
                                    fontSize: '13px',
                                    fontWeight: 500,
                                    color: '#e5e7eb'
                                },
                                children: "Zad\xe1n\xed pro z\xf3nov\xe1n\xed & preference uspo\u0159\xe1d\xe1n\xed:"
                            }),
                            /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("div", {
                                style: {
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '8px'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("span", {
                                        style: {
                                            fontSize: '12px',
                                            color: '#9ca3af'
                                        },
                                        children: "AI Model:"
                                    }),
                                    /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("select", {
                                        value: model,
                                        onChange: (e)=>onModelChange(e.target.value),
                                        style: {
                                            backgroundColor: '#121212',
                                            border: '1px solid #333333',
                                            color: '#f3f4f6',
                                            padding: '5px 12px',
                                            borderRadius: '6px',
                                            fontSize: '12px',
                                            cursor: 'pointer'
                                        },
                                        children: (0, $347f08a9fa010a1a$export$142368568726dda).map((m)=>/*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("option", {
                                                value: m.id,
                                                children: m.name
                                            }, m.id))
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("div", {
                        style: {
                            display: 'flex',
                            flexWrap: 'wrap',
                            gap: '6px'
                        },
                        children: $a3ed16d8c0bbb224$var$ZONING_PRESETS.map((preset, idx)=>/*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("button", {
                                type: "button",
                                onClick: ()=>onPromptChange(preset.prompt),
                                style: {
                                    backgroundColor: '#121212',
                                    border: '1px solid #2a2a2a',
                                    color: '#9ca3af',
                                    padding: '4px 10px',
                                    borderRadius: '6px',
                                    fontSize: '11px',
                                    cursor: 'pointer',
                                    transition: 'all 0.2s'
                                },
                                onMouseEnter: (e)=>e.currentTarget.style.color = '#f3f4f6',
                                onMouseLeave: (e)=>e.currentTarget.style.color = '#9ca3af',
                                children: preset.label
                            }, idx))
                    }),
                    /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("textarea", {
                        id: "zoning-prompt-textarea",
                        value: prompt,
                        onChange: (e)=>onPromptChange(e.target.value),
                        placeholder: "Popi\u0161te, jak si p\u0159edstavujete funk\u010Dn\xed rozd\u011Blen\xed prostoru (nap\u0159. Prostorn\xfd ob\xfdvac\xed pokoj s TV st\u011Bnou na z\xe1padn\xed st\u011Bn\u011B, j\xeddeln\xed kout navazuj\xedc\xed na kuchy\u0148 a pracovn\xed kout u okna)...",
                        rows: 3,
                        style: {
                            width: '100%',
                            backgroundColor: '#121212',
                            border: '1px solid #333333',
                            borderRadius: '8px',
                            color: '#f3f4f6',
                            padding: '12px',
                            fontSize: '13px',
                            fontFamily: 'inherit',
                            resize: 'vertical',
                            boxSizing: 'border-box'
                        }
                    }),
                    /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("div", {
                        style: {
                            backgroundColor: '#161616',
                            padding: '10px 14px',
                            borderRadius: '8px',
                            border: '1px solid #2c2c2c',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between'
                        },
                        children: [
                            /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("label", {
                                style: {
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '10px',
                                    cursor: 'pointer',
                                    fontSize: '13px',
                                    color: '#e5e7eb'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("input", {
                                        type: "checkbox",
                                        checked: includeAllSkills,
                                        onChange: (e)=>onToggleIncludeAllSkills && onToggleIncludeAllSkills(e.target.checked),
                                        style: {
                                            cursor: 'pointer',
                                            width: '16px',
                                            height: '16px'
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("span", {
                                                style: {
                                                    fontWeight: 600
                                                },
                                                children: [
                                                    "Zahrnout do z\xf3nov\xe1n\xed v\u0161echny design skilly (slo\u017Eka ",
                                                    /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("code", {
                                                        children: "skills"
                                                    }),
                                                    ")"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("div", {
                                                style: {
                                                    fontSize: '11px',
                                                    color: '#9ca3af',
                                                    marginTop: '2px'
                                                },
                                                children: "Zahrne 18 pravidel interi\xe9rov\xe9ho designu (ergonomie, pr\u016Fchody, materi\xe1ly, osv\u011Btlen\xed atd.) p\u016Fvodn\u011B ur\u010Den\xfdch pro chatbota."
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("span", {
                                style: {
                                    fontSize: '11px',
                                    padding: '2px 8px',
                                    borderRadius: '12px',
                                    backgroundColor: includeAllSkills ? 'rgba(16, 185, 129, 0.15)' : 'rgba(255, 255, 255, 0.05)',
                                    color: includeAllSkills ? '#34d399' : '#9ca3af',
                                    fontWeight: 600
                                },
                                children: includeAllSkills ? "Aktivn\xed (18 skill\u016F)" : 'Vypnuto (jen skills-zoning)'
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("div", {
                        style: {
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            marginTop: '6px',
                            flexWrap: 'wrap',
                            gap: '10px'
                        },
                        children: [
                            /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("div", {
                                style: {
                                    display: 'flex',
                                    gap: '10px',
                                    alignItems: 'center'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("button", {
                                        type: "button",
                                        onClick: handleRunZoning,
                                        disabled: isZoning,
                                        style: {
                                            backgroundColor: isZoning ? '#1d4ed8' : '#2563eb',
                                            border: 'none',
                                            color: '#ffffff',
                                            padding: '10px 24px',
                                            borderRadius: '8px',
                                            fontSize: '13px',
                                            fontWeight: 600,
                                            cursor: isZoning ? 'wait' : 'pointer',
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '8px',
                                            boxShadow: '0 4px 6px -1px rgba(37, 99, 235, 0.3)',
                                            transition: 'all 0.2s'
                                        },
                                        children: isZoning ? /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)((0, $eeebe4096ef7ee1f$exports.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("span", {
                                                    style: {
                                                        display: 'inline-block',
                                                        animation: 'spin 1s linear infinite'
                                                    },
                                                    children: "\u23F3"
                                                }),
                                                "Generuji 3 varianty z\xf3nov\xe1n\xed..."
                                            ]
                                        }) : /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)((0, $eeebe4096ef7ee1f$exports.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("span", {
                                                    children: "\u26A1"
                                                }),
                                                "Generovat 3 varianty z\xf3n"
                                            ]
                                        })
                                    }),
                                    zones.length > 0 && /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("button", {
                                        type: "button",
                                        onClick: onClearZones,
                                        style: {
                                            backgroundColor: 'transparent',
                                            border: '1px solid #444444',
                                            color: '#9ca3af',
                                            padding: '8px 16px',
                                            borderRadius: '6px',
                                            fontSize: '12px',
                                            cursor: 'pointer'
                                        },
                                        children: "Vymazat z\xf3ny"
                                    })
                                ]
                            }),
                            zones.length > 0 && /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("div", {
                                style: {
                                    display: 'flex',
                                    gap: '16px',
                                    alignItems: 'center'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("label", {
                                        style: {
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '8px',
                                            cursor: 'pointer',
                                            fontSize: '13px',
                                            color: '#e5e7eb'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("input", {
                                                type: "checkbox",
                                                checked: showZonesInPreview,
                                                onChange: (e)=>onToggleShowZones(e.target.checked),
                                                style: {
                                                    cursor: 'pointer'
                                                }
                                            }),
                                            /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("span", {
                                                children: "Zobrazit z\xf3ny (polygony)"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("label", {
                                        style: {
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '8px',
                                            cursor: 'pointer',
                                            fontSize: '13px',
                                            color: '#38bdf8'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("input", {
                                                type: "checkbox",
                                                checked: showZoneAnchors,
                                                onChange: (e)=>onToggleShowZoneAnchors && onToggleShowZoneAnchors(e.target.checked),
                                                style: {
                                                    cursor: 'pointer'
                                                }
                                            }),
                                            /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("span", {
                                                children: "\u2693 Zobrazit kotevn\xed objekty (anchors)"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            errorMessage && /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("div", {
                style: {
                    padding: '12px 16px',
                    backgroundColor: 'rgba(239, 68, 68, 0.1)',
                    border: '1px solid #ef4444',
                    borderRadius: '8px',
                    color: '#fca5a5',
                    fontSize: '13px'
                },
                children: [
                    /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("strong", {
                        children: "Chyba:"
                    }),
                    " ",
                    errorMessage
                ]
            }),
            zones.length > 0 && /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("div", {
                style: {
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '16px',
                    backgroundColor: '#171717',
                    padding: '18px',
                    borderRadius: '10px',
                    border: '1px solid #282828'
                },
                children: [
                    variants.length > 0 && /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("div", {
                                style: {
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                    marginBottom: '10px'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("div", {
                                        style: {
                                            fontSize: '13px',
                                            fontWeight: 600,
                                            color: '#f3f4f6'
                                        },
                                        children: [
                                            "Architektonick\xe9 varianty z\xf3nov\xe1n\xed (",
                                            variants.length,
                                            "):"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("div", {
                                        style: {
                                            fontSize: '11px',
                                            color: '#9ca3af'
                                        },
                                        children: "Ka\u017Ed\xe1 varianta nab\xedz\xed odli\u0161nou prostorovou topologii a vztahy kotev"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("div", {
                                style: {
                                    display: 'grid',
                                    gridTemplateColumns: `repeat(${variants.length}, 1fr)`,
                                    gap: '10px'
                                },
                                children: variants.map((v, idx)=>{
                                    const isSelected = activeVariantIndex === idx;
                                    const confidenceBadge = v.confidence === 'high' ? "\uD83D\uDFE2 Vysok\xe1 jistota" : v.confidence === 'medium' ? "\uD83D\uDFE1 St\u0159edn\xed jistota" : "\uD83D\uDD34 N\xedzk\xe1 jistota";
                                    return /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("button", {
                                        type: "button",
                                        onClick: ()=>onSelectVariant && onSelectVariant(idx),
                                        style: {
                                            backgroundColor: isSelected ? 'rgba(37, 99, 235, 0.18)' : '#202020',
                                            border: isSelected ? '2px solid #3b82f6' : '1px solid #333333',
                                            borderRadius: '8px',
                                            padding: '12px 14px',
                                            cursor: 'pointer',
                                            textAlign: 'left',
                                            display: 'flex',
                                            flexDirection: 'column',
                                            gap: '6px',
                                            transition: 'all 0.2s',
                                            boxShadow: isSelected ? '0 0 12px rgba(59, 130, 246, 0.25)' : 'none'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("div", {
                                                style: {
                                                    display: 'flex',
                                                    justifyContent: 'space-between',
                                                    alignItems: 'center'
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("span", {
                                                        style: {
                                                            fontWeight: 700,
                                                            fontSize: '13px',
                                                            color: isSelected ? '#60a5fa' : '#e5e7eb'
                                                        },
                                                        children: v.title || `Varianta ${idx + 1}`
                                                    }),
                                                    typeof v.score === 'number' && /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("span", {
                                                        style: {
                                                            fontSize: '11px',
                                                            fontWeight: 700,
                                                            padding: '2px 8px',
                                                            borderRadius: '10px',
                                                            backgroundColor: isSelected ? '#2563eb' : '#333333',
                                                            color: '#ffffff'
                                                        },
                                                        children: [
                                                            v.score,
                                                            " b."
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("div", {
                                                style: {
                                                    display: 'flex',
                                                    justifyContent: 'space-between',
                                                    fontSize: '11px',
                                                    color: '#9ca3af'
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("span", {
                                                        children: [
                                                            v.selectedZoneTypes.length,
                                                            " z\xf3n, ",
                                                            v.zoneAnchors.length,
                                                            " kotev"
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("span", {
                                                        children: confidenceBadge
                                                    })
                                                ]
                                            })
                                        ]
                                    }, v.variantId || idx);
                                })
                            })
                        ]
                    }),
                    activeVariant && /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("div", {
                        style: {
                            backgroundColor: 'rgba(59, 130, 246, 0.05)',
                            border: '1px solid rgba(59, 130, 246, 0.25)',
                            borderRadius: '8px',
                            padding: '14px 16px',
                            display: 'flex',
                            flexDirection: 'column',
                            gap: '8px'
                        },
                        children: [
                            /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("div", {
                                style: {
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("span", {
                                        style: {
                                            fontWeight: 700,
                                            fontSize: '14px',
                                            color: '#93c5fd'
                                        },
                                        children: [
                                            "\uD83D\uDCA1 ",
                                            activeVariant.title
                                        ]
                                    }),
                                    typeof activeVariant.score === 'number' && /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("span", {
                                        style: {
                                            fontSize: '12px',
                                            color: '#60a5fa',
                                            fontWeight: 600
                                        },
                                        children: [
                                            "Sk\xf3re n\xe1vrhu: ",
                                            /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("strong", {
                                                children: [
                                                    activeVariant.score,
                                                    " / 100 bod\u016F"
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("div", {
                                style: {
                                    fontSize: '13px',
                                    color: '#e5e7eb',
                                    lineHeight: '1.6'
                                },
                                children: activeVariant.description
                            }),
                            activeVariant.tradeOffs && /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("div", {
                                style: {
                                    marginTop: '4px',
                                    padding: '8px 12px',
                                    backgroundColor: 'rgba(234, 179, 8, 0.08)',
                                    border: '1px solid rgba(234, 179, 8, 0.3)',
                                    borderRadius: '6px',
                                    fontSize: '12px',
                                    color: '#fef08a'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("strong", {
                                        children: "\u2696\uFE0F Hlavn\xed kompromis / \xfaskal\xed:"
                                    }),
                                    " ",
                                    activeVariant.tradeOffs
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("div", {
                                style: {
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                    marginBottom: '8px'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("div", {
                                        style: {
                                            fontSize: '13px',
                                            fontWeight: 600,
                                            color: '#f3f4f6'
                                        },
                                        children: [
                                            "Vygenerovan\xe9 z\xf3ny (",
                                            zones.length,
                                            "):"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("div", {
                                        style: {
                                            fontSize: '11px',
                                            color: '#9ca3af'
                                        },
                                        children: "Kliknut\xedm na kartu z\xf3ny zv\xfdrazn\xedte jej\xed polygon v n\xe1hledu"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("div", {
                                style: {
                                    display: 'grid',
                                    gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
                                    gap: '10px'
                                },
                                children: zones.map((zone)=>{
                                    const isFocused = focusedZoneId === zone.id;
                                    return /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("div", {
                                        onClick: ()=>onFocusZone && onFocusZone(isFocused ? null : zone.id),
                                        style: {
                                            backgroundColor: isFocused ? 'rgba(59, 130, 246, 0.15)' : '#222222',
                                            border: `1px solid ${isFocused ? zone.strokeColor : '#333333'}`,
                                            borderLeft: `4px solid ${zone.strokeColor}`,
                                            borderRadius: '6px',
                                            padding: '10px 14px',
                                            cursor: 'pointer',
                                            transition: 'all 0.2s'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("div", {
                                                style: {
                                                    display: 'flex',
                                                    justifyContent: 'space-between',
                                                    alignItems: 'center'
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("span", {
                                                        style: {
                                                            fontWeight: 600,
                                                            fontSize: '13px',
                                                            color: '#f3f4f6'
                                                        },
                                                        children: zone.name
                                                    }),
                                                    /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("span", {
                                                        style: {
                                                            fontSize: '11px',
                                                            fontWeight: 600,
                                                            color: zone.strokeColor,
                                                            backgroundColor: `${zone.strokeColor}18`,
                                                            padding: '2px 6px',
                                                            borderRadius: '4px'
                                                        },
                                                        children: [
                                                            zone.areaPercent,
                                                            "%"
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("div", {
                                                style: {
                                                    display: 'flex',
                                                    justifyContent: 'space-between',
                                                    marginTop: '6px',
                                                    fontSize: '12px',
                                                    color: '#9ca3af'
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("span", {
                                                        children: [
                                                            "Plocha: ",
                                                            /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("strong", {
                                                                style: {
                                                                    color: '#e5e7eb'
                                                                },
                                                                children: [
                                                                    zone.area,
                                                                    " m\xb2"
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("span", {
                                                        children: [
                                                            "T\u011B\u017Ei\u0161t\u011B: [",
                                                            (zone.centroid[0] / 1000).toFixed(1),
                                                            ", ",
                                                            (zone.centroid[1] / 1000).toFixed(1),
                                                            "]m"
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }, zone.id);
                                })
                            })
                        ]
                    }),
                    zoneAnchors.length > 0 && /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("div", {
                        style: {
                            backgroundColor: '#1b1b1b',
                            padding: '14px',
                            borderRadius: '8px',
                            border: '1px solid #2e2e2e'
                        },
                        children: [
                            /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("div", {
                                style: {
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                    marginBottom: '10px'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("div", {
                                        style: {
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '8px'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("span", {
                                                style: {
                                                    fontSize: '16px'
                                                },
                                                children: "\u2693"
                                            }),
                                            /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("span", {
                                                style: {
                                                    fontSize: '13px',
                                                    fontWeight: 600,
                                                    color: '#f3f4f6'
                                                },
                                                children: [
                                                    "Pou\u017Eit\xe9 kotevn\xed objekty (",
                                                    zoneAnchors.length,
                                                    ")"
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("div", {
                                        style: {
                                            fontSize: '11px',
                                            color: '#9ca3af'
                                        },
                                        children: "Objekty (fyzick\xe9 i virtu\xe1ln\xed) slou\u017E\xedc\xed jako kotevn\xed body pro v\xfdpo\u010Det z\xf3n"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("div", {
                                style: {
                                    display: 'grid',
                                    gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))',
                                    gap: '8px'
                                },
                                children: zoneAnchors.map((anchor)=>{
                                    const zoneDef = (0, $a7f3ce86011fb77e$export$2020fa29d940ee6a)[anchor.zoneType] || (0, $a7f3ce86011fb77e$export$2020fa29d940ee6a).living;
                                    const isFocused = focusedZoneId === anchor.zoneId || focusedAnchorId === anchor.id;
                                    return /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("div", {
                                        onClick: ()=>onFocusAnchor && onFocusAnchor(isFocused ? null : anchor.id),
                                        style: {
                                            backgroundColor: isFocused ? 'rgba(59, 130, 246, 0.15)' : '#242424',
                                            border: `1px solid ${isFocused ? zoneDef.strokeColor : '#383838'}`,
                                            borderLeft: `3px solid ${zoneDef.strokeColor}`,
                                            borderRadius: '6px',
                                            padding: '8px 12px',
                                            cursor: 'pointer',
                                            transition: 'all 0.2s'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("div", {
                                                style: {
                                                    display: 'flex',
                                                    justifyContent: 'space-between',
                                                    alignItems: 'center'
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("span", {
                                                        style: {
                                                            fontWeight: 600,
                                                            fontSize: '12px',
                                                            color: '#f3f4f6'
                                                        },
                                                        children: [
                                                            "\u2693 ",
                                                            anchor.name
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("span", {
                                                        style: {
                                                            fontSize: '10px',
                                                            color: zoneDef.strokeColor,
                                                            backgroundColor: `${zoneDef.strokeColor}18`,
                                                            padding: '1px 6px',
                                                            borderRadius: '4px',
                                                            fontWeight: 600
                                                        },
                                                        children: zoneDef.nameCs
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("div", {
                                                style: {
                                                    display: 'flex',
                                                    justifyContent: 'space-between',
                                                    marginTop: '6px',
                                                    fontSize: '11px',
                                                    color: '#9ca3af'
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("span", {
                                                        children: [
                                                            "Rozm\u011Bry: ",
                                                            /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("strong", {
                                                                style: {
                                                                    color: '#e5e7eb'
                                                                },
                                                                children: [
                                                                    anchor.size.width,
                                                                    "\xd7",
                                                                    anchor.size.length,
                                                                    "m"
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("span", {
                                                        children: [
                                                            "Pozice: [",
                                                            /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("strong", {
                                                                children: [
                                                                    anchor.position.x.toFixed(1),
                                                                    ", ",
                                                                    anchor.position.y.toFixed(1)
                                                                ]
                                                            }),
                                                            "]m"
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }, anchor.id);
                                })
                            })
                        ]
                    }),
                    aiExplanation && !activeVariant && /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("div", {
                        style: {
                            backgroundColor: 'rgba(59, 130, 246, 0.06)',
                            border: '1px solid rgba(59, 130, 246, 0.2)',
                            borderRadius: '6px',
                            padding: '12px 14px',
                            fontSize: '13px',
                            color: '#dbeafe',
                            lineHeight: '1.6'
                        },
                        children: [
                            /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("strong", {
                                children: "\uD83D\uDCA1 Zd\u016Fvodn\u011Bn\xed architekta (Gemini):"
                            }),
                            " ",
                            aiExplanation
                        ]
                    })
                ]
            })
        ]
    });
}




var $bFZzf = parcelRequire("bFZzf");

function $b1705ca09ff99c40$export$ceec4b071d622ae0({ isOpen: isOpen, onClose: onClose, backendUrl: backendUrl }) {
    const [htmlContent, setHtmlContent] = (0, $bFZzf.useState)('');
    const [loading, setLoading] = (0, $bFZzf.useState)(true);
    const [error, setError] = (0, $bFZzf.useState)(null);
    (0, $bFZzf.useEffect)(()=>{
        if (!isOpen) return;
        setLoading(true);
        setError(null);
        fetch(`${backendUrl}/api/zoning/docs`).then((res)=>{
            if (!res.ok) throw new Error(`Chyba p\u{159}i na\u{10D}\xedt\xe1n\xed dokumentace (status ${res.status})`);
            return res.json();
        }).then((data)=>{
            if (data.html) setHtmlContent(data.html);
            else if (data.markdown) setHtmlContent((0, $1c80c15edccb5c8b$exports.marked).parse(data.markdown));
            setLoading(false);
        }).catch((err)=>{
            setError(err instanceof Error ? err.message : String(err));
            setLoading(false);
        });
    }, [
        isOpen,
        backendUrl
    ]);
    if (!isOpen) return null;
    return /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("div", {
        style: {
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.75)',
            backdropFilter: 'blur(6px)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 9999,
            padding: '24px'
        },
        onClick: onClose,
        children: /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("div", {
            style: {
                backgroundColor: '#1a1a1a',
                border: '1px solid #333333',
                borderRadius: '12px',
                width: '100%',
                maxWidth: '900px',
                maxHeight: '90vh',
                display: 'flex',
                flexDirection: 'column',
                boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.5), 0 8px 10px -6px rgba(0, 0, 0, 0.5)',
                overflow: 'hidden'
            },
            onClick: (e)=>e.stopPropagation(),
            children: [
                /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("div", {
                    style: {
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        padding: '16px 24px',
                        borderBottom: '1px solid #333333',
                        backgroundColor: '#222222'
                    },
                    children: [
                        /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("div", {
                            style: {
                                display: 'flex',
                                alignItems: 'center',
                                gap: '10px'
                            },
                            children: [
                                /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("span", {
                                    style: {
                                        fontSize: '20px'
                                    },
                                    children: "\uD83D\uDCD0"
                                }),
                                /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("h3", {
                                    style: {
                                        margin: 0,
                                        fontSize: '18px',
                                        fontWeight: 600,
                                        color: '#f3f4f6'
                                    },
                                    children: "Dokumentace z\xf3nov\xe1n\xed m\xedstnost\xed (ZONING.md)"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("div", {
                            style: {
                                display: 'flex',
                                gap: '12px',
                                alignItems: 'center'
                            },
                            children: [
                                /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("a", {
                                    href: `${backendUrl}/zoning-doc`,
                                    target: "_blank",
                                    rel: "noreferrer",
                                    style: {
                                        color: '#60a5fa',
                                        fontSize: '13px',
                                        textDecoration: 'none',
                                        padding: '4px 8px',
                                        border: '1px solid rgba(96, 165, 250, 0.3)',
                                        borderRadius: '4px'
                                    },
                                    children: "\u2197 Otev\u0159\xedt na nov\xe9 z\xe1lo\u017Ece"
                                }),
                                /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("button", {
                                    onClick: onClose,
                                    style: {
                                        background: 'transparent',
                                        border: 'none',
                                        color: '#9ca3af',
                                        fontSize: '20px',
                                        cursor: 'pointer',
                                        padding: '4px 8px',
                                        borderRadius: '4px'
                                    },
                                    title: "Zav\u0159\xedt",
                                    children: "\u2715"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("div", {
                    style: {
                        padding: '24px',
                        overflowY: 'auto',
                        color: '#e5e7eb',
                        fontSize: '14px',
                        lineHeight: '1.7',
                        flex: 1
                    },
                    children: [
                        loading && /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("div", {
                            style: {
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                padding: '60px',
                                gap: '12px',
                                color: '#9ca3af'
                            },
                            children: /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("span", {
                                children: "Na\u010D\xedt\xe1m dokumentaci z\xf3nov\xe1n\xed..."
                            })
                        }),
                        error && /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("div", {
                            style: {
                                padding: '20px',
                                backgroundColor: 'rgba(239, 68, 68, 0.1)',
                                border: '1px solid #ef4444',
                                borderRadius: '8px',
                                color: '#fca5a5'
                            },
                            children: [
                                /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("strong", {
                                    children: "Chyba:"
                                }),
                                " ",
                                error
                            ]
                        }),
                        !loading && !error && /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("div", {
                            className: "markdown-doc-body",
                            dangerouslySetInnerHTML: {
                                __html: htmlContent
                            },
                            style: {
                                fontFamily: 'system-ui, -apple-system, sans-serif'
                            }
                        })
                    ]
                })
            ]
        })
    });
}




function $c6e83f7c2eae145d$export$86fbec116b87613f() {
    const [activeTab, setActiveTab] = (0, $bFZzf.useState)('editor');
    const { roomData: roomData, questionnaire: questionnaire, prompt: prompt, model: model, aiMessage: aiMessage, backendUrl: backendUrl, setBackendUrl: setBackendUrl, status: status, errorMessage: errorMessage, logs: logs, generatedScript: generatedScript, validationResult: validationResult, geminiCalls: geminiCalls, searchLogs: searchLogs, isValidating: isValidating, dbRooms: dbRooms, selectedRoomId: selectedRoomId, backendHealthy: backendHealthy, historyIndex: historyIndex, history: history, zones: // Zoning states & methods
    zones, variants: variants, activeVariantIndex: activeVariantIndex, selectZoningVariant: selectZoningVariant, zoneAnchors: zoneAnchors, showZoneAnchors: showZoneAnchors, handleToggleShowZoneAnchors: handleToggleShowZoneAnchors, includeAllSkills: includeAllSkills, handleToggleIncludeAllSkills: handleToggleIncludeAllSkills, focusedAnchorId: focusedAnchorId, handleFocusAnchor: handleFocusAnchor, isZoning: isZoning, zoningPrompt: zoningPrompt, zoningModel: zoningModel, zoningExplanation: zoningExplanation, zoningErrorMessage: zoningErrorMessage, showZonesInPreview: showZonesInPreview, focusedZoneId: focusedZoneId, handleGenerateZones: handleGenerateZones, handleClearZones: handleClearZones, handleZoningPromptChange: handleZoningPromptChange, handleZoningModelChange: handleZoningModelChange, handleToggleShowZones: handleToggleShowZones, handleFocusZone: handleFocusZone, handleUndo: // Other handlers
    handleUndo, handleRedo: handleRedo, handleRoomSelect: handleRoomSelect, handleSaveRoom: handleSaveRoom, handleFieldChange: handleFieldChange, handleQuestionnaireChange: handleQuestionnaireChange, handlePromptChange: handlePromptChange, handleModelChange: handleModelChange, handleRoomDataUpload: handleRoomDataUpload, handleSolveError: handleSolveError, handleSolveAllErrors: handleSolveAllErrors, handleUpdateLayout: handleUpdateLayout } = (0, $f9af346427ba4536$export$260ca91bcd5499f3)();
    const { skills: skills } = (0, $6d3477a982cfb87f$export$52147cc63c0ab0e2)(backendUrl);
    const handleApplyPromptToOrchestrator = (promptText)=>{
        handlePromptChange(promptText);
        const el = document.getElementById('design-prompt-textarea');
        if (el) el.focus();
    };
    const handleRunOrchestrator = (promptText)=>{
        handlePromptChange(promptText);
        setTimeout(()=>{
            handleUpdateLayout();
        }, 100);
    };
    return /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("div", {
        style: (0, $8a3c98632a397758$export$9dd6ff9ea0189349).container,
        children: [
            /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)((0, $bb4933fc8764fe54$export$8b251419efc915eb), {
                backendHealthy: backendHealthy,
                backendUrl: backendUrl,
                setBackendUrl: setBackendUrl,
                activeTab: activeTab,
                onTabChange: setActiveTab
            }),
            /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsxs)("main", {
                style: {
                    ...(0, $8a3c98632a397758$export$9dd6ff9ea0189349).mainGrid,
                    display: activeTab === 'editor' ? 'flex' : 'none'
                },
                children: [
                    /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)((0, $545b9db0cff2c060$export$2d5166f3af0c3560), {
                        roomData: roomData,
                        questionnaire: questionnaire,
                        handleFieldChange: handleFieldChange,
                        handleQuestionnaireChange: handleQuestionnaireChange,
                        dbRooms: dbRooms,
                        selectedRoomId: selectedRoomId,
                        handleRoomSelect: handleRoomSelect,
                        onRoomDataChange: handleRoomDataUpload
                    }),
                    /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)((0, $dd277cc5481ddeb6$export$d3ae2e2a0de15619), {
                        roomData: roomData,
                        validationResult: validationResult,
                        isValidating: isValidating,
                        onSaveRoom: handleSaveRoom,
                        onSolveError: handleSolveError,
                        onSolveAllErrors: handleSolveAllErrors,
                        status: status,
                        onUndo: handleUndo,
                        onRedo: handleRedo,
                        canUndo: historyIndex > 0,
                        canRedo: historyIndex < history.length - 1,
                        zones: zones,
                        showZonesInPreview: showZonesInPreview,
                        focusedZoneId: focusedZoneId,
                        zoneAnchors: zoneAnchors,
                        showZoneAnchors: showZoneAnchors,
                        focusedAnchorId: focusedAnchorId
                    }),
                    /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("section", {
                        style: {
                            gridColumn: 'span 12'
                        },
                        children: /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)((0, $a3ed16d8c0bbb224$export$ab08871484d62e13), {
                            prompt: zoningPrompt,
                            onPromptChange: handleZoningPromptChange,
                            model: zoningModel,
                            onModelChange: handleZoningModelChange,
                            onGenerateZones: handleGenerateZones,
                            onClearZones: handleClearZones,
                            isZoning: isZoning,
                            zones: zones,
                            variants: variants,
                            activeVariantIndex: activeVariantIndex,
                            onSelectVariant: selectZoningVariant,
                            zoneAnchors: zoneAnchors,
                            showZoneAnchors: showZoneAnchors,
                            onToggleShowZoneAnchors: handleToggleShowZoneAnchors,
                            includeAllSkills: includeAllSkills,
                            onToggleIncludeAllSkills: handleToggleIncludeAllSkills,
                            onFocusAnchor: handleFocusAnchor,
                            focusedAnchorId: focusedAnchorId,
                            aiExplanation: zoningExplanation,
                            errorMessage: zoningErrorMessage,
                            backendUrl: backendUrl,
                            showZonesInPreview: showZonesInPreview,
                            onToggleShowZones: handleToggleShowZones,
                            onFocusZone: handleFocusZone,
                            focusedZoneId: focusedZoneId
                        })
                    }),
                    /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("section", {
                        style: {
                            gridColumn: 'span 12'
                        },
                        children: /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)((0, $5d9edfad2f50c8f1$export$ecfd0f5195a7a18), {
                            backendUrl: backendUrl,
                            roomData: roomData,
                            skills: skills,
                            onApplyPromptToOrchestrator: handleApplyPromptToOrchestrator,
                            onRunOrchestrator: handleRunOrchestrator,
                            onOpenSkillsLibrary: ()=>setActiveTab('skills')
                        })
                    }),
                    /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)((0, $b92cc80221770949$export$766ea011d7fc650f), {
                        model: model,
                        prompt: prompt,
                        status: status,
                        errorMessage: errorMessage,
                        aiMessage: aiMessage,
                        onModelChange: handleModelChange,
                        onPromptChange: handlePromptChange,
                        onUpdateLayout: handleUpdateLayout
                    }),
                    /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)((0, $608ea1dd4cd3078a$export$5bbd2894fcdab524), {
                        logs: logs,
                        generatedScript: generatedScript,
                        geminiCalls: geminiCalls,
                        searchLogs: searchLogs
                    })
                ]
            }),
            /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)("main", {
                style: {
                    padding: '24px',
                    maxWidth: '1400px',
                    margin: '0 auto',
                    display: activeTab === 'skills' ? 'block' : 'none'
                },
                children: /*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)((0, $418a8156cf324d8a$export$f16c619bb7a6cd8), {
                    backendUrl: backendUrl
                })
            })
        ]
    });
}
const $c6e83f7c2eae145d$var$root = (0, $6fa0a1dddf463a10$exports.createRoot)(document.getElementById('root'));
$c6e83f7c2eae145d$var$root.render(/*#__PURE__*/ (0, $eeebe4096ef7ee1f$exports.jsx)($c6e83f7c2eae145d$export$86fbec116b87613f, {}));


//# sourceMappingURL=dev-frontend.f06311a8.js.map
